const t=["outline-phase2-blue","outline-karma-coral","outline-soft-black","outline-not-gray","outline-transparent","outline-white","outline-black","outline-dark-blue","outline-medium-blue","outline-light-blue","outline-dark-gray","outline-medium-gray","outline-light-gray","outline-misty-teal","outline-electric-violet","outline-dusty-blue","brand-primary","brand-secondary","brand-tertiary","brand-quaternary","brand-quinary","brand-senary","brand-septenary","brand-octonary","brand-nonary","brand-denary","neutral-transparent","neutral-white","neutral-grayLight","neutral-grayMedium","neutral-gray","neutral-grayDark","neutral-black","ui-error","ui-warning","ui-info","ui-success","ui-errorText","ui-warningText","ui-infoText","ui-successText","ui-formError","ui-formDisabled","demo-darkBlue","demo-lightBlue","demo-darkGray","demo-lightGray","gray-50","gray-100","gray-200","gray-300","gray-400","gray-500","gray-600","gray-700","gray-800","gray-900","blue-50","blue-100","blue-200","blue-300","blue-400","blue-500","blue-600","blue-700","blue-800","blue-900","red-50","red-100","red-200","red-300","red-400","red-500","red-600","red-700","red-800","red-900","yellow-50","yellow-100","yellow-200","yellow-300","yellow-400","yellow-500","yellow-600","yellow-700","yellow-800","yellow-900","green-50","green-100","green-200","green-300","green-400","green-500","green-600","green-700","green-800","green-900","indigo-50","indigo-100","indigo-200","indigo-300","indigo-400","indigo-500","indigo-600","indigo-700","indigo-800","indigo-900","purple-50","purple-100","purple-200","purple-300","purple-400","purple-500","purple-600","purple-700","purple-800","purple-900","pink-50","pink-100","pink-200","pink-300","pink-400","pink-500","pink-600","pink-700","pink-800","pink-900"];var e={xs:"480px",sm:"640px",md:"768px",lg:"1024px",xl:"1280px",xxl:"1440px",xxxl:"2180px"},i={thin:"var(--fw-extralight)",extralight:"var(--fw-thin)",light:"var(--fw-light)",normal:"var(--fw-normal)",medium:"var(--fw-medium)",semibold:"var(--fw-semibold)",bold:"var(--fw-bold)",extrabold:"var(--fw-extrabold)",black:"var(--fw-black)"},r={0:"0px",1:"0.25rem",2:"0.5rem",3:"0.75rem",4:"1rem",5:"1.25rem",6:"1.5rem",7:"1.75rem",8:"2rem",9:"2.25rem",10:"2.5rem",11:"2.75rem",12:"3rem",14:"3.5rem",16:"4rem",20:"5rem",24:"6rem",28:"7rem",32:"8rem",36:"9rem",40:"10rem",44:"11rem",48:"12rem",52:"13rem",56:"14rem",60:"15rem",64:"16rem",72:"18rem",80:"20rem",96:"24rem",px:"1px",.5:"0.125rem",1.5:"0.375rem",2.5:"0.625rem",3.5:"0.875rem"};const n=new Map(Object.entries(e).map((([t,e])=>[t,parseInt(e.slice(0,-2))])).sort((([,t],[,e])=>t-e)));class o{constructor(t){this.containerSizes=[],this.handleResize=()=>{var t,e;const i=this.containerSizes,r=null!==(e=null===(t=this.host.parentElement)||void 0===t?void 0:t.clientWidth)&&void 0!==e?e:0;this.containerSizes=Array.from(n).filter((([,t])=>r>=t)).map((([t])=>t)),this.containerSizes.length!==i.length&&(Array.from(n).forEach((([t])=>{this.containerSizes.includes(t)&&this.host.setAttribute(`container-size-${t}`,"true"),!1===this.containerSizes.includes(t)&&this.host.removeAttribute(`container-size-${t}`)})),this.host.requestUpdate())},this.host=t,this.host.addController(this),this.handleResize()}hostConnected(){this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(document.querySelector("body"))}hostDisconnected(){this.resizeObserver.disconnect()}}class a{constructor(t){this.isHoverableDevice=!1,this.handleResize=()=>{const t=this.isHoverableDevice;this.isHoverableDevice=window.matchMedia("(any-hover: hover) and (any-pointer: fine)").matches,this.isHoverableDevice!==t&&this.host.requestUpdate()},this.host=t,this.host.addController(this),this.handleResize()}hostConnected(){this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(document.querySelector("body"))}hostDisconnected(){this.resizeObserver.disconnect()}}class s{constructor(t,e){this._lastMouseDownTimestamp=0,this.host=t,this.host.addController(this),this._getLink=e,this.isLinked=this.isLinked.bind(this)}hostConnected(){this.isLinked()&&(this._handleClicks(),this._handleHover(),this._handleFocus())}isLinked(){return void 0!==this.host.href&&this.host.href.length>0}_handleClicks(){this.host.addEventListener("mousedown",(()=>{this._lastMouseDownTimestamp=Date.now()})),this.host.addEventListener("mouseup",(t=>{var e,i,r;t.target!==this._getLink()&&this._isClickNotDrag()&&(t.stopPropagation(),null===(e=this._getLink())||void 0===e||e.click(),null===(i=this._getLink())||void 0===i||i.dispatchEvent(new Event("mousedown")),null===(r=this._getLink())||void 0===r||r.dispatchEvent(new Event("mouseup")))}))}_isClickNotDrag(){return Date.now()-this._lastMouseDownTimestamp<200}_handleHover(){const t=this.host.querySelectorAll("labcoat-button");this.host.addEventListener("mouseover",(()=>{t.forEach((t=>{t.classList.add("state--hover")}))})),this.host.addEventListener("mouseout",(()=>{t.forEach((t=>{t.classList.remove("state--hover")}))}))}_handleFocus(){const t=this.host.querySelectorAll("labcoat-button");this.host.addEventListener("focus",(()=>{t.forEach((t=>{t.classList.add("state--focus")}))})),this.host.addEventListener("blur",(()=>{t.forEach((t=>{t.classList.remove("state--focus")}))}))}}class l{constructor(t){this.isMobile=!1,this.handleResize=()=>{const t=this.formatScreenSize(e.md);window.innerWidth<=t?this.isMobile=!0:this.isMobile=!1,this.host.requestUpdate()},this.formatScreenSize=t=>parseInt(t.slice(0,-2)),(this.host=t).addController(this),this.handleResize()}hostConnected(){window.addEventListener("resize",this.handleResize)}hostDisconnected(){window.removeEventListener("resize",this.handleResize)}}const d=new Map(Object.entries(e).map((([t,e])=>[t,parseInt(e.slice(0,-2))])).sort((([,t],[,e])=>t-e)));class c{constructor(t){this.isMobile=!1,this.screenSize="xxs",this.handleResize=()=>{const t=[["isMobile",this.isMobile],["screenSize",this.screenSize]];this.isMobile=window.innerWidth<=d.get("sm"),this.screenSize=Array.from(d).reduce(((t,[e,i])=>window.innerWidth>=i?e:t),"xxs"),t.map((([t,e])=>this[t]!==e)).reduce(((t,e)=>t||e))&&this.host.requestUpdate()},(this.host=t).addController(this),this.handleResize()}hostConnected(){this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(document.querySelector("body"))}hostDisconnected(){this.resizeObserver.disconnect()}}class h{constructor(t,e){this.slotNames=[],(this.host=t).addController(this),this.hostEl=this.host,this.shadowShift=!(!e||"boolean"!=typeof e)&&e,this.handleSlotChange=this.handleSlotChange.bind(this)}hasDefaultSlot(){return[...this.host.childNodes].some((t=>{if(t.nodeType===t.TEXT_NODE&&""!==t.textContent.trim())return this.defaultSlot=!0;if(t.nodeType===t.ELEMENT_NODE){if(!t.hasAttribute("slot"))return this.defaultSlot=!0}return this.defaultSlot=!1}))}hasNamedSlot(t){return this.namedSlots=null!==this.host.querySelector(`:scope > [slot="${t}"]`)}test(t){const e=t||"";return""===e?this.hasDefaultSlot():this.hasNamedSlot(e)}hostConnected(){this.host.shadowRoot.addEventListener("slotchange",this.handleSlotChange),this.slotNames=this.getSlots(),setTimeout((()=>this.moveSlots()),0)}hostDisconnected(){this.host.shadowRoot.removeEventListener("slotchange",this.handleSlotChange)}handleSlotChange(t){const e=t.target;(this.defaultSlot&&!e.name||e.name&&this.slotNames.includes(e.name))&&this.host.requestUpdate(),this.moveSlots()}getSlots(){const t=[],e=this.host.querySelectorAll("[slot]");return e.length?this.namedSlots=!0:this.namedSlots=!1,e.forEach((e=>{const i=e.getAttribute("slot");this.test(i)&&t.push(i)})),t}moveNamedSlot(t){const e=this.host,i=!!e.renderRoot&&e.renderRoot.querySelector(`slot[name="${t}"]`);if(i){const r=e.querySelector("[slot="+t+"]");r&&i.append(r)}}moveDefaultSlot(){const t=this.host,e=Array.from(t.children).filter((t=>!t.getAttributeNode("slot"))),i=!!t.renderRoot&&t.renderRoot.querySelector("slot");i&&e.forEach((t=>{i.before(t)}))}moveSlots(){this.shadowShift&&(this.slotNames.map((t=>{this.moveNamedSlot(t)})),this.moveDefaultSlot())}}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function p(t,e,i,r){for(var n,o=arguments.length,a=o<3?e:null===r?r=Object.getOwnPropertyDescriptor(e,i):r,s=t.length-1;s>=0;s--)(n=t[s])&&(a=(o<3?n(a):o>3?n(e,i,a):n(e,i))||a);return o>3&&a&&Object.defineProperty(e,i,a),a
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */}const u=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,g=Symbol(),f=new Map;class m{constructor(t,e){if(this._$cssResult$=!0,e!==g)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t}get styleSheet(){let t=f.get(this.cssText);return u&&void 0===t&&(f.set(this.cssText,t=new CSSStyleSheet),t.replaceSync(this.cssText)),t}toString(){return this.cssText}}const b=(t,...e)=>{const i=1===t.length?t[0]:e.reduce(((e,i,r)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(i)+t[r+1]),t[0]);return new m(i,g)},v=u?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const i of t.cssRules)e+=i.cssText;return(t=>new m("string"==typeof t?t:t+"",g))(e)})(t):t
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;var w;const x=window.trustedTypes,y=x?x.emptyScript:"",C=window.reactiveElementPolyfillSupport,k={toAttribute(t,e){switch(e){case Boolean:t=t?y:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,e){let i=t;switch(e){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t)}catch(t){i=null}}return i}},A=(t,e)=>e!==t&&(e==e||t==t),z={attribute:!0,type:String,converter:k,reflect:!1,hasChanged:A};class $ extends HTMLElement{constructor(){super(),this._$Et=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Ei=null,this.o()}static addInitializer(t){var e;null!==(e=this.l)&&void 0!==e||(this.l=[]),this.l.push(t)}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((e,i)=>{const r=this._$Eh(i,e);void 0!==r&&(this._$Eu.set(r,i),t.push(r))})),t}static createProperty(t,e=z){if(e.state&&(e.attribute=!1),this.finalize(),this.elementProperties.set(t,e),!e.noAccessor&&!this.prototype.hasOwnProperty(t)){const i="symbol"==typeof t?Symbol():"__"+t,r=this.getPropertyDescriptor(t,i,e);void 0!==r&&Object.defineProperty(this.prototype,t,r)}}static getPropertyDescriptor(t,e,i){return{get(){return this[e]},set(r){const n=this[t];this[e]=r,this.requestUpdate(t,n,i)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||z}static finalize(){if(this.hasOwnProperty("finalized"))return!1;this.finalized=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),this.elementProperties=new Map(t.elementProperties),this._$Eu=new Map,this.hasOwnProperty("properties")){const t=this.properties,e=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const i of e)this.createProperty(i,t[i])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(t){const e=[];if(Array.isArray(t)){const i=new Set(t.flat(1/0).reverse());for(const t of i)e.unshift(v(t))}else void 0!==t&&e.push(v(t));return e}static _$Eh(t,e){const i=e.attribute;return!1===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}o(){var t;this._$Ep=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Em(),this.requestUpdate(),null===(t=this.constructor.l)||void 0===t||t.forEach((t=>t(this)))}addController(t){var e,i;(null!==(e=this._$Eg)&&void 0!==e?e:this._$Eg=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(i=t.hostConnected)||void 0===i||i.call(t))}removeController(t){var e;null===(e=this._$Eg)||void 0===e||e.splice(this._$Eg.indexOf(t)>>>0,1)}_$Em(){this.constructor.elementProperties.forEach(((t,e)=>{this.hasOwnProperty(e)&&(this._$Et.set(e,this[e]),delete this[e])}))}createRenderRoot(){var t;const e=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return((t,e)=>{u?t.adoptedStyleSheets=e.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):e.forEach((e=>{const i=document.createElement("style"),r=window.litNonce;void 0!==r&&i.setAttribute("nonce",r),i.textContent=e.cssText,t.appendChild(i)}))})(e,this.constructor.elementStyles),e}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostConnected)||void 0===e?void 0:e.call(t)}))}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostDisconnected)||void 0===e?void 0:e.call(t)}))}attributeChangedCallback(t,e,i){this._$AK(t,i)}_$ES(t,e,i=z){var r,n;const o=this.constructor._$Eh(t,i);if(void 0!==o&&!0===i.reflect){const a=(null!==(n=null===(r=i.converter)||void 0===r?void 0:r.toAttribute)&&void 0!==n?n:k.toAttribute)(e,i.type);this._$Ei=t,null==a?this.removeAttribute(o):this.setAttribute(o,a),this._$Ei=null}}_$AK(t,e){var i,r,n;const o=this.constructor,a=o._$Eu.get(t);if(void 0!==a&&this._$Ei!==a){const t=o.getPropertyOptions(a),s=t.converter,l=null!==(n=null!==(r=null===(i=s)||void 0===i?void 0:i.fromAttribute)&&void 0!==r?r:"function"==typeof s?s:null)&&void 0!==n?n:k.fromAttribute;this._$Ei=a,this[a]=l(e,t.type),this._$Ei=null}}requestUpdate(t,e,i){let r=!0;void 0!==t&&(((i=i||this.constructor.getPropertyOptions(t)).hasChanged||A)(this[t],e)?(this._$AL.has(t)||this._$AL.set(t,e),!0===i.reflect&&this._$Ei!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,i))):r=!1),!this.isUpdatePending&&r&&(this._$Ep=this._$E_())}async _$E_(){this.isUpdatePending=!0;try{await this._$Ep}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Et&&(this._$Et.forEach(((t,e)=>this[e]=t)),this._$Et=void 0);let e=!1;const i=this._$AL;try{e=this.shouldUpdate(i),e?(this.willUpdate(i),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostUpdate)||void 0===e?void 0:e.call(t)})),this.update(i)):this._$EU()}catch(t){throw e=!1,this._$EU(),t}e&&this._$AE(i)}willUpdate(t){}_$AE(t){var e;null===(e=this._$Eg)||void 0===e||e.forEach((t=>{var e;return null===(e=t.hostUpdated)||void 0===e?void 0:e.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EU(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$Ep}shouldUpdate(t){return!0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,e)=>this._$ES(e,this[e],t))),this._$EC=void 0),this._$EU()}updated(t){}firstUpdated(t){}}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var M;$.finalized=!0,$.elementProperties=new Map,$.elementStyles=[],$.shadowRootOptions={mode:"open"},null==C||C({ReactiveElement:$}),(null!==(w=globalThis.reactiveElementVersions)&&void 0!==w?w:globalThis.reactiveElementVersions=[]).push("1.3.0");const S=globalThis.trustedTypes,L=S?S.createPolicy("lit-html",{createHTML:t=>t}):void 0,H=`lit$${(Math.random()+"").slice(9)}$`,B="?"+H,_=`<${B}>`,F=document,D=(t="")=>F.createComment(t),E=t=>null===t||"object"!=typeof t&&"function"!=typeof t,V=Array.isArray,O=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,j=/-->/g,Z=/>/g,R=/>|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,T=/'/g,N=/"/g,P=/^(?:script|style|textarea|title)$/i,Y=(t=>(e,...i)=>({_$litType$:t,strings:e,values:i}))(1),I=Symbol.for("lit-noChange"),U=Symbol.for("lit-nothing"),W=new WeakMap,q=F.createTreeWalker(F,129,null,!1),G=(t,e)=>{const i=t.length-1,r=[];let n,o=2===e?"<svg>":"",a=O;for(let e=0;e<i;e++){const i=t[e];let s,l,d=-1,c=0;for(;c<i.length&&(a.lastIndex=c,l=a.exec(i),null!==l);)c=a.lastIndex,a===O?"!--"===l[1]?a=j:void 0!==l[1]?a=Z:void 0!==l[2]?(P.test(l[2])&&(n=RegExp("</"+l[2],"g")),a=R):void 0!==l[3]&&(a=R):a===R?">"===l[0]?(a=null!=n?n:O,d=-1):void 0===l[1]?d=-2:(d=a.lastIndex-l[2].length,s=l[1],a=void 0===l[3]?R:'"'===l[3]?N:T):a===N||a===T?a=R:a===j||a===Z?a=O:(a=R,n=void 0);const h=a===R&&t[e+1].startsWith("/>")?" ":"";o+=a===O?i+_:d>=0?(r.push(s),i.slice(0,d)+"$lit$"+i.slice(d)+H+h):i+H+(-2===d?(r.push(void 0),e):h)}const s=o+(t[i]||"<?>")+(2===e?"</svg>":"");if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return[void 0!==L?L.createHTML(s):s,r]};class Q{constructor({strings:t,_$litType$:e},i){let r;this.parts=[];let n=0,o=0;const a=t.length-1,s=this.parts,[l,d]=G(t,e);if(this.el=Q.createElement(l,i),q.currentNode=this.el.content,2===e){const t=this.el.content,e=t.firstChild;e.remove(),t.append(...e.childNodes)}for(;null!==(r=q.nextNode())&&s.length<a;){if(1===r.nodeType){if(r.hasAttributes()){const t=[];for(const e of r.getAttributeNames())if(e.endsWith("$lit$")||e.startsWith(H)){const i=d[o++];if(t.push(e),void 0!==i){const t=r.getAttribute(i.toLowerCase()+"$lit$").split(H),e=/([.?@])?(.*)/.exec(i);s.push({type:1,index:n,name:e[2],strings:t,ctor:"."===e[1]?et:"?"===e[1]?rt:"@"===e[1]?nt:tt})}else s.push({type:6,index:n})}for(const e of t)r.removeAttribute(e)}if(P.test(r.tagName)){const t=r.textContent.split(H),e=t.length-1;if(e>0){r.textContent=S?S.emptyScript:"";for(let i=0;i<e;i++)r.append(t[i],D()),q.nextNode(),s.push({type:2,index:++n});r.append(t[e],D())}}}else if(8===r.nodeType)if(r.data===B)s.push({type:2,index:n});else{let t=-1;for(;-1!==(t=r.data.indexOf(H,t+1));)s.push({type:7,index:n}),t+=H.length-1}n++}}static createElement(t,e){const i=F.createElement("template");return i.innerHTML=t,i}}function X(t,e,i=t,r){var n,o,a,s;if(e===I)return e;let l=void 0!==r?null===(n=i._$Cl)||void 0===n?void 0:n[r]:i._$Cu;const d=E(e)?void 0:e._$litDirective$;return(null==l?void 0:l.constructor)!==d&&(null===(o=null==l?void 0:l._$AO)||void 0===o||o.call(l,!1),void 0===d?l=void 0:(l=new d(t),l._$AT(t,i,r)),void 0!==r?(null!==(a=(s=i)._$Cl)&&void 0!==a?a:s._$Cl=[])[r]=l:i._$Cu=l),void 0!==l&&(e=X(t,l._$AS(t,e.values),l,r)),e}class K{constructor(t,e){this.v=[],this._$AN=void 0,this._$AD=t,this._$AM=e}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}p(t){var e;const{el:{content:i},parts:r}=this._$AD,n=(null!==(e=null==t?void 0:t.creationScope)&&void 0!==e?e:F).importNode(i,!0);q.currentNode=n;let o=q.nextNode(),a=0,s=0,l=r[0];for(;void 0!==l;){if(a===l.index){let e;2===l.type?e=new J(o,o.nextSibling,this,t):1===l.type?e=new l.ctor(o,l.name,l.strings,this,t):6===l.type&&(e=new ot(o,this,t)),this.v.push(e),l=r[++s]}a!==(null==l?void 0:l.index)&&(o=q.nextNode(),a++)}return n}m(t){let e=0;for(const i of this.v)void 0!==i&&(void 0!==i.strings?(i._$AI(t,i,e),e+=i.strings.length-2):i._$AI(t[e])),e++}}class J{constructor(t,e,i,r){var n;this.type=2,this._$AH=U,this._$AN=void 0,this._$AA=t,this._$AB=e,this._$AM=i,this.options=r,this._$Cg=null===(n=null==r?void 0:r.isConnected)||void 0===n||n}get _$AU(){var t,e;return null!==(e=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==e?e:this._$Cg}get parentNode(){let t=this._$AA.parentNode;const e=this._$AM;return void 0!==e&&11===t.nodeType&&(t=e.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,e=this){t=X(this,t,e),E(t)?t===U||null==t||""===t?(this._$AH!==U&&this._$AR(),this._$AH=U):t!==this._$AH&&t!==I&&this.$(t):void 0!==t._$litType$?this.T(t):void 0!==t.nodeType?this.k(t):(t=>{var e;return V(t)||"function"==typeof(null===(e=t)||void 0===e?void 0:e[Symbol.iterator])})(t)?this.S(t):this.$(t)}A(t,e=this._$AB){return this._$AA.parentNode.insertBefore(t,e)}k(t){this._$AH!==t&&(this._$AR(),this._$AH=this.A(t))}$(t){this._$AH!==U&&E(this._$AH)?this._$AA.nextSibling.data=t:this.k(F.createTextNode(t)),this._$AH=t}T(t){var e;const{values:i,_$litType$:r}=t,n="number"==typeof r?this._$AC(t):(void 0===r.el&&(r.el=Q.createElement(r.h,this.options)),r);if((null===(e=this._$AH)||void 0===e?void 0:e._$AD)===n)this._$AH.m(i);else{const t=new K(n,this),e=t.p(this.options);t.m(i),this.k(e),this._$AH=t}}_$AC(t){let e=W.get(t.strings);return void 0===e&&W.set(t.strings,e=new Q(t)),e}S(t){V(this._$AH)||(this._$AH=[],this._$AR());const e=this._$AH;let i,r=0;for(const n of t)r===e.length?e.push(i=new J(this.A(D()),this.A(D()),this,this.options)):i=e[r],i._$AI(n),r++;r<e.length&&(this._$AR(i&&i._$AB.nextSibling,r),e.length=r)}_$AR(t=this._$AA.nextSibling,e){var i;for(null===(i=this._$AP)||void 0===i||i.call(this,!1,!0,e);t&&t!==this._$AB;){const e=t.nextSibling;t.remove(),t=e}}setConnected(t){var e;void 0===this._$AM&&(this._$Cg=t,null===(e=this._$AP)||void 0===e||e.call(this,t))}}class tt{constructor(t,e,i,r,n){this.type=1,this._$AH=U,this._$AN=void 0,this.element=t,this.name=e,this._$AM=r,this.options=n,i.length>2||""!==i[0]||""!==i[1]?(this._$AH=Array(i.length-1).fill(new String),this.strings=i):this._$AH=U}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,e=this,i,r){const n=this.strings;let o=!1;if(void 0===n)t=X(this,t,e,0),o=!E(t)||t!==this._$AH&&t!==I,o&&(this._$AH=t);else{const r=t;let a,s;for(t=n[0],a=0;a<n.length-1;a++)s=X(this,r[i+a],e,a),s===I&&(s=this._$AH[a]),o||(o=!E(s)||s!==this._$AH[a]),s===U?t=U:t!==U&&(t+=(null!=s?s:"")+n[a+1]),this._$AH[a]=s}o&&!r&&this.C(t)}C(t){t===U?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"")}}class et extends tt{constructor(){super(...arguments),this.type=3}C(t){this.element[this.name]=t===U?void 0:t}}const it=S?S.emptyScript:"";class rt extends tt{constructor(){super(...arguments),this.type=4}C(t){t&&t!==U?this.element.setAttribute(this.name,it):this.element.removeAttribute(this.name)}}class nt extends tt{constructor(t,e,i,r,n){super(t,e,i,r,n),this.type=5}_$AI(t,e=this){var i;if((t=null!==(i=X(this,t,e,0))&&void 0!==i?i:U)===I)return;const r=this._$AH,n=t===U&&r!==U||t.capture!==r.capture||t.once!==r.once||t.passive!==r.passive,o=t!==U&&(r===U||n);n&&this.element.removeEventListener(this.name,this,r),o&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var e,i;"function"==typeof this._$AH?this._$AH.call(null!==(i=null===(e=this.options)||void 0===e?void 0:e.host)&&void 0!==i?i:this.element,t):this._$AH.handleEvent(t)}}class ot{constructor(t,e,i){this.element=t,this.type=6,this._$AN=void 0,this._$AM=e,this.options=i}get _$AU(){return this._$AM._$AU}_$AI(t){X(this,t)}}const at=window.litHtmlPolyfillSupport;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var st,lt;null==at||at(Q,J),(null!==(M=globalThis.litHtmlVersions)&&void 0!==M?M:globalThis.litHtmlVersions=[]).push("2.2.0");class dt extends ${constructor(){super(...arguments),this.renderOptions={host:this},this._$Dt=void 0}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const e=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Dt=((t,e,i)=>{var r,n;const o=null!==(r=null==i?void 0:i.renderBefore)&&void 0!==r?r:e;let a=o._$litPart$;if(void 0===a){const t=null!==(n=null==i?void 0:i.renderBefore)&&void 0!==n?n:null;o._$litPart$=a=new J(e.insertBefore(D(),t),t,void 0,null!=i?i:{})}return a._$AI(t),a})(e,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!1)}render(){return I}}dt.finalized=!0,dt._$litElement$=!0,null===(st=globalThis.litElementHydrateSupport)||void 0===st||st.call(globalThis,{LitElement:dt});const ct=globalThis.litElementPolyfillSupport;null==ct||ct({LitElement:dt}),(null!==(lt=globalThis.litElementVersions)&&void 0!==lt?lt:globalThis.litElementVersions=[]).push("3.2.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ht=t=>e=>"function"==typeof e?((t,e)=>(window.customElements.define(t,e),e))(t,e):((t,e)=>{const{kind:i,elements:r}=e;return{kind:i,elements:r,finisher(e){window.customElements.define(t,e)}}})(t,e)
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */,pt=(t,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(i){i.createProperty(e.key,t)}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this))},finisher(i){i.createProperty(e.key,t)}};function ut(t){return(e,i)=>void 0!==i?((t,e,i)=>{e.constructor.createProperty(i,t)})(t,e,i):pt(t,e)
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */}function gt(t){return ut({...t,state:!0})}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const ft=({finisher:t,descriptor:e})=>(i,r)=>{var n;if(void 0===r){const r=null!==(n=i.originalKey)&&void 0!==n?n:i.key,o=null!=e?{kind:"method",placement:"prototype",key:r,descriptor:e(i.key)}:{...i,key:r};return null!=t&&(o.finisher=function(e){t(e,r)}),o}{const n=i.constructor;void 0!==e&&Object.defineProperty(i,r,e(r)),null==t||t(n,r)}}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;function mt(t,e){return ft({descriptor:i=>{const r={get(){var e,i;return null!==(i=null===(e=this.renderRoot)||void 0===e?void 0:e.querySelector(t))&&void 0!==i?i:null},enumerable:!0,configurable:!0};if(e){const e="symbol"==typeof i?Symbol():"__"+i;r.get=function(){var i,r;return void 0===this[e]&&(this[e]=null!==(r=null===(i=this.renderRoot)||void 0===i?void 0:i.querySelector(t))&&void 0!==r?r:null),this[e]}}return r}})}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function bt(t){return ft({descriptor:e=>({get(){var e,i;return null!==(i=null===(e=this.renderRoot)||void 0===e?void 0:e.querySelectorAll(t))&&void 0!==i?i:[]},enumerable:!0,configurable:!0})})}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var vt;const wt=null!=(null===(vt=window.HTMLSlotElement)||void 0===vt?void 0:vt.prototype.assignedElements)?(t,e)=>t.assignedElements(e):(t,e)=>t.assignedNodes(e).filter((t=>t.nodeType===Node.ELEMENT_NODE));function xt(t){const{slot:e,selector:i}=null!=t?t:{};return ft({descriptor:r=>({get(){var r;const n="slot"+(e?`[name=${e}]`:":not([name])"),o=null===(r=this.renderRoot)||void 0===r?void 0:r.querySelector(n),a=null!=o?wt(o,t):[];return i?a.filter((t=>t.matches(i))):a},enumerable:!0,configurable:!0})})}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const yt=t=>({_$litStatic$:t}),Ct=new Map,kt=(t=>(e,...i)=>{var r;const n=i.length;let o,a;const s=[],l=[];let d,c=0,h=!1;for(;c<n;){for(d=e[c];c<n&&void 0!==(a=i[c],o=null===(r=a)||void 0===r?void 0:r._$litStatic$);)d+=o+e[++c],h=!0;l.push(a),s.push(d),c++}if(c===n&&s.push(e[n]),h){const t=s.join("$$lit$$");void 0===(e=Ct.get(t))&&(s.raw=s,Ct.set(t,e=s)),i=l}return t(e,...i)})(Y),At=t=>null!=t?t:U;
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var zt=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
/* ! tailwindcss v3.0.23 | MIT License | https://tailwindcss.com */

*,
::before,
::after{
  box-sizing:border-box;
  border-width:0;
  border-style:solid;
  border-color:var(--gray-200);
}

::before,
::after{
  --tw-content:'';
}

html{
  line-height:1.5;
  -webkit-text-size-adjust:100%;
  -moz-tab-size:4;
  tab-size:4;
  font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

body{
  margin:0;
  line-height:inherit;
}

hr{
  height:0;
  color:inherit;
  border-top-width:1px;
}

abbr:where([title]){
  -webkit-text-decoration:underline dotted;
          text-decoration:underline dotted;
}

h1,
h2,
h3,
h4,
h5,
h6{
  font-size:inherit;
  font-weight:inherit;
}

a{
  color:inherit;
  text-decoration:inherit;
}

b,
strong{
  font-weight:bolder;
}

code,
kbd,
samp,
pre{
  font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size:1em;
}

small{
  font-size:80%;
}

sub,
sup{
  font-size:75%;
  line-height:0;
  position:relative;
  vertical-align:baseline;
}

sub{
  bottom:-0.25em;
}

sup{
  top:-0.5em;
}

table{
  text-indent:0;
  border-color:inherit;
  border-collapse:collapse;
}

button,
input,
optgroup,
select,
textarea{
  font-family:inherit;
  font-size:100%;
  line-height:inherit;
  color:inherit;
  margin:0;
  padding:0;
}

button,
select{
  text-transform:none;
}

button,
[type='button'],
[type='reset'],
[type='submit']{
  -webkit-appearance:button;
  background-color:transparent;
  background-image:none;
}

:-moz-focusring{
  outline:auto;
}

:-moz-ui-invalid{
  box-shadow:none;
}

progress{
  vertical-align:baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button{
  height:auto;
}

[type='search']{
  -webkit-appearance:textfield;
  outline-offset:-2px;
}

::-webkit-search-decoration{
  -webkit-appearance:none;
}

::-webkit-file-upload-button{
  -webkit-appearance:button;
  font:inherit;
}

summary{
  display:list-item;
}

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre{
  margin:0;
}

fieldset{
  margin:0;
  padding:0;
}

legend{
  padding:0;
}

ol,
ul,
menu{
  list-style:none;
  margin:0;
  padding:0;
}

textarea{
  resize:vertical;
}

input::-moz-placeholder, textarea::-moz-placeholder{
  opacity:1;
  color:var(--gray-400);
}

input::placeholder,
textarea::placeholder{
  opacity:1;
  color:var(--gray-400);
}

button,
[role="button"]{
  cursor:pointer;
}
:disabled{
  cursor:default;
}

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object{
  display:block;
  vertical-align:middle;
}

img,
video{
  max-width:100%;
  height:auto;
}

[hidden]{
  display:none;
}

*, ::before, ::after{
  --tw-translate-x:0;
  --tw-translate-y:0;
  --tw-rotate:0;
  --tw-skew-x:0;
  --tw-skew-y:0;
  --tw-scale-x:1;
  --tw-scale-y:1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness:proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width:0px;
  --tw-ring-offset-color:#fff;
  --tw-ring-color:rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow:0 0 #0000;
  --tw-ring-shadow:0 0 #0000;
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}
`;let $t=class extends dt{connectedCallback(){super.connectedCallback()}disconnectedCallback(){super.disconnectedCallback()}_conditionalSlotTemplate({elementName:t,slotNameStub:e,wrapperElementType:i="div",ariaLabel:r=null}){const n=`${t}--${e}`;return null!==this.querySelector(`[slot="${n}"]`)?kt`<${yt(i)} id="${e}" aria-label="${At(r)}">
          <slot
            name="${n}"
            @slotchange="${()=>this.requestUpdate()}"
          ></slot>
        </${yt(i)}>`:null}};$t.styles=[zt],$t=p([ht("outline-element")],$t);var Mt=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.accordion-title {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  color: var(--outline-soft-black);
}

.accordion-title.mobile {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--outline-soft-black);
}

::slotted(outline-heading){
  margin-bottom:2.5rem;
}

[aria-hidden='true']{
  display:none !important;
}
`;let St=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.slots=new h(this,!1),this.clean=!1,this.singlePanel=!1,this.allOpen=!1,this.isMobile=()=>this.mobileController.isMobile?"mobile":null}render(){return Y`
      ${this.hasLabel?Y`<div class="label"><slot name="label"></slot></div>`:null}
      <div class="accordion" @keydown=${this.handleKeyboardNav}>
        <slot name="panels"></slot>
      </div>
    `}handleKeyboardNav(t){var e,i;let r=0;const n=this.panels,o=Array.prototype.indexOf.call(n,t.target);if("ArrowDown"!==t.key&&"ArrowUp"!==t.key)return;"ArrowDown"===t.key&&(r=(null==n?void 0:n.length)&&o+1>(null==n?void 0:n.length)-1?0:o+1),"ArrowUp"===t.key&&(r=(null==n?void 0:n.length)&&o-1<0?(null==n?void 0:n.length)-1:o-1);null===(i=null===(e=(null==n?void 0:n[r]).shadowRoot)||void 0===e?void 0:e.querySelector("button"))||void 0===i||i.focus()}firstUpdated(){this.hasLabel=this.slots.test("label"),this.allOpen&&this.panels.map((t=>{t.setAttribute("active","active")}))}updated(){this.clean?this.panels.map((t=>t.setAttribute("clean","clean"))):this.panels.map((t=>t.removeAttribute("clean")))}};St.styles=[Mt],p([ut({type:Boolean})],St.prototype,"clean",void 0),p([ut({type:Boolean,attribute:"single-panel"})],St.prototype,"singlePanel",void 0),p([ut({type:Boolean})],St.prototype,"allOpen",void 0),p([xt({slot:"panels"})],St.prototype,"panels",void 0),p([gt()],St.prototype,"hasLabel",void 0),St=p([ht("outline-accordion")],St);var Lt=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.accordion-button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-width: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 2rem;
  padding-right: 0px;
}

.accordion-button.mobile {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 1rem !important;
  padding-right: 0px !important;
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
  line-height: 1.25rem !important;
}

.accordion-button.active {
  background-color: var(--outline-soft-black);
  color: var(--neutral-white);
}

.accordion-button.inactive {
  background-color: var(--neutral-white);
  color: var(--outline-soft-black);
}

.accordion-button.clean {
  border-bottom-width: 1px;
  border-style: solid;
  border-color: var(--outline-medium-gray);
  padding-left: 0px;
}

.accordion-button.clean.active {
  background-color: var(--neutral-white) !important;
  color: var(--outline-soft-black) !important;
}

.accordion-button.clean.inactive {
  color: var(--outline-soft-black);
}

.accordion-content {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.accordion-content.mobile {
  padding-left: 1rem;
  padding-right: 1rem;
}

.clean .accordion-content {
  padding-left: 0px;
  padding-right: 0px;
}

.accordion-label {
  text-align: left;
  max-width:75%;
}

::slotted(outline-heading){
  margin:1rem 0;
}

.accordion-heading {
  margin: 0px;
  display: flex;
}

.accordion-icon {
  display: flex;
  height: 100%;
  width: 5rem;
  align-items: center;
  justify-content: center;
}

.accordion-icon.clean {
  background-color: var(--neutral-white) !important;
  color: var(--outline-soft-black) !important;
}

.accordion-icon.active {
  background-color: var(--outline-soft-black);
  color: var(--neutral-white);
}

.accordion-icon.inactive {
  background-color: var(--outline-dark-gray);
  color: var(--outline-white);
}

.accordion-panel {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  border-style: solid;
  border-color: var(--outline-soft-black);
}

.accordion-panel.clean {
  border-width: 0px;
}

[aria-hidden='true']{
  display:none !important;
}
`
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;const Ht=1,Bt=2,_t=t=>(...e)=>({_$litDirective$:t,values:e});class Ft{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const Dt=_t(class extends Ft{constructor(t){var e;if(super(t),t.type!==Ht||"class"!==t.name||(null===(e=t.strings)||void 0===e?void 0:e.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return" "+Object.keys(t).filter((e=>t[e])).join(" ")+" "}update(t,[e]){var i,r;if(void 0===this.et){this.et=new Set,void 0!==t.strings&&(this.st=new Set(t.strings.join(" ").split(/\s/).filter((t=>""!==t))));for(const t in e)e[t]&&!(null===(i=this.st)||void 0===i?void 0:i.has(t))&&this.et.add(t);return this.render(e)}const n=t.element.classList;this.et.forEach((t=>{t in e||(n.remove(t),this.et.delete(t))}));for(const t in e){const i=!!e[t];i===this.et.has(t)||(null===(r=this.st)||void 0===r?void 0:r.has(t))||(i?(n.add(t),this.et.add(t)):(n.remove(t),this.et.delete(t)))}return I}});var Et=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host svg{
  height:inherit;
  width:inherit;
}
`
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;class Vt extends Ft{constructor(t){if(super(t),this.it=U,t.type!==Bt)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(t){if(t===U||null==t)return this.ft=void 0,this.it=t;if(t===I)return t;if("string"!=typeof t)throw Error(this.constructor.directiveName+"() called with a non-string value");if(t===this.it)return this.ft;this.it=t;const e=[t];return e.raw=e,this.ft={_$litType$:this.constructor.resultType,strings:e,values:[]}}}Vt.directiveName="unsafeHTML",Vt.resultType=1;const Ot=_t(Vt);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class jt extends Vt{}jt.directiveName="unsafeSVG",jt.resultType=2;const Zt=_t(jt);function Rt(t,e,i){const r=new CustomEvent(e,Object.assign({bubbles:!0,cancelable:!1,composed:!0,detail:{}},i));return t.dispatchEvent(r),r}function Tt(t,e){const i=Object.assign({waitUntilFirstUpdate:!1},e);return(e,r)=>{const{update:n}=e;if(t in e){const o=t;e.update=function(t){if(t.has(o)){const e=t.get(o),n=this[o];e!==n&&(i.waitUntilFirstUpdate&&!this.hasUpdated||this[r](e,n))}n.call(this,t)}}}}const Nt={"check-lg":'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">\n      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"></path>\n    </svg>\n  ',"chevron-down":'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">\n      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>\n    </svg>\n  ',"chevron-left":'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">\n      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>\n    </svg>\n  ',"chevron-right":'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">\n      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>\n    </svg>\n  ',"chevron-up":'\n  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">\n    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>\n  </svg>\n  ',x:'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">\n      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>\n    </svg>\n  ',"x-circle-fill":'\n    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">\n      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>\n    </svg>\n  '};let Pt=[{name:"system",resolver:t=>t in Nt?`data:image/svg+xml,${encodeURIComponent(Nt[t])}`:""},{name:"bootstrap",resolver:t=>`https://cdn.jsdelivr.net/npm/bootstrap-icons@1.0.0/icons/${t}.svg`},{name:"boxicons",resolver:t=>{let e="regular";return"bxs-"===t.substring(0,4)&&(e="solid"),"bxl-"===t.substring(0,4)&&(e="logos"),`https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${e}/${t}.svg`},mutator:t=>t.setAttribute("fill","currentColor")},{name:"lucide",resolver:t=>`https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${t}.svg`},{name:"heroicons",resolver:t=>`https://cdn.jsdelivr.net/npm/heroicons@0.4.2/outline/${t}.svg`,mutator:t=>{t.setAttribute("width","16px"),t.setAttribute("height","16px")}},{name:"iconoir",resolver:t=>`https://cdn.jsdelivr.net/gh/lucaburgio/iconoir@latest/icons/${t}.svg`},{name:"ionicons",resolver:t=>`https://cdn.jsdelivr.net/npm/ionicons@5.1.2/dist/ionicons/svg/${t}.svg`,mutator:t=>{t.setAttribute("fill","currentColor"),t.setAttribute("stroke","currentColor"),[...t.querySelectorAll(".ionicon-fill-none")].map((t=>t.setAttribute("fill","none"))),[...t.querySelectorAll(".ionicon-stroke-width")].map((t=>t.setAttribute("stroke-width","32px")))}},{name:"jam",resolver:t=>`https://cdn.jsdelivr.net/npm/jam-icons@2.0.0/svg/${t}.svg`,mutator:t=>t.setAttribute("fill","currentColor")},{name:"fa",resolver:t=>{const e=t.replace(/^fa[rbs]-/,"");let i="regular";return"fas-"===t.substring(0,4)&&(i="solid"),"fab-"===t.substring(0,4)&&(i="brands"),`https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${i}/${e}.svg`},mutator:t=>t.setAttribute("fill","currentColor")},{name:"material",resolver:t=>{const e=t.match(/^(.*?)(_(round|sharp))?$/);return`https://cdn.jsdelivr.net/npm/@material-icons/svg@1.0.5/svg/${e[1]}/${e[3]||"outline"}.svg`},mutator:t=>t.setAttribute("fill","currentColor")},{name:"remix",resolver:t=>{const e=t.match(/^(.*?)\/(.*?)?$/);return e[1]=e[1].charAt(0).toUpperCase()+e[1].slice(1),`https://cdn.jsdelivr.net/npm/remixicon@2.5.0/icons/${e[1]}/${e[2]}.svg`},mutator:t=>t.setAttribute("fill","currentColor")},{name:"unicons",resolver:t=>{const e=t.match(/^(.*?)(-s)?$/);return`https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${"-s"===e[2]?"solid":"line"}/${e[1]}.svg`},mutator:t=>t.setAttribute("fill","currentColor")},{name:"custom",resolver:t=>`/dist/assets/svg/custom/${t}.svg`}],Yt=[];function It(t){Pt=Pt.filter((e=>e.name!==t))}function Ut(t){Yt.push(t)}function Wt(t){Yt=Yt.filter((e=>e!==t))}function qt(t){return Pt.find((e=>e.name===t))}function Gt(t,e){It(t),Pt.push({name:t,resolver:e.resolver,mutator:e.mutator}),Yt.forEach((e=>{e.library===t&&e.redraw()}))}const Qt=new Map;function Xt(t,e="cors"){if(Qt.has(t))return Qt.get(t);const i=fetch(t,{mode:e}).then((async t=>({ok:t.ok,status:t.status,html:await t.text()})));return Qt.set(t,i),i}const Kt=new Map;async function Jt(t){if(Kt.has(t))return Kt.get(t);const e=await Xt(t),i={ok:e.ok,status:e.status,svg:null};if(e.ok){const t=document.createElement("div");t.innerHTML=e.html;const r=t.firstElementChild;i.svg="svg"===(null==r?void 0:r.tagName.toLowerCase())?r.outerHTML:""}return Kt.set(t,i),i}var te={libraries:{bootstrap:!0,boxicons:!0,fontawesome:!0,heroicons:!0,iconoir:!0,ionicons:!0,jam:!0,lucide:!0,material:!0,remix:!0,unicons:!0},defaults:{library:"bootstrap",size:"16px",icon:"chevron-right"}};const ee=new DOMParser;let ie=class extends $t{constructor(){super(...arguments),this.svg="",this.label="",this.library=te.defaults.library,this.size=te.defaults.size}connectedCallback(){super.connectedCallback(),Ut(this)}firstUpdated(){this.setIcon(),this.sizeIcon()}disconnectedCallback(){super.disconnectedCallback(),Wt(this)}sizeIcon(){var t;if(this.size&&"string"==typeof this.size&&this.size!==te.defaults.size){const e=null===(t=this.shadowRoot)||void 0===t?void 0:t.querySelector(".icon");null==e||e.style.setProperty("width",this.size),null==e||e.style.setProperty("height",this.size)}}getUrl(){const t=qt(this.library);return this.name&&t?t.resolver(this.name):this.src}redraw(){this.setIcon()}async setIcon(){var t;const e=qt(this.library),i=this.getUrl();if(i)try{const r=await Jt(i);if(i!==this.getUrl())return;if(r.ok){const i=ee.parseFromString(r.svg,"text/html").body.querySelector("svg");null!==i?(null===(t=null==e?void 0:e.mutator)||void 0===t||t.call(e,i),this.svg=i.outerHTML,Rt(this,"outline-load")):(this.svg="",Rt(this,"outline-error",{detail:{status:r.status}}))}else this.svg="",Rt(this,"outline-error",{detail:{status:r.status}})}catch(t){Rt(this,"outline-error",{detail:{status:-1}})}else this.svg.length>0&&(this.svg="")}handleChange(){this.setIcon()}render(){const t="string"==typeof this.label&&this.label.length>0,e={icon:!0,[`icon-library--${this.library}`]:this.library};return Y` <div
      part="base"
      class="${Dt(e)}"
      role=${At(t?"img":void 0)}
      aria-label=${At(t?this.label:void 0)}
      aria-hidden=${At(t?void 0:"true")}
    >
      ${Zt(this.svg)}
    </div>`}};ie.styles=[Et],p([gt()],ie.prototype,"svg",void 0),p([ut({type:String,reflect:!0,attribute:"name"})],ie.prototype,"name",void 0),p([ut({type:String,attribute:"src"})],ie.prototype,"src",void 0),p([ut({type:String,attribute:"label"})],ie.prototype,"label",void 0),p([ut({type:String,attribute:"library"})],ie.prototype,"library",void 0),p([ut({attribute:"size"})],ie.prototype,"size",void 0),p([Tt("name"),Tt("src"),Tt("library")],ie.prototype,"setIcon",null),ie=p([ht("outline-icon")],ie);let re=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.clean=!1,this.active=!1,this.id=Math.floor(1e4*Math.random()).toString()}render(){const t=this.mobileController.isMobile?"mobile":null,e=this.clean?"clean":null,i=this.active?"active":"inactive";return Y` <div class="accordion-panel ${e}">
      <div class="accordion-heading">
        <button
          class="accordion-button ${t} ${i} ${e}"
          id="${this.id}-button"
          aria-expanded=${this.active}
          aria-controls="${this.id}-info"
          @click=${this.setActive}
        >
          <span class="accordion-label ${t}">
            <slot name="heading"> </slot>
          </span>
          <span class="accordion-icon ${t} ${i} ${e}">
            <outline-icon
              name="${this.active?"chevron-up":"chevron-down"}"
              size="24px"
            ></outline-icon>
          </span>
        </button>
      </div>
      <div
        class="accordion-content ${t}"
        role="region"
        aria-labelledby="${this.id}-button"
        id="${this.id}-info"
        aria-hidden="${!this.active}"
      >
        <slot></slot>
      </div>
    </div>`}setActive(){const t=this.parentElement;if(t.singlePanel){const e=[...t.panels].filter((t=>1==t.active));e.length<1&&(this.active=!0),e.length>0&&e.map((t=>{t.id===this.id?this.active=!1:(t.active=!1,this.active=!0)}))}else this.active=!this.active}};re.styles=[Lt],p([ut({type:Boolean})],re.prototype,"clean",void 0),p([ut({type:Boolean,reflect:!0,attribute:!0})],re.prototype,"active",void 0),p([ut({type:String,reflect:!0})],re.prototype,"id",void 0),re=p([ht("outline-accordion-panel")],re);var ne=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.links{
  padding-top:var(--outline-admin-links-y-spacing);
  padding-bottom:var(--outline-admin-links-y-spacing);
}

ul{
  display:flex;
  list-style-type:none;
  margin:0;
  padding:0;
}

li{
  margin:0;
  padding:0;
  display:block;
}

a{
  position:relative;
  text-decoration:none;
  padding-top:var(--outline-admin-links-link-y-spacing);
  padding-bottom:var(--outline-admin-links-link-y-spacing);
  padding-left:var(--outline-admin-links-link-x-spacing);
  padding-right:var(--outline-admin-links-link-x-spacing);
  background:var(--outline-admin-links-bg-default);
  color:var(--outline-admin-links-color-default);
}

a:hover{
    outline:none;
    background:var(--outline-admin-links-bg-hover);
    color:var(--outline-admin-links-color-hover);
  }

a:focus{
    outline:0;
    background:var(--outline-admin-links-bg-focus);
    color:var(--outline-admin-links-color-focus);
  }

a:not(.is-active):hover::before,
  a:not(.is-active):focus::before{
    position:absolute;
    top:50%;
    left:50%;
    width:calc(100%);
    height:100%;
    content:'';
    transform:translate(-50%, -50%);
    border:solid 2px var(--outline-admin-links-color-hover);
    border-radius:0.25rem;
  }

a.is-active{
    outline:solid 2px var(--outline-admin-links-color-hover);
    background:var(--outline-admin-links-bg-active);
    color:var(--outline-admin-links-color-active);
    z-index:1;
  }

a.is-active:hover,
    a.is-active:focus{
      outline-offset:2px;
    }

.visually-hidden{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}
`;let oe=class extends $t{constructor(){super(...arguments),this.slots=new h(this,!0)}render(){return Y`
      <div class="links">
        <slot></slot>
      </div>
    `}};oe.styles=[ne],oe=p([ht("outline-admin-links")],oe);var ae=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#body {

  display: block;

  border-width: 0px;

  border-left-width: 8px;

  border-style: solid;

  background-color: var(--ui-infoBackground);

  padding: 1rem;

  color: var(--ui-infoText);

  border-color:var(--ui-infoText)
}
#header {

  font-size: var(--fs-lg);

  line-height: var(--lh-lg);

  font-weight: var(--fw-bold);

  text-transform: capitalize
}
:host([statusType='warning']) #body {

  background-color: var(--ui-warningBackground);

  color: var(--ui-warningText);

  border-color:var(--ui-warningText)
}
:host([statusType='error']) #body {

  background-color: var(--ui-errorBackground);

  color: var(--ui-errorText);

  border-color:var(--ui-errorText)
}
:host([statusType='success']) #body {

  background-color: var(--ui-successBackground);

  color: var(--ui-successText);

  border-color:var(--ui-successText)
}
`;const se=["small","large"],le=["information","warning","error","success"];let de=class extends $t{constructor(){super(...arguments),this.statusType="information",this.isInteractive=!1,this.shouldShowIcon=!0,this.size="large"}render(){return Y`
      <div
        id="body"
        role="${this.isInteractive?"alertdialog":"alert"}"
        aria-labelledby="${this.isInteractive?"message":null}"
      >
        ${!0===this.shouldShowIcon?Y`
              <div id="icon">
                <!--@todo include icon when we have that ready.-->
              </div>
            `:null}
        ${"large"===this.size?Y`
              <div id="header">
                <slot name="outline-alert--header">${this.statusType}</slot>
              </div>
            `:null}
        <div id="message">
          <slot></slot>
        </div>
      </div>
    `}};de.styles=[ae],p([ut({type:String})],de.prototype,"statusType",void 0),p([ut({type:Boolean})],de.prototype,"isInteractive",void 0),p([ut({type:Boolean})],de.prototype,"shouldShowIcon",void 0),p([ut({type:String})],de.prototype,"size",void 0),de=p([ht("outline-alert")],de);var ce=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outline-breadcrumbs{
  color:var(--outline-breadcrumb-text-color-default);
  background:var(--outline-breadcrumb-bg-color);
  padding:var(--outline-breadcrumb-bg-padding);
}

a, ::slotted(a) {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  -webkit-text-decoration:var(--outline-breadcrumb-link-decoration-default);
          text-decoration:var(--outline-breadcrumb-link-decoration-default);
  color:var(--outline-breadcrumb-link-color-default);
}

a:hover,
::slotted(a:hover){
  -webkit-text-decoration:var(--outline-breadcrumb-link-decoration-hover);
          text-decoration:var(--outline-breadcrumb-link-decoration-hover);
  color:var(--outline-breadcrumb-link-color-hover);
}

a:focus,
::slotted(a:focus){
  -webkit-text-decoration:var(--outline-breadcrumb-link-decoration-focus);
          text-decoration:var(--outline-breadcrumb-link-decoration-focus);
  outline:none;
  color:var(--outline-breadcrumb-link-color-focus);
}

.separator{
  margin-left:var(--outline-breadcrumb-separator-spacing);
  margin-right:var(--outline-breadcrumb-separator-spacing);
}
`,he=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
  max-width:100vw;
  font-family:Futura Std, Helvetica, Arial, sans-serif;
}@media (min-width: 640px){:host{
    max-width:640px;
  }
}@media (min-width: 768px){:host{
    max-width:768px;
  }
}@media (min-width: 1024px){:host{
    max-width:1024px;
  }
}@media (min-width: 1280px){:host{
    max-width:1280px;
  }
}@media (min-width: 1440px){:host{
    max-width:1440px;
  }
}@media (min-width: 2180px){:host{
    max-width:2180px;
  }
}:host{
  padding-top:var(--outline-container-padding-y);
  padding-right:var(--outline-container-padding-x);
  padding-bottom:var(--outline-container-padding-y);
  padding-left:var(--outline-container-padding-x);
}

:host(:not([x-padding])){
  padding-left:0px;
  padding-right:0px;
}

:host(:not([y-padding])){
  padding-top:0px;
  padding-bottom:0px;
}

:host([full-bleed]){
  max-width:100%;
}

:host([container-align]), :host([container-align='center']){
  margin-left:auto;
  margin-right:auto;
}

:host([container-align='left']){
  margin-left:auto;
  margin-right:auto;
  margin-left:0px;
}

:host([container-align='right']){
  margin-left:auto;
  margin-right:auto;
  margin-right:0px;
}
`;let pe=class extends $t{constructor(){super(...arguments),this.xPadding=!1,this.yPadding=!1,this.fullBleed=!1,this.containerAlign="center"}render(){return Y`<slot></slot>`}};pe.styles=[he],p([ut({type:Boolean,reflect:!0,attribute:"x-padding"})],pe.prototype,"xPadding",void 0),p([ut({type:Boolean,reflect:!0,attribute:"y-padding"})],pe.prototype,"yPadding",void 0),p([ut({type:Boolean,reflect:!0,attribute:"full-bleed"})],pe.prototype,"fullBleed",void 0),p([ut({type:String,reflect:!0,attribute:"container-align"})],pe.prototype,"containerAlign",void 0),pe=p([ht("outline-container")],pe);let ue=class extends $t{constructor(){super(...arguments),this.slots=new h(this,!0),this.stringSeparator="/"}firstUpdated(){this.querySelectorAll("span:not(.last)").forEach((t=>{const e=document.createElement("span");e.classList.add("separator"),e.innerHTML=this.stringSeparator,t.append(e)}))}render(){return Y`
      <section class="outline-breadcrumbs">
        <outline-container>
          <slot></slot>
        </outline-container>
      </section>
    `}};ue.styles=[ce],p([ut({type:String,attribute:"string-separator"})],ue.prototype,"stringSeparator",void 0),ue=p([ht("outline-breadcrumbs")],ue);var ge=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display: inline-flex;
  border-radius: 0.5rem;
  vertical-align: middle;
}

.btn {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  border-radius: 0.5rem;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  font-weight: var(--fw-semibold);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
  line-height: 1.5 !important;
  padding:0.5em 1em;
}

.btn[aria-disabled='true'] {
  pointer-events: none !important;
  cursor: not-allowed !important;
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}

.btn.primary {
  border-style: none;
  background-color: var(--outline-dark-blue);
  color: var(--outline-white);
}

.btn.primary:hover, .btn.primary:focus {
  background-color: var(--outline-medium-blue);
}

.btn.primary:hover, .btn.primary:focus {
  color: var(--outline-white);
}

.btn.primary:hover, .btn.primary:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.btn.primary:hover, .btn.primary:focus {
  --tw-ring-color: var(--outline-dark-blue);
}

.primary[aria-disabled='true'] {
  background-color: var(--outline-light-gray) !important;
  color: var(--outline-dark-gray) !important;
}

.primary[aria-disabled='true']:hover, .primary[aria-disabled='true']:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.primary[aria-disabled='true']:hover, .primary[aria-disabled='true']:focus {
  --tw-ring-color: var(--outline-medium-gray);
}

.btn.secondary {
  background-color: var(--outline-white);
  color: var(--outline-dark-blue);
  border:1px solid var(--outline-dark-blue);
}

.btn.secondary:hover, .btn.secondary:focus {
  background-color: var(--outline-light-blue);
}

.btn.secondary:hover, .btn.secondary:focus {
  color: var(--outline-dark-blue);
}

.btn.secondary:hover, .btn.secondary:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.btn.secondary:hover, .btn.secondary:focus {
  --tw-ring-color: var(--outline-medium-blue);
}

.secondary[aria-disabled='true'] {
  background-color: var(--outline-light-gray) !important;
  color: var(--outline-dark-gray) !important;
  border-color:var(--outline-dark-gray);
}

.secondary[aria-disabled='true']:hover, .secondary[aria-disabled='true']:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.secondary[aria-disabled='true']:hover, .secondary[aria-disabled='true']:focus {
  --tw-ring-color: var(--outline-medium-gray);
}

.btn.small {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

.btn.medium {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.btn.large {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

.btn.none {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-right: 1rem !important;
  padding-left: 0px !important;
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
  font-weight: var(--fw-semibold) !important;
  color: var(--outline-dark-blue) !important;
}

.btn.none:hover, .btn.none:focus {
  color: var(--outline-medium-blue) !important;
}

.btn.none:hover, .btn.none:focus {
  -webkit-text-decoration-line: underline !important;
          text-decoration-line: underline !important;
}

.btn.none[aria-disabled='true'] {
  color: var(--outline-dark-gray) !important;
}
`;let fe=class extends $t{constructor(){super(...arguments),this.slots=new h(this,!1),this.buttonVariant="primary",this.buttonSize="medium",this.isDisabled=!1}firstUpdated(){this.hasLeftIcon=this.slots.test("left"),this.hasRightIcon=this.slots.test("right")}render(){return this.buttonUrl?Y` <a
          class="btn ${this.buttonVariant} ${this.buttonSize}"
          href=${this.buttonUrl}
          target=${At(this.buttonTarget)}
          aria-label="${At(this.buttonLabel)}"
          aria-disabled="${At(this.isDisabled)}"
        >
          ${this.iconTemplate(this.hasLeftIcon,"left")}
          <slot></slot>
          ${this.iconTemplate(this.hasRightIcon,"right")}
        </a>`:Y`<button
          class="btn ${this.buttonVariant} ${this.buttonSize}"
          aria-label="${At(this.buttonLabel)}"
          aria-disabled="${At(this.isDisabled)}"
          .onclick="${this.onClick}"
          .onkeyup="${this.onKeyUp}"
        >
          ${this.iconTemplate(this.hasLeftIcon,"left")}
          <slot></slot>
          ${this.iconTemplate(this.hasRightIcon,"right")}
        </button> `}iconTemplate(t,e){return t?Y`<slot name="${e}"></slot>`:null}updated(){this.hasAttribute("is-disabled")?this.setAttribute("aria-disabled","true"):this.setAttribute("aria-disabled","false")}};fe.styles=[ge],p([ut({type:String,attribute:"button-url"})],fe.prototype,"buttonUrl",void 0),p([ut({type:String,attribute:"button-label"})],fe.prototype,"buttonLabel",void 0),p([ut({type:String,attribute:"button-target"})],fe.prototype,"buttonTarget",void 0),p([ut({type:String,attribute:"button-variant"})],fe.prototype,"buttonVariant",void 0),p([ut({type:String,attribute:"button-size"})],fe.prototype,"buttonSize",void 0),p([ut({type:Boolean,attribute:"is-disabled"})],fe.prototype,"isDisabled",void 0),p([ut()],fe.prototype,"onClick",void 0),p([ut()],fe.prototype,"onKeyUp",void 0),p([gt()],fe.prototype,"hasLeftIcon",void 0),p([gt()],fe.prototype,"hasRightIcon",void 0),fe=p([ht("outline-button")],fe);var me=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

  display: block;

  overflow: hidden;
}

  :host section {

  display: flex
}

  :host section {

  flex-direction: column
}

  :host section {

  overflow: hidden
}

  :host section {

  text-align: left
}

  :host p {

  margin-bottom: 2.5rem
}

.outline-shadow {

  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);

  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);

  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);

  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.outline-rounded-2xl {

  border-radius: 1rem
}

.outline-bg-primary {

  background-color: var(--outline-dark-blue)
}

.outline-bg-secondary {

  background-color: var(--outline-medium-blue)
}

.outline-bg-tertiary {

  background-color: var(--outline-light-blue)
}

.outline-bg-black {

  background-color: var(--neutral-black)
}

.outline-bg-white {

  background-color: var(--neutral-white)
}

.outline-bg-gray {

  background-color: var(--neutral-grayMedium)
}

.outline-bg-light-gray {

  background-color: var(--neutral-grayLight)
}
`;let be=class extends $t{constructor(){super(...arguments),this.isRounded=!1,this.hasShadow=!1}connectedCallback(){super.connectedCallback(),this.hasHeaderSlot=null!==this.querySelector('[slot="header"]'),this.hasContentSlot=null!==this.querySelector('[slot="content"]'),this.hasFooterSlot=null!==this.querySelector('[slot="footer"]')}headerTemplate(t){return this.hasHeaderSlot?Y` <section class="${Dt(t)}">
      <slot name="header"></slot>
    </section>`:null}contentTemplate(t){return this.hasContentSlot?Y` <section class="${Dt(t)}">
      <slot name="content"></slot>
    </section>`:null}footerTemplate(t){return this.hasFooterSlot?Y` <section class="${Dt(t)}">
      <slot name="footer"></slot>
    </section>`:null}render(){const t={card:!0,"outline-shadow":this.hasShadow,"outline-rounded-2xl":this.isRounded},e={"card-header":!0,[`outline-bg-${this.bgColorHeader}`]:void 0!==this.bgColorHeader},i={"card-content":!0,[`outline-bg-${this.bgColorContent}`]:void 0!==this.bgColorContent},r={"card-footer":!0,[`outline-bg-${this.bgColorFooter}`]:void 0!==this.bgColorFooter};return Y`
      <section class="${Dt(t)}">
        ${this.headerTemplate(e)}
        ${this.contentTemplate(i)}
        ${this.footerTemplate(r)}
      </section>
    `}};be.styles=[me],p([ut()],be.prototype,"bgColorHeader",void 0),p([ut()],be.prototype,"bgColorContent",void 0),p([ut()],be.prototype,"bgColorFooter",void 0),p([ut({type:Boolean,attribute:"is-rounded"})],be.prototype,"isRounded",void 0),p([ut({type:Boolean,attribute:"has-shadow"})],be.prototype,"hasShadow",void 0),p([gt()],be.prototype,"hasHeaderSlot",void 0),p([gt()],be.prototype,"hasContentSlot",void 0),p([gt()],be.prototype,"hasFooterSlot",void 0),be=p([ht("outline-card")],be);var ve=function(t){var e=/\blang(?:uage)?-([\w-]+)\b/i,i=0,r={},n={manual:t.Prism&&t.Prism.manual,disableWorkerMessageHandler:t.Prism&&t.Prism.disableWorkerMessageHandler,util:{encode:function t(e){return e instanceof o?new o(e.type,t(e.content),e.alias):Array.isArray(e)?e.map(t):e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\u00a0/g," ")},type:function(t){return Object.prototype.toString.call(t).slice(8,-1)},objId:function(t){return t._||Object.defineProperty(t,"_",{value:++i}),t._},clone:function t(e,i){var r,o;switch(i=i||{},n.util.type(e)){case"Object":if(o=n.util.objId(e),i[o])return i[o];for(var a in r={},i[o]=r,e)e.hasOwnProperty(a)&&(r[a]=t(e[a],i));return r;case"Array":return o=n.util.objId(e),i[o]?i[o]:(r=[],i[o]=r,e.forEach((function(e,n){r[n]=t(e,i)})),r);default:return e}},getLanguage:function(t){for(;t&&!e.test(t.className);)t=t.parentElement;return t?(t.className.match(e)||[,"none"])[1].toLowerCase():"none"},currentScript:function(){if("undefined"==typeof document)return null;if("currentScript"in document)return document.currentScript;try{throw new Error}catch(r){var t=(/at [^(\r\n]*\((.*):.+:.+\)$/i.exec(r.stack)||[])[1];if(t){var e=document.getElementsByTagName("script");for(var i in e)if(e[i].src==t)return e[i]}return null}},isActive:function(t,e,i){for(var r="no-"+e;t;){var n=t.classList;if(n.contains(e))return!0;if(n.contains(r))return!1;t=t.parentElement}return!!i}},languages:{plain:r,plaintext:r,text:r,txt:r,extend:function(t,e){var i=n.util.clone(n.languages[t]);for(var r in e)i[r]=e[r];return i},insertBefore:function(t,e,i,r){var o=(r=r||n.languages)[t],a={};for(var s in o)if(o.hasOwnProperty(s)){if(s==e)for(var l in i)i.hasOwnProperty(l)&&(a[l]=i[l]);i.hasOwnProperty(s)||(a[s]=o[s])}var d=r[t];return r[t]=a,n.languages.DFS(n.languages,(function(e,i){i===d&&e!=t&&(this[e]=a)})),a},DFS:function t(e,i,r,o){o=o||{};var a=n.util.objId;for(var s in e)if(e.hasOwnProperty(s)){i.call(e,s,e[s],r||s);var l=e[s],d=n.util.type(l);"Object"!==d||o[a(l)]?"Array"!==d||o[a(l)]||(o[a(l)]=!0,t(l,i,s,o)):(o[a(l)]=!0,t(l,i,null,o))}}},plugins:{},highlightAll:function(t,e){n.highlightAllUnder(document,t,e)},highlightAllUnder:function(t,e,i){var r={callback:i,container:t,selector:'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'};n.hooks.run("before-highlightall",r),r.elements=Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)),n.hooks.run("before-all-elements-highlight",r);for(var o,a=0;o=r.elements[a++];)n.highlightElement(o,!0===e,r.callback)},highlightElement:function(i,r,o){var a=n.util.getLanguage(i),s=n.languages[a];i.className=i.className.replace(e,"").replace(/\s+/g," ")+" language-"+a;var l=i.parentElement;l&&"pre"===l.nodeName.toLowerCase()&&(l.className=l.className.replace(e,"").replace(/\s+/g," ")+" language-"+a);var d={element:i,language:a,grammar:s,code:i.textContent};function c(t){d.highlightedCode=t,n.hooks.run("before-insert",d),d.element.innerHTML=d.highlightedCode,n.hooks.run("after-highlight",d),n.hooks.run("complete",d),o&&o.call(d.element)}if(n.hooks.run("before-sanity-check",d),(l=d.element.parentElement)&&"pre"===l.nodeName.toLowerCase()&&!l.hasAttribute("tabindex")&&l.setAttribute("tabindex","0"),!d.code)return n.hooks.run("complete",d),void(o&&o.call(d.element));if(n.hooks.run("before-highlight",d),d.grammar)if(r&&t.Worker){var h=new Worker(n.filename);h.onmessage=function(t){c(t.data)},h.postMessage(JSON.stringify({language:d.language,code:d.code,immediateClose:!0}))}else c(n.highlight(d.code,d.grammar,d.language));else c(n.util.encode(d.code))},highlight:function(t,e,i){var r={code:t,grammar:e,language:i};return n.hooks.run("before-tokenize",r),r.tokens=n.tokenize(r.code,r.grammar),n.hooks.run("after-tokenize",r),o.stringify(n.util.encode(r.tokens),r.language)},tokenize:function(t,e){var i=e.rest;if(i){for(var r in i)e[r]=i[r];delete e.rest}var n=new l;return d(n,n.head,t),s(t,n,e,n.head,0),function(t){var e=[],i=t.head.next;for(;i!==t.tail;)e.push(i.value),i=i.next;return e}(n)},hooks:{all:{},add:function(t,e){var i=n.hooks.all;i[t]=i[t]||[],i[t].push(e)},run:function(t,e){var i=n.hooks.all[t];if(i&&i.length)for(var r,o=0;r=i[o++];)r(e)}},Token:o};function o(t,e,i,r){this.type=t,this.content=e,this.alias=i,this.length=0|(r||"").length}function a(t,e,i,r){t.lastIndex=e;var n=t.exec(i);if(n&&r&&n[1]){var o=n[1].length;n.index+=o,n[0]=n[0].slice(o)}return n}function s(t,e,i,r,l,h){for(var p in i)if(i.hasOwnProperty(p)&&i[p]){var u=i[p];u=Array.isArray(u)?u:[u];for(var g=0;g<u.length;++g){if(h&&h.cause==p+","+g)return;var f=u[g],m=f.inside,b=!!f.lookbehind,v=!!f.greedy,w=f.alias;if(v&&!f.pattern.global){var x=f.pattern.toString().match(/[imsuy]*$/)[0];f.pattern=RegExp(f.pattern.source,x+"g")}for(var y=f.pattern||f,C=r.next,k=l;C!==e.tail&&!(h&&k>=h.reach);k+=C.value.length,C=C.next){var A=C.value;if(e.length>t.length)return;if(!(A instanceof o)){var z,$=1;if(v){if(!(z=a(y,k,t,b)))break;var M=z.index,S=z.index+z[0].length,L=k;for(L+=C.value.length;M>=L;)L+=(C=C.next).value.length;if(k=L-=C.value.length,C.value instanceof o)continue;for(var H=C;H!==e.tail&&(L<S||"string"==typeof H.value);H=H.next)$++,L+=H.value.length;$--,A=t.slice(k,L),z.index-=k}else if(!(z=a(y,0,A,b)))continue;M=z.index;var B=z[0],_=A.slice(0,M),F=A.slice(M+B.length),D=k+A.length;h&&D>h.reach&&(h.reach=D);var E=C.prev;if(_&&(E=d(e,E,_),k+=_.length),c(e,E,$),C=d(e,E,new o(p,m?n.tokenize(B,m):B,w,B)),F&&d(e,C,F),$>1){var V={cause:p+","+g,reach:D};s(t,e,i,C.prev,k,V),h&&V.reach>h.reach&&(h.reach=V.reach)}}}}}}function l(){var t={value:null,prev:null,next:null},e={value:null,prev:t,next:null};t.next=e,this.head=t,this.tail=e,this.length=0}function d(t,e,i){var r=e.next,n={value:i,prev:e,next:r};return e.next=n,r.prev=n,t.length++,n}function c(t,e,i){for(var r=e.next,n=0;n<i&&r!==t.tail;n++)r=r.next;e.next=r,r.prev=e,t.length-=n}if(t.Prism=n,o.stringify=function t(e,i){if("string"==typeof e)return e;if(Array.isArray(e)){var r="";return e.forEach((function(e){r+=t(e,i)})),r}var o={type:e.type,content:t(e.content,i),tag:"span",classes:["token",e.type],attributes:{},language:i},a=e.alias;a&&(Array.isArray(a)?Array.prototype.push.apply(o.classes,a):o.classes.push(a)),n.hooks.run("wrap",o);var s="";for(var l in o.attributes)s+=" "+l+'="'+(o.attributes[l]||"").replace(/"/g,"&quot;")+'"';return"<"+o.tag+' class="'+o.classes.join(" ")+'"'+s+">"+o.content+"</"+o.tag+">"},!t.document)return t.addEventListener?(n.disableWorkerMessageHandler||t.addEventListener("message",(function(e){var i=JSON.parse(e.data),r=i.language,o=i.code,a=i.immediateClose;t.postMessage(n.highlight(o,n.languages[r],r)),a&&t.close()}),!1),n):n;var h=n.util.currentScript();function p(){n.manual||n.highlightAll()}if(h&&(n.filename=h.src,h.hasAttribute("data-manual")&&(n.manual=!0)),!n.manual){var u=document.readyState;"loading"===u||"interactive"===u&&h&&h.defer?document.addEventListener("DOMContentLoaded",p):window.requestAnimationFrame?window.requestAnimationFrame(p):window.setTimeout(p,16)}return n}("undefined"!=typeof window?window:"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope?self:{});
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */"undefined"!=typeof module&&module.exports&&(module.exports=ve),"undefined"!=typeof global&&(global.Prism=ve),ve.languages.markup={comment:/<!--[\s\S]*?-->/,prolog:/<\?[\s\S]+?\?>/,doctype:{pattern:/<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,greedy:!0,inside:{"internal-subset":{pattern:/(^[^\[]*\[)[\s\S]+(?=\]>$)/,lookbehind:!0,greedy:!0,inside:null},string:{pattern:/"[^"]*"|'[^']*'/,greedy:!0},punctuation:/^<!|>$|[[\]]/,"doctype-tag":/^DOCTYPE/,name:/[^\s<>'"]+/}},cdata:/<!\[CDATA\[[\s\S]*?\]\]>/i,tag:{pattern:/<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,greedy:!0,inside:{tag:{pattern:/^<\/?[^\s>\/]+/,inside:{punctuation:/^<\/?/,namespace:/^[^\s>\/:]+:/}},"special-attr":[],"attr-value":{pattern:/=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,inside:{punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}},punctuation:/\/?>/,"attr-name":{pattern:/[^\s>\/]+/,inside:{namespace:/^[^\s>\/:]+:/}}}},entity:[{pattern:/&[\da-z]{1,8};/i,alias:"named-entity"},/&#x?[\da-f]{1,8};/i]},ve.languages.markup.tag.inside["attr-value"].inside.entity=ve.languages.markup.entity,ve.languages.markup.doctype.inside["internal-subset"].inside=ve.languages.markup,ve.hooks.add("wrap",(function(t){"entity"===t.type&&(t.attributes.title=t.content.replace(/&amp;/,"&"))})),Object.defineProperty(ve.languages.markup.tag,"addInlined",{value:function(t,e){var i={};i["language-"+e]={pattern:/(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,lookbehind:!0,inside:ve.languages[e]},i.cdata=/^<!\[CDATA\[|\]\]>$/i;var r={"included-cdata":{pattern:/<!\[CDATA\[[\s\S]*?\]\]>/i,inside:i}};r["language-"+e]={pattern:/[\s\S]+/,inside:ve.languages[e]};var n={};n[t]={pattern:RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g,(function(){return t})),"i"),lookbehind:!0,greedy:!0,inside:r},ve.languages.insertBefore("markup","cdata",n)}}),Object.defineProperty(ve.languages.markup.tag,"addAttribute",{value:function(t,e){ve.languages.markup.tag.inside["special-attr"].push({pattern:RegExp(/(^|["'\s])/.source+"(?:"+t+")"+/\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,"i"),lookbehind:!0,inside:{"attr-name":/^[^\s=]+/,"attr-value":{pattern:/=[\s\S]+/,inside:{value:{pattern:/(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,lookbehind:!0,alias:[e,"language-"+e],inside:ve.languages[e]},punctuation:[{pattern:/^=/,alias:"attr-equals"},/"|'/]}}}})}}),ve.languages.html=ve.languages.markup,ve.languages.mathml=ve.languages.markup,ve.languages.svg=ve.languages.markup,ve.languages.xml=ve.languages.extend("markup",{}),ve.languages.ssml=ve.languages.xml,ve.languages.atom=ve.languages.xml,ve.languages.rss=ve.languages.xml,function(t){var e=/(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;t.languages.css={comment:/\/\*[\s\S]*?\*\//,atrule:{pattern:/@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,inside:{rule:/^@[\w-]+/,"selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,lookbehind:!0,alias:"selector"},keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/,lookbehind:!0}}},url:{pattern:RegExp("\\burl\\((?:"+e.source+"|"+/(?:[^\\\r\n()"']|\\[\s\S])*/.source+")\\)","i"),greedy:!0,inside:{function:/^url/i,punctuation:/^\(|\)$/,string:{pattern:RegExp("^"+e.source+"$"),alias:"url"}}},selector:{pattern:RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|"+e.source+")*(?=\\s*\\{)"),lookbehind:!0},string:{pattern:e,greedy:!0},property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,lookbehind:!0},important:/!important\b/i,function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,lookbehind:!0},punctuation:/[(){};:,]/},t.languages.css.atrule.inside.rest=t.languages.css;var i=t.languages.markup;i&&(i.tag.addInlined("style","css"),i.tag.addAttribute("style","css"))}(ve),ve.languages.clike={comment:[{pattern:/(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,lookbehind:!0,greedy:!0},{pattern:/(^|[^\\:])\/\/.*/,lookbehind:!0,greedy:!0}],string:{pattern:/(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,greedy:!0},"class-name":{pattern:/(\b(?:class|interface|extends|implements|trait|instanceof|new)\s+|\bcatch\s+\()[\w.\\]+/i,lookbehind:!0,inside:{punctuation:/[.\\]/}},keyword:/\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,boolean:/\b(?:true|false)\b/,function:/\b\w+(?=\()/,number:/\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,operator:/[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,punctuation:/[{}[\];(),.:]/},ve.languages.javascript=ve.languages.extend("clike",{"class-name":[ve.languages.clike["class-name"],{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:prototype|constructor))/,lookbehind:!0}],keyword:[{pattern:/((?:^|\})\s*)catch\b/,lookbehind:!0},{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,lookbehind:!0}],function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,number:/\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}),ve.languages.javascript["class-name"][0].pattern=/(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/,ve.languages.insertBefore("javascript","keyword",{regex:{pattern:/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,lookbehind:!0,greedy:!0,inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/,lookbehind:!0,alias:"language-regex",inside:ve.languages.regex},"regex-delimiter":/^\/|\/$/,"regex-flags":/^[a-z]+$/}},"function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,alias:"function"},parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,lookbehind:!0,inside:ve.languages.javascript},{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,lookbehind:!0,inside:ve.languages.javascript},{pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,lookbehind:!0,inside:ve.languages.javascript},{pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,lookbehind:!0,inside:ve.languages.javascript}],constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}),ve.languages.insertBefore("javascript","string",{hashbang:{pattern:/^#!.*/,greedy:!0,alias:"comment"},"template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,greedy:!0,inside:{"template-punctuation":{pattern:/^`|`$/,alias:"string"},interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,lookbehind:!0,inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/,alias:"punctuation"},rest:ve.languages.javascript}},string:/[\s\S]+/}}}),ve.languages.markup&&(ve.languages.markup.tag.addInlined("script","javascript"),ve.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,"javascript")),ve.languages.js=ve.languages.javascript,ve.languages.graphql={comment:/#.*/,description:{pattern:/(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,greedy:!0,alias:"string",inside:{"language-markdown":{pattern:/(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,lookbehind:!0,inside:ve.languages.markdown}}},string:{pattern:/"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,greedy:!0},number:/(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,boolean:/\b(?:true|false)\b/,variable:/\$[a-z_]\w*/i,directive:{pattern:/@[a-z_]\w*/i,alias:"function"},"attr-name":{pattern:/[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,greedy:!0},"atom-input":{pattern:/[A-Z]\w*Input(?=!?.*$)/m,alias:"class-name"},scalar:/\b(?:Boolean|Float|ID|Int|String)\b/,constant:/\b[A-Z][A-Z_\d]*\b/,"class-name":{pattern:/(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,lookbehind:!0},fragment:{pattern:/(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,lookbehind:!0,alias:"function"},"definition-mutation":{pattern:/(\bmutation\s+)[a-zA-Z_]\w*/,lookbehind:!0,alias:"function"},"definition-query":{pattern:/(\bquery\s+)[a-zA-Z_]\w*/,lookbehind:!0,alias:"function"},keyword:/\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,operator:/[!=|&]|\.{3}/,"property-query":/\w+(?=\s*\()/,object:/\w+(?=\s*\{)/,punctuation:/[!(){}\[\]:=,]/,property:/\w+/},ve.hooks.add("after-tokenize",(function(t){if("graphql"===t.language)for(var e=t.tokens.filter((function(t){return"string"!=typeof t&&"comment"!==t.type&&"scalar"!==t.type})),i=0;i<e.length;){var r=e[i++];if("keyword"===r.type&&"mutation"===r.content){var n=[];if(h(["definition-mutation","punctuation"])&&"("===c(1).content){i+=2;var o=p(/^\($/,/^\)$/);if(-1===o)continue;for(;i<o;i++){var a=c(0);"variable"===a.type&&(u(a,"variable-input"),n.push(a.content))}i=o+1}if(h(["punctuation","property-query"])&&"{"===c(0).content&&(i++,u(c(0),"property-mutation"),n.length>0)){var s=p(/^\{$/,/^\}$/);if(-1===s)continue;for(var l=i;l<s;l++){var d=e[l];"variable"===d.type&&n.indexOf(d.content)>=0&&u(d,"variable-input")}}}}function c(t){return e[i+t]}function h(t,e){e=e||0;for(var i=0;i<t.length;i++){var r=c(i+e);if(!r||r.type!==t[i])return!1}return!0}function p(t,r){for(var n=1,o=i;o<e.length;o++){var a=e[o],s=a.content;if("punctuation"===a.type&&"string"==typeof s)if(t.test(s))n++;else if(r.test(s)&&0===--n)return o}return-1}function u(t,e){var i=t.alias;i?Array.isArray(i)||(t.alias=i=[i]):t.alias=i=[],i.push(e)}})),ve.languages.json={property:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,lookbehind:!0,greedy:!0},string:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,lookbehind:!0,greedy:!0},comment:{pattern:/\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,greedy:!0},number:/-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,punctuation:/[{}[\],]/,operator:/:/,boolean:/\b(?:true|false)\b/,null:{pattern:/\bnull\b/,alias:"keyword"}},ve.languages.webmanifest=ve.languages.json,function(t){var e=/("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;t.languages.json5=t.languages.extend("json",{property:[{pattern:RegExp(e.source+"(?=\\s*:)"),greedy:!0},{pattern:/(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,alias:"unquoted"}],string:{pattern:e,greedy:!0},number:/[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/})}(ve),function(t){var e=/(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;function i(t){return t=t.replace(/<inner>/g,(function(){return e})),RegExp(/((?:^|[^\\])(?:\\{2})*)/.source+"(?:"+t+")")}var r=/(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source,n=/\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g,(function(){return r})),o=/\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;t.languages.markdown=t.languages.extend("markup",{}),t.languages.insertBefore("markdown","prolog",{"front-matter-block":{pattern:/(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,lookbehind:!0,greedy:!0,inside:{punctuation:/^---|---$/,"font-matter":{pattern:/\S+(?:\s+\S+)*/,alias:["yaml","language-yaml"],inside:t.languages.yaml}}},blockquote:{pattern:/^>(?:[\t ]*>)*/m,alias:"punctuation"},table:{pattern:RegExp("^"+n+o+"(?:"+n+")*","m"),inside:{"table-data-rows":{pattern:RegExp("^("+n+o+")(?:"+n+")*$"),lookbehind:!0,inside:{"table-data":{pattern:RegExp(r),inside:t.languages.markdown},punctuation:/\|/}},"table-line":{pattern:RegExp("^("+n+")"+o+"$"),lookbehind:!0,inside:{punctuation:/\||:?-{3,}:?/}},"table-header-row":{pattern:RegExp("^"+n+"$"),inside:{"table-header":{pattern:RegExp(r),alias:"important",inside:t.languages.markdown},punctuation:/\|/}}}},code:[{pattern:/((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,lookbehind:!0,alias:"keyword"},{pattern:/^```[\s\S]*?^```$/m,greedy:!0,inside:{"code-block":{pattern:/^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,lookbehind:!0},"code-language":{pattern:/^(```).+/,lookbehind:!0},punctuation:/```/}}],title:[{pattern:/\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,alias:"important",inside:{punctuation:/==+$|--+$/}},{pattern:/(^\s*)#.+/m,lookbehind:!0,alias:"important",inside:{punctuation:/^#+|#+$/}}],hr:{pattern:/(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,lookbehind:!0,alias:"punctuation"},list:{pattern:/(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,lookbehind:!0,alias:"punctuation"},"url-reference":{pattern:/!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,inside:{variable:{pattern:/^(!?\[)[^\]]+/,lookbehind:!0},string:/(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,punctuation:/^[\[\]!:]|[<>]/},alias:"url"},bold:{pattern:i(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^..)[\s\S]+(?=..$)/,lookbehind:!0,inside:{}},punctuation:/\*\*|__/}},italic:{pattern:i(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^.)[\s\S]+(?=.$)/,lookbehind:!0,inside:{}},punctuation:/[*_]/}},strike:{pattern:i(/(~~?)(?:(?!~)<inner>)+\2/.source),lookbehind:!0,greedy:!0,inside:{content:{pattern:/(^~~?)[\s\S]+(?=\1$)/,lookbehind:!0,inside:{}},punctuation:/~~?/}},"code-snippet":{pattern:/(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,lookbehind:!0,greedy:!0,alias:["code","keyword"]},url:{pattern:i(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),lookbehind:!0,greedy:!0,inside:{operator:/^!/,content:{pattern:/(^\[)[^\]]+(?=\])/,lookbehind:!0,inside:{}},variable:{pattern:/(^\][ \t]?\[)[^\]]+(?=\]$)/,lookbehind:!0},url:{pattern:/(^\]\()[^\s)]+/,lookbehind:!0},string:{pattern:/(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,lookbehind:!0}}}}),["url","bold","italic","strike"].forEach((function(e){["url","bold","italic","strike","code-snippet"].forEach((function(i){e!==i&&(t.languages.markdown[e].inside.content.inside[i]=t.languages.markdown[i])}))})),t.hooks.add("after-tokenize",(function(t){"markdown"!==t.language&&"md"!==t.language||function t(e){if(e&&"string"!=typeof e)for(var i=0,r=e.length;i<r;i++){var n=e[i];if("code"===n.type){var o=n.content[1],a=n.content[3];if(o&&a&&"code-language"===o.type&&"code-block"===a.type&&"string"==typeof o.content){var s=o.content.replace(/\b#/g,"sharp").replace(/\b\+\+/g,"pp"),l="language-"+(s=(/[a-z][\w-]*/i.exec(s)||[""])[0].toLowerCase());a.alias?"string"==typeof a.alias?a.alias=[a.alias,l]:a.alias.push(l):a.alias=[l]}}else t(n.content)}}(t.tokens)})),t.hooks.add("wrap",(function(e){if("code-block"===e.type){for(var i="",r=0,n=e.classes.length;r<n;r++){var o=e.classes[r],d=/language-(.+)/.exec(o);if(d){i=d[1];break}}var c,h,p=t.languages[i];if(p)e.content=t.highlight((c=e.content,h=(h=c.replace(a,"")).replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi,(function(t,e){var i;if("#"===(e=e.toLowerCase())[0])return i="x"===e[1]?parseInt(e.slice(2),16):Number(e.slice(1)),l(i);var r=s[e];return r||t})),h),p,i);else if(i&&"none"!==i&&t.plugins.autoloader){var u="md-"+(new Date).valueOf()+"-"+Math.floor(1e16*Math.random());e.attributes.id=u,t.plugins.autoloader.loadLanguages(i,(function(){var e=document.getElementById(u);e&&(e.innerHTML=t.highlight(e.textContent,t.languages[i],i))}))}}}));var a=RegExp(t.languages.markup.tag.pattern.source,"gi"),s={amp:"&",lt:"<",gt:">",quot:'"'},l=String.fromCodePoint||String.fromCharCode;t.languages.md=t.languages.markdown}(ve),function(t){var e=t.util.clone(t.languages.javascript),i=/(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source,r=/(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source,n=/(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;function o(t,e){return t=t.replace(/<S>/g,(function(){return i})).replace(/<BRACES>/g,(function(){return r})).replace(/<SPREAD>/g,(function(){return n})),RegExp(t,e)}n=o(n).source,t.languages.jsx=t.languages.extend("markup",e),t.languages.jsx.tag.pattern=o(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source),t.languages.jsx.tag.inside.tag.pattern=/^<\/?[^\s>\/]*/i,t.languages.jsx.tag.inside["attr-value"].pattern=/=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/i,t.languages.jsx.tag.inside.tag.inside["class-name"]=/^[A-Z]\w*(?:\.[A-Z]\w*)*$/,t.languages.jsx.tag.inside.comment=e.comment,t.languages.insertBefore("inside","attr-name",{spread:{pattern:o(/<SPREAD>/.source),inside:t.languages.jsx}},t.languages.jsx.tag),t.languages.insertBefore("inside","special-attr",{script:{pattern:o(/=<BRACES>/.source),inside:{"script-punctuation":{pattern:/^=(?=\{)/,alias:"punctuation"},rest:t.languages.jsx},alias:"language-javascript"}},t.languages.jsx.tag);var a=function(t){return t?"string"==typeof t?t:"string"==typeof t.content?t.content:t.content.map(a).join(""):""},s=function(e){for(var i=[],r=0;r<e.length;r++){var n=e[r],o=!1;if("string"!=typeof n&&("tag"===n.type&&n.content[0]&&"tag"===n.content[0].type?"</"===n.content[0].content[0].content?i.length>0&&i[i.length-1].tagName===a(n.content[0].content[1])&&i.pop():"/>"===n.content[n.content.length-1].content||i.push({tagName:a(n.content[0].content[1]),openedBraces:0}):i.length>0&&"punctuation"===n.type&&"{"===n.content?i[i.length-1].openedBraces++:i.length>0&&i[i.length-1].openedBraces>0&&"punctuation"===n.type&&"}"===n.content?i[i.length-1].openedBraces--:o=!0),(o||"string"==typeof n)&&i.length>0&&0===i[i.length-1].openedBraces){var l=a(n);r<e.length-1&&("string"==typeof e[r+1]||"plain-text"===e[r+1].type)&&(l+=a(e[r+1]),e.splice(r+1,1)),r>0&&("string"==typeof e[r-1]||"plain-text"===e[r-1].type)&&(l=a(e[r-1])+l,e.splice(r-1,1),r--),e[r]=new t.Token("plain-text",l,null,l)}n.content&&"string"!=typeof n.content&&s(n.content)}};t.hooks.add("after-tokenize",(function(t){"jsx"!==t.language&&"tsx"!==t.language||s(t.tokens)}))}(ve),function(t){t.languages.typescript=t.languages.extend("javascript",{"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,lookbehind:!0,greedy:!0,inside:null},builtin:/\b(?:string|Function|any|number|boolean|Array|symbol|console|Promise|unknown|never)\b/}),t.languages.typescript.keyword.push(/\b(?:abstract|as|declare|implements|is|keyof|readonly|require)\b/,/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,/\btype\b(?=\s*(?:[\{*]|$))/),delete t.languages.typescript.parameter;var e=t.languages.extend("typescript",{});delete e["class-name"],t.languages.typescript["class-name"].inside=e,t.languages.insertBefore("typescript","function",{decorator:{pattern:/@[$\w\xA0-\uFFFF]+/,inside:{at:{pattern:/^@/,alias:"operator"},function:/^[\s\S]+/}},"generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,greedy:!0,inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,generic:{pattern:/<[\s\S]+/,alias:"class-name",inside:e}}}}),t.languages.ts=t.languages.typescript}(ve),function(t){var e=t.util.clone(t.languages.typescript);t.languages.tsx=t.languages.extend("jsx",e);var i=t.languages.tsx.tag;i.pattern=RegExp(/(^|[^\w$]|(?=<\/))/.source+"(?:"+i.pattern.source+")",i.pattern.flags),i.lookbehind=!0}(ve),function(t){function e(e,i){t.languages[e]&&t.languages.insertBefore(e,"comment",{"doc-comment":i})}var i=t.languages.markup.tag,r={pattern:/\/\/\/.*/,greedy:!0,alias:"comment",inside:{tag:i}},n={pattern:/'''.*/,greedy:!0,alias:"comment",inside:{tag:i}};e("csharp",r),e("fsharp",r),e("vbnet",n)}(ve),function(){if(void 0!==ve&&"undefined"!=typeof document&&document.querySelector){var t,e="line-numbers",i="linkable-line-numbers",r=function(){if(void 0===t){var e=document.createElement("div");e.style.fontSize="13px",e.style.lineHeight="1.5",e.style.padding="0",e.style.border="0",e.innerHTML="&nbsp;<br />&nbsp;",document.body.appendChild(e),t=38===e.offsetHeight,document.body.removeChild(e)}return t},n=!0,o=0;ve.hooks.add("before-sanity-check",(function(t){var e=t.element.parentElement;if(d(e)){var i=0;a(".line-highlight",e).forEach((function(t){i+=t.textContent.length,t.parentNode.removeChild(t)})),i&&/^(?: \n)+$/.test(t.code.slice(-i))&&(t.code=t.code.slice(0,-i))}})),ve.hooks.add("complete",(function t(i){var r=i.element.parentElement;if(d(r)){clearTimeout(o);var n=ve.plugins.lineNumbers,a=i.plugins&&i.plugins.lineNumbers;if(s(r,e)&&n&&!a)ve.hooks.add("line-numbers",t);else c(r)(),o=setTimeout(h,1)}})),window.addEventListener("hashchange",h),window.addEventListener("resize",(function(){a("pre").filter(d).map((function(t){return c(t)})).forEach(l)}))}function a(t,e){return Array.prototype.slice.call((e||document).querySelectorAll(t))}function s(t,e){return t.classList.contains(e)}function l(t){t()}function d(t){return!(!t||!/pre/i.test(t.nodeName))&&(!!t.hasAttribute("data-line")||!(!t.id||!ve.util.isActive(t,i)))}function c(t,o,d){var c=(o="string"==typeof o?o:t.getAttribute("data-line")||"").replace(/\s+/g,"").split(",").filter(Boolean),h=+t.getAttribute("data-line-offset")||0,p=(r()?parseInt:parseFloat)(getComputedStyle(t).lineHeight),u=ve.util.isActive(t,e),g=t.querySelector("code"),f=u?t:g||t,m=[],b=g&&f!=g?function(t,e){var i=getComputedStyle(t),r=getComputedStyle(e);function n(t){return+t.substr(0,t.length-2)}return e.offsetTop+n(r.borderTopWidth)+n(r.paddingTop)-n(i.paddingTop)}(t,g):0;c.forEach((function(e){var i=e.split("-"),r=+i[0],n=+i[1]||r,o=t.querySelector('.line-highlight[data-range="'+e+'"]')||document.createElement("div");if(m.push((function(){o.setAttribute("aria-hidden","true"),o.setAttribute("data-range",e),o.className=(d||"")+" line-highlight"})),u&&ve.plugins.lineNumbers){var a=ve.plugins.lineNumbers.getLine(t,r),s=ve.plugins.lineNumbers.getLine(t,n);if(a){var l=a.offsetTop+b+"px";m.push((function(){o.style.top=l}))}if(s){var c=s.offsetTop-a.offsetTop+s.offsetHeight+"px";m.push((function(){o.style.height=c}))}}else m.push((function(){o.setAttribute("data-start",String(r)),n>r&&o.setAttribute("data-end",String(n)),o.style.top=(r-h-1)*p+b+"px",o.textContent=new Array(n-r+2).join(" \n")}));m.push((function(){f.appendChild(o)}))}));var v=t.id;if(u&&ve.util.isActive(t,i)&&v){s(t,i)||m.push((function(){t.classList.add(i)}));var w=parseInt(t.getAttribute("data-start")||"1");a(".line-numbers-rows > span",t).forEach((function(t,e){var i=e+w;t.onclick=function(){var t=v+"."+i;n=!1,location.hash=t,setTimeout((function(){n=!0}),1)}}))}return function(){m.forEach(l)}}function h(){var t=location.hash.slice(1);a(".temporary.line-highlight").forEach((function(t){t.parentNode.removeChild(t)}));var e=(t.match(/\.([\d,-]+)$/)||[,""])[1];if(e&&!document.getElementById(t)){var i=t.slice(0,t.lastIndexOf(".")),r=document.getElementById(i);if(r)r.hasAttribute("data-line")||r.setAttribute("data-line",""),c(r,e,"temporary ")(),n&&document.querySelector(".temporary.line-highlight").scrollIntoView()}}}();var we=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
  border-radius:0.25rem;
}

code[class*='language-'],
pre[class*='language-']{
  color:#ccc;
  background:none;
  font-family:Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size:1em;
  text-align:left;
  white-space:pre;
  word-spacing:normal;
  word-break:normal;
  word-wrap:normal;
  line-height:1.5;

  -moz-tab-size:4;
  tab-size:4;

  -webkit-hyphens:none;
  hyphens:none;
}

pre[class*='language-']{
  padding:0 1rem;
  margin:0 0;
  overflow:auto;
}

:not(pre) > code[class*='language-'],
pre[class*='language-']{
  background:#2d2d2d;
  border-radius:5px;
}

:not(pre) > code[class*='language-']{
  padding:0.1em;
  border-radius:0.3em;
  white-space:normal;
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata{
  color:#999;
}

.token.punctuation{
  color:#ccc;
}

.token.tag,
.token.attr-name,
.token.namespace,
.token.deleted{
  color:#e2777a;
}

.token.function-name{
  color:#6196cc;
}

.token.boolean,
.token.number,
.token.function{
  color:#f08d49;
}

.token.property,
.token.class-name,
.token.constant,
.token.symbol{
  color:#f8c555;
}

.token.selector,
.token.important,
.token.atrule,
.token.keyword,
.token.builtin{
  color:#cc99cd;
}

.token.string,
.token.char,
.token.attr-value,
.token.regex,
.token.variable{
  color:#7ec699;
}

.token.operator,
.token.entity,
.token.url{
  color:#67cdcc;
}

.token.important,
.token.bold{
  font-weight:bold;
}

.token.italic{
  font-style:italic;
}

.token.entity{
  cursor:help;
}

.token.inserted{
  color:green;
}

pre[data-line]{
  position:relative;
  padding:1em 0 1em 3em;
}

.line-highlight{
  position:absolute;
  left:0;
  right:0;
  padding:inherit 0;
  margin-top:1em;

  background:hsla(24, 20%, 50%, 0.08);
  background:linear-gradient(
    to right,
    hsla(24, 20%, 50%, 0.1) 70%,
    hsla(24, 20%, 50%, 0)
  );

  pointer-events:none;

  line-height:inherit;
  white-space:pre;
}

@media print{
  .line-highlight{
    -webkit-print-color-adjust:exact;
    color-adjust:exact;
  }
}

.line-highlight:before,
.line-highlight[data-end]:after{
  content:attr(data-start);
  position:absolute;
  top:0.4em;
  left:0.6em;
  min-width:1em;
  padding:0 0.5em;
  background-color:hsla(24, 20%, 50%, 0.4);
  color:hsl(24, 20%, 95%);
  font:bold 65%/1.5 sans-serif;
  text-align:center;
  vertical-align:0.3em;
  border-radius:999px;
  text-shadow:none;
  box-shadow:0 1px white;
}

.line-highlight[data-end]:after{
  content:attr(data-end);
  top:auto;
  bottom:0.4em;
}

.line-numbers .line-highlight:before,
.line-numbers .line-highlight:after{
  content:none;
}

pre[id].linkable-line-numbers span.line-numbers-rows{
  pointer-events:all;
}

pre[id].linkable-line-numbers span.line-numbers-rows > span:before{
  cursor:pointer;
}

pre[id].linkable-line-numbers span.line-numbers-rows > span:hover:before{
  background-color:rgba(128, 128, 128, 0.2);
}

pre[class*='language-'].line-numbers{
  position:relative;
  padding-left:3.8em;
  counter-reset:linenumber;
}

pre[class*='language-'].line-numbers > code{
  position:relative;
  white-space:inherit;
}

.line-numbers .line-numbers-rows{
  position:absolute;
  pointer-events:none;
  top:-0.13em;
  left:-3.8em;
  width:3em;
  border-right:1px solid #999;

  -webkit-user-select:none;
  -moz-user-select:none;
  user-select:none;
}

.line-numbers-rows > span{
  pointer-events:none;
  display:block;
  counter-increment:linenumber;
}

.line-numbers-rows > span::before{
  content:counter(linenumber);
  color:#999;
  display:block;
  padding-right:0.8em;
  text-align:right;
}

#copy-button{
  padding:4px;
  position:absolute;
  top:5px;
  right:5px;
}

.wrapper{
  display:flex;
  flex-direction:column;
}
`;let xe=class extends $t{constructor(){super(...arguments),this.code="<p>Hello World</p>",this.language="typescript",this.formatCode=()=>"jsx"===this.language.toLowerCase()||"html"===this.language.toLowerCase()?this.innerHTML:this.textContent,this.prismCodeLookup=()=>{let t="";switch(this.language){case"css":t=ve.highlight(this.code,ve.languages.css,"css");break;case"graphql":t=ve.highlight(this.code,ve.languages.graphql,"graphql");break;case"html":t=ve.highlight(this.code,ve.languages.html,"html");break;case"javascript":t=ve.highlight(this.code,ve.languages.javascript,"javascript");break;case"json":t=ve.highlight(this.code,ve.languages.json,"json");break;case"markdown":t=ve.highlight(this.code,ve.languages.markdown,"markdown");break;case"jsx":t=ve.highlight(this.code,ve.languages.jsx,"jsx");break;case"tsx":t=ve.highlight(this.code,ve.languages.tsx,"tsx");break;case"svg":t=ve.highlight(this.code,ve.languages.svg,"svg");break;case"typescript":t=ve.highlight(this.code,ve.languages.typescript,"typescript");break;case"xml":t=ve.highlight(this.code,ve.languages.xml,"xml")}return t}}connectedCallback(){super.connectedCallback()}render(){const t=this.lineNumbers?"line-numbers":"",e=`language-${this.language.toLowerCase()}`;return this.code=this.formatCode(),Y`
      <pre class="${t} ${e}" id="pre">
        <code id="code" class="${e}">
          ${Ot(this.prismCodeLookup())}
        </code>
      </pre>
    `}};xe.styles=[we],p([mt("slot")],xe.prototype,"codeSlot",void 0),p([mt("#code-block-template")],xe.prototype,"template",void 0),p([ut({})],xe.prototype,"code",void 0),p([ut({type:Boolean,attribute:"line-numbers"})],xe.prototype,"lineNumbers",void 0),p([ut()],xe.prototype,"language",void 0),xe=p([ht("outline-code-block")],xe);var ye=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
}

outline-container{
  display:grid;
  height:100%;
  grid-template-columns:repeat(12, minmax(0, 1fr));
}

:host([gap-size='large']) outline-container, :host([gap-size-sm='large']) outline-container, :host([gap-size-md='large']) outline-container, :host([gap-size-lg='large']) outline-container, :host([gap-size-xl='large']) outline-container, :host([gap-size-xxl='large']) outline-container, :host([gap-size-xxxl='large']) outline-container{
  row-gap:4rem;
  -moz-column-gap:0px;
       column-gap:0px;
}

:host([gap-size='medium']) outline-container, :host([gap-size-sm='medium']) outline-container, :host([gap-size-md='medium']) outline-container, :host([gap-size-lg='medium']) outline-container, :host([gap-size-xl='medium']) outline-container, :host([gap-size-xxl='medium']) outline-container, :host([gap-size-xxxl='medium']) outline-container{
  row-gap:2.5rem;
  -moz-column-gap:0px;
       column-gap:0px;
}

:host([gap-size='small']) outline-container, :host([gap-size-sm='small']) outline-container, :host([gap-size-md='small']) outline-container, :host([gap-size-lg='small']) outline-container, :host([gap-size-xl='small']) outline-container, :host([gap-size-xxl='small']) outline-container, :host([gap-size-xxxl='small']) outline-container{
  row-gap:1rem;
  -moz-column-gap:0px;
       column-gap:0px;
}

:host([gap-size='none']) outline-container{
  gap:0px;
}

@media (min-width: 640px){
  :host([gap-size='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }

  :host([gap-size='medium']) outline-container{
    row-gap:2.5rem;
  }

  :host([gap-size='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }

  :host([gap-size='small']) outline-container{
    row-gap:1rem;
  }

  :host([gap-size='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([is-auto-fitted='true']) outline-container{
    grid-template-columns:repeat(auto-fit, minmax(0, 1fr));
  }
  :host([gap-size-sm='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-sm='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-sm='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-sm='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-sm='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-sm='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-sm='none']) outline-container{
    gap:0px;
  }
}

@media (min-width: 768px){
  :host([gap-size-md='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-md='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-md='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-md='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-md='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-md='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-md='none']) outline-container{
    gap:0px;
  }
}

@media (min-width: 1024px){
  :host([gap-size-lg='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-lg='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-lg='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-lg='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-lg='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-lg='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-lg='none']) outline-container{
    gap:0px;
  }
}

@media (min-width: 1280px){
  :host([gap-size-xl='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-xl='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-xl='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-xl='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-xl='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-xl='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-xl='none']) outline-container{
    gap:0px;
  }
}

@media (min-width: 1440px){
  :host([gap-size-xxl='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-xxl='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-xxl='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-xxl='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-xxl='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-xxl='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-xxl='none']) outline-container{
    gap:0px;
  }
}

@media (min-width: 2180px){
  :host([gap-size-xxl='large']) outline-container{
    row-gap:4rem;
  }
  :host([gap-size-xxl='large']) outline-container{
    -moz-column-gap:4rem;
         column-gap:4rem;
  }
  :host([gap-size-xxl='medium']) outline-container{
    row-gap:2.5rem;
  }
  :host([gap-size-xxl='medium']) outline-container{
    -moz-column-gap:2.5rem;
         column-gap:2.5rem;
  }
  :host([gap-size-xxl='small']) outline-container{
    row-gap:1rem;
  }
  :host([gap-size-xxl='small']) outline-container{
    -moz-column-gap:1rem;
         column-gap:1rem;
  }
  :host([gap-size-xxl='none']) outline-container{
    gap:0px;
  }
}
`;let Ce=class extends $t{constructor(){super(...arguments),this.xPadding=!1,this.yPadding=!1,this.fullBleed=!1,this.containerAlign="center",this.gapSize="small"}render(){return Y`
      <outline-container
        ?x-padding="${this.xPadding}"
        ?y-padding="${this.yPadding}"
        ?full-bleed="${this.fullBleed}"
        container-align="${At(this.containerAlign)}"
      >
        <slot></slot>
      </outline-container>
    `}};Ce.styles=[ye],p([ut({type:Boolean,reflect:!0,attribute:"x-padding"})],Ce.prototype,"xPadding",void 0),p([ut({type:Boolean,reflect:!0,attribute:"y-padding"})],Ce.prototype,"yPadding",void 0),p([ut({type:Boolean,reflect:!0,attribute:"full-bleed"})],Ce.prototype,"fullBleed",void 0),p([ut({type:String,reflect:!0,attribute:"container-align"})],Ce.prototype,"containerAlign",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size"})],Ce.prototype,"gapSize",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-sm"})],Ce.prototype,"gapSizeSm",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-md"})],Ce.prototype,"gapSizeMd",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-lg"})],Ce.prototype,"gapSizeLg",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-xl"})],Ce.prototype,"gapSizeXl",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-xxl"})],Ce.prototype,"gapSizeXxl",void 0),p([ut({type:String,reflect:!0,attribute:"gap-size-xxxl"})],Ce.prototype,"gapSizeXxxl",void 0),Ce=p([ht("outline-grid")],Ce);const ke=["xs","sm","base","lg","xl","2xl","3xl","4xl","5xl","6xl","7xl","8xl","9xl"],Ae=Object.keys(i);var ze=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

    display: block
}

h1, h2, h3, h4, h5, h6 {

    margin: 0px;

    margin-bottom: 1rem
}

h1 {

    font-size: var(--fs-h1-small);

    line-height: var(--lh-h1-small)
}

@media (min-width: 768px) {

    h1 {

        font-size: var(--fs-h1-medium);

        line-height: var(--lh-h1-medium)
    }
}

@media (min-width: 1024px) {

    h1 {

        font-size: var(--fs-h1);

        line-height: var(--lh-h1)
    }
}

h2 {

    font-size: var(--fs-h2-small);

    line-height: var(--lh-h2-small)
}

@media (min-width: 768px) {

    h2 {

        font-size: var(--fs-h2-medium);

        line-height: var(--lh-h2-medium)
    }
}

@media (min-width: 1024px) {

    h2 {

        font-size: var(--fs-h2);

        line-height: var(--lh-h2)
    }
}

h3 {

    font-size: var(--fs-h3-small);

    line-height: var(--lh-h3-small)
}

@media (min-width: 768px) {

    h3 {

        font-size: var(--fs-h3-medium);

        line-height: var(--lh-h3-medium)
    }
}

@media (min-width: 1024px) {

    h3 {

        font-size: var(--fs-h3);

        line-height: var(--lh-h3)
    }
}

h4 {

    font-size: var(--fs-h4-small);

    line-height: var(--lh-h4-small)
}

@media (min-width: 768px) {

    h4 {

        font-size: var(--fs-h4-medium);

        line-height: var(--lh-h4-medium)
    }
}

@media (min-width: 1024px) {

    h4 {

        font-size: var(--fs-h4);

        line-height: var(--lh-h4)
    }
}

h5 {

    font-size: var(--fs-h5-small);

    line-height: var(--lh-h5-small)
}

@media (min-width: 768px) {

    h5 {

        font-size: var(--fs-h5-medium);

        line-height: var(--lh-h5-medium)
    }
}

@media (min-width: 1024px) {

    h5 {

        font-size: var(--fs-h5);

        line-height: var(--lh-h5)
    }
}

h6 {

    font-size: var(--fs-h6-small);

    line-height: var(--lh-h6-small)
}

@media (min-width: 768px) {

    h6 {

        font-size: var(--fs-h6-medium);

        line-height: var(--lh-h6-medium)
    }
}

@media (min-width: 1024px) {

    h6 {

        font-size: var(--fs-h6);

        line-height: var(--lh-h6)
    }
}

.outline-text--base {

    font-size: var(--fs-base) !important;

    line-height: var(--lh-base) !important
}

.outline-text--xs {

    font-size: var(--fs-xs) !important;

    line-height: var(--lh-xs) !important
}

.outline-text--sm {

    font-size: var(--fs-sm) !important;

    line-height: var(--lh-sm) !important
}

.outline-text--lg {

    font-size: var(--fs-lg) !important;

    line-height: var(--lh-lg) !important
}

.outline-text--lg.mobile {

    font-size: var(--fs-base) !important;

    line-height: var(--lh-base) !important
}

.outline-text--xl {

    font-size: var(--fs-xl) !important;

    line-height: var(--lh-xl) !important
}

.outline-text--xl.mobile {

    font-size: var(--fs-base) !important;

    line-height: var(--lh-base) !important
}

.outline-text--2xl {

    font-size: var(--fs-2xl) !important;

    line-height: var(--lh-2xl) !important
}

.outline-text--2xl.mobile {

    font-size: var(--fs-lg) !important;

    line-height: var(--lh-lg) !important
}

.outline-text--3xl {

    font-size: var(--fs-3xl) !important;

    line-height: var(--lh-3xl) !important
}

.outline-text--3xl.mobile {

    font-size: var(--fs-lg) !important;

    line-height: var(--lh-lg) !important
}

.outline-text--4xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-4xl) !important
}

.outline-text--4xl.mobile {

    font-size: var(--fs-xl) !important;

    line-height: var(--lh-xl) !important
}

.outline-text--5xl {

    font-size: var(--fs-5xl) !important;

    line-height: var(--lh-5xl) !important
}

.outline-text--5xl.mobile {

    font-size: var(--fs-2xl) !important;

    line-height: var(--lh-2xl) !important
}

.outline-text--6xl {

    font-size: var(--fs-6xl) !important;

    line-height: var(--lh-6xl) !important
}

.outline-text--6xl.mobile {

    font-size: var(--fs-3xl) !important;

    line-height: var(--lh-3xl) !important
}

.outline-text--7xl {

    font-size: var(--fs-7xl) !important;

    line-height: var(--lh-7xl) !important
}

.outline-text--7xl.mobile {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-4xl) !important
}

.outline-text--8xl {

    font-size: var(--fs-8xl) !important;

    line-height: var(--lh-8xl) !important
}

.outline-text--8xl.mobile {

    font-size: var(--fs-5xl) !important;

    line-height: var(--lh-5xl) !important
}

.outline-text--9xl {

    font-size: var(--fs-9xl) !important;

    line-height: var(--lh-9lx) !important
}

.outline-text--9xl.mobile {

    font-size: var(--fs-6xl) !important;

    line-height: var(--lh-6xl) !important
}

.outline-font--thin {

    font-weight: var(--fw-extralight)
}

.outline-font--extralight {

    font-weight: var(--fw-thin)
}

.outline-font--light {

    font-family: Futura Std Light, Helvetica, Arial, sans-serif;

    font-weight: var(--fw-light)
}

.outline-font--normal {

    font-weight: var(--fw-normal)
}

.outline-font--semibold {

    font-weight: var(--fw-semibold)
}

.outline-font--bold {

    font-weight: var(--fw-bold)
}

.outline-font--extrabold {

    font-weight: var(--fw-extrabold)
}

.outline-font--black {

    font-weight: var(--fw-black)
}
`;let $e=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.level="h2",this.levelStyle="bold"}render(){const t={"outline-text":!0,[`outline-text--${this.levelSize}`]:!!this.levelSize||"",[`outline-font--${this.levelStyle}`]:!0,mobile:this.mobileController.isMobile};return kt`
      <${yt(this.level)} class=${Dt(t)}>
        <slot></slot>
      </${yt(this.level)}>`}};var Me,Se,Le,He,Be,_e;$e.styles=[ze],p([ut({type:String,reflect:!0,attribute:"level"})],$e.prototype,"level",void 0),p([ut({type:String,reflect:!0,attribute:"level-size"})],$e.prototype,"levelSize",void 0),p([ut({type:String,reflect:!0,attribute:"level-style"})],$e.prototype,"levelStyle",void 0),$e=p([ht("outline-heading")],$e),function(t){t.ADJUSTMENTS="adjustments",t.ANNOTATION="annotation"}(Me||(Me={})),function(t){t.CODE_BRACKET="codeBrackets",t.COLORS="colors",t.COMMENTS="comments",t.DIRECTION="direction",t.FLOW="flow",t.PLUGIN="plugin",t.REPO="repo",t.STACK="stack"}(Se||(Se={})),function(t){t.ADJUSTMENTS_OUTLINE="adjustmentsOutline",t.ANNOTATION_OUTLINE="annotationOutline",t.ARROW_CIRCLE_DOWN_OUTLINE="arrowCircleDownOutline",t.ARROW_CIRCLE_LEFT_OUTLINE="arrowCircleLeftOutline",t.ARROW_CIRCLE_RIGHT_OUTLINE="arrowCircleRightOutline",t.ARROW_CIRCLE_UP_OUTLINE="arrowCircleUpOutline",t.ARROW_DOWN_OUTLINE="arrowDownOutline",t.ARROW_LEFT_OUTLINE="arrowLeftOutline",t.ARROW_RIGHT_OUTLINE="arrowRightOutline",t.ARROW_UP_OUTLINE="arrowUpOutline",t.ARROW_NARROW_DOWN_OUTLINE="arrowNarrowDownOutline",t.ARROW_NARROW_LEFT_OUTLINE="arrowNarrowLeftOutline",t.ARROW_NARROW_RIGHT_OUTLINE="arrowNarrowRightOutline",t.ARROW_NARROW_UP_OUTLINE="arrowNarrowUpOutline",t.ARROW_EXPAND_OUTLINE="arrowExpandOutline",t.USER_OUTLINE="userOutline",t.SEARCH_OUTLINE="searchOutline"}(Le||(Le={})),function(t){t.ADJUSTMENTS_SOLID="adjustmentsSolid",t.ANNOTATION_SOLID="annotationSolid",t.ARROW_CIRCLE_DOWN_SOLID="arrowCircleDownSolid",t.ARROW_CIRCLE_LEFT_SOLID="arrowCircleLeftSolid",t.ARROW_CIRCLE_RIGHT_SOLID="arrowCircleRightSolid",t.ARROW_CIRCLE_UP_SOLID="arrowCircleUpSolid",t.ARROW_DOWN_SOLID="arrowDownSolid",t.ARROW_LEFT_SOLID="arrowLeftSolid",t.ARROW_RIGHT_SOLID="arrowRightSolid",t.ARROW_UP_SOLID="arrowUpSolid",t.ARROW_NARROW_DOWN_SOLID="arrowNarrowDownSolid",t.ARROW_NARROW_LEFT_SOLID="arrowNarrowLeftSolid",t.ARROW_NARROW_RIGHT_SOLID="arrowNarrowRightSolid",t.ARROW_NARROW_UP_SOLID="arrowNarrowUpSolid",t.ARROW_EXPAND_SOLID="arrowExpandSolid",t.USER_SOLID="userSolid",t.SEARCH_SOLID="searchSolid"}(He||(He={})),function(t){t.OUTLINE="Outline",t.SOLID="Solid"}(Be||(Be={})),function(t){t[t.BACKGROUND=100]="BACKGROUND",t[t.HEADING=700]="HEADING",t[t.TEXT=600]="TEXT"}(_e||(_e={}));const Fe=Object.assign(Object.assign(Object.assign({},Se),Le),He);var De=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

  :host([parallax]) figure {
  height: 50vh;
}

  :host([parallax]) figure{
    -webkit-clip-path:inset(0 0 0 0);
            clip-path:inset(0 0 0 0);
  }

  :host([parallax='false']) figure {
  height: auto;
}

  :host([parallax='false']) figure{
    -webkit-clip-path:inset(0 0 0 0);
            clip-path:inset(0 0 0 0);
  }

@media (min-width: 1024px){
    :host([parallax='false']) figure {
    height: auto;
  }
}

figure {
  margin: 0px;
  display: block;
}

::slotted([slot='caption']) {
  margin-top: 0.5rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

::slotted(img) {
  width: 100%;
}
`;let Ee=class extends $t{firstUpdated(){this.hasCaptionSlot=null!==this.querySelector('[slot="caption"]')}captionSlotTemplate(){return this.hasCaptionSlot?Y`<figcaption><slot name="caption"></slot></figcaption>`:null}render(){return Y`
      <figure><slot></slot></figure>
      ${this.captionSlotTemplate()}
    `}};Ee.styles=[De],p([gt()],Ee.prototype,"hasCaptionSlot",void 0),Ee=p([ht("outline-image")],Ee);var Ve=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
  box-sizing:border-box;
}

:host *,
:host *::before,
:host *::after{
  box-sizing:inherit;
}

[hidden]{
  display:none !important;
}
`;let Oe=class extends $t{constructor(){super(...arguments),this.mode="cors",this.allowScripts=!1}executeScript(t){const e=document.createElement("script");[...t.attributes].forEach((t=>e.setAttribute(t.name,t.value))),e.textContent=t.textContent,t.parentNode.replaceChild(e,t)}async handleSrcChange(){try{const t=this.src,e=await Xt(t,this.mode);if(t!==this.src)return;if(!e.ok)return void Rt(this,"outline-error",{detail:{status:e.status}});this.innerHTML=e.html,this.allowScripts&&[...this.querySelectorAll("script")].forEach((t=>this.executeScript(t))),Rt(this,"outline-load")}catch(t){Rt(this,"outline-error",{detail:{status:-1}})}}render(){return Y`<slot></slot>`}};Oe.styles=[Ve],p([ut()],Oe.prototype,"src",void 0),p([ut()],Oe.prototype,"mode",void 0),p([ut({attribute:"allow-scripts",type:Boolean})],Oe.prototype,"allowScripts",void 0),p([Tt("src")],Oe.prototype,"handleSrcChange",null),Oe=p([ht("outline-include")],Oe);const je={name:"Link Destination",description:"https://www.w3schools.com/tags/att_a_href.asp",control:{type:"text"},table:{defaultValue:{summary:"false"}}},Ze={name:"Link Relationship",description:"https://www.w3schools.com/tags/att_a_rel.asp",options:["alternate","author","bookmark","external","help","license","next","nofollow","noopener","noreferrer","prev","search","tag"],control:{type:"select"},table:{defaultValue:{summary:"null"}}};var Re=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host, a, ::slotted(a) {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  color:var(--outline-link-color-default)
}

:host(:hover), a:hover, ::slotted(a:hover) {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
  color:var(--outline-link-color-hover) !important
}

:host(:focus), a:focus, ::slotted(a:focus) {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
  outline: 2px solid transparent;
  outline-offset: 2px;
  color:var(--outline-link-color-focus) !important
}
`;let Te=class extends $t{constructor(){super(...arguments),this.linkHref=!1,this.linkText=!1}render(){return Y`${this.linkHref?Y` <a
          href=${this.linkHref}
          rel="${At(this.linkRel)}"
          target="${At(this.linkTarget)}"
        >
          ${this.linkText?Y`${this.linkText}`:Y`<slot></slot>`}
        </a>`:Y`<slot></slot>`}`}};Te.styles=[Re],p([ut({type:String,attribute:"link-href"})],Te.prototype,"linkHref",void 0),p([ut({type:String,attribute:"link-text"})],Te.prototype,"linkText",void 0),p([ut({type:String,attribute:"link-target"})],Te.prototype,"linkTarget",void 0),p([ut({type:String,attribute:"link-rel"})],Te.prototype,"linkRel",void 0),Te=p([ht("outline-link")],Te);var Ne=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.list{
  border:unset;
  margin:0px;
  display:flex;
  flex-wrap:wrap;
  padding:0px;
}

ul.list, ul.grid{
  list-style-type:none;
}

ul.list > ::slotted(li), ol.list > ::slotted(li), ul.grid > ::slotted(li), ol.grid > ::slotted(li){
  display:flex;
  align-items:center;
  white-space:nowrap;
  padding:0.5rem;
}

.columns--2,
.columns--3,
.columns--4{
  display:flex;
  flex-direction:column;
}

.row{
  display:flex;
  flex-direction:row;
}

.column{
  display:flex;
  flex-direction:column;
}

.col-center{
  display:flex;
  flex-direction:column;
  align-items:center;
}

.mobile-col-center{
  display:flex;
  flex-direction:column;
  align-items:center;
}

.mobile-row{
  display:flex;
  flex-direction:row;
}

.mobile-col{
  display:flex;
  flex-direction:column;
}

ul.list.divided* > ::slotted(li:not(:last-of-type)){
  border-bottom:0 !important;
}

@media (min-width: 640px){
  .mobile-col-center{
    display:flex;
    flex-direction:row;
  }

  .mobile-col{
    display:flex;
    flex-direction:row;
  }

  .mobile-row{
    display:flex;
    flex-direction:column;
  }

  .columns--2{
    display:grid;
  }

  .columns--2{
    grid-template-columns:repeat(2, minmax(0, 1fr));
  }

ul.columns--2{
    list-style-type:none;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    display:flex;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    align-items:center;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    padding:0.5rem;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    display:flex;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    align-items:center;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--2 > ::slotted(li), ol.columns--2 > ::slotted(li){
    padding:0.5rem;
  }

  .columns--3{
    display:grid;
  }

  .columns--3{
    grid-template-columns:repeat(3, minmax(0, 1fr));
  }

  .columns--3{
    gap:0.25rem;
  }

ul.columns--3{
    list-style-type:none;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    display:flex;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    align-items:center;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    padding:0.5rem;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    display:flex;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    align-items:center;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--3 > ::slotted(li), ol.columns--3 > ::slotted(li){
    padding:0.5rem;
  }

  .columns--4{
    display:grid;
  }

  .columns--4{
    grid-template-columns:repeat(4, minmax(0, 1fr));
  }

ul.columns--4{
    list-style-type:none;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    display:flex;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    align-items:center;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    padding:0.5rem;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    display:flex;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    align-items:center;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    white-space:nowrap;
  }

ul.columns--4 > ::slotted(li), ol.columns--4 > ::slotted(li){
    padding:0.5rem;
  }

  :is(ul, ol, div).list.divided > ::slotted(li:not(:last-of-type))::after{
    content:'|';
    margin-left:1rem;
  }

  :is(ul, ol, div).list.divided > ::slotted(li:not(:last-of-type))::after{
    color:white;
  }

  :is(ul, ol, div).list.divided.blue > ::slotted(li:not(:last-of-type))::after{
    color:#0080fe;
  }

  :is(ul, ol, div).list.divided.teal > ::slotted(li:not(:last-of-type))::after{
    color:#72f1e4;
  }

  :is(ul, ol, div).list.divided.red > ::slotted(li:not(:last-of-type))::after{
    color:#fa5c5c;
  }

  :is(ul, ol, div).list.divided.black
    > ::slotted(li:not(:last-of-type))::after{
    color:black;
  }
}
`;const Pe=["ol","ul","div"],Ye=["column","row","mobile-row","mobile-col","col-center","mobile-col-center"],Ie=["blue","teal","red","white","black"],Ue=["2","3","4"];let We=class extends $t{constructor(){super(...arguments),this.orientation="column"}render(){const t={list:!this.columns,grid:this.columns,[`${this.orientation}`]:this.orientation&&!this.columns,divided:this.divider,[`${this.divider}`]:this.divider,[`columns--${this.columns}`]:this.columns};return this.navLabel?Y`
          <slot name="heading"></slot>
          <nav role="navigation" aria-label="${this.navLabel}">
            ${this.listCase(t)}
          </nav>
          <slot name="footer"></slot>
        `:Y`<slot name="heading"></slot>
          ${this.listCase(t)}
          <slot name="footer"></slot>`}listCase(t){switch(this.listType){case"ol":return Y`
          <ol class=${Dt(t)}>
            <slot></slot>
          </ol>
        `;case"ul":return Y`
          <ul class=${Dt(t)}>
            <slot></slot>
          </ul>
        `;default:return Y`
          <div class=${Dt(t)}>
            <slot></slot>
          </div>
        `}}};We.styles=[Ne],p([ut({type:String,attribute:"list-type"})],We.prototype,"listType",void 0),p([ut({type:String})],We.prototype,"orientation",void 0),p([ut({type:String,attribute:"nav-label"})],We.prototype,"navLabel",void 0),p([ut({type:String})],We.prototype,"divider",void 0),p([ut({type:String})],We.prototype,"columns",void 0),We=p([ht("outline-list")],We);var qe=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--neutral-black);
  --tw-bg-opacity: 0.6;
  background-color:rgb(0, 0, 0, var(--tw-bg-opacity));
}

#container {
  height: 100vh;
  max-width: 100%;
  overflow-y: auto;
  border-radius: 0.125rem;
  background-color: var(--neutral-white);
}

@media (min-width: 768px) {

  #container {
    height: auto;
  }

  #container {
    max-width: 25vw;
  }
}

#container{
  min-width:320px;
}

@media (min-width: 768px) {

  #overlay.medium #container {
    max-width: 50vw;
  }
}

#overlay.full-screen #container {
  height: 100vh;
}

#overlay.full-screen #container {
  width: 100vw;
}

#overlay.full-screen #container {
  max-width: 100vw;
}

@media (min-width: 768px) {

  #overlay.full-screen #container {
    width: 100vw;
  }
}

@media (min-width: 768px) {

  #overlay.full-screen #container {
    max-width: 100vw;
  }
}

#header {
  position: relative;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
}

#close {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  border-width: 0px;
  background-color: var(--neutral-transparent);
}

#close:before{
  content:'\\2715';
}

#main {
  padding: 1.5rem;
}

#accessibility-description {
  display: none;
}
`;const Ge=["small","medium","full-screen"],Qe='\n  a[href]:not([tabindex="-1"]),\n  area[href]:not([tabindex="-1"]),\n  input:not([disabled]):not([tabindex="-1"]),\n  select:not([disabled]):not([tabindex="-1"]),\n  textarea:not([disabled]):not([tabindex="-1"]),\n  button:not([disabled]):not([tabindex="-1"]),\n  iframe:not([tabindex="-1"]),\n  [tabindex]:not([tabindex="-1"]),\n  [contentEditable=true]:not([tabindex="-1"])\n';let Xe=class extends $t{constructor(){super(...arguments),this.isOpen=!1,this.shouldForceAction=!1,this.size="medium"}render(){return Y`
      <div
        id="trigger"
        tabindex="0"
        @click="${this.open}"
        @keydown="${this._handleTriggerKeydown}"
      >
        <slot name="outline-modal--trigger"></slot>
      </div>
      ${this._overlayTemplate()}
    `}connectedCallback(){super.connectedCallback(),this._handleSlotChange()}_handleSlotChange(){this._hasHeaderSlot=null!==this.querySelector('[slot="outline-modal--header"]'),this._hasAccessibilityDescriptionSlot=null!==this.querySelector('[slot="outline-modal--accessibility-description"]')}_overlayTemplate(){let t=Y``;return this.isOpen&&(t=Y`
        <div
          id="overlay"
          tabindex="-1"
          class="${this.size}"
          @click="${this._handleOverlayClick}"
          @keydown="${this._handleOverlayKeydown}"
        >
          <div
            id="container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="${At(this._hasHeaderSlot?"header":void 0)}"
            aria-describedby="${At(this._hasAccessibilityDescriptionSlot?"accessibility-description":void 0)}"
          >
            <div id="header">
              <slot
                id="title"
                name="outline-modal--header"
                @slotchange="${this._handleSlotChange}"
              ></slot>
              ${this.shouldForceAction?null:Y`
                    <button
                      id="close"
                      aria-label="Close modal"
                      @click="${this.close}"
                      @keydown="${this._handleCloseKeydown}"
                    ></button>
                  `}
            </div>
            <div id="main">
              <slot></slot>
            </div>
          </div>
        </div>
        <slot
          id="accessibility-description"
          name="outline-modal--accessibility-description"
          @slotchange="${this._handleSlotChange}"
        ></slot>
      `),t}async open(){this.isOpen||(this.isOpen=!0,await this.updateComplete,this._focusOnElement(),this._trapFocus(),this.dispatchEvent(new CustomEvent("opened")))}async close(){this.isOpen&&(this.isOpen=!1,await this.updateComplete,this.dispatchEvent(new CustomEvent("closed")),this.triggerElement.focus())}_handleTriggerKeydown(t){"Enter"===t.key&&(t.preventDefault(),this.open())}_handleOverlayClick(t){t.target===t.currentTarget&&!1===this.shouldForceAction&&this.close()}_handleOverlayKeydown(t){"Escape"===t.key&&!1===this.shouldForceAction&&this.close()}_handleCloseKeydown(t){"Enter"===t.key&&this.close()}_focusOnElement(){var t;const e=this.shouldForceAction?null:this.closeElement,i=void 0!==this.elementToFocusSelector?this.querySelector(this.elementToFocusSelector):null,r=this.querySelector(Qe),n=null!==(t=null!=i?i:r)&&void 0!==t?t:e;null!==n&&n.focus()}_trapFocus(){var t;const e=this.shouldForceAction?this.firstFocusableSlottedElement:this.closeElement;if(null!==e){const i=null!==(t=this.lastFocusableSlottedElement)&&void 0!==t?t:e;i.addEventListener("keydown",(t=>{"Tab"===t.key&&!1===t.shiftKey&&(t.preventDefault(),e.focus())})),e.addEventListener("keydown",(t=>{"Tab"===t.key&&t.shiftKey&&(t.preventDefault(),i.focus())}))}}get firstFocusableSlottedElement(){var t;const e=this.querySelectorAll(Qe);return null!==(t=Array.from(e).slice(0)[0])&&void 0!==t?t:null}get lastFocusableSlottedElement(){var t;const e=this.querySelectorAll(Qe);return null!==(t=Array.from(e).slice(-1)[0])&&void 0!==t?t:null}};Xe.styles=[qe],p([ut({attribute:!1})],Xe.prototype,"isOpen",void 0),p([ut({type:Boolean})],Xe.prototype,"shouldForceAction",void 0),p([ut({type:String})],Xe.prototype,"size",void 0),p([gt()],Xe.prototype,"_hasHeaderSlot",void 0),p([gt()],Xe.prototype,"_hasAccessibilityDescriptionSlot",void 0),p([mt("#trigger")],Xe.prototype,"triggerElement",void 0),p([mt("#close")],Xe.prototype,"closeElement",void 0),p([ut({type:String})],Xe.prototype,"elementToFocusSelector",void 0),Xe=p([ht("outline-modal")],Xe);var Ke=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
}

p {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  margin-bottom:1em;
}

ul{
  list-style-type:disc;
  list-style-position:inside;
}

ol{
  list-style-type:decimal;
  list-style-position:inside;
}

li{
  padding-left:1em;
  margin-top:0.5em;
  margin-bottom:0.5em;
}

hr{
  border-color:var(--brand-primary);
  margin-top:2em;
  margin-bottom:2em;
}

blockquote{
  margin-top:1em;
  margin-bottom:1em;
  font-size:var(--fs-lg);
  font-weight:bold;
}

a {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  color:var(--outline-link-color-default);
}

a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
  color:var(--outline-link-color-hover) !important;
}

a:focus {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
  outline: 2px solid transparent;
  outline-offset: 2px;
  color:var(--outline-link-color-focus) !important;
}
`;let Je=class extends $t{constructor(){super(...arguments),this.slots=new h(this,!0)}render(){return Y`<slot></slot>`}};Je.styles=[$t.styles,Ke],Je=p([ht("outline-styled-text")],Je);var ti=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position:relative;
  display:block;
  height:0px;
  padding-bottom:calc(9 / 16 * 100%)
}

iframe {
  position:absolute;
  top:0px;
  bottom:0px;
  left:0px;
  right:0px;
  display:block;
  height:100%;
  width:100%
}
`;let ei=class extends $t{render(){return Y`
      <iframe
        src="https://player.vimeo.com/video/${this.videoID}"
        title="Vimeo video ${this.videoID}"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe>
      <script src="https://player.vimeo.com/api/player.js"></script>
    `}};ei.styles=[ti],p([ut({type:String,attribute:"video-id",reflect:!0})],ei.prototype,"videoID",void 0),ei=p([ht("outline-video-vimeo")],ei);var ii=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position:relative;
  display:block;
  height:0px;
  padding-bottom:calc(9 / 16 * 100%)
}

iframe {
  position:absolute;
  top:0px;
  bottom:0px;
  left:0px;
  right:0px;
  display:block;
  height:100%;
  width:100%
}
`;let ri=class extends $t{render(){return Y`
      <iframe
        src="https://www.youtube.com/embed/${this.videoID}"
        title="YouTube video ${this.videoID}"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    `}};ri.styles=[ii],p([ut({type:String,attribute:"video-id",reflect:!0})],ri.prototype,"videoID",void 0),ri=p([ht("outline-video-youtube")],ri);var ni=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.accordion {
  margin: auto;
  max-width:1135px
}

.accordion-title {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  color: var(--demo-darkBlue)
}

.accordion-title.mobile {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--demo-darkBlue)
}

.accordion-title:after {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  width: 2rem;
  border-width: 1px;
  border-style: solid;
  border-color: var(--demo-darkBlue);
  content:''
}

.accordion-title.mobile:after {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  width: 1rem;
  border-width: 1px
}
`;let oi=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.clean=!1,this.singlePanel=!1,this.allOpen=!1,this.active=[],this.isMobile=()=>this.mobileController.isMobile?"mobile":null}render(){return Y`
      ${this.label?Y`<h4 class="accordion-title ${this.isMobile()}">
            ${this.label}
          </h4>`:null}
      <div
        class="accordion"
        @click=${this.setActive}
        @keydown=${this.handleKeyboardNav}
      >
        <slot name="panels"></slot>
      </div>
    `}setActive(t){const e=(null==t?void 0:t.target).id;return this.singlePanel?this.active.includes(e)?this.active=[]:this.active=[e]:this.active.includes(e)?this.active=this.active.filter((t=>t!==e)):this.active=[e,...this.active]}handleKeyboardNav(t){var e,i;let r=0;const n=this.panels,o=Array.prototype.indexOf.call(n,t.target);if("ArrowDown"!==t.key&&"ArrowUp"!==t.key)return;"ArrowDown"===t.key&&(r=(null==n?void 0:n.length)&&o+1>(null==n?void 0:n.length)-1?0:o+1),"ArrowUp"===t.key&&(r=(null==n?void 0:n.length)&&o-1<0?(null==n?void 0:n.length)-1:o-1);null===(i=null===(e=(null==n?void 0:n[r]).shadowRoot)||void 0===e?void 0:e.querySelector("button"))||void 0===i||i.focus()}firstUpdated(){this.allOpen&&this.panels.map((t=>{this.active.push(t.id),t.setAttribute("active","active")}))}updated(){this.clean?this.panels.map((t=>t.setAttribute("clean","clean"))):this.panels.map((t=>t.removeAttribute("clean"))),this.allOpen?this.panels.map((t=>{this.active.push(t.id),t.setAttribute("active","active")})):this.panels.map((t=>this.active.includes(t.id)?t.setAttribute("active","active"):t.removeAttribute("active")))}};oi.styles=[ni],p([ut({type:String})],oi.prototype,"label",void 0),p([ut({type:Boolean})],oi.prototype,"clean",void 0),p([ut({type:Boolean,attribute:"single-panel"})],oi.prototype,"singlePanel",void 0),p([ut({type:Boolean})],oi.prototype,"allOpen",void 0),p([gt()],oi.prototype,"active",void 0),p([function(t,e,i){let r,n=t;return"object"==typeof t?(n=t.slot,r=t):r={flatten:e},i?xt({slot:n,flatten:e,selector:i}):ft({descriptor:t=>({get(){var t,e;const i="slot"+(n?`[name=${n}]`:":not([name])"),o=null===(t=this.renderRoot)||void 0===t?void 0:t.querySelector(i);return null!==(e=null==o?void 0:o.assignedNodes(r))&&void 0!==e?e:[]},enumerable:!0,configurable:!0})})}("panels",!0)],oi.prototype,"panels",void 0),oi=p([ht("atmos-accordion")],oi);var ai=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.accordion-button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-width: 0px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
  background:transparent;
  cursor:pointer;
}

.accordion-button.mobile {
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
  line-height: 1.25rem !important;
}

.accordion-button.clean {
  border-bottom-width: 1px;
  border-style: solid;
  border-color: var(--demo-lightGray);
}

.accordion-button.gradient {
  color: var(--neutral-white);
}

.accordion-button.gradient ::slotted([slot='heading']) {
  color: var(--neutral-white);
}

.accordion-button.clean.active {
  color: var(--demo-darkBlue) !important;
  background-color:transparent;
  border-bottom:0;
}

.accordion-button.gradient.active{
  background-color:transparent !important;
}

.accordion-button.gradient.inactive{
  background-color:transparent;
}

.accordion-button.gradient.inactive ::slotted([slot='heading']) {
  color: var(--neutral-grayDark);
}

.accordion-button.clean.inactive {
  color: var(--demo-darkBlue);
}

.accordion-label{
  max-width:75%;
}

.accordion-label.mobile {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

::slotted([slot='heading']) {
  color: var(--neutral-grayDark);
}

.accordion-heading {
  margin: 0px;
  display: flex;
  min-height:4rem;
}

.accordion-icon {
  display: flex;
  height: 100%;
  width: 5rem;
  align-items: center;
  justify-content: center;
  color: var(--brand-primary);
  border-radius:50%;
  border:solid var(--neutral-grayMedium) 1px;
  height:77px;
  width:77px;
}

.accordion-icon.gradient{
  border-color:var(--neutral-grayMedium);
}

.accordion-icon.gradient.active{
  border-color:var(--brand-secondary);
}

.accordion-icon.mobile{
  height:40px;
  width:40px;
}

.accordion-icon.active atmos-icon{
  transform:rotate(180deg);
}

.accordion-icon.gradient.active atmos-icon{
  color:var(--brand-secondary);
}

.accordion-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-bottom:solid var(--neutral-grayMedium) 1px;
}

.accordion-panel.clean {
  border-width: 0px;
}

.accordion-panel.gradient{
  background-color:transparent;
}

.accordion-panel.gradient.active{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.accordion-content {
  padding-left: 1rem;
  padding-right: 3.5rem;
  padding-bottom: 1rem;
}

.accordion-content.person{
  padding-left:18%;
}

.accordion-content.gradient {
  color: var(--neutral-white);
}

@media only screen and (min-width: 768px){
  .accordion-content {
    padding-left: 2.5rem;
  }

  .accordion-button.gradient:hover{
    background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  }

  .accordion-button.gradient.active:hover{
    background:transparent;
  }
    .accordion-button.gradient.inactive:hover ::slotted([slot='heading']) {
    color: var(--neutral-white);
  }
    .accordion-button.gradient.inactive:hover atmos-icon{
      color:var(--brand-secondary);
    }

  .accordion-icon.gradient.inactive:hover{
    border-color:var(--brand-secondary);
  }

  .accordion-button {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .accordion-content {
    padding-right: 7rem;
  }

  .accordion-content {
    padding-bottom: 2.5rem;
  }

  .accordion-content.gradient {
    padding-bottom: 6rem;
  }

  .accordion-content.person{
    padding-left:200px;
  }
}
`;let si=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.clean=!1,this.active=!1,this.gradient=!1,this.personAccordion=!1,this.id=Math.floor(1e4*Math.random()).toString()}render(){const t=this.mobileController.isMobile?"mobile":null,e=this.clean?"clean":null,i=this.active?"active":"inactive",r=this.gradient?"gradient":null,n=this.personAccordion?"person":"null";return Y` <div
      class="accordion-panel ${e} ${r} ${i}"
    >
      <div class="accordion-heading">
        <button
          class="accordion-button
        ${t}
        ${i}
        ${e}
        ${r}
        "
          id="${this.id}-button"
          aria-expanded=${this.active}
          aria-controls="${this.id}-info"
        >
          <span class="accordion-label ${t}">
            <slot name="heading"> </slot>
          </span>
          <span
            class="accordion-icon
          ${t}
          ${i}
          ${e}
          ${r}
          "
          >
            <atmos-icon icon="chevronDown" svg="true"></atmos-icon>
          </span>
        </button>
      </div>
      <div
        class="accordion-content ${t} ${r} ${n}"
        role="region"
        aria-labelledby="${this.id}-button"
        id="${this.id}-info"
        .hidden=${!this.active}
        aria-hidden="${!this.active}"
      >
        <slot></slot>
      </div>
    </div>`}};si.styles=[ai],p([ut({type:Boolean})],si.prototype,"clean",void 0),p([ut({type:Boolean})],si.prototype,"active",void 0),p([ut({reflect:!0,attribute:"gradient",type:Boolean})],si.prototype,"gradient",void 0),p([ut({reflect:!0,attribute:"person-accordion",type:Boolean})],si.prototype,"personAccordion",void 0),p([ut({type:String,reflect:!0})],si.prototype,"id",void 0),si=p([ht("atmos-accordion-panel")],si);var li=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.btn {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--brand-primary);
  display: inline-block;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  background:none;
  border-style:solid;
  border-width:2px;
  border-color:transparent;
  cursor:pointer;
  padding:2px 11px;
  position:relative;
  transition:color 0.5s, border-color 0.5s;
}

.btn.reverse {
  color: var(--brand-secondary);
}

.btn.thin.reverse {
  color: var(--neutral-white);
}

.btn.large {
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
}

:host(.hover) .btn,
.btn:hover{
  background-color:var(--brand-primary-hover);
}

:host(.hover) .btn.reverse, .btn.reverse:hover {
  color: var(--neutral-white);
}

.btn.thin.reverse:hover {
  color: var(--brand-secondary);
}

.btn:active .btn-active-bar{
  background-color:var(--neutral-grayDark);
  position:absolute;
  bottom:0;
  height:2px;
  left:11px;
  width:calc(100% - 22px);
}

.btn:active {
  color: var(--neutral-grayDark);
  border-color:transparent !important;
}

.btn:after{
  content:'';
  background:var(--neutral-gray-dark);
  height:2px;
  width:calc(100% -22px);
}

.btn:focus{
  outline:none;
  border-radius:9px;
  border-color:var(--brand-primary);
}

.btn.reverse:active {
  color: var(--neutral-white);
}

.btn.thin.reverse:active {
  color: var(--brand-secondary);
}

.btn.reverse:focus{
  border-color:var(--brand-secondary);
}

.btn.thin.reverse:focus{
  border-color:var(--neutral-white);
}

.btn.reverse:active .btn-active-bar{
  background-color:var(--neutral-white);
}

.btn.thin.reverse:active .btn-active-bar{
  background-color:var(--brand-secondary);
}

.btn-arrow {
  display: inline-block;
  border-bottom:solid 4.5px transparent;
  border-top:solid 4.5px transparent;
  border-left:solid 6px var(--brand-primary);
  transform:translate(4px, 0);
  transition:border-color 0.5s, transform 0.5s;
}

.large .btn-arrow{
  border-bottom:solid 6px transparent;
  border-top:solid 6px transparent;
  border-left:solid 10px var(--brand-primary);
}

.btn-arrow-animated{
  transform:translate(-7px, 0);
}

.large .btn-arrow-animated{
  transform:translate(-13px, 0);
}

.btn:active .btn-arrow-animated,
:host(.hover) .btn .btn-arrow-animated,
.btn:hover .btn-arrow-animated{
  transform:translate(2px, 0);
}

:host(.hover) .btn .btn-arrow,
.btn:hover .btn-arrow{
  border-left-color:var(--brand-primary-hover);
}

.btn.reverse .btn-arrow{
  border-left-color:var(--brand-secondary);
}

.btn.thin.reverse .btn-arrow{
  border-left-color:var(--neutral-white);
}

:host(.hover) .btn.reverse .btn-arrow,
.btn.reverse:hover .btn-arrow{
  border-left-color:var(--neutral-white);
}

:host(.hover) .btn.thin.reverse .btn-arrow,
.btn.thin.reverse:hover .btn-arrow{
  border-left-color:var(--brand-secondary);
}

:host(.hover) .btn.reverse .btn-arrow,
.btn.reverse:hover .btn-arrow{
  border-left-color:var(--neutral-white);
}

:host(.hover) .btn.thin.reverse .btn-arrow,
.btn.thin.reverse:hover .btn-arrow{
  border-left-color:var(--brand-secondary);
}

.btn:active .btn-arrow{
  border-left-color:var(--neutral-gray-dark);
}

.btn.reverse:active .btn-arrow{
  border-left-color:var(--neutral-white);
}

.btn.thin.reverse:active .btn-arrow{
  border-left-color:var(--brand-secondary);
}

@media only screen and (min-width: 640px){
  .btn.responsive {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
  }

  .responsive .btn-arrow{
    border-bottom:solid 6px transparent;
    border-top:solid 6px transparent;
    border-left:solid 10px var(--brand-primary);
  }

  .responsive .btn-arrow-animated{
    transform:translate(-13px, 0);
  }
}

.btn-button{
  background-color:var(--brand-primary-hover);
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  border:none;
  cursor:pointer;
  line-height:27px;
  padding:11px 24px;
}

.btn-button:hover{
  background-color:var(--brand-primary-hover);
}

.btn-button:active {
  background-color: var(--neutral-grayDark);
}

.btn-button:focus{
  outline-style:solid;
  outline-width:2px;
  outline-offset:2px;
  outline-color:var(--brand-primary);
}

.btn.thin {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

@media only screen and (min-width: 1280px){
  .btn.thin {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
}
`;let di=class extends $t{constructor(){super(...arguments),this.target="_self",this.rel="",this.title="",this.variant="none",this.size="small",this.type="link"}renderLinkButton(){const t=this.url.startsWith("/document")?"_blank":this.target;return void 0!==this.url?Y` <a
          class="btn ${this.variant} ${this.size}"
          href=${this.url}
          target=${t}
          rel=${this.rel}
          title=${this.title}
        >
          <slot></slot>
          <span class="btn-arrow"></span>
          <span class="btn-arrow btn-arrow-animated"></span>
          <span class="btn-active-bar"></span>
        </a>`:Y` <button
          class="btn ${this.variant} ${this.size}"
          .disabled=${this.disabled}
        >
          <slot></slot>
          <span class="btn-arrow"></span>
          <span class="btn-arrow btn-arrow-animated"></span>
          <span class="btn-active-bar"></span>
        </button>`}renderButton(){return Y` <button class="btn-button" .disabled=${this.disabled}>
      <slot></slot>
    </button>`}render(){return"link"==this.type?this.renderLinkButton():this.renderButton()}};di.styles=[li],p([ut({type:String})],di.prototype,"url",void 0),p([ut({type:String})],di.prototype,"target",void 0),p([ut({type:String})],di.prototype,"rel",void 0),p([ut({type:String,attribute:"link-title"})],di.prototype,"title",void 0),p([ut({reflect:!0,attribute:"variant"})],di.prototype,"variant",void 0),p([ut({reflect:!0,attribute:"size"})],di.prototype,"size",void 0),p([ut({attribute:"type"})],di.prototype,"type",void 0),p([ut({type:Boolean})],di.prototype,"disabled",void 0),di=p([ht("atmos-button")],di);var ci=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outter-wrapper{
  overflow:hidden;
}

.wrapper {
  background-color: var(--neutral-grayLight);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 3rem;
  align-items:center;
  display:flex;
  flex-direction:column;
  margin-top:164px;
}

.image {
  border-radius: 9999px;
  height:327px;
  margin-bottom:-164px;
  overflow:hidden;
  transform:translate(0, -50%);
  width:327px;
}

.image ::slotted(img){
  width:100%;
  height:100%;
  object-fit:cover;
}

.title {
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
  margin-bottom: 1rem;
  letter-spacing:-0.02em;
  line-height:116%;
  margin-top:29px;
  margin-bottom:17px;
}

.title span {
  color: var(--brand-primary);
}

.text {
  margin-bottom: 1rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
}

@media only screen and (min-width: 640px){
  .wrapper{
    padding-bottom:70px;
    padding-left:80px;
    padding-right:80px;
  }

  .title {
    font-size: var(--fs-6xl);
    line-height: var(--lh-6xl);
  }

  .title{
    margin-top:33px;
  }

  .text {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
  }
}

@media only screen and (min-width: 1024px){
  .wrapper{
    align-items:center;
    flex-direction:row-reverse;
    justify-content:center;
    padding-bottom:50px;
  }

  .wrapper.left{
    flex-direction:row;
  }

  .image{
    flex-shrink:0;
    height:443px;
    margin-bottom:calc(443px * -0.15);
    margin-left:62px;
    transform:translate(0, -15%);
    width:443px;
  }

  .wrapper.left .image{
    margin-left:0;
    margin-right:62px;
  }

  .info{
    padding-top:50px;
  }

  .title {
    margin-top: 0px;
  }
}
`;let hi=class extends $t{getTitle(){return this.title?Y`<h3 class="title">
        ${this.title}${this.titleAccent&&Y`<span>${this.titleAccent}</span>`}
      </h3>`:""}getText(){return this.text?Y`<p class="text">
        ${this.text?Ot(this.text):""}
      </p>`:""}render(){return Y``}};p([ut({type:String,attribute:"title"})],hi.prototype,"title",void 0),p([ut({type:String,attribute:"title-accent"})],hi.prototype,"titleAccent",void 0),p([ut({type:String,attribute:"text"})],hi.prototype,"text",void 0),hi=p([ht("atmos-promo-base")],hi);let pi=class extends hi{constructor(){super(...arguments),this.position="right"}getImage(){return Y`<div class="image"><slot name="image"></slot></div>`}render(){return Y` <div class="outter-wrapper">
      <div class="wrapper ${this.position}">
        ${this.getImage()}
        <div class="info">
          ${this.getTitle()} ${this.getText()}
          <slot name="button"></slot>
        </div>
      </div>
    </div>`}};pi.styles=[ci],p([ut({attribute:"position"})],pi.prototype,"position",void 0),pi=p([ht("atmos-circle-promo")],pi);var ui=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  padding: 1rem;
  position: relative;
  margin: auto;
  max-width: 1136px;
}

.inner{
  border:2px solid var(--brand-secondary);
  border-radius:19px;
  padding:56px 16px 40px;
}

.text {
  margin: 0px;
}

.heading {
  margin-top: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  background-color: var(--neutral-white);
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  margin-bottom: 2.5rem;
}

.active-title {
  color: var(--brand-primary);
}

.content {
  display: flex;
  flex-direction: column;
  position: relative;
  width:100%;
}

.textpanel{
  width:100%;
}

.tabs {
  display: none;
}

.options {
  display: none;
  flex-direction: column;
}

.options.open {
  display: flex;
  z-index: 10;
  position: relative;
  padding:30px 0;
  row-gap:6px;
}

.option-container {
  background-color: var(--neutral-white);
  display: flex;
  flex-direction: column;
  position: relative;
  position: absolute;
  width:calc(100% - 4px);
  top:-80px;
  border:2px solid var(--brand-secondary);
  border-radius:19px;
}

button {
  color: var(--neutral-grayDark);
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  border-width: 0px;
  cursor: pointer;
  font-size:17px;
  background:transparent;
}

button.selection {
  display: flex;
  align-items: center;
  padding:7px 10px 9px;
  border-radius:19px;
}

button.selection.open {
  display: none;
}

button.option {
  display: flex;
  text-align: left;
  align-items: center;
  width: auto;
  padding-left:30px;
}

button.option.active:before {
  position: absolute;
  background:transparent;
  content:'';
  width:2px;
  height:48px;
  left:-2px;
}

button.option.homeowners.active:before{
  background:var(--icon-homeowners);
}

button.option.plumbersContractors.active:before{
  background:var(--icon-plumbersContractors);
}

button.option.commercialManagers.active:before{
  background:var(--icon-commercialManagers);
}

button.option.buildersDevelopers.active:before{
  background:var(--icon-buildersDevelopers);
}

button.option.firstResponders.active:before{
  background:var(--icon-firstResponders);
}

.text {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  letter-spacing: 0;
  letter-spacing:-0.005em;
}

.title {
  margin-bottom: 1rem;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
}

button.selection .icon-container {
  color: var(--neutral-white);
  border-radius: 9999px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  min-height:44px;
  min-width:44px;
}

button.option .icon-container {
  color: var(--neutral-white);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  overflow: visible;
  min-height:44px;
  min-width:44px;
  margin:2px 14px 2px 2px;
  border:2px solid white;
  box-shadow:0 0 0 2pt transparent;
}

.icon-container atmos-icon{
  min-width:24px;
  min-height:22px;
}

.icon-container.homeowners{
  background:var(--icon-homeowners);
}

.icon-container.commercialManagers{
  background:var(--icon-commercialManagers);
}

.icon-container.buildersDevelopers{
  background:var(--icon-buildersDevelopers);
}

.icon-container.firstResponders{
  background:var(--icon-firstResponders);
}

.icon-container.plumbersContractors{
  background:var(--icon-plumbersContractors);
}

button.option.active .icon-container.homeowners{
  box-shadow:0 0 0 2pt var(--icon-homeowners);
}

button.option.active .icon-container.commercialManagers{
  box-shadow:0 0 0 2pt var(--icon-commercialManagers);
}

button.option.active .icon-container.buildersDevelopers{
  box-shadow:0 0 0 2pt var(--icon-buildersDevelopers);
}

button.option.active .icon-container.firstResponders{
  box-shadow:0 0 0 2pt var(--icon-firstResponders);
}

button.option.active .icon-container.plumbersContractors{
  box-shadow:0 0 0 2pt var(--icon-plumbersContractors);
}

button.option.active:after {
  position: absolute;
  width: 0px;
  height: 0px;
  content:'';
  border-top:5px solid transparent;
  border-bottom:5px solid transparent;
  left:12px;
}

button.option.homeowners.active:after{
  border-left:7px solid var(--icon-homeowners);
}

button.option.commercialManagers.active:after{
  border-left:7px solid var(--icon-commercialManagers);
}

button.option.buildersDevelopers.active:after{
  border-left:7px solid var(--icon-buildersDevelopers);
}

button.option.firstResponders.active:after{
  border-left:7px solid var(--icon-firstResponders);
}

button.option.plumbersContractors.active:after{
  border-left:7px solid var(--icon-plumbersContractors);
}

atmos-icon {
  display: flex;
}

.dropdown-container {
  margin-left: auto;
}

@media only screen and (max-width: 380px){
  button.selection .icon-container,
  button.option .icon-container{
    display:none;
  }
}

@media only screen and (min-width: 640px){
  .dropdown-container{
    margin-right:46px;
  }
}

@media only screen and (min-width: 1280px){
  .wrapper {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .wrapper {
    padding-top: 0px;
  }
  .wrapper {
    padding-bottom: 4rem;
  }

  .inner {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .inner {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .inner {
    margin: auto;
  }

  .heading {
    left: 0px;
  }

  .heading {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }

  .heading {
    text-align: center;
  }

  .heading {
    margin: auto;
  }

  .heading {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .heading {
    padding-top: 0.75rem;
  }

  .heading {
    padding-bottom: 2rem;
  }

  .heading{
    background:transparent;
  }

  .tabs {
    display: block;
  }

  .tablist {
    display: flex;
  }

  .tablist {
    align-items: flex-start;
  }

  .tablist {
    justify-content: center;
  }

  .tablist {
    padding: 0px;
  }

  .tablist {
    position: relative;
  }

  .tablist{
    height:84px;
  }

  .text {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .text {
    margin-left: auto;
    margin-right: auto;
  }

  .content {
    flex-direction: row;
  }

  .content {
    justify-content: center;
  }

  .content {
    margin-top: 0px;
  }

  .option-container {
    display: none;
  }

  button.option {
    padding-left: 0px;
  }

  button.option {
    position: relative;
  }

  button.option {
    height: 100%;
  }

  button.option {
    align-items: baseline;
  }

  button.option{
    margin-right:50px;
  }

  button.option:last-of-type{
    margin-right:0;
  }

  button.option.homeowners.active::before,
  button.option.plumbersContractors.active::before,
  button.option.commercialManagers.active::before,
  button.option.firstResponders.active::before,
  button.option.builderDevelopers.active::before{
    background:none;
  }

  button.option.active:after, button.option:after {
    opacity: 0;
  }

  button.option.active:after, button.option:after {
    width: 0px;
  }

  button.option.active:after, button.option:after {
    height: 0px;
  }

  button.option.active:after, button.option:after {
    position: absolute;
  }

  button.option.active:after,
  button.option:after{
    content:'';
    border-left:5px solid transparent;
    border-right:5px solid transparent;
    border-bottom:7px solid transparent;
    left:calc(50% - 3.5px);
    bottom:8px;
    transition:bottom 0.25s ease-in, border-bottom 0.25s ease-in,
      opacity 0.25s ease-in;
  }

  button.option.homeowners.active::after,
  button.option.plumbersContractors.active::after,
  button.option.commercialManagers.active::after,
  button.option.buildersDevelopers.active::after,
  button.option.firstResponders.active::after{
    border-left:5px solid transparent;
  }

  button.option:hover:after {
    opacity: 1;
  }

  button.option:hover:after{
    bottom:14px;
  }

  button.option.homeowners:hover:after{
    border-bottom-color:var(--icon-homeowners);
  }

  button.option.commercialManagers:hover:after{
    border-bottom-color:var(--icon-commercialManagers);
  }

  button.option.buildersDevelopers:hover:after{
    border-bottom-color:var(--icon-buildersDevelopers);
  }

  button.option.firstResponders:hover:after{
    border-bottom-color:var(--icon-firstResponders);
  }

  button.option.plumbersContractors:hover:after{
    border-bottom-color:var(--icon-plumbersContractors);
  }

  button.option:before, button.option.active:before {
    width: 100%;
  }

  button.option:before, button.option.active:before {
    position: absolute;
  }

  button.option:before, button.option.active:before {
    left: 0px;
  }

  button.option:before,
  button.option.active:before{
    height:2px;
    content:'';
    bottom:-2px;
    background:transparent;
    transition:background 0.25s ease-in;
  }

  button.option.homeowners:hover::before{
    background:var(--icon-homeowners);
  }

  button.option.commercialManagers:hover::before{
    background:var(--icon-commercialManagers);
  }

  button.option.buildersDevelopers:hover::before{
    background:var(--icon-buildersDevelopers);
  }

  button.option.firstResponders:hover::before{
    background:var(--icon-firstResponders);
  }

  button.option.plumbersContractors:hover::before{
    background:var(--icon-plumbersContractors);
  }

  button.option .icon-container{
    transition:box-shadow 0.15s linear;
  }
}
`,gi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  display: block;
  padding: 3rem;
}

.wrapper.none {
  padding: 0px;
}

.wrapper.blue{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.wrapper.gray{
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
}

.wrapper.white{
  background:none;
}

.wrapper.related {
  background-color: var(--neutral-white);
}

.title {
  margin-bottom: 1.5rem;
  margin-top: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
}

.title.imageCard {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

.wrapper.related .title {
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
}

.text {
  margin-bottom: 1.5rem;
  margin-top: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  letter-spacing: -.005em;
}

.title.reverse, .text.reverse {
  color: var(--neutral-white);
}

.text.reverse a{
  color:var(--brand-secondary);
}

.wrapper.blue .title, .wrapper.gray .title, .wrapper.blue .text, .wrapper.gray .text {
  color: var(--neutral-white);
}

@media only screen and (max-width: 639px){
  .wrapper {
    display: block;
  }
  .wrapper {
    padding: 0.75rem;
  }

  .wrapper.none {
    padding: 0px;
  }

  .title {
    margin-bottom: 1rem;
  }

  .title {
    font-size: var(--fs-3xl);
    line-height: var(--lh-3xl);
  }

  .wrapper.related .title {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl);
  }

  .text {
    margin-bottom: 1rem;
  }

  .text {
    font-family: Futura Std, Helvetica, Arial, sans-serif;
  }

  .text {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }

  .text {
    letter-spacing: 0;
  }
}
`;let fi=class extends $t{constructor(){super(...arguments),this.related="no-related",this.type="none",this.variant="none",this.parent="",this.buttonSize="small",this.isHover=!1}handleHover(){this.isHover=!0}handleOut(){this.isHover=!1}getTitle(){return this.title?Y`<h3 class="title ${this.parent} ${this.variant}">
        ${this.title}
      </h3>`:""}getText(){return this.text?Y`<div class="text ${this.variant}">
        ${Ot(this.text)}
      </div>`:""}getLink(){return this.link&&this.url?Y`<atmos-button
        class="button ${this.isHover&&"hover"}"
        variant="${this.variant}"
        size="${this.buttonSize}"
        url="${this.url}"
        target="${this.target}"
        rel="${this.rel}"
        link-title="${this.linkTitle}"
        >${this.link}</atmos-button
      >`:""}render(){return Y`
      <div
        class="wrapper ${this.link&&"clickable"} ${this.type} ${this.related}"
        @mouseover="${this.handleHover}"
        @mouseleave="${this.handleOut}"
      >
        ${this.getTitle()} ${this.getText()}
        <slot></slot>
        ${this.getLink()}
      </div>
    `}};fi.styles=[gi],p([ut({type:String})],fi.prototype,"url",void 0),p([ut({type:String})],fi.prototype,"link",void 0),p([ut({type:String})],fi.prototype,"target",void 0),p([ut({type:String})],fi.prototype,"rel",void 0),p([ut({type:String})],fi.prototype,"title",void 0),p([ut({type:String,attribute:"link-title"})],fi.prototype,"linkTitle",void 0),p([ut({type:String})],fi.prototype,"text",void 0),p([ut({type:String})],fi.prototype,"related",void 0),p([ut({reflect:!0,attribute:"type"})],fi.prototype,"type",void 0),p([ut({reflect:!0,attribute:"variant"})],fi.prototype,"variant",void 0),p([ut({attribute:"parent"})],fi.prototype,"parent",void 0),p([ut({reflect:!0,attribute:"button-size"})],fi.prototype,"buttonSize",void 0),p([gt()],fi.prototype,"isHover",void 0),fi=p([ht("atmos-feature-content")],fi);let mi=class extends fi{constructor(){super(...arguments),this.camelFormat=t=>{const e=t.replace(/\//g," ").split(" ").map((t=>t.charAt(0).toUpperCase()+t.slice(1))).join("");return e.charAt(0).toLowerCase()+e.slice(1)},this.formatDisplayTitle=t=>t.replace(/\//g," and ")}_handleTab(t){let e;if(t.target!==t.currentTarget){e=t.target.closest("button.option")}else e=t.target;const i=e.innerText,r=[...this.selectors].filter((t=>t.title===i));[...this._tabs].forEach((t=>{t.classList.remove("active"),t.setAttribute("aria-selected","false")})),null==e||e.classList.add("active"),null==e||e.setAttribute("aria-selected","true"),this.activeTitle=r[0].title,this.activeIcon=r[0].icon,this.showOptions=!1}_handleOptions(){this.showOptions?this.showOptions=!1:this.showOptions=!0}_handleKeydown(t){const e=t.target;"Escape"===t.key&&(this.showOptions=!1),"Enter"!==t.key&&" "!==t.key||!0!==this.showOptions||!e.classList.contains("option")||this._handleTab(t)}_hideOptions(t){t.target!==this&&(this.showOptions=!1)}_initContent(){this.activeTitle=this.selectors[0].title,this.activeIcon=this.selectors[0].icon}getTitle(){return this.title?Y`<h3 id="heading" class="heading">
        ${this.title}
        <span class="active-title">
          ${this.formatDisplayTitle(this.activeTitle)}
        </span>
      </h3> `:""}getIcon(t){return Y`<span class="icon-container ${t}">
      <atmos-icon icon="${t}" svg="true"></atmos-icon>
    </span>`}connectedCallback(){super.connectedCallback(),this._initContent(),document.addEventListener("click",this._hideOptions.bind(this))}disconnectedCallback(){document.removeEventListener("click",this._hideOptions),super.disconnectedCallback()}render(){return Y`
      <div class="wrapper">
        ${this.getTitle()}
        <div class="tabs">
          <div class="tablist" role="tablist">
            ${this.selectors.map(((t,e)=>{const{title:i,icon:r}=t;return Y`
                <button
                  @click="${this._handleTab}"
                  id="${r}"
                  class="option ${0===e?"active":""} ${r}"
                  role="tab"
                  aria-controls="textpanel"
                  aria-selected="${0===e?"true":"false"}"
                >
                  ${this.getIcon(r)} ${i}
                </button>
              `}))}
          </div>
        </div>
        <div class="inner">
          <div class="content">
            <div class="option-container">
              <button
                @click="${this._handleOptions}"
                id="selectButton"
                class="selection ${this.showOptions?"open":""}"
                aria-controls="tablist-mobile"
                ?aria-expanded="${this.showOptions}"
              >
                ${this.getIcon(this.activeIcon)} ${this.activeTitle}
                <span class="dropdown-container">
                  <atmos-icon icon="dropdown" svg="true"></atmos-icon>
                </span>
              </button>
              <div
                @keydown="${this._handleKeydown}"
                id="tablist-mobile"
                class="options ${this.showOptions?"open":""}"
                role="tablist"
              >
                ${this.selectors.map(((t,e)=>{const i=this.camelFormat(t.title),{title:r,icon:n}=t;return Y`
                    <button
                      @click="${this._handleTab}"
                      id="${i}"
                      class="option ${0===e?"active":""} ${i}"
                      role="tab"
                      tabindex="${this.showOptions?"0":"-1"}"
                      aria-controls="textpanel"
                      aria-selected="${0===e?"true":"false"}"
                    >
                      ${this.getIcon(n)} ${r}
                    </button>
                  `}))}
              </div>
            </div>
            <div
              id="textpanel"
              class="textpanel"
              role="tabpanel"
              aria-labelledby="heading"
            >
              <slot name="${this.camelFormat(this.activeTitle)}">
              </slot>
            </div>
          </div>
        </div>
      </div>
    `}};mi.styles=[ui],p([ut({type:Array,attribute:"selectors"})],mi.prototype,"selectors",void 0),p([gt()],mi.prototype,"activeTitle",void 0),p([gt()],mi.prototype,"activeIcon",void 0),p([gt()],mi.prototype,"activeOption",void 0),p([gt()],mi.prototype,"showOptions",void 0),p([mt(".options")],mi.prototype,"_options",void 0),p([bt("button.option")],mi.prototype,"_tabs",void 0),mi=p([ht("atmos-content-switcher")],mi);var bi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  border-bottom:solid 1px var(--neutral-grayMedium);
  padding-bottom:48px;
  padding:0 20px;
}

.title {
  margin-top: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
}

.title p{
  padding:0;
  margin:0;
}

.icon {
  margin-right: 0.75rem;
  color: var(--neutral-grayDark);
  display:inline-block;
  width:16px;
  transform:translate(0, 4px);
}

.icon atmos-icon{
  min-width:24px;
  min-height:22px;
}

.documents {
  margin: 0px;
  padding: 0px;
  list-style-type:none;
}

.documents a {
  margin-bottom: 1.5rem;
  display: block;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--brand-primary);
  text-decoration:none;
  height:40px;
}

.documents a:hover{
  background-color:var(--brand-primary-hover);
}

@media only screen and (min-width: 768px){
  .wrapper{
    display:flex;
  }

  .title{
    width:260px;
  }

  .documents{
    padding-left:40px;
  }
}
`;let vi=class extends $t{constructor(){super(...arguments),this.title="",this.documents=[]}render(){return Y`<div class="wrapper">
      <h3 class="title">${this.title?Ot(`${this.title}`):""}</h3>
      <ul class="documents">
        ${this.documents.map((t=>Y`
            <li>
              <a target="_blank" href="${t.url}">
                <span class="icon"
                  ><atmos-icon icon="pdf" svg="true"></atmos-icon
                ></span>
                ${t.name}
              </a>
            </li>
          `))}
      </ul>
    </div>`}};vi.styles=[bi],p([ut({attribute:"title"})],vi.prototype,"title",void 0),p([ut({type:Array,attribute:"documents"})],vi.prototype,"documents",void 0),vi=p([ht("atmos-documents")],vi);var wi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
label {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color:#2c2c2c;
  line-height:150%;
  margin-bottom:4px;
}

sup{
  color:#ff0000;
}

label.disabled{
  color:#a5a5a5;
}

.sr-only {
  position: absolute;
  width:1px;
  height:1px;
  padding: 0px;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.error-container{
  color:#ff0000;
  display: flex;
  font-size:14px;
  line-height:150%;
  margin-top:5px;
}

.dropdown-container{
  color:#2c2c2c;
  display: flex;
  font-size:14px;
  line-height:150%;
  align-items:center;
  margin-right:8px;
}

.dropdown-container.-menu{
  color:#2175d9;
  transform:rotate(180deg);
  margin-right:24px;
}

.error-container atmos-icon{
  margin-right:4px;
  margin-top:2px;
}

.custom-select {
  position: relative;
  border:1px solid #2c2c2c;
}

.custom-select.active{
  border-color:transparent;
}

.custom-select.disabled{
  pointer-events:none;
  border-color:#a5a5a5;
}

.custom-select.active:focus-visible{
  border-color:transparent;
  outline:none;
}

.custom-select select {
  display: none;
}

.select-selected{
  height:100%;
  width:auto;
  background:#ffffff;
  display: flex;
  justify-content:space-between;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-size:18px;
  color:#2c2c2c;
  line-height:38px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left:16px;
  padding-right:16px;
}

.select-selected.disabled{
  color:#a5a5a5;
}

.select-items {
  position: absolute;
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background:#ffffff;
  border-top:2px solid #2175d9;
  top:0;
  left:0;
  right:0;
  z-index:99;
  padding-top:11px;
  padding-bottom:32px;
}

.option-overlay {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size:18px;
  line-height:100%;
  padding:15px 48px;
  color:#2c2c2c;
  border:1px solid transparent;
}

.option-overlay:focus-visible{
  outline:1px solid #2175d9;
  border:1px solid #2175d9;
}

.option-overlay.selected{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  color:#ffffff;
}

.select-hide {
  display: none;
}

.custom-select:hover{
  cursor:pointer;
}

.custom-select:focus-visible{
  border:1px solid #2175d9;
  outline:1px solid #2175d9;
}

.select-items div:hover,
.same-as-selected{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  color:#ffffff;
}

@media only screen and (min-width: 1024px){
  .select-items {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
`;let xi=class extends $t{constructor(){super(...arguments),this.hasError=!1,this.required=!1,this.disabled=!1,this.menuOpen=!1,this.errorMessage="Error Message"}firstUpdated(){this.required=this.hasAttribute("required"),this.disabled=this.hasAttribute("disabled"),this.hasError=this.hasAttribute("error");const t=[...this._options].find((t=>t.hasAttribute("selected")));this.activeLabel=t?t.innerText:[...this._options][0].innerText}_handleClick(){this._toggleMenu()}_handleKeydown(t){const e=t.target;" "===t.key&&(t.preventDefault(),this.menuOpen=!0),"Escape"===t.key&&(this.menuOpen=!1),"Enter"!==t.key&&" "!==t.key||!0!==this.menuOpen||!e.classList.contains("option-overlay")||this._handleSelection(t)}_handleSelection(t){const e=t.target;[...this._optionOverlay].forEach((t=>{t.classList.remove("selected")})),e.classList.add("selected");const i=e.getAttribute("data-value"),r=[...this._options].filter((t=>t.getAttribute("value")===`${i}`));[...this._options].forEach((t=>{t.removeAttribute("selected")})),r[0].setAttribute("selected","true"),this.activeLabel=r[0].innerText,this.menuOpen=!1}_toggleMenu(){this.menuOpen?this.menuOpen=!1:this.menuOpen=!0}_closeMenu(t){t.target!==this&&(this.menuOpen=!1)}connectedCallback(){super.connectedCallback(),document.addEventListener("click",this._closeMenu.bind(this))}disconnectedCallback(){document.removeEventListener("click",this._closeMenu.bind(this)),super.disconnectedCallback()}render(){return Y`
      <label class="${this.disabled?"disabled":""}" for="${this.id}"
        >${this.label}
        ${!0===this.required?Y` <sup>*</sup><span class="sr-only">required</span>`:null}</label
      >

      <div
        class="custom-select ${this.menuOpen?"active":""} ${this.disabled?"disabled":""}"
        id="custom-select"
        tabindex="0"
        @keydown="${this._handleKeydown}"
      >
        <select
          form="${At(this.form)}"
          multiple="${At(this.multiple)}"
          ?required="${At(this.required)}"
          id="${this.id}"
          name="${this.name}"
          aria-hidden="true"
        >
          ${this.options.map((t=>Y`<option
              value="${t.value}"
              ?selected="${t.selected}"
            >
              ${t.text}
            </option>`))}
        </select>

        <div
          @click="${this._handleClick}"
          class="select-selected ${this.menuOpen?"active select-arrow-active":""}
            ${this.disabled?"disabled":""}"
        >
          ${this.activeLabel}

          <span class="dropdown-container">
            <atmos-icon class="" icon="dropdown" svg="true"></atmos-icon>
          </span>
        </div>

        <div class="select-items ${this.menuOpen?"active":"select-hide"}">
          <span class="dropdown-container -menu">
            <atmos-icon class="" icon="dropdown" svg="true"></atmos-icon>
          </span>
          ${this.options.map((t=>Y`<div
              class="option-overlay"
              @click="${this._handleSelection}"
              data-value="${t.value}"
              ?selected="${t.selected}"
              tabindex="${this.menuOpen?"0":""}"
              aria-hidden="${!this.menuOpen}"
              aria-labelledby="custom-select"
            >
              ${t.text}
            </div>`))}
        </div>
      </div>

      ${this.hasError?Y`
            <div class="error-container">
              <atmos-icon
                class="mr-1"
                icon="exclamationTriangle"
                svg="true"
              ></atmos-icon
              ><span class="error-message">${this.errorMessage}</span>
            </div>
          `:""}
    `}};xi.styles=[wi],p([gt()],xi.prototype,"hasError",void 0),p([gt()],xi.prototype,"required",void 0),p([gt()],xi.prototype,"disabled",void 0),p([gt()],xi.prototype,"menuOpen",void 0),p([gt()],xi.prototype,"activeLabel",void 0),p([ut({type:Array,attribute:"options"})],xi.prototype,"options",void 0),p([ut({type:String,attribute:"id"})],xi.prototype,"id",void 0),p([ut({type:String,attribute:"name"})],xi.prototype,"name",void 0),p([ut({type:String,attribute:"label"})],xi.prototype,"label",void 0),p([ut({type:String,attribute:"form"})],xi.prototype,"form",void 0),p([ut({type:Boolean,attribute:"multiple"})],xi.prototype,"multiple",void 0),p([ut({type:String,attribute:"errormessage"})],xi.prototype,"errorMessage",void 0),p([bt("div.option-overlay")],xi.prototype,"_optionOverlay",void 0),p([bt("option")],xi.prototype,"_options",void 0),p([mt(".select-selected")],xi.prototype,"_selectOverlay",void 0),xi=p([ht("atmos-dropdown")],xi);var yi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.wrapper{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  z-index:-1;
}

.inner {
  position: relative;
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

::slotted([slot='bgImage']) {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  left:55%;
  width:45%;
  opacity:0.23;
  -webkit-mask-image:linear-gradient(to right, transparent 0%, #0074ff 75%);
          mask-image:linear-gradient(to right, transparent 0%, #0074ff 75%);
}

.container {
  position: relative;
  margin: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 3rem;
  padding-top:var(--spacing-22);
  max-width:564px;
}

.title {
  margin-top: 0px;
  margin-bottom: 2rem;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
  line-height:1.2;
}

.text {
  position: relative;
  margin-left: 0px;
  margin-right: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-family: Futura Std Light, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-light);
  color: var(--neutral-white);
  font-size:var(--fs-2xl);
}

.text::after {
  font-family: Futura Std Light Oblique, Helvetica, Arial, sans-serif;
  content:'"';
}

.quotation{
  position:absolute;
}

.image-wrapper-outer {
  margin: auto;
  max-width:35.25rem;
}

.image-wrapper-inner {
  position: relative;
  width:100%;
}

.image-wrapper-inner::after {
  display: block;
  content:'';
  padding-bottom:100%;
}

::slotted([slot='employee']) {
  position: absolute;
  height: 100%;
  overflow: hidden;
  border-radius: 9999px;
  object-fit: cover;
  filter:drop-shadow(rgba(0, 0, 0, 0.15) 6px 14px 32px 0px);
}

::slotted(.employee-image){
  width:100%;
  height:100%;
  max-width:none;
}

::slotted(.bg-image){
  width:auto;
  min-height:100%;
}

.spotlight-name {
  margin-bottom: 0px;
  margin-top: 0.75rem;
  text-align: right;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  font-size:var(--fs-xl);
}

.spotlight-role {
  margin: 0px;
  text-align: right;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  font-size:var(--fs-base);
}

.container {
  position: relative;
  z-index: 10;
}

.desktop-title-wrapper {
  display: block;
}

.content-inner{
  position:relative;
}

@media only screen and (max-width: 639px){
  .test {
    display: none;
  }
}

@media only screen and (min-width: 1281px){
  .title{
    font-size:var(--fs-6xl);
    margin-bottom:var(--spacing-24);
  }

  .text{
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }

  .text::before {
    left: -1rem;
  }

  .text::before{
    font-size:140px;
  }

  .spotlight-name {
    margin-top: 1rem;
  }

  .spotlight-name {
    text-align: center;
  }

  .spotlight-name{
    font-size:var(--fs-3xl);
    line-height:var(--lh-xl);
  }

  .spotlight-role {
    text-align: center;
  }

  .mobile-title-wrapper {
    display: none;
  }

  .container {
    padding-left: 0px;
    padding-right: 0px;
  }

  .container{
    padding-top:var(--spacing-36);
    padding-bottom:var(--spacing-20);
    max-width:1160px;
  }

  .content-outer {
    display: flex;
  }

  .content-outer {
    justify-content: space-between;
  }

  .content-inner {
    margin-left: 0px;
  }

  .content-inner{
    flex-basis:100%;
    max-width:564px;
    margin-top:var(--spacing-8);
  }

  .quotation{
    top:220px;
  }

  .image-wrapper-outer{
    flex-basis:100%;
    max-width:460px;
    margin:0 137px 0 0;
  }

  ::slotted([slot='employee']){
    filter:drop-shadow(rgba(0, 0, 0, 0.15) 13px 5px 64px 0px);
  }
}

@media only screen and (max-width: 1280px){
  .desktop-title-wrapper {
    display: none;
  }

  .content-inner{
    margin-top:30px;
  }

  .quotation{
    top:-45px;
  }

  .inner::before {
    left: 0px;
  }

  .inner::before {
    width: 100%;
  }

  .inner::after {
    width: 100%;
  }
}
`;let Ci=class extends fi{constructor(){super(...arguments),this.variant="none"}getImageCaption(){return""!==this.name||""!==this.role?Y`<p class="spotlight-name">${this.name}</p>
        <p class="spotlight-role">${this.role}</p>`:""}getQuote(){return""!==this.text?Y`<blockquote class="text ${this.variant}">
        ${this.text}
      </blockquote>`:""}getTitle(){return""!==this.title?Y`<h2 class="title ${this.variant}">${this.title}</h2>`:""}render(){return Y`
      <section class="wrapper spotlight">
        <div class="inner">
          <slot name="bgImage"></slot>
          <div class="container">
            <div class="mobile-title-wrapper">${this.getTitle()}</div>
            <div class="content-outer">
              <div class="image-wrapper-outer">
                <div class="image-wrapper-inner">
                  <slot name="employee"></slot>
                </div>
                ${this.getImageCaption()}
              </div>
              <div class="content-inner">
                <div class="desktop-title-wrapper">${this.getTitle()}</div>
                <svg
                  class="quotation"
                  width="39"
                  height="30"
                  viewBox="0 0 39 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.55 29.5141H32.822L38.8 0.600098H31.114L23.55 29.5141ZM0.97998 29.5141H10.252L16.23 0.600098H8.54398L0.97998 29.5141Z"
                    fill="white"
                  />
                </svg>
                ${this.getQuote()} ${this.getLink()}
              </div>
            </div>
          </div>
        </div>
      </section>
    `}};Ci.styles=[yi],p([ut({type:String})],Ci.prototype,"name",void 0),p([ut({type:String})],Ci.prototype,"role",void 0),p([ut({reflect:!0,attribute:"variant"})],Ci.prototype,"variant",void 0),p([ut({type:String,attribute:"backgroundImage"})],Ci.prototype,"backgroundImage",void 0),Ci=p([ht("atmos-employee-spotlight")],Ci);var ki=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  margin: auto;
  padding-top: 3rem;
  padding-bottom: 3rem;
  max-width:34.25rem;
}

.inner {
  position: relative;
}

.inner::after {
  position: absolute;
  left: 0px;
  content:'';
  height:calc(100% - 4px);
  width:calc(100% - 4px);
  top:12px;
  border:2px solid #7b868c;
  border-radius:9px;
  z-index:-1;
}

.heading-wrapper {
  display: flex;
  justify-content: center;
}

.heading {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
  color: var(--neutral-gray);
  background-color: var(--neutral-white);
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  width:-webkit-fit-content;
  width:-moz-fit-content;
  width:fit-content;
}

.feedback {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  padding-left: 2rem;
  padding-right: 2rem;
  color: var(--brand-primary);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  display: flex;
  align-items: center;
  border-style: none;
  background:none;
  min-width:7.625rem;
}

.feedback.active {
  background-color: var(--brand-primary);
  color: var(--neutral-white);
}

.feedback-text {
  margin-right: 0.625rem;
}

.icon-container {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0px;
  padding-right: 0px;
}

.icon-container atmos-icon{
  display:block;
  min-width:21px;
  min-height:23px;
}

.feedback:hover {
  cursor: pointer;
}

.feedback.unhelpful .icon{
  margin-top:8px;
}

.feedback.helpful .icon{
  margin-bottom:2px;
}

@media only screen and (min-width: 1024px){
  .wrapper{
    padding:7.5rem 0;
  }

  .heading {
    font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  }

  .heading {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .heading {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .heading {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
  }
}
`;let Ai=class extends $t{_handleFeedback(t){const e=t.currentTarget,i=e.dataset.feedback;if(this.toggleActiveState(e),void 0!==i){this.feedback=i;const t=new CustomEvent("provide-feedback",{detail:`Was this content helpful? ${this.feedback}`,bubbles:!0,composed:!0});this.dispatchEvent(t)}}toggleActiveState(t){t.classList.contains("active")?t.classList.remove("active"):t.classList.add("active")}getTitle(){return this.title?Y`<div class="heading-wrapper">
        <p class="heading">${this.title}</p>
      </div>`:""}render(){return Y`
      <div class="wrapper">
        <div class="inner">
          ${this.getTitle()}
          <div class="icon-container">
            <button
              id="yes"
              class="feedback helpful ${"yes"===this.feedback?"active":null}"
              data-feedback="yes"
              @click="${this._handleFeedback}"
            >
              <span class="feedback-text">Yes</span>
              <atmos-icon class="icon" icon="thumbsup" svg="true"></atmos-icon>
            </button>
            <button
              id="no"
              class="feedback unhelpful ${"no"===this.feedback?"active":null}"
              data-feedback="no"
              @click="${this._handleFeedback}"
            >
              <span class="feedback-text">No</span>
              <atmos-icon
                class="icon"
                icon="thumbsdown"
                svg="true"
              ></atmos-icon>
            </button>
          </div>
        </div>
      </div>
    `}};Ai.styles=[ki],p([ut({type:String,attribute:"title"})],Ai.prototype,"title",void 0),p([gt()],Ai.prototype,"feedback",void 0),Ai=p([ht("atmos-feedback")],Ai);var zi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  color: var(--neutral-white);
}

.atmos-logo-link {
  color: var(--neutral-white);
}

.wrapper {
  position: relative;
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
  padding:94px var(--spacing-5) 35px;
}

.divide {
  border-width: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 0px;
  margin-right: 0px;
  border-top:1px solid #7b868c;
}

.logo-wrapper-mobile {
  position: absolute;
  right: 0px;
  margin-right: 1.25rem;
  width:128px;
  top:48px;
}

.atmos-logo-link {
  display: block;
}

.copyright-statement{
  font-size:44px;
  letter-spacing:-0.015em;
}

.logo-wrapper-desktop {
  display: none;
}

::slotted([slot='footer-column']){
  max-width:238px;
}

@media only screen and (min-width: 640px){
  .wrapper{
    padding:94px var(--spacing-8) 35px;
  }
}

@media only screen and (min-width: 1024px){
  .wrapper{
    padding:64px var(--spacing-8) var(--spacing-8);
  }

  .logo-wrapper-mobile {
    display: none;
  }

  .logo-wrapper-desktop {
    display: block;
  }

  .column-container {
    display: flex;
  }

  .column-container {
    justify-content: space-between;
  }
}

@media only screen and (min-width: 1280px){
  .wrapper{
    padding:96px 138px 51px;
  }

  .inner{
    max-width:1180px;
  }

  .inner {
    margin: auto;
  }

  .divide{
    margin:18px 0;
  }
}

@media only screen and (min-width: 1440px){
  ::slotted([slot='footer-column']){
    min-width:238px;
  }
}
`;let $i=class extends $t{render(){return Y`
      <div class="wrapper">
        <div class="inner">
          <div class="logo-wrapper-mobile">
            <a class="atmos-logo-link" href=/>
              <atmos-icon icon="atmosLogo" url="${this.iconUrl}" svg="true"></atmos-icon>
            </a>
          </div>
          
          <div class="column-container">
            <slot name="footer-column"></slot>
          </div>

          <hr class="divide" />

          <div class="legal-container">
            <slot name="legal-links"></slot>
          </div>
          <slot name="copyright"></slot>
        </div>
      </div>
    `}};$i.styles=[zi],p([ut({type:String})],$i.prototype,"iconUrl",void 0),$i=p([ht("atmos-footer")],$i);var Mi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  position:relative;
  background-position-x:-3000px;
  background-repeat:no-repeat;
  background-size:1550px;
  max-width:1200px;
  margin:0 auto;
}

.wrapper .footprint-title{
  margin:0 20px;
}

.wrapper .footprint-title .footprint-title-block{
  font-size:64px;
  line-height:64px;
  padding:0;
  background:#fff;
  display:inline-block;
  font-weight:bold;
}

.wrapper .footprint-title strong{
  color:var(--brand-primary);
}

.wrapper .footprint-map{
  min-height:inherit;
  padding:20px 0px 20px;
  text-align:center;
  position:relative;
}

.map-wrapper{
  position:relative;
}

::slotted([slot='bgMap']){
  position:relative;
  width:100% !important;
  max-width:1200px !important;
  margin:0 auto !important;
}

.wrapper .footprint-map .expand{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%, -150%);
  width:88px;
  height:88px;
  border:none;
  background-color:transparent;
  background-repeat:no-repeat;
  color:#fff;
  text-decoration:none;
}

.wrapper .footprint-map .expand span{
  position:absolute;
  left:18px;
  top:48px;
}

.wrapper .footprint-map .footprint-body{
  max-width:inherit;
  width:auto;
  margin:20px;
  font-size:18px;
  transform:inherit;
  text-align:justify;
}

.wrapper .footprint-map .footprint-body span{
  font-size:16px;
}

.wrapper .footnote img{
  margin-right:10px;
}

.wrapper .footnote .footnote-item{
  font-size:var(--fs-sm);
  display:flex;
  align-items:center;
  margin:0 20px;
}

.wrapper .footnote .footnote-item div{
  width:20px;
  text-align:center;
  display:flex;
  justify-content:center;
}

@media only screen and (min-width: 640px){
  .wrapper .footprint-title .footprint-title-block{
    font-size:64px;
    line-height:64px;
    padding:0;
    background:#fff;
    display:inline-block;
    font-weight:bold;
  }

  .wrapper .footnote{
    max-width:1200px;
    margin:0 auto;
    display:flex;
    flex-wrap:wrap;
  }

  .wrapper .footnote .footnote-item div{
    width:30px;
  }
}

@media only screen and (min-width: 1024px){
  .wrapper{
    position:relative;
    background-repeat:no-repeat;
    background-position-x:center;
  }

  .wrapper .footnote{
    max-width:1200px;
    margin:0 auto;
    display:flex;
    justify-content:space-around;
  }

  .wrapper .footprint-title .footprint-title-block{
    font-size:80px;
    line-height:80px;
    padding:50px 10px 0;
    background:#fff;
    display:inline-block;
    font-weight:bold;
  }

  .wrapper .footprint-map .footprint-body{
    line-height:30px;
    width:640px;
    position:absolute;
    left:50%;
    padding:50px;
    transform:translateX(-350px);
    z-index:1;
    background-image:radial-gradient(#fff, #fff, transparent);
  }

  .wrapper .footprint-map{
    padding:0;
  }

  .wrapper .footprint-map .expand{
    display:none;
  }

  .wrapper .footprint-map img{
    position:absolute;
    left:50%;
    transform:translateX(-50%);
    width:auto;
  }
}
`;const Si=['<svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <circle cx="10.5" cy="10.5" r="9.5" fill="#2175D9" stroke="#fff" stroke-width="2"/>\n  <circle cx="10.5" cy="10.5" r="4.5" fill="#fff"/>\n</svg>','<svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <circle cx="6.5" cy="6.5" r="5.5" fill="#2175D9" stroke="#fff" stroke-width="2"/>\n</svg>','<svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#FEE96C" stroke="#7B868C" d="M.5.5h13v14H.5z"/>\n</svg>','<svg viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#2C2C2C" d="M0 5L4.243.757 8.485 5 4.243 9.243z"/>\n</svg>','<svg viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <circle cx="3.5" cy="3.5" r="3.5" fill="#19AD45"/>\n</svg>'];let Li=class extends $t{constructor(){super(...arguments),this.title="",this.text="",this.textSecondary="",this.bg=""}render(){return Y`
      <div class="wrapper" style="background-image: url('${'<svg viewBox="0 0 1600 270" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1h87c22.644 0 41 18.356 41 41v119c0 22.644 18.356 41 41 41h740.5c22.644 0 41-18.356 41-41v-10.5c0-22.644 18.356-41 41-41H1230c22.64 0 41 18.356 41 41V228c0 22.644 18.36 41 41 41h288" stroke="#FEE96C" stroke-width="2"/>\n</svg>'}')">
        ${this.title&&Y` <div class="footprint-title">
            <div class="footprint-title-block">${Ot(this.title)}</div>
          </div>`}
        <div class="footprint-map">
          <p class="footprint-body">
            ${this.text?Ot(this.text):""}<br /><br />
            <span>${this.textSecondary?Ot(this.textSecondary):""}</span>
          </p>
          <div class="map-wrapper">
            <slot name="bgMap"></slot>
            <a href="${this.mapUrl}" title"expand" class="expand">
              <img src="${'<svg viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <circle cx="43.5" cy="43.5" r="43.5" fill="url(#paint0_linear)"/>\n  <path d="M33 29.438c0 .187.047.328.14.421.094.094.235.141.422.141h.376c.14 0 .28-.047.374-.14a.595.595 0 00.188-.422V24h5.438c.14 0 .28-.047.374-.14a.595.595 0 00.188-.422v-.375c0-.141-.094-.282-.188-.375-.093-.094-.234-.188-.374-.188h-5.813c-.328 0-.61.14-.797.328a1.098 1.098 0 00-.328.797v5.813zM47.063 22.5a.595.595 0 00-.422.188.532.532 0 00-.141.375v.375c0 .187.047.328.14.421.094.094.235.141.422.141H52.5v5.438c0 .187.047.328.14.421.094.094.235.141.422.141h.376c.14 0 .28-.047.374-.14a.595.595 0 00.188-.422v-5.813c0-.281-.14-.563-.328-.797-.234-.187-.516-.328-.797-.328h-5.813zM54 36.563c0-.141-.094-.282-.188-.376-.093-.093-.234-.187-.374-.187h-.376a.595.595 0 00-.421.188.532.532 0 00-.141.374V42h-5.438a.595.595 0 00-.421.188.532.532 0 00-.141.374v.376c0 .187.047.328.14.421.094.094.235.141.422.141h5.813a1.1 1.1 0 00.797-.328c.187-.188.328-.469.328-.797v-5.813zM39.937 43.5a.537.537 0 00.376-.14.595.595 0 00.187-.422v-.376c0-.14-.094-.28-.188-.374-.093-.094-.234-.188-.374-.188H34.5v-5.438c0-.14-.094-.28-.188-.374-.093-.094-.234-.188-.374-.188h-.376a.595.595 0 00-.421.188.532.532 0 00-.141.374v5.813c0 .328.094.61.328.797.188.234.469.328.797.328h5.813z" fill="#fff"/>\n  <defs>\n    <linearGradient id="paint0_linear" x1="41.35" y1="87" x2="79.73" y2="14.84" gradientUnits="userSpaceOnUse">\n      <stop stop-color="#0053B7"/>\n      <stop offset="1" stop-color="#0074FF"/>\n    </linearGradient>\n  </defs>\n</svg>'}" alt"expand" />
              <span>Expand</span>
            </a>
          </div>
        </div>
        ${this.footnotes.filter((t=>""!==t.footnote))[0]?Y`<div class="footnote">
                ${this.footnotes.map(((t,e)=>""!==t.footnote?Y`
                      <div class="footnote-item">
                        <div><img src="${Si[e]}" /></div>
                        <span>${t.footnote}</span>
                      </div>
                    `:""))}
              </div>`:null}

      </div>
    `}};Li.styles=[Mi],p([ut()],Li.prototype,"title",void 0),p([ut()],Li.prototype,"text",void 0),p([ut()],Li.prototype,"textSecondary",void 0),p([ut({type:Array,attribute:"footnotes"})],Li.prototype,"footnotes",void 0),p([ut()],Li.prototype,"bg",void 0),p([ut({attribute:"map-url"})],Li.prototype,"mapUrl",void 0),Li=p([ht("atmos-footprint")],Li);var Hi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
label {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color:#2c2c2c;
  line-height:150%;
  margin-bottom:4px;
}

input{
  background:#ffffff;
  border:1px solid #2c2c2c;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color:#2c2c2c;
  line-height:48px;
  padding-left: 1rem;
  padding-right: 1rem;
}

sup{
  color:#ff0000;
}

input:focus-visible{
  border:1px solid #2175d9;
  outline:1px solid #2175d9;
}

input.error{
  border:2px solid #ff0000;
}

input[type='checkbox'],
input[type='radio']{
  margin:0;
  position:absolute;
  opacity:0;
  cursor:pointer;
  height:0;
  width:0;
}

input[type='image']{
  border:none;
  background:none;
}

span.checkmark{
  position:absolute;
  left:0;
  height:24px;
  width:24px;
  background-color:#ffffff;
  border:1px solid #2c2c2c;
}

span.radio{
  position:absolute;
  left:0;
  height:22px;
  width:22px;
  background-color:#ffffff;
  border:1px solid #2c2c2c;
  border-radius:50%;
}

input[type='checkbox']:checked ~ span.checkmark,
input[type='radio']:checked ~ span.checkmark{
  background:#2175d9;
  border:1px solid #2175d9;
}

span.checkmark:after{
  content:'';
  position:absolute;
  display:none;
}

input[type='checkbox']:checked ~ span.checkmark:after,
input[type='radio']:checked ~ span.checkmark:after{
  display:block;
}

input[type='checkbox']:disabled ~ span.checkmark,
input[type='radio']:disabled ~ span.checkmark{
  border:1px solid #e2e2e2;
  background-color:#e2e2e2;
}

span.checkmark:after{
  left:9px;
  top:4px;
  width:4px;
  height:12px;
  border:solid white;
  border-width:0 2px 2px 0;
  transform:rotate(45deg);
}

span.radio:after{
  top:6px;
  left:6px;
  width:8px;
  height:8px;
  border-radius:50%;
  background:white;
}

label.checkbox, label.radio {
  margin-bottom: 0px;
  padding-left: 2.5rem;
  z-index:1;
  line-height:26px;
  -webkit-user-select:none;
     -moz-user-select:none;
          user-select:none;
}

label.disabled{
  color:#a5a5a5;
}

label.checkbox.disabled:hover,
label.radio.disabled:hover{
  cursor:default;
}

label.checkbox:hover,
label.radio:hover{
  cursor:pointer;
}

.sr-only{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.error-container{
  color:#ff0000;
  display:flex;
  font-family:Futura Std;
  font-style:normal;
  font-weight:normal;
  font-size:14px;
  line-height:150%;
  margin-top:5px;
}

:host-context([type='radio']),
:host-context([type='checkbox']){
  flex-wrap:wrap;
}

:host-context([type='radio']) .error-container,
:host-context([type='checkbox']) .error-container{
  flex-basis:100%;
}

atmos-icon{
  margin-right:4px;
  margin-top:2px;
}
`;let Bi=class extends $t{constructor(){super(...arguments),this.hasError=!1,this.required=!1,this.disabled=!1,this.readonly=!1,this.checked=!1,this.type="text",this.errorMessage="Error Message"}firstUpdated(){this.required=this.hasAttribute("required"),this.disabled=this.hasAttribute("disabled"),this.readonly=this.hasAttribute("readonly"),this.checked=this.hasAttribute("checked"),this.hasError=this.hasAttribute("error")}render(){return Y`
      <label
        for="${this.id}"
        class="${this.labelClass}${"hidden"===this.type?" hidden":null}${this.disabled?" disabled":""} ${this.type}"
      >
        ${this.label}
        ${!0===this.required?Y` <sup>*</sup><span class="sr-only">required</span>`:null}
      </label>
      <input
        class="${this.inputClass}${this.hasError?" error":null}"
        id="${this.id}"
        name="${this.name}"
        type="${this.type}"
        value="${At(this.value)}"
        placeholder="${At(this.placeholder)}"
        min="${At(this.min)}"
        max="${At(this.max)}"
        maxlength="${At(this.maxlength)}"
        pattern="${At(this.pattern)}"
        size="${At(this.size)}"
        step="${At(this.step)}"
        src="${At(this.src)}"
        alt="${At(this.alt)}"
        formaction="${At(this.formaction)}"
        formenctype="${At(this.formenctype)}"
        formmethod="${At(this.formmethod)}"
        formnovalidate="${At(this.formnovalidate)}"
        formtarget="${At(this.formtarget)}"
        form="${At(this.form)}"
        height="${At(this.height)}"
        width="${At(this.width)}"
        multiple="${At(this.multiple)}"
        accept="${At(this.accept)}"
        autocomplete="${At(this.autocomplete)}"
        autofocus="${At(this.autofocus)}"
        capture="${At(this.capture)}"
        errormessage="${At(this.errorMessage)}"
        dirname="${At(this.name)}.${At(this.dirname)}"
        ?required=${At(this.required)}
        ?disabled=${At(this.disabled)}
        ?checked=${At(this.checked)}
        ?readonly=${At(this.readonly)}
      />
      ${"checkbox"===this.type||"radio"===this.type?Y`<span
            class="checkmark ${"radio"===this.type?"radio":""}"
          ></span>`:""}
      ${this.hasError?Y`
            <div class="error-container">
              <atmos-icon
                class="mr-1"
                icon="exclamationTriangle"
                svg="true"
              ></atmos-icon
              ><span class="error-message">${this.errorMessage}</span>
            </div>
          `:""}
    `}};Bi.styles=[Hi],p([gt()],Bi.prototype,"hasError",void 0),p([gt()],Bi.prototype,"required",void 0),p([gt()],Bi.prototype,"disabled",void 0),p([gt()],Bi.prototype,"readonly",void 0),p([gt()],Bi.prototype,"checked",void 0),p([ut({reflect:!0,attribute:"type"})],Bi.prototype,"type",void 0),p([ut({type:String,attribute:"label"})],Bi.prototype,"label",void 0),p([ut({type:String,attribute:"value"})],Bi.prototype,"value",void 0),p([ut({type:String,attribute:"inputClass"})],Bi.prototype,"inputClass",void 0),p([ut({type:String,attribute:"labelClass"})],Bi.prototype,"labelClass",void 0),p([ut({type:String,reflect:!0,attribute:"errormessage"})],Bi.prototype,"errorMessage",void 0),p([ut({type:String,attribute:"placeholder"})],Bi.prototype,"placeholder",void 0),p([ut({type:Number,attribute:"min"})],Bi.prototype,"min",void 0),p([ut({type:Number,attribute:"max"})],Bi.prototype,"max",void 0),p([ut({type:Number,attribute:"step"})],Bi.prototype,"step",void 0),p([ut({type:Number,attribute:"size"})],Bi.prototype,"size",void 0),p([ut({type:Number,attribute:"maxlength"})],Bi.prototype,"maxlength",void 0),p([ut({type:String,attribute:"id"})],Bi.prototype,"id",void 0),p([ut({type:String,attribute:"pattern"})],Bi.prototype,"pattern",void 0),p([ut({type:String,attribute:"src"})],Bi.prototype,"src",void 0),p([ut({type:String,attribute:"alt"})],Bi.prototype,"alt",void 0),p([ut({type:String,attribute:"accept"})],Bi.prototype,"accept",void 0),p([ut({type:String,attribute:"autocomplete"})],Bi.prototype,"autocomplete",void 0),p([ut({type:Boolean,attribute:"autofocus"})],Bi.prototype,"autofocus",void 0),p([ut({type:String,attribute:"capture"})],Bi.prototype,"capture",void 0),p([ut({reflect:!0,attribute:"dirname"})],Bi.prototype,"dirname",void 0),p([ut({type:String,attribute:"name"})],Bi.prototype,"name",void 0),p([ut({type:String,attribute:"formaction"})],Bi.prototype,"formaction",void 0),p([ut({type:String,attribute:"formenctype"})],Bi.prototype,"formenctype",void 0),p([ut({reflect:!0,attribute:"formmethod"})],Bi.prototype,"formmethod",void 0),p([ut({type:Boolean,attribute:"formnovalidate"})],Bi.prototype,"formnovalidate",void 0),p([ut({type:String,attribute:"formtarget"})],Bi.prototype,"formtarget",void 0),p([ut({type:String,attribute:"form"})],Bi.prototype,"form",void 0),p([ut({type:Number,attribute:"height"})],Bi.prototype,"height",void 0),p([ut({type:Number,attribute:"width"})],Bi.prototype,"width",void 0),p([ut({type:Boolean,attribute:"multiple"})],Bi.prototype,"multiple",void 0),Bi=p([ht("atmos-form-input")],Bi);const _i=[{label:"Our Company",path:"",children:[{title:null,items:[],altern:!1},{title:"Overview",items:[{label:"About",path:"entity:node/425",children:[]},{label:"Board of Directors",path:"entity:node/595",children:[]},{label:"Careers",path:"entity:node/462",children:[]},{label:"Leadership",path:"entity:node/458",children:[]},{label:"News",path:"entity:node/645",children:[]},{label:"Filings, Rates & Tariffs",path:"entity:node/675",children:[]}],altern:!1},{title:"Sustainability",items:[{label:"2021 CRS Report",path:"https://www.atmosenergy.com/sustainability",children:[]},{label:"Environment",path:"entity:node/806",children:[]},{label:"Pipe Replacement Process",path:"entity:node/486",children:[]},{label:"Reports",path:"entity:node/805",children:[]},{label:"Zero Net Energy Homes",path:"entity:node/468",children:[]}],altern:!1},{title:"Operations",items:[{label:"Texas",path:"entity:node/488",children:[]},{label:"Colorado",path:"entity:node/475",children:[]},{label:"Kansas",path:"entity:node/479",children:[]},{label:"Louisiana",path:"entity:node/482",children:[]},{label:"Mississippi",path:"entity:node/484",children:[]},{label:"Kentucky",path:"entity:node/483",children:[]},{label:"Tennessee",path:"entity:node/483",children:[]},{label:"Virginia",path:"entity:node/483",children:[]},{label:"Atmos Pipeline-Texas",path:"entity:node/515",children:[]}],altern:!1},{title:"Investors",items:[{label:"Investor Relations",path:"entity:node/673",children:[]},{label:"Financial News",path:"entity:node/646",children:[]},{label:"Publications & SEC Filings",path:"entity:node/544",children:[]},{label:"Stock Information",path:"entity:node/647",children:[]},{label:"Webcasts & Presentations",path:"entity:node/546",children:[]}],altern:!1}]},{label:"Our Customers",path:"",children:[{title:null,items:[],altern:!1},{title:"Customer Service",items:[{label:"Claims Process",path:"entity:node/388",children:[]},{label:"Locate a Gas Dealer",path:"entity:node/511",children:[]},{label:"Low Income Programs",path:"entity:node/399",children:[]},{label:"Stop Service",path:"https://www.atmosenergy.com/accountcenter/logon/login.html",children:[]},{label:"Start/Transfer Service",path:"https://www.atmosenergy.com/accountcenter/moveininf/bpMoveInStart.html",children:[]},{label:"Utility Scams",path:"entity:node/492",children:[]}],altern:!1},{title:"Billing and Payment",items:[{label:"Account Options",path:"entity:node/491",children:[]},{label:"Bill Inserts",path:"entity:node/493",children:[]},{label:"Budget Billing",path:"entity:node/503",children:[]},{label:"Get Help Paying Your Bill",path:"entity:node/502",children:[]},{label:"Large Volume Customer Login",path:"entity:node/525",children:[]},{label:"Pay Your Bill",path:"entity:node/526",children:[]},{label:"Understanding Your Bill",path:"entity:node/654",children:[]},{label:"Wireless Meter Reading",path:"entity:node/539",children:[]}],altern:!1},{title:"Ways to Save",items:[{label:"Appliance Rebates",path:"entity:node/410",children:[]},{label:"Business Savings",path:"entity:node/411",children:[]},{label:"Manage Energy at Home",path:"entity:node/421",children:[]},{label:"Why Choose Natural Gas",path:"entity:node/416",children:[]}],altern:!1}]},{label:"Safety",path:"",children:[{title:null,items:[{label:"Carbon Monoxide Safety",path:"entity:node/787",children:[]},{label:"Call 811 Before Digging",path:"entity:node/335",children:[]},{label:"Cross Bore",path:"entity:node/343",children:[]},{label:"Elements of Natural Gas",path:"entity:node/347",children:[]},{label:"Excavator Digging Safely",path:"entity:node/336",children:[]},{label:"Excess Flow Valve",path:"entity:node/350",children:[]},{label:"First Responders",path:"entity:node/353",children:[]},{label:"Home Safety",path:"entity:node/354",children:[]},{label:"Leak Detection",path:"entity:node/358",children:[]},{label:"Natural Gas Contractors & Professionals",path:"entity:node/362",children:[]},{label:"Recognizing a Leak",path:"entity:node/360",children:[]},{label:"Right of Way",path:"entity:node/361",children:[]},{label:"Weather Safety",path:"entity:node/387",children:[]}],altern:!1}]}],Fi=[{label:"Pay Bill",path:"#",external:!1},{label:"Manage Account",path:"#",external:!1},{label:"Contact Us",path:"#",external:!1}],Di={quickLinks:[{label:"Manage Account",value:"Manage Account"},{label:"Pay Bill",value:"Pay Bill"},{label:"Help Paying Bill",value:"Help Paying Bill"},{label:"Start/Transfer Service",value:"Start/Transfer Service"},{label:"Stop Service",value:"Stop Service"},{label:"Contact Us",value:"Contact Us"}],recentSearches:[{label:"Rebates",value:"Rebates"},{label:"Replacing gas lines mid-Tex",value:"Replacing gas lines mid-Tex"}],suggestedPages:[{label:"Saving money on your gas bill",path:"#",external:!1},{label:"Service map",path:"#",external:!1},{label:"How Atmos prioritizes your safety",path:"#",external:!1}]};var Ei=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.content {
  display: block;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom:var(--spacing-14);
}

.wrapper.-media .inner, .wrapper.-icon-card .inner, .wrapper.-location-selector .inner {
  background-image: none;
}

.title {
  margin-bottom: 2rem;
  margin-top: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  padding-top:var(--spacing-20);
}

.title .accent {
  color: var(--brand-primary);
}

span.location {
  color: var(--brand-primary);
}

.subheading {
  margin-top: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size:26px;
}

.text {
  letter-spacing: -.005em;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  margin-bottom: 1.5rem;
  margin-top: 0px;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--neutral-grayDark);
  line-height: 1.5;
}

.iamge-hero-wrapper{
  width:100%;
}

::slotted([slot='image']){
  width:100%;
}

.location-selector {
  background-color: var(--neutral-white);
  padding:0 3rem;
}

.location-selector.-map{
  min-height:349px;
  height:349px;
}

.location-selector-inner {
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  position: relative;
  border-top:4px solid var(--brand-secondary);
  padding:39px 28px 0;
  min-height:306px;
}

.location-selector.-map .location-selector-inner {
  padding: 0px;
  height:calc(100% - 4px);
}

::slotted(p) {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  text-align: center;
  color: var(--neutral-grayDark);
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

::slotted(form){
  margin-top:69px;
}

::slotted([slot='map']) {
  height: 100%;
  min-height:345px;
  min-width:350px;
}

::slotted(form) input {
  position: absolute;
}

@media only screen and (min-width: 640px){
  .title{
    line-height:var(--lh-6xl);
    letter-spacing:-0.02em;
  }
}

@media only screen and (max-width: 639px){
  .title {
    padding-top: 2rem;
  }
  .title {
    margin-bottom: 1.5rem;
  }
  .title {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }
  .title {
    line-height: 1.25;
  }

  .content {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .content {
    padding-top: 0px;
  }

  .content {
    padding-bottom: 1.5rem;
  }

  .location-selector {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .text {
    font-family: Futura Std, Helvetica, Arial, sans-serif;
  }

  .text {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
  }
}

@media only screen and (max-width: 1279px){
  .inner-map{
    display:flex;
    flex-direction:column-reverse;
  }

  .location-selector{
    padding-bottom:var(--spacing-14);
  }
}

@media only screen and (min-width: 1280px){
  .wrapper.-media .inner, .wrapper.-icon-card .inner, .wrapper.-location-selector .inner {
    display: flex;
  }
  .wrapper.-media .inner, .wrapper.-icon-card .inner, .wrapper.-location-selector .inner {
    flex-direction: row-reverse;
  }
  .wrapper.-media .inner, .wrapper.-icon-card .inner, .wrapper.-location-selector .inner {
    margin: auto;
  }
  .wrapper.-media .inner, .wrapper.-icon-card .inner, .wrapper.-location-selector .inner {
    max-width: 1136px;
  }

  .wrapper.-media .hero-img,
  .wrapper.-icon-card .icon-card-wrapper,
  .wrapper.-location-selector .location-selector{
    flex-basis:50%;
    display:flex;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    background-image: none;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    padding-left: 0px;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    padding-bottom: 0px;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    display: flex;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    flex-direction: column;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    justify-content: center;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    padding-right: 0px;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    margin: 0px;
  }

  .wrapper.-media .content, .wrapper.-icon-card .content, .wrapper.-location-selector .content {
    justify-content: center;
  }

  .wrapper.-media .content,
  .wrapper.-icon-card .content,
  .wrapper.-location-selector .content{
    flex-basis:50%;
    padding:80px 0 56px;
  }

  .wrapper .content.-link{
    padding-bottom:80px;
  }

  .wrapper.-media .content-inner,
  .wrapper.-icon-card .content-inner,
  .wrapper.-location-selector .content-inner{
    padding-right:60px;
  }

  .location-selector {
    padding: 0px;
  }

  .location-selector{
    background-color:transparent;
    height:auto;
  }

  .location-selector.-map{
    height:auto;
  }

  .location-selector-inner {
    background-color: var(--neutral-white);
  }

  .location-selector-inner{
    max-width:290px;
    margin:0 auto 0 116px;
    padding:65px 32px 0;
    height:calc(100% - 69px);
    min-height:302px;
  }

  .location-selector.-map .location-selector-inner {
    padding: 0px;
  }

  .location-selector.-map .location-selector-inner{
    height:367px;
    min-height:367px;
    max-width:354px;
    height:calc(100% - 4px);
  }

  ::slotted(p){
    font-size:28px;
  }

  ::slotted(form) {
    padding: 0px;
  }

  ::slotted(form){
    margin-top:49px;
    margin-bottom:59px;
  }

  ::slotted([slot='map']) {
    height: 100%;
  }

  ::slotted([slot='map']){
    min-height:0;
    min-width:350px;
  }

  .wrapper.-media .title, .wrapper.-icon-card .title, .wrapper.-location-selector .title {
    padding-top: 0px;
  }

  .content {
    margin: auto;
  }

  .content {
    max-width: 1136px;
  }

  .content{
    padding-left:var(--spacing-56);
    padding-right:var(--spacing-56);
  }

  .text{
    max-width:53.5rem;
  }

  .image-hero-wrapper{
    width:50%;
  }

  ::slotted([slot='image']){
    display:block;
    height:100% !important;
    width:100%;
    object-fit:cover;
  }

  ::slotted([slot='image']) {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .icon-card-wrapper {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .location-selector-inner {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

.form-test{
  display: flex;
  flex-direction: column;
  align-items: center;
}
`;let Vi=class extends fi{constructor(){super(...arguments),this.showMap=!1,this.heroVariant="none"}getImage(){return this.imageUrl?Y`<div class="image-hero-wrapper"><slot name="image"></slot></div>`:""}getTitle(){return""!==this.title?Y`<h1 class="title ${this.variant}">
        ${this.title} <span class="accent">${this.titleAccent}</span>${this.mapLocation?Y`: <br /><span class="location">${this.mapLocation}</span>`:""}
      </h1> `:""}getSubheading(){return""!==this.subheading?Y`<h3 class="subheading ${this.variant}">
        ${this.subheading}
      </h3>`:""}getLocationSelector(){return"location-selector"===this.heroVariant?Y`<div class="location-selector ${this.showMap?"-map":""}">
        <div class="location-selector-inner">
          ${this.showMap?Y`<slot name="map"></slot>`:Y`<slot name="location-selector"></slot>`}
        </div>
      </div>`:""}getIconCard(){return"{}"!==JSON.stringify(this.infoCard)?Y`<div class="icon-card-wrapper">
        <atmos-icon-card
          icon="phone"
          url="${this.infoCard.url}"
          type="${this.infoCard.type}"
          title="${this.infoCard.title}"
          text="${this.infoCard.text}"
          link="${this.infoCard.link}"
          rel="${this.infoCard.rel}"
          target="${this.infoCard.target}"
          link-title="${this.infoCard.linkTitle}"
          phone="${this.infoCard.phone}"
          cta="cta"
        >
        </atmos-icon-card>
      </div>`:""}_handleSubmit(){this.showMap=!0,this.text=""}render(){return Y`
      <div
        @zip-code-submit="${this._handleSubmit}"
        class="wrapper
        ${this.imageUrl?"-media":""}
        ${"location-selector"===this.heroVariant?"-location-selector":""}
        ${"{}"!==JSON.stringify(this.infoCard)?"-icon-card":""}"
      >
        <div class="inner ${this.mapLocation?"inner-map":""}">
          ${this.getImage()} ${this.getIconCard()} ${this.getLocationSelector()}
          <div class="content ${this.link?"-link":""}">
            <div class="content-inner">
              ${this.getTitle()} ${this.getSubheading()} ${this.getText()}
              ${this.getLink()}
            </div>
          </div>
        </div>
      </div>
    `}};Vi.styles=[Ei],p([gt()],Vi.prototype,"showMap",void 0),p([ut({reflect:!0,attribute:"hero-variant"})],Vi.prototype,"heroVariant",void 0),p([ut({type:String,attribute:"image-url"})],Vi.prototype,"imageUrl",void 0),p([ut({type:String,attribute:"title-accent"})],Vi.prototype,"titleAccent",void 0),p([ut({type:String})],Vi.prototype,"subheading",void 0),p([ut({type:String,reflect:!0,attribute:"map-location"})],Vi.prototype,"mapLocation",void 0),p([ut({type:Object,attribute:"info-card"})],Vi.prototype,"infoCard",void 0),Vi=p([ht("atmos-hero")],Vi);var Oi,ji=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host(atmos-icon){
  display:flex;
  position:relative;
  width:100%;
  height:100%;
  min-width:60px;
  min-height:60px;
}

img,
svg{
  height:auto;
  width:100%;
}

svg{
  max-height:100%;
  width:auto;
  height:auto;
  position:absolute;
  inset:0px;
  margin:auto auto;
  max-width:100%;
}
`;!function(t){t.PHONE="phone",t.WARNING="warning",t.FACEBOOK="facebook",t.LINKEDIN="linkedin",t.YOUTUBE="youtube",t.TWITTER="twitter",t.INSTAGRAM="instagram",t.PRINT="print",t.EMAIL="email",t.ENVELOPE="envelope",t.CHEVRONRIGHT="chevronRight",t.QUOTE="quote",t.EXCLAMATIONTRIANGLE="exclamationTriangle",t.DROPDOWN="dropdown",t.STATUSINFO="statusInfo",t.STATUSERROR="statusError",t.STATUSWARNING="statusWarning",t.STATUSOK="statusOk",t.ATMOSLOGO="atmosLogo",t.POLYGON="polygon",t.HAMGURGER="hamburger",t.SEARCH="search",t.CLOSE="close",t.BELL="bell",t.QUESTION="question",t.HOMEOWNERS="homeowners",t.COMMERCIALMANAGERS="commercialManagers",t.BUILDERSDEVELOPERS="buildersDevelopers",t.FIRSTRESPONDERS="firstResponders",t.PLUMBERSCONTRACTORS="plumbersContractors",t.NEXT="next",t.CHECK="check",t.BAN="ban",t.BOLT="bolt",t.FLASHLIGHT="flashlight",t.CIGAR="cigar",t.CAR="car",t.TAP="tap",t.THUMBSUP="thumbsup",t.THUMBSDOWN="thumbsdown",t.CHEVRONDOWN="chevronDown",t.PDF="pdf",t.ARROWRIGHT="arrowRight",t.FILE="file",t.PIN="pin"}(Oi||(Oi={}));const Zi={phone:'<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.4072 3.59375C35.8054 3.72656 36.2036 3.99219 36.5354 4.39062C36.8009 4.78906 37 5.1875 37 5.58594C37 11.1641 35.6063 16.2773 32.819 20.9922C30.1643 25.5742 26.5142 29.2266 21.935 31.8828C17.2231 34.6719 12.1129 36 6.67093 36C6.14 36 5.74181 35.8672 5.34361 35.5352C4.94542 35.2695 4.74632 34.8711 4.61359 34.4062L3.08719 27.6992C2.95445 27.2344 2.95445 26.7695 3.21992 26.3047C3.48538 25.9062 3.81721 25.5742 4.28177 25.3086L11.4492 22.2539C11.8474 22.1211 12.312 22.0547 12.7766 22.1875C13.1748 22.3203 13.5729 22.5195 13.9048 22.8516L16.8249 26.4375C19.0813 25.3086 21.1386 23.8477 22.9969 21.9883C24.7887 20.1953 26.2488 18.1367 27.4434 15.8125L23.8596 12.8906C23.4614 12.625 23.2623 12.2266 23.1296 11.7617C22.9969 11.3633 23.0632 10.8984 23.2623 10.4336L26.3151 3.26172C26.5142 2.86328 26.8461 2.53125 27.3106 2.26562C27.7088 2 28.1734 1.93359 28.7043 2.06641L35.4072 3.59375ZM6.67093 33.875C11.7147 33.875 16.493 32.6133 20.8732 30.0234C25.1206 27.5664 28.5052 24.1797 31.0271 19.8633C33.549 15.4805 34.8763 10.7656 34.8763 5.65234L28.2397 4.125L25.1869 11.2969L30.0316 15.2148C28.4388 18.668 26.5806 21.457 24.5233 23.5156C22.3996 25.6406 19.6786 27.4336 16.2276 29.0273L12.312 24.1797L5.14452 27.2344L6.67093 33.875Z" fill="currentColor"/></svg>',warning:'<svg width="84" height="72" viewBox="0 0 84 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M41.9999 0L83.5691 72H0.430664L41.9999 0Z" fill="#FEE96C"/><rect x="41" y="24" width="2" height="27" rx="1" fill="#2C2C2C"/><circle cx="42" cy="58" r="2" fill="#2C2C2C"/></svg>',facebook:'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 1.78571C32 1.28571 31.7857 0.857143 31.4286 0.5C31.0714 0.214286 30.6429 0 30.2143 0H1.78571C1.21429 0 0.785714 0.214286 0.5 0.5C0.142857 0.857143 0 1.28571 0 1.78571V30.2143C0 30.7143 0.142857 31.1429 0.5 31.5C0.785714 31.8571 1.21429 32 1.78571 32H17.0714V19.5714H12.9286V14.7857H17.0714V11.2143C17.0714 9.21429 17.6429 7.64286 18.7857 6.5C19.9286 5.42857 21.4286 4.85714 23.2857 4.85714C24.7143 4.85714 26 4.92857 27 5V9.35714H24.4286C23.5 9.35714 22.8571 9.57143 22.5 10C22.2143 10.3571 22.0714 10.9286 22.0714 11.7143V14.7857H26.8571L26.2143 19.5714H22.0714V32H30.2143C30.7143 32 31.1429 31.8571 31.5 31.5C31.7857 31.1429 32 30.7143 32 30.2143V1.78571Z" fill="currentColor"/></svg>',twitter:'<svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32.2734 7.25C33.6797 6.20433 34.9453 4.94952 36 3.41587C34.5938 4.04327 33.1875 4.46154 31.7812 4.60096C33.3281 3.625 34.4531 2.30048 35.0156 0.557692C33.5391 1.39423 31.9922 2.02163 30.3047 2.30048C29.6016 1.60337 28.7578 1.04567 27.8438 0.627404C26.9297 0.209135 25.9453 0 24.8906 0C23.5547 0 22.3594 0.348558 21.2344 0.975962C20.1094 1.67308 19.1953 2.57933 18.5625 3.69471C17.8594 4.8101 17.5781 6.0649 17.5781 7.31971C17.5781 7.8774 17.5781 8.4351 17.7188 8.99279C14.6953 8.85337 11.8828 8.15625 9.21094 6.76202C6.53906 5.4375 4.35938 3.625 2.53125 1.32452C1.82812 2.50962 1.47656 3.76442 1.47656 5.01923C1.47656 6.27404 1.75781 7.45913 2.39062 8.50481C2.95312 9.62019 3.79688 10.4567 4.78125 11.1538C3.58594 11.1538 2.46094 10.8053 1.47656 10.1779V10.3173C1.47656 12.0601 2.03906 13.5938 3.16406 14.9183C4.28906 16.3125 5.69531 17.149 7.38281 17.4976C6.67969 17.637 6.04688 17.7067 5.41406 17.7067C4.99219 17.7067 4.5 17.7067 4.07812 17.637C4.5 19.101 5.34375 20.2861 6.60938 21.262C7.875 22.238 9.28125 22.6562 10.9688 22.6562C8.22656 24.7476 5.13281 25.7933 1.75781 25.7933C1.05469 25.7933 0.492188 25.7933 0 25.7236C3.375 27.9543 7.17188 29 11.3203 29C15.6094 29 19.4062 27.9543 22.7812 25.7236C25.8047 23.7716 28.1953 21.1923 29.8828 17.8462C31.5 14.7788 32.3438 11.5024 32.3438 8.15625C32.3438 7.73798 32.2734 7.45913 32.2734 7.25Z" fill="currentColor"/></svg>',youtube:'<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4844 2.34375C21.6406 3.04688 21.7969 4.14062 21.875 5.54688L21.9141 7.5L21.875 9.45312C21.7969 10.9375 21.6406 11.9922 21.4844 12.6953C21.3281 13.1641 21.0938 13.5547 20.7812 13.8672C20.4297 14.2188 20.0391 14.4531 19.5703 14.5703C18.8672 14.7656 17.3047 14.8828 14.8047 14.9609L11.25 15L7.69531 14.9609C5.19531 14.8828 3.59375 14.7656 2.92969 14.5703C2.46094 14.4531 2.03125 14.2188 1.71875 13.8672C1.36719 13.5547 1.13281 13.1641 1.01562 12.6953C0.820312 11.9922 0.703125 10.9375 0.625 9.45312L0.585938 7.5C0.585938 6.95312 0.585938 6.28906 0.625 5.54688C0.703125 4.14062 0.820312 3.04688 1.01562 2.34375C1.13281 1.875 1.36719 1.48438 1.71875 1.13281C2.03125 0.820312 2.46094 0.585938 2.92969 0.429688C3.59375 0.273438 5.19531 0.117188 7.69531 0.0390625L11.25 0L14.8047 0.0390625C17.3047 0.117188 18.8672 0.273438 19.5703 0.429688C20.0391 0.585938 20.4297 0.820312 20.7812 1.13281C21.0938 1.48438 21.3281 1.875 21.4844 2.34375ZM9.0625 10.7031L14.6484 7.5L9.0625 4.33594V10.7031Z" fill="currentColor"/></svg>',linkedin:'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.2857 0C29.8393 0 30.3929 0.285714 30.808 0.714286C31.2232 1.14286 31.5 1.71429 31.5 2.28571V29.7143C31.5 30.3571 31.2232 30.9286 30.808 31.3571C30.3929 31.7857 29.8393 32 29.2857 32H2.71429C2.09152 32 1.53795 31.7857 1.12277 31.3571C0.707589 30.9286 0.5 30.3571 0.5 29.7143V2.28571C0.5 1.71429 0.707589 1.14286 1.12277 0.714286C1.53795 0.285714 2.09152 0 2.71429 0H29.2857ZM9.84152 27.4286H9.91071V12.1429H5.27455V27.4286H9.84152ZM7.55804 10.0714C8.25 10.0714 8.87277 9.85714 9.42634 9.28571C9.97991 8.71429 10.2567 8.07143 10.2567 7.35714C10.2567 6.64286 9.97991 6 9.42634 5.42857C8.87277 4.85714 8.25 4.57143 7.55804 4.57143C6.79688 4.57143 6.17411 4.85714 5.68973 5.42857C5.13616 6 4.92857 6.64286 4.92857 7.35714C4.92857 8.07143 5.13616 8.71429 5.68973 9.28571C6.17411 9.85714 6.79688 10.0714 7.55804 10.0714ZM27.0714 27.4286V19.0714C27.0714 16.7143 26.7254 15 26.1027 13.8571C25.2031 12.5 23.6808 11.7857 21.6049 11.7857C20.4978 11.7857 19.5982 12.0714 18.7679 12.5714C18.0759 13 17.5223 13.5714 17.2455 14.2143H17.1763V12.1429H12.7478V27.4286H17.3147V19.8571C17.3147 18.7143 17.4531 17.7857 17.7991 17.1429C18.2143 16.3571 18.9754 15.9286 20.0826 15.9286C21.1205 15.9286 21.8125 16.4286 22.1585 17.2857C22.3661 17.8571 22.5045 18.7857 22.5045 20V27.4286H27.0714Z" fill="currentColor"/></svg>',instagram:'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7.91406C17.4062 7.91406 18.7422 8.33594 20.0078 9.03906C21.2734 9.74219 22.2578 10.7266 22.9609 11.9922C23.6641 13.2578 24.0859 14.5938 24.0859 16C24.0859 17.4766 23.6641 18.8125 22.9609 20.0781C22.2578 21.3438 21.2734 22.3281 20.0078 23.0312C18.7422 23.7344 17.4062 24.0859 16 24.0859C14.5234 24.0859 13.1875 23.7344 11.9219 23.0312C10.6562 22.3281 9.67188 21.3438 8.96875 20.0781C8.26562 18.8125 7.91406 17.4766 7.91406 16C7.91406 14.5938 8.26562 13.2578 8.96875 11.9922C9.67188 10.7266 10.6562 9.74219 11.9219 9.03906C13.1875 8.33594 14.5234 7.91406 16 7.91406ZM16 21.2734C17.4062 21.2734 18.6719 20.7812 19.7266 19.7266C20.7109 18.7422 21.2734 17.4766 21.2734 16C21.2734 14.5938 20.7109 13.3281 19.7266 12.2734C18.6719 11.2891 17.4062 10.7266 16 10.7266C14.5234 10.7266 13.2578 11.2891 12.2734 12.2734C11.2188 13.3281 10.7266 14.5938 10.7266 16C10.7266 17.4766 11.2188 18.7422 12.2734 19.7266C13.2578 20.7812 14.5234 21.2734 16 21.2734ZM26.3359 7.5625C26.3359 7.07031 26.125 6.64844 25.7734 6.22656C25.3516 5.875 24.9297 5.66406 24.4375 5.66406C23.875 5.66406 23.4531 5.875 23.1016 6.22656C22.6797 6.64844 22.5391 7.07031 22.5391 7.5625C22.5391 8.125 22.6797 8.54688 23.1016 8.89844C23.4531 9.32031 23.875 9.46094 24.4375 9.46094C24.9297 9.46094 25.3516 9.32031 25.7031 8.89844C26.0547 8.54688 26.2656 8.125 26.3359 7.5625ZM31.6797 9.46094C31.6797 10.7969 31.75 12.9766 31.75 16C31.75 19.0938 31.6797 21.2734 31.6094 22.6094C31.5391 23.9453 31.3281 25.0703 31.0469 26.0547C30.625 27.25 29.9219 28.3047 29.0781 29.1484C28.2344 29.9922 27.1797 30.625 26.0547 31.0469C25.0703 31.3984 23.875 31.6094 22.5391 31.6797C21.2031 31.75 19.0234 31.75 16 31.75C12.9062 31.75 10.7266 31.75 9.39062 31.6797C8.05469 31.6094 6.92969 31.3984 5.94531 30.9766C4.75 30.625 3.69531 29.9922 2.85156 29.1484C2.00781 28.3047 1.375 27.25 0.953125 26.0547C0.601562 25.0703 0.390625 23.9453 0.320312 22.6094C0.25 21.2734 0.25 19.0938 0.25 16C0.25 12.9766 0.25 10.7969 0.320312 9.46094C0.390625 8.125 0.601562 6.92969 0.953125 5.94531C1.375 4.82031 2.00781 3.76562 2.85156 2.92188C3.69531 2.07812 4.75 1.375 5.94531 0.953125C6.92969 0.671875 8.05469 0.460938 9.39062 0.390625C10.7266 0.320312 12.9062 0.25 16 0.25C19.0234 0.25 21.2031 0.320312 22.5391 0.390625C23.875 0.460938 25.0703 0.671875 26.0547 0.953125C27.1797 1.375 28.2344 2.07812 29.0781 2.92188C29.9219 3.76562 30.625 4.82031 31.0469 5.94531C31.3281 6.92969 31.5391 8.125 31.6797 9.46094ZM28.3047 25.2812C28.5859 24.5078 28.7266 23.2422 28.8672 21.4844C28.8672 20.5 28.9375 19.0234 28.9375 17.125V14.875C28.9375 12.9766 28.8672 11.5 28.8672 10.5156C28.7266 8.75781 28.5859 7.49219 28.3047 6.71875C27.7422 5.3125 26.6875 4.25781 25.2812 3.69531C24.5078 3.41406 23.2422 3.27344 21.4844 3.13281C20.4297 3.13281 18.9531 3.0625 17.125 3.0625H14.875C12.9766 3.0625 11.5 3.13281 10.5156 3.13281C8.75781 3.27344 7.49219 3.41406 6.71875 3.69531C5.24219 4.25781 4.25781 5.3125 3.69531 6.71875C3.41406 7.49219 3.20312 8.75781 3.13281 10.5156C3.0625 11.5703 3.0625 13.0469 3.0625 14.875V17.125C3.0625 19.0234 3.0625 20.5 3.13281 21.4844C3.20312 23.2422 3.41406 24.5078 3.69531 25.2812C4.25781 26.7578 5.3125 27.7422 6.71875 28.3047C7.49219 28.5859 8.75781 28.7969 10.5156 28.8672C11.5 28.9375 12.9766 28.9375 14.875 28.9375H17.125C19.0234 28.9375 20.5 28.9375 21.4844 28.8672C23.2422 28.7969 24.5078 28.5859 25.2812 28.3047C26.6875 27.7422 27.7422 26.6875 28.3047 25.2812Z" fill="currentColor"/></svg>',print:'<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.25 13.5C31.0781 13.5 32.6953 14.2031 34.0312 15.4688C35.2969 16.8047 36 18.4219 36 20.25V29.8125C36 30.3047 35.7891 30.7266 35.5078 31.0078C35.1562 31.3594 34.7344 31.5 34.3125 31.5H29.25V34.3125C29.25 34.8047 29.0391 35.2266 28.7578 35.5078C28.4062 35.8594 27.9844 36 27.5625 36H8.4375C7.94531 36 7.52344 35.8594 7.24219 35.5078C6.89062 35.2266 6.75 34.8047 6.75 34.3125V31.5H1.6875C1.19531 31.5 0.773438 31.3594 0.492188 31.0078C0.140625 30.7266 0 30.3047 0 29.8125V20.25C0 18.4219 0.632812 16.8047 1.96875 15.4688C3.23438 14.2031 4.85156 13.5 6.75 13.5V1.6875C6.75 1.26562 6.89062 0.84375 7.24219 0.492188C7.52344 0.210938 7.94531 0 8.4375 0H23.4844C23.9062 0 24.3281 0.210938 24.6797 0.492188L28.7578 4.57031C29.0391 4.92188 29.25 5.34375 29.25 5.76562V13.5ZM10.125 3.375V16.875H25.875V6.46875L22.7812 3.375H10.125ZM25.875 32.625V27H10.125V32.625H25.875ZM32.625 28.125V20.25C32.625 19.3359 32.2734 18.5625 31.6406 17.8594C30.9375 17.2266 30.1641 16.875 29.25 16.875V18.5625C29.25 19.0547 29.0391 19.4766 28.7578 19.7578C28.4062 20.1094 27.9844 20.25 27.5625 20.25H8.4375C7.94531 20.25 7.52344 20.1094 7.24219 19.7578C6.89062 19.4766 6.75 19.0547 6.75 18.5625V16.875C5.76562 16.875 4.99219 17.2266 4.35938 17.8594C3.65625 18.5625 3.375 19.3359 3.375 20.25V28.125H6.75V25.3125C6.75 24.8906 6.89062 24.4688 7.24219 24.1172C7.52344 23.8359 7.94531 23.625 8.4375 23.625H27.5625C27.9844 23.625 28.4062 23.8359 28.7578 24.1172C29.0391 24.4688 29.25 24.8906 29.25 25.3125V28.125H32.625ZM32.0625 21.375C32.0625 20.9531 31.8516 20.5312 31.5703 20.1797C31.2188 19.8984 30.7969 19.6875 30.375 19.6875C29.8828 19.6875 29.4609 19.8984 29.1797 20.1797C28.8281 20.5312 28.6875 20.9531 28.6875 21.375C28.6875 21.8672 28.8281 22.2891 29.1797 22.5703C29.4609 22.9219 29.8828 23.0625 30.375 23.0625C30.7969 23.0625 31.2188 22.9219 31.5703 22.5703C31.8516 22.2891 32.0625 21.8672 32.0625 21.375Z" fill="currentColor"/></svg>',email:'<svg width="38" height="27" viewBox="0 0 38 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.7773 8.92969C35.043 10.2656 31.2852 12.9375 25.6484 16.875L24.9258 17.4375C23.7695 18.2812 22.9023 18.9141 22.1797 19.2656C21.0234 19.9688 19.9395 20.25 19 20.25C17.9883 20.25 16.9766 19.9688 15.8203 19.3359C15.0977 18.9844 14.2305 18.3516 13.0742 17.5078L12.3516 16.875C6.49805 12.7969 2.8125 10.125 1.22266 8.92969C1.07812 8.85938 0.861328 8.85938 0.716797 8.92969C0.572266 9 0.5 9.14062 0.5 9.28125V23.625C0.5 24.6094 0.789062 25.3828 1.51172 26.0156C2.16211 26.7188 2.95703 27 3.96875 27H34.0312C34.9707 27 35.7656 26.7188 36.4883 26.0156C37.1387 25.3828 37.5 24.6094 37.5 23.625V9.28125C37.5 9.14062 37.3555 9 37.2109 8.85938C37.0664 8.78906 36.9219 8.78906 36.7773 8.92969ZM19 18C18.3496 18 17.5547 17.7188 16.6875 17.1562C16.1094 16.875 15.3867 16.3828 14.4473 15.6094L13.7246 15.1172C7.79883 10.8984 3.75195 8.01562 1.65625 6.39844L1.15039 6.04688C0.716797 5.76562 0.5 5.27344 0.5 4.71094V3.375C0.5 2.46094 0.789062 1.6875 1.51172 0.984375C2.16211 0.351562 2.95703 0 3.96875 0H34.0312C34.9707 0 35.7656 0.351562 36.4883 0.984375C37.1387 1.6875 37.5 2.46094 37.5 3.375V4.71094C37.5 5.27344 37.2832 5.76562 36.8496 6.04688L36.4883 6.32812C34.3926 7.94531 30.3457 10.8984 24.2754 15.1172L23.5527 15.6094C22.541 16.3828 21.8184 16.875 21.3125 17.1562C20.373 17.7188 19.5781 18 19 18Z" fill="currentColor"/></svg>',envelope:'<svg width="33" height="25" viewBox="0 0 33 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.9062 0.25C30.7441 0.25 31.4531 0.572266 32.0977 1.15234C32.6777 1.79688 33 2.50586 33 3.34375V21.9062C33 22.8086 32.6777 23.5176 32.0977 24.0977C31.4531 24.7422 30.7441 25 29.9062 25H3.09375C2.19141 25 1.48242 24.7422 0.902344 24.0977C0.257812 23.5176 0 22.8086 0 21.9062V3.34375C0 2.50586 0.257812 1.79688 0.902344 1.15234C1.48242 0.572266 2.19141 0.25 3.09375 0.25H29.9062ZM3.09375 2.3125C2.77148 2.3125 2.51367 2.44141 2.32031 2.63477C2.12695 2.82812 2.0625 3.08594 2.0625 3.34375V5.98633C3.54492 7.27539 6.76758 9.91797 11.7949 13.8496L12.375 14.3652C13.2129 15.1387 13.9219 15.6543 14.4375 15.9121C15.2109 16.4922 15.9199 16.75 16.5 16.75C17.0156 16.75 17.7246 16.4922 18.5625 15.9121C19.0137 15.6543 19.6582 15.1387 20.5605 14.3652L21.2051 13.8496C26.168 9.91797 29.3906 7.27539 30.9375 5.98633V3.34375C30.9375 3.08594 30.8086 2.82812 30.6152 2.63477C30.4219 2.44141 30.1641 2.3125 29.9062 2.3125H3.09375ZM29.9062 22.9375C30.1641 22.9375 30.4219 22.873 30.6152 22.6797C30.8086 22.4863 30.9375 22.2285 30.9375 21.9062V8.69336C29.3906 9.91797 26.6191 12.1738 22.4941 15.4609L21.8496 15.9766C20.8184 16.8789 19.9805 17.459 19.4004 17.8457C18.3047 18.4902 17.3379 18.8125 16.5 18.8125C15.5977 18.8125 14.6309 18.4902 13.5996 17.8457C12.9551 17.459 12.1172 16.8789 11.1504 15.9766L10.5059 15.4609C6.38086 12.1738 3.54492 9.91797 2.0625 8.69336V21.9062C2.0625 22.2285 2.12695 22.4863 2.32031 22.6797C2.51367 22.873 2.77148 22.9375 3.09375 22.9375H29.9062Z" fill="#FEE96C"/></svg>',chevronRight:'<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.66259 8.25581L12.7505 4.73081L7.66259 1.20581" stroke="currentColor" stroke-width="1.5"/><path d="M0.749991 8.25581L5.83789 4.73081L0.749991 1.20581" stroke="currentColor" stroke-width="1.5"/></svg>',quote:'<svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.5505 29.5141H32.8225L38.8005 0.600098H31.1145L23.5505 29.5141ZM0.980469 29.5141H10.2525L16.2305 0.600098H8.54447L0.980469 29.5141Z" fill="currentColor"/></svg>',exclamationTriangle:'<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.6709 14.8881C15.0044 14.8881 15.2916 14.7815 15.5325 14.5684C15.7734 14.3553 15.9217 14.0959 15.9773 13.7901C16.0329 13.4844 15.9865 13.1833 15.8383 12.8868L9.1674 1.32394C9.00063 1.02746 8.76437 0.828256 8.45862 0.72634C8.15287 0.624423 7.84713 0.624423 7.54138 0.72634C7.23563 0.828256 6.99937 1.02746 6.8326 1.32394L0.161718 12.8868C0.0134766 13.1833 -0.032849 13.4844 0.0227416 13.7901C0.0783323 14.0959 0.226574 14.3553 0.467467 14.5684C0.70836 14.7815 0.995578 14.8881 1.32912 14.8881H14.6709ZM14.6706 13.9987H1.32887C1.1621 13.9987 1.03702 13.9246 0.953631 13.7763C0.870245 13.6281 0.865612 13.4799 0.939733 13.3316L7.61061 1.76876C7.70326 1.62051 7.83297 1.54639 7.99975 1.54639C8.16652 1.54639 8.29623 1.62051 8.38888 1.76876L15.0598 13.3316C15.1339 13.4799 15.1292 13.6281 15.0459 13.7763C14.9625 13.9246 14.8374 13.9987 14.6706 13.9987ZM8.00028 12.5532C8.22264 12.5532 8.40795 12.4791 8.55619 12.3308C8.70443 12.1826 8.77855 11.9973 8.77855 11.7749C8.77855 11.5526 8.70443 11.3673 8.55619 11.219C8.42912 11.092 8.27483 11.0194 8.09331 11.0012L8.00028 10.9967C7.77792 10.9967 7.59262 11.0708 7.44438 11.219C7.29613 11.3673 7.22201 11.5526 7.22201 11.7749C7.22201 11.9973 7.29613 12.1826 7.44438 12.3308C7.59262 12.4791 7.77792 12.5532 8.00028 12.5532ZM8.11144 10.4408C8.20409 10.4408 8.28284 10.4084 8.3477 10.3436C8.41255 10.2787 8.44498 10.1999 8.44498 10.1073L8.63955 5.43768C8.65808 5.34503 8.63492 5.26628 8.57006 5.20142C8.5052 5.13656 8.41719 5.10414 8.306 5.10414H7.69451C7.58333 5.10414 7.49531 5.13656 7.43045 5.20142C7.3656 5.26628 7.34243 5.34503 7.36096 5.43768L7.55553 10.1351C7.55553 10.2092 7.58796 10.2787 7.65281 10.3436C7.71767 10.4084 7.79642 10.4408 7.88907 10.4408H8.11144Z" fill="currentColor"/></svg>',dropdown:'<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L5.5 6L10 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',statusInfo:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.6249C14.0937 23.6249 16.0312 23.1015 17.8125 22.0546C19.5937 21.0078 21.0078 19.5937 22.0546 17.8125C23.1015 16.0312 23.6249 14.0937 23.6249 12C23.6249 9.90623 23.1015 7.96873 22.0546 6.18749C21.0078 4.40624 19.5937 2.99218 17.8125 1.94531C16.0312 0.898437 14.0937 0.375 12 0.375C9.90623 0.375 7.96873 0.898437 6.18749 1.94531C4.40624 2.99218 2.99218 4.40624 1.94531 6.18749C0.898437 7.96873 0.375 9.90623 0.375 12C0.375 14.0937 0.898437 16.0312 1.94531 17.8125C2.99218 19.5937 4.40624 21.0078 6.18749 22.0546C7.96873 23.1015 9.90623 23.6249 12 23.6249ZM12 22.1249C10.1562 22.1249 8.46092 21.6718 6.91405 20.7656C5.36718 19.8593 4.14062 18.6328 3.23437 17.0859C2.32812 15.539 1.875 13.8437 1.875 12C1.875 10.1562 2.32812 8.46092 3.23437 6.91405C4.14062 5.36718 5.36718 4.14062 6.91405 3.23437C8.46092 2.32812 10.1562 1.875 12 1.875C13.8125 1.875 15.5 2.32812 17.0625 3.23437C18.625 4.14062 19.8593 5.36718 20.7656 6.91405C21.6718 8.46092 22.1249 10.1562 22.1249 12C22.1249 13.8437 21.6718 15.539 20.7656 17.0859C19.8593 18.6328 18.6328 19.8593 17.0859 20.7656C15.539 21.6718 13.8437 22.1249 12 22.1249ZM13.6875 18C13.8437 18 13.9765 17.9453 14.0859 17.8359C14.1953 17.7265 14.25 17.5937 14.25 17.4375V17.0625C14.25 16.9062 14.1953 16.7734 14.0859 16.664C13.9765 16.5546 13.8437 16.5 13.6875 16.5H13.125V9.93748C13.125 9.78123 13.0703 9.64842 12.9609 9.53904C12.8515 9.42967 12.7187 9.37498 12.5625 9.37498H10.3125C10.1562 9.37498 10.0234 9.42967 9.91404 9.53904C9.80467 9.64842 9.74998 9.78123 9.74998 9.93748V10.3125C9.74998 10.4687 9.80467 10.6015 9.91404 10.7109C10.0234 10.8203 10.1562 10.875 10.3125 10.875H10.875V16.5H10.3125C10.1562 16.5 10.0234 16.5546 9.91404 16.664C9.80467 16.7734 9.74998 16.9062 9.74998 17.0625V17.4375C9.74998 17.5937 9.80467 17.7265 9.91404 17.8359C10.0234 17.9453 10.1562 18 10.3125 18H13.6875ZM12 8.24998C12.4062 8.24998 12.7578 8.10154 13.0547 7.80467C13.3515 7.5078 13.5 7.15623 13.5 6.74998C13.5 6.34374 13.3515 5.99217 13.0547 5.6953C12.7578 5.39843 12.4062 5.24999 12 5.24999C11.5937 5.24999 11.2422 5.39843 10.9453 5.6953C10.6484 5.99217 10.5 6.34374 10.5 6.74998C10.5 7.15623 10.6484 7.5078 10.9453 7.80467C11.2422 8.10154 11.5937 8.24998 12 8.24998Z" fill="currentColor"/></svg>',statusError:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.6249C14.0937 23.6249 16.0312 23.1015 17.8125 22.0546C19.5937 21.0078 21.0078 19.5937 22.0546 17.8125C23.1015 16.0312 23.6249 14.0937 23.6249 12C23.6249 9.90623 23.1015 7.96873 22.0546 6.18749C21.0078 4.40624 19.5937 2.99218 17.8125 1.94531C16.0312 0.898437 14.0937 0.375 12 0.375C9.90623 0.375 7.96873 0.898437 6.18749 1.94531C4.40624 2.99218 2.99218 4.40624 1.94531 6.18749C0.898437 7.96873 0.375 9.90623 0.375 12C0.375 14.0937 0.898437 16.0312 1.94531 17.8125C2.99218 19.5937 4.40624 21.0078 6.18749 22.0546C7.96873 23.1015 9.90623 23.6249 12 23.6249ZM12 22.1249C10.1562 22.1249 8.46092 21.6718 6.91405 20.7656C5.36718 19.8593 4.14062 18.6328 3.23437 17.0859C2.32812 15.539 1.875 13.8437 1.875 12C1.875 10.1562 2.32812 8.46092 3.23437 6.91405C4.14062 5.36718 5.36718 4.14062 6.91405 3.23437C8.46092 2.32812 10.1562 1.875 12 1.875C13.8125 1.875 15.5 2.32812 17.0625 3.23437C18.625 4.14062 19.8593 5.36718 20.7656 6.91405C21.6718 8.46092 22.1249 10.1562 22.1249 12C22.1249 13.8437 21.6718 15.539 20.7656 17.0859C19.8593 18.6328 18.6328 19.8593 17.0859 20.7656C15.539 21.6718 13.8437 22.1249 12 22.1249ZM12 18.5625C12.375 18.5625 12.6875 18.4375 12.9375 18.1875C13.1875 17.9375 13.3125 17.625 13.3125 17.25C13.3125 16.875 13.1875 16.5625 12.9375 16.3125C12.6875 16.0625 12.375 15.9375 12 15.9375C11.625 15.9375 11.3125 16.0625 11.0625 16.3125C10.8125 16.5625 10.6875 16.875 10.6875 17.25C10.6875 17.625 10.8125 17.9375 11.0625 18.1875C11.3125 18.4375 11.625 18.5625 12 18.5625ZM12.1875 15C12.3437 15 12.4765 14.9453 12.5859 14.8359C12.6953 14.7265 12.75 14.5937 12.75 14.4375L13.0781 6.56249C13.1093 6.40624 13.0703 6.27342 12.9609 6.16405C12.8515 6.05467 12.7031 5.99999 12.5156 5.99999H11.4843C11.2968 5.99999 11.1484 6.05467 11.039 6.16405C10.9297 6.27342 10.8906 6.40624 10.9219 6.56249L11.25 14.4843C11.25 14.6093 11.3047 14.7265 11.414 14.8359C11.5234 14.9453 11.6562 15 11.8125 15H12.1875Z" fill="currentColor"/></svg>',statusWarning:'<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.9906 21.342C22.4906 21.342 22.9211 21.1823 23.2822 20.8629C23.6433 20.5435 23.8655 20.1546 23.9488 19.6963C24.0321 19.238 23.9627 18.7867 23.7405 18.3423L13.7413 1.01033C13.4913 0.565926 13.1372 0.26734 12.6789 0.114574C12.2206 -0.0381914 11.7623 -0.0381914 11.304 0.114574C10.8457 0.26734 10.4916 0.565926 10.2416 1.01033L0.242404 18.3423C0.0202006 18.7867 -0.0492384 19.238 0.0340881 19.6963C0.117415 20.1546 0.339619 20.5435 0.7007 20.8629C1.06178 21.1823 1.4923 21.342 1.99226 21.342H21.9906ZM21.9906 20.0088H1.99226C1.74228 20.0088 1.5548 19.8977 1.42981 19.6755C1.30482 19.4533 1.29787 19.2311 1.40898 19.0089L11.4082 1.67695C11.547 1.45474 11.7415 1.34364 11.9914 1.34364C12.2414 1.34364 12.4359 1.45474 12.5747 1.67695L22.5739 19.0089C22.685 19.2311 22.6781 19.4533 22.5531 19.6755C22.4281 19.8977 22.2406 20.0088 21.9906 20.0088ZM11.9914 17.8423C12.3248 17.8423 12.6025 17.7312 12.8247 17.509C13.0469 17.2868 13.158 17.009 13.158 16.6757C13.158 16.3424 13.0469 16.0647 12.8247 15.8425C12.6342 15.652 12.403 15.5432 12.1309 15.516L11.9914 15.5092C11.6581 15.5092 11.3804 15.6203 11.1582 15.8425C10.936 16.0647 10.8249 16.3424 10.8249 16.6757C10.8249 17.009 10.936 17.2868 11.1582 17.509C11.3804 17.7312 11.6581 17.8423 11.9914 17.8423ZM12.1581 14.6759C12.297 14.6759 12.415 14.6273 12.5122 14.5301C12.6095 14.4328 12.6581 14.3148 12.6581 14.1759L12.9497 7.1765C12.9775 7.03762 12.9428 6.91957 12.8455 6.82236C12.7483 6.72515 12.6164 6.67654 12.4497 6.67654H11.5331C11.3665 6.67654 11.2346 6.72515 11.1373 6.82236C11.0401 6.91957 11.0054 7.03762 11.0332 7.1765L11.3248 14.2176C11.3248 14.3287 11.3734 14.4328 11.4707 14.5301C11.5679 14.6273 11.6859 14.6759 11.8248 14.6759H12.1581Z" fill="currentColor"/></svg>',statusOk:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.6249C14.0937 23.6249 16.0312 23.1015 17.8125 22.0546C19.5937 21.0078 21.0078 19.5937 22.0546 17.8125C23.1015 16.0312 23.6249 14.0937 23.6249 12C23.6249 9.90623 23.1015 7.96873 22.0546 6.18749C21.0078 4.40624 19.5937 2.99218 17.8125 1.94531C16.0312 0.898437 14.0937 0.375 12 0.375C9.90623 0.375 7.96873 0.898437 6.18749 1.94531C4.40624 2.99218 2.99218 4.40624 1.94531 6.18749C0.898437 7.96873 0.375 9.90623 0.375 12C0.375 14.0937 0.898437 16.0312 1.94531 17.8125C2.99218 19.5937 4.40624 21.0078 6.18749 22.0546C7.96873 23.1015 9.90623 23.6249 12 23.6249ZM12 22.1249C10.1875 22.1249 8.49998 21.6718 6.93748 20.7656C5.37499 19.8593 4.14062 18.6328 3.23437 17.0859C2.32812 15.539 1.875 13.8515 1.875 12.0234C1.875 10.1953 2.32812 8.49998 3.23437 6.93748C4.14062 5.37499 5.36718 4.14062 6.91405 3.23437C8.46092 2.32812 10.1484 1.875 11.9765 1.875C13.8047 1.875 15.5 2.32812 17.0625 3.23437C18.625 4.14062 19.8593 5.36718 20.7656 6.91405C21.6718 8.46092 22.1249 10.1484 22.1249 11.9765C22.1249 13.8047 21.6718 15.5 20.7656 17.0625C19.8593 18.625 18.6328 19.8593 17.0859 20.7656C15.539 21.6718 13.8437 22.1249 12 22.1249ZM9.79685 17.8125C9.9531 17.8125 10.0781 17.75 10.1719 17.625L18.6562 9.23435C18.75 9.1406 18.7968 9.0156 18.7968 8.85935C18.7968 8.7031 18.75 8.56248 18.6562 8.43748L18.2343 8.06248C18.1406 7.93748 18.0156 7.87498 17.8593 7.87498C17.7031 7.87498 17.5625 7.92186 17.4375 8.01561L9.79685 15.6562L6.56249 12.375C6.43749 12.2812 6.29686 12.2343 6.14061 12.2343C5.98436 12.2343 5.85936 12.2812 5.76561 12.375L5.34374 12.75C5.24999 12.875 5.20311 13.0156 5.20311 13.1718C5.20311 13.3281 5.24999 13.4531 5.34374 13.5468L9.37498 17.625C9.49998 17.75 9.6406 17.8125 9.79685 17.8125Z" fill="currentColor"/></svg>',atmosLogo:'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 219 98" style="enable-background:new 0 0 219 98" xml:space="preserve"><style>.st0{fill:currentColor}</style><path class="st0" d="m67.8 73-.1 2.1c0 1.9.7 4.1 1.8 5.8 1.2 1.7 3.2 2.6 5.3 2.6 2.8 0 4.8-1.4 6.1-3.8l1.4.7c-1.5 3.3-4.9 5-8.4 5-2.8 0-5.2-.7-7.2-2.7s-3.1-4.9-3.1-7.7c0-6 3.8-10.3 9.9-10.4 5 0 9 3.3 8.9 8.5H67.8m10.1-1.8c0-3.1-1.9-5.1-4.8-5.1s-4.9 2.4-5.2 5.1h10zM109.4 79.7c0 2.2.4 3.8 2.9 4h.5v1.2h-11v-1.2h.6c2.6-.2 3-1.7 3-4v-8.5c0-1.1-.1-2.1-.7-3-.6-1-1.8-1.5-2.9-1.5-2.7 0-5.4 1.6-7.4 3.3v9.7c0 2.3.4 3.9 3 4h.6v1.2H86.9v-1.2h.5c2.7-.1 3.2-1.4 3.2-4v-8.6c0-2.3-.4-3.9-3-4h-.7v-1.2l6.3-.9h1.3v3.3c2.5-2.3 5.4-3.7 8.8-3.7 1.6 0 3.3.6 4.5 1.7 1.4 1.2 1.6 2.6 1.6 4.3v9.1zM121 73l-.1 2.1c0 1.9.7 4.1 1.8 5.8 1.2 1.7 3.2 2.6 5.3 2.6 2.8 0 4.8-1.4 6.1-3.8l1.4.7c-1.5 3.3-4.9 5-8.4 5-2.8 0-5.2-.7-7.2-2.7s-3.1-4.9-3.1-7.7c0-6 3.8-10.3 9.9-10.4 5 0 9 3.3 8.9 8.5H121m10.1-1.8c0-3.1-2-5.1-4.8-5.1-2.9 0-4.9 2.4-5.2 5.1h10zM149.1 79.7c.1 2.4.4 3.9 3.1 4h.7v1.2h-11.4v-1.2h.5c2.7-.2 3.2-1.5 3.2-4v-8.6c0-2.3-.4-3.9-3-4h-.7v-1.2l6.3-.9h1.3v3c1.8-1.9 4.2-3.5 7-3.5 1.4 0 3.1.5 3.1 2.2 0 1.3-1 2.2-2.3 2.2-2 0-2.4-1.4-3.7-1.4-1.4 0-3.1 1.3-4.1 2.3v9.9zM176.4 82.7c3.1.4 6.7.8 6.7 4.7 0 5.7-6.7 6.5-11.1 6.5-3.4 0-10.1-.5-10.1-4.9 0-2.4 2-3 3.9-3.6v-.1c-1.6-.4-3-1.5-3-3.4 0-2.3 2-3.9 4.1-4.2-2.1-1.2-3.3-3.4-3.3-5.9.2-4.6 4.1-7.3 8.3-7.3 1.3 0 2.6.3 3.8.7 1-1.9 2.5-3.3 4.8-3.3 1.1 0 2.4.5 2.4 1.8 0 .8-.6 1.6-1.5 1.6s-1.7-.7-2.6-.7c-.9 0-1.3.6-1.8 1.2 2.1 1.5 3.4 3.5 3.4 6.2 0 1.9-1 4-2.5 5.2-1.7 1.4-3.9 1.7-6 1.7-1.3 0-2.5-.2-3.7-.7-.8.3-2 1.2-2 2.2 0 1.4 2.3 1.6 3.3 1.7l6.9.6m-9.1 3c-1.6.5-3 1.2-3 2.9 0 3.6 5.2 3.9 7.8 3.9 2.6 0 8-.2 8-3.8 0-2.3-3-2.2-4.7-2.4l-8.1-.6zm.3-14c0 3.1.8 5.7 4.5 5.7 1.4 0 2.9-.7 3.6-1.9.5-1 .7-2.7.7-3.9 0-3-.7-5.6-4.3-5.6-3.5 0-4.5 2.8-4.5 5.7M202.9 71.8c.4-1 1-2.6 1-3.6 0-1.6-1.6-1.8-2.8-2V65h9.2v1.2c-2.8.5-3.6 1.8-4.6 4.2l-6.6 15.9c-.7 1.8-1.4 3.5-2.7 4.9-1.4 1.5-3.5 2.6-5.5 2.6-1.5 0-3.7-.7-3.7-2.6 0-1.2 1-2.1 2.2-2.1 1.9 0 1.9 2.2 3.8 2.2 2.1 0 3.4-3.4 4.1-5l.2-.3-7-16.9c-.9-2.2-1.1-2.8-3.7-3.1v-1.2h9.9V66c-.9 0-2.3.3-2.3 1.5 0 .5.2.8.4 1.3l4.8 12.1 3.3-9.1z"/><path class="st0" d="M55 13.1h33.8v13.5H80v30.9H63.8V26.6H55zM105.2 41.4 103 57.5H86.9l6.2-44.4H107l6.7 14.6 6.6-14.6h14l6.2 44.4h-16.1l-2.3-16.1-8.4 16.7zM162.3 12.5c-12.6 0-22.9 10.3-22.9 22.9s10.3 22.9 22.9 22.9c12.6 0 22.9-10.3 22.9-22.9s-10.3-22.9-22.9-22.9m0 30.5c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7M13 29.2 52.1 31l-1.3-3.7L13 29.2zM11.5 33.6l42.2 1.9-1.3-3.7-40.9 1.8zM9.9 38.1l45.4 1.8-1.3-3.7L9.9 38zM15.6 25.9l7.6-21h19.4l7.9 21.7zM10 41.3 4.2 57.5h22.7l5.6-16.6zM55.5 40.6l6.1 16.9H38.8l-5.5-16.6zM192.2 46.4c-3.7 0-6.9-2.5-6.9-2.5v12.8s4 2.3 10.9 2.3c8.1 0 14.8-6.6 14.8-14.6 0-3.2-1-6.1-2.8-8.5 0 0-2-2.8-4.9-4.7-1.1-.8-3.4-2.2-3.4-3.5 0-2 1.5-3.1 3.9-3.1 3.1 0 5.4 1.4 6.2 2.1l-.5-12.7s-1.9-1.4-8.8-1.4c-8.1 0-15.3 6-15.3 14.1 0 4.4 2.2 9.2 7.3 12.7 0 0 2.4 1.8 3.2 3.6.4.8.2 1.4.2 1.4-.6 1.6-1.9 2.1-3.9 2"/><path class="st0" d="M207.5 81.6c0-2.3 1.9-4.2 4.2-4.2 2.4 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.8-4.2-4.2m7.8 0c0-2-1.7-3.6-3.6-3.6-1.9 0-3.6 1.6-3.6 3.6s1.7 3.6 3.6 3.6c2 0 3.6-1.6 3.6-3.6m-1.6 2.3h-.7l-1.4-2.1h-.8v2.1h-.7v-4.6h2c.8 0 1.6.2 1.6 1.2 0 .9-.6 1.2-1.5 1.3l1.5 2.1zm-2.1-2.8c.6 0 1.6.1 1.6-.6 0-.5-.6-.6-1.1-.6h-1.2v1.2h.7z"/></svg>',polygon:'<svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5.83333L0.5 10.8852L0.5 0.781518L8 5.83333Z" fill="currentColor"/></svg>',hamburger:'<svg width="26" height="14" viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" width="22" height="2" fill="currentColor"/><rect x="2" y="6" width="24" height="2" fill="currentColor"/><rect y="12" width="26" height="2" fill="currentColor"/></svg>',search:'<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5555 13.3561L20.7349 19.5355C21.5432 20.3177 20.3177 21.5432 19.5355 20.7349L13.3561 14.5555C10.0969 17.215 5.35157 16.9543 2.40527 13.9819C-0.801758 10.8009 -0.801758 5.58623 2.40527 2.40527C5.58623 -0.801758 10.8009 -0.801758 13.9819 2.40527C16.9543 5.35157 17.215 10.0969 14.5555 13.3561ZM3.60465 3.60465C1.07553 6.13378 1.07553 10.2534 3.60465 12.7825C6.13378 15.3116 10.2534 15.3116 12.7825 12.7825C15.3116 10.2534 15.3116 6.13378 12.7825 3.60465C10.2534 1.07553 6.13378 1.07553 3.60465 3.60465Z" fill="currentColor"/></svg>',close:'<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.0569619 16.9984L17.0015 0.000200853L18 1.00183L1.05543 18.0001L0.0569619 16.9984Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.998233 2.24852e-05L17.9428 16.9982L16.9443 17.9999L-0.000235181 1.00165L0.998233 2.24852e-05Z" fill="currentColor"/></svg>',bell:'<svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.5742 19.6758C24.0488 20.2031 24.3125 20.8359 24.3125 21.5215C24.3125 22.207 24.0488 22.7871 23.5742 23.2617C23.0996 23.7891 22.5195 24 21.7812 24H15.875C15.875 24.9492 15.5059 25.7402 14.873 26.373C14.1875 27.0586 13.3965 27.375 12.5 27.375C11.5508 27.375 10.7598 27.0586 10.127 26.373C9.44141 25.7402 9.125 24.9492 9.125 24H3.21875C2.48047 24 1.84766 23.7891 1.37305 23.2617C0.898438 22.7871 0.6875 22.207 0.6875 21.5215C0.6875 20.8359 0.951172 20.2031 1.47852 19.6758C2.00586 19.1484 2.375 18.6738 2.63867 18.252C3.06055 17.6191 3.37695 16.7754 3.64062 15.7734C3.9043 14.6133 4.0625 13.1367 4.0625 11.3438C4.0625 9.97266 4.32617 8.70703 4.95898 7.49414C5.5918 6.33398 6.43555 5.33203 7.49023 4.54102C8.54492 3.75 9.75781 3.22266 11.1289 3.01172C10.918 2.74805 10.8125 2.43164 10.8125 2.0625C10.8125 1.64062 10.9707 1.21875 11.2871 0.902344C11.6035 0.585938 12.0254 0.375 12.5 0.375C12.9219 0.375 13.3438 0.585938 13.6602 0.902344C13.9766 1.21875 14.1875 1.64062 14.1875 2.0625C14.1875 2.43164 14.082 2.74805 13.8711 3.01172C15.1895 3.22266 16.4023 3.75 17.457 4.54102C18.5117 5.33203 19.3555 6.33398 19.9883 7.49414C20.6211 8.70703 20.9375 9.97266 20.9375 11.3438C20.9375 13.1367 21.043 14.6133 21.3594 15.7734C21.5703 16.7754 21.9395 17.6191 22.3613 18.252C22.5723 18.6738 22.9941 19.1484 23.5742 19.6758ZM12.5 25.6875C12.9219 25.6875 13.3438 25.5293 13.6602 25.2129C13.9766 24.8965 14.1875 24.4746 14.1875 24H10.8125C10.8125 24.4746 10.9707 24.8965 11.2871 25.2129C11.6035 25.5293 12.0254 25.6875 12.5 25.6875ZM21.7812 22.3125C22.1504 22.3125 22.4141 22.1543 22.5723 21.7852C22.6777 21.4688 22.625 21.1523 22.3613 20.8887C21.3066 19.834 20.5156 18.7266 20.0938 17.5137C19.5137 16.0371 19.25 13.9805 19.25 11.3438C19.25 10.1309 18.9336 9.02344 18.3535 7.96875C17.7207 6.91406 16.9297 6.12305 15.875 5.49023C14.8203 4.91016 13.7129 4.59375 12.5 4.59375C11.2344 4.59375 10.127 4.91016 9.07227 5.49023C8.01758 6.12305 7.22656 6.91406 6.64648 7.96875C6.01367 9.02344 5.75 10.1309 5.75 11.3438C5.75 13.9805 5.43359 16.0371 4.85352 17.5137C4.43164 18.7266 3.69336 19.834 2.63867 20.8887C2.32227 21.1523 2.26953 21.4688 2.42773 21.7852C2.5332 22.1543 2.79688 22.3125 3.21875 22.3125H21.7812Z" fill="currentColor"/></svg>',question:'<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="49" height="49" rx="9" fill="#FEE96C"/><path d="M22.374 28.8999V28.0825C22.374 26.9019 22.5557 25.9331 22.9189 25.1763C23.2822 24.4093 23.9583 23.6021 24.9473 22.7544C26.3197 21.5939 27.1825 20.721 27.5356 20.1357C27.8989 19.5505 28.0806 18.8441 28.0806 18.0166C28.0806 16.9873 27.7476 16.1951 27.0815 15.6401C26.4256 15.075 25.4771 14.7925 24.2358 14.7925C23.4386 14.7925 22.6616 14.8883 21.9048 15.0801C21.1479 15.2617 20.2801 15.5998 19.3013 16.0942L18.4082 14.0508C20.3154 13.0518 22.3084 12.5522 24.3872 12.5522C26.3146 12.5522 27.8132 13.0265 28.8828 13.9751C29.9525 14.9237 30.4873 16.2607 30.4873 17.9863C30.4873 18.723 30.3864 19.3739 30.1846 19.939C29.9928 20.494 29.7052 21.0238 29.3218 21.5283C28.9383 22.0228 28.1108 22.825 26.8394 23.9351C25.8201 24.8029 25.144 25.5244 24.811 26.0996C24.4881 26.6748 24.3267 27.4417 24.3267 28.4004V28.8999H22.374ZM21.6323 33.3955C21.6323 32.0231 22.2378 31.3369 23.4487 31.3369C24.034 31.3369 24.4831 31.5135 24.7959 31.8667C25.1188 32.2199 25.2803 32.7295 25.2803 33.3955C25.2803 34.0413 25.1188 34.5459 24.7959 34.9092C24.473 35.2624 24.0239 35.439 23.4487 35.439C22.924 35.439 22.4901 35.2826 22.147 34.9697C21.8039 34.6468 21.6323 34.1221 21.6323 33.3955Z" fill="black"/></svg>',homeowners:'<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9775 0.588005C12.2337 0.342133 12.6366 0.336811 12.8992 0.575832L23.3879 10.1222C24.3002 10.9525 23.7128 12.4706 22.4792 12.4706H6.22363C5.85084 12.4706 5.54864 12.7728 5.54864 13.1456V19.975C5.54864 20.3478 5.85084 20.65 6.22364 20.65H18.4861C18.8589 20.65 19.1611 20.3478 19.1611 19.975V14.7736C19.1611 14.4008 19.4633 14.0986 19.8361 14.0986C20.2089 14.0986 20.5111 14.4008 20.5111 14.7736V19.975C20.5111 21.0934 19.6045 22 18.4861 22H6.22364C5.10526 22 4.19863 21.0934 4.19863 19.975V13.1456C4.19863 12.0272 5.10526 11.1206 6.22363 11.1206H22.4792L12.4571 1.99885L1.74101 12.2826C1.47203 12.5408 1.04474 12.532 0.786614 12.263C0.528492 11.994 0.537288 11.5667 0.806261 11.3086L11.9775 0.588005Z" fill="currentColor"/><path d="M10.7236 16.6C10.7236 16.2272 11.0258 15.925 11.3986 15.925H13.4236C13.7964 15.925 14.0986 16.2272 14.0986 16.6V20.65C14.0986 21.0228 13.7964 21.325 13.4236 21.325H11.3986C11.0258 21.325 10.7236 21.0228 10.7236 20.65V16.6Z" fill="currentColor"/></svg>',commercialManagers:'<svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.2388 1.1064C11.2388 0.716345 11.555 0.400146 11.9451 0.400146H27.0387C27.4287 0.400146 27.7449 0.716345 27.7449 1.1064V22.2939C27.7449 22.6839 27.4287 23.0001 27.0387 23.0001H15.1737C14.7836 23.0001 14.4674 22.6839 14.4674 22.2939C14.4674 21.9038 14.7836 21.5876 15.1737 21.5876H26.3324V1.81265H12.6513V22.2939C12.6513 22.6839 12.3351 23.0001 11.9451 23.0001H0.907422C0.517371 23.0001 0.201172 22.6839 0.201172 22.2939V8.40045C0.201172 8.0104 0.517371 7.6942 0.907422 7.6942H8.71653C9.10658 7.6942 9.42278 8.0104 9.42278 8.40045C9.42278 8.79051 9.10658 9.1067 8.71653 9.1067H1.61367V21.5876H11.2388V1.1064Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.73242 13.1126C3.73242 12.7226 4.04862 12.4064 4.43867 12.4064H7.96992C8.35997 12.4064 8.67617 12.7226 8.67617 13.1126C8.67617 13.5027 8.35997 13.8189 7.96992 13.8189H4.43867C4.04862 13.8189 3.73242 13.5027 3.73242 13.1126Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9152 7.46265C15.9152 7.0726 16.2314 6.7564 16.6215 6.7564L22.2715 6.7564C22.6615 6.7564 22.9777 7.0726 22.9777 7.46265C22.9777 7.8527 22.6615 8.1689 22.2715 8.1689L16.6215 8.1689C16.2314 8.1689 15.9152 7.8527 15.9152 7.46265Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.73242 16.997C3.73242 16.607 4.04862 16.2908 4.43867 16.2908H7.96992C8.35997 16.2908 8.67617 16.607 8.67617 16.997C8.67617 17.3871 8.35997 17.7033 7.96992 17.7033H4.43867C4.04862 17.7033 3.73242 17.3871 3.73242 16.997Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9152 11.347C15.9152 10.957 16.2314 10.6408 16.6215 10.6408H22.2715C22.6615 10.6408 22.9777 10.957 22.9777 11.347C22.9777 11.7371 22.6615 12.0533 22.2715 12.0533H16.6215C16.2314 12.0533 15.9152 11.7371 15.9152 11.347Z" fill="currentColor"/><path d="M17.8574 17.3501C17.8574 16.9601 18.1736 16.6439 18.5637 16.6439H20.6824C21.0725 16.6439 21.3887 16.9601 21.3887 17.3501V21.5876C21.3887 21.9777 21.0725 22.2939 20.6824 22.2939H18.5637C18.1736 22.2939 17.8574 21.9777 17.8574 21.5876V17.3501Z" fill="currentColor"/></svg>',buildersDevelopers:'<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.86676 3.36644C7.05897 3.65553 6.98044 4.04569 6.69135 4.2379C4.35126 5.7938 3.20047 8.15608 3.20047 11.2573C3.20047 11.6045 2.91905 11.8859 2.5719 11.8859C2.22475 11.8859 1.94333 11.6045 1.94333 11.2573C1.94333 7.79952 3.25436 5.01346 5.99531 3.19103C6.28439 2.99883 6.67455 3.07736 6.86676 3.36644ZM17.1342 3.36644C17.3264 3.07736 17.7166 2.99883 18.0056 3.19103C20.7466 5.01346 22.0576 7.79952 22.0576 11.2573C22.0576 11.6045 21.7762 11.8859 21.429 11.8859C21.0819 11.8859 20.8005 11.6045 20.8005 11.2573C20.8005 8.15608 19.6497 5.7938 17.3096 4.2379C17.0205 4.04569 16.942 3.65553 17.1342 3.36644Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.39084 0.464917C8.51003 0.332762 8.67965 0.257324 8.85761 0.257324H15.1433C15.3213 0.257324 15.4909 0.332762 15.6101 0.464917C15.7293 0.597072 15.7869 0.773557 15.7686 0.950575L14.8257 10.0649C14.79 10.4102 14.4811 10.6611 14.1358 10.6254C13.7905 10.5897 13.5395 10.2808 13.5752 9.9355L14.4464 1.51447H9.55457L10.4257 9.9355C10.4614 10.2808 10.2105 10.5897 9.86515 10.6254C9.51984 10.6611 9.21096 10.4102 9.17524 10.0649L8.23238 0.950575C8.21407 0.773557 8.27165 0.597072 8.39084 0.464917Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.6243 12.8584C22.7979 12.6359 23.9433 13.5239 23.9433 14.7532V14.9064C23.9433 15.5953 23.5623 16.2619 22.8802 16.5499C21.3781 17.1839 17.6105 18.4859 12.0005 18.4859C6.39048 18.4859 2.62288 17.1839 1.12076 16.5499C0.438601 16.2619 0.0576172 15.5953 0.0576172 14.9064V14.7532C0.0576172 13.5239 1.20307 12.6359 2.37664 12.8584C4.31687 13.2263 7.88805 13.7716 12.0005 13.7716C16.1129 13.7716 19.6841 13.2263 21.6243 12.8584ZM22.6862 14.7532C22.6862 14.3467 22.292 14.0113 21.8585 14.0935C19.8705 14.4705 16.2167 15.0288 12.0005 15.0288C7.78429 15.0288 4.13041 14.4705 2.14243 14.0935C1.70891 14.0113 1.31476 14.3467 1.31476 14.7532V14.9064C1.31476 15.1425 1.43967 15.3199 1.60966 15.3917C2.98641 15.9728 6.58759 17.2288 12.0005 17.2288C17.4134 17.2288 21.0145 15.9728 22.3913 15.3917C22.5613 15.3199 22.6862 15.1425 22.6862 14.9064V14.7532Z" fill="currentColor"/></svg>',firstResponders:'<svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.28356 0.828767C9.28356 0.481616 9.56499 0.200195 9.91214 0.200195H19.9693C20.3164 0.200195 20.5978 0.481616 20.5978 0.828767C20.5978 1.17592 20.3164 1.45734 19.9693 1.45734H10.5407V9.0002C10.5407 9.34735 10.2593 9.62877 9.91214 9.62877H1.42643C1.21673 9.62877 1.02084 9.5242 0.904153 9.34996C0.787468 9.17572 0.765357 8.95477 0.845199 8.76087L3.0452 3.41801C3.14218 3.18248 3.37171 3.02877 3.62642 3.02877H7.08357C7.43072 3.02877 7.71214 3.31019 7.71214 3.65734C7.71214 4.00449 7.43072 4.28591 7.08357 4.28591H4.04737L2.36502 8.37163H9.28356V0.828767Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.1693 0.828767C22.1693 0.481616 22.4507 0.200195 22.7978 0.200195H24.6836C25.0307 0.200195 25.3121 0.481616 25.3121 0.828767V9.62877C25.3121 9.97592 25.0307 10.2573 24.6836 10.2573H12.4264C12.0793 10.2573 11.7978 9.97592 11.7978 9.62877C11.7978 9.28162 12.0793 9.0002 12.4264 9.0002H24.055V1.45734H22.7978C22.4507 1.45734 22.1693 1.17592 22.1693 0.828767Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.6836 11.2002C25.0307 11.2002 25.3121 11.4816 25.3121 11.8288V14.3431C25.3121 14.6902 25.0307 14.9716 24.6836 14.9716H22.1693C21.8221 14.9716 21.5407 14.6902 21.5407 14.3431C21.5407 13.9959 21.8221 13.7145 22.1693 13.7145H24.055V11.8288C24.055 11.4816 24.3364 11.2002 24.6836 11.2002Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.42643 10.8859C1.77358 10.8859 2.055 11.1673 2.055 11.5145V13.7145H3.31214C3.65929 13.7145 3.94071 13.9959 3.94071 14.3431C3.94071 14.6902 3.65929 14.9716 3.31214 14.9716H1.42643C1.07928 14.9716 0.797854 14.6902 0.797854 14.3431V11.5145C0.797854 11.1673 1.07928 10.8859 1.42643 10.8859ZM10.2264 14.3431C10.2264 13.9959 10.5078 13.7145 10.855 13.7145H17.455C17.8021 13.7145 18.0836 13.9959 18.0836 14.3431C18.0836 14.6902 17.8021 14.9716 17.455 14.9716H10.855C10.5078 14.9716 10.2264 14.6902 10.2264 14.3431Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.4836 14.6573C22.4836 16.0459 21.3579 17.1716 19.9693 17.1716C18.5807 17.1716 17.455 16.0459 17.455 14.6573C17.455 13.2687 18.5807 12.1431 19.9693 12.1431C21.3579 12.1431 22.4836 13.2687 22.4836 14.6573ZM19.9693 15.9145C20.6636 15.9145 21.2264 15.3516 21.2264 14.6573C21.2264 13.963 20.6636 13.4002 19.9693 13.4002C19.275 13.4002 18.7121 13.963 18.7121 14.6573C18.7121 15.3516 19.275 15.9145 19.9693 15.9145Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.65499 14.6573C8.65499 16.0459 7.52931 17.1716 6.14071 17.1716C4.75211 17.1716 3.62642 16.0459 3.62642 14.6573C3.62642 13.2687 4.75211 12.1431 6.14071 12.1431C7.52931 12.1431 8.65499 13.2687 8.65499 14.6573ZM6.14071 15.9145C6.83501 15.9145 7.39785 15.3516 7.39785 14.6573C7.39785 13.963 6.83501 13.4002 6.14071 13.4002C5.44641 13.4002 4.88357 13.963 4.88357 14.6573C4.88357 15.3516 5.44641 15.9145 6.14071 15.9145Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.3293 2.71448C17.6765 2.71448 17.9579 2.9959 17.9579 3.34305V7.11448C17.9579 7.46163 17.6765 7.74306 17.3293 7.74306C16.9822 7.74306 16.7007 7.46163 16.7007 7.11448V3.34305C16.7007 2.9959 16.9822 2.71448 17.3293 2.71448Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.9693 5.10309C19.9693 5.45024 19.6879 5.73166 19.3407 5.73166L15.5693 5.73166C15.2221 5.73166 14.9407 5.45024 14.9407 5.10309C14.9407 4.75593 15.2221 4.47451 15.5693 4.47451L19.3407 4.47451C19.6879 4.47451 19.9693 4.75593 19.9693 5.10309Z" fill="currentColor"/></svg>',plumbersContractors:'<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2574 2.87469C10.1288 5.00324 9.49573 8.06898 10.2848 10.8128L1.68583 19.4118C0.198453 20.8992 0.213755 23.34 1.71991 24.8461C3.22607 26.3523 5.66687 26.3676 7.15425 24.8802L13.899 17.9687C13.9649 17.9046 14.0174 17.8278 14.0532 17.7429C14.089 17.6579 14.1075 17.5665 14.1075 17.4739C14.1076 17.3814 14.0893 17.2894 14.0536 17.2036C14.0179 17.1177 13.9656 17.0395 13.8998 16.9736C13.8339 16.9077 13.7557 16.8555 13.6698 16.8198C13.5839 16.7841 13.492 16.7658 13.3995 16.7659C13.3069 16.7659 13.2155 16.7844 13.1305 16.8202C13.0456 16.856 12.9688 16.9084 12.9047 16.9744L6.15999 23.886C5.19958 24.8464 3.67431 24.8368 2.70178 23.8643C1.72924 22.8917 1.71968 21.3665 2.68009 20.4061L11.5399 11.5463C11.6332 11.4543 11.6982 11.3374 11.7275 11.2092C11.7567 11.081 11.749 10.9466 11.7052 10.8217C10.8748 8.46514 11.3888 5.73175 13.2516 3.86895C15.0207 2.09988 17.5251 1.63751 19.7798 2.31208L15.4381 6.65376C15.3602 6.73221 15.3024 6.82836 15.2695 6.93422C15.2366 7.04008 15.2296 7.15258 15.249 7.26237L15.7616 10.2296C15.7868 10.3724 15.8557 10.5044 15.9587 10.6074C16.0616 10.7104 16.1936 10.7792 16.3364 10.8045L19.3037 11.3171C19.4135 11.3365 19.526 11.3294 19.6318 11.2965C19.7377 11.2636 19.8338 11.2058 19.9123 11.1279L24.254 6.78624C24.9285 9.04095 24.4662 11.5453 22.6971 13.3144C20.8343 15.1772 18.0732 15.7126 15.7213 14.8839C15.6339 14.8529 15.5415 14.8394 15.4494 14.8441C15.3572 14.8488 15.2671 14.8715 15.1842 14.9112C15.1013 14.9508 15.0272 15.0064 14.9662 15.075C14.9051 15.1435 14.8584 15.2235 14.8285 15.3105C14.7986 15.3975 14.7863 15.4898 14.7921 15.582C14.798 15.6742 14.8219 15.7646 14.8626 15.848C14.9032 15.9314 14.9598 16.0062 15.0292 16.0681C15.0985 16.13 15.1791 16.1778 15.2665 16.2087C18.125 17.2159 21.4444 16.5556 23.6914 14.3087C26.1445 11.8555 26.6377 8.17485 25.1933 5.17888C25.1443 5.07866 25.0722 4.99127 24.9831 4.92395C24.894 4.85664 24.7903 4.81133 24.6808 4.79178C24.5713 4.77223 24.459 4.779 24.3533 4.81154C24.2475 4.84407 24.1514 4.90144 24.0728 4.97887L19.1712 9.88053L17.0462 9.51985L16.6855 7.39488L21.5872 2.49323C21.6646 2.41465 21.722 2.3185 21.7545 2.21277C21.787 2.10704 21.7938 1.99476 21.7743 1.88523C21.7547 1.7757 21.7094 1.67208 21.6421 1.58296C21.5748 1.49383 21.4874 1.42177 21.3872 1.37273C18.3912 -0.0716432 14.7105 0.421535 12.2574 2.87469Z" fill="currentColor"/></svg>',next:'<svg width="18" height="33" viewBox="0 0 18 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.05261 32L16.7197 16.5L1.05262 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>',check:'<svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4492 0.835938C23.5625 0.722656 23.6758 0.609375 23.9023 0.609375C24.0723 0.609375 24.2422 0.722656 24.3555 0.835938L25.0352 1.45898C25.1484 1.62891 25.2051 1.79883 25.2051 1.96875C25.2051 2.19531 25.1484 2.30859 25.0352 2.42188L8.04297 19.4141C7.87305 19.584 7.70312 19.6406 7.5332 19.6406C7.36328 19.6406 7.19336 19.584 7.08008 19.4141L0.339844 12.6738C0.226562 12.5605 0.169922 12.4473 0.169922 12.2207C0.169922 12.0508 0.226562 11.8809 0.339844 11.7109L1.01953 11.0879C1.13281 10.9746 1.24609 10.8613 1.47266 10.8613C1.64258 10.8613 1.8125 10.9746 1.92578 11.0879L7.5332 16.6953L23.4492 0.835938Z" fill="currentColor"/></svg>',ban:'<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 0.078125C16.9922 0.078125 19.3711 0.757812 21.5234 2.00391C23.6758 3.25 25.375 4.94922 26.6211 7.10156C27.8672 9.25391 28.5469 11.6328 28.5469 14.125C28.5469 16.6738 27.8672 18.9961 26.6211 21.1484C25.375 23.3008 23.6758 25.0566 21.5234 26.3027C19.3711 27.5488 16.9922 28.1719 14.5 28.1719C11.9512 28.1719 9.62891 27.5488 7.47656 26.3027C5.32422 25.0566 3.56836 23.3008 2.32227 21.1484C1.07617 18.9961 0.453125 16.6738 0.453125 14.125C0.453125 11.6328 1.07617 9.25391 2.32227 7.10156C3.56836 4.94922 5.32422 3.25 7.47656 2.00391C9.62891 0.757812 11.9512 0.078125 14.5 0.078125ZM5.83398 22.791C7.30664 24.2637 9.0625 25.3398 11.0449 25.9062C13.0273 26.4727 15.0098 26.5859 17.0488 26.1328C19.0879 25.6797 20.9004 24.7734 22.4863 23.4141L5.21094 6.13867C3.85156 7.72461 2.94531 9.53711 2.49219 11.5762C2.03906 13.6152 2.15234 15.5977 2.71875 17.5801C3.28516 19.5625 4.36133 21.3184 5.83398 22.791ZM23.7891 22.1113C25.1484 20.5254 25.998 18.7695 26.4512 16.7305C26.9043 14.6914 26.791 12.709 26.2246 10.7266C25.6582 8.74414 24.582 6.98828 23.1094 5.51562C21.6367 4.04297 19.8809 2.9668 17.8984 2.40039C15.916 1.83398 13.9336 1.7207 11.8945 2.17383C9.85547 2.62695 8.09961 3.47656 6.51367 4.83594L23.7891 22.1113Z" fill="currentColor"/></svg>',bolt:'<svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M11.5352 2.4375H4.85156C4.625 2.4375 4.39844 2.55078 4.22852 2.66406C4.00195 2.83398 3.94531 3.00391 3.94531 3.23047L2.8125 15.0117C2.75586 15.3516 2.8125 15.5781 3.03906 15.748C3.20898 15.9746 3.43555 16.0312 3.71875 16.0312H9.72266L6.94727 26.6797C6.83398 27.0195 6.89062 27.2461 7.06055 27.4727C7.23047 27.6992 7.45703 27.8125 7.79688 27.8125C8.13672 27.8125 8.36328 27.6992 8.58984 27.3594L17.1992 11.9531C17.3125 11.6699 17.3125 11.3867 17.1426 11.0469C16.9727 10.7637 16.7461 10.5938 16.4062 10.5938H10.5156L12.4414 3.57031C12.498 3.34375 12.4414 3.06055 12.2715 2.83398C12.0449 2.60742 11.8184 2.4375 11.5352 2.4375ZM11.5352 0.625C12.4414 0.625 13.1211 1.02148 13.6875 1.70117C14.2539 2.4375 14.3672 3.23047 14.1406 4.02344L12.8945 8.78125H16.4062C17.0859 8.78125 17.6523 9.00781 18.1621 9.4043C18.6152 9.85742 18.9551 10.3672 19.0684 10.9902C19.1816 11.6699 19.125 12.2363 18.7852 12.8027L10.1758 28.209C9.89258 28.6621 9.55273 29.0586 9.15625 29.2852C8.70312 29.5117 8.25 29.625 7.79688 29.625C6.89062 29.625 6.21094 29.2852 5.64453 28.6055C5.07812 27.9258 4.96484 27.1328 5.19141 26.2266L7.34375 17.8438H3.71875C2.92578 17.8438 2.24609 17.5605 1.67969 16.9941C1.11328 16.4277 0.886719 15.6914 1 14.8418L2.13281 3.06055C2.18945 2.38086 2.47266 1.81445 2.98242 1.36133C3.49219 0.908203 4.11523 0.625 4.85156 0.625H11.5352Z" fill="#2C2C2C"/>  </svg>',flashlight:'<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M18.6817 4.58048C18.377 4.27579 17.92 4.27579 17.6153 4.58048L14.3399 7.81779C14.3399 7.81779 14.3399 7.85588 14.3018 7.85588C14.3018 7.89397 14.2637 7.89397 14.2637 7.93205C14.2637 7.97014 14.2256 7.97014 14.2256 8.00822C14.2256 8.04631 14.1875 8.04631 14.1875 8.0844C14.1875 8.12248 14.1495 8.12248 14.1495 8.16057V8.19866L12.5879 13.9116L0.628907 25.8706C0.476563 26.0229 0.400391 26.2134 0.400391 26.4038C0.400391 26.5942 0.476563 26.7847 0.628907 26.937L5.46584 31.7739C5.61818 31.9263 5.80861 32.0025 5.99904 32.0025C6.18947 32.0025 6.3799 31.9263 6.53225 31.7739L18.5294 19.8149L24.2423 18.2534H24.2803C24.3184 18.2534 24.3184 18.2534 24.3565 18.2153C24.3946 18.2153 24.3946 18.1772 24.4327 18.1772C24.4708 18.1772 24.4708 18.1391 24.5089 18.1391C24.547 18.1391 24.547 18.101 24.585 18.101C24.585 18.101 24.6231 18.101 24.6231 18.0629L27.8604 14.8256C28.0128 14.6733 28.089 14.4829 28.089 14.2924C28.089 14.102 28.0128 13.9116 27.8604 13.7592L18.6817 4.58048ZM17.92 18.4057C17.8057 18.4438 17.6915 18.52 17.5772 18.5962L5.99904 30.1743L2.22852 26.4038L13.8067 14.8256C13.8829 14.7495 13.959 14.5971 13.9971 14.4829L15.254 9.83636L22.5665 17.1489L17.92 18.4057ZM24.0518 16.4252L15.9776 8.351L18.1485 6.18009L26.2227 14.2543L24.0518 16.4252Z" fill="#2C2C2C"/>  <path d="M13.2735 18.063L11.1026 20.2339C10.7979 20.5385 10.7979 20.9956 11.1026 21.3003C11.2549 21.4526 11.4453 21.5288 11.6358 21.5288C11.8262 21.5288 12.0166 21.4526 12.169 21.3003L14.3399 19.1294C14.6446 18.8247 14.6446 18.3676 14.3399 18.063C14.0352 17.7583 13.5782 17.7583 13.2735 18.063Z" fill="#2C2C2C"/>  <path d="M24.3185 8.0844C24.4709 8.23675 24.6613 8.31292 24.8517 8.31292C25.0421 8.31292 25.2326 8.23675 25.3849 8.0844L28.6222 4.84709C28.9269 4.5424 28.9269 4.08537 28.6222 3.78068C28.3175 3.47599 27.8605 3.47599 27.5558 3.78068L24.3185 7.018C24.0138 7.2846 24.0138 7.77972 24.3185 8.0844Z" fill="#2C2C2C"/>  <path d="M30.9835 7.93203L27.4796 9.79825C27.0987 9.98868 26.9845 10.4457 27.1749 10.8266C27.3272 11.0932 27.5938 11.2455 27.8605 11.2455C27.9747 11.2455 28.089 11.2074 28.2032 11.1693L31.7071 9.30313C32.088 9.1127 32.2023 8.65567 32.0118 8.27481C31.8214 7.89395 31.3263 7.7416 30.9835 7.93203Z" fill="#2C2C2C"/>  <path d="M21.5383 5.22793C21.6526 5.3041 21.7668 5.3041 21.8811 5.3041C22.1477 5.3041 22.4143 5.15176 22.5666 4.88516L24.4709 1.38124C24.6614 1.00038 24.5471 0.543343 24.1663 0.352913C23.7854 0.162483 23.3284 0.276741 23.1379 0.657602L21.2336 4.16152C21.0432 4.58047 21.1575 5.0375 21.5383 5.22793Z" fill="#2C2C2C"/></svg>',cigar:'<svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M24.6164 22.062H1.66795C1.18736 22.062 0.796875 22.4525 0.796875 22.9331V27.679C0.796875 28.1596 1.18736 28.55 1.66795 28.55H24.5863C25.0669 28.55 25.4574 28.1596 25.4574 27.679V22.9331C25.4875 22.4525 25.097 22.062 24.6164 22.062ZM2.56907 23.8042H20.0507V26.8079H2.56907V23.8042ZM23.7153 26.8079H21.7628V23.8042H23.7153V26.8079Z" fill="#2C2C2C"/>  <path d="M9.47614 11.1885V11.579C9.47614 13.9519 11.4286 15.9043 13.8015 15.9043H17.466C19.058 15.9043 20.3196 17.1959 20.3196 18.7579V20.2297C20.3196 20.7103 20.7101 21.1008 21.1907 21.1008C21.6712 21.1008 22.0617 20.7103 22.0617 20.2297V18.7879C22.0617 16.2347 19.9892 14.1622 17.466 14.1622H13.8015C12.3898 14.1622 11.2183 13.0208 11.2183 11.579V10.3775C11.2183 9.8969 10.8278 9.50642 10.3472 9.50642C8.12447 9.50642 6.32224 7.70419 6.32224 5.48143C6.32224 3.76931 7.40357 2.23741 9.02558 1.69674C9.47614 1.54656 9.71644 1.03593 9.56625 0.585368C9.41607 0.13481 8.90544 -0.105488 8.45488 0.0446984C6.14201 0.855703 4.58008 3.04842 4.58008 5.48143C4.58008 8.39504 6.71272 10.768 9.47614 11.1885Z" fill="#2C2C2C"/>  <path d="M11.8503 3.4387C14.1332 3.4387 15.9654 5.301 15.9654 7.55379C15.9654 8.54502 15.635 9.44614 15.0042 10.1971C14.794 10.4674 14.7339 10.8278 14.8841 11.1282C15.0343 11.4286 15.3347 11.6389 15.6651 11.6389H17.6776C19.1193 11.6389 20.501 12.2096 21.5223 13.2308C22.5436 14.2521 23.1143 15.6338 23.1143 17.0756V20.2595C23.1143 20.7401 23.5048 21.1306 23.9854 21.1306C24.466 21.1306 24.8564 20.7401 24.8564 20.2595V17.0756C24.8564 13.1107 21.6124 9.86666 17.6475 9.86666H17.197C17.4973 9.14577 17.6776 8.33476 17.6776 7.52376C17.6776 4.27974 15.0343 1.6665 11.8203 1.6665C11.3397 1.6665 10.9492 2.05699 10.9492 2.53758C10.9793 3.04821 11.3697 3.4387 11.8503 3.4387Z" fill="#2C2C2C"/>  </svg>',car:'<svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M9.60938 13.8438C9.60938 13.3906 9.26953 12.8242 8.58984 12.1445C7.91016 11.4648 7.34375 11.125 6.89062 11.125C6.38086 11.125 5.92773 11.3516 5.58789 11.6914C5.24805 12.0312 5.07812 12.4844 5.07812 12.9375C5.07812 13.4473 5.24805 13.9004 5.58789 14.2402C5.92773 14.5801 6.38086 14.75 6.89062 14.75H7.11719C7.85352 14.75 8.41992 14.75 8.75977 14.6367C9.32617 14.5234 9.60938 14.2969 9.60938 13.8438ZM24.1094 11.125C24.5625 11.125 25.0156 11.3516 25.3555 11.6914C25.6953 12.0312 25.9219 12.4844 25.9219 12.9375C25.9219 13.4473 25.6953 13.9004 25.3555 14.2402C25.0156 14.5801 24.5625 14.75 24.1094 14.75H23.8828C23.0898 14.75 22.5801 14.75 22.2402 14.6367C21.6738 14.5234 21.3906 14.2969 21.3906 13.8438C21.3906 13.3906 21.6738 12.8242 22.3535 12.1445C23.0332 11.4648 23.5996 11.125 24.1094 11.125ZM29.9434 6.14062C30 5.91406 29.9434 5.74414 29.8301 5.51758C29.7168 5.34766 29.5469 5.23438 29.3203 5.23438H27.5078C27.168 5.23438 26.9414 5.4043 26.8848 5.6875L26.5449 6.59375L24.8457 2.85547C24.4492 2.0625 23.8828 1.43945 23.1465 0.986328C22.4102 0.533203 21.6172 0.25 20.7109 0.25H10.2891C9.38281 0.25 8.5332 0.533203 7.79688 0.986328C7.06055 1.43945 6.49414 2.0625 6.1543 2.85547L4.45508 6.59375L4.11523 5.6875C4.00195 5.4043 3.83203 5.23438 3.49219 5.23438H1.67969C1.45312 5.23438 1.22656 5.34766 1.11328 5.51758C1 5.74414 0.943359 5.91406 1.05664 6.14062L1.50977 7.5C1.56641 7.83984 1.79297 7.95312 2.13281 7.95312H3.77539C3.15234 8.46289 2.69922 9.08594 2.35938 9.76562C2.01953 10.502 1.90625 11.2383 1.90625 12.0312V15.2031C1.90625 16.1094 2.18945 16.8457 2.8125 17.4121V19.7344C2.8125 20.4141 2.98242 20.9238 3.43555 21.377C3.88867 21.8301 4.39844 22 5.07812 22H7.79688C8.41992 22 8.92969 21.8301 9.38281 21.377C9.83594 20.9238 10.0625 20.4141 10.0625 19.7344V18.375H20.9375V19.7344C20.9375 20.4141 21.1074 20.9238 21.5605 21.377C22.0137 21.8301 22.5234 22 23.2031 22H25.9219C26.5449 22 27.0547 21.8301 27.5078 21.377C27.9609 20.9238 28.1875 20.4141 28.1875 19.7344V17.4121C28.7539 16.8457 29.0938 16.1094 29.0938 15.2031V12.0312C29.0938 11.2383 28.9238 10.502 28.584 9.76562C28.2441 9.08594 27.791 8.46289 27.2246 7.95312H28.8672C29.207 7.95312 29.377 7.83984 29.4902 7.5L29.9434 6.14062ZM6.38086 6.65039L7.79688 3.64844C8.02344 3.19531 8.36328 2.79883 8.81641 2.51562C9.26953 2.23242 9.72266 2.0625 10.2891 2.0625H20.7109C21.2207 2.0625 21.7305 2.23242 22.1836 2.51562C22.6367 2.79883 22.9766 3.19531 23.2031 3.64844L24.6191 6.65039C24.2793 6.65039 23.9961 6.59375 23.6562 6.59375H7.34375C7.00391 6.59375 6.66406 6.65039 6.38086 6.65039ZM8.25 18.375V19.7344C8.25 19.8477 8.19336 19.9609 8.08008 20.0742C7.9668 20.1875 7.91016 20.1875 7.79688 20.1875H5.07812C4.96484 20.1875 4.85156 20.1875 4.73828 20.0742C4.625 19.9609 4.625 19.8477 4.625 19.7344V18.3184C4.73828 18.375 5.36133 18.375 6.4375 18.375H8.25ZM26.375 18.3184V19.7344C26.375 19.8477 26.3184 19.9609 26.2051 20.0742C26.0918 20.1875 26.0352 20.1875 25.9219 20.1875H23.2031C23.0898 20.1875 22.9766 20.1875 22.8633 20.0742C22.75 19.9609 22.75 19.8477 22.75 19.7344V18.375H24.5625C25.582 18.375 26.2051 18.375 26.375 18.3184ZM23.6562 8.40625C24.6191 8.40625 25.4688 8.80273 26.2051 9.48242C26.8848 10.2188 27.2812 11.0684 27.2812 12.0312V15.2031C27.2812 15.5996 27.1113 15.9395 26.8848 16.166C26.6016 16.4492 26.2617 16.5625 25.9219 16.5625H5.07812C4.68164 16.5625 4.3418 16.4492 4.11523 16.166C3.83203 15.9395 3.71875 15.5996 3.71875 15.2031V12.0312C3.71875 11.0684 4.05859 10.2188 4.79492 9.48242C5.47461 8.80273 6.32422 8.40625 7.34375 8.40625H23.6562ZM19.6914 12.9375C19.918 12.9375 20.0312 13.1074 20.0312 13.4473C20.0312 13.7871 19.8613 14.127 19.6348 14.3535C19.3516 14.6367 19.0117 14.75 18.6719 14.75H12.3281C11.9316 14.75 11.5918 14.6367 11.3652 14.3535C11.082 14.127 10.9688 13.7871 10.9688 13.4473C10.9688 13.1074 11.082 12.9375 11.3086 12.9375H19.6914Z" fill="#2C2C2C"/>  </svg>',tap:'<svg width="36" height="26" viewBox="0 0 36 26" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M29.0551 13.2613H24.8948V11.6611C24.8948 10.4985 23.9486 9.55233 22.7856 9.55233H20.2379V5.1866H22.3015C23.7318 5.1866 24.8948 4.02321 24.8948 2.59333C24.8948 1.16339 23.7318 0 22.3015 0H13.0534C11.6231 0 10.4601 1.16339 10.4601 2.59333C10.4601 4.02321 11.6231 5.1866 13.0534 5.1866H15.117V9.55233H12.5644C11.407 9.55233 10.4649 10.4985 10.4649 11.6611V13.2613H6.30464C2.82809 13.2613 0 16.0898 0 19.566V25.1828C0 25.5733 0.316269 25.89 0.707201 25.89H6.30464C6.69552 25.89 7.01184 25.5733 7.01184 25.1828V20.2732H10.4649V21.8827C10.4649 23.0457 11.407 23.9918 12.5644 23.9918H22.7856C23.9486 23.9918 24.8948 23.0457 24.8948 21.8827V20.2732H28.3479V25.1828C28.3479 25.5733 28.6642 25.89 29.0551 25.89H34.6525C35.0435 25.89 35.3597 25.5733 35.3597 25.1828V19.566C35.3597 17.883 34.7058 16.3018 33.5172 15.1136C32.3231 13.9192 30.7381 13.2613 29.0551 13.2613ZM11.8745 2.59333C11.8745 1.94345 12.4035 1.4144 13.0534 1.4144H22.3015C22.9514 1.4144 23.4804 1.94345 23.4804 2.59333C23.4804 3.24315 22.9514 3.7722 22.3015 3.7722H19.5307H15.8242H13.0534C12.4035 3.7722 11.8745 3.24315 11.8745 2.59333ZM16.5314 5.1866H18.8235V9.55233H16.5314V5.1866ZM6.30464 18.8588C5.91377 18.8588 5.59744 19.1754 5.59744 19.566V24.4756H1.41435V19.566C1.41435 16.8694 3.60848 14.6757 6.30464 14.6757H10.4649V18.8588H6.30464ZM23.4804 21.8827C23.4804 22.2657 23.1689 22.5774 22.7856 22.5774H12.5644C12.1867 22.5774 11.8793 22.2657 11.8793 21.8827V19.566V13.9685V11.6611C11.8793 11.2782 12.1867 10.9667 12.5644 10.9667H15.8242H19.5307H22.7856C23.1751 10.9667 23.4804 11.2716 23.4804 11.6611V13.9685V19.566V21.8827ZM33.9454 24.4756H29.7623V19.566C29.7623 19.1754 29.446 18.8588 29.0551 18.8588H24.8948V14.6757H29.0551C30.3604 14.6757 31.5897 15.1864 32.5171 16.1136C33.4384 17.0345 33.9454 18.2607 33.9454 19.566V24.4756Z" fill="#2C2C2C"/></svg>',thumbsup:'<svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0234 13.082C20.1953 14.0273 20.0664 14.9297 19.6367 15.7891C19.6797 16.3047 19.6367 16.7773 19.5078 17.293C19.3789 17.8086 19.1641 18.2812 18.9062 18.668C18.8633 19.957 18.4766 20.9023 17.7031 21.5898C16.8438 22.3633 15.6406 22.75 14.0508 22.75H13.1055C11.9023 22.75 10.7852 22.6211 9.79688 22.3633C9.19531 22.2344 8.50781 21.9766 7.64844 21.6328C7.13281 21.4609 6.74609 21.2891 6.53125 21.2031C6.14453 21.1172 5.80078 21.0312 5.45703 21.0312C5.37109 21.332 5.19922 21.5898 4.94141 21.7617C4.68359 21.9766 4.42578 22.0625 4.125 22.0625H1.375C0.988281 22.0625 0.644531 21.9336 0.386719 21.6758C0.128906 21.418 0 21.0742 0 20.6875V10.375C0 10.0312 0.128906 9.6875 0.386719 9.42969C0.644531 9.17188 0.988281 9 1.375 9H5.62891C5.88672 8.74219 6.40234 8.18359 7.08984 7.28125C7.77734 6.37891 8.25 5.77734 8.59375 5.43359C8.67969 5.34766 8.80859 4.91797 8.98047 4.1875C9.23828 3.15625 9.49609 2.42578 9.75391 1.95312C10.1836 1.17969 10.8281 0.75 11.6445 0.75C12.9336 0.75 13.9219 1.13672 14.6523 1.82422C15.3828 2.59766 15.7695 3.75781 15.7695 5.26172C15.7695 5.94922 15.6406 6.59375 15.3828 7.23828H16.9297C17.9609 7.23828 18.8203 7.625 19.5508 8.35547C20.2383 9.12891 20.625 9.98828 20.625 10.9336C20.625 11.707 20.4102 12.3945 20.0234 13.082ZM17.4023 15.4023C17.832 14.9727 18.0469 14.5 18.0469 13.9414C18.0469 13.3828 17.918 12.9102 17.6172 12.5664C17.7891 12.5664 18.0039 12.3945 18.2188 12.0508C18.4336 11.707 18.5625 11.3633 18.5625 10.9336C18.5625 10.5469 18.3906 10.1602 18.0898 9.81641C17.7461 9.47266 17.3594 9.30078 16.9297 9.30078H12.4609C12.4609 8.95703 12.5039 8.61328 12.6758 8.22656C12.7188 8.05469 12.8477 7.75391 13.0625 7.32422C13.2344 6.9375 13.4062 6.63672 13.4922 6.37891C13.6211 6.03516 13.707 5.64844 13.707 5.26172C13.707 4.53125 13.6211 3.97266 13.4492 3.62891C13.1055 3.11328 12.5039 2.8125 11.6445 2.8125C11.4727 2.98438 11.3438 3.24219 11.2578 3.54297C11.1719 3.71484 11.1289 4.01562 11.043 4.44531C10.9141 5.04688 10.8281 5.47656 10.7422 5.73438C10.5703 6.20703 10.3125 6.59375 10.0117 6.89453C9.75391 7.15234 9.36719 7.66797 8.76562 8.44141C8.12109 9.30078 7.64844 9.90234 7.34766 10.2031C6.78906 10.8047 6.31641 11.0625 5.97266 11.0625H5.5V19.0547C5.97266 19.0547 6.48828 19.1406 7.08984 19.2695C7.43359 19.3555 7.94922 19.5273 8.63672 19.7852C9.49609 20.0859 10.1406 20.3008 10.6133 20.3867C11.3867 20.6016 12.1172 20.6875 12.8906 20.6875H14.4805C15.2969 20.6875 15.8984 20.4727 16.3281 20.043C16.7578 19.6133 16.9297 18.8828 16.8008 17.8516C17.1445 17.6797 17.3594 17.3359 17.5312 16.8203C17.6602 16.3047 17.6172 15.832 17.4023 15.4023ZM3.78125 19.3125C3.78125 19.0547 3.65234 18.7969 3.48047 18.582C3.26562 18.4102 3.00781 18.2812 2.75 18.2812C2.44922 18.2812 2.19141 18.4102 2.01953 18.582C1.80469 18.7969 1.71875 19.0547 1.71875 19.3125C1.71875 19.6133 1.80469 19.8711 2.01953 20.043C2.19141 20.2578 2.44922 20.3438 2.75 20.3438C3.00781 20.3438 3.26562 20.2578 3.48047 20.043C3.65234 19.8711 3.78125 19.6133 3.78125 19.3125Z" fill="currentColor"/></svg>',thumbsdown:'<svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0234 10.418C20.4102 11.1055 20.625 11.8359 20.625 12.5664C20.625 13.5547 20.2383 14.4141 19.5508 15.1445C18.8203 15.918 17.9609 16.2617 16.9297 16.2617H15.3828C15.6406 16.9492 15.7695 17.5938 15.7695 18.2383C15.7695 19.7852 15.3828 20.9023 14.6523 21.6758C13.9219 22.4062 12.9336 22.75 11.6445 22.75C10.8281 22.75 10.1836 22.3633 9.75391 21.5469C9.49609 21.1172 9.23828 20.3438 8.98047 19.3125C8.80859 18.625 8.67969 18.1953 8.59375 18.0664C8.25 17.7656 7.77734 17.1641 7.08984 16.2617C6.40234 15.3594 5.88672 14.7578 5.62891 14.5H5.32812C5.15625 14.7148 4.98438 14.8867 4.8125 15.0156C4.59766 15.1445 4.38281 15.1875 4.125 15.1875H1.375C0.988281 15.1875 0.644531 15.0586 0.386719 14.8008C0.128906 14.543 0 14.1992 0 13.8125V3.5C0 3.15625 0.128906 2.8125 0.386719 2.55469C0.644531 2.29688 0.988281 2.125 1.375 2.125H4.125C4.46875 2.125 4.76953 2.25391 5.02734 2.46875H5.5C5.80078 2.46875 6.14453 2.42578 6.48828 2.29688C6.70312 2.25391 7.04688 2.125 7.5625 1.91016C8.42188 1.56641 9.15234 1.30859 9.75391 1.13672C10.7852 0.878906 11.9023 0.75 13.1055 0.75H14.0508C15.6406 0.75 16.8438 1.13672 17.7031 1.91016C18.4766 2.59766 18.8633 3.58594 18.9062 4.83203C19.1641 5.26172 19.3789 5.69141 19.5078 6.20703C19.6367 6.72266 19.6797 7.23828 19.6367 7.71094C20.0664 8.57031 20.1953 9.47266 20.0234 10.418ZM2.75 13.4688C3.00781 13.4688 3.26562 13.3828 3.48047 13.168C3.65234 12.9961 3.78125 12.7383 3.78125 12.4375C3.78125 12.1797 3.65234 11.9219 3.48047 11.707C3.26562 11.5352 3.00781 11.4062 2.75 11.4062C2.44922 11.4062 2.19141 11.5352 2.01953 11.707C1.80469 11.9219 1.71875 12.1797 1.71875 12.4375C1.71875 12.7383 1.80469 12.9961 2.01953 13.168C2.19141 13.3828 2.44922 13.4688 2.75 13.4688ZM16.9297 14.1992C17.3594 14.1992 17.7461 14.0273 18.0898 13.6836C18.3906 13.3398 18.5625 12.9961 18.5625 12.5664C18.5625 12.1797 18.4336 11.793 18.2188 11.4492C18.0039 11.1055 17.7891 10.9336 17.6172 10.9336C17.918 10.5898 18.0469 10.1602 18.0469 9.60156C18.0469 9.04297 17.832 8.52734 17.4023 8.09766C17.6172 7.66797 17.6602 7.23828 17.5312 6.72266C17.3594 6.20703 17.1445 5.86328 16.8008 5.64844C16.9297 4.66016 16.7578 3.92969 16.3281 3.45703C15.8984 3.02734 15.2969 2.8125 14.4805 2.8125H12.8906C12.1172 2.8125 11.3867 2.94141 10.6133 3.11328C10.1406 3.24219 9.49609 3.45703 8.63672 3.71484C7.94922 3.97266 7.43359 4.14453 7.08984 4.23047C6.48828 4.40234 5.97266 4.44531 5.5 4.44531V12.4375H5.97266C6.31641 12.4375 6.78906 12.7383 7.34766 13.2969C7.64844 13.6406 8.12109 14.1992 8.76562 15.0586C9.36719 15.875 9.75391 16.3906 10.0117 16.6055C10.3125 16.9492 10.5703 17.3359 10.7422 17.7656C10.8281 18.0664 10.9141 18.4961 11.043 19.0547C11.1289 19.4844 11.1719 19.7852 11.2578 19.957C11.3438 20.3008 11.4727 20.5156 11.6445 20.6875C12.5039 20.6875 13.1055 20.4297 13.4492 19.8711C13.6211 19.5273 13.707 19.0117 13.707 18.2383C13.707 17.8945 13.6211 17.5078 13.4922 17.1211C13.4062 16.9062 13.2344 16.6055 13.0625 16.1758C12.8477 15.7891 12.7188 15.4883 12.6758 15.2734C12.5039 14.9297 12.4609 14.543 12.4609 14.1992H16.9297Z" fill="currentColor"/></svg>',chevronDown:'<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3047 0.429688H17.2656C17.3438 0.507812 17.4219 0.625 17.4219 0.742188C17.4219 0.898438 17.3438 1.01562 17.2656 1.09375L9.02344 9.33594C8.94531 9.41406 8.82812 9.45312 8.71094 9.45312C8.55469 9.45312 8.4375 9.41406 8.35938 9.33594L0.117188 1.09375C0.0390625 1.01562 0 0.898438 0 0.742188C0 0.625 0.0390625 0.507812 0.117188 0.429688L0.429688 0.117188C0.507812 0.0390625 0.585938 0 0.742188 0C0.859375 0 0.976562 0.0390625 1.09375 0.117188L8.71094 7.77344L16.3281 0.117188C16.4062 0.0390625 16.5234 0 16.6797 0C16.7969 0 16.9141 0.0390625 16.9922 0.117188L17.3047 0.429688Z" fill="currentColor"/></svg>',pdf:'<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.1758 4.64453C15.5449 5.05469 15.75 5.50586 15.75 6.03906V19.6562C15.75 20.2305 15.5449 20.6816 15.1758 21.0508C14.7656 21.4609 14.3145 21.625 13.7812 21.625H1.96875C1.39453 21.625 0.943359 21.4609 0.574219 21.0508C0.164062 20.6816 0 20.2305 0 19.6562V2.59375C0 2.06055 0.164062 1.60938 0.574219 1.19922C0.943359 0.830078 1.39453 0.625 1.96875 0.625H10.3359C10.8691 0.625 11.3203 0.830078 11.7305 1.19922L15.1758 4.64453ZM14.2324 5.58789L10.7871 2.14258C10.7051 2.06055 10.582 2.01953 10.5 1.9375V5.875H14.4375C14.3555 5.79297 14.3145 5.66992 14.2324 5.58789ZM13.7812 20.3125C13.9453 20.3125 14.1094 20.2715 14.2324 20.1484C14.3555 20.0254 14.4375 19.8613 14.4375 19.6562V7.1875H10.1719C9.88477 7.1875 9.63867 7.10547 9.47461 6.90039C9.26953 6.73633 9.1875 6.49023 9.1875 6.20312V1.9375H1.96875C1.76367 1.9375 1.59961 2.01953 1.47656 2.14258C1.35352 2.26562 1.3125 2.42969 1.3125 2.59375V19.6562C1.3125 19.8613 1.35352 20.0254 1.47656 20.1484C1.59961 20.2715 1.76367 20.3125 1.96875 20.3125H13.7812ZM12.8789 13.2988C13.002 13.4629 13.084 13.668 13.125 13.9141C13.125 14.2012 13.043 14.4473 12.8789 14.6523C12.7148 14.8574 12.4277 14.9395 12.0996 14.9395C11.7715 14.9395 11.3613 14.8984 10.8691 14.7344C10.377 14.5703 9.88477 14.3652 9.47461 14.1191C8.90039 14.2422 7.95703 14.4883 6.72656 14.8984L6.11133 15.1035C5.61914 15.9648 5.16797 16.5801 4.79883 16.9902C4.42969 17.4004 4.06055 17.6465 3.69141 17.6875C3.36328 17.7285 3.07617 17.6465 2.87109 17.4414C2.66602 17.2363 2.58398 16.9902 2.625 16.7441C2.78906 16.0879 3.56836 15.3496 5.04492 14.5703C5.53711 13.709 6.11133 12.5195 6.76758 10.9609C6.5625 10.2227 6.43945 9.60742 6.39844 9.11523C6.31641 8.58203 6.31641 8.13086 6.43945 7.76172C6.48047 7.51562 6.64453 7.35156 6.93164 7.26953C7.21875 7.1875 7.50586 7.1875 7.79297 7.31055C8.03906 7.43359 8.20312 7.67969 8.28516 8.04883C8.36719 8.37695 8.36719 8.78711 8.28516 9.2793C8.24414 9.60742 8.16211 10.0176 8.03906 10.5508L7.99805 10.6738C8.4082 11.7402 9.02344 12.5195 9.84375 13.0117C11.4434 12.8066 12.4688 12.8887 12.8789 13.2988ZM3.48633 16.9492C3.48633 16.9902 3.52734 16.9492 3.69141 16.8262C3.81445 16.7441 3.97852 16.5801 4.14258 16.334C4.38867 16.0879 4.63477 15.7188 4.92188 15.2676L4.79883 15.3906C4.06055 16.0469 3.60938 16.5801 3.48633 16.9492ZM7.38281 7.80273V7.84375C7.30078 7.84375 7.30078 8.08984 7.30078 8.58203C7.30078 9.07422 7.3418 9.48438 7.46484 9.77148C7.58789 9.56641 7.62891 9.19727 7.62891 8.62305C7.62891 8.08984 7.54688 7.80273 7.38281 7.80273ZM6.23438 14.3652L6.76758 14.1191C7.62891 13.791 8.32617 13.5449 8.81836 13.4629C8.24414 13.0527 7.75195 12.4785 7.38281 11.7402C6.97266 12.8477 6.5625 13.709 6.23438 14.3652ZM12.5098 14.1191C12.5918 14.0781 12.5508 14.0371 12.4688 13.9551C12.3867 13.873 12.2227 13.832 11.9766 13.75C11.6484 13.709 11.2383 13.709 10.7461 13.75C11.1562 13.9551 11.5664 14.0781 11.8945 14.1191C12.0996 14.2012 12.2637 14.2012 12.3867 14.1602C12.4277 14.1602 12.4688 14.1602 12.5098 14.1191Z" fill="currentColor"/></svg>',arrowRight:'<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2344 0.675781C12.3477 0.5625 12.5176 0.505859 12.7441 0.505859C12.9141 0.505859 13.084 0.5625 13.1973 0.675781L25.1484 12.6836C25.2617 12.7969 25.375 12.9668 25.375 13.1367C25.375 13.3633 25.2617 13.4766 25.1484 13.5898L13.1973 25.5977C13.084 25.7109 12.9141 25.7676 12.7441 25.7676C12.5176 25.7676 12.3477 25.7109 12.2344 25.5977L11.8379 25.1445C11.7246 25.0312 11.668 24.918 11.668 24.6914C11.668 24.5215 11.7246 24.3516 11.8379 24.1816L21.9766 14.0996H0.679688C0.453125 14.0996 0.283203 14.043 0.169922 13.9297C0.0566406 13.8164 0 13.6465 0 13.4199V12.8535C0 12.6836 0.0566406 12.5137 0.169922 12.4004C0.283203 12.2871 0.453125 12.1738 0.679688 12.1738H21.9766L11.8379 2.0918C11.7246 1.97852 11.668 1.80859 11.668 1.58203C11.668 1.41211 11.7246 1.24219 11.8379 1.12891L12.2344 0.675781Z" fill="currentColor"/></svg>',file:'<svg width="22" height="30" viewBox="0 0 22 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.957 5.92578C21.4668 6.49219 21.75 7.11523 21.75 7.85156V26.6562C21.75 27.4492 21.4668 28.0723 20.957 28.582C20.3906 29.1484 19.7676 29.375 19.0312 29.375H2.71875C1.92578 29.375 1.30273 29.1484 0.792969 28.582C0.226562 28.0723 0 27.4492 0 26.6562V3.09375C0 2.35742 0.226562 1.73438 0.792969 1.16797C1.30273 0.658203 1.92578 0.375 2.71875 0.375H14.2734C15.0098 0.375 15.6328 0.658203 16.1992 1.16797L20.957 5.92578ZM19.6543 7.22852L14.8965 2.4707C14.7832 2.35742 14.6133 2.30078 14.5 2.1875V7.625H19.9375C19.8242 7.51172 19.7676 7.3418 19.6543 7.22852ZM19.0312 27.5625C19.2578 27.5625 19.4844 27.5059 19.6543 27.3359C19.8242 27.166 19.9375 26.9395 19.9375 26.6562V9.4375H14.0469C13.6504 9.4375 13.3105 9.32422 13.084 9.04102C12.8008 8.81445 12.6875 8.47461 12.6875 8.07812V2.1875H2.71875C2.43555 2.1875 2.20898 2.30078 2.03906 2.4707C1.86914 2.64062 1.8125 2.86719 1.8125 3.09375V26.6562C1.8125 26.9395 1.86914 27.166 2.03906 27.3359C2.20898 27.5059 2.43555 27.5625 2.71875 27.5625H19.0312Z" fill="currentColor"/></svg>',pin:'<svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6.67105C12 7.35788 11.6666 8.55116 11.0556 10.0817C10.4627 11.5669 9.66593 13.2337 8.86007 14.8061C8.05576 16.3755 7.25033 17.8357 6.64537 18.9044C6.5955 18.9925 6.54701 19.078 6.5 19.1605C6.453 19.078 6.4045 18.9925 6.35463 18.9044C5.74967 17.8357 4.94424 16.3755 4.13994 14.8061C3.33408 13.2337 2.53727 11.5669 1.94436 10.0817C1.33336 8.55116 1 7.35788 1 6.67105C1 3.62146 3.46493 1.15381 6.5 1.15381C9.53507 1.15381 12 3.62146 12 6.67105Z" fill="white" stroke="white" stroke-width="2"/><g transform="translate(5, 4)"><path d="M4.5 3.25L-3.05875e-07 6.4976L-2.19608e-08 0.00240449L4.5 3.25Z" fill="#2175D9"/></g></svg>'},Ri={phone:'<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M35.407 3.594c.398.133.797.398 1.128.797.266.398.465.796.465 1.195 0 5.578-1.394 10.691-4.181 15.406-2.655 4.582-6.305 8.235-10.884 10.89C17.223 34.673 12.113 36 6.671 36c-.531 0-.93-.133-1.327-.465-.399-.265-.598-.664-.73-1.129L3.087 27.7c-.133-.465-.133-.93.133-1.394.265-.399.597-.73 1.062-.996l7.167-3.055c.398-.133.863-.2 1.328-.067.398.133.796.332 1.128.665l2.92 3.585a23.531 23.531 0 006.172-4.449c1.792-1.793 3.252-3.851 4.446-6.175L23.86 12.89c-.399-.266-.598-.664-.73-1.13-.133-.398-.067-.863.132-1.327l3.053-7.172c.2-.399.531-.73.996-.996.398-.266.862-.332 1.393-.2l6.703 1.528zM6.671 33.875c5.044 0 9.822-1.262 14.202-3.852 4.248-2.457 7.632-5.843 10.154-10.16 2.522-4.383 3.85-9.097 3.85-14.21L28.24 4.124l-3.053 7.172 4.845 3.918c-1.593 3.453-3.451 6.242-5.509 8.3-2.123 2.126-4.844 3.919-8.295 5.512l-3.916-4.847-7.167 3.054 1.526 6.641z" fill="currentColor"/>\n</svg>',warning:'<svg viewBox="0 0 84 72" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M42 0l41.57 72H.43L42 0z" fill="#FEE96C"/>\n  <rect x="41" y="24" width="2" height="27" rx="1" fill="#2C2C2C"/>\n  <circle cx="42" cy="58" r="2" fill="#2C2C2C"/>\n</svg>',facebook:'<svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n  <path d="M32 1.786c0-.5-.214-.929-.571-1.286-.358-.286-.786-.5-1.215-.5H1.786C1.214 0 .786.214.5.5.143.857 0 1.286 0 1.786v28.428c0 .5.143.929.5 1.286.286.357.714.5 1.286.5H17.07V19.571h-4.14v-4.785h4.142v-3.572c0-2 .572-3.571 1.715-4.714 1.143-1.071 2.643-1.643 4.5-1.643C24.714 4.857 26 4.93 27 5v4.357h-2.571c-.929 0-1.572.214-1.929.643-.286.357-.429.929-.429 1.714v3.072h4.786l-.643 4.785h-4.143V32h8.143c.5 0 .929-.143 1.286-.5.286-.357.5-.786.5-1.286V1.786z"/>\n</svg>',twitter:'<svg viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M32.273 7.25A16.198 16.198 0 0036 3.416c-1.406.627-2.813 1.046-4.219 1.185 1.547-.976 2.672-2.3 3.235-4.043-1.477.836-3.024 1.464-4.711 1.742A8.519 8.519 0 0027.844.627 7.012 7.012 0 0024.89 0c-1.336 0-2.532.349-3.657.976-1.125.697-2.039 1.603-2.672 2.719-.703 1.115-.984 2.37-.984 3.625 0 .557 0 1.115.14 1.673-3.023-.14-5.835-.837-8.507-2.231-2.672-1.324-4.852-3.137-6.68-5.437-.703 1.185-1.054 2.44-1.054 3.694 0 1.255.28 2.44.914 3.486.562 1.115 1.406 1.952 2.39 2.649a6.107 6.107 0 01-3.304-.976v.14c0 1.742.562 3.276 1.687 4.6 1.125 1.395 2.531 2.231 4.219 2.58-.703.139-1.336.209-1.969.209-.422 0-.914 0-1.336-.07.422 1.464 1.266 2.65 2.531 3.625 1.266.976 2.672 1.394 4.36 1.394-2.742 2.092-5.836 3.137-9.211 3.137-.703 0-1.266 0-1.758-.07C3.375 27.955 7.172 29 11.32 29c4.29 0 8.086-1.046 11.461-3.276 3.024-1.952 5.414-4.532 7.102-7.878 1.617-3.067 2.46-6.344 2.46-9.69 0-.418-.07-.697-.07-.906z" fill="currentColor"/>\n</svg>',youtube:'<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.4844 2.34375C21.6406 3.04688 21.7969 4.14062 21.875 5.54688L21.9141 7.5L21.875 9.45312C21.7969 10.9375 21.6406 11.9922 21.4844 12.6953C21.3281 13.1641 21.0938 13.5547 20.7812 13.8672C20.4297 14.2188 20.0391 14.4531 19.5703 14.5703C18.8672 14.7656 17.3047 14.8828 14.8047 14.9609L11.25 15L7.69531 14.9609C5.19531 14.8828 3.59375 14.7656 2.92969 14.5703C2.46094 14.4531 2.03125 14.2188 1.71875 13.8672C1.36719 13.5547 1.13281 13.1641 1.01562 12.6953C0.820312 11.9922 0.703125 10.9375 0.625 9.45312L0.585938 7.5C0.585938 6.95312 0.585938 6.28906 0.625 5.54688C0.703125 4.14062 0.820312 3.04688 1.01562 2.34375C1.13281 1.875 1.36719 1.48438 1.71875 1.13281C2.03125 0.820312 2.46094 0.585938 2.92969 0.429688C3.59375 0.273438 5.19531 0.117188 7.69531 0.0390625L11.25 0L14.8047 0.0390625C17.3047 0.117188 18.8672 0.273438 19.5703 0.429688C20.0391 0.585938 20.4297 0.820312 20.7812 1.13281C21.0938 1.48438 21.3281 1.875 21.4844 2.34375ZM9.0625 10.7031L14.6484 7.5L9.0625 4.33594V10.7031Z" fill="currentColor"/>\n</svg>',linkedin:'<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M29.286 0c.553 0 1.107.286 1.522.714.415.429.692 1 .692 1.572v27.428c0 .643-.277 1.215-.692 1.643a2.112 2.112 0 01-1.522.643H2.714c-.622 0-1.176-.214-1.591-.643-.415-.428-.623-1-.623-1.643V2.286c0-.572.208-1.143.623-1.572C1.538.286 2.092 0 2.714 0h26.572zM9.842 27.429h.069V12.143H5.275v15.286h4.567zM7.558 10.07c.692 0 1.315-.214 1.868-.785.554-.572.83-1.215.83-1.929S9.98 6 9.427 5.43c-.553-.572-1.176-.858-1.868-.858-.761 0-1.384.286-1.868.858-.554.571-.761 1.214-.761 1.928s.207 1.357.76 1.929c.485.571 1.108.785 1.869.785zm19.513 17.36v-8.36c0-2.357-.346-4.071-.968-5.214-.9-1.357-2.422-2.071-4.498-2.071a5.296 5.296 0 00-2.837.785c-.692.429-1.246 1-1.523 1.643h-.069v-2.071h-4.428v15.286h4.567v-7.572c0-1.143.138-2.071.484-2.714.415-.786 1.176-1.214 2.284-1.214 1.038 0 1.73.5 2.076 1.357.207.571.346 1.5.346 2.714v7.429h4.566z" fill="currentColor"/>\n</svg>',instagram:'<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M16 7.914c1.406 0 2.742.422 4.008 1.125a7.458 7.458 0 012.953 2.953c.703 1.266 1.125 2.602 1.125 4.008 0 1.477-.422 2.813-1.125 4.078a7.457 7.457 0 01-2.953 2.953A8.131 8.131 0 0116 24.086a8.2 8.2 0 01-4.078-1.055 7.457 7.457 0 01-2.953-2.953A8.2 8.2 0 017.914 16c0-1.406.352-2.742 1.055-4.008a7.458 7.458 0 012.953-2.953c1.265-.703 2.601-1.125 4.078-1.125zm0 13.36c1.406 0 2.672-.493 3.727-1.547A5.148 5.148 0 0021.273 16c0-1.406-.562-2.672-1.546-3.727-1.055-.984-2.32-1.546-3.727-1.546a5.148 5.148 0 00-3.727 1.546c-1.054 1.055-1.546 2.32-1.546 3.727 0 1.477.492 2.742 1.546 3.727.985 1.054 2.25 1.546 3.727 1.546zM26.336 7.561c0-.492-.211-.914-.563-1.335-.421-.352-.843-.563-1.335-.563-.563 0-.985.211-1.336.563-.422.421-.563.843-.563 1.335 0 .563.14.985.563 1.336.351.422.773.563 1.335.563.493 0 .915-.14 1.266-.563.352-.351.563-.773.633-1.335zM31.68 9.46c0 1.336.07 3.516.07 6.539 0 3.094-.07 5.273-.14 6.61a15.322 15.322 0 01-.563 3.445 8.33 8.33 0 01-1.969 3.093c-.844.844-1.898 1.477-3.023 1.899-.985.351-2.18.562-3.516.633-1.336.07-3.516.07-6.539.07-3.094 0-5.273 0-6.61-.07-1.335-.07-2.46-.282-3.445-.703a7.255 7.255 0 01-3.093-1.829c-.844-.843-1.477-1.898-1.899-3.093-.351-.985-.562-2.11-.633-3.446C.25 21.273.25 19.094.25 16c0-3.023 0-5.203.07-6.54.07-1.335.282-2.53.633-3.515.422-1.125 1.055-2.18 1.899-3.023A8.33 8.33 0 015.945.953 15.32 15.32 0 019.391.391C10.727.32 12.906.25 16 .25c3.023 0 5.203.07 6.54.14a16 16 0 013.515.563 8.653 8.653 0 013.023 1.969 8.653 8.653 0 011.969 3.023c.281.985.492 2.18.633 3.516zm-3.375 15.82c.28-.773.422-2.039.562-3.797 0-.984.07-2.46.07-4.359v-2.25c0-1.898-.07-3.375-.07-4.36-.14-1.757-.281-3.023-.562-3.796a5.33 5.33 0 00-3.024-3.024c-.773-.28-2.039-.422-3.797-.562-1.054 0-2.53-.07-4.359-.07h-2.25c-1.898 0-3.375.07-4.36.07-1.757.14-3.023.281-3.796.562-1.477.563-2.461 1.618-3.024 3.024-.28.773-.492 2.039-.562 3.797-.07 1.054-.07 2.53-.07 4.359v2.25c0 1.898 0 3.375.07 4.36.07 1.757.281 3.023.562 3.796.563 1.477 1.618 2.461 3.024 3.024.773.28 2.039.492 3.797.562.984.07 2.46.07 4.359.07h2.25c1.898 0 3.375 0 4.36-.07 1.757-.07 3.023-.281 3.796-.562a5.33 5.33 0 003.024-3.024z" fill="currentColor"/>\n</svg>',print:'<svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M29.25 13.5c1.828 0 3.445.703 4.781 1.969C35.297 16.805 36 18.422 36 20.25v9.563c0 .492-.21.914-.492 1.195a1.647 1.647 0 01-1.196.492H29.25v2.813c0 .492-.21.914-.492 1.195a1.647 1.647 0 01-1.195.492H8.438c-.493 0-.915-.14-1.196-.492-.351-.281-.492-.703-.492-1.196V31.5H1.687c-.492 0-.914-.14-1.195-.492C.141 30.727 0 30.305 0 29.813V20.25c0-1.828.633-3.445 1.969-4.781C3.234 14.203 4.852 13.5 6.75 13.5V1.687c0-.421.14-.843.492-1.195A1.696 1.696 0 018.438 0h15.046c.422 0 .844.21 1.196.492l4.078 4.078c.281.352.492.774.492 1.196V13.5zM10.125 3.375v13.5h15.75V6.469l-3.094-3.094H10.125zm15.75 29.25V27h-15.75v5.625h15.75zm6.75-4.5V20.25c0-.914-.352-1.688-.984-2.39-.703-.633-1.477-.985-2.391-.985v1.688c0 .492-.21.914-.492 1.195a1.647 1.647 0 01-1.195.492H8.438c-.493 0-.915-.14-1.196-.492-.351-.281-.492-.703-.492-1.195v-1.688c-.984 0-1.758.352-2.39.984-.704.703-.985 1.477-.985 2.391v7.875H6.75v-2.813c0-.421.14-.843.492-1.195a1.696 1.696 0 011.196-.492h19.124c.422 0 .844.21 1.196.492.281.352.492.774.492 1.195v2.813h3.375zm-.563-6.75c0-.422-.21-.844-.492-1.195-.351-.282-.773-.492-1.195-.492-.492 0-.914.21-1.195.492a1.646 1.646 0 00-.492 1.195c0 .492.14.914.492 1.195.28.352.703.492 1.195.492.422 0 .844-.14 1.195-.492a1.69 1.69 0 00.492-1.195z" fill="#2C2C2C"/>\n</svg>',email:'<svg viewBox="0 0 38 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M36.777 8.93c-1.734 1.336-5.492 4.008-11.129 7.945l-.722.563c-1.156.843-2.024 1.476-2.746 1.828-1.157.703-2.24.984-3.18.984-1.012 0-2.023-.281-3.18-.914-.722-.352-1.59-.984-2.746-1.828l-.722-.633c-5.854-4.078-9.54-6.75-11.13-7.945a.633.633 0 00-.505 0 .385.385 0 00-.217.35v14.344c0 .984.29 1.758 1.012 2.39.65.704 1.445.985 2.457.985H34.03c.94 0 1.735-.281 2.457-.984.65-.633 1.012-1.407 1.012-2.391V9.281c0-.14-.145-.281-.29-.422-.144-.07-.288-.07-.433.07zM19 18c-.65 0-1.445-.281-2.313-.844-.578-.281-1.3-.773-2.24-1.547l-.722-.492C7.799 10.898 3.752 8.016 1.656 6.398l-.506-.351C.717 5.766.5 5.273.5 4.71V3.375c0-.914.29-1.688 1.012-2.39C2.162.351 2.957 0 3.969 0H34.03c.94 0 1.735.352 2.457.984.65.704 1.012 1.477 1.012 2.391v1.336c0 .562-.217 1.055-.65 1.336l-.362.281c-2.095 1.617-6.142 4.57-12.213 8.79l-.722.491c-1.012.774-1.735 1.266-2.24 1.547-.94.563-1.735.844-2.313.844z" fill="#2C2C2C"/>\n</svg>',envelope:'<svg width="33" height="25" viewBox="0 0 33 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M29.9062 0.25C30.7441 0.25 31.4531 0.572266 32.0977 1.15234C32.6777 1.79688 33 2.50586 33 3.34375V21.9062C33 22.8086 32.6777 23.5176 32.0977 24.0977C31.4531 24.7422 30.7441 25 29.9062 25H3.09375C2.19141 25 1.48242 24.7422 0.902344 24.0977C0.257812 23.5176 0 22.8086 0 21.9062V3.34375C0 2.50586 0.257812 1.79688 0.902344 1.15234C1.48242 0.572266 2.19141 0.25 3.09375 0.25H29.9062ZM3.09375 2.3125C2.77148 2.3125 2.51367 2.44141 2.32031 2.63477C2.12695 2.82812 2.0625 3.08594 2.0625 3.34375V5.98633C3.54492 7.27539 6.76758 9.91797 11.7949 13.8496L12.375 14.3652C13.2129 15.1387 13.9219 15.6543 14.4375 15.9121C15.2109 16.4922 15.9199 16.75 16.5 16.75C17.0156 16.75 17.7246 16.4922 18.5625 15.9121C19.0137 15.6543 19.6582 15.1387 20.5605 14.3652L21.2051 13.8496C26.168 9.91797 29.3906 7.27539 30.9375 5.98633V3.34375C30.9375 3.08594 30.8086 2.82812 30.6152 2.63477C30.4219 2.44141 30.1641 2.3125 29.9062 2.3125H3.09375ZM29.9062 22.9375C30.1641 22.9375 30.4219 22.873 30.6152 22.6797C30.8086 22.4863 30.9375 22.2285 30.9375 21.9062V8.69336C29.3906 9.91797 26.6191 12.1738 22.4941 15.4609L21.8496 15.9766C20.8184 16.8789 19.9805 17.459 19.4004 17.8457C18.3047 18.4902 17.3379 18.8125 16.5 18.8125C15.5977 18.8125 14.6309 18.4902 13.5996 17.8457C12.9551 17.459 12.1172 16.8789 11.1504 15.9766L10.5059 15.4609C6.38086 12.1738 3.54492 9.91797 2.0625 8.69336V21.9062C2.0625 22.2285 2.12695 22.4863 2.32031 22.6797C2.51367 22.873 2.77148 22.9375 3.09375 22.9375H29.9062Z" fill="#FEE96C"/>\n</svg>',chevronRight:'<svg viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M7.663 8.256L12.75 4.73 7.663 1.206M.75 8.256L5.838 4.73.75 1.206" stroke="currentColor" stroke-width="1.5"/>\n</svg>',quote:'<svg viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M23.55 29.514h9.272L38.8.6h-7.685L23.55 29.514zm-22.57 0h9.272L16.23.6H8.544L.98 29.514z" fill="currentColor"/>\n</svg>',exclamationTriangle:'<svg viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.67 14.888c.334 0 .622-.107.863-.32.24-.213.389-.472.444-.778a1.41 1.41 0 00-.139-.903L9.168 1.324a1.247 1.247 0 00-.71-.598 1.414 1.414 0 00-.917 0 1.247 1.247 0 00-.708.598L.162 12.887a1.41 1.41 0 00-.14.903c.056.306.205.565.445.778.241.213.529.32.862.32h13.342zm0-.89H1.33a.405.405 0 01-.375-.222.449.449 0 01-.014-.444L7.61 1.769A.436.436 0 018 1.546c.167 0 .296.075.389.223l6.67 11.563a.449.449 0 01-.013.444.405.405 0 01-.375.223zM8 12.554a.754.754 0 00.556-.222.754.754 0 00.223-.556.754.754 0 00-.686-.774L8 10.997a.754.754 0 00-.556.222.754.754 0 00-.222.556c0 .222.074.408.222.556a.754.754 0 00.556.222zm.111-2.112a.322.322 0 00.237-.097.322.322 0 00.097-.237l.195-4.67a.247.247 0 00-.07-.236.357.357 0 00-.264-.097h-.611c-.112 0-.2.033-.265.097a.247.247 0 00-.069.237l.195 4.697c0 .074.032.144.097.209a.322.322 0 00.236.097h.222z" fill="currentColor"/>\n</svg>',dropdown:'<svg viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1 1.5L5.5 6 10 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>',statusInfo:'<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.625a11.27 11.27 0 005.813-1.57 11.746 11.746 0 004.242-4.242A11.269 11.269 0 0023.625 12a11.27 11.27 0 00-1.57-5.813 11.746 11.746 0 00-4.242-4.242A11.27 11.27 0 0012 .375a11.27 11.27 0 00-5.813 1.57 11.747 11.747 0 00-4.242 4.242A11.269 11.269 0 00.375 12c0 2.094.523 4.031 1.57 5.813a11.746 11.746 0 004.242 4.242A11.269 11.269 0 0012 23.625zm0-1.5c-1.844 0-3.54-.453-5.086-1.36a10.134 10.134 0 01-3.68-3.68C2.328 15.54 1.875 13.845 1.875 12c0-1.844.453-3.54 1.36-5.086a10.133 10.133 0 013.679-3.68C8.461 2.328 10.156 1.875 12 1.875c1.813 0 3.5.453 5.063 1.36a10.079 10.079 0 013.703 3.679c.906 1.547 1.359 3.242 1.359 5.086 0 1.844-.453 3.539-1.36 5.086a10.134 10.134 0 01-3.68 3.68c-1.546.906-3.241 1.359-5.085 1.359zM13.688 18a.542.542 0 00.398-.164.542.542 0 00.164-.398v-.375a.542.542 0 00-.164-.399.542.542 0 00-.399-.164h-.562V9.937a.542.542 0 00-.164-.398.543.543 0 00-.399-.164h-2.25a.542.542 0 00-.398.164.542.542 0 00-.164.398v.376c0 .156.055.288.164.398.11.11.242.164.399.164h.562V16.5h-.563a.542.542 0 00-.398.164.543.543 0 00-.164.398v.375c0 .157.055.29.164.399.11.11.242.164.399.164h3.374zM12 8.25c.406 0 .758-.148 1.055-.445.296-.297.445-.649.445-1.055 0-.406-.149-.758-.445-1.055A1.442 1.442 0 0012 5.25c-.406 0-.758.148-1.055.445A1.441 1.441 0 0010.5 6.75c0 .406.148.758.445 1.055.297.297.649.445 1.055.445z" fill="currentColor"/>\n</svg>',statusError:'<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.625a11.27 11.27 0 005.813-1.57 11.746 11.746 0 004.242-4.242A11.269 11.269 0 0023.625 12a11.27 11.27 0 00-1.57-5.813 11.746 11.746 0 00-4.242-4.242A11.27 11.27 0 0012 .375a11.27 11.27 0 00-5.813 1.57 11.747 11.747 0 00-4.242 4.242A11.269 11.269 0 00.375 12c0 2.094.523 4.031 1.57 5.813a11.746 11.746 0 004.242 4.242A11.269 11.269 0 0012 23.625zm0-1.5c-1.844 0-3.54-.453-5.086-1.36a10.134 10.134 0 01-3.68-3.68C2.328 15.54 1.875 13.845 1.875 12c0-1.844.453-3.54 1.36-5.086a10.133 10.133 0 013.679-3.68C8.461 2.328 10.156 1.875 12 1.875c1.813 0 3.5.453 5.063 1.36a10.079 10.079 0 013.703 3.679c.906 1.547 1.359 3.242 1.359 5.086 0 1.844-.453 3.539-1.36 5.086a10.134 10.134 0 01-3.68 3.68c-1.546.906-3.241 1.359-5.085 1.359zm0-3.563c.375 0 .688-.125.938-.375s.374-.562.374-.937-.124-.688-.374-.938a1.272 1.272 0 00-.938-.375c-.375 0-.688.126-.938.376s-.374.562-.374.937.124.688.374.938.563.375.938.375zM12.188 15a.542.542 0 00.398-.164.542.542 0 00.164-.399l.328-7.875a.416.416 0 00-.117-.398.602.602 0 00-.445-.164h-1.032a.602.602 0 00-.445.164.416.416 0 00-.117.398l.328 7.922c0 .125.055.242.164.352.11.11.242.164.399.164h.374z" fill="currentColor"/>\n</svg>',statusWarning:'<svg viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.99 21.342c.5 0 .931-.16 1.292-.48a1.99 1.99 0 00.667-1.166 2.11 2.11 0 00-.209-1.354L13.742 1.01A1.868 1.868 0 0012.68.115a2.12 2.12 0 00-1.375 0 1.868 1.868 0 00-1.062.895l-10 17.332a2.114 2.114 0 00-.208 1.354c.083.459.306.848.667 1.167.36.32.791.479 1.291.479h19.999zm0-1.333H1.993a.607.607 0 01-.562-.334.672.672 0 01-.021-.666l10-17.332a.653.653 0 01.582-.333c.25 0 .445.11.584.333l9.999 17.332a.672.672 0 01-.02.666.607.607 0 01-.563.334zm-9.999-2.167c.334 0 .611-.11.834-.333.222-.222.333-.5.333-.833a1.13 1.13 0 00-.333-.833c-.19-.191-.422-.3-.694-.327l-.14-.007a1.13 1.13 0 00-.833.333 1.13 1.13 0 00-.333.834c0 .333.111.61.333.833.222.222.5.333.833.333zm.167-3.166a.482.482 0 00.354-.146.482.482 0 00.146-.354l.292-7a.37.37 0 00-.104-.354.535.535 0 00-.396-.145h-.917a.535.535 0 00-.396.145.37.37 0 00-.104.354l.292 7.042c0 .11.048.215.146.312a.482.482 0 00.354.146h.333z" fill="currentColor"/>\n</svg>',statusOk:'<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.625a11.27 11.27 0 005.813-1.57 11.746 11.746 0 004.242-4.242A11.269 11.269 0 0023.625 12a11.27 11.27 0 00-1.57-5.813 11.746 11.746 0 00-4.242-4.242A11.27 11.27 0 0012 .375a11.27 11.27 0 00-5.813 1.57 11.747 11.747 0 00-4.242 4.242A11.269 11.269 0 00.375 12c0 2.094.523 4.031 1.57 5.813a11.746 11.746 0 004.242 4.242A11.269 11.269 0 0012 23.625zm0-1.5a9.92 9.92 0 01-5.063-1.36 10.079 10.079 0 01-3.703-3.68c-.906-1.546-1.359-3.234-1.359-5.062 0-1.828.453-3.523 1.36-5.086a10.079 10.079 0 013.679-3.703c1.547-.906 3.234-1.359 5.063-1.359a9.95 9.95 0 015.085 1.36 10.079 10.079 0 013.704 3.679c.906 1.547 1.359 3.234 1.359 5.063a9.963 9.963 0 01-1.36 5.085 10.08 10.08 0 01-3.68 3.704c-1.546.906-3.241 1.359-5.085 1.359zm-2.203-4.313a.446.446 0 00.375-.187l8.484-8.39a.507.507 0 00.14-.376.685.685 0 00-.14-.422l-.422-.375a.445.445 0 00-.375-.187.685.685 0 00-.422.14l-7.64 7.641-3.235-3.281a.685.685 0 00-.421-.14.507.507 0 00-.375.14l-.422.375a.685.685 0 00-.14.422c0 .156.046.281.14.375l4.031 4.078a.583.583 0 00.422.188z" fill="currentColor"/>\n</svg>',atmosLogo:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 219 98">\n  <path class="st0" d="M67.8 73l-.1 2.1c0 1.9.7 4.1 1.8 5.8 1.2 1.7 3.2 2.6 5.3 2.6 2.8 0 4.8-1.4 6.1-3.8l1.4.7c-1.5 3.3-4.9 5-8.4 5-2.8 0-5.2-.7-7.2-2.7s-3.1-4.9-3.1-7.7c0-6 3.8-10.3 9.9-10.4 5 0 9 3.3 8.9 8.5H67.8m10.1-1.8c0-3.1-1.9-5.1-4.8-5.1s-4.9 2.4-5.2 5.1h10zm31.5 8.4c0 2.2.4 3.8 2.9 4h.5v1.2h-11v-1.2h.6c2.6-.2 3-1.7 3-4v-8.5c0-1.1-.1-2.1-.7-3-.6-1-1.8-1.5-2.9-1.5-2.7 0-5.4 1.6-7.4 3.3v9.7c0 2.3.4 3.9 3 4h.6v1.2H86.9v-1.2h.5c2.7-.1 3.2-1.4 3.2-4v-8.6c0-2.3-.4-3.9-3-4h-.7v-1.2l6.3-.9h1.3v3.3c2.5-2.3 5.4-3.7 8.8-3.7 1.6 0 3.3.6 4.5 1.7 1.4 1.2 1.6 2.6 1.6 4.3v9.1zM121 73l-.1 2.1c0 1.9.7 4.1 1.8 5.8 1.2 1.7 3.2 2.6 5.3 2.6 2.8 0 4.8-1.4 6.1-3.8l1.4.7c-1.5 3.3-4.9 5-8.4 5-2.8 0-5.2-.7-7.2-2.7s-3.1-4.9-3.1-7.7c0-6 3.8-10.3 9.9-10.4 5 0 9 3.3 8.9 8.5H121m10.1-1.8c0-3.1-2-5.1-4.8-5.1-2.9 0-4.9 2.4-5.2 5.1h10zm18 8.4c.1 2.4.4 3.9 3.1 4h.7v1.2h-11.4v-1.2h.5c2.7-.2 3.2-1.5 3.2-4v-8.6c0-2.3-.4-3.9-3-4h-.7v-1.2l6.3-.9h1.3v3c1.8-1.9 4.2-3.5 7-3.5 1.4 0 3.1.5 3.1 2.2 0 1.3-1 2.2-2.3 2.2-2 0-2.4-1.4-3.7-1.4-1.4 0-3.1 1.3-4.1 2.3v9.9zm27.3 3c3.1.4 6.7.8 6.7 4.7 0 5.7-6.7 6.5-11.1 6.5-3.4 0-10.1-.5-10.1-4.9 0-2.4 2-3 3.9-3.6v-.1c-1.6-.4-3-1.5-3-3.4 0-2.3 2-3.9 4.1-4.2-2.1-1.2-3.3-3.4-3.3-5.9.2-4.6 4.1-7.3 8.3-7.3 1.3 0 2.6.3 3.8.7 1-1.9 2.5-3.3 4.8-3.3 1.1 0 2.4.5 2.4 1.8 0 .8-.6 1.6-1.5 1.6s-1.7-.7-2.6-.7c-.9 0-1.3.6-1.8 1.2 2.1 1.5 3.4 3.5 3.4 6.2 0 1.9-1 4-2.5 5.2-1.7 1.4-3.9 1.7-6 1.7-1.3 0-2.5-.2-3.7-.7-.8.3-2 1.2-2 2.2 0 1.4 2.3 1.6 3.3 1.7l6.9.6m-9.1 3c-1.6.5-3 1.2-3 2.9 0 3.6 5.2 3.9 7.8 3.9 2.6 0 8-.2 8-3.8 0-2.3-3-2.2-4.7-2.4l-8.1-.6zm.3-14c0 3.1.8 5.7 4.5 5.7 1.4 0 2.9-.7 3.6-1.9.5-1 .7-2.7.7-3.9 0-3-.7-5.6-4.3-5.6-3.5 0-4.5 2.8-4.5 5.7m35.3.1c.4-1 1-2.6 1-3.6 0-1.6-1.6-1.8-2.8-2V65h9.2v1.2c-2.8.5-3.6 1.8-4.6 4.2l-6.6 15.9c-.7 1.8-1.4 3.5-2.7 4.9-1.4 1.5-3.5 2.6-5.5 2.6-1.5 0-3.7-.7-3.7-2.6 0-1.2 1-2.1 2.2-2.1 1.9 0 1.9 2.2 3.8 2.2 2.1 0 3.4-3.4 4.1-5l.2-.3-7-16.9c-.9-2.2-1.1-2.8-3.7-3.1v-1.2h9.9V66c-.9 0-2.3.3-2.3 1.5 0 .5.2.8.4 1.3l4.8 12.1 3.3-9.1zM55 13.1h33.8v13.5H80v30.9H63.8V26.6H55zm50.2 28.3L103 57.5H86.9l6.2-44.4H107l6.7 14.6 6.6-14.6h14l6.2 44.4h-16.1l-2.3-16.1-8.4 16.7zm57.1-28.9c-12.6 0-22.9 10.3-22.9 22.9s10.3 22.9 22.9 22.9c12.6 0 22.9-10.3 22.9-22.9s-10.3-22.9-22.9-22.9m0 30.5c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7M13 29.2L52.1 31l-1.3-3.7L13 29.2zm-1.5 4.4l42.2 1.9-1.3-3.7-40.9 1.8zm-1.6 4.5l45.4 1.8-1.3-3.7L9.9 38zm5.7-12.2l7.6-21h19.4l7.9 21.7zM10 41.3L4.2 57.5h22.7l5.6-16.6zm45.5-.7l6.1 16.9H38.8l-5.5-16.6zm136.7 5.8c-3.7 0-6.9-2.5-6.9-2.5v12.8s4 2.3 10.9 2.3c8.1 0 14.8-6.6 14.8-14.6 0-3.2-1-6.1-2.8-8.5 0 0-2-2.8-4.9-4.7-1.1-.8-3.4-2.2-3.4-3.5 0-2 1.5-3.1 3.9-3.1 3.1 0 5.4 1.4 6.2 2.1l-.5-12.7s-1.9-1.4-8.8-1.4c-8.1 0-15.3 6-15.3 14.1 0 4.4 2.2 9.2 7.3 12.7 0 0 2.4 1.8 3.2 3.6.4.8.2 1.4.2 1.4-.6 1.6-1.9 2.1-3.9 2m15.3 35.2c0-2.3 1.9-4.2 4.2-4.2 2.4 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.8-4.2-4.2m7.8 0c0-2-1.7-3.6-3.6-3.6-1.9 0-3.6 1.6-3.6 3.6s1.7 3.6 3.6 3.6c2 0 3.6-1.6 3.6-3.6m-1.6 2.3h-.7l-1.4-2.1h-.8v2.1h-.7v-4.6h2c.8 0 1.6.2 1.6 1.2 0 .9-.6 1.2-1.5 1.3l1.5 2.1zm-2.1-2.8c.6 0 1.6.1 1.6-.6 0-.5-.6-.6-1.1-.6h-1.2v1.2h.7z"/>\n</svg>',polygon:'<svg viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M8 5.833L.5 10.885V.782L8 5.833z" fill="currentColor"/>\n</svg>',hamburger:'<svg viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill="currentColor" d="M4 0h22v2H4zM2 6h24v2H2zm-2 6h26v2H0z"/>\n</svg>',search:'<svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M14.556 13.356l6.179 6.18c.808.782-.417 2.007-1.2 1.199l-6.179-6.18a8.164 8.164 0 01-10.95-.573c-3.208-3.181-3.208-8.396 0-11.577 3.18-3.207 8.395-3.207 11.576 0a8.164 8.164 0 01.574 10.951zM3.604 3.605a6.5 6.5 0 000 9.178 6.5 6.5 0 009.178 0 6.5 6.5 0 000-9.178 6.5 6.5 0 00-9.178 0z" fill="currentColor"/>\n</svg>',close:'<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M.057 16.998L17.001 0 18 1.002 1.055 18l-.998-1.002z" fill="currentColor"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M.998 0l16.945 16.998L16.944 18 0 1.002.998 0z" fill="currentColor"/>\n</svg>',bell:'<svg viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M23.574 19.676c.475.527.738 1.16.738 1.846 0 .685-.263 1.265-.738 1.74-.474.527-1.055.738-1.793.738h-5.906c0 .95-.37 1.74-1.002 2.373-.685.686-1.476 1.002-2.373 1.002-.95 0-1.74-.316-2.373-1.002-.686-.633-1.002-1.424-1.002-2.373H3.219c-.739 0-1.371-.21-1.846-.738-.475-.475-.685-1.055-.685-1.74 0-.686.263-1.319.79-1.846a8.108 8.108 0 001.16-1.424c.423-.633.739-1.477 1.003-2.479.263-1.16.421-2.636.421-4.43 0-1.37.264-2.636.897-3.849A9.101 9.101 0 017.49 4.541a8.022 8.022 0 013.639-1.53 1.473 1.473 0 01-.316-.949c0-.421.158-.843.474-1.16.316-.316.738-.527 1.213-.527.422 0 .844.21 1.16.527.317.317.527.739.527 1.16 0 .37-.105.686-.316.95a8.072 8.072 0 013.586 1.529 9.1 9.1 0 012.531 2.953 8.156 8.156 0 01.95 3.85c0 1.793.105 3.27.421 4.43.211 1.001.58 1.845 1.002 2.478.211.422.633.896 1.213 1.424zM12.5 25.688c.422 0 .844-.159 1.16-.475.317-.317.527-.738.527-1.213h-3.374c0 .475.158.896.474 1.213.316.316.738.474 1.213.474zm9.281-3.375c.37 0 .633-.159.791-.528a.83.83 0 00-.21-.896c-1.055-1.055-1.846-2.162-2.268-3.375-.58-1.477-.844-3.534-.844-6.17 0-1.213-.316-2.32-.896-3.375a6.976 6.976 0 00-2.479-2.479c-1.055-.58-2.162-.896-3.375-.896-1.266 0-2.373.316-3.428.896-1.054.633-1.845 1.424-2.426 2.479-.632 1.054-.896 2.162-.896 3.375 0 2.636-.316 4.693-.896 6.17-.422 1.213-1.16 2.32-2.215 3.375-.317.263-.37.58-.211.896.105.37.369.527.79.527h18.563z" fill="currentColor"/>\n</svg>',question:'<svg viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <rect width="49" height="49" rx="9" fill="#FEE96C"/>\n  <path d="M22.374 28.9v-.817c0-1.181.182-2.15.545-2.907.363-.767 1.04-1.574 2.028-2.422 1.373-1.16 2.236-2.033 2.589-2.618.363-.585.545-1.292.545-2.12 0-1.029-.333-1.82-1-2.376-.655-.565-1.604-.848-2.845-.848-.797 0-1.574.096-2.331.288-.757.182-1.625.52-2.604 1.014l-.893-2.043c1.907-1 3.9-1.499 5.98-1.499 1.927 0 3.425.475 4.495 1.423 1.07.949 1.604 2.286 1.604 4.011 0 .737-.1 1.388-.302 1.953a5.697 5.697 0 01-.863 1.59c-.384.494-1.211 1.296-2.483 2.406-1.019.868-1.695 1.59-2.028 2.165-.323.575-.484 1.342-.484 2.3v.5h-1.953zm-.742 4.495c0-1.372.606-2.058 1.817-2.058.585 0 1.034.177 1.347.53.323.353.484.863.484 1.528 0 .646-.161 1.15-.484 1.514-.323.353-.772.53-1.347.53-.525 0-.959-.156-1.302-.47-.343-.322-.515-.847-.515-1.574z" fill="#000"/>\n</svg>',homeowners:'<svg viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.977.588A.675.675 0 0112.9.576l10.489 9.546c.912.83.325 2.349-.909 2.349H6.224a.675.675 0 00-.675.675v6.829c0 .373.302.675.675.675h12.262a.675.675 0 00.675-.675v-5.201a.675.675 0 111.35 0v5.201A2.025 2.025 0 0118.486 22H6.224a2.025 2.025 0 01-2.025-2.025v-6.83c0-1.118.906-2.024 2.025-2.024h16.255L12.457 1.999 1.741 12.283a.675.675 0 11-.935-.974L11.977.588z" fill="currentColor"/>\n  <path d="M10.724 16.6c0-.373.302-.675.675-.675h2.025c.372 0 .675.302.675.675v4.05a.675.675 0 01-.675.675h-2.025a.675.675 0 01-.675-.675V16.6z" fill="currentColor"/>\n</svg>',commercialManagers:'<svg viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.239 1.106c0-.39.316-.706.706-.706H27.04c.39 0 .706.316.706.706v21.188c0 .39-.316.706-.706.706H15.174a.706.706 0 110-1.412h11.158V1.813h-13.68v20.48c0 .39-.317.707-.707.707H.907a.706.706 0 01-.706-.706V8.4c0-.39.316-.706.706-.706h7.81a.706.706 0 010 1.413H1.614v12.48h9.625V1.108z" fill="#fff"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.732 13.113c0-.39.317-.707.707-.707h3.53a.706.706 0 110 1.413H4.44a.706.706 0 01-.707-.706zm12.183-5.65c0-.39.316-.707.707-.707h5.65a.706.706 0 010 1.413h-5.65a.706.706 0 01-.707-.706zM3.732 16.997c0-.39.317-.706.707-.706h3.53a.706.706 0 110 1.412H4.44a.706.706 0 01-.707-.706zm12.183-5.65c0-.39.316-.706.707-.706h5.65a.706.706 0 010 1.412h-5.65a.706.706 0 01-.707-.706z" fill="currentColor"/>\n  <path d="M17.857 17.35c0-.39.317-.706.707-.706h2.118c.39 0 .707.316.707.706v4.238c0 .39-.316.706-.707.706h-2.118a.706.706 0 01-.707-.706V17.35z" fill="currentColor"/>\n</svg>',buildersDevelopers:'<svg viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.867 3.366a.63.63 0 01-.176.872c-2.34 1.556-3.49 3.918-3.49 7.02a.629.629 0 11-1.258 0c0-3.458 1.311-6.245 4.052-8.067a.629.629 0 01.872.175zm10.267 0a.629.629 0 01.872-.175c2.74 1.822 4.052 4.609 4.052 8.066a.629.629 0 11-1.258 0c0-3.1-1.15-5.463-3.49-7.02a.629.629 0 01-.176-.87zM8.39.465a.629.629 0 01.468-.208h6.285a.629.629 0 01.626.694l-.943 9.114a.629.629 0 11-1.25-.13l.87-8.42H9.555l.87 8.42a.629.629 0 11-1.25.13L8.232.95a.629.629 0 01.159-.486zm13.234 12.393c1.174-.222 2.32.666 2.32 1.895v.153c0 .69-.382 1.356-1.064 1.644-1.502.634-5.27 1.936-10.88 1.936-5.61 0-9.377-1.302-10.88-1.936-.681-.288-1.062-.955-1.062-1.644v-.153c0-1.23 1.145-2.117 2.319-1.895a53.14 53.14 0 009.623.914c4.113 0 7.684-.546 9.624-.914zm1.062 1.895c0-.406-.394-.742-.828-.66a54.389 54.389 0 01-9.857.936 54.39 54.39 0 01-9.859-.935c-.433-.083-.827.253-.827.66v.152c0 .236.125.414.295.486 1.376.58 4.978 1.837 10.39 1.837 5.413 0 9.015-1.256 10.391-1.837.17-.072.295-.25.295-.486v-.153z" fill="currentColor"/>\n</svg>',firstResponders:'<svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.284.829c0-.347.281-.629.628-.629H19.97a.629.629 0 010 1.257h-9.428V9a.629.629 0 01-.629.629H1.426a.629.629 0 01-.58-.868l2.2-5.343a.629.629 0 01.58-.39h3.458a.629.629 0 110 1.258H4.047L2.365 8.372h6.919V.829zm12.886 0c0-.347.28-.629.628-.629h1.886c.347 0 .628.282.628.629v8.8a.629.629 0 01-.628.628H12.426a.629.629 0 110-1.257h11.629V1.457h-1.257a.629.629 0 01-.629-.628zM24.684 11.2c.347 0 .628.282.628.629v2.514a.629.629 0 01-.628.629h-2.515a.629.629 0 110-1.258h1.886V11.83c0-.347.281-.629.629-.629zm-23.258-.314c.348 0 .629.281.629.629v2.2h1.257a.629.629 0 110 1.257H1.426a.629.629 0 01-.628-.629v-2.829c0-.347.281-.628.628-.628zm8.8 3.457a.63.63 0 01.629-.629h6.6a.629.629 0 010 1.258h-6.6a.629.629 0 01-.629-.629z" fill="currentColor"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.484 14.657a2.514 2.514 0 11-5.029 0 2.514 2.514 0 015.029 0zm-2.515 1.258a1.257 1.257 0 100-2.515 1.257 1.257 0 000 2.514zM8.655 14.657a2.514 2.514 0 11-5.029 0 2.514 2.514 0 015.029 0zm-2.514 1.258a1.257 1.257 0 100-2.515 1.257 1.257 0 000 2.514zM17.33 2.714c.347 0 .628.282.628.629v3.771a.629.629 0 11-1.257 0V3.343c0-.347.281-.629.628-.629z" fill="currentColor"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.97 5.103a.629.629 0 01-.63.629h-3.77a.629.629 0 110-1.257h3.77c.348 0 .63.28.63.628z" fill="currentColor"/>\n</svg>',plumbersContractors:'<svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M12.257 2.875c-2.128 2.128-2.761 5.194-1.972 7.938l-8.6 8.599c-1.486 1.487-1.47 3.928.035 5.434 1.506 1.506 3.947 1.522 5.434.034l6.746-6.91a.688.688 0 00.155-.765.713.713 0 00-.655-.438.693.693 0 00-.494.208L6.16 23.886c-.96.96-2.486.95-3.458-.022-.973-.972-.982-2.498-.022-3.458l8.86-8.86a.689.689 0 00.165-.724c-.83-2.357-.316-5.09 1.547-6.953 1.769-1.77 4.273-2.231 6.528-1.557l-4.342 4.342a.687.687 0 00-.189.608l.513 2.968a.709.709 0 00.574.575l2.968.512a.697.697 0 00.608-.19l4.342-4.34c.674 2.254.212 4.758-1.557 6.527-1.863 1.863-4.624 2.399-6.976 1.57a.706.706 0 00-.537.027.689.689 0 00-.392.671.71.71 0 00.475.627c2.858 1.007 6.177.347 8.424-1.9 2.454-2.454 2.947-6.134 1.502-9.13a.711.711 0 00-.84-.367.687.687 0 00-.28.167L19.17 9.88l-2.125-.361-.36-2.125 4.901-4.902a.687.687 0 00.187-.608.709.709 0 00-.387-.512c-2.996-1.445-6.677-.951-9.13 1.502z" fill="currentColor"/>\n</svg>',next:'<svg viewBox="0 0 18 33" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.053 32L16.72 16.5 1.053 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>',check:'<svg viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M23.45.836c.113-.113.226-.227.452-.227.17 0 .34.114.453.227l.68.623c.113.17.17.34.17.51 0 .226-.057.34-.17.453L8.043 19.414a.692.692 0 01-.51.227.515.515 0 01-.453-.227l-6.74-6.74c-.113-.114-.17-.227-.17-.453 0-.17.057-.34.17-.51l.68-.623c.113-.113.226-.227.453-.227.17 0 .34.114.453.227l5.607 5.607L23.45.835z" fill="currentColor"/>\n</svg>',ban:'<svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M14.5.078c2.492 0 4.871.68 7.023 1.926a13.757 13.757 0 015.098 5.098c1.246 2.152 1.926 4.53 1.926 7.023 0 2.549-.68 4.871-1.926 7.023-1.246 2.153-2.945 3.909-5.098 5.155-2.152 1.246-4.53 1.869-7.023 1.869-2.549 0-4.871-.623-7.023-1.87a14.06 14.06 0 01-5.155-5.154C1.076 18.996.453 16.674.453 14.125c0-2.492.623-4.871 1.87-7.023 1.244-2.153 3-3.852 5.153-5.098C9.629.758 11.95.078 14.5.078zM5.834 22.791c1.473 1.473 3.229 2.549 5.21 3.115 1.983.567 3.966.68 6.005.227a12.349 12.349 0 005.437-2.719L5.211 6.14a12.348 12.348 0 00-2.719 5.437c-.453 2.04-.34 4.022.227 6.004.566 1.983 1.642 3.738 3.115 5.211zm17.955-.68c1.36-1.586 2.209-3.341 2.662-5.38.453-2.04.34-4.022-.226-6.004-.567-1.983-1.643-3.739-3.116-5.211-1.472-1.473-3.228-2.55-5.21-3.116-1.983-.566-3.965-.68-6.005-.226-2.039.453-3.794 1.303-5.38 2.662L23.789 22.11z" fill="currentColor"/>\n</svg>',bolt:'<svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M11.5352 2.4375H4.85156C4.625 2.4375 4.39844 2.55078 4.22852 2.66406C4.00195 2.83398 3.94531 3.00391 3.94531 3.23047L2.8125 15.0117C2.75586 15.3516 2.8125 15.5781 3.03906 15.748C3.20898 15.9746 3.43555 16.0312 3.71875 16.0312H9.72266L6.94727 26.6797C6.83398 27.0195 6.89062 27.2461 7.06055 27.4727C7.23047 27.6992 7.45703 27.8125 7.79688 27.8125C8.13672 27.8125 8.36328 27.6992 8.58984 27.3594L17.1992 11.9531C17.3125 11.6699 17.3125 11.3867 17.1426 11.0469C16.9727 10.7637 16.7461 10.5938 16.4062 10.5938H10.5156L12.4414 3.57031C12.498 3.34375 12.4414 3.06055 12.2715 2.83398C12.0449 2.60742 11.8184 2.4375 11.5352 2.4375ZM11.5352 0.625C12.4414 0.625 13.1211 1.02148 13.6875 1.70117C14.2539 2.4375 14.3672 3.23047 14.1406 4.02344L12.8945 8.78125H16.4062C17.0859 8.78125 17.6523 9.00781 18.1621 9.4043C18.6152 9.85742 18.9551 10.3672 19.0684 10.9902C19.1816 11.6699 19.125 12.2363 18.7852 12.8027L10.1758 28.209C9.89258 28.6621 9.55273 29.0586 9.15625 29.2852C8.70312 29.5117 8.25 29.625 7.79688 29.625C6.89062 29.625 6.21094 29.2852 5.64453 28.6055C5.07812 27.9258 4.96484 27.1328 5.19141 26.2266L7.34375 17.8438H3.71875C2.92578 17.8438 2.24609 17.5605 1.67969 16.9941C1.11328 16.4277 0.886719 15.6914 1 14.8418L2.13281 3.06055C2.18945 2.38086 2.47266 1.81445 2.98242 1.36133C3.49219 0.908203 4.11523 0.625 4.85156 0.625H11.5352Z" fill="currentColor"/>\n</svg>',flashlight:'<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M18.6817 4.58048C18.377 4.27579 17.92 4.27579 17.6153 4.58048L14.3399 7.81779C14.3399 7.81779 14.3399 7.85588 14.3018 7.85588C14.3018 7.89397 14.2637 7.89397 14.2637 7.93205C14.2637 7.97014 14.2256 7.97014 14.2256 8.00822C14.2256 8.04631 14.1875 8.04631 14.1875 8.0844C14.1875 8.12248 14.1495 8.12248 14.1495 8.16057V8.19866L12.5879 13.9116L0.628907 25.8706C0.476563 26.0229 0.400391 26.2134 0.400391 26.4038C0.400391 26.5942 0.476563 26.7847 0.628907 26.937L5.46584 31.7739C5.61818 31.9263 5.80861 32.0025 5.99904 32.0025C6.18947 32.0025 6.3799 31.9263 6.53225 31.7739L18.5294 19.8149L24.2423 18.2534H24.2803C24.3184 18.2534 24.3184 18.2534 24.3565 18.2153C24.3946 18.2153 24.3946 18.1772 24.4327 18.1772C24.4708 18.1772 24.4708 18.1391 24.5089 18.1391C24.547 18.1391 24.547 18.101 24.585 18.101C24.585 18.101 24.6231 18.101 24.6231 18.0629L27.8604 14.8256C28.0128 14.6733 28.089 14.4829 28.089 14.2924C28.089 14.102 28.0128 13.9116 27.8604 13.7592L18.6817 4.58048ZM17.92 18.4057C17.8057 18.4438 17.6915 18.52 17.5772 18.5962L5.99904 30.1743L2.22852 26.4038L13.8067 14.8256C13.8829 14.7495 13.959 14.5971 13.9971 14.4829L15.254 9.83636L22.5665 17.1489L17.92 18.4057ZM24.0518 16.4252L15.9776 8.351L18.1485 6.18009L26.2227 14.2543L24.0518 16.4252Z" fill="currentColor"/>\n<path d="M13.2735 18.063L11.1026 20.2339C10.7979 20.5385 10.7979 20.9956 11.1026 21.3003C11.2549 21.4526 11.4453 21.5288 11.6358 21.5288C11.8262 21.5288 12.0166 21.4526 12.169 21.3003L14.3399 19.1294C14.6446 18.8247 14.6446 18.3676 14.3399 18.063C14.0352 17.7583 13.5782 17.7583 13.2735 18.063Z" fill="currentColor"/>\n<path d="M24.3185 8.0844C24.4709 8.23675 24.6613 8.31292 24.8517 8.31292C25.0421 8.31292 25.2326 8.23675 25.3849 8.0844L28.6222 4.84709C28.9269 4.5424 28.9269 4.08537 28.6222 3.78068C28.3175 3.47599 27.8605 3.47599 27.5558 3.78068L24.3185 7.018C24.0138 7.2846 24.0138 7.77972 24.3185 8.0844Z" fill="currentColor"/>\n<path d="M30.9835 7.93203L27.4796 9.79825C27.0987 9.98868 26.9845 10.4457 27.1749 10.8266C27.3272 11.0932 27.5938 11.2455 27.8605 11.2455C27.9747 11.2455 28.089 11.2074 28.2032 11.1693L31.7071 9.30313C32.088 9.1127 32.2023 8.65567 32.0118 8.27481C31.8214 7.89395 31.3263 7.7416 30.9835 7.93203Z" fill="currentColor"/>\n<path d="M21.5383 5.22793C21.6526 5.3041 21.7668 5.3041 21.8811 5.3041C22.1477 5.3041 22.4143 5.15176 22.5666 4.88516L24.4709 1.38124C24.6614 1.00038 24.5471 0.543343 24.1663 0.352913C23.7854 0.162483 23.3284 0.276741 23.1379 0.657602L21.2336 4.16152C21.0432 4.58047 21.1575 5.0375 21.5383 5.22793Z" fill="currentColor"/>\n</svg>',cigar:'<svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M24.6164 22.062H1.66795C1.18736 22.062 0.796875 22.4525 0.796875 22.9331V27.679C0.796875 28.1596 1.18736 28.55 1.66795 28.55H24.5863C25.0669 28.55 25.4574 28.1596 25.4574 27.679V22.9331C25.4875 22.4525 25.097 22.062 24.6164 22.062ZM2.56907 23.8042H20.0507V26.8079H2.56907V23.8042ZM23.7153 26.8079H21.7628V23.8042H23.7153V26.8079Z" fill="currentColor"/>\n<path d="M9.47614 11.1885V11.579C9.47614 13.9519 11.4286 15.9043 13.8015 15.9043H17.466C19.058 15.9043 20.3196 17.1959 20.3196 18.7579V20.2297C20.3196 20.7103 20.7101 21.1008 21.1907 21.1008C21.6712 21.1008 22.0617 20.7103 22.0617 20.2297V18.7879C22.0617 16.2347 19.9892 14.1622 17.466 14.1622H13.8015C12.3898 14.1622 11.2183 13.0208 11.2183 11.579V10.3775C11.2183 9.8969 10.8278 9.50642 10.3472 9.50642C8.12447 9.50642 6.32224 7.70419 6.32224 5.48143C6.32224 3.76931 7.40357 2.23741 9.02558 1.69674C9.47614 1.54656 9.71644 1.03593 9.56625 0.585368C9.41607 0.13481 8.90544 -0.105488 8.45488 0.0446984C6.14201 0.855703 4.58008 3.04842 4.58008 5.48143C4.58008 8.39504 6.71272 10.768 9.47614 11.1885Z" fill="currentColor"/>\n<path d="M11.8503 3.4387C14.1332 3.4387 15.9654 5.301 15.9654 7.55379C15.9654 8.54502 15.635 9.44614 15.0042 10.1971C14.794 10.4674 14.7339 10.8278 14.8841 11.1282C15.0343 11.4286 15.3347 11.6389 15.6651 11.6389H17.6776C19.1193 11.6389 20.501 12.2096 21.5223 13.2308C22.5436 14.2521 23.1143 15.6338 23.1143 17.0756V20.2595C23.1143 20.7401 23.5048 21.1306 23.9854 21.1306C24.466 21.1306 24.8564 20.7401 24.8564 20.2595V17.0756C24.8564 13.1107 21.6124 9.86666 17.6475 9.86666H17.197C17.4973 9.14577 17.6776 8.33476 17.6776 7.52376C17.6776 4.27974 15.0343 1.6665 11.8203 1.6665C11.3397 1.6665 10.9492 2.05699 10.9492 2.53758C10.9793 3.04821 11.3697 3.4387 11.8503 3.4387Z" fill="currentColor"/>\n</svg>',car:'<svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M9.60938 13.8438C9.60938 13.3906 9.26953 12.8242 8.58984 12.1445C7.91016 11.4648 7.34375 11.125 6.89062 11.125C6.38086 11.125 5.92773 11.3516 5.58789 11.6914C5.24805 12.0312 5.07812 12.4844 5.07812 12.9375C5.07812 13.4473 5.24805 13.9004 5.58789 14.2402C5.92773 14.5801 6.38086 14.75 6.89062 14.75H7.11719C7.85352 14.75 8.41992 14.75 8.75977 14.6367C9.32617 14.5234 9.60938 14.2969 9.60938 13.8438ZM24.1094 11.125C24.5625 11.125 25.0156 11.3516 25.3555 11.6914C25.6953 12.0312 25.9219 12.4844 25.9219 12.9375C25.9219 13.4473 25.6953 13.9004 25.3555 14.2402C25.0156 14.5801 24.5625 14.75 24.1094 14.75H23.8828C23.0898 14.75 22.5801 14.75 22.2402 14.6367C21.6738 14.5234 21.3906 14.2969 21.3906 13.8438C21.3906 13.3906 21.6738 12.8242 22.3535 12.1445C23.0332 11.4648 23.5996 11.125 24.1094 11.125ZM29.9434 6.14062C30 5.91406 29.9434 5.74414 29.8301 5.51758C29.7168 5.34766 29.5469 5.23438 29.3203 5.23438H27.5078C27.168 5.23438 26.9414 5.4043 26.8848 5.6875L26.5449 6.59375L24.8457 2.85547C24.4492 2.0625 23.8828 1.43945 23.1465 0.986328C22.4102 0.533203 21.6172 0.25 20.7109 0.25H10.2891C9.38281 0.25 8.5332 0.533203 7.79688 0.986328C7.06055 1.43945 6.49414 2.0625 6.1543 2.85547L4.45508 6.59375L4.11523 5.6875C4.00195 5.4043 3.83203 5.23438 3.49219 5.23438H1.67969C1.45312 5.23438 1.22656 5.34766 1.11328 5.51758C1 5.74414 0.943359 5.91406 1.05664 6.14062L1.50977 7.5C1.56641 7.83984 1.79297 7.95312 2.13281 7.95312H3.77539C3.15234 8.46289 2.69922 9.08594 2.35938 9.76562C2.01953 10.502 1.90625 11.2383 1.90625 12.0312V15.2031C1.90625 16.1094 2.18945 16.8457 2.8125 17.4121V19.7344C2.8125 20.4141 2.98242 20.9238 3.43555 21.377C3.88867 21.8301 4.39844 22 5.07812 22H7.79688C8.41992 22 8.92969 21.8301 9.38281 21.377C9.83594 20.9238 10.0625 20.4141 10.0625 19.7344V18.375H20.9375V19.7344C20.9375 20.4141 21.1074 20.9238 21.5605 21.377C22.0137 21.8301 22.5234 22 23.2031 22H25.9219C26.5449 22 27.0547 21.8301 27.5078 21.377C27.9609 20.9238 28.1875 20.4141 28.1875 19.7344V17.4121C28.7539 16.8457 29.0938 16.1094 29.0938 15.2031V12.0312C29.0938 11.2383 28.9238 10.502 28.584 9.76562C28.2441 9.08594 27.791 8.46289 27.2246 7.95312H28.8672C29.207 7.95312 29.377 7.83984 29.4902 7.5L29.9434 6.14062ZM6.38086 6.65039L7.79688 3.64844C8.02344 3.19531 8.36328 2.79883 8.81641 2.51562C9.26953 2.23242 9.72266 2.0625 10.2891 2.0625H20.7109C21.2207 2.0625 21.7305 2.23242 22.1836 2.51562C22.6367 2.79883 22.9766 3.19531 23.2031 3.64844L24.6191 6.65039C24.2793 6.65039 23.9961 6.59375 23.6562 6.59375H7.34375C7.00391 6.59375 6.66406 6.65039 6.38086 6.65039ZM8.25 18.375V19.7344C8.25 19.8477 8.19336 19.9609 8.08008 20.0742C7.9668 20.1875 7.91016 20.1875 7.79688 20.1875H5.07812C4.96484 20.1875 4.85156 20.1875 4.73828 20.0742C4.625 19.9609 4.625 19.8477 4.625 19.7344V18.3184C4.73828 18.375 5.36133 18.375 6.4375 18.375H8.25ZM26.375 18.3184V19.7344C26.375 19.8477 26.3184 19.9609 26.2051 20.0742C26.0918 20.1875 26.0352 20.1875 25.9219 20.1875H23.2031C23.0898 20.1875 22.9766 20.1875 22.8633 20.0742C22.75 19.9609 22.75 19.8477 22.75 19.7344V18.375H24.5625C25.582 18.375 26.2051 18.375 26.375 18.3184ZM23.6562 8.40625C24.6191 8.40625 25.4688 8.80273 26.2051 9.48242C26.8848 10.2188 27.2812 11.0684 27.2812 12.0312V15.2031C27.2812 15.5996 27.1113 15.9395 26.8848 16.166C26.6016 16.4492 26.2617 16.5625 25.9219 16.5625H5.07812C4.68164 16.5625 4.3418 16.4492 4.11523 16.166C3.83203 15.9395 3.71875 15.5996 3.71875 15.2031V12.0312C3.71875 11.0684 4.05859 10.2188 4.79492 9.48242C5.47461 8.80273 6.32422 8.40625 7.34375 8.40625H23.6562ZM19.6914 12.9375C19.918 12.9375 20.0312 13.1074 20.0312 13.4473C20.0312 13.7871 19.8613 14.127 19.6348 14.3535C19.3516 14.6367 19.0117 14.75 18.6719 14.75H12.3281C11.9316 14.75 11.5918 14.6367 11.3652 14.3535C11.082 14.127 10.9688 13.7871 10.9688 13.4473C10.9688 13.1074 11.082 12.9375 11.3086 12.9375H19.6914Z" fill="currentColor"/>\n</svg>',tap:'<svg width="36" height="26" viewBox="0 0 36 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M29.0551 13.2613H24.8948V11.6611C24.8948 10.4985 23.9486 9.55233 22.7856 9.55233H20.2379V5.1866H22.3015C23.7318 5.1866 24.8948 4.02321 24.8948 2.59333C24.8948 1.16339 23.7318 0 22.3015 0H13.0534C11.6231 0 10.4601 1.16339 10.4601 2.59333C10.4601 4.02321 11.6231 5.1866 13.0534 5.1866H15.117V9.55233H12.5644C11.407 9.55233 10.4649 10.4985 10.4649 11.6611V13.2613H6.30464C2.82809 13.2613 0 16.0898 0 19.566V25.1828C0 25.5733 0.316269 25.89 0.707201 25.89H6.30464C6.69552 25.89 7.01184 25.5733 7.01184 25.1828V20.2732H10.4649V21.8827C10.4649 23.0457 11.407 23.9918 12.5644 23.9918H22.7856C23.9486 23.9918 24.8948 23.0457 24.8948 21.8827V20.2732H28.3479V25.1828C28.3479 25.5733 28.6642 25.89 29.0551 25.89H34.6525C35.0435 25.89 35.3597 25.5733 35.3597 25.1828V19.566C35.3597 17.883 34.7058 16.3018 33.5172 15.1136C32.3231 13.9192 30.7381 13.2613 29.0551 13.2613ZM11.8745 2.59333C11.8745 1.94345 12.4035 1.4144 13.0534 1.4144H22.3015C22.9514 1.4144 23.4804 1.94345 23.4804 2.59333C23.4804 3.24315 22.9514 3.7722 22.3015 3.7722H19.5307H15.8242H13.0534C12.4035 3.7722 11.8745 3.24315 11.8745 2.59333ZM16.5314 5.1866H18.8235V9.55233H16.5314V5.1866ZM6.30464 18.8588C5.91377 18.8588 5.59744 19.1754 5.59744 19.566V24.4756H1.41435V19.566C1.41435 16.8694 3.60848 14.6757 6.30464 14.6757H10.4649V18.8588H6.30464ZM23.4804 21.8827C23.4804 22.2657 23.1689 22.5774 22.7856 22.5774H12.5644C12.1867 22.5774 11.8793 22.2657 11.8793 21.8827V19.566V13.9685V11.6611C11.8793 11.2782 12.1867 10.9667 12.5644 10.9667H15.8242H19.5307H22.7856C23.1751 10.9667 23.4804 11.2716 23.4804 11.6611V13.9685V19.566V21.8827ZM33.9454 24.4756H29.7623V19.566C29.7623 19.1754 29.446 18.8588 29.0551 18.8588H24.8948V14.6757H29.0551C30.3604 14.6757 31.5897 15.1864 32.5171 16.1136C33.4384 17.0345 33.9454 18.2607 33.9454 19.566V24.4756Z" fill="currentColor"/>\n</svg>',thumbsup:'<svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M20.0234 13.082C20.1953 14.0273 20.0664 14.9297 19.6367 15.7891C19.6797 16.3047 19.6367 16.7773 19.5078 17.293C19.3789 17.8086 19.1641 18.2812 18.9062 18.668C18.8633 19.957 18.4766 20.9023 17.7031 21.5898C16.8438 22.3633 15.6406 22.75 14.0508 22.75H13.1055C11.9023 22.75 10.7852 22.6211 9.79688 22.3633C9.19531 22.2344 8.50781 21.9766 7.64844 21.6328C7.13281 21.4609 6.74609 21.2891 6.53125 21.2031C6.14453 21.1172 5.80078 21.0312 5.45703 21.0312C5.37109 21.332 5.19922 21.5898 4.94141 21.7617C4.68359 21.9766 4.42578 22.0625 4.125 22.0625H1.375C0.988281 22.0625 0.644531 21.9336 0.386719 21.6758C0.128906 21.418 0 21.0742 0 20.6875V10.375C0 10.0312 0.128906 9.6875 0.386719 9.42969C0.644531 9.17188 0.988281 9 1.375 9H5.62891C5.88672 8.74219 6.40234 8.18359 7.08984 7.28125C7.77734 6.37891 8.25 5.77734 8.59375 5.43359C8.67969 5.34766 8.80859 4.91797 8.98047 4.1875C9.23828 3.15625 9.49609 2.42578 9.75391 1.95312C10.1836 1.17969 10.8281 0.75 11.6445 0.75C12.9336 0.75 13.9219 1.13672 14.6523 1.82422C15.3828 2.59766 15.7695 3.75781 15.7695 5.26172C15.7695 5.94922 15.6406 6.59375 15.3828 7.23828H16.9297C17.9609 7.23828 18.8203 7.625 19.5508 8.35547C20.2383 9.12891 20.625 9.98828 20.625 10.9336C20.625 11.707 20.4102 12.3945 20.0234 13.082ZM17.4023 15.4023C17.832 14.9727 18.0469 14.5 18.0469 13.9414C18.0469 13.3828 17.918 12.9102 17.6172 12.5664C17.7891 12.5664 18.0039 12.3945 18.2188 12.0508C18.4336 11.707 18.5625 11.3633 18.5625 10.9336C18.5625 10.5469 18.3906 10.1602 18.0898 9.81641C17.7461 9.47266 17.3594 9.30078 16.9297 9.30078H12.4609C12.4609 8.95703 12.5039 8.61328 12.6758 8.22656C12.7188 8.05469 12.8477 7.75391 13.0625 7.32422C13.2344 6.9375 13.4062 6.63672 13.4922 6.37891C13.6211 6.03516 13.707 5.64844 13.707 5.26172C13.707 4.53125 13.6211 3.97266 13.4492 3.62891C13.1055 3.11328 12.5039 2.8125 11.6445 2.8125C11.4727 2.98438 11.3438 3.24219 11.2578 3.54297C11.1719 3.71484 11.1289 4.01562 11.043 4.44531C10.9141 5.04688 10.8281 5.47656 10.7422 5.73438C10.5703 6.20703 10.3125 6.59375 10.0117 6.89453C9.75391 7.15234 9.36719 7.66797 8.76562 8.44141C8.12109 9.30078 7.64844 9.90234 7.34766 10.2031C6.78906 10.8047 6.31641 11.0625 5.97266 11.0625H5.5V19.0547C5.97266 19.0547 6.48828 19.1406 7.08984 19.2695C7.43359 19.3555 7.94922 19.5273 8.63672 19.7852C9.49609 20.0859 10.1406 20.3008 10.6133 20.3867C11.3867 20.6016 12.1172 20.6875 12.8906 20.6875H14.4805C15.2969 20.6875 15.8984 20.4727 16.3281 20.043C16.7578 19.6133 16.9297 18.8828 16.8008 17.8516C17.1445 17.6797 17.3594 17.3359 17.5312 16.8203C17.6602 16.3047 17.6172 15.832 17.4023 15.4023ZM3.78125 19.3125C3.78125 19.0547 3.65234 18.7969 3.48047 18.582C3.26562 18.4102 3.00781 18.2812 2.75 18.2812C2.44922 18.2812 2.19141 18.4102 2.01953 18.582C1.80469 18.7969 1.71875 19.0547 1.71875 19.3125C1.71875 19.6133 1.80469 19.8711 2.01953 20.043C2.19141 20.2578 2.44922 20.3438 2.75 20.3438C3.00781 20.3438 3.26562 20.2578 3.48047 20.043C3.65234 19.8711 3.78125 19.6133 3.78125 19.3125Z" fill="currentColor"/>\n</svg>',thumbsdown:'<svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M20.0234 10.418C20.4102 11.1055 20.625 11.8359 20.625 12.5664C20.625 13.5547 20.2383 14.4141 19.5508 15.1445C18.8203 15.918 17.9609 16.2617 16.9297 16.2617H15.3828C15.6406 16.9492 15.7695 17.5938 15.7695 18.2383C15.7695 19.7852 15.3828 20.9023 14.6523 21.6758C13.9219 22.4062 12.9336 22.75 11.6445 22.75C10.8281 22.75 10.1836 22.3633 9.75391 21.5469C9.49609 21.1172 9.23828 20.3438 8.98047 19.3125C8.80859 18.625 8.67969 18.1953 8.59375 18.0664C8.25 17.7656 7.77734 17.1641 7.08984 16.2617C6.40234 15.3594 5.88672 14.7578 5.62891 14.5H5.32812C5.15625 14.7148 4.98438 14.8867 4.8125 15.0156C4.59766 15.1445 4.38281 15.1875 4.125 15.1875H1.375C0.988281 15.1875 0.644531 15.0586 0.386719 14.8008C0.128906 14.543 0 14.1992 0 13.8125V3.5C0 3.15625 0.128906 2.8125 0.386719 2.55469C0.644531 2.29688 0.988281 2.125 1.375 2.125H4.125C4.46875 2.125 4.76953 2.25391 5.02734 2.46875H5.5C5.80078 2.46875 6.14453 2.42578 6.48828 2.29688C6.70312 2.25391 7.04688 2.125 7.5625 1.91016C8.42188 1.56641 9.15234 1.30859 9.75391 1.13672C10.7852 0.878906 11.9023 0.75 13.1055 0.75H14.0508C15.6406 0.75 16.8438 1.13672 17.7031 1.91016C18.4766 2.59766 18.8633 3.58594 18.9062 4.83203C19.1641 5.26172 19.3789 5.69141 19.5078 6.20703C19.6367 6.72266 19.6797 7.23828 19.6367 7.71094C20.0664 8.57031 20.1953 9.47266 20.0234 10.418ZM2.75 13.4688C3.00781 13.4688 3.26562 13.3828 3.48047 13.168C3.65234 12.9961 3.78125 12.7383 3.78125 12.4375C3.78125 12.1797 3.65234 11.9219 3.48047 11.707C3.26562 11.5352 3.00781 11.4062 2.75 11.4062C2.44922 11.4062 2.19141 11.5352 2.01953 11.707C1.80469 11.9219 1.71875 12.1797 1.71875 12.4375C1.71875 12.7383 1.80469 12.9961 2.01953 13.168C2.19141 13.3828 2.44922 13.4688 2.75 13.4688ZM16.9297 14.1992C17.3594 14.1992 17.7461 14.0273 18.0898 13.6836C18.3906 13.3398 18.5625 12.9961 18.5625 12.5664C18.5625 12.1797 18.4336 11.793 18.2188 11.4492C18.0039 11.1055 17.7891 10.9336 17.6172 10.9336C17.918 10.5898 18.0469 10.1602 18.0469 9.60156C18.0469 9.04297 17.832 8.52734 17.4023 8.09766C17.6172 7.66797 17.6602 7.23828 17.5312 6.72266C17.3594 6.20703 17.1445 5.86328 16.8008 5.64844C16.9297 4.66016 16.7578 3.92969 16.3281 3.45703C15.8984 3.02734 15.2969 2.8125 14.4805 2.8125H12.8906C12.1172 2.8125 11.3867 2.94141 10.6133 3.11328C10.1406 3.24219 9.49609 3.45703 8.63672 3.71484C7.94922 3.97266 7.43359 4.14453 7.08984 4.23047C6.48828 4.40234 5.97266 4.44531 5.5 4.44531V12.4375H5.97266C6.31641 12.4375 6.78906 12.7383 7.34766 13.2969C7.64844 13.6406 8.12109 14.1992 8.76562 15.0586C9.36719 15.875 9.75391 16.3906 10.0117 16.6055C10.3125 16.9492 10.5703 17.3359 10.7422 17.7656C10.8281 18.0664 10.9141 18.4961 11.043 19.0547C11.1289 19.4844 11.1719 19.7852 11.2578 19.957C11.3438 20.3008 11.4727 20.5156 11.6445 20.6875C12.5039 20.6875 13.1055 20.4297 13.4492 19.8711C13.6211 19.5273 13.707 19.0117 13.707 18.2383C13.707 17.8945 13.6211 17.5078 13.4922 17.1211C13.4062 16.9062 13.2344 16.6055 13.0625 16.1758C12.8477 15.7891 12.7188 15.4883 12.6758 15.2734C12.5039 14.9297 12.4609 14.543 12.4609 14.1992H16.9297Z" fill="currentColor"/>\n</svg>',chevronDown:'<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3047 0.429688H17.2656C17.3438 0.507812 17.4219 0.625 17.4219 0.742188C17.4219 0.898438 17.3438 1.01562 17.2656 1.09375L9.02344 9.33594C8.94531 9.41406 8.82812 9.45312 8.71094 9.45312C8.55469 9.45312 8.4375 9.41406 8.35938 9.33594L0.117188 1.09375C0.0390625 1.01562 0 0.898438 0 0.742188C0 0.625 0.0390625 0.507812 0.117188 0.429688L0.429688 0.117188C0.507812 0.0390625 0.585938 0 0.742188 0C0.859375 0 0.976562 0.0390625 1.09375 0.117188L8.71094 7.77344L16.3281 0.117188C16.4062 0.0390625 16.5234 0 16.6797 0C16.7969 0 16.9141 0.0390625 16.9922 0.117188L17.3047 0.429688Z" fill="currentColor"/></svg>',pdf:'<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M15.1758 4.64453C15.5449 5.05469 15.75 5.50586 15.75 6.03906V19.6562C15.75 20.2305 15.5449 20.6816 15.1758 21.0508C14.7656 21.4609 14.3145 21.625 13.7812 21.625H1.96875C1.39453 21.625 0.943359 21.4609 0.574219 21.0508C0.164062 20.6816 0 20.2305 0 19.6562V2.59375C0 2.06055 0.164062 1.60938 0.574219 1.19922C0.943359 0.830078 1.39453 0.625 1.96875 0.625H10.3359C10.8691 0.625 11.3203 0.830078 11.7305 1.19922L15.1758 4.64453ZM14.2324 5.58789L10.7871 2.14258C10.7051 2.06055 10.582 2.01953 10.5 1.9375V5.875H14.4375C14.3555 5.79297 14.3145 5.66992 14.2324 5.58789ZM13.7812 20.3125C13.9453 20.3125 14.1094 20.2715 14.2324 20.1484C14.3555 20.0254 14.4375 19.8613 14.4375 19.6562V7.1875H10.1719C9.88477 7.1875 9.63867 7.10547 9.47461 6.90039C9.26953 6.73633 9.1875 6.49023 9.1875 6.20312V1.9375H1.96875C1.76367 1.9375 1.59961 2.01953 1.47656 2.14258C1.35352 2.26562 1.3125 2.42969 1.3125 2.59375V19.6562C1.3125 19.8613 1.35352 20.0254 1.47656 20.1484C1.59961 20.2715 1.76367 20.3125 1.96875 20.3125H13.7812ZM12.8789 13.2988C13.002 13.4629 13.084 13.668 13.125 13.9141C13.125 14.2012 13.043 14.4473 12.8789 14.6523C12.7148 14.8574 12.4277 14.9395 12.0996 14.9395C11.7715 14.9395 11.3613 14.8984 10.8691 14.7344C10.377 14.5703 9.88477 14.3652 9.47461 14.1191C8.90039 14.2422 7.95703 14.4883 6.72656 14.8984L6.11133 15.1035C5.61914 15.9648 5.16797 16.5801 4.79883 16.9902C4.42969 17.4004 4.06055 17.6465 3.69141 17.6875C3.36328 17.7285 3.07617 17.6465 2.87109 17.4414C2.66602 17.2363 2.58398 16.9902 2.625 16.7441C2.78906 16.0879 3.56836 15.3496 5.04492 14.5703C5.53711 13.709 6.11133 12.5195 6.76758 10.9609C6.5625 10.2227 6.43945 9.60742 6.39844 9.11523C6.31641 8.58203 6.31641 8.13086 6.43945 7.76172C6.48047 7.51562 6.64453 7.35156 6.93164 7.26953C7.21875 7.1875 7.50586 7.1875 7.79297 7.31055C8.03906 7.43359 8.20312 7.67969 8.28516 8.04883C8.36719 8.37695 8.36719 8.78711 8.28516 9.2793C8.24414 9.60742 8.16211 10.0176 8.03906 10.5508L7.99805 10.6738C8.4082 11.7402 9.02344 12.5195 9.84375 13.0117C11.4434 12.8066 12.4688 12.8887 12.8789 13.2988ZM3.48633 16.9492C3.48633 16.9902 3.52734 16.9492 3.69141 16.8262C3.81445 16.7441 3.97852 16.5801 4.14258 16.334C4.38867 16.0879 4.63477 15.7188 4.92188 15.2676L4.79883 15.3906C4.06055 16.0469 3.60938 16.5801 3.48633 16.9492ZM7.38281 7.80273V7.84375C7.30078 7.84375 7.30078 8.08984 7.30078 8.58203C7.30078 9.07422 7.3418 9.48438 7.46484 9.77148C7.58789 9.56641 7.62891 9.19727 7.62891 8.62305C7.62891 8.08984 7.54688 7.80273 7.38281 7.80273ZM6.23438 14.3652L6.76758 14.1191C7.62891 13.791 8.32617 13.5449 8.81836 13.4629C8.24414 13.0527 7.75195 12.4785 7.38281 11.7402C6.97266 12.8477 6.5625 13.709 6.23438 14.3652ZM12.5098 14.1191C12.5918 14.0781 12.5508 14.0371 12.4688 13.9551C12.3867 13.873 12.2227 13.832 11.9766 13.75C11.6484 13.709 11.2383 13.709 10.7461 13.75C11.1562 13.9551 11.5664 14.0781 11.8945 14.1191C12.0996 14.2012 12.2637 14.2012 12.3867 14.1602C12.4277 14.1602 12.4688 14.1602 12.5098 14.1191Z" fill="currentColor"/>\n</svg>',arrowRight:'<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M12.2344 0.675781C12.3477 0.5625 12.5176 0.505859 12.7441 0.505859C12.9141 0.505859 13.084 0.5625 13.1973 0.675781L25.1484 12.6836C25.2617 12.7969 25.375 12.9668 25.375 13.1367C25.375 13.3633 25.2617 13.4766 25.1484 13.5898L13.1973 25.5977C13.084 25.7109 12.9141 25.7676 12.7441 25.7676C12.5176 25.7676 12.3477 25.7109 12.2344 25.5977L11.8379 25.1445C11.7246 25.0312 11.668 24.918 11.668 24.6914C11.668 24.5215 11.7246 24.3516 11.8379 24.1816L21.9766 14.0996H0.679688C0.453125 14.0996 0.283203 14.043 0.169922 13.9297C0.0566406 13.8164 0 13.6465 0 13.4199V12.8535C0 12.6836 0.0566406 12.5137 0.169922 12.4004C0.283203 12.2871 0.453125 12.1738 0.679688 12.1738H21.9766L11.8379 2.0918C11.7246 1.97852 11.668 1.80859 11.668 1.58203C11.668 1.41211 11.7246 1.24219 11.8379 1.12891L12.2344 0.675781Z" fill="currentColor"/>\n</svg>',file:'<svg width="22" height="30" viewBox="0 0 22 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M20.957 5.92578C21.4668 6.49219 21.75 7.11523 21.75 7.85156V26.6562C21.75 27.4492 21.4668 28.0723 20.957 28.582C20.3906 29.1484 19.7676 29.375 19.0312 29.375H2.71875C1.92578 29.375 1.30273 29.1484 0.792969 28.582C0.226562 28.0723 0 27.4492 0 26.6562V3.09375C0 2.35742 0.226562 1.73438 0.792969 1.16797C1.30273 0.658203 1.92578 0.375 2.71875 0.375H14.2734C15.0098 0.375 15.6328 0.658203 16.1992 1.16797L20.957 5.92578ZM19.6543 7.22852L14.8965 2.4707C14.7832 2.35742 14.6133 2.30078 14.5 2.1875V7.625H19.9375C19.8242 7.51172 19.7676 7.3418 19.6543 7.22852ZM19.0312 27.5625C19.2578 27.5625 19.4844 27.5059 19.6543 27.3359C19.8242 27.166 19.9375 26.9395 19.9375 26.6562V9.4375H14.0469C13.6504 9.4375 13.3105 9.32422 13.084 9.04102C12.8008 8.81445 12.6875 8.47461 12.6875 8.07812V2.1875H2.71875C2.43555 2.1875 2.20898 2.30078 2.03906 2.4707C1.86914 2.64062 1.8125 2.86719 1.8125 3.09375V26.6562C1.8125 26.9395 1.86914 27.166 2.03906 27.3359C2.20898 27.5059 2.43555 27.5625 2.71875 27.5625H19.0312Z" fill="currentColor"/>\n</svg>',pin:'<svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M12 6.67105C12 7.35788 11.6666 8.55116 11.0556 10.0817C10.4627 11.5669 9.66593 13.2337 8.86007 14.8061C8.05576 16.3755 7.25033 17.8357 6.64537 18.9044C6.5955 18.9925 6.54701 19.078 6.5 19.1605C6.453 19.078 6.4045 18.9925 6.35463 18.9044C5.74967 17.8357 4.94424 16.3755 4.13994 14.8061C3.33408 13.2337 2.53727 11.5669 1.94436 10.0817C1.33336 8.55116 1 7.35788 1 6.67105C1 3.62146 3.46493 1.15381 6.5 1.15381C9.53507 1.15381 12 3.62146 12 6.67105Z" fill="white" stroke="white" stroke-width="2"/>\n<g transform="translate(5, 4)">\n<path d="M4.5 3.25L-3.05875e-07 6.4976L-2.19608e-08 0.00240449L4.5 3.25Z" fill="#2175D9"/>\n</g>\n</svg>'};let Ti=class extends $t{constructor(){super(...arguments),this.url="",this.svg=!1}render(){const t=void 0!==Ri[this.icon]?Ri[this.icon]:this.url;return this.svg?Y`${Zi[this.icon]?Ot(Zi[this.icon]):""}`:Y` <img src=${t} alt=${this.icon} />`}};Ti.styles=[ji],p([ut()],Ti.prototype,"icon",void 0),p([ut()],Ti.prototype,"url",void 0),p([ut({type:Boolean})],Ti.prototype,"svg",void 0),Ti=p([ht("atmos-icon")],Ti);var Ni=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 2rem;
  padding-bottom: 3rem;
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
}

.phone a {
  margin-bottom: 1.5rem;
  display: block;
  font-family: Futura Std Light, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-light);
  color: var(--neutral-white);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  font-size:30px;
}

.wrapper{
  align-items:center;
  display:flex;
  flex-direction:column;
}

.icon {
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  align-items:center;
  border:2px solid #fee96c;
  display:flex;
  height:88px;
  justify-content:center;
  width:88px;
}

.icon.cta{
  border-color:var(--brand-secondary);
}

.icon atmos-icon {
  color: var(--neutral-white);
  stroke:transparent;
  width:37px;
  min-width:37px;
  min-height:37px;
  color:#fee96c;
}

.icon.cta atmos-icon {
  color: var(--brand-secondary);
}

@media only screen and (min-width: 640px){
  :host {
    padding-top: 4rem;
  }
  :host {
    padding-bottom: 4rem;
  }

  .phone{
    font-size:36px;
    margin:0;
  }

  .wrapper{
    align-items:flex-start;
    flex-direction:row;
    justify-content:center;
  }

  .icon {
    margin-bottom: 0px;
  }

  .icon {
    margin-right: 3rem;
  }

  .icon atmos-icon{
    min-width:43px;
    min-height:43px;
  }

  .content{
    max-width:308px;
  }
}
`;let Pi=class extends $t{constructor(){super(...arguments),this.url="#",this.cta=null}render(){const t=this.phone.replace(/-/g,".");return Y`
      <div class="wrapper">
        <div class="icon ${this.cta?"cta":""}">
          <atmos-icon icon="${this.icon}" svg="true"></atmos-icon>
        </div>
        <atmos-feature-content
          class="content"
          url="${this.url}"
          type="none"
          variant="reverse"
          title="${this.title}"
          text="${this.text}"
          link="${this.link}"
          target="${this.target}"
          rel="${this.rel}"
          link-title="${this.linkTitle}"
          button-size="responsive"
        >
          <span class="phone"
            ><a href="tel:${this.phone}">${t}</a></span
          >
        </atmos-feature-content>
      </div>
    `}};Pi.styles=[Ni],p([ut({type:String})],Pi.prototype,"url",void 0),p([ut({type:String})],Pi.prototype,"link",void 0),p([ut({type:String})],Pi.prototype,"target",void 0),p([ut({type:String})],Pi.prototype,"rel",void 0),p([ut({type:String,attribute:"link-title"})],Pi.prototype,"linkTitle",void 0),p([ut({type:String})],Pi.prototype,"title",void 0),p([ut({type:String})],Pi.prototype,"text",void 0),p([ut({type:String})],Pi.prototype,"phone",void 0),p([ut({type:String})],Pi.prototype,"icon",void 0),p([ut({type:String})],Pi.prototype,"cta",void 0),Pi=p([ht("atmos-icon-card")],Pi);var Yi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:flex;
  align-items:center;
}

atmos-icon.dark{
  color:var(--neutral-grayDark);
}

atmos-icon.light{
  color:var(--neutral-white);
}

atmos-icon{
  min-width:37px;
  min-height:37px;
}

a{
  line-height:1;
}
`;const Ii={twitter:"Twitter",facebook:"Facebook",linkedin:"Linkedin",instagram:"Instagram",youtube:"Youtube",email:"Mailto",print:"javascript:"};let Ui=class extends $t{constructor(){super(...arguments),this.variant="dark",this.setSocialMedia=()=>{const t=this.linkUrl.toLowerCase();Object.entries(Ii).forEach((([e,i])=>{t.includes(i.toLowerCase())&&(this.iconMedia=e)}))}}connectedCallback(){super.connectedCallback(),this.setSocialMedia()}render(){const t=Ii[this.iconMedia];return Y`
      <a
        href="${this.linkUrl}"
        target="${"print"!==this.iconMedia&&"email"!==this.iconMedia?"_blank":"_self"}"
      >
        <atmos-icon class="${this.variant}" icon="${this.iconMedia}" svg="true">
          ${t}</atmos-icon
        >
      </a>
    `}};Ui.styles=[Yi],p([ut({type:String})],Ui.prototype,"linkUrl",void 0),p([ut({reflect:!0,attribute:"variant"})],Ui.prototype,"variant",void 0),Ui=p([ht("atmos-icon-link")],Ui);var Wi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outer-wrapper{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.wrapper {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  align-items:center;
  display:flex;
  flex-direction:column;
}

.title-wrapper-desktop{
  display:none;
}

.icon {
  position: relative;
  align-items:center;
  display:flex;
  justify-content:center;
  height:177px;
  overflow:hidden;
  width:177px;
}

.icon atmos-icon{
  display:block;
  min-width:54px;
  min-height:54px;
}

.icon svg{
  position:absolute;
  top:0;
  left:0;
  transform:translate(-12px, -58px);
  width:109%;
}

.title {
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  margin-bottom: 1rem;
  letter-spacing:-0.02em;
  line-height:116%;
  margin-top:29px;
  margin-bottom:17px;
}

atmos-icon {
  color: var(--neutral-white);
  stroke:transparent;
  width:37px;
  color:#fee96c;
}

.title span {
  color: var(--brand-secondary);
}

.text {
  margin-bottom: 1rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

.phone {
  display: block !important;
  font-family: Futura Std Light, Helvetica, Arial, sans-serif !important;
  font-weight: var(--fw-light) !important;
  color: var(--neutral-white) !important;
  -webkit-text-decoration-line: none !important;
          text-decoration-line: none !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-size:36px;
  letter-spacing:-0.01em;
}

::slotted([slot='cta']) {
  display: block !important;
  font-family: Futura Std Light, Helvetica, Arial, sans-serif !important;
  font-weight: var(--fw-light) !important;
  color: var(--brand-secondary) !important;
  -webkit-text-decoration-line: none !important;
          text-decoration-line: none !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-size:36px;
  letter-spacing:-0.01em;
}

@media only screen and (max-width: 1280px){
  .mask{
    display:none;
  }
}

@media only screen and (min-width: 480px){
  .wrapper{
    align-items:center;
    flex-direction:row;
    justify-content:center;

    padding:60px 48px;
  }

  .info{
    flex:2 1 0;
  }

  .icon-container{
    flex:1 1 0;
    max-width:110px;
    margin-right:48px;
    align-self:flex-start;
  }

  .icon{
    height:auto;
    margin-right:48px;
    margin-left:auto;
    width:113px;
    height:113px;
  }

  .phone {
    margin-bottom: 0px;
  }

  .icon atmos-icon{
    width:57px;
  }

  .icon svg{
    transform:translate(-7px, -3px);
    width:108%;
    height:auto;
  }

  .title {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }

  .title {
    margin-top: 0px;
  }
}

@media only screen and (min-width: 640px){
  .wrapper{
    max-width:670px;
    margin:auto;
    padding:60px 48px;
  }
}

@media only screen and (min-width: 1280px){
    .full-width .wrapper{
      justify-content:center;
      margin-left:auto;
      margin-right:auto;
      max-width:1240px;
      position:relative;
    }

    .full-width .phone {
    margin-bottom: 0px;
  }

    .full-width .title-wrapper-desktop{
      display:flex;
      align-items:center;
      position:relative;
      width:100%;
    }

    .full-width .title-wrapper-mobile{
      display:none;
    }

    .full-width .icon{
      margin-left:0;
      margin-right:auto;
      min-width:271px;
      height:271px;
      width:271px;
    }
    .full-width .info{
      max-width:446px;
      margin-right:auto;
      flex:1 1 0;
      margin-left:5rem;
    }

    .full-width .icon svg{
      transform:translate(-19px, -9px);
      width:109%;
    }

    .full-width .icon atmos-icon{
      width:83px;
    }

    .full-width .title {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }

    .full-width .title{

      margin-bottom:0;
      position:absolute;
      left:-48px;
      margin-top:4px;
    }

    .full-width .icon-container{
      display:flex;
      margin-right:2rem;
      max-width:40rem;
    }
}
`;let qi=class extends hi{parsePhone(t){return t.replace(/[^\d]/g,"")}withinTwoColumn(){return this.closest("#twocolumn")?this.twoColumn=!0:this.twoColumn=!1}getIcon(){return this.icon?Y`<div class="icon-container">
        <div class="icon">
          <svg
            width="297"
            height="298"
            viewBox="0 0 297 298"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="297"
              height="298"
              class="mask"
            >
              <path
                d="M182 139C214 130.334 280.2 98.2 297 99L291 82L249 29L202 0H129L62.0001 23L31 48L1.00008 99C2.00008 114.333 3.40008 150.2 1.00008 171C-1.39992 191.8 15.3334 223.667 24.0001 237L62.0001 269C82.0001 278.667 123.4 298 129 298C136 298 182 296 194 293C203.6 290.6 238.667 272 255 263L291 203L182 139Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#mask0)">
              <circle
                cx="154.5"
                cy="144.5"
                r="134.5"
                stroke="#FEE96C"
                stroke-width="2"
              />
            </g>
          </svg>
          ${this.icon?Y`<atmos-icon svg="true" icon="${this.icon}" />`:""}
        </div>
        <div class="title-wrapper-desktop">${this.getTitle()}</div>
      </div>`:""}connectedCallback(){super.connectedCallback(),this.withinTwoColumn()}render(){return Y` <div
      class="outer-wrapper ${this.twoColumn?"":"full-width"}"
    >
      <div class="wrapper">
        ${this.getIcon()}
        <div class="info">
          <div class="title-wrapper-mobile">${this.getTitle()}</div>
          ${this.getText()}
          ${this.ctaLinkUrl&&this.ctaLinkText||this.ctaPhone?Y`<atmos-feature-content
                class="content"
                url="${this.ctaLinkUrl}"
                target="${this.target}"
                rel="${this.rel}"
                link-title="${this.linkTitle}"
                type="none"
                variant="reverse"
                link="${this.ctaLinkText}"
                button-size="responsive"
              >
                ${this.ctaPhone?Y`<a
                      href="tel:${this.parsePhone(this.ctaPhone)}"
                      class="phone"
                      >${this.ctaPhone}</a
                    >`:null}
              </atmos-feature-content>`:null}
        </div>
      </div>
    </div>`}};qi.styles=[Wi],p([ut({type:String,attribute:"icon"})],qi.prototype,"icon",void 0),p([ut({type:String,attribute:"cta-link-url"})],qi.prototype,"ctaLinkUrl",void 0),p([ut({type:String,attribute:"cta-link-text"})],qi.prototype,"ctaLinkText",void 0),p([ut({type:String,attribute:"target"})],qi.prototype,"target",void 0),p([ut({type:String,attribute:"rel"})],qi.prototype,"rel",void 0),p([ut({type:String,attribute:"link-title"})],qi.prototype,"linkTitle",void 0),p([ut({type:String,attribute:"cta-phone"})],qi.prototype,"ctaPhone",void 0),p([gt()],qi.prototype,"twoColumn",void 0),qi=p([ht("atmos-icon-promo")],qi);var Gi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.media-card-wrapper{
  max-width:1200px;
  margin:0 auto;
}

.media-card-wrapper ::slotted(img){
  display:block;
  width:100%;
}

.media-card-wrapper.full-width ::slotted(img),
.media-card-wrapper.full-width-reverse ::slotted(img){
  max-width:100% !important;
  height:100% !important;
  object-fit:cover;
}

.media-card-wrapper.full-width{
  display:flex;
  flex:1;
  box-sizing:border-box;
  overflow:hidden;
  align-items:center;
}

.media-card-wrapper.full-width-reverse{
  display:flex;
  flex:1;
  box-sizing:border-box;
  flex-direction:row-reverse;
}

.media-card-wrapper.full-width .image-wrapper{
  position:relative;
}

.media-card-wrapper.full-width .image-wrapper,
.media-card-wrapper.full-width atmos-feature-content,
.media-card-wrapper.full-width-reverse .image-wrapper,
.media-card-wrapper.full-width-reverse atmos-feature-content{
  width:50%;
  align-items:center;
}

.media-card-wrapper atmos-feature-content{
  display:flex;
}

.media-card-wrapper.full-width atmos-feature-content{
  display:flex;
  box-sizing:border-box;
}

@media only screen and (min-width: 1023px){
  .media-card-wrapper.full-width atmos-feature-content{
    padding:5% 5%;
  }
}

.media-card-wrapper.blue atmos-feature-content{
  background:linear-gradient(
    28.01deg,
    rgb(0, 83, 183) 16.5%,
    rgb(0, 116, 255) 85.96%
  );
  display:flex;
}

.media-card-wrapper.gray atmos-feature-content{
  background:linear-gradient(
    355.13deg,
    rgb(46, 46, 46) 5.24%,
    rgb(59, 69, 81) 90.93%
  );
  display:flex;
}

.media-card-wrapper.white atmos-feature-content{
  background:#ffffff;
  display:flex;
}

@media (max-width: 768px){
  .media-card-wrapper.full-width,
  .media-card-wrapper.full-width-reverse{
    flex-flow:column;
  }

  .media-card-wrapper.full-width .image-wrapper,
  .media-card-wrapper.full-width atmos-feature-content,
  .media-card-wrapper.full-width-reverse .image-wrapper,
  .media-card-wrapper.full-width-reverse atmos-feature-content{
    width:100%;
  }
}
`;let Qi=class extends fi{getMedia(){return Y`<div class="image-wrapper">
      ${this.url?Y`
            <a href="${this.url}" title="${this.title}" target="${this.target}">
              <slot name="image"></slot>
            </a>
          `:Y` <slot name="image"></slot> `}
    </div>`}render(){return Y`
      <div
        class="image-card-wrapper media-card-wrapper ${this.layout} ${this.type}"
      >
        ${this.getMedia()}
        <atmos-feature-content
          parent="imageCard"
          url="${At(this.url)}"
          variant="${this.variant}"
          type="white"
          title="${this.title}"
          text="${this.text}"
          link="${this.link}"
          target="${this.target}"
          rel="${this.rel}"
          link-title="${this.linkTitle}"
          related="${this.related}"
        />
      </div>
    `}};Qi.styles=[Gi],p([ut({type:String})],Qi.prototype,"layout",void 0),Qi=p([ht("atmos-image-card")],Qi);var Xi=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  position: relative;
  margin: auto;
  display: block;
  padding-top: 2.5rem;
  margin:0 auto;
  max-width:1200px;
}

.overlay-bottom .wrapper{
  transform:translateY(50%);
}

.wrapper.narrow {
  width: 16rem;
  margin:auto;
}

.wrapper.horizontal {
  width: 16rem;
}

.wrapper.horizontal-reverse {
  padding-top: 0px;
}

::slotted([slot='infoImage']) {
  display: block;
  width:100%;
}

.inner {
  position: relative;
  min-height: 160px;
  background-color: var(--neutral-white);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 2rem;
  padding-top: 4rem;
  filter:drop-shadow(2px 2px 8px rgba(0, 76, 142, 0.04))
    drop-shadow(4px 4px 22px rgba(0, 76, 142, 0.12));
}

.wrapper.horizontal-reverse .inner{
  filter:none;
}

.inner.sm {
  padding-bottom: 2rem;
}

.inner.md {
  padding-bottom: 3rem;
}

.inner.lg {
  padding-bottom: 4rem;
}

.inner.img{
  padding:24px;
}

atmos-icon {
  display: flex;
}

.bg-img{
  min-height:215px;
  background-repeat:no-repeat;
  background-size:cover;
}

.label {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--brand-secondary);
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  margin: auto;
  height: 5rem;
  width: 5rem;
  text-align: center;
  transform:translate(0px, -40px);
}

.card-number {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size:27px;
  letter-spacing:-0.01em;
}

.card-title {
  margin-top: 0px;
  margin-bottom: 1rem;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  color: var(--neutral-grayDark);
  font-size:12px;
  letter-spacing:0.205em;
}

.card-body {
  margin: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
}

.card-body b {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
}

.wrapper.horizontal .card a {
  display: block;
  padding-top: 0.5rem;
  color: var(--brand-primary);
  text-decoration:none;
}

.wrapper.horizontal-reverse .card{
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.wrapper.horizontal-reverse .label {
  transform:translate(-40px, -40px);
  right:auto;
  top:50%;
}

.wrapper.horizontal-reverse .inner {
  padding-left: 4rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
}

.wrapper .card a {
  display: block;
  color: var(--brand-primary);
  text-decoration:none;
}

.wrapper.carousel .card a {
  display: block;
  padding-top: 0.5rem;
  color: var(--brand-primary);
  text-decoration:none;
}

.wrapper .card .card-body a,
.wrapper.carousel .card .card-body a{
  display:inline;
}

.wrapper.social {
  width: 100%;
  padding-top: 0px;
}

.wrapper.social .inner{
    filter:none;
    background:transparent;
  }

.wrapper.social .inner {
  padding: 0px;
}

.wrapper.social .social-icon-wrapper{
    max-width:24px;
  }

.wrapper.social .social-icon-wrapper {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.social-icon-wrapper atmos-icon{
  min-width:37px;
  min-height:37px;
}

@media only screen and (min-width: 1280px){
  .bg-img.double{
    min-height:400px;
  }

  .bg-img.double + .inner.img{
    padding:24px;
    height:calc(100% - 448px);
  }
}

@media only screen and (min-width: 768px){
  .wrapper.horizontal {
    width: auto;
  }
  .wrapper.horizontal {
    padding-top: 0px;
  }
  .wrapper.horizontal{
    padding-left:40px;
  }

  .wrapper.horizontal .card{
    display:flex;
    justify-content:space-between;
    align-items:center;
  }

  .wrapper.horizontal .card .horizontal-right {
    padding-left: 2rem;
  }

  .wrapper.horizontal .card .horizontal-right{
    flex-shrink:0;
    text-align:right;
  }

  .wrapper.horizontal .label {
    right: auto;
  }

  .wrapper.horizontal .label{
    transform:translate(-40px, -40px);
    right:auto;
    top:50%;
  }

  .wrapper.horizontal .card a{
    font-size:22px;
  }

  .wrapper.horizontal .card a {
    padding-top: 0px;
  }

  .wrapper.horizontal .inner {
    padding-left: 4rem;
  }

  .wrapper.horizontal .inner {
    padding-bottom: 1rem;
  }

  .wrapper.horizontal .inner {
    padding-top: 1rem;
  }

  .wrapper.horizontal .inner {
    font-weight: var(--fw-bold);
  }

  .wrapper.horizontal .inner{
    font-size:26px;
  }

  .wrapper.horizontal-reverse .label {
    display: flex;
  }

  .wrapper.horizontal-reverse .label {
    align-items: center;
  }

  .wrapper.horizontal-reverse .label {
    justify-content: center;
  }

  .wrapper.horizontal-reverse .label {
    border-radius: 9999px;
  }

  .wrapper.horizontal-reverse .label {
    background-color: var(--brand-secondary);
  }

  .wrapper.horizontal-reverse .label {
    position: absolute;
  }

  .wrapper.horizontal-reverse .label {
    left: 0px;
  }

  .wrapper.horizontal-reverse .label {
    right: 0px;
  }

  .wrapper.horizontal-reverse .label {
    top: 0px;
  }

  .wrapper.horizontal-reverse .label {
    margin: auto;
  }

  .wrapper.horizontal-reverse .label {
    height: 5rem;
  }

  .wrapper.horizontal-reverse .label {
    width: 5rem;
  }

  .wrapper.horizontal-reverse .label {
    text-align: center;
  }

  .wrapper.horizontal-reverse .label{
    transform:translate(0px, -40px);
  }

  .wrapper.horizontal-reverse .inner {
    position: relative;
  }

  .wrapper.horizontal-reverse .inner {
    background-color: var(--neutral-white);
  }

  .wrapper.horizontal-reverse .inner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .wrapper.horizontal-reverse .inner {
    padding-bottom: 2rem;
  }

  .wrapper.horizontal-reverse .inner {
    padding-top: 4rem;
  }

  .social-icon-wrapper atmos-icon{
    min-width:43px;
    min-height:43px;
  }
}
`;let Ki=class extends Pi{constructor(){super(...arguments),this.isHover=!1}getImage(){return Y`<slot name="infoImage"></slot>`}handleHover(){this.isHover=!0}handleOut(){this.isHover=!1}render(){return Y`
      <div class="${this.overlayBottom?"overlay-bottom":""}">
        <div class="wrapper ${this.sampleImage?"img":""} ${this.variant}">
          ${this.getImage()}
          <div
            class="inner ${this.cardPadding} ${this.sampleImage?"img":""}"
          >
            ${(()=>this.cardIcon&&"none"!==this.cardIcon?Y`
                  <div class="label">
                    <div class="icon">
                      ${"blank"!==this.cardIcon?Y`<atmos-icon
                            icon="${this.cardIcon}"
                            svg="true"
                            color="black"
                          ></atmos-icon>`:null}
                    </div>
                  </div>
                `:this.cardNumber?Y`<div class="label">
                  <p class="card-number">${this.cardNumber}</p>
                </div>`:null)()}

            <div class="card">
              <div class="horizontal-left">
                ${this.title?Y`<p class="card-title">${this.title}</p>`:""}
                ${this.text?Y`${this.socialIcon?Y`<div class="social-icon-wrapper">
                            <atmos-icon
                              icon="${this.socialIcon}"
                              svg="true"
                            ></atmos-icon>
                          </div>`:null}
                      <p class="card-body">${Ot(this.text)}</p>`:""}
              </div>
              <div class="horizontal-right">
                ${this.linkText&&this.url?Y` <atmos-button
                      class="button ${this.isHover&&"hover"}"
                      variant="${this.variant}"
                      url="${this.url}"
                      target="${this.target}"
                      rel="${this.rel}"
                      link-title="${this.linkTitle}"
                      link-title="${this.linkText}"
                    >
                      ${this.link}
                    </atmos-button>`:""}
              </div>
            </div>
          </div>
        </div>
      </div>
    `}};Ki.styles=[Xi],p([ut({reflect:!0,attribute:"card-icon"})],Ki.prototype,"cardIcon",void 0),p([ut({type:Boolean,attribute:"overlay-bottom"})],Ki.prototype,"overlayBottom",void 0),p([ut({reflect:!0,attribute:"card-number"})],Ki.prototype,"cardNumber",void 0),p([ut({reflect:!0,attribute:"card-padding"})],Ki.prototype,"cardPadding",void 0),p([ut({type:String,attribute:"sample-image"})],Ki.prototype,"sampleImage",void 0),p([ut({type:String,attribute:"social-icon"})],Ki.prototype,"socialIcon",void 0),p([ut({type:String,attribute:"social-post-link"})],Ki.prototype,"socialPostLink",void 0),p([ut({type:String})],Ki.prototype,"variant",void 0),p([ut({type:String})],Ki.prototype,"url",void 0),p([ut({type:String,attribute:"link-text"})],Ki.prototype,"linkText",void 0),p([ut({type:String,attribute:"alt-text"})],Ki.prototype,"altText",void 0),p([ut({type:String,attribute:"card-group-total"})],Ki.prototype,"cardGroupTotal",void 0),p([gt()],Ki.prototype,"isHover",void 0),Ki=p([ht("atmos-info-card")],Ki);var Ji=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
@font-face{
  font-family:'swiper-icons';
  src:url('data:application/font-woff;charset=utf-8;base64, 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');
  font-weight:400;
  font-style:normal;
}

:root{
  --swiper-theme-color:#007aff;
}

.swiper{
  margin-left:auto;
  margin-right:auto;
  position:relative;
  overflow:hidden;
  list-style:none;
  padding:0;
  z-index:1;
}

.swiper-vertical > .swiper-wrapper{
  flex-direction:column;
}

.swiper-wrapper{
  position:relative;
  width:100%;
  height:100%;
  z-index:1;
  display:flex;
  transition-property:transform;
  box-sizing:content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper{
  transform:translate3d(0px, 0, 0);
}

.swiper-pointer-events{
  touch-action:pan-y;
}

.swiper-pointer-events.swiper-vertical{
  touch-action:pan-x;
}

.swiper-slide{
  flex-shrink:0;
  width:100%;
  height:100%;
  position:relative;
  transition-property:transform;
}

.swiper-slide-invisible-blank{
  visibility:hidden;
}

.swiper-autoheight,
.swiper-autoheight .swiper-slide{
  height:auto;
}

.swiper-autoheight .swiper-wrapper{
  align-items:flex-start;
  transition-property:transform, height;
}

.swiper-backface-hidden .swiper-slide{
  transform:translateZ(0);
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-3d,
.swiper-3d.swiper-css-mode .swiper-wrapper{
  perspective:1200px;
}

.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow{
  transform-style:preserve-3d;
}

.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom{
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  pointer-events:none;
  z-index:10;
}

.swiper-3d .swiper-slide-shadow{
  background:rgba(0, 0, 0, 0.15);
}

.swiper-3d .swiper-slide-shadow-left{
  background-image:linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-right{
  background-image:linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-top{
  background-image:linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-bottom{
  background-image:linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-css-mode > .swiper-wrapper{
  overflow:auto;
  scrollbar-width:none;
  -ms-overflow-style:none;
}

.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar{
  display:none;
}

.swiper-css-mode > .swiper-wrapper > .swiper-slide{
  scroll-snap-align:start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper{
  scroll-snap-type:x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper{
  scroll-snap-type:y mandatory;
}

.swiper-centered > .swiper-wrapper::before{
  content:'';
  flex-shrink:0;
  order:9999;
}

.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child{
  -webkit-margin-start:var(--swiper-centered-offset-before);
          margin-inline-start:var(--swiper-centered-offset-before);
}

.swiper-centered.swiper-horizontal > .swiper-wrapper::before{
  height:100%;
  min-height:1px;
  width:var(--swiper-centered-offset-after);
}

.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child{
  -webkit-margin-before:var(--swiper-centered-offset-before);
          margin-block-start:var(--swiper-centered-offset-before);
}

.swiper-centered.swiper-vertical > .swiper-wrapper::before{
  width:100%;
  min-width:1px;
  height:var(--swiper-centered-offset-after);
}

.swiper-centered > .swiper-wrapper > .swiper-slide{
  scroll-snap-align:center center;
}

.swiper-virtual .swiper-slide{
  -webkit-backface-visibility:hidden;
  transform:translateZ(0);
}

.swiper-virtual.swiper-css-mode .swiper-wrapper::after{
  content:'';
  position:absolute;
  left:0;
  top:0;
  pointer-events:none;
}

.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{
  height:1px;
  width:var(--swiper-virtual-size);
}

.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{
  width:1px;
  height:var(--swiper-virtual-size);
}

:root{
  --swiper-navigation-size:44px;
}

.swiper-button-prev,
.swiper-button-next{
  position:absolute;
  top:50%;
  width:calc(44px / 44 * 27);
  width:calc(var(--swiper-navigation-size) / 44 * 27);
  height:44px;
  height:var(--swiper-navigation-size);
  margin-top:calc(0px - (44px / 2));
  margin-top:calc(0px - (var(--swiper-navigation-size) / 2));
  z-index:10;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  color:var(--swiper-theme-color);
  color:var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled{
  opacity:0.35;
  cursor:auto;
  pointer-events:none;
}

.swiper-button-prev:after,
.swiper-button-next:after{
  font-family:swiper-icons;
  font-size:44px;
  font-size:var(--swiper-navigation-size);
  letter-spacing:0;
  text-transform:none;
  font-variant:initial;
  line-height:1;
}

.swiper-button-prev,
.swiper-rtl .swiper-button-next{
  left:10px;
  right:auto;
}

.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after{
  content:'prev';
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev{
  right:10px;
  left:auto;
}

.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after{
  content:'next';
}

.swiper-button-lock{
  display:none;
}

:root{
}

.swiper-pagination{
  position:absolute;
  text-align:center;
  transition:300ms opacity;
  transform:translate3d(0, 0, 0);
  z-index:10;
}

.swiper-pagination.swiper-pagination-hidden{
  opacity:0;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal{
  bottom:10px;
  left:0;
  width:100%;
}

.swiper-pagination-bullets-dynamic{
  overflow:hidden;
  font-size:0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transform:scale(0.33);
  position:relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{
  transform:scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{
  transform:scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{
  transform:scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{
  transform:scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{
  transform:scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{
  transform:scale(0.33);
}

.swiper-pagination-bullet{
  width:8px;
  width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height:8px;
  height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display:inline-block;
  border-radius:50%;
  background:#000;
  background:var(--swiper-pagination-bullet-inactive-color, #000);
  opacity:0.2;
  opacity:var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}

button.swiper-pagination-bullet{
  border:none;
  margin:0;
  padding:0;
  box-shadow:none;
  -webkit-appearance:none;
          -moz-appearance:none;
       appearance:none;
}

.swiper-pagination-clickable .swiper-pagination-bullet{
  cursor:pointer;
}

.swiper-pagination-bullet:only-child{
  display:none !important;
}

.swiper-pagination-bullet-active{
  opacity:1;
  opacity:var(--swiper-pagination-bullet-opacity, 1);
  background:var(--swiper-theme-color);
  background:var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets{
  right:10px;
  top:50%;
  transform:translate3d(0px, -50%, 0);
}

.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{
  margin:6px 0;
  margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display:block;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{
  top:50%;
  transform:translateY(-50%);
  width:8px;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  display:inline-block;
  transition:200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{
  margin:0 4px;
  margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{
  left:50%;
  transform:translateX(-50%);
  white-space:nowrap;
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transition:200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transition:200ms transform, 200ms right;
}

.swiper-pagination-progressbar{
  background:rgba(0, 0, 0, 0.25);
  position:absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{
  background:var(--swiper-theme-color);
  background:var(--swiper-pagination-color, var(--swiper-theme-color));
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  transform:scale(0);
  transform-origin:left top;
}

.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{
  transform-origin:right top;
}

.swiper-horizontal > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-horizontal,
.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{
  width:100%;
  height:4px;
  left:0;
  top:0;
}

.swiper-vertical > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-vertical,
.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{
  width:4px;
  height:100%;
  left:0;
  top:0;
}

.swiper-pagination-lock{
  display:none;
}

.swiper-scrollbar{
  border-radius:10px;
  position:relative;
  -ms-touch-action:none;
  background:rgba(0, 0, 0, 0.1);
}

.swiper-horizontal > .swiper-scrollbar{
  position:absolute;
  left:1%;
  bottom:3px;
  z-index:50;
  height:5px;
  width:98%;
}

.swiper-vertical > .swiper-scrollbar{
  position:absolute;
  right:3px;
  top:1%;
  z-index:50;
  width:5px;
  height:98%;
}

.swiper-scrollbar-drag{
  height:100%;
  width:100%;
  position:relative;
  background:rgba(0, 0, 0, 0.5);
  border-radius:10px;
  left:0;
  top:0;
}

.swiper-scrollbar-cursor-drag{
  cursor:move;
}

.swiper-scrollbar-lock{
  display:none;
}

.swiper-zoom-container{
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  text-align:center;
}

.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas{
  max-width:100%;
  max-height:100%;
  object-fit:contain;
}

.swiper-slide-zoomed{
  cursor:move;
}

:root{
}

.swiper-lazy-preloader{
  width:42px;
  height:42px;
  position:absolute;
  left:50%;
  top:50%;
  margin-left:-21px;
  margin-top:-21px;
  z-index:10;
  transform-origin:50%;
  box-sizing:border-box;
  border:4px solid var(--swiper-theme-color);
  border:4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius:50%;
  border-top-color:transparent;
}

.swiper-slide-visible .swiper-lazy-preloader{
  -webkit-animation:swiper-preloader-spin 1s infinite linear;
          animation:swiper-preloader-spin 1s infinite linear;
}

.swiper-lazy-preloader-white{
  --swiper-preloader-color:#fff;
}

.swiper-lazy-preloader-black{
  --swiper-preloader-color:#000;
}

@-webkit-keyframes swiper-preloader-spin{
  0%{
    transform:rotate(0deg);
  }
  100%{
    transform:rotate(360deg);
  }
}

@keyframes swiper-preloader-spin{
  0%{
    transform:rotate(0deg);
  }
  100%{
    transform:rotate(360deg);
  }
}

.swiper .swiper-notification{
  position:absolute;
  left:0;
  top:0;
  pointer-events:none;
  opacity:0;
  z-index:-1000;
}

.swiper-free-mode > .swiper-wrapper{
  transition-timing-function:ease-out;
  margin:0 auto;
}

.swiper-grid > .swiper-wrapper{
  flex-wrap:wrap;
}

.swiper-grid-column > .swiper-wrapper{
  flex-wrap:wrap;
  flex-direction:column;
}

.swiper-fade.swiper-free-mode .swiper-slide{
  transition-timing-function:ease-out;
}

.swiper-fade .swiper-slide{
  pointer-events:none;
  transition-property:opacity;
}

.swiper-fade .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-fade .swiper-slide-active,
.swiper-fade .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-cube{
  overflow:visible;
}

.swiper-cube .swiper-slide{
  pointer-events:none;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  z-index:1;
  visibility:hidden;
  transform-origin:0 0;
  width:100%;
  height:100%;
}

.swiper-cube .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-cube.swiper-rtl .swiper-slide{
  transform-origin:100% 0;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-next,
.swiper-cube .swiper-slide-prev,
.swiper-cube .swiper-slide-next + .swiper-slide{
  pointer-events:auto;
  visibility:visible;
}

.swiper-cube .swiper-slide-shadow-top,
.swiper-cube .swiper-slide-shadow-bottom,
.swiper-cube .swiper-slide-shadow-left,
.swiper-cube .swiper-slide-shadow-right{
  z-index:0;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-cube .swiper-cube-shadow{
  position:absolute;
  left:0;
  bottom:0px;
  width:100%;
  height:100%;
  opacity:0.6;
  z-index:0;
}

.swiper-cube .swiper-cube-shadow:before{
  content:'';
  background:#000;
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  filter:blur(50px);
}

.swiper-flip{
  overflow:visible;
}

.swiper-flip .swiper-slide{
  pointer-events:none;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  z-index:1;
}

.swiper-flip .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-flip .swiper-slide-active,
.swiper-flip .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-flip .swiper-slide-shadow-top,
.swiper-flip .swiper-slide-shadow-bottom,
.swiper-flip .swiper-slide-shadow-left,
.swiper-flip .swiper-slide-shadow-right{
  z-index:0;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-creative .swiper-slide{
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  overflow:hidden;
  transition-property:transform, opacity, height;
}

.swiper-cards{
  overflow:visible;
}

.swiper-cards .swiper-slide{
  transform-origin:center bottom;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  overflow:hidden;
}

:host {
  display: block;
}

.wrapper {
  position: relative;
  overflow: hidden;
  margin: auto;
  max-width:1600px;
}

.inner {
  margin: auto;
  position: relative;
  max-width:375px;
}

.card-wrapper{
  max-width:254px;
  margin:26px auto 54px;
  height:calc(100% - 80px);
}

button{
  border:none;
  padding:4px;
  background:none;
}

button.swiper-button-next:after,
button.swiper-button-prev:after{
  content:none;
}

.swiper-button-next,
.swiper-button-prev{
  color:#2175d9 !important;
  font-size:31px !important;
  top:50% !important;
  transform:translate(0, -20px);
}

.swiper-button-prev{
  left:0 !important;
}

.swiper-button-next{
  right:0 !important;
}

.icon-container.-prev{
  transform:rotateY(180deg);
}

atmos-icon{
  display:flex;
}

.title-wrapper {
  margin: auto;
  max-width:254px;
}

.title {
  position: relative;
  background-color: var(--neutral-white);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  margin:10px auto 0;
  max-width:254px;
}

.bg-desktop {
  display: none;
}

.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
  display: none;
}

.swiper-slide{
  height:auto;
}

@media only screen and (min-width: 640px){
  .title{
    margin-left:29.5px;
  }

  .icon-wrapper {
    margin-right: 2.25rem;
  }

  .icon-wrapper {
    margin-bottom: 0px;
  }

  .icon-wrapper{
    flex-shrink:0;
  }

  .title-wrapper,
  .inner{
    max-width:634px;
  }

  .card-wrapper{
    margin:17px auto 45px;
    height:calc(100% - 62px);
  }

  .swiper-button-next,
  .swiper-button-prev{
    top:60% !important;
  }
}

@media only screen and (min-width: 768px){
  .inner{
    max-width:640px;
  }

  .swiper-button-prev{
    left:-20px !important;
  }

  .swiper-button-next{
    right:-20px !important;
  }
}

@media only screen and (min-width: 1440px){
  .bg-desktop {
    margin-top: 1rem;
  }
  .bg-desktop {
    display: block;
  }
  .bg-desktop {
    position: absolute;
  }
  .bg-desktop{
    background-repeat:no-repeat;
    height:356px;
    width:1600px;
    background-position-x:-160px;
    background-position-x:0;
    margin-top:0;
    left:50%;
    top:45%;
    transform:translate(-800px, -178px);
  }

  .title{
    font-size:40px;
    line-height:126%;
    max-width:364px;
  }

  .inner{
    max-width:1265px;
  }

  .title-wrapper{
    max-width:1265px;
  }

  .swiper-button-next,
  .swiper-button-prev{
    top:50% !important;
    transform:translate(0, -20px);
  }

  .swiper-button-prev{
    left:-50px !important;
  }

  .swiper-button-next{
    right:-50px !important;
  }
}
`;let tr=class extends $t{constructor(){super(...arguments),this._swiperInstance=null}updated(){this._swiperInstance&&this._swiperInstance.destroy(),setTimeout((()=>{const t=this._slides.length,e=this._swiperBtnPrev,i=this._swiperBtnNext;let r,n;switch(t){case 1:r=1,n=1;break;case 2:r=2,n=2;break;case 3:r=2,n=3;break;default:r=2,n=4}this._swiperInstance=new Swiper(this._swiper,{slidesPerView:1,navigation:{nextEl:i,prevEl:e},a11y:{itemRoleDescriptionMessage:"slide of carousel of navigable informational slides pertaining"},breakpoints:{640:{slidesPerView:r},1440:{slidesPerView:n}}}),this._swiperInstance.init()}),100)}render(){return Y`
      <div class="wrapper">
        <div class="bg-desktop"></div>
        <div class="inner">
          <div id="swiper" class="swiper" role="region" aria-label="carousel">
            <div class="swiper-wrapper">
              ${this.cards.map((t=>Y`
                  <div class="swiper-slide">
                    <div class="card-wrapper">
                      <atmos-info-card
                        card-number="${At(t.number)}"
                        card-icon="${At(t.icon)}"
                        text="${At(t.text)}"
                        title="${At(t.title)}"
                        card-padding="${At(t.cardPadding)}"
                      ></atmos-info-card>
                    </div>
                  </div>
                `))}
            </div>
          </div>
          <button
            type="button"
            aria-controls="swiper"
            class="swiper-button-prev"
          >
            <span class="icon-container -prev">
              <atmos-icon class="" icon="next" svg="true"></atmos-icon>
            </span>
          </button>
          <button
            type="button"
            aria-controls="swiper"
            class="swiper-button-next"
          >
            <span class="icon-container -next">
              <atmos-icon class="" icon="next" svg="true"></atmos-icon>
            </span>
          </button>
        </div>
      </div>
    `}};tr.styles=[Ji],p([mt(".swiper")],tr.prototype,"_swiper",void 0),p([mt(".swiper-button-prev")],tr.prototype,"_swiperBtnPrev",void 0),p([mt(".swiper-button-next")],tr.prototype,"_swiperBtnNext",void 0),p([bt(".swiper-slide")],tr.prototype,"_slides",void 0),p([ut({reflect:!0,attribute:"card-icon"})],tr.prototype,"cardIcon",void 0),p([ut({type:Array,attribute:"cards"})],tr.prototype,"cards",void 0),tr=p([ht("atmos-info-card-carousel")],tr);var er=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.grid-wrapper{
  display:grid;
  margin:auto;
  row-gap:32px;
  max-width:254px;
}

.grid-wrapper.full{
  max-width:none;
}

.grid-wrapper.img{
  max-width:352px;
}

.inner{
  padding-bottom:2.4rem;
}

@media only screen and (min-width: 640px){
  .grid-wrapper{
    max-width:548px;
    grid-column-gap:40px;
    grid-auto-rows:1fr;
    grid-template-columns:repeat(2, 1fr);
  }

  .grid-wrapper.full{
    max-width:none;
  }

  .grid-wrapper.img{
    max-width:744px;
  }

  .grid-wrapper.single{
    grid-template-columns:repeat(1, 1fr);
  }
}

@media only screen and (min-width: 1280px){
  .grid-wrapper, .grid-wrapper.img{
    max-width:1136px;
  }

  .grid-wrapper.full{
    max-width:none;
  }

  .grid-wrapper.single{
    grid-template-columns:repeat(1, 1fr);
  }

  .grid-wrapper.double{
    grid-template-columns:repeat(2, 1fr);
  }

  .grid-wrapper.multi{
    grid-template-columns:repeat(3, 1fr);
  }
}
`;let ir=class extends $t{constructor(){super(...arguments),this.type="normal"}render(){const t=this.cards.length;let e;this.cards.filter((t=>{void 0!==t.sampleImage&&(e=!0)}));let i="";switch(t){case 1:i="single";break;case 2:i="double";break;default:i="multi"}return Y`
      <div class="wrapper">
        <div class="inner">
          <div
            class="grid-wrapper ${this.type} ${i} ${e?"img":""}"
          >
            ${this.cards.map((e=>{const{number:i,icon:r,text:n,title:o,cardPadding:a,sampleImage:s,altText:l}=e;return Y`
                <div class="card-wrapper grid-card">
                  <atmos-info-card
                    card-group-total="${t}"
                    card-number="${At(i)}"
                    card-icon="${At(r)}"
                    text="${At(n)}"
                    title="${At(o)}"
                    card-padding="${At(a)}"
                    href="${At(s)}"
                    alt-text="${At(l)}"
                    variant="narrow"
                  ></atmos-info-card>
                </div>
              `}))}
          </div>
        </div>
      </div>
    `}};ir.styles=[er],p([ut({type:Array,attribute:"cards"})],ir.prototype,"cards",void 0),p([ut({attribute:"type"})],ir.prototype,"type",void 0),ir=p([ht("atmos-info-card-stacked")],ir);var rr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
  position: relative;
}

figure {
  margin: 0px;
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  aspect-ratio:1504 / 870;
}

::slotted(img){
  aspect-ratio:1504 / 870;
  object-fit:cover;
  width:100%;
  max-width:100%;
}

.info {
  padding-top: 2rem;
  padding-right: 1rem;
  padding-bottom: 2rem;
  padding-left: 1rem;
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
  box-sizing:border-box;
}

@media only screen and (min-width: 640px){
  .info {
    padding: 3rem;
  }
}

@media only screen and (min-width: 1024px){
  .info{
    width:calc(50% - 20px);
  }

  .info.right{
    margin-left:auto;
  }

  .info-wrapper {
    position: absolute;
  }

  .info-wrapper{
    bottom:0;
    max-width:1094px;
    width:100%;
  }
  .figure, .info {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media only screen and (min-width: 1094px){
  .info-wrapper{
    left:50%;
    margin-left:-547px;
  }
}
`;let nr=class extends $t{firstUpdated(){this.hasInfo=null!==this.querySelector('[slot="info"]')}infoSlotTemplate(){return this.hasInfo?Y` <div class="info-wrapper">
          <div class="info ${this.position}">
            <slot name="info"></slot>
          </div>
        </div>`:null}render(){return Y`
      <figure><slot name="image"></slot></figure>
      ${this.infoSlotTemplate()}
    `}};nr.styles=[rr],p([gt()],nr.prototype,"hasInfo",void 0),p([ut({attribute:"position"})],nr.prototype,"position",void 0),nr=p([ht("atmos-jumbo-feature")],nr);var or=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  opacity:0;
  position:absolute;
  z-index:6000;
  transition:opacity 0.25s ease-in;
  left:0;
}

.wrapper.blue{
  opacity:0;
  transition:opacity 0.9s ease-in;
}

.wrapper:not(.open){
  display:none;
}

.wrapper.open{
  align-items:center;
  display:block;
  display:flex;
  justify-content:center;
  width:100%;
  height:100%;
  opacity:1;
}

.overlay{
  background:rgba(0, 0, 0, 0.8);
  height:100%;
  width:100%;
  position:fixed;
  top:0px;
  left:0px;
}

.dialog{
  background:#ffffff;
  border-radius:13px;
  padding:1rem;
  position:fixed;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);
  width:70%;
  z-index:6000;
}

.dialog.blue {
  text-align: center;
  color: var(--neutral-white);
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.dialog h1{
  margin:0 0 10px;
}

.dialog a{
  float:right;
  background:none;
  font-size:20px;
  border:none;
  margin-bottom:10px;
  text-align:right;
  cursor:pointer;
  width:25px;
  height:25px;
  text-decoration:none;
}

.dialog.dark a {
  color: var(--neutral-white);
}
`;let ar=class extends $t{constructor(){super(...arguments),this.variant=""}_handleCloseClick(t,e){this.open="false",t.preventDefault(),t.stopPropagation();const i=new CustomEvent("modal-click",{detail:{state:e}});this.dispatchEvent(i)}render(){return Y`
      <div class="${Dt({wrapper:!0,open:"true"===this.open})}">
        <div class="overlay"
          @click="${t=>this._handleCloseClick(t,!1)}"
          ></div>
        <div class="dialog ${this.variant}">
          <a
              @click="${t=>this._handleCloseClick(t,!1)}"
          >&#x2715</a>
          <div id="content" class="content">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    `}};ar.styles=[or],p([ut({type:String})],ar.prototype,"open",void 0),p([ut({type:String})],ar.prototype,"text",void 0),p([ut({type:String})],ar.prototype,"variant",void 0),ar=p([ht("atmos-modal-dialog")],ar);var sr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outer-wrapper{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.wrapper{
  padding:40px 20px 40px 20px;
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
}

.title {
  color: var(--neutral-white);
  margin-bottom: 1rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  letter-spacing:-0.02em;
  font-weight:normal;
}

.title a{
  text-decoration:none;
  color:var(--brand-secondary);
}

.title a[href^='tel:'] {
  color: var(--neutral-white);
}

.title h2 {
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  margin-bottom: 1rem;
  line-height:72px;
  letter-spacing:-0.02em;
  margin-top:29px;
  margin-bottom:17px;
}

.text {
  color: var(--neutral-white);
  margin-bottom: 1rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  letter-spacing:-0.02em;
  font-weight:normal;
}

.text a{
  text-decoration:none;
  color:var(--brand-secondary);
}

.text a[href^='tel:'] {
  color: var(--neutral-white);
}

ul{
  list-style-type:square;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--neutral-white);
}

.title h1 a,
.text h1 a,
.title h2 a,
.text h2 a,
.title h3 a,
.text h3 a,
.title h4 a,
.text h4 a,
.title h5 a,
.text h5 a,
.title h6 a,
.text h6 a{
  color:inherit;
  font-size:inherit;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
}

ul li{
  margin-bottom:15px;
}

.wrapper .right .top{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
}

.wrapper .right .top.mobile{
  display:block;
}

.wrapper .right .footer{
  width:100%;
  display:flex;
  align-items:center;
}

.wrapper .right .footer atmos-button{
  position:absolute;
  transform:translateX(110px);
  max-width:300px;
}

.wrapper .left{
  width:100%;
}

.wrapper .right .top > div{
  width:100%;
}

.icon {
  position: relative;
  align-items:center;
  display:flex;
  justify-content:center;
  height:137px;
  overflow:hidden;
  width:142px;
  flex-shrink:0;
}

.icon.mobile{
  display:flex;
}

.icon.desktop{
  display:none;
}

.icon atmos-icon{
  display:block;
  width:40px;
}

.icon svg{
  position:absolute;
  top:0;
  left:0;
  width:auto;
}

.title h2{
  margin-top:0;
}

@media only screen and (min-width: 640px){
  .wrapper{
    flex-direction:row;
    justify-content:space-between;
    padding:80px 40px 100px 40px;
  }

  .icon{
    flex-shrink:0;
    height:137px;
    width:142px;
  }

  .icon atmos-icon{
    width:40px;
  }

  .icon svg{
    width:auto;
  }

  .title h2 {
    font-size: var(--fs-5xl);
    line-height: var(--lh-5xl);
  }

  .title h2 {
    margin-top: 0px;
  }

  .title h2{
    line-height:72px;
  }

  .wrapper .right .footer atmos-button{
    position:absolute;
    transform:translateX(110px);
    max-width:500px;
  }
}

@media only screen and (min-width: 1024px){
  .wrapper{
    justify-content:space-between;
    margin-left:auto;
    margin-right:auto;
    max-width:1240px;
    position:relative;
  }

  .wrapper .left{
    width:30%;
  }

  .wrapper .right{
    width:65%;
  }

  .wrapper .right .top > div{
    width:48%;
  }

  .wrapper .right .one.top > div{
    width:auto;
  }

  .wrapper .right .top.desktop{
    display:flex;
  }

  .icon.mobile{
    display:none;
  }

  .icon.desktop{
    display:flex;
  }

  .wrapper .right .top.mobile{
    display:none;
  }

  .info{
    max-width:446px;
  }

  .wrapper .right .footer atmos-button{
    position:absolute;
    transform:translateX(110px);
    max-width:inherit;
  }
}
`;let lr=class extends $t{getIconDesktop(){return this.icon&&this.iconLink&&this.iconText?Y`<div class="icon desktop">
        <svg
          width="137"
          height="137"
          viewBox="0 0 137 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_3050_17034"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="137"
            height="137"
          >
            <path
              d="M83.3185 63.9028C98.0299 59.9184 128.464 40.1456 136.188 40.5134L133.429 37.698L114.12 13.3322L92.5131 0H58.9527L28.1507 10.5738L13.899 22.0671L0.107112 45.5134C0.566843 52.5626 1.21047 69.0517 0.107112 78.6141C-0.996244 88.1765 6.6966 102.827 10.6809 108.956L28.1507 123.668C37.3454 128.112 56.3783 137 58.9527 137C62.1709 137 83.3185 136.081 88.8353 134.701C93.2487 133.598 109.37 125.047 116.879 120.909L133.429 99L83.3185 63.9028Z"
              fill="#C4C4C4"
            />
          </mask>
          <g mask="url(#mask0_3050_17034)">
            <circle
              cx="70.6764"
              cy="66.4312"
              r="61.2936"
              stroke="#FEE96C"
              stroke-width="2"
            />
          </g>
        </svg>
        ${this.icon?Y`<atmos-icon svg="true" icon="${this.icon}" />`:""}
      </div>`:""}getIconMobile(){return this.icon&&this.iconLink&&this.iconText?Y`<div class="icon mobile">
        <svg
          width="118"
          height="137"
          viewBox="0 0 118 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_3105_22077"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="118"
            height="137"
          >
            <path
              d="M83.3185 63.9028L118 19.5L92.5131 0H58.9527L28.1507 10.5738L13.899 22.0671L0.107112 45.5134C0.566843 52.5626 1.21047 69.0517 0.107112 78.6141C-0.996244 88.1765 6.6966 102.827 10.6809 108.956L28.1507 123.668C37.3454 128.112 56.3783 137 58.9527 137C62.1709 137 83.3185 136.081 88.8353 134.701C104.403 130.809 116 121.5 116 121.5L83.3185 63.9028Z"
              fill="#C4C4C4"
            />
          </mask>
          <g mask="url(#mask0_3105_22077)">
            <circle
              cx="70.6764"
              cy="66.4313"
              r="61.2936"
              stroke="#FEE96C"
              stroke-width="2"
            />
          </g>
        </svg>
        ${this.icon?Y`<atmos-icon icon="${this.icon}" />`:""}
      </div>`:""}getRightColumns(){return Y`
      ${this.middleColumn?Y`<div class="text">${Ot(this.middleColumn)}</div>`:""}
      ${this.rightColumn?Y`<div class="text">${Ot(this.rightColumn)}</div>`:""}
    `}render(){return Y` <div class="outer-wrapper">
      <div class="wrapper">
        <div class="left">
          <div class="title">
            ${this.leftColumn?Ot(this.leftColumn):""}
          </div>
        </div>

        <div class="right">
          <div
            class="desktop top ${this.middleColumn&&this.rightColumn?"":"one"}"
          >
            ${this.getRightColumns()}
          </div>
          <div class="footer">
            ${this.getIconDesktop()} ${this.getIconMobile()}
            ${this.iconLink&&this.iconText?Y`<atmos-button
                  url="${this.iconLink}"
                  target="${this.target}"
                  rel="${this.rel}"
                  link-title="${this.linkTitle}"
                  variant="reverse"
                  size="large"
                >
                  ${this.iconText}
                </atmos-button>`:null}
          </div>
        </div>
      </div>
    </div>`}};lr.styles=[sr],p([ut({type:String,attribute:"icon"})],lr.prototype,"icon",void 0),p([ut({type:String,attribute:"left-col-text"})],lr.prototype,"leftColumn",void 0),p([ut({type:String,attribute:"mid-col-text"})],lr.prototype,"middleColumn",void 0),p([ut({type:String,attribute:"right-col-text"})],lr.prototype,"rightColumn",void 0),p([ut({type:String,attribute:"icon-text"})],lr.prototype,"iconText",void 0),p([ut({type:String,attribute:"icon-link"})],lr.prototype,"iconLink",void 0),p([ut({type:String,attribute:"target"})],lr.prototype,"target",void 0),p([ut({type:String,attribute:"rel"})],lr.prototype,"rel",void 0),p([ut({type:String,attribute:"link-title"})],lr.prototype,"linkTitle",void 0),lr=p([ht("atmos-multi-column")],lr);var dr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  padding-top: 0.75rem;
  position: relative;
  margin: auto;
  max-width: 1136px;
}

.heading-wrapper {
  display: flex;
  align-items: center;
  margin-bottom:38px;
}

.inner {
  position: relative;
  border-radius:32px;
  border:2px solid var(--brand-secondary);
  padding-bottom:22px;
  width:calc(100% - 4px);
}

.inner.-link,
.inner.-section-link{
  border-bottom:none;
  border-bottom-right-radius:0;
  border-bottom-left-radius:0;
}

.heading {
  background-color: var(--neutral-white);
  display: inline-block;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  margin: 0px;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  position: absolute;
  z-index: 10;
  margin-left: 1.5rem;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  padding:6px 12px 9px;
  letter-spacing:0.01em;
}

.link-wrapper-desktop {
  display: none;
}

.content-tabs {
  display: flex;
  flex-direction: column;
}

atmos-button {
  display: flex;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  border-bottom-right-radius:32px;
  border-bottom-left-radius:32px;
}

button {
  color: var(--neutral-grayDark);
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  background-color: var(--neutral-white);
  position: relative;
  text-align: left;
  width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  margin-left: auto;
  margin-right: auto;
  border-style: none;
  overflow: visible;
  padding:0 10px 0 30px;
  font-size:16px;
}

button.active:before {
  position: absolute;
  content:'';
  width:2px;
  height:52px;
  left:-2px;
}

button.homeowners.active:before{
  background:var(--icon-homeowners);
}

button.commercialManagers.active:before{
  background:var(--icon-commercialManagers);
}

button.buildersDevelopers.active:before{
  background:var(--icon-buildersDevelopers);
}

button.firstResponders.active:before{
  background:var(--icon-firstResponders);
}

button.plumbersContractors.active:before{
  background:var(--icon-plumbersContractors);
}

atmos-icon {
  display: flex;
}

button.active:after {
  position: absolute;
  width: 0px;
  height: 0px;
  content:'';
  border-top:5px solid transparent;
  border-bottom:5px solid transparent;
  top:calc(50% - 6px);
  left:12px;
}

button.active.homeowners:after{
  border-left:7px solid var(--icon-homeowners);
}

button.active.commercialManagers:after{
  border-left:7px solid var(--icon-commercialManagers);
}

button.active.buildersDevelopers:after{
  border-left:7px solid var(--icon-buildersDevelopers);
}

button.active.firstResponders:after{
  border-left:7px solid var(--icon-firstResponders);
}

button.active.plumbersContractors:after{
  border-left:7px solid var(--icon-plumbersContractors);
}

.icon-container {
  color: var(--neutral-white);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  overflow: visible;
  height:44px;
  width:44px;
  margin:2px 14px 2px 2px;
  border:2px solid white;
  box-shadow:0 0 0 2pt transparent;
}

.icon-container.homeowners{
  background:var(--icon-homeowners);
}

.icon-container.commercialManagers{
  background:var(--icon-commercialManagers);
}

.icon-container.buildersDevelopers{
  background:var(--icon-buildersDevelopers);
}

.icon-container.firstResponders{
  background:var(--icon-firstResponders);
}

.icon-container.plumbersContractors{
  background:var(--icon-plumbersContractors);
}

button.option.active .icon-container.homeowners{
  box-shadow:0 0 0 2pt var(--icon-homeowners);
}

button.option.active .icon-container.commercialManagers{
  box-shadow:0 0 0 2pt var(--icon-commercialManagers);
}

button.option.active .icon-container.buildersDevelopers{
  box-shadow:0 0 0 2pt var(--icon-buildersDevelopers);
}

button.option.active .icon-container.firstResponders{
  box-shadow:0 0 0 2pt var(--icon-firstResponders);
}

button.option.active .icon-container.plumbersContractors{
  box-shadow:0 0 0 2pt var(--icon-plumbersContractors);
}

button:hover {
  cursor: pointer;
}

@media only screen and (min-width: 1280px){
  .wrapper {
    padding-top: 1rem;
  }
  .wrapper {
    display: flex;
  }

  .wrapper.-section-link{
    flex-wrap:wrap;
  }

  .inner {
    padding: 0px;
  }

  .inner{
    border-top-left-radius:32px;
    border-bottom-left-radius:32px;
    border-top-right-radius:32px;
    border-bottom:2px solid var(--brand-secondary);

    min-height:155px;
  }

  .inner.-section-link .content-tabs{
  }

  .inner.-link{
    border-bottom:2px solid var(--brand-secondary);
    border-right:none;
    border-top-right-radius:0px;
    border-bottom-left-radius:32px;
  }

  .inner.-section-link{
    border-bottom:none;
    border-bottom-right-radius:0;
    border-bottom-left-radius:0;
    border-top-right-radius:32px;
    border-top-left-radius:32px;
  }

  .heading-wrapper {
    margin: 0px;
  }

  .heading {
    font-size: var(--fs-3xl);
    line-height: var(--lh-3xl);
  }

  .heading{
    margin-left:38px;
  }

  atmos-button {
    margin-top: 0px;
  }

  atmos-button {
    justify-items: center;
  }

  atmos-button {
    align-items: center;
  }

  atmos-button{
    border-top-right-radius:32px;
    border-bottom-left-radius:0;
    flex-basis:258px;
  }

  atmos-button.section {
    width: 100%;
  }

  atmos-button.section{
    flex-basis:auto;
    border-top-right-radius:0;
    border-top-left-radius:0;
    border-bottom-left-radius:32px;
    border-bottom-right-radius:32px;
  }

  .link-wrapper-desktop {
    display: block;
  }

  .link-wrapper-desktop {
    margin-left: auto;
  }

  .icon-container {
    margin: 0px;
  }

  .icon-container {
    margin-right: 0.75rem;
  }

  .icon-container{
    min-width:56px;
    min-height:56px;
    border-width:4px;
  }

  .text{
    margin:55px auto 64px;
  }

  .content-tabs {
    height: 100%;
  }

  .content-tabs {
    flex-direction: row;
  }

  .content-tabs {
    justify-content: flex-end;
  }

  .content-tabs {
    margin-top: 0px;
  }

  .content-tabs {
    padding-left: 3rem;
  }

  .content-tabs {
    padding-right: 2rem;
  }

  .content-tabs {
    align-items: center;
  }

  button {
    display: flex;
  }

  button {
    padding: 0px;
  }

  button {
    height: 100%;
  }

  button {
    align-items: center;
  }

  button{
    font-size:18px;
    max-width:200px;
  }

  button {
    margin-left: 0px;
  }

  button:last-of-type {
    padding-right: 0px;
  }

  .inner.-link button{
    padding-right:10px;
    max-width:none;
  }

  .inner.-link button {
    margin: auto;
  }

  button.homeowners.active:before,
  button.commercialManagers.active:before,
  button.buildersDevelopers.active:before,
  button.firstResponders.active:before,
  button.plumbersContractors.active:before{
    background:transparent;
  }

  button:before, button.active:before {
    width: 100%;
  }

  button:before, button.active:before {
    position: absolute;
  }

  button:before, button.active:before {
    left: 0px;
  }

  button:before,
  button.active:before{
    content:'';
    background:transparent;
    height:2px;
    bottom:-2px;
    transition:background 0.25s ease-in;
  }

  .wrapper.-section-link button:before,
  .wrapper.-section-link button.active:before{
    content:none;
  }

  button.homeowners:hover:before{
    background:var(--icon-homeowners);
  }

  button.commercialManagers:hover:before{
    background:var(--icon-commercialManagers);
  }

  button.buildersDevelopers:hover:before{
    background:var(--icon-buildersDevelopers);
  }

  button.firstResponders:hover:before{
    background:var(--icon-firstResponders);
  }

  button.plumbersContractors:hover:before{
    background:var(--icon-plumbersContractors);
  }

  button:after, button.active:after, button.active.homeowners:after, button.active.commercialManagers:after, button.active.buildersDevelopers:after, button.active.firstResponders:after, button.active.plumbersContractors:after {
    position: absolute;
  }

  button:after, button.active:after, button.active.homeowners:after, button.active.commercialManagers:after, button.active.buildersDevelopers:after, button.active.firstResponders:after, button.active.plumbersContractors:after {
    width: 0px;
  }

  button:after, button.active:after, button.active.homeowners:after, button.active.commercialManagers:after, button.active.buildersDevelopers:after, button.active.firstResponders:after, button.active.plumbersContractors:after {
    height: 0px;
  }

  button:after, button.active:after, button.active.homeowners:after, button.active.commercialManagers:after, button.active.buildersDevelopers:after, button.active.firstResponders:after, button.active.plumbersContractors:after {
    opacity: 0;
  }

  button:after,
  button.active:after,
  button.active.homeowners:after,
  button.active.commercialManagers:after,
  button.active.buildersDevelopers:after,
  button.active.firstResponders:after,
  button.active.plumbersContractors:after{
    content:'';
    border-left:5px solid transparent;
    border-right:5px solid transparent;
    border-bottom:7px solid transparent;
    bottom:10px;
    left:calc(50% - 3.5px);
    transition:bottom 0.25s ease-in, border-bottom 0.25s ease-in,
      opacity 0.25s ease-in;
    top:initial;
  }

  button.active:hover:after, button:hover:after {
    opacity: 1;
  }

  button.active:hover:after,
  button:hover:after{
    bottom:17px;
  }

  button.homeowners:hover:after,
  button.active.homeowners:hover:after{
    border-bottom-color:var(--icon-homeowners);
  }

  button.commercialManagers:hover:after{
    border-bottom-color:var(--icon-commercialManagers);
  }

  button.buildersDevelopers:hover:after{
    border-bottom-color:var(--icon-buildersDevelopers);
  }

  button.firstResponders:hover:after{
    border-bottom-color:var(--icon-firstResponders);
    opacity:1 !important;
    bottom:17px !important;
  }

  button.plumbersContractors:hover:after{
    border-bottom-color:var(--icon-plumbersContractors);
  }

  .icon-container.active::before{
    content:none;
  }

  .icon-container,
  .icon-container.homeowners{
    transition:box-shadow 0.15s linear;
  }
}
`;let cr=class extends mi{_initContent(){this.activeTitle=this.selectors[0].title,this.activeSectionLinkText=this.activeTitle,this.activeSectionLinkUrl=this.selectors[0].sectionLinkUrl}_handleTab(t){var e;let i;if(t.target!==t.currentTarget){i=t.target.closest("button.option")}else i=t.target;const r=i.innerText;if([...this._tabs].forEach((t=>{t.classList.remove("active"),t.setAttribute("aria-selected","false")})),null==i||i.classList.add("active"),null==i||i.setAttribute("aria-selected","true"),this.hasSectionLink()){this.activeSectionLinkText=r;const t=function(t){return t.title===r},i=this.selectors.filter(t);this.activeSectionLinkUrl=null===(e=i[0])||void 0===e?void 0:e.sectionLinkUrl}const n=new CustomEvent("get-updated-context",{detail:`${this.camelFormat(r)}`,bubbles:!0,composed:!0});this.dispatchEvent(n)}getTitle(){return this.title?Y`<h3 class="heading">${this.title}</h3> `:""}hasSectionLink(){return this.selectors.every((t=>t.hasOwnProperty("sectionLinkUrl")&&""!==t.sectionLinkUrl))}getSectionLink(){return this.hasSectionLink()&&""===this.link?Y`<atmos-button
        class="section"
        variant="reverse"
        size="${this.buttonSize}"
        url="${this.activeSectionLinkUrl}"
        target="${this.target}"
        rel="${this.rel}"
        link-title="${this.linkTitle}"
        >See more for ${this.activeSectionLinkText}</atmos-button
      >`:""}connectedCallback(){super.connectedCallback(),this._initContent();const t=new CustomEvent("get-initial-context",{detail:`${this.camelFormat(this.selectors[0].title)}`,bubbles:!0,composed:!0});this.dispatchEvent(t)}render(){return Y`
      <div
        class="wrapper ${this.hasSectionLink()&&""===this.link?"-section-link":""}"
      >
        <div
          class="inner ${this.link?"-link":""} ${this.hasSectionLink()&&""===this.link?"-section-link":""}"
        >
          <div class="heading-wrapper">${this.getTitle()}</div>
          <div class="content-tabs" role="tablist">
            ${this.selectors.map(((t,e)=>{const{title:i,icon:r}=t;return Y`
                <button
                  @click="${this._handleTab}"
                  id="${r}"
                  class="option ${0===e?"active":""} ${r}"
                  role="tab"
                  aria-controls="${this.ariaControls}"
                  aria-selected="${0===e?"true":"false"}"
                >
                  ${this.getIcon(r)}${i}
                </button>
              `}))}
          </div>
        </div>
        ${this.getLink()} ${this.getSectionLink()}
      </div>
    `}};cr.styles=[dr],p([ut({type:Array,attribute:"aria-controls"})],cr.prototype,"ariaControls",void 0),p([gt()],cr.prototype,"activeSectionLinkText",void 0),p([gt()],cr.prototype,"activeSectionLinkUrl",void 0),p([bt(".icon-container")],cr.prototype,"_icons",void 0),cr=p([ht("atmos-page-content-switcher")],cr);var hr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  display:flex;
  align-items:center;
}

.info{
  padding-left:20px;
}

.info h3 {
  text-align: left;
  margin-top:0;
  margin-bottom:5px;
}

.info h5 {
  text-align: left;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  font-weight:normal;
  margin:0;
}

.image {
  border-radius: 9999px;
  height:80px;
  overflow:hidden;
  width:80px;
  flex-shrink:0;
}

.image ::slotted(img){
  width:100%;
  height:100%;
  object-fit:cover;
}

@media only screen and (min-width: 768px){
  .info{
    padding-left:35px;
  }

  .image{
    height:125px;
    width:125px;
  }

  .title {
    font-size: var(--fs-6xl);
    line-height: var(--lh-6xl);
  }

  .title{
    margin-top:33px;
  }

  .text {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
  }
}
`;let pr=class extends $t{constructor(){super(...arguments),this.name="",this.title=""}getImage(){return Y`<div class="image"><slot name="image"></slot></div>`}render(){return Y`<div class="wrapper">
      ${this.getImage()}
      <div class="info">
        <h3>${this.name}</h3>
        <h5>${this.title}</h5>
      </div>
    </div>`}};pr.styles=[hr],p([ut({attribute:"name"})],pr.prototype,"name",void 0),p([ut({attribute:"title"})],pr.prototype,"title",void 0),pr=p([ht("atmos-person")],pr);var ur=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: inline-block;
}

.btn {
  display: block;
  border-radius: 9999px;
  border-style: none;
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-sizing:border-box;
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
  cursor:pointer;
  height:78px;
  position:relative;
  transition:background 0.5s;
  width:78px;
}

.btn span {
  display: inline-block;
  border-left:solid 20px var(--neutral-white);
  border-top:solid 13px transparent;
  border-bottom:solid 13px transparent;
  border-right:solid 0px transparent;
  transform:translate(3px, 0);
  transition:border-color 0.5s;
}

.btn.btn-blue{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
}

.btn:hover{
  background:linear-gradient(
    355.13deg,
    var(--brand-primary) 100%,
    var(--brand-primary) 100%
  );
}

.btn.btn-blue:hover{
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
}

.btn:active,
.btn.btn-blue:active{
  background:linear-gradient(
    355.13deg,
    var(--neutral-white) 100%,
    var(--neutral-white) 100%
  );
}

.btn:active span,
.btn.btn-blue:active span{
  border-left-color:var(--brand-primary);
}

.btn:focus,
.btn.btn-blue:focus{
  background:linear-gradient(
    355.13deg,
    var(--neutral-white) 100%,
    var(--neutral-white) 100%
  );
  outline:none;
  border:solid 2px var(--brand-primary);
}

.btn:focus span{
  border-left:solid 20px var(--brand-primary);
  border-top:solid 13px transparent;
  border-bottom:solid 13px transparent;
  border-right:solid 0px transparent;
}

.btn:hover span,
.btn:active span,
.btn:focus span{
  border-top-width:16px;
  border-bottom-width:16px;
  border-left-width:26px;
}

@media only screen and (max-width: 639px){
  .btn{
    height:50px;
    width:50px;
  }

  .btn span{
    border-left-width:10px;
    border-top-width:8px;
    border-bottom-width:8px;
    transform:translate(2px, 0);
  }

  .btn:hover span,
  .btn:active span,
  .btn:focus span{
    border-top-width:10px;
    border-bottom-width:10px;
    border-left-width:16px;
  }
}
`;let gr=class extends $t{constructor(){super(...arguments),this.color="gray",this.label="none"}render(){return Y`
      <button class="btn ${`btn-${this.color}`}" aria-label="${this.label}">
        <span></span>
      </button>
    `}};gr.styles=[ur],p([ut({attribute:"color"})],gr.prototype,"color",void 0),p([ut({type:String})],gr.prototype,"label",void 0),gr=p([ht("atmos-play-button")],gr);var fr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  padding-top:75px;
  padding-bottom:75px;
  position:relative;
  overflow:hidden;
}

.outer {
  padding-right: 1.25rem;
  padding-left: 1.25rem;
  padding-bottom: 4rem;
  padding-top: 2.25rem;
  background-color: var(--neutral-white);
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  align-items:center;
  display:flex;
  flex-direction:column;
  margin-left:auto;
  margin-right:auto;
  max-width:279px;
  position:relative;
}

.title{
  display:block;
  text-align:right;
  padding-top:20px;
}

.bg-mobile{
  background-repeat:no-repeat;
  height:520px;
  left:50%;
  position:absolute;
  top:124px;
  transform:translate(-200px, 0px);
  width:380px;
}

.bg-desktop{
  display:none;
}

.icon-wrapper {
  color: var(--brand-primary);
  margin-bottom: 1.75rem;
  width:38px;
}

.quote, .title {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--brand-primary);
  font-weight:300;
  font-size:22px;
  line-height:31px;
  letter-spacing:-0.01em;
}

.quote:before{
  content:'';
}

.quote:after{
  content:'”';
}

@media only screen and (min-width: 640px){
  .wrapper{
    box-sizing:border-box;
    display:flex;
    min-height:420px;
    padding-left:60px;
    padding-right:60px;
  }
  .bg-mobile{
    display:none;
  }

  .bg-desktop{
    display:block;
    background-repeat:no-repeat;
    height:420px;
    left:50%;
    position:absolute;
    top:50%;
    transform:translate(-805px, -210px);
    width:1608px;
  }

  .outer{
    padding-top:56px;
    padding-right:79px;
    padding-bottom:46px;
    padding-left:50px;
    flex-direction:row;
    max-width:940px;
  }

  .icon-wrapper {
    margin-right: 2.25rem;
  }

  .icon-wrapper {
    margin-bottom: 0px;
  }

  .icon-wrapper{
    flex-shrink:0;
  }
}

@media only screen and (min-width: 1024px){
  .outer {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
`;let mr=class extends $t{constructor(){super(...arguments),this.quote="",this.title=""}render(){return Y`
      <div class="wrapper">
        <div class="bg-mobile" style="background-image: url('${'<svg viewBox="0 0 378 517" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M378 2H45.5c-13.807 0-25 11.193-25 25v259c0 13.807 11.193 25 25 25h120c13.807 0 25 11.193 25 25v153.5c0 13.807-11.193 25-25 25H.5" stroke="#FEE96C" stroke-width="4"/>\n</svg>'}')"></div>
        <div
          class="bg-desktop"
          style="background-image: url('${'<svg viewBox="0 0 1607 419" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1607 418h-398c-22.64 0-41-18.356-41-41V42c0-22.644-18.36-41-41-41H585c-22.644 0-41 18.356-41 41v130c0 22.644-18.356 41-41 41H227c-22.644 0-41-18.356-41-41v-35c0-22.644-18.356-41-41-41H0" stroke="#FEE96C" stroke-width="2"/>\n</svg>'}')"
        ></div>
        <div class="outer">
          <div class="icon-wrapper">
            <atmos-icon icon="quote" svg="true"></atmos-icon>
          </div>
          <div>
            <q class="quote"> ${this.quote} </q>
            ${""!==this.title?Y`<cite class="title">${this.title}</cite>`:Y``}
          </div>
        </div>
      </div>
    `}};mr.styles=[fr],p([ut()],mr.prototype,"quote",void 0),p([ut()],mr.prototype,"title",void 0),mr=p([ht("atmos-pull-quote")],mr);var br=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.btn {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  position: relative;
  background-color:var(--neutral-white);
  border-color:var(--neutral-gray);
  border-style:solid;
  border-width:1px;
  border-radius:8px;
  cursor:pointer;
  height:32px;
  min-width:120px;
  padding:0 12px;
  transition:background-color 0.5s, border-color 0.5s;
  width:100%;
}

.btn:after{
  border:solid 2px transparent;
  border-radius:9px;
  content:'';
  position:absolute;
  height:calc(100% + 6px);
  left:-5px;
  top:-5px;
  width:calc(100% + 6px);
}

@media only screen and (max-width: 639px){
  .btn {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
  .btn{
    height:100%;
    padding-top:3px;
    padding-bottom:3px;
    min-height:44px;
  }
}

.btn:hover {
  background-color: var(--brand-primary);
  color: var(--neutral-white);
  border-color:var(--brand-primary);
}

.btn:focus {
  background-color: var(--brand-primary);
  color: var(--neutral-white);
  outline:none;
}

.btn:focus:after{
  border-color:var(--brand-primary);
}

.btn:active{
  background-color:var(--brand-primary-hover);
  color: var(--neutral-white);
  border-color:var(--brand-primary-hover);
}
`;let vr=class extends $t{render(){return Y` <button class="btn" .disabled=${this.disabled}>
      <span class="wrapper">
        <slot></slot>
      </span>
    </button>`}};vr.styles=[br],p([ut({type:Boolean})],vr.prototype,"disabled",void 0),vr=p([ht("atmos-quick-links")],vr);var wr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  padding-left:var(--spacing-14);
  padding-right:var(--spacing-14);
  padding-top: 2rem;
  margin: auto;
  max-width:1500px;
  margin-bottom:100px;
}

.overlay-bottom{
  margin:-280px 50px 0 50px;
}

.no-overlay{
  margin:0;
}

.svg{
  height:135px;
  width:135px;
}

figure {
  margin: 0px;
}

.overlay-bottom .wrapper{
  transform:translateY(280px);
}

.cta {
  display: block;
  position: absolute;
  bottom: 1rem;
  color: var(--neutral-white);
  font-family: Futura Std Light, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-light);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  margin-left:2.5rem;
}

.title{
  margin-left:-40px;
  font-size:var(--fs-3xl);
  color:var(--neutral-white);
  font-weight:bold;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
}

.icons-wrapper{
  margin-left:-50px;
  padding-top: 1rem;
}

.cards-wrapper{
  width:calc(100% + var(--spacing-14));
  display:grid;
  grid-auto-rows:1fr;
  padding-top: 3rem;
  filter:drop-shadow(2px 2px 8px rgba(0, 76, 142, 0.04))
    drop-shadow(4px 4px 22px rgba(0, 76, 142, 0.12));
}

.card-wrapper{
  min-width:20%;
  display:flex;
  align-items:center;
  background:#fff;
  transform:translateY(50%);
  border-right:1px solid #efefef;
}

.icon {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  margin-bottom:1.5rem;
  display:flex;
  height:150px;
  position:relative;
  align-items:center;
  width:calc(100% + 48px);
}

.icon:last-of-type {
  margin-bottom: 0px;
}

.icon svg{
  position:absolute;
  left:0;
}

.icon .number {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size:var(--fs-4xl);
  font-weight:bold;
  color:#fee96c;
  margin-left:60px;
}

.icon .text{
  line-height:var(--lh-base);
  margin-left:25px;
  color:var(--neutral-white);
  font-size:18px;
  line-height:123%;
  letter-spacing:0.01em;
}

.icon .text b,
.icon .text strong{
  color:#fee96c;
}

@media only screen and (min-width: 768px){
  .title{
    margin-left:0;
  }

  .icons-wrapper{
    margin-left:-10px;
  }

  .cards-wrapper {
    width: 100%;
  }

  .icon{
    width:auto;
  }

  .card-wrapper {
    display: block;
  }

  .card-wrapper{
    padding:1.2rem 0px;
  }
}

@media only screen and (min-width: 1024px){
  .title{
    margin-left:0;
  }
  .cards-wrapper{
    display:flex;
  }

  .card-wrapper {
    padding: 0px;
  }
}

@media only screen and (min-width: 1280px){
  .icon .number{
    margin-left:70px;
  }

  .icon .text {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
  }

  .icon .text{
    margin-left:30px;
  }

  .icon{
    height:162px;
    margin-bottom:3.5rem;
  }
  .svg{
    height:173px;
    width:173px;
  }

  .icon .number {
    font-size: var(--fs-5xl);
    line-height: var(--lh-5xl);
  }

  .title{
    font-size:var(--fs-4xl);
  }

  .wrapper{
    background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
    padding-left:180px;
    padding-right:180px;
    padding-top:64px;
  }
}

@media only screen and (min-width: 1440px){
  .icons-wrapper{
    display:flex;
    justify-content:space-around;
    transform:translateY(20%);
  }

  .cta {
    bottom: 1rem;
  }
}
`;let xr=class extends $t{getPhoneCta(){return this.phoneCta?Y`<a class="cta" href="tel:${this.phoneCta}"
        >${this.phoneCta}</a
      >`:null}getIcon(){return Y` <svg
      class="svg"
      width="167"
      height="171"
      viewBox="0 0 167 171"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2441_19767"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="167"
        height="171"
      >
        <path
          d="M103.996 79.7619C122.359 74.7887 156.903 38.5409 166.543 39L142.442 16.6409L115.473 0H73.5834L35.137 13.198L17.3484 27.5436L0.133694 56.8087C0.70752 65.6074 1.51088 86.1886 0.133694 98.1242C-1.24349 110.06 8.35853 128.346 13.3317 135.997L35.137 154.359C46.6136 159.906 70.3699 171 73.5834 171C77.6001 171 103.996 169.852 110.882 168.131C116.391 166.754 136.513 156.081 145.885 150.916L166.543 135.997L103.996 79.7619Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_2441_19767)">
        <circle
          cx="88.2143"
          cy="82.9178"
          r="76.7534"
          stroke="#FEE96C"
          stroke-width="2"
        />
      </g>
    </svg>`}infoSlotTemplate(){const t=this.cards.length;return Y`
      <div class="${this.overlayBottom?"overlay-bottom":"no-overlay"}">
        <div class="wrapper">
          <div class="rcl-content">
            <div class="title">${this.title}</div>
            ${this.icons&&Y`<div class="icons-wrapper">
              ${this.icons.map(((t,e)=>Y`
                  <div class="icon">
                    ${this.getIcon()}
                    <div class="number">${t.number}</div>
                    <div class="text">
                      ${t.text?Ot(t.text):""}${e===this.icons.length-1?this.getPhoneCta():null}
                    </div>
                  </div>
                `))}
            </div>`}
            <div class="cards-wrapper">
              ${this.cards.map((e=>{const{number:i,icon:r,text:n,title:o,cardPadding:a,sampleImage:s,altText:l}=e;return Y`
                  <div class="card-wrapper">
                    <atmos-info-card
                      card-group-total="${t}"
                      card-number="${At(i)}"
                      card-icon="${At(r)}"
                      text="${At(n)}"
                      title="${At(o)}"
                      card-padding="${At(a)}"
                      href="${At(s)}"
                      alt-text="${At(l)}"
                      variant="horizontal-reverse"
                    ></atmos-info-card>
                  </div>
                `}))}
            </div>
          </div>
        </div>
      </div>
    `}render(){return Y`
      <figure><slot></slot></figure>
      ${this.infoSlotTemplate()}
    `}};xr.styles=[wr],p([ut({type:Array,attribute:"icons"})],xr.prototype,"icons",void 0),p([ut({type:Boolean,attribute:"overlay-bottom"})],xr.prototype,"overlayBottom",void 0),p([ut({type:Array,attribute:"cards"})],xr.prototype,"cards",void 0),p([ut({type:String,attribute:"phone-cta"})],xr.prototype,"phoneCta",void 0),xr=p([ht("atmos-recognizing-leak")],xr);var yr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  background:linear-gradient(
    1.48deg,
    #c2deff 1.51%,
    rgba(194, 222, 255, 0) 90.41%
  );
  padding-bottom:200px;
}

.wrapper-title {
  margin: auto;
}

.title {
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
}

.title span {
  color: var(--brand-primary);
}

.grid-wrapper {
  display: grid;
  margin: auto;
  row-gap:32px;
  max-width:254px;
}

.grid-wrapper.full{
  max-width:none;
}

.grid-wrapper.img,
.wrapper-title{
  max-width:352px;
}

.inner{
  padding-bottom:2.4rem;
}

@media only screen and (min-width: 640px){
  .grid-wrapper{
    max-width:548px;
    grid-column-gap:40px;
    grid-auto-rows:1fr;
    grid-template-columns:repeat(2, 1fr);
  }

  .grid-wrapper.full{
    max-width:none;
  }

  .grid-wrapper.img,
  .wrapper-title{
    max-width:744px;
  }

  .grid-wrapper.single{
    grid-template-columns:repeat(1, 1fr);
  }
}

@media only screen and (min-width: 1280px){
  .grid-wrapper, .grid-wrapper.img, .wrapper-title {
    max-width: 1136px;
  }

  .title {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }

  .grid-wrapper.full{
    max-width:none;
  }

  .grid-wrapper.single{
    grid-template-columns:repeat(1, 1fr);
  }

  .grid-wrapper.double{
    grid-template-columns:repeat(2, 1fr);
  }

  .grid-wrapper.multi{
    grid-template-columns:repeat(3, 1fr);
  }
}
`;let Cr=class extends $t{constructor(){super(...arguments),this.type="normal"}getTitle(){return""!==this.title?Y`<h2 class="title">${Ot(this.title)}</h2> `:""}render(){let t="";switch(this.cards.length){case 1:t="single";break;case 2:t="double";break;default:t="multi"}return Y`
      <div class="wrapper">
        <div class="wrapper-title">${this.getTitle()}</div>
        <div class="inner">
          <div class="grid-wrapper ${this.type} ${t} img">
            ${this.cards.map((t=>{const{title:e,text:i,url:r,link:n,imageUrl:o}=t;return Y`
                <div class="card-wrapper grid-card">
                  <atmos-image-card
                    type="white"
                    url="${At(r)}"
                    title="${e}"
                    text="${i}"
                    link="${n}"
                    imageUrl="${o}"
                    related="related"
                  >
                  </atmos-image-card>
                </div>
              `}))}
          </div>
        </div>
      </div>
    `}};Cr.styles=[yr],p([ut({type:String})],Cr.prototype,"title",void 0),p([ut({type:Array,attribute:"cards"})],Cr.prototype,"cards",void 0),p([ut({attribute:"type"})],Cr.prototype,"type",void 0),Cr=p([ht("atmos-related-cards")],Cr);var kr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  border:solid 1px var(--neutral-grayMedium);
  border-radius:32px;
  padding:32px;
}

.wrapper-list ul{
  list-style-type:none;
  margin:0;
  padding:0;
  display:flex;
  flex-wrap:wrap;
}

.wrapper-list ul li{
  box-sizing:border-box;
  flex-shrink:0;
  width:calc(100% / 3);
  padding-right:20px;
}

@media only screen and (max-width: 767px){
  .wrapper-list ul li{
    width:100%;
  }
}

h2 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
  margin-top:0;
}

h5 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  margin:0 0 4px 0;
}

h6 {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  margin:0 0 28px 0;
}
`;let Ar=class extends $t{render(){return Y`
      <div class="wrapper">
        <h2>${this.title}</h2>
        <div class="wrapper-list">
          <ul>
            ${this.list.map((t=>Y`
                <li>
                  <h5>${t.title}</h5>
                  <h6>${t.name}</h6>
                </li>
              `))}
          </ul>
        </div>
      </div>
    `}};Ar.styles=[kr],p([ut({type:String,attribute:"title"})],Ar.prototype,"title",void 0),p([ut({type:Array,attribute:"list"})],Ar.prototype,"list",void 0),Ar=p([ht("atmos-research-coverage")],Ar);var zr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper.open{
  width:50vw;
}

.links atmos-quick-links{
  margin-bottom:5px;
}

.extras,
.links{
  background-color:#fff;
}

.search-button {
  background-color: var(--brand-primary);
  display: flex;
  color: var(--neutral-white);
  padding: 0px;
  align-items:center;
  border:none;
  cursor:pointer;
  height:50px;
  justify-content:center;
  transition:background 0.5s;
  width:97px;
}

.search-button:hover{
  background-color:var(--brand-primary-hover);
}

.search-button atmos-icon {
  display: block;
  width:21px;
}

.box-wrapper {
  background-color: var(--brand-primary);
  display: flex;
  align-items:center;
  height:50px;
  padding:0 39px 0 15px;
}

.close-action {
  display: block;
  padding: 0px;
  color: var(--neutral-white);
  background:none;
  border:none;
  cursor:pointer;
  height:20px;
  margin-left:16px;
  width:20px;
}

.close-action atmos-icon{
  min-width:18px;
  min-height:18px;
}

.input-wrapper {
  width: 100%;
  position: relative;
  height:38px;
}

.input-wrapper ::slotted([slot='search-field']) {
  width: 100%;
  border:none;
  box-sizing:border-box;
  height:38px;
  padding-right:50px;
}

.search-action {
  position: absolute;
  display: block;
  padding: 0px;
  background:none;
  border:none;
  cursor:pointer;
  height:21px;
  right:16px;
  top:9px;
  width:21px;
}

.suggestions {
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  display:none;
  max-width:420px;
  padding:40px 20px;
  background:#fff;
  transform:translate(15px, -6px);
  border:1px solid #ccc;
}

.wrapper.open .suggestions{
  display:block;
}

.extras{
  padding-top:36px;
  max-width:420px;
}

.recent{
  padding-top:0;
  max-width:420px;
}

.extras h3 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  margin-top: 0px;
  margin-bottom:20px;
  text-transform:uppercase;
}

.extras ul {
  padding: 0px;
  margin: 0px;
  list-style-type:none;
}

.extras ul li button {
  margin: 0px;
  padding: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  cursor:pointer;
  border:none;
  background:transparent;
}

.extras ul li{
  margin-bottom:20px;
}

.extras ul li:last-child {
  margin-bottom: 0px;
}

@media only screen and (min-width: 640px){
  .links{
    display:flex;
    flex-wrap:wrap;
  }

  .links atmos-quick-links{
    width:50%;
    text-align:center;
  }

  .input-text{
    font-size:2.25rem;
    padding-bottom:6px;
  }
  Que tal contador,
  buen dia,
  oiga una duda,
  si pusiera .input button{
    bottom:13px;
  }
}

@media only screen and (min-width: 1024px){
  .suggestions {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
`,$r=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.links{
  display:flex;
  flex-wrap:wrap;
  margin-left:-5px;
  margin-right:-5px;
}

.links atmos-quick-links{
  margin:0px 5px 10px 5px;
  width:calc(100% / 3 - 15px);
}

.input{
  position:relative;
}

.input button{
  position:absolute;
  border:none;
  background:transparent;
  cursor:pointer;
  height:25px;
  margin:0;
  padding:0;
  bottom:10px;
  right:0;
  width:25px;
}

.input-text {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
  font-size:1.75rem;
  font-weight:400;
  border:none;
  border-bottom:solid 1px var(--neutral-grayDark);
  box-sizing:border-box;
  padding:0 35px 3px 0;
  padding-bottom:6px;
  width:100%;
}

.input-text::-moz-placeholder {
  color: var(--neutral-grayDark);
}

.input-text::placeholder {
  color: var(--neutral-grayDark);
}

.input-text:focus{
  outline-color:var(--brand-primary);
  outline-width:2px;
  outline-offset:10px;
}

.input button:focus{
  outline-color:var(--brand-primary);
  outline-width:2px;
  outline-offset:2px;
}

@media only screen and (min-width: 640px){
  .links atmos-quick-links{
    width:auto;
  }

  .input-text{
    font-size:2.25rem;
    padding-bottom:6px;
  }

  .input button{
    bottom:13px;
  }
}

.extras{
  margin-top:48px;
}

.recent{
  margin-top:36px;
}

.extras h3 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  margin-top: 0px;
  margin-bottom:20px;
  text-transform:uppercase;
}

.extras ul {
  padding: 0px;
  margin: 0px;
  list-style-type:none;
}

.extras ul li button {
  margin: 0px;
  padding: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  cursor:pointer;
  border:none;
  background:transparent;
}

.extras ul li{
  margin-bottom:20px;
}

.extras ul li:last-child {
  margin-bottom: 0px;
}
`;let Mr=class extends dt{constructor(){super(...arguments),this.query="",this.links=[],this.recent=[],this.suggested=[],this._handleClick=(t,e)=>{var i;t.preventDefault(),t.stopPropagation();const r=null===(i=this.shadowRoot)||void 0===i?void 0:i.querySelector(".input-text");r&&(r.value=e.value),this.query=e.value},this._handleSearch=t=>{t.preventDefault(),t.stopPropagation(),this._searchEvent()},this._handleSubmit=({key:t})=>{"Enter"===t&&this._searchEvent()}}_handleChange({target:t}){this.query=t.value}_searchEvent(){const t=new CustomEvent("search",{detail:{query:this.query}});this.dispatchEvent(t)}_handleSuggested(t,e){t.preventDefault(),t.stopPropagation();const i=new CustomEvent("search-suggested",{detail:{item:e}});this.dispatchEvent(i)}renderLinks(){return this.links?Y`
          <div class="links">
            ${this.links.map((t=>Y`<atmos-quick-links
                  @click="${e=>this._handleClick(e,t)}"
                  >${t.label}</atmos-quick-links
                >`))}
          </div>
        `:null}render(){return Y`
      <div class="wrapper">
        <div class="input">
          <slot name="search-field"></slot>
        </div>
      </div>
    `}};Mr.styles=[$r],p([gt()],Mr.prototype,"query",void 0),p([ut({type:Array})],Mr.prototype,"links",void 0),p([ut({type:Array})],Mr.prototype,"recent",void 0),p([ut({type:Array})],Mr.prototype,"suggested",void 0),Mr=p([ht("atmos-search")],Mr);let Sr=class extends Mr{constructor(){super(...arguments),this.searchEnabled=!1}connectedCallback(){super.connectedCallback(),document.addEventListener("keydown",(t=>{const{keyCode:e}=t;27==e&&(this.searchEnabled=!1)}))}disconnectedCallback(){document.removeEventListener("keydown",(t=>{const{keyCode:e}=t;27==e&&(this.searchEnabled=!1)})),super.disconnectedCallback()}_openClose(t,e){t.preventDefault(),t.stopPropagation(),this.searchEnabled=e}renderInput(){return Y`
      <div class="box-wrapper">
        <div class="input-wrapper">
          <slot name="search-field"></slot>
        </div>
        <button
          class="close-action"
          @click="${t=>{this._openClose(t,!1)}}"
        >
          <atmos-icon icon="close" svg="true" aria-label="close search box" />
        </button>
      </div>
    `}renderButton(){return Y`
      <button
        class="search-button"
        @click="${t=>{this._openClose(t,!0)}}"
        aria-label="open search box"
      >
        <atmos-icon icon="search" svg="true" />
      </button>
    `}render(){return Y`
      <div class="wrapper ${this.searchEnabled?"open":""}">
        ${this.searchEnabled?this.renderInput():this.renderButton()}
      </div>
    `}};Sr.styles=[zr],p([gt()],Sr.prototype,"searchEnabled",void 0),Sr=p([ht("atmos-search-desktop")],Sr);var Lr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper.large{
  max-width:1000px;
  margin:0 auto;
}

.wrapper.medium{
  max-width:750px;
  margin:0 auto;
}

.links{
  display:flex;
  flex-wrap:wrap;
  margin-top:10px;
}

.links atmos-quick-links{
  text-align:center;
  padding:2px;
}

.input{
  position:relative;
}

.input button{
  position:absolute;
  border:none;
  background:transparent;
  cursor:pointer;
  height:25px;
  margin:0;
  padding:0;
  bottom:10px;
  right:0;
  width:25px;
}

.input ::slotted([slot='search-field-header']) {
  font-family: Futura Std, Helvetica, Arial, sans-serif !important;
  color: var(--neutral-grayDark);
  font-size:1.25rem !important;
  font-weight:400;
  border:none;
  box-sizing:border-box;
  padding:6px !important;
  width:100%;
  outline:none;
  line-height:1.25rem !important;
}

.input ::slotted([slot='search-field-block']) {
  font-family: Futura Std, Helvetica, Arial, sans-serif !important;
  color: var(--neutral-grayDark);
  font-size:1.75rem !important;
  font-weight:400;
  border:none;
  border-bottom:solid 1px var(--neutral-grayDark) !important;
  box-sizing:border-box;
  padding:0 35px 6px 0 !important;
  width:100%;
  outline:none;
}

.input-text::-moz-placeholder {
  color: var(--neutral-grayDark);
}

.input-text::placeholder {
  color: var(--neutral-grayDark);
}

.input-text:focus{
  outline-color:var(--brand-primary);
  outline-width:2px;
  outline-offset:10px;
}

.input button:focus{
  outline-color:var(--brand-primary);
  outline-width:2px;
  outline-offset:2px;
}

@media only screen and (min-width: 640px){
  .input-text{
    font-size:2.25rem;
    padding-bottom:6px;
  }

  .input button{
    bottom:13px;
  }
}

.extras{
  margin-top:48px;
}

.recent{
  margin-top:94px;
}

.extras h3 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  margin-top: 0px;
  margin-bottom:20px;
  text-transform:uppercase;
}

.extras ul {
  padding: 0px;
  margin: 0px;
  list-style-type:none;
}

.extras ul li button {
  margin: 0px;
  padding: 0px;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  cursor:pointer;
  border:none;
  background:transparent;
}

.extras ul li{
  margin-bottom:20px;
}

.extras ul li:last-child {
  margin-bottom: 0px;
}
`;let Hr=class extends Mr{constructor(){super(...arguments),this.query="",this.defaultValue="",this._handleSubmit=({key:t})=>{"Enter"===t&&this._searchEvent()},this._handleSearch=t=>{t.preventDefault(),t.stopPropagation();const e=new CustomEvent("searchField",{detail:{query:this.query}});this.dispatchEvent(e)}}_handleChange({target:t}){this.query=t.value}_searchEvent(){const t=new CustomEvent("searchField",{detail:{query:this.query}});this.dispatchEvent(t)}render(){const t=this.variant?"large":"medium";return Y`
      <div class="wrapper ${t}">
        <div class="input">
          <slot name="search-field-block"></slot>
          <slot name="search-field-header"></slot>
          <button aria-label="search" @click="${this._handleSearch}">
            <atmos-icon icon="search" svg="true" />
          </button>
        </div>
        ${this.renderLinks()}
      </div>
    `}};Hr.styles=[Lr],p([gt()],Hr.prototype,"query",void 0),p([ut({attribute:"default-value"})],Hr.prototype,"defaultValue",void 0),p([ut({attribute:"variant"})],Hr.prototype,"variant",void 0),Hr=p([ht("atmos-search-field")],Hr);var Br=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.search-result-wrapper {
  margin-top: 2rem;
  border-bottom:1px solid #c3c8c8;
}

a{
  text-decoration:none;
}

.title {
  color: var(--brand-primary);
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  margin-bottom: 1.5rem;
}

.text {
  color: var(--neutral-grayDark);
  margin-bottom: 2rem;
}
`;let _r=class extends $t{render(){return Y`
      <div class="search-result-wrapper">
        <a href="${this.url}">
          <div class="title">${this.title}</div>
          <div class="text">${this.text?Ot(this.text):""}</div>
        </a>
      </div>
    `}};_r.styles=[Br],p([ut({attribute:"text"})],_r.prototype,"text",void 0),p([ut({attribute:"url"})],_r.prototype,"url",void 0),_r=p([ht("atmos-search-result")],_r);var Fr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outer-wrapper {
  padding-top: 0.75rem;
  position: relative;
  margin: auto;
  max-width: 1136px;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link-wrapper-top{
  display:none;
}

h3.title {
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  color: var(--neutral-grayDark);
  margin-bottom: 2rem;
  letter-spacing:-0.02em;
  line-height:116%;
  word-break:break-all;
}

h3.title span {
  display: block;
  color: var(--brand-primary);
}

.links {
  width: 100%;
  margin: 0px;
  margin-bottom: 1.5rem;
  list-style-type:none;
  padding:0;
}

.link {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  background-color: var(--neutral-white);
  width: 100%;
  display: block;
  border:none;
  border-top:solid var(--neutral-grayMedium) 1px;
  cursor:pointer;
  font-size:17px;
  padding:14px 0;
  transition:background 0.5s;
}

.links li:last-child .link{
  border-bottom:solid var(--neutral-grayMedium) 1px;
}

.link:hover, .link:focus, .link.active {
  background-color: var(--brand-primary);
  color: var(--neutral-white);
  border-top-color:var(--brand-primary);
}

.sidebar .links{
  display:none;
}

.stacked{
  width:100%;
}

@media only screen and (min-width: 640px){
  .header {
    display: flex;
  }
  .header {
    flex-direction: row;
  }
  .header {
    align-items: flex-start;
  }
  .header {
    margin: auto;
  }
  .header {
    padding-bottom: 2rem;
  }
  .header{
    max-width:548px;
    justify-content:space-between;
  }

  h3.title{
    margin-top:10px;
  }

  .links{
    flex-shrink:0;
    margin-left:20px;
    width:156px;
  }

  .link-wrapper-bottom {
    display: flex;
  }

  .link-wrapper-bottom {
    justify-content: center;
  }
}

@media only screen and (min-width: 1280px){
  h3.title {
    font-size: var(--fs-6xl);
    line-height: var(--lh-6xl);
  }

  .header {
    align-items: flex-end;
  }

  .header{
    max-width:none;
  }

  .link-wrapper-top{
    display:block;
  }

  .header .links{
    display:none;
  }

  .wrapper {
    display: flex;
  }

  .sidebar{
    padding-top:40px;
    padding-right:138px;
  }

  .sidebar .links{
    display:block;
    margin-left:0;
  }

  .link-wrapper-bottom{
    display:none;
  }
}
`;let Dr=class extends hi{constructor(){super(...arguments),this.items=[],this.url=null,this.link=null,this.target=null,this.rel=null,this.activeItem=0,this.camelFormat=t=>{const e=t.replace(/\//g," ").split(" ").map((t=>t.charAt(0).toUpperCase()+t.slice(1))).join("");return e.charAt(0).toLowerCase()+e.slice(1)}}_handleClick(t){this.activeItem=t}renderLinks(){const t=this.items.map((t=>t.title));return Y`
      <ul
        class="links"
        role="tablist"
        aria-label="Group of tab options to toggle group of info cards concerning ${this.title} ${this.titleAccent}"
      >
        ${t.map(((t,e)=>Y`
              <li>
                <button
                  @click="${()=>this._handleClick(e)}"
                  class="link ${e===this.activeItem?"active":""}"
                  id="${this.camelFormat(t)}"
                  role="tab"
                  aria-controls="cards"
                  aria-selected="${e===this.activeItem?"true":""}"
                >
                  ${t}
                </button>
              </li>
            `))}
      </ul>
    `}renderCards(){const t=this.items[this.activeItem],e=t&&t.cards?t.cards.map(((t,e)=>{const i=Object.assign({},t);return i.icon||(i.number=`${e+1}`),i})):[],i=t?t.title:"";return Y`
      <atmos-info-card-stacked
        class="stacked"
        id="cards"
        role="tabpanel"
        aria-labelledby="${this.camelFormat(i)}"
        type="full"
        cards="${JSON.stringify([...e])}"
      />
    `}renderLink(t){return this.url&&this.link&&this.target&&this.rel&&this.linkTitle&&Y`
        <div class="link-wrapper-${t}">
          <atmos-button
            url="${At(this.url)}"
            target="${this.target}"
            rel="${this.rel}
            link-title="${this.linkTitle}"
          >
            ${this.link}
          </atmos-button>
        </div>
      `}render(){return Y`
      <div class="outer-wrapper">
        <div class="header">
          ${this.getTitle()} ${this.renderLinks()} ${this.renderLink("top")}
        </div>
        <div class="wrapper">
          <div class="sidebar">${this.renderLinks()}</div>
          ${this.renderCards()}
        </div>
        ${this.renderLink("bottom")}
      </div>
    `}};Dr.styles=[Fr],p([ut({type:Array,attribute:"items"})],Dr.prototype,"items",void 0),p([ut({type:String})],Dr.prototype,"url",void 0),p([ut({type:String})],Dr.prototype,"link",void 0),p([ut({type:String})],Dr.prototype,"target",void 0),p([ut({type:String})],Dr.prototype,"rel",void 0),p([ut({type:String,attribute:"link-title"})],Dr.prototype,"linkTitle",void 0),p([gt()],Dr.prototype,"activeItem",void 0),Dr=p([ht("atmos-season-switcher")],Dr);var Er=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
@font-face{
  font-family:'swiper-icons';
  src:url('data:application/font-woff;charset=utf-8;base64, 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');
  font-weight:400;
  font-style:normal;
}

:root{
  --swiper-theme-color:#007aff;
}

.swiper{
  margin-left:auto;
  margin-right:auto;
  position:relative;
  overflow:hidden;
  list-style:none;
  padding:0;
  z-index:1;
}

.swiper-vertical > .swiper-wrapper{
  flex-direction:column;
}

.swiper-wrapper{
  position:relative;
  width:100%;
  height:100%;
  z-index:1;
  display:flex;
  transition-property:transform;
  box-sizing:content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper{
  transform:translate3d(0px, 0, 0);
}

.swiper-pointer-events{
  touch-action:pan-y;
}

.swiper-pointer-events.swiper-vertical{
  touch-action:pan-x;
}

.swiper-slide{
  flex-shrink:0;
  width:100%;
  height:100%;
  position:relative;
  transition-property:transform;
}

.swiper-slide-invisible-blank{
  visibility:hidden;
}

.swiper-autoheight,
.swiper-autoheight .swiper-slide{
  height:auto;
}

.swiper-autoheight .swiper-wrapper{
  align-items:flex-start;
  transition-property:transform, height;
}

.swiper-backface-hidden .swiper-slide{
  transform:translateZ(0);
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-3d,
.swiper-3d.swiper-css-mode .swiper-wrapper{
  perspective:1200px;
}

.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow{
  transform-style:preserve-3d;
}

.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom{
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  pointer-events:none;
  z-index:10;
}

.swiper-3d .swiper-slide-shadow{
  background:rgba(0, 0, 0, 0.15);
}

.swiper-3d .swiper-slide-shadow-left{
  background-image:linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-right{
  background-image:linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-top{
  background-image:linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-3d .swiper-slide-shadow-bottom{
  background-image:linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-css-mode > .swiper-wrapper{
  overflow:auto;
  scrollbar-width:none;
  -ms-overflow-style:none;
}

.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar{
  display:none;
}

.swiper-css-mode > .swiper-wrapper > .swiper-slide{
  scroll-snap-align:start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper{
  scroll-snap-type:x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper{
  scroll-snap-type:y mandatory;
}

.swiper-centered > .swiper-wrapper::before{
  content:'';
  flex-shrink:0;
  order:9999;
}

.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child{
  -webkit-margin-start:var(--swiper-centered-offset-before);
          margin-inline-start:var(--swiper-centered-offset-before);
}

.swiper-centered.swiper-horizontal > .swiper-wrapper::before{
  height:100%;
  min-height:1px;
  width:var(--swiper-centered-offset-after);
}

.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child{
  -webkit-margin-before:var(--swiper-centered-offset-before);
          margin-block-start:var(--swiper-centered-offset-before);
}

.swiper-centered.swiper-vertical > .swiper-wrapper::before{
  width:100%;
  min-width:1px;
  height:var(--swiper-centered-offset-after);
}

.swiper-centered > .swiper-wrapper > .swiper-slide{
  scroll-snap-align:center center;
}

.swiper-virtual .swiper-slide{
  -webkit-backface-visibility:hidden;
  transform:translateZ(0);
}

.swiper-virtual.swiper-css-mode .swiper-wrapper::after{
  content:'';
  position:absolute;
  left:0;
  top:0;
  pointer-events:none;
}

.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{
  height:1px;
  width:var(--swiper-virtual-size);
}

.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{
  width:1px;
  height:var(--swiper-virtual-size);
}

:root{
  --swiper-navigation-size:44px;
}

.swiper-button-prev,
.swiper-button-next{
  position:absolute;
  top:50%;
  width:calc(44px / 44 * 27);
  width:calc(var(--swiper-navigation-size) / 44 * 27);
  height:44px;
  height:var(--swiper-navigation-size);
  margin-top:calc(0px - (44px / 2));
  margin-top:calc(0px - (var(--swiper-navigation-size) / 2));
  z-index:10;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  color:var(--swiper-theme-color);
  color:var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled{
  opacity:0.35;
  cursor:auto;
  pointer-events:none;
}

.swiper-button-prev:after,
.swiper-button-next:after{
  font-family:swiper-icons;
  font-size:44px;
  font-size:var(--swiper-navigation-size);
  letter-spacing:0;
  text-transform:none;
  font-variant:initial;
  line-height:1;
}

.swiper-button-prev,
.swiper-rtl .swiper-button-next{
  left:10px;
  right:auto;
}

.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after{
  content:'prev';
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev{
  right:10px;
  left:auto;
}

.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after{
  content:'next';
}

.swiper-button-lock{
  display:none;
}

:root{
}

.swiper-pagination{
  position:absolute;
  text-align:center;
  transition:300ms opacity;
  transform:translate3d(0, 0, 0);
  z-index:10;
}

.swiper-pagination.swiper-pagination-hidden{
  opacity:0;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal{
  bottom:10px;
  left:0;
  width:100%;
}

.swiper-pagination-bullets-dynamic{
  overflow:hidden;
  font-size:0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transform:scale(0.33);
  position:relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{
  transform:scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{
  transform:scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{
  transform:scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{
  transform:scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{
  transform:scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{
  transform:scale(0.33);
}

.swiper-pagination-bullet{
  width:8px;
  width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height:8px;
  height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display:inline-block;
  border-radius:50%;
  background:#000;
  background:var(--swiper-pagination-bullet-inactive-color, #000);
  opacity:0.2;
  opacity:var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}

button.swiper-pagination-bullet{
  border:none;
  margin:0;
  padding:0;
  box-shadow:none;
  -webkit-appearance:none;
          -moz-appearance:none;
       appearance:none;
}

.swiper-pagination-clickable .swiper-pagination-bullet{
  cursor:pointer;
}

.swiper-pagination-bullet:only-child{
  display:none !important;
}

.swiper-pagination-bullet-active{
  opacity:1;
  opacity:var(--swiper-pagination-bullet-opacity, 1);
  background:var(--swiper-theme-color);
  background:var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets{
  right:10px;
  top:50%;
  transform:translate3d(0px, -50%, 0);
}

.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{
  margin:6px 0;
  margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display:block;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{
  top:50%;
  transform:translateY(-50%);
  width:8px;
}

.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  display:inline-block;
  transition:200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{
  margin:0 4px;
  margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{
  left:50%;
  transform:translateX(-50%);
  white-space:nowrap;
}

.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transition:200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{
  transition:200ms transform, 200ms right;
}

.swiper-pagination-progressbar{
  background:rgba(0, 0, 0, 0.25);
  position:absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{
  background:var(--swiper-theme-color);
  background:var(--swiper-pagination-color, var(--swiper-theme-color));
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  transform:scale(0);
  transform-origin:left top;
}

.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{
  transform-origin:right top;
}

.swiper-horizontal > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-horizontal,
.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{
  width:100%;
  height:4px;
  left:0;
  top:0;
}

.swiper-vertical > .swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-vertical,
.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{
  width:4px;
  height:100%;
  left:0;
  top:0;
}

.swiper-pagination-lock{
  display:none;
}

.swiper-scrollbar{
  border-radius:10px;
  position:relative;
  -ms-touch-action:none;
  background:rgba(0, 0, 0, 0.1);
}

.swiper-horizontal > .swiper-scrollbar{
  position:absolute;
  left:1%;
  bottom:3px;
  z-index:50;
  height:5px;
  width:98%;
}

.swiper-vertical > .swiper-scrollbar{
  position:absolute;
  right:3px;
  top:1%;
  z-index:50;
  width:5px;
  height:98%;
}

.swiper-scrollbar-drag{
  height:100%;
  width:100%;
  position:relative;
  background:rgba(0, 0, 0, 0.5);
  border-radius:10px;
  left:0;
  top:0;
}

.swiper-scrollbar-cursor-drag{
  cursor:move;
}

.swiper-scrollbar-lock{
  display:none;
}

.swiper-zoom-container{
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  text-align:center;
}

.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas{
  max-width:100%;
  max-height:100%;
  object-fit:contain;
}

.swiper-slide-zoomed{
  cursor:move;
}

:root{
}

.swiper-lazy-preloader{
  width:42px;
  height:42px;
  position:absolute;
  left:50%;
  top:50%;
  margin-left:-21px;
  margin-top:-21px;
  z-index:10;
  transform-origin:50%;
  box-sizing:border-box;
  border:4px solid var(--swiper-theme-color);
  border:4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius:50%;
  border-top-color:transparent;
}

.swiper-slide-visible .swiper-lazy-preloader{
  -webkit-animation:swiper-preloader-spin 1s infinite linear;
          animation:swiper-preloader-spin 1s infinite linear;
}

.swiper-lazy-preloader-white{
  --swiper-preloader-color:#fff;
}

.swiper-lazy-preloader-black{
  --swiper-preloader-color:#000;
}

@-webkit-keyframes swiper-preloader-spin{
  0%{
    transform:rotate(0deg);
  }
  100%{
    transform:rotate(360deg);
  }
}

@keyframes swiper-preloader-spin{
  0%{
    transform:rotate(0deg);
  }
  100%{
    transform:rotate(360deg);
  }
}

.swiper .swiper-notification{
  position:absolute;
  left:0;
  top:0;
  pointer-events:none;
  opacity:0;
  z-index:-1000;
}

.swiper-free-mode > .swiper-wrapper{
  transition-timing-function:ease-out;
  margin:0 auto;
}

.swiper-grid > .swiper-wrapper{
  flex-wrap:wrap;
}

.swiper-grid-column > .swiper-wrapper{
  flex-wrap:wrap;
  flex-direction:column;
}

.swiper-fade.swiper-free-mode .swiper-slide{
  transition-timing-function:ease-out;
}

.swiper-fade .swiper-slide{
  pointer-events:none;
  transition-property:opacity;
}

.swiper-fade .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-fade .swiper-slide-active,
.swiper-fade .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-cube{
  overflow:visible;
}

.swiper-cube .swiper-slide{
  pointer-events:none;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  z-index:1;
  visibility:hidden;
  transform-origin:0 0;
  width:100%;
  height:100%;
}

.swiper-cube .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-cube.swiper-rtl .swiper-slide{
  transform-origin:100% 0;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-cube .swiper-slide-active,
.swiper-cube .swiper-slide-next,
.swiper-cube .swiper-slide-prev,
.swiper-cube .swiper-slide-next + .swiper-slide{
  pointer-events:auto;
  visibility:visible;
}

.swiper-cube .swiper-slide-shadow-top,
.swiper-cube .swiper-slide-shadow-bottom,
.swiper-cube .swiper-slide-shadow-left,
.swiper-cube .swiper-slide-shadow-right{
  z-index:0;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-cube .swiper-cube-shadow{
  position:absolute;
  left:0;
  bottom:0px;
  width:100%;
  height:100%;
  opacity:0.6;
  z-index:0;
}

.swiper-cube .swiper-cube-shadow:before{
  content:'';
  background:#000;
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  filter:blur(50px);
}

.swiper-flip{
  overflow:visible;
}

.swiper-flip .swiper-slide{
  pointer-events:none;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  z-index:1;
}

.swiper-flip .swiper-slide .swiper-slide{
  pointer-events:none;
}

.swiper-flip .swiper-slide-active,
.swiper-flip .swiper-slide-active .swiper-slide-active{
  pointer-events:auto;
}

.swiper-flip .swiper-slide-shadow-top,
.swiper-flip .swiper-slide-shadow-bottom,
.swiper-flip .swiper-slide-shadow-left,
.swiper-flip .swiper-slide-shadow-right{
  z-index:0;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
}

.swiper-creative .swiper-slide{
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  overflow:hidden;
  transition-property:transform, opacity, height;
}

.swiper-cards{
  overflow:visible;
}

.swiper-cards .swiper-slide{
  transform-origin:center bottom;
  -webkit-backface-visibility:hidden;
          backface-visibility:hidden;
  overflow:hidden;
}

.card-wrapper-mobile{
  max-width:295px;
  margin:0 40px;
  display:flex;
  flex-direction:column;
}

.card-wrapper-desktop {
  display: flex;
}

img{
  object-fit:cover;
  height:295px;
}

.social-icon-group-wrapper {
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 2.5rem;
  max-width:186px;
}

.social-post-link {
  display: flex;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  color: var(--neutral-grayDark);
}

.carousel-title {
  margin-top: 2rem;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  text-align: center;
  color: var(--neutral-grayDark);
}

atmos-icon-link{
  width:1.25rem;
}

.wrapper {
  position: relative;
  overflow: hidden;
  margin: auto;
  margin-bottom: 4rem;
  max-width:1600px;
}

.card-wrapper{
  margin:26px auto 54px;
  height:calc(100% - 80px);
  max-width:295px;
}

@media only screen and (min-width: 640px){
  .card-wrapper-mobile{
    max-width:295px;
    margin:auto;
  }
}

@media only screen and (min-width: 768px){
  .inner{
    max-width:690px;
  }

  .card-wrapper{
    max-width:305px;
  }

  .wrapper {
    margin-top: 4rem;
  }
}

@media only screen and (min-width: 1440px){
  .inner{
    max-width:1172px;
  }

  .wrapper {
    margin-top: 6rem;
  }

  .card-wrapper{
    max-width:350px;
  }
}
`;let Vr=class extends tr{constructor(){super(...arguments),this.mobileController=new l(this),this._swiperInstance=null}initCarousel(){const t=this._slides.length,e=this._swiperBtnPrev,i=this._swiperBtnNext;let r,n;switch(t){case 1:r=1,n=1;break;case 2:r=2,n=2;break;default:r=2,n=3}this._swiperInstance=new Swiper(this._swiper,{slidesPerView:1,navigation:{nextEl:i,prevEl:e},a11y:{itemRoleDescriptionMessage:"slide of carousel of navigable informational slides pertaining"},breakpoints:{640:{slidesPerView:r},1440:{slidesPerView:n}}}),this._swiperInstance.init()}firstUpdated(){this.mobileController.isMobile||this.initCarousel()}updated(){this.mobileController.isMobile&&null!==this._swiperInstance&&!this._swiperInstance.destroyed&&void 0===this._swiperInstance.destroyed&&this._swiperInstance.destroy(),this.mobileController.isMobile||null!==this._swiperInstance&&!this._swiperInstance.destroyed||this.initCarousel()}getCarouselTitle(){return this.carouselTitle?Y` <h3 class="carousel-title">${this.carouselTitle}</h3> `:null}render(){const t=this.cards.slice(0,3);return Y`
      <div class="wrapper">
        <div class="inner">
          ${this.getCarouselTitle()}
          ${this.socialLinks?Y` <div class="social-icon-group-wrapper">
                ${this.socialLinks.map((t=>Y`
                    <div class="social-icon-wrapper mr-5 w-6">
                      <atmos-icon-link variant="dark" linkUrl="${t}">
                      </atmos-icon-link>
                    </div>
                  `))}
              </div>`:null}
          ${this.mobileController.isMobile?Y`<div class="card-wrapper-mobile">
                ${t.map((t=>Y`
                    ${t.socialPostLink?Y` <div class="card-wrapper">
                          <a
                            class="social-post-link"
                            href="${t.socialPostLink}"
                            target="_blank"
                          >
                            <atmos-info-card
                              title="${At(t.title)}"
                              text="${At(t.text)}"
                              sample-image="${At(t.sampleImage)}"
                              alt-text="${At(t.altText)}"
                              card-padding="${At(t.cardPadding)}"
                              variant="${At(t.variant)}"
                              social-icon="${At(t.socialIcon)}"
                            >
                              <img
                                slot="infoImage"
                                src="${t.sampleImage}" /></atmos-info-card
                          ></a>
                        </div>`:Y`<div class="card-wrapper">
                          <atmos-info-card
                            title="${At(t.title)}"
                            text="${At(t.text)}"
                            sample-image="${At(t.sampleImage)}"
                            alt-text="${At(t.altText)}"
                            card-padding="${At(t.cardPadding)}"
                            variant="${At(t.variant)}"
                            social-icon="${At(t.socialIcon)}"
                          >
                            <img slot="infoImage" src="${t.sampleImage}" />
                          </atmos-info-card>
                        </div>`}
                  `))}
              </div>`:Y`<div class="card-wrapper-desktop">
                <div
                  id="swiper"
                  class="swiper"
                  role="region"
                  aria-label="carousel"
                >
                  <div class="swiper-wrapper">
                    ${this.cards.map((t=>Y`
                        <div class="swiper-slide">
                          ${t.socialPostLink?Y`<a
                                class="social-post-link"
                                href="${t.socialPostLink}"
                                target="_blank"
                              >
                                <div class="card-wrapper">
                                  <atmos-info-card
                                    title="${At(t.title)}"
                                    text="${At(t.text)}"
                                    sample-image="${At(t.sampleImage)}"
                                    alt-text="${At(t.altText)}"
                                    card-padding="${At(t.cardPadding)}"
                                    variant="${At(t.variant)}"
                                    social-icon="${At(t.socialIcon)}"
                                  >
                                    <img
                                      slot="infoImage"
                                      src="${t.sampleImage}"
                                    />
                                  </atmos-info-card>
                                </div>
                              </a>`:Y`<div class="card-wrapper">
                                <atmos-info-card
                                  title="${At(t.title)}"
                                  text="${At(t.text)}"
                                  sample-image="${At(t.sampleImage)}"
                                  alt-text="${At(t.altText)}"
                                  card-padding="${At(t.cardPadding)}"
                                  variant="${At(t.variant)}"
                                  social-icon="${At(t.socialIcon)}"
                                >
                                  <img
                                    slot="infoImage"
                                    src="${t.sampleImage}"
                                  />
                                </atmos-info-card>
                              </div>`}
                        </div>
                      `))}
                  </div>
                </div>
                <button
                  type="button"
                  aria-controls="swiper"
                  class="swiper-button-prev"
                >
                  <span class="icon-container -prev">
                    <atmos-icon class="" icon="next" svg="true"></atmos-icon>
                  </span>
                </button>
                <button
                  type="button"
                  aria-controls="swiper"
                  class="swiper-button-next"
                >
                  <span class="icon-container -next">
                    <atmos-icon class="" icon="next" svg="true"></atmos-icon>
                  </span>
                </button>
              </div>`}
        </div>
      </div>
    `}};Vr.styles=[tr.styles,Er],p([ut({type:Array,attribute:"social-links"})],Vr.prototype,"socialLinks",void 0),p([ut({type:String,attribute:"carousel-title"})],Vr.prototype,"carouselTitle",void 0),Vr=p([ht("atmos-social-carousel")],Vr);var Or=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  background-color: var(--neutral-white);
  border:2px solid #c4dfff;
  box-sizing:border-box;
  border-radius:34px;
  display:flex;
  align-items:center;
  padding:20px 40px;
  max-width:1130px;
}

.wrapper.warning{
  border-color:#fee96c;
}

.wrapper.error{
  border-color:#de0000;
}

.wrapper.success{
  border-color:#19ad45;
}

.icon{
  flex-shrink:0;
  height:23.25px;
  margin-right:34.38px;
  width:23.25px;
}

.title {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight:bold;
  line-height:123%;
  margin-bottom:5px;
}

::slotted(p) {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  margin-bottom:0;
}
`;const jr={info:"statusInfo",warning:"statusWarning",error:"statusError",success:"statusOk"};let Zr=class extends $t{constructor(){super(...arguments),this.type="info"}getTitle(){return this.title?Y`<h3 class="title">${this.title}</h3>`:""}render(){return Y`
      <div class="wrapper ${this.type}">
        <div class="icon">
          <atmos-icon svg="true" icon="${jr[this.type]}" />
        </div>
        <div class="message">
          ${this.getTitle()}
          <slot></slot>
        </div>
      </div>
    `}};Zr.styles=[Or],p([ut({type:String})],Zr.prototype,"type",void 0),p([ut({type:String})],Zr.prototype,"title",void 0),Zr=p([ht("atmos-system-message")],Zr);var Rr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
textarea{
  height:100%;
  width:auto;
  background:#ffffff;
  border:1px solid #2c2c2c;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color:#2c2c2c;
  line-height:1.5;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

label {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color:#2c2c2c;
  line-height:150%;
  margin-bottom:4px;
}

sup{
  color:#ff0000;
}

textarea:focus-visible{
  border:1px solid #2175d9;
  outline:1px solid #2175d9;
}

textarea.error{
  border:2px solid #ff0000;
}

label.disabled{
  color:#a5a5a5;
}

.sr-only{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.error-container{
  color:#ff0000;
  display:flex;
  font-family:Futura Std;
  font-style:normal;
  font-weight:normal;
  font-size:14px;
  line-height:150%;
  margin-top:5px;
}

atmos-icon{
  margin-right:4px;
  margin-top:2px;
}
`;let Tr=class extends $t{constructor(){super(...arguments),this.hasError=!1,this.required=!1,this.disabled=!1,this.readonly=!1,this.errorMessage="Error Message"}firstUpdated(){this.required=this.hasAttribute("required"),this.disabled=this.hasAttribute("disabled"),this.readonly=this.hasAttribute("readonly"),this.hasError=this.hasAttribute("error")}render(){return Y`
      <label class="${this.disabled?"disabled":null}" for="${this.id}"
        >${this.label}
        ${!0===this.required?Y` <sup>*</sup><span class="sr-only">required</span>`:null}</label
      >
      <textarea
        class="${this.hasError?"error":null}"
        id="${this.id}"
        name="${this.name}"
        rows="${At(this.rows)}"
        cols="${At(this.cols)}"
        placeholder="${At(this.placeholder)}"
        wrap="${At(this.wrap)}"
        autofocus="${At(this.autofocus)}"
        minlength="${At(this.minlength)}"
        maxlength="${At(this.maxlength)}"
        form="${At(this.form)}"
        error="${At(this.errorMessage)}"
        ?disabled="${At(this.disabled)}"
        ?readonly="${At(this.readonly)}"
        ?required="${At(this.required)}"
      >
${At(this.content)}</textarea
      >
      ${this.hasError?Y`
            <div class="error-container">
              <atmos-icon
                class="mr-1"
                icon="exclamationTriangle"
                svg="true"
              ></atmos-icon
              ><span class="error-message">${this.errorMessage}</span>
            </div>
          `:""}
    `}};Tr.styles=[Rr],p([gt()],Tr.prototype,"hasError",void 0),p([gt()],Tr.prototype,"required",void 0),p([gt()],Tr.prototype,"disabled",void 0),p([gt()],Tr.prototype,"readonly",void 0),p([ut({type:String,attribute:"id"})],Tr.prototype,"id",void 0),p([ut({type:Number,attribute:"rows"})],Tr.prototype,"rows",void 0),p([ut({type:Number,attribute:"cols"})],Tr.prototype,"cols",void 0),p([ut({type:String,attribute:"name"})],Tr.prototype,"name",void 0),p([ut({type:String,attribute:"label"})],Tr.prototype,"label",void 0),p([ut({type:String,attribute:"content"})],Tr.prototype,"content",void 0),p([ut({type:String,attribute:"form"})],Tr.prototype,"form",void 0),p([ut({type:Number,attribute:"minlength"})],Tr.prototype,"minlength",void 0),p([ut({type:Number,attribute:"maxlength"})],Tr.prototype,"maxlength",void 0),p([ut({type:String,attribute:"placeholder"})],Tr.prototype,"placeholder",void 0),p([ut({type:Boolean,attribute:"autofocus"})],Tr.prototype,"autofocus",void 0),p([ut({reflect:!0,attribute:"wrap"})],Tr.prototype,"wrap",void 0),p([ut({type:String,attribute:"errormessage"})],Tr.prototype,"errorMessage",void 0),Tr=p([ht("atmos-textarea")],Tr);var Nr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.atmos-video-wrapper{
  width:100%;
  position:relative;
  overflow:hidden;
  padding-top:56.25%;
}

.atmos-video-wrapper.full-width,
.atmos-video-wrapper.full-width-reverse{
  width:100%;
  height:100%;
  position:relative;
  overflow:inherit;
  padding-top:0;
}

.atmos-video-wrapper.block{
  width:100%;
  position:relative;
}

::slotted([slot='videoThumbnail']){
  width:100%;
  object-fit:cover;
  display:block;
  position:absolute;
  top:0;
  height:100%;
}

.atmos-video-wrapper.full-width ::slotted([slot='videoThumbnail']),
.atmos-video-wrapper.full-width-reverse ::slotted([slot='videoThumbnail']){
  display:grid;
  height:100%;
  position:absolute;
}

.atmos-video-wrapper{
  position:relative;
}

.gatsby-image-wrapper{
  background-color:blue;
}

.gatsby-image-wrapper img{
  max-width:100%;
  height:100%;
  object-fit:cover;
}

.full-width img,
.full-width-reverse img{
  max-width:100%;
  height:100%;
  object-fit:cover;
}

atmos-play-button{
  border:none;
  position:absolute;
  left:100%;
  top:50%;
  transform:translate(-25px, -25px);
}

atmos-play-button.full-width{
  border:none;
  position:absolute;
  left:100%;
  top:50%;
  transform:translate(-25px, -25px);
}

atmos-play-button.full-width-reverse{
  border:none;
  position:absolute;
  left:0;
  top:50%;
  transform:translate(-25px, -25px);
}

atmos-play-button{
  left:50%;
  z-index:2;
}

@media only screen and (min-width: 639px){
  atmos-play-button.full-width{
    transform:translate(-39px, -39px);
  }
  atmos-play-button.full-width-reverse{
    transform:translate(-39px, -39px);
  }
}

.iframe-wrapper{
  aspect-ratio:16 / 9;
}

.iframe-wrapper iframe{
  height:100%;
  width:100%;
}
`;let Pr=class extends $t{constructor(){super(),this.remote=null,this.open="false"}connectedCallback(){super.connectedCallback()}_handleOpenClick(t){this.open="true",this.remote||this.videoModal.play();const e=new CustomEvent("modal-click-level-1",{detail:{state:this.open}});this.dispatchEvent(e),t.preventDefault()}_handleUpdate(t){this.remote||(this.videoModal.pause(),this.videoModal.currentTime=0);const{detail:{state:e}}=t;this.open=e;const i=new CustomEvent("modal-click-level-1",{detail:{state:e}});this.dispatchEvent(i)}renderVideo(){return this.remote?Y`<slot name="videoEmbed"></slot>`:Y`
        <video controls class="video" id="video" style="width: 100%">
          <source src="${this.url}" type="video/mp4">
          </object>
        </video>
      `}render(){return Y`
      <atmos-modal-dialog
        open=${this.open}
        @modal-click="${t=>{this._handleUpdate(t)}}"
      >
        <div slot="content">${this.renderVideo()}</div>
      </atmos-modal-dialog>
      <div class="atmos-video-wrapper ${this.layout}">
        <atmos-play-button
          @click="${t=>this._handleOpenClick(t)}"
          class="${this.layout}"
        ></atmos-play-button>
        <div class="atmos-video-image">
          <slot name="videoThumbnail"></slot>
        </div>
      </div>
    `}};Pr.styles=[Nr],p([mt("#video")],Pr.prototype,"videoModal",void 0),p([ut({type:String})],Pr.prototype,"url",void 0),p([ut({type:String})],Pr.prototype,"layout",void 0),p([ut({type:String})],Pr.prototype,"open",void 0),p([ut({type:String})],Pr.prototype,"remote",void 0),Pr=p([ht("atmos-video")],Pr);var Yr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.video-card-wrapper{
  overflow:hidden;
  width:100%;
}

.iframe-wrapper #remote{
  width:100%;
}

.video-card-wrapper.full-width{
  display:flex;
}

.video-card-wrapper.full-width-reverse{
  display:flex;
  flex-direction:row-reverse;
}

.video-card-wrapper atmos-feature-content{
  display:flex;
}

.video-card-wrapper.full-width atmos-video,
.video-card-wrapper.full-width atmos-feature-content,
.video-card-wrapper.full-width-reverse atmos-video,
.video-card-wrapper.full-width-reverse atmos-feature-content{
  width:50%;
  align-items:center;
  flex:1;
}

.video-card-wrapper.full-width ::slotted(img),
.video-card-wrapper.full-width-reverse ::slotted(img){
  display:absolute;
}

.gatsby-image-wrapper img{
  max-width:100%;
  height:100%;
  object-fit:cover;
}

@media only screen and (min-width: 1023px){
  .video-card-wrapper.full-width atmos-feature-content,
  .video-card-wrapper.full-width-reverse atmos-feature-content{
    padding:5% 0;
  }
}

.video-card-wrapper.blue atmos-feature-content{
  background:linear-gradient(
    28.01deg,
    rgb(0, 83, 183) 16.5%,
    rgb(0, 116, 255) 85.96%
  );
}

.video-card-wrapper.gray atmos-feature-content{
  background:linear-gradient(
    355.13deg,
    rgb(46, 46, 46) 5.24%,
    rgb(59, 69, 81) 90.93%
  );
}

.video-card-wrapper.white atmos-feature-content{
  background:none;
  display:flex;
}
`;let Ir=class extends Qi{constructor(){super(...arguments),this.mobileController=new l(this),this.remote=null}_handleUpdate(t){const{detail:{state:e}}=t,i=new CustomEvent("modal-click-level-1",{detail:{state:e}});this.dispatchEvent(i)}render(){const t=this.mobileController.isMobile?"mobile":null;return Y`
      <div
        id="video-card-wrapper"
        class="video-card-wrapper media-card-wrapper ${"mobile"===t?"block":this.layout} ${this.type}"
      >
        <atmos-video
          @modal-click-level-1="${t=>{this._handleUpdate(t)}}"
          url="${this.videoUrl}"
          layout="${"mobile"===t?"block":this.layout}"
          remote="${At(this.remote)}"
        >
          <slot slot="videoEmbed" name="videoCardEmbed"></slot>
          <slot slot="videoThumbnail" name="videoThumbnail"></slot>
        </atmos-video>
        <atmos-feature-content
          class="${"mobile"===t?"block":this.layout}"
          url="${At(this.url)}"
          type="white"
          variant="${this.variant}"
          title="${this.title}"
          text="${this.text}"
          link="${this.link}"
          target="${this.target}"
          rel="${this.rel}"
          link-title="${this.linkTitle}"
        />
      </div>
    `}};Ir.styles=[Yr],p([ut({type:String})],Ir.prototype,"controls",void 0),p([ut({attribute:"video-url"})],Ir.prototype,"videoUrl",void 0),p([ut({type:String})],Ir.prototype,"remote",void 0),Ir=p([ht("atmos-video-card")],Ir);var Ur=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  padding:20px 0;
}

.wrapper.no-padding{
  padding:0;
}

.wrapper.popup-alert {
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.wrapper.popup-alert h2 {
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  text-transform: uppercase;
}

@media (min-width: 640px) {

  .wrapper.popup-alert h2 {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl);
  }
}

@media (min-width: 1024px) {

  .wrapper.popup-alert h2 {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl);
  }
}

.wrapper.popup-alert h2 strong{
  color:var(--brand-secondary);
}

.wrapper.popup-alert p {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

@media (min-width: 640px) {

  .wrapper.popup-alert p {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
  }
}

@media (min-width: 1024px) {

  .wrapper.popup-alert p {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl);
  }
}

:host {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
}
`;let Wr=class extends $t{constructor(){super(...arguments),this.markup="",this.variant=""}render(){return Y`
      <div class="wrapper ${this.variant}">
        ${this.markup?Ot(this.markup):""}
      </div>
    `}};Wr.styles=[Ur],p([ut()],Wr.prototype,"markup",void 0),p([ut({type:String,attribute:"variant"})],Wr.prototype,"variant",void 0),Wr=p([ht("atmos-wysiwyg")],Wr);var qr=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
sup {
  color: var(--ui-formError);
}

input:focus-visible {
  border-width: 1px;
  border-color: var(--brand-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input:hover {
  cursor: pointer;
}

input.error{
  border:1px solid var(--ui-formError);
}

label.disabled {
  color: var(--ui-formDisabled);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0px;
  margin: -1px;
  overflow: hidden;
  white-space: nowrap;
  border-width: 0px;
  clip:rect(0, 0, 0, 0);
}

.error-container {
  color: var(--ui-formError);
  display: flex;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size:14px;
  line-height:150%;
  margin-top:5px;
}

atmos-icon{
  margin-right:4px;
  margin-top:2px;
}

fieldset {
  border-width: 0px;
  padding: 0px;
  margin: 0px;
}

.legend-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  align-items: center;
}

legend {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--neutral-grayDark);
  line-height:150%;
}

legend.disabled {
  color: var(--ui-formDisabled);
}

input {
  font-family: Futura Std Light, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-light);
  text-align: center;
  color: var(--neutral-grayDark);
  border-width: 1px;
  background-color: var(--neutral-grayLight);
  border-color:transparent;
  font-size:38px;
  line-height:64px;
  padding:0 5px;
  width:13%;
  caret-color:transparent;
  border-radius:9px;
}

.input-wrapper {
  display: flex;
  justify-content: space-between;
}

.clear {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--brand-primary);
}

.clear.disabled {
  color: var(--ui-formDisabled);
}

.clear:hover {
  cursor: pointer;
}
`;let Gr=class extends Bi{_handleClear(){[...this._inputs].forEach((t=>{t.value="",this.zipCode=null})),this.hasError&&(this.setAttribute("error","false"),this.hasError=!1)}_createZipCode(){let t="";[...this._inputs].forEach((e=>{t+=e.value})),5===t.length&&(this.zipCode=Number(t))}_handleSelectionPosition(t){t.composedPath()[0].selectionStart=1}_handleInput(t){this._handleSelectionPosition(t);const e=new RegExp("^[0-9]$"),i=t.composedPath()[0],r="Backspace"===t.key,n=e.test(t.key),o=i.nextElementSibling,a=i.previousElementSibling;r&&a&&"INPUT"===a.tagName?i.value||a.focus():!r&&n&&(i.value=t.key,o&&"INPUT"===o.tagName&&(o.focus(),o.value="")),this._createZipCode()}render(){return Y`
      <fieldset errormessage="${At(this.errorMessage)}">
        <div class="legend-wrapper">
          <legend
            id="legend"
            class="${this.legendClass}${this.disabled?" disabled":""}"
          >
            ${this.label}
            ${!0===this.required?Y` <sup>*</sup><span class="sr-only">required</span>`:""}
          </legend>
          <span
            class="clear${this.disabled?" disabled":""}"
            @click="${this._handleClear}"
            >clear</span
          >
        </div>
        <div class="input-wrapper">
          ${this.inputs.map(((t,e)=>Y`
              <input
                class="${this.inputClass} ${this.hasError?" error":""} ${t.name}"
                @keyup="${this._handleInput}"
                @click="${this._handleSelectionPosition}"
                aria-labelledby="legend"
                aria-description="5 digit zip code position ${e+1}"
                id="${t.name}"
                type="text"
                name="${t.name}"
                placeholder="${At(t.placeholder)}"
                maxlength="1"
                pattern="[0-9]*"
                size="${At(this.size)}"
                form="${At(this.form)}"
                inputmode="numeric"
                ?required=${At(this.required)}
                ?disabled=${At(this.disabled)}
                ?readonly=${At(this.readonly)}
              />
            `))}
        </div>
      </fieldset>
      ${this.hasError?Y`
            <div class="error-container">
              <atmos-icon
                class="mr-1"
                icon="exclamationTriangle"
                svg="true"
              ></atmos-icon
              ><span class="error-message">${this.errorMessage}</span>
            </div>
          `:""}
    `}};Gr.styles=[qr],p([gt()],Gr.prototype,"zipCode",void 0),p([ut({type:Array,attribute:"inputs"})],Gr.prototype,"inputs",void 0),p([ut({type:String,attribute:"legendClass"})],Gr.prototype,"legendClass",void 0),p([bt("input")],Gr.prototype,"_inputs",void 0),Gr=p([ht("atmos-zip-code-collection")],Gr);const Qr=Object.keys(r),Xr=["small","medium","large","none"],Kr=["top","middle","bottom"],Jr=["vertical","horizontal"],tn=["text","search","password","email","tel","number","url"];function en(t,e,i){return(t||"")+(void 0!==e?` ${e}`:"")+(void 0!==i?` ${i}`:"")}const rn={defaultSlot:{table:{category:"Slots",defaultValue:{summary:"NULL"}},name:"Default Slot",description:"Renders anything that is passed into the inner HTML of the given element."}},nn={orientation:{name:"Orientation",control:{type:"radio",options:Jr}}},on={name:"Number of Columns to Span",control:{type:"range",min:1,max:12,step:1}},an={name:"Number of Rows to Span",control:{type:"range",min:1,max:6,step:1}},sn={name:"Gap Size",control:{type:"select",options:["large","medium","small","none"]}},ln={name:"Vertical Alignment",control:{type:"select",options:Kr}},dn={name:"Horizontal Alignment",control:{type:"select",options:["left","center","right"]}},cn={name:"Size",control:{type:"select",options:Xr}},hn={name:"Color",description:"Select from a pre-defined list of colors.",control:{type:"select",options:t}},pn={name:"Spacing",control:{type:"select",options:Qr}},un={name:"Image URL",description:"The image URL to use for this demo.",control:{type:"text"}},gn={table:{disable:!0}},fn=t=>{const[e,i]=t.split("rem");return"px"===i||void 0===i?t:16*parseFloat(e)+"px"};var mn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
    grid-column:span 12 / span 12;
    display:flex;
    flex-direction:column;
}
  :host([row-span='1']) {
    grid-row:span 1 / span 1;
}
  :host([row-span='2']) {
    grid-row:span 2 / span 2;
}
  :host([row-span='3']) {
    grid-row:span 3 / span 3;
}
  :host([row-span='4']) {
    grid-row:span 4 / span 4;
}
  :host([row-span='5']) {
    grid-row:span 5 / span 5;
}
  :host([row-span='6']) {
    grid-row:span 6 / span 6;
}
  :host([col-span-default='1']) {
    grid-column:span 1 / span 1;
}
  :host([col-span-default='2']) {
    grid-column:span 2 / span 2;
}
  :host([col-span-default='3']) {
    grid-column:span 3 / span 3;
}
  :host([col-span-default='4']) {
    grid-column:span 4 / span 4;
}
  :host([col-span-default='5']) {
    grid-column:span 5 / span 5;
}
  :host([col-span-default='6']) {
    grid-column:span 6 / span 6;
}
  :host([col-span-default='7']) {
    grid-column:span 7 / span 7;
}
  :host([col-span-default='8']) {
    grid-column:span 8 / span 8;
}
  :host([col-span-default='9']) {
    grid-column:span 9 / span 9;
}
  :host([col-span-default='10']) {
    grid-column:span 10 / span 10;
}
  :host([col-span-default='11']) {
    grid-column:span 11 / span 11;
}
  :host([col-span-default='12']) {
    grid-column:span 12 / span 12;
}
  @media (min-width: 640px){
    :host([col-span-sm='1']) {
        grid-column:span 1 / span 1;
    }

    :host([col-span-sm='2']) {
        grid-column:span 2 / span 2;
    }

    :host([col-span-sm='3']) {
        grid-column:span 3 / span 3;
    }

    :host([col-span-sm='4']) {
        grid-column:span 4 / span 4;
    }

    :host([col-span-sm='5']) {
        grid-column:span 5 / span 5;
    }

    :host([col-span-sm='6']) {
        grid-column:span 6 / span 6;
    }

    :host([col-span-sm='7']) {
        grid-column:span 7 / span 7;
    }

    :host([col-span-sm='8']) {
        grid-column:span 8 / span 8;
    }

    :host([col-span-sm='9']) {
        grid-column:span 9 / span 9;
    }

    :host([col-span-sm='10']) {
        grid-column:span 10 / span 10;
    }

    :host([col-span-sm='11']) {
        grid-column:span 11 / span 11;
    }

    :host([col-span-sm='12']) {
        grid-column:span 12 / span 12;
    }
  }
  @media (min-width: 768px){
    :host([col-span-md='1']) {
        grid-column:span 1 / span 1;
    }

    :host([col-span-md='2']) {
        grid-column:span 2 / span 2;
    }

    :host([col-span-md='3']) {
        grid-column:span 3 / span 3;
    }

    :host([col-span-md='4']) {
        grid-column:span 4 / span 4;
    }

    :host([col-span-md='5']) {
        grid-column:span 5 / span 5;
    }

    :host([col-span-md='6']) {
        grid-column:span 6 / span 6;
    }

    :host([col-span-md='7']) {
        grid-column:span 7 / span 7;
    }

    :host([col-span-md='8']) {
        grid-column:span 8 / span 8;
    }

    :host([col-span-md='9']) {
        grid-column:span 9 / span 9;
    }

    :host([col-span-md='10']) {
        grid-column:span 10 / span 10;
    }

    :host([col-span-md='11']) {
        grid-column:span 11 / span 11;
    }

    :host([col-span-md='12']) {
        grid-column:span 12 / span 12;
    }
  }
  :host([border-gap-size="small"]) {
    margin-bottom:1rem;
}
  :host([border-gap-size="medium"]) {
    margin-bottom:2.5rem;
}
  :host([border-gap-size="large"]) {
    margin-bottom:4rem;
}
  @media (min-width: 1024px){
    :host([col-span-lg='1']) {
        grid-column:span 1 / span 1;
    }

    :host([col-span-lg='2']) {
        grid-column:span 2 / span 2;
    }

    :host([col-span-lg='3']) {
        grid-column:span 3 / span 3;
    }

    :host([col-span-lg='4']) {
        grid-column:span 4 / span 4;
    }

    :host([col-span-lg='5']) {
        grid-column:span 5 / span 5;
    }

    :host([col-span-lg='6']) {
        grid-column:span 6 / span 6;
    }

    :host([col-span-lg='7']) {
        grid-column:span 7 / span 7;
    }

    :host([col-span-lg='8']) {
        grid-column:span 8 / span 8;
    }

    :host([col-span-lg='9']) {
        grid-column:span 9 / span 9;
    }

    :host([col-span-lg='10']) {
        grid-column:span 10 / span 10;
    }

    :host([col-span-lg='11']) {
        grid-column:span 11 / span 11;
    }

    :host([col-span-lg='12']) {
        grid-column:span 12 / span 12;
    }
  }
  @media (min-width: 1280px){
    :host([col-span-xl='1']) {
        grid-column:span 1 / span 1;
    }

    :host([col-span-xl='2']) {
        grid-column:span 2 / span 2;
    }

    :host([col-span-xl='3']) {
        grid-column:span 3 / span 3;
    }

    :host([col-span-xl='4']) {
        grid-column:span 4 / span 4;
    }

    :host([col-span-xl='5']) {
        grid-column:span 5 / span 5;
    }

    :host([col-span-xl='6']) {
        grid-column:span 6 / span 6;
    }

    :host([col-span-xl='7']) {
        grid-column:span 7 / span 7;
    }

    :host([col-span-xl='8']) {
        grid-column:span 8 / span 8;
    }

    :host([col-span-xl='9']) {
        grid-column:span 9 / span 9;
    }

    :host([col-span-xl='10']) {
        grid-column:span 10 / span 10;
    }

    :host([col-span-xl='11']) {
        grid-column:span 11 / span 11;
    }

    :host([col-span-xl='12']) {
        grid-column:span 12 / span 12;
    }
    :host([border-gap-size="small"]), :host([border-gap-size="medium"]), :host([border-gap-size="large"]) {
        margin-bottom:0px;
    }
    :host([has-left-divider]){
      border-left:1px solid var(--neutral-grayMedium) !important;
    }

    :host([has-left-divider][border-gap-size="small"]) {
        padding-left:1rem;
    }
    :host([has-left-divider][border-gap-size="medium"]) {
        padding-left:2.5rem;
    }
    :host([has-left-divider][border-gap-size="large"]) {
        padding-left:4rem;
    }

    :host([has-right-divider][border-gap-size="small"]) {
        padding-right:1rem;
    }
    :host([has-right-divider][border-gap-size="medium"]) {
        padding-right:2.5rem;
    }
    :host([has-right-divider][border-gap-size="large"]) {
        padding-right:4rem;
    }
  }
  @media (min-width: 1440px){
    :host([col-span-xxl='1']) {
        grid-column:span 1 / span 1;
    }

    :host([col-span-xxl='2']) {
        grid-column:span 2 / span 2;
    }

    :host([col-span-xxl='3']) {
        grid-column:span 3 / span 3;
    }

    :host([col-span-xxl='4']) {
        grid-column:span 4 / span 4;
    }

    :host([col-span-xxl='5']) {
        grid-column:span 5 / span 5;
    }

    :host([col-span-xxl='6']) {
        grid-column:span 6 / span 6;
    }

    :host([col-span-xxl='7']) {
        grid-column:span 7 / span 7;
    }

    :host([col-span-xxl='8']) {
        grid-column:span 8 / span 8;
    }

    :host([col-span-xxl='9']) {
        grid-column:span 9 / span 9;
    }

    :host([col-span-xxl='10']) {
        grid-column:span 10 / span 10;
    }

    :host([col-span-xxl='11']) {
        grid-column:span 11 / span 11;
    }

    :host([col-span-xxl='12']) {
        grid-column:span 12 / span 12;
    }
  }
  :host([content-align='middle']) {
    justify-content:center;
}
  :host([content-align='bottom']) {
    justify-content:flex-end;
}
`;let bn=class extends $t{constructor(){super(...arguments),this.colSpanDefault=12,this.rowSpan=1,this.contentAlign="middle"}render(){return Y`<slot></slot>`}};bn.styles=[mn],p([ut({type:Number,reflect:!0,attribute:"col-span-default"})],bn.prototype,"colSpanDefault",void 0),p([ut({type:Number,reflect:!0,attribute:"col-span-sm"})],bn.prototype,"colSpanSm",void 0),p([ut({type:Number,reflect:!0,attribute:"col-span-md"})],bn.prototype,"colSpanMd",void 0),p([ut({type:Number,reflect:!0,attribute:"col-span-lg"})],bn.prototype,"colSpanLg",void 0),p([ut({type:Number,reflect:!0,attribute:"col-span-xl"})],bn.prototype,"colSpanXl",void 0),p([ut({type:Number,reflect:!0,attribute:"col-span-2xl"})],bn.prototype,"colSpan2xl",void 0),p([ut({type:Number,reflect:!0,attribute:"row-span"})],bn.prototype,"rowSpan",void 0),p([ut({type:String,reflect:!0,attribute:"content-align"})],bn.prototype,"contentAlign",void 0),p([ut({type:Boolean,reflect:!0,attribute:"has-left-divider"})],bn.prototype,"hasLeftDivider",void 0),p([ut({type:Boolean,reflect:!0,attribute:"has-right-divider"})],bn.prototype,"hasRightDivider",void 0),p([ut({type:String,reflect:!0,attribute:"border-gap-size"})],bn.prototype,"borderGapSize",void 0),bn=p([ht("outline-column")],bn);var vn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: inline-block;
  cursor: pointer;
}

:host([disabled]) {
  cursor: not-allowed;
}

.tab {
  pointer-events: none;
  margin-bottom: 0.125rem;
  display: block;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  white-space: nowrap;
  border-radius: 0.25rem;
  border-bottom-width: 2px;
  border-color: var(--outline-dark-gray);
  background-repeat: no-repeat;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 1.5rem;
  padding-right: 9rem;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-medium);
  color: var(--outline-dark-gray);
}

@media (min-width: 1024px) {

  .tab {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl);
  }
}

.tab{
  background-image:url("data:image/svg+xml,%3Csvg width='12' height='22' viewBox='0 0 12 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.6036 10.3964L1.4449 0.237629C1.10859 -0.0871735 0.572681 -0.0778466 0.247879 0.258463C-0.0689857 0.586538 -0.0689856 1.10663 0.247879 1.43465L9.8081 10.9949L0.247879 20.5551C-0.0826265 20.8857 -0.0826265 21.4216 0.247879 21.7521C0.578485 22.0826 1.11435 22.0826 1.4449 21.7521L11.6036 11.5934C11.9341 11.2628 11.9341 10.7269 11.6036 10.3964Z' fill='%23363739'/%3E%3C/svg%3E%0A");
  background-position:calc(100% - 24px) 50%;
}

.tab:hover:not(.tab--disabled) {
  color: var(--outline-light-gray);
}

.tab:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tab:focus:not(.tab--disabled), .tab:focus-visible:not(.tab--disabled) {
  background-color: var(--outline-light-blue);
  color: var(--outline-dark-blue);
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tab.tab--active:not(.tab--disabled) {
  background-color: var(--outline-light-gray);
  color: var(--outline-dark-blue);
  background-image:url("data:image/svg+xml,%3Csvg width='12' height='22' viewBox='0 0 12 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.6036 10.3964L1.4449 0.237629C1.10859 -0.0871735 0.572681 -0.0778466 0.247879 0.258463C-0.0689857 0.586538 -0.0689856 1.10663 0.247879 1.43465L9.8081 10.9949L0.247879 20.5551C-0.0826265 20.8857 -0.0826265 21.4216 0.247879 21.7521C0.578485 22.0826 1.11435 22.0826 1.4449 21.7521L11.6036 11.5934C11.9341 11.2628 11.9341 10.7269 11.6036 10.3964Z' fill='%23056CB6'/%3E%3C/svg%3E%0A");
}

.tab.tab--disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
`;let wn=0,xn=class extends $t{constructor(){super(...arguments),this.componentId="tab-"+ ++wn,this.panel="",this.active=!1,this.disabled=!1}focus(t){this.tab.focus(t)}blur(){this.tab.blur()}render(){return this.id=this.id||this.componentId,Y`
      <div
        part="base"
        class=${Dt({tab:!0,"tab--active":this.active,"tab--disabled":this.disabled})}
        role="tab"
        aria-disabled=${this.disabled?"true":"false"}
        aria-selected=${this.active?"true":"false"}
        tabindex=${this.disabled||!this.active?"-1":"0"}
      >
        <slot> </slot>
      </div>
    `}};function yn(t,e){return{top:Math.round(t.getBoundingClientRect().top-e.getBoundingClientRect().top),left:Math.round(t.getBoundingClientRect().left-e.getBoundingClientRect().left)}}function Cn(t,e,i="vertical",r="smooth"){const n=yn(t,e),o=n.top+e.scrollTop,a=n.left+e.scrollLeft,s=e.scrollLeft,l=e.scrollLeft+e.offsetWidth,d=e.scrollTop,c=e.scrollTop+e.offsetHeight;"horizontal"!==i&&"both"!==i||(a<s?e.scrollTo({left:a,behavior:r}):a+t.clientWidth>l&&e.scrollTo({left:a-e.offsetWidth+t.clientWidth,behavior:r})),"vertical"!==i&&"both"!==i||(o<d?e.scrollTo({top:o,behavior:r}):o+t.clientHeight>c&&e.scrollTo({top:o-e.offsetHeight+t.clientHeight,behavior:r}))}xn.styles=[vn],p([mt(".tab")],xn.prototype,"tab",void 0),p([ut()],xn.prototype,"panel",void 0),p([ut({type:Boolean,reflect:!0})],xn.prototype,"active",void 0),p([ut({type:Boolean,reflect:!0})],xn.prototype,"disabled",void 0),xn=p([ht("outline-tab")],xn);var kn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.tab-group {
  display: flex;
  border-width: 1px;
  border-color: var(--neutral-transparent);
}

.tab-group .tab-group__tabs {
  position: relative;
  display: flex;
}

.tab-group .tab-group__indicator {
  position: absolute;
  left: 0px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tab-group--start {
  flex-direction: row;
}

.tab-group--start .tab-group__nav-container {
  order: 1;
  border-width: 1px;
  border-bottom-color: var(--outline-light-gray);
}

.tab-group--start .tab-group__tabs{
  flex:0 0 auto;
  flex-direction:column;
}

.tab-group--start .tab-group__indicator{
  right:calc(-1 * 2px);
  border-bottom:0;
}

.tab-group--start .tab-group__body {
  order: 2;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  flex:1 1 auto;
}

.tab-group--top {
  flex-direction: column;
}

.tab-group--top .tab-group__nav-container {
  order: 1;
}

.tab-group--top .tab-group__nav {
  display: flex;
  overflow-x: auto;
  scrollbar-width:none;
}

.tab-group--top .tab-group__nav::-webkit-scrollbar {
  height: 0px;
  width: 0px;
}

.tab-group--top .tab-group__tabs {
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
  border-width: 1px;
  border-bottom-color: var(--outline-dark-gray);
}

.tab-group--top .tab-group__tabs .tab {
  padding-right: 1.5rem;
  background-image:none;
}

.tab-group--top .tab-group__indicator{
  bottom:-2px;
}

.tab-group--top .tab-group__body {
  order: 2;
}
`;let An=class extends $t{constructor(){super(...arguments),this.mobileController=new l(this),this.tabs=[],this.panels=[],this.placement="start",this.activation="auto",this._handleResize=()=>{this.mobileController.isMobile||this.intersectionObserver()}}connectedCallback(){super.connectedCallback(),window.addEventListener("resize",this._handleResize),this.resizeObserver=new ResizeObserver((()=>{this.mobileController.isMobile||(this.preventIndicatorTransition(),this.repositionIndicator())})),this.mutationObserver=new MutationObserver((t=>{t.some((t=>!["aria-labelledby","aria-controls"].includes(t.attributeName)))&&setTimeout((()=>this.setAriaLabels())),t.some((t=>"disabled"===t.attributeName))&&this.syncTabsAndPanels()})),this.mobileController.isMobile||this.updateComplete.then((()=>{this.syncTabsAndPanels(),this.mutationObserver.observe(this,{attributes:!0,childList:!0,subtree:!0}),this.resizeObserver.observe(this.nav),this.intersectionObserver()}))}disconnectedCallback(){this.mutationObserver.disconnect(),this.resizeObserver.unobserve(this.nav),window.removeEventListener("resize",this._handleResize)}intersectionObserver(){new IntersectionObserver(((t,e)=>{t[0].intersectionRatio>0&&(this.setAriaLabels(),this.setActiveTab(this.getActiveTab()||this.tabs[0],{emitEvents:!1}),e.unobserve(t[0].target))})).observe(this.tabGroup)}show(t){const e=this.tabs.find((e=>e.panel===t));e&&this.setActiveTab(e,{scrollBehavior:"smooth"})}getAllTabs(t=!1){return[...this.shadowRoot.querySelector('slot[name="nav"]').assignedElements()].filter((e=>t?"outline-tab"===e.tagName.toLowerCase():"outline-tab"===e.tagName.toLowerCase()&&!e.disabled))}getAllPanels(){return[...this.body.querySelector("slot").assignedElements()].filter((t=>"outline-tab-panel"===t.tagName.toLowerCase()))}getActiveTab(){return this.tabs.find((t=>t.active))}handleClick(t){const e=t.target.closest("outline-tab");(null==e?void 0:e.closest("outline-tab-group"))===this&&e&&this.setActiveTab(e,{scrollBehavior:"smooth"})}handleKeyDown(t){const e=t.target.closest("outline-tab");if((null==e?void 0:e.closest("outline-tab-group"))===this&&(["Enter"," "].includes(t.key)&&e&&(this.setActiveTab(e,{scrollBehavior:"smooth"}),t.preventDefault()),["ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Home","End"].includes(t.key))){const e=document.activeElement;if(e&&"outline-tab"===e.tagName.toLowerCase()){let i=this.tabs.indexOf(e);"Home"===t.key?i=0:"End"===t.key?i=this.tabs.length-1:["top","bottom"].includes(this.placement)&&"ArrowLeft"===t.key||["start","end"].includes(this.placement)&&"ArrowUp"===t.key?i=Math.max(0,i-1):(["top","bottom"].includes(this.placement)&&"ArrowRight"===t.key||["start","end"].includes(this.placement)&&"ArrowDown"===t.key)&&(i=Math.min(this.tabs.length-1,i+1)),this.tabs[i].focus({preventScroll:!0}),"auto"===this.activation&&this.setActiveTab(this.tabs[i],{scrollBehavior:"smooth"}),["top","bottom"].includes(this.placement)&&Cn(this.tabs[i],this.nav,"horizontal"),t.preventDefault()}}}handleScrollToStart(){this.nav.scroll({left:this.nav.scrollLeft-this.nav.clientWidth,behavior:"smooth"})}handleScrollToEnd(){this.nav.scroll({left:this.nav.scrollLeft+this.nav.clientWidth,behavior:"smooth"})}setActiveTab(t,e){if(e=Object.assign({emitEvents:!0,scrollBehavior:"auto"},e),t&&t!==this.activeTab&&!t.disabled){const i=this.activeTab;this.activeTab=t,this.tabs.map((t=>t.active=t===this.activeTab)),this.panels.map((t=>t.active=t.name===this.activeTab.panel)),this.syncIndicator(),["top","bottom"].includes(this.placement)&&Cn(this.activeTab,this.nav,"horizontal",e.scrollBehavior),e.emitEvents&&(i&&Rt(this,"outline-tab-hide",{detail:{name:i.panel}}),Rt(this,"outline-tab-show",{detail:{name:this.activeTab.panel}}))}}setAriaLabels(){this.tabs.map((t=>{const e=this.panels.find((e=>e.name===t.panel));e&&(t.setAttribute("aria-controls",e.getAttribute("id")),e.setAttribute("aria-labelledby",t.getAttribute("id")))}))}syncIndicator(){if(this.indicator){if(!this.getActiveTab())return void(this.indicator.style.display="none");this.indicator.style.display="block",this.repositionIndicator()}}repositionIndicator(){const t=this.getActiveTab();if(!t)return;const e=t.clientWidth,i=t.clientHeight,r=yn(t,this.nav),n=r.top+this.nav.scrollTop,o=r.left+this.nav.scrollLeft;switch(this.placement){case"top":case"bottom":this.indicator.style.width=`${e}px`,this.indicator.style.height="auto",this.indicator.style.transform=`translateX(${o}px)`;break;case"start":case"end":this.indicator.style.width="auto",this.indicator.style.height=`${i}px`,this.indicator.style.transform=`translateY(${n}px)`}}preventIndicatorTransition(){if(!this.mobileController.isMobile){const t=this.indicator.style.transition;this.indicator.style.transition="none",requestAnimationFrame((()=>{this.indicator.style.transition=t}))}}syncTabsAndPanels(){this.mobileController.isMobile||(this.tabs=this.getAllTabs(),this.panels=this.getAllPanels()),this.syncIndicator()}render(){return Y`${this.mobileController.isMobile?Y`<slot name="accordion-wrapper"></slot> `:Y`<outline-container
            ><div
              part="base"
              class=${Dt({"tab-group":!0,"tab-group--top":"top"===this.placement,"tab-group--bottom":"bottom"===this.placement,"tab-group--start":"start"===this.placement,"tab-group--end":"end"===this.placement})}
              @click=${this.handleClick}
              @keydown=${this.handleKeyDown}
            >
              <div class="tab-group__nav-container">
                <div part="nav" class="tab-group__nav">
                  <div part="tabs" class="tab-group__tabs" role="tablist">
                    <div
                      part="active-tab-indicator"
                      class="tab-group__indicator"
                    ></div>
                    <slot
                      name="nav"
                      @slotchange=${this.syncTabsAndPanels}
                    ></slot>
                  </div>
                </div>
              </div>
              <div part="body" class="tab-group__body">
                <slot @slotchange=${this.syncTabsAndPanels}></slot>
              </div></div
          ></outline-container>`}
    </outline-container>`}};An.styles=[kn],p([mt(".tab-group")],An.prototype,"tabGroup",void 0),p([mt(".tab-group__body")],An.prototype,"body",void 0),p([mt(".tab-group__nav")],An.prototype,"nav",void 0),p([mt(".tab-group__indicator")],An.prototype,"indicator",void 0),p([ut({type:String,reflect:!0,attribute:"placement"})],An.prototype,"placement",void 0),p([ut()],An.prototype,"activation",void 0),p([Tt("placement")],An.prototype,"syncIndicator",null),An=p([ht("outline-tab-group")],An);let zn=0,$n=class extends $t{constructor(){super(...arguments),this.componentId="tab-panel-"+ ++zn,this.name="",this.active=!1}connectedCallback(){super.connectedCallback(),this.id=this.id||this.componentId}render(){return this.style.display=this.active?"block":"none",Y`
      <div
        part="base"
        class="tab-panel"
        role="tabpanel"
        aria-selected=${this.active?"true":"false"}
        aria-hidden=${this.active?"false":"true"}
      >
        <slot></slot>
      </div>
    `}};p([ut()],$n.prototype,"name",void 0),p([ut({type:Boolean,reflect:!0})],$n.prototype,"active",void 0),$n=p([ht("outline-tab-panel")],$n);var Mn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
  padding-bottom:50px;
}

::slotted([slot='alertHeader']) {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: var(--neutral-white);
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
}

::slotted([slot='alertPopUp']){
  z-index:6000;
}

@media only screen and (min-width: 1024px){
  :host{
    display:block;
    padding-bottom:90px;
  }
}

.menu-wrapper {
  position: relative;
  background:linear-gradient(89.89deg, #373737 0%, #3b4551 100%);
}

.primary-menu {
  position: relative;
  display: flex;
  align-items:center;
  height:50px;
  justify-content:space-between;
  max-width:700px;
  padding-left:230px;
  padding-right:120px;
}

@media only screen and (min-width: 1280px){
  .primary-menu {
    margin: auto;
  }
  .primary-menu {
    max-width: 1136px;
  }
  .primary-menu{
    padding-left:0;
  }
}

@media only screen and (min-width: 1400px){
  .primary-menu{
    padding-right:0;
  }
}

.menu {
  display: flex;
  padding: 0px;
  margin: 0px;
  list-style-type:none;
}

.menu a {
  display: block;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  border-bottom:solid 2px transparent;
  box-sizing:border-box;
  height:50px;
  line-height:50px;
  text-decoration:none;
  transition:border-bottom-color 0.5s, color 0.5s;
}

.menu li{
  margin-right:27px;
}

.menu li:last-child{
  margin-right:0;
}

.menu a:hover, .menu a:focus {
  color: var(--brand-secondary);
  border-bottom-color:var(--brand-secondary);
  outline:none;
}

.link-wrapper{
  width:140px;
}

@media only screen and (min-width: 1280px){
  .link-wrapper{
    padding-left:230px;
    width:auto;
  }
}

@media only screen and (min-width: 1400px){
  .link-wrapper{
    padding-left:0;
  }
}

.location {
  background-color: var(--brand-primary);
  position: absolute;
  height:50px;
  left:0;
  z-index:3000;
  min-width:230px;
  top:0;
}

@media only screen and (min-width: 1400px){
  .location{
    min-width:auto;
    width:calc((100% - 1136px) / 2);
  }
}

.search {
  position: absolute;
  height:50px;
  right:0;
  top:0;
  z-index:3000;
}

.search atmos-search-desktop {
  position: absolute;
  right:0;
}

@media only screen and (min-width: 1280px){
  .search{
    min-width:auto;
    width:calc((100% - 1136px) / 2);
  }
}

.menu-bottom {
  position: relative;
  padding-right:20px;
  padding-top:18px;
}

@media only screen and (min-width: 1280px){
  .menu-bottom{
    padding-right:0;
  }
}

.logo {
  position: absolute;
  display: block;
  color: var(--brand-primary);
  left:15px;
  top:9px;
  width:105px;
  z-index:1000;
}

@media only screen and (min-width: 1024px){
  .logo{
    left:20px;
    width:127px;
  }
}

@media only screen and (min-width: 1280px){
  .logo{
    left:calc(230px - 197px);
    width:197px;
  }

  .internal .logo{
    left:calc(230px - 123px);
    width:123px;
  }
}

@media only screen and (min-width: 1400px){
  .internal .logo{
    left:calc(((100% - 1136px) / 2) - 123px);
  }
}

@media only screen and (min-width: 1540px){
  .logo{
    left:calc(((100% - 1136px) / 2) - 197px);
  }

  .internal .logo{
    left:calc(((100% - 1136px) / 2) - 123px);
  }
}

.logo svg path:first-child{
  fill:var(--neutral-grayDark);
}

.mobile-wrapper .link-wrapper {
  background-color: var(--neutral-grayDark);
  display: flex;
  align-items:center;
  height:44px;
  padding-left:5px;
  width:auto;
}

.action-bar-wrapper {
  background-color: var(--brand-primary);
  display: flex;
  align-items:center;
  height:50px;
  justify-content:space-between;
}

.action-bar {
  display: flex;
  height:50px;
}

.action-bar atmos-header-menu-button{
  border-left:1px solid #7aa7dc;
}

.mobile-overlay {
  position: absolute;
  background-color: var(--neutral-white);
  height:100vh;
  top:0;
  left:0;
  width:100%;
  z-index:4000;
}

.overlay-close {
  position: absolute;
  border:1px solid var(--neutral-grayMedium);
  top:0;
  right:0;
  z-index:3000;
}

.menu-mobile-wrapper {
  display: flex;
  align-items:center;
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  bottom:0;
  padding:0 48px;
  position:fixed;
  height:194px;
  width:100%;
}

.menu-mobile {
  margin: 0px;
  padding: 0px;
  list-style-type:none;
}

.menu-mobile li a {
  display: block;
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  color: var(--neutral-white);
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  padding-bottom:11px;
  text-decoration:none;
}

.scrollable {
  position: absolute;
  width: 100%;
  height:calc(100vh - 194px);
  left:0;
  overflow-y:auto;
  top:0;
}

.search .menu-mobile-wrapper{
  display:none;
}

.search .scrollable{
  height:100vh;
}

.mobile-submenu-wrapper{
  margin-top:120px;
}

.mobile-search-wrapper{
  padding:90px 16px 20px;
}
`;const Sn=window.matchMedia("(min-width: 1024px)");let Ln=class extends $t{constructor(){super(...arguments),this.preventFocusEvent=!1,this.isDesktop=!1,this.menuOpen=!1,this.searchOpen=!1,this.links=[],this.link=null,this.subMenu=[],this.type="homepage",this.searchData={quickLinks:[],recentSearches:[],suggestedPages:[]},this._handleMediaQuery=t=>{const{matches:e}=t;this.isDesktop=e,e&&(this.searchOpen=!1,this.menuOpen=!1)}}firstUpdated(){this.isDesktop=Sn.matches}connectedCallback(){super.connectedCallback(),Sn.addListener(this._handleMediaQuery)}disconnectedCallback(){Sn.removeListener(this._handleMediaQuery),super.disconnectedCallback()}_handlePreventFocus(){this.preventFocusEvent=!0}_handleClick(t,e,i,r=null){t.preventDefault(),t.stopPropagation();const n=new CustomEvent("menu-click",{detail:{key:e,item:i,parent:r}});this.dispatchEvent(n)}_handleLogoClick(t){t.preventDefault(),t.stopPropagation();const e=new CustomEvent("logo-click",{detail:{}});this.dispatchEvent(e)}_handleSearch(t){const{detail:e}=t,i=new CustomEvent("search",{detail:e});this.dispatchEvent(i)}_handleSearchSuggested(t){const{detail:{item:e}}=t;this._handleClick(t,0,e)}_handleSubmenuClick(t){const{detail:e}=t,i=Object.assign(Object.assign({},e),{from:"submenu"}),r=new CustomEvent("menu-click",{detail:i});this.dispatchEvent(r)}_focusElement(t){setTimeout((()=>{var e;const i=null===(e=this.shadowRoot)||void 0===e?void 0:e.querySelector(t);i&&i.focus()}),50)}_mobileMenuHandler(t){t.preventDefault(),t.stopPropagation(),this.menuOpen=!0,this.searchOpen=!1,this._focusElement(".mobile-overlay")}_searchMenuHandler(t){t.preventDefault(),t.stopPropagation(),this.menuOpen=!1,this.searchOpen=!0,this._focusElement(".mobile-overlay")}_closeMenuHandler(t){t.preventDefault(),t.stopPropagation(),this.menuOpen=!1,this.searchOpen=!1,this._focusElement(".logo")}renderLogo(){return Y`
      <a href="#" class="logo" @click="${this._handleLogoClick}">
        <svg
          data-name="Header Logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 501 235"
        >
          <path
            fill="#231f20"
            d="M179.27 165.28c0-7.21-4.58-12-11.2-12-6.92 0-11.5 5.75-12.18 12Zm-23.58 4-.19 5a26 26 0 0 0 4.19 13.54c2.73 4 7.6 6.05 12.37 6.05 6.63 0 11.21-3.22 14.33-9l3.21 1.66c-3.51 7.69-11.59 11.69-19.88 11.69-6.53 0-12.28-1.76-17.05-6.33a26.05 26.05 0 0 1-7.31-18.23c0-14.13 8.87-24.26 23.29-24.36 11.7-.1 21.15 7.8 20.95 20h-33.91m97.9 15.86c0 5.26.87 9 6.91 9.36h1.27v2.92h-25.92v-2.92h1.36c6.14-.39 7-4 7-9.46V165a13.64 13.64 0 0 0-1.56-7.12 8 8 0 0 0-6.82-3.5c-6.43 0-12.67 3.7-17.35 7.79v22.9c0 5.46.88 9.07 7 9.46h1.36v2.92h-26.37v-2.92h1.08c6.43-.3 7.6-3.32 7.6-9.46V164.8c0-5.46-1-9.07-7.12-9.46h-1.56v-2.92l14.92-2.15h3.11V158c5.85-5.46 12.67-8.67 20.76-8.67a16 16 0 0 1 10.53 3.9c3.31 2.82 3.8 6 3.8 10.13v21.83Zm50.87-19.88c0-7.21-4.59-12-11.21-12-6.92 0-11.5 5.75-12.18 12Zm-23.59 4-.19 5a26 26 0 0 0 4.19 13.54c2.73 4 7.6 6.05 12.37 6.05 6.63 0 11.21-3.22 14.33-9l3.22 1.66c-3.51 7.69-11.6 11.69-19.88 11.69-6.53 0-12.28-1.76-17.06-6.33a26.09 26.09 0 0 1-7.31-18.23c0-14.13 8.87-24.26 23.29-24.36 11.7-.1 21.15 7.8 21 20h-33.96m66.01 15.76c.2 5.56 1 9.07 7.22 9.36l1.65.1v2.92H329v-2.92h1c6.44-.39 7.51-3.41 7.51-9.46V164.8c0-5.46-1-9.07-7.12-9.46h-1.55v-2.92l14.91-2.15h3.11v7.31c4.29-4.38 9.85-8.28 16.38-8.28 3.21 0 7.21 1.27 7.21 5.16a5.15 5.15 0 0 1-5.36 5.27c-4.58 0-5.66-3.22-8.67-3.22-3.32 0-7.41 3-9.56 5.36v23.19Zm43.52-18.71c0 7.31 2 13.45 10.52 13.45 3.32 0 6.92-1.56 8.48-4.58 1.27-2.43 1.56-6.43 1.56-9.16 0-7.11-1.75-13.25-10-13.25-8.09 0-10.52 6.72-10.52 13.54Zm-.59 32.94c-3.7 1.17-7 2.73-7 6.92 0 8.58 12.18 9.16 18.42 9.16s18.8-.49 18.8-9c0-5.45-7-5.16-11-5.65l-19.2-1.46Zm21.35-7.21c7.4 1 15.69 1.94 15.69 11 0 13.35-15.79 15.4-26.22 15.4-7.89 0-23.68-1.08-23.68-11.6 0-5.55 4.68-7 9.26-8.48v-.19c-3.8-1-7.12-3.61-7.12-7.89 0-5.36 4.68-9.07 9.56-9.94a15.35 15.35 0 0 1-7.7-13.94c.39-10.82 9.55-17.15 19.58-17.15a27.28 27.28 0 0 1 8.87 1.56c2.34-4.48 6-7.8 11.21-7.8 2.63 0 5.75 1.07 5.75 4.19a3.61 3.61 0 0 1-3.61 3.7c-2.24 0-4.09-1.75-6.14-1.75s-3 1.37-4.28 2.83c5 3.6 8.08 8.28 8.08 14.61a16.2 16.2 0 0 1-5.94 12.28c-3.9 3.22-9.26 4.1-14.23 4.1a24.5 24.5 0 0 1-8.77-1.56c-2 .78-4.68 2.92-4.68 5.16 0 3.41 5.36 3.8 7.7 4.1l16.67 1.36m62.37-25.62c.88-2.44 2.24-6 2.24-8.58 0-3.7-3.8-4.28-6.63-4.67v-2.93h21.64v2.93c-6.53 1.07-8.38 4.28-10.72 9.94l-15.59 37.51c-1.76 4.2-3.41 8.19-6.34 11.6a18.16 18.16 0 0 1-13 6.14c-3.61 0-8.77-1.75-8.77-6a4.93 4.93 0 0 1 5.07-4.87c4.48 0 4.48 5.07 9 5.07 4.88 0 8.09-8.09 9.55-11.7l.39-.78-16.56-39.66c-2.25-5.17-2.63-6.63-8.77-7.21v-2.93h23.19v2.93c-2.14.09-5.36.68-5.36 3.4a7.16 7.16 0 0 0 .88 3.13l11.4 28.55 8.38-21.83Z"
          />
          <path
            fill="#007cc3"
            d="M125.35 28.3H205v31.77l-20.82.03v72.79h-38.01V60.1l-20.82-.03V28.3zm118.32 66.58-5.33 37.94h-37.9l14.67-104.43h32.74l15.68 34.26 15.68-34.26h32.74l14.66 104.43h-37.89l-5.33-37.93-19.86 39.44-19.86-39.45zm134.25 3.92a18 18 0 1 1 18.05-18 18 18 0 0 1-18.05 18Zm0-71.94a53.89 53.89 0 1 0 53.89 53.89 53.89 53.89 0 0 0-53.89-53.89M26.72 66.31l91.9 4.25-3.14-8.68-88.76 4.28v.15zm-3.68 10.42 99.35 4.25-3.14-8.68-96.21 4.28v.15zm-3.62 10.44 106.74 4.25-3.14-8.69-103.6 4.29v.15zM32.84 58.4 50.72 9h45.64l18.53 51.16-82.05-1.76M19.63 94.65l-13.8 38.23h53.56l13.1-38.98-52.86.75zm107.02-1.53L141 132.88H87.43l-13.14-39 52.36-.76zm321.6 13.53c-8.62 0-16.35-5.87-16.35-5.87v30.1s9.33 5.43 25.61 5.43c19 0 34.81-15.45 34.81-34.43a34.08 34.08 0 0 0-6.54-20.11 50.4 50.4 0 0 0-11.55-11.13c-2.53-1.88-8-5.22-8-8.32 0-4.66 3.63-7.36 9.15-7.36a23.64 23.64 0 0 1 14.53 4.85L488.76 30s-4.51-3.3-20.76-3.3c-19 0-36.1 14.1-36.1 33.08 0 10.43 5.27 21.59 17.2 29.92 0 0 5.64 4.18 7.53 8.44a5.43 5.43 0 0 1 .44 3.39c-.87 4.23-4 5.36-8.78 5.09"
          />
          <path
            fill="#231f20"
            d="M487.74 191.78c.78 0 2.14.14 2.14-.85 0-.65-.85-.76-1.52-.76h-1.67v1.61Zm2.93 3.76h-1.05l-1.88-2.88h-1.05v2.88h-.88v-6.25h2.72c1.13 0 2.23.31 2.23 1.65s-.86 1.69-2 1.72l1.89 2.88Zm2.14-3.09a4.86 4.86 0 1 0-4.86 4.83 4.87 4.87 0 0 0 4.86-4.83Zm-10.6 0a5.74 5.74 0 1 1 5.74 5.71 5.68 5.68 0 0 1-5.74-5.71Z"
          />
        </svg>
      </a>
    `}renderMenuDesktop(){return Y`
      <slot name="alertHeader"></slot>
      <slot name="alertPopUp"></slot>
      <div class="menu-wrapper">
        <div class="location"><slot name="location"></slot></div>
        <div class="primary-menu">
          <div class="link-wrapper">
            ${this.link?Y`
                  <atmos-button
                    url="${this.link.path}"
                    variant="reverse"
                    size="thin"
                  >
                    ${this.link.label?Ot(this.link.label):""}
                  </atmos-button>
                `:""}
          </div>
          <ul class="menu">
            ${this.links.map(((t,e)=>Y`
                  <li>
                    <a
                      data-menu-label="${t.label}"
                      @click="${i=>this._handleClick(i,e,t)}"
                      @mousedown="${this._handlePreventFocus}"
                      href="${t.path}"
                    >
                      ${t.label}
                    </a>
                  </li>
                `))}
          </ul>
        </div>
        <div class="search">
          <atmos-search-desktop
            links=${JSON.stringify(this.searchData.quickLinks)}
            recent="${JSON.stringify(this.searchData.recentSearches)}"
            suggested="${JSON.stringify(this.searchData.suggestedPages)}"
            @search="${this._handleSearch}"
            @search-suggested="${this._handleSearchSuggested}"
          >
            <slot slot="search-field" name="search-field"></slot>
          </atmos-search-desktop>
        </div>
      </div>
      <div class="menu-bottom ${this.type}">
        ${this.renderLogo()}
        <atmos-header-submenu
          items="${JSON.stringify(this.subMenu)}"
          @menu-click="${t=>{this._handleSubmenuClick(t)}}"
        />
      </div>
    `}renderMobileOverlay(){return this.menuOpen||this.searchOpen?Y`
          <div
            class="mobile-overlay ${this.searchOpen?"search":""}"
            tabindex="0"
          >
            <atmos-header-menu-button
              class="overlay-close"
              icon="close"
              label="close"
              @click="${this._closeMenuHandler}"
            >
            </atmos-header-menu-button>
            <div class="scrollable">
              ${this.searchOpen?Y`
                    <div class="mobile-search-wrapper">
                      <atmos-search
                        links=${JSON.stringify(this.searchData.quickLinks)}
                        recent="${JSON.stringify(this.searchData.recentSearches)}"
                        suggested="${JSON.stringify(this.searchData.suggestedPages)}"
                        @search="${this._handleSearch}"
                        @search-suggested="${this._handleSearchSuggested}"
                      />
                        <slot slot="search-field" name="search-field"></slot>
                      </atmos-search>
                    </div>
                  `:null}
              ${this.menuOpen?Y`
                    <div class="mobile-submenu-wrapper">
                      <atmos-header-mobile-submenu
                        items="${JSON.stringify(this.subMenu)}"
                        @menu-click="${t=>{this._handleSubmenuClick(t)}}"
                      ></atmos-header-mobile-submenu>
                    </div>
                  `:null}
            </div>
            ${this.links?Y`<div class="menu-mobile-wrapper">
                  <ul class="menu-mobile">
                    ${this.links.map(((t,e)=>Y`
                          <li>
                            <a
                              @click="${i=>this._handleClick(i,e,t)}"
                              @mousedown="${this._handlePreventFocus}"
                              href="${t.path}"
                            >
                              ${t.label}
                            </a>
                          </li>
                        `))}
                  </ul>
                </div>`:""}
          </div>
        `:null}renderMobile(){return Y`
      <div class="mobile-wrapper">
        <slot name="alertHeader"></slot>
        <slot name="alertPopUp"></slot>
        <div class="link-wrapper">
          ${this.link?Y`
                <atmos-button
                  url="${this.link.path}"
                  variant="reverse"
                  size="thin"
                >
                  ${this.link.label?Ot(this.link.label):""}
                </atmos-button>
              `:""}
        </div>
        <div class="action-bar-wrapper">
          <div class="mobile-location"><slot name="location"></slot></div>
          <div class="action-bar">
            <atmos-header-menu-button
              icon="search"
              label="search"
              @click="${this._searchMenuHandler}"
            >
            </atmos-header-menu-button>
            <atmos-header-menu-button
              icon="hamburger"
              label="menu"
              @click="${this._mobileMenuHandler}"
            >
            </atmos-header-menu-button>
          </div>
        </div>
        <div class="menu-bottom">${this.renderLogo()}</div>
      </div>
      ${this.renderMobileOverlay()}
    `}render(){return Y`
      ${this.isDesktop?this.renderMenuDesktop():this.renderMobile()}
    `}};Ln.styles=[Mn],p([gt()],Ln.prototype,"preventFocusEvent",void 0),p([gt()],Ln.prototype,"isDesktop",void 0),p([gt()],Ln.prototype,"menuOpen",void 0),p([gt()],Ln.prototype,"searchOpen",void 0),p([ut({type:Array})],Ln.prototype,"links",void 0),p([ut({type:Object,attribute:"left-link"})],Ln.prototype,"link",void 0),p([ut({type:Array,attribute:"sub-menu"})],Ln.prototype,"subMenu",void 0),p([ut({attribute:"type"})],Ln.prototype,"type",void 0),p([ut({attribute:"search-data",type:Object})],Ln.prototype,"searchData",void 0),Ln=p([ht("atmos-header")],Ln);var Hn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
h3 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  margin-top: 0px;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom:solid 1px var(--neutral-grayMedium);
}

h4 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  margin-top: 0px;
  margin-bottom: 1.5rem;
}

.dropdown-wrapper {
  background-color: var(--neutral-white);
  display: flex;
  --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
  --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  max-width:862px;
}

.dropdown {
  background-color: var(--neutral-white);
  flex:1;
  padding:32px 62px 40px 34px;
}

.dropdown-items {
  display: flex;
  justify-content:space-between;
}

.dropdown-item{
  flex-shrink:0;
}

.dropdown-item ul{
  list-style-type:none;
  margin:0;
  padding:0;
}

.dropdown-item ul li {
  margin-bottom: 1.5rem;
}

.dropdown-item ul li:last-child {
  margin-bottom: 0px;
}

.dropdown-item ul li a {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--neutral-grayDark);
  text-decoration:none;
}

.dropdown-item ul li a:hover {
  color: var(--brand-primary);
}

.dropdown-item > ul ul{
  padding-left:20px;
}

.dropdown-item > ul ul li:first-child{
  padding-top:29px;
}

.dropdown-item > ul li ul li a {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.altern-wrapper{
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  padding:52px 33px 56px 25px;
  width:334px;
  flex-grow:0;
  box-sizing:border-box;
}

.dropdown-wrapper.altern .dropdown{
  padding:50px 35px 40px 34px;
}

.altern-wrapper .dropdown-item{
  padding-left:11px;
}

.altern-wrapper .dropdown-item h4 {
  margin-bottom: 1.5rem;
  color: var(--neutral-white);
  border-top:1px solid rgba(255, 255, 255, 0.32);
  margin-top:48px;
  padding-top:45px;
}

.altern-wrapper .dropdown-item ul li a {
  color: var(--brand-secondary);
}

@media only screen and (min-width: 1024px){
  .dropdown-wrapper {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
`;let Bn=class extends $t{constructor(){super(...arguments),this.headline=null,this.items=[]}_handleClick(t,e,i,r=null){t.preventDefault(),t.stopPropagation();const n=new CustomEvent("menu-click",{detail:{key:e,item:i,parent:r}});this.dispatchEvent(n)}renderItem(t,e,i=null){return Y` <li>
      <a
        data-link="menu"
        href="${t.path}"
        @click="${r=>this._handleClick(r,e,t,i)}"
        >${t.label}</a
      >
      ${At(t.children)?this.renderTree(t.children,t):null}
    </li>`}renderTree(t,e=null){return Y`
      <ul>
        ${null==t?void 0:t.map(((t,i)=>this.renderItem(t,i,e)))}
      </ul>
    `}render(){const t=this.items.filter((t=>!t.altern)),e=this.items.filter((t=>t.altern));return Y` <div
      class="dropdown-wrapper ${e.length?"altern":""}"
    >
      <div class="dropdown">
        ${this.headline&&Y`<h3 class="headline">${this.headline}</h3>`}
        <div class="dropdown-items">
          ${t.map((t=>Y`
              <div class="dropdown-item">
                ${t.title&&!e.length&&Y`<h4 class="headline">${t.title}</h4>`}
                ${this.renderTree(t.items)}
              </div>
            `))}
        </div>
      </div>
      ${e.length?Y`
            <div class="altern-wrapper">
              ${e.map((t=>Y`
                  ${t.link&&Y`
                    <atmos-button
                      url="${t.url}"
                      variant="reverse"
                      size="large"
                    >
                      ${Ot(t.link)}
                    </atmos-button>
                  `}
                  <div class="dropdown-item">
                    ${t.title&&Y`<h4 class="headline">${t.title}</h4>`}
                    ${this.renderTree(t.items)}
                  </div>
                `))}
            </div>
          `:null}
    </div>`}};Bn.styles=[Hn],p([ut()],Bn.prototype,"headline",void 0),p([ut({type:Array})],Bn.prototype,"items",void 0),Bn=p([ht("atmos-header-dropdown")],Bn);var _n=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.button {
  background-color: var(--brand-primary);
  color: var(--neutral-white);
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:0;
  padding:0;
  border:none;
  height:50px;
  width:50px;
}

.button:hover{
  background-color:var(--brand-primary-hover);
}

.button.large{
  width:97px;
}

.button:active {
  background-color: var(--neutral-grayDark);
  background:var(--neutral-grayDark) !important;
}

.button:focus{
  background-color:var(--brand-primary-hover);
  outline:none;
}
`;let Fn=class extends $t{constructor(){super(...arguments),this.size="small"}render(){return Y`
      <button
        class="button ${this.size}"
        aria-label="${this.label||this.icon}"
      >
        <span><atmos-icon icon="${this.icon}" svg="true" /></span>
      </button>
    `}};Fn.styles=[_n],p([ut({type:String})],Fn.prototype,"icon",void 0),p([ut({type:String})],Fn.prototype,"label",void 0),p([ut({type:String})],Fn.prototype,"size",void 0),Fn=p([ht("atmos-header-menu-button")],Fn);var Dn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.submenu-wrapper {
  position: relative;
  width: 100%;
  box-sizing:border-box;
  padding-left:48px;
}

ul {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  margin: 0px;
  padding: 0px;
  font-size:28px;
  line-height:35px;
  list-style-type:none;
}

ul li a {
  color: var(--neutral-grayDark);
  text-decoration:none;
}

.first-level > li{
  margin-bottom:16px;
}

.level-1 {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  line-height:18px;
  max-height:0;
  padding-left:32px;
  transition:max-height 0.5s;
  overflow-y:hidden;
}

.level-1 > li{
  margin-bottom:22px;
}

.level-1 > li:first-child{
  margin-top:26px;
}

.level-1 ul {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  line-height:16px;
  padding-left:20px;
}

.level-1 ul li{
  margin-bottom:25px;
}

.level-1 ul li:first-child{
  margin-top:22px;
}

.selected .level-1{
  max-height:1000px;
}
`;let En=class extends $t{constructor(){super(...arguments),this.selected=null,this.items=[]}_handleClick(t,e,i,r=null){t.preventDefault();const n=new CustomEvent("menu-click",{detail:{key:e,item:i,parent:r}});this.dispatchEvent(n)}_handleTopLevelClick(t,e,i){t.preventDefault(),t.stopPropagation(),this.selected&&this.selected===e?this.selected=null:this.selected=e,i.children||(this.selected=null,this._handleClick(t,e,i))}renderTree(t,e,i){return t?Y`
          <ul class="level-${i}">
            ${t.map((t=>Y`<li class="strong"><b>${t.title}</b></li>
                ${t.items.map(((t,i)=>Y` <li>
                      &nbsp;&nbsp;<a
                        @click="${r=>this._handleClick(r,i,t,e)}"
                        href="${t.path}"
                      >
                        ${t.label}
                      </a>
                    </li>`))} `))}
          </ul>
        `:Y``}render(){return Y` <div class="submenu-wrapper">
      <div class="submenu">
        <ul class="first-level">
          ${this.items.map(((t,e)=>{var i;return Y` <li
              class="${t.children&&this.selected===e?"selected":""} ${t.children?"has-children":""}"
            >
              <a
                @click="${i=>this._handleTopLevelClick(i,e,t)}"
                href="${t.path}"
              >
                ${t.label}
              </a>
              ${this.renderTree(null!==(i=t.children)&&void 0!==i?i:[],t,1)}
            </li>`}))}
        </ul>
      </div>
    </div>`}};En.styles=[Dn],p([gt()],En.prototype,"selected",void 0),p([ut({type:Array})],En.prototype,"items",void 0),En=p([ht("atmos-header-mobile-submenu")],En);var Vn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.submenu-wrapper {
  position: relative;
  margin: auto;
  max-width: 1136px;
}

.submenu-dropdowns{
  position:absolute;
  width:100%;
  z-index:1000;
}

.submenu-dropdowns atmos-header-dropdown{
  position:absolute;
  right:-150px;
  transform:translate(0, 12px);
  width:862px;
}

.submenu{
  display:flex;
}

.first-level{
  display:flex;
  list-style-type:none;
  margin:0;
  margin-left:auto;
  padding:0;
}

.first-level > li {
  position: relative;
}

.first-level > li:not(:last-child){
  margin-right:41px;
}

.first-level > li > a {
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  color: var(--neutral-grayDark);
  font-weight:400;
  transition:color 0.5s;
}

.first-level > li > a:hover, .first-level > li > a:focus {
  color: var(--brand-primary);
}

.dropdown-wrapper {
  position: absolute;
  left:50%;
  transform:translate(-111px, 25px);
  width:222px;
}

.has-children.selected a:after {
  position: absolute;
  display: block;
  content:'';
  border:solid 3px transparent;
  border-top-color:var(--brand-primary);
  border-right-color:var(--brand-primary);
  transform:rotate(-45deg);
  left:50%;
  margin-left:-3px;
  bottom:-7px;
}
`;let On=class extends $t{constructor(){super(...arguments),this.selected=null,this.itemSelected=null,this.preventFocusEvent=!1,this.items=[]}connectedCallback(){super.connectedCallback(),document.addEventListener("click",(()=>{this.selected=null,this.itemSelected=null})),document.addEventListener("keydown",(t=>{const{keyCode:e}=t;27==e&&(this.selected=null,this.itemSelected=null)}))}disconnectedCallback(){document.removeEventListener("click",(()=>{this.selected=null,this.itemSelected=null})),document.removeEventListener("keydown",(t=>{const{keyCode:e}=t;27==e&&(this.selected=null,this.itemSelected=null)})),super.disconnectedCallback()}_handleClick(t,e,i,r=null){t.preventDefault();const n=new CustomEvent("menu-click",{detail:{key:e,item:i,parent:r}});this.dispatchEvent(n)}_handleDropdownClick(t,e){const{detail:i}=t,r=Object.assign({},i);(null==r?void 0:r.parent)||(r.parent=e);const n=new CustomEvent("menu-click",{detail:r});this.dispatchEvent(n)}_handleFocus(t){this.preventFocusEvent||(this.selected=t,this.itemSelected=this.items[t])}_handlePreventFocus(){this.preventFocusEvent=!0}_handleTopLevelClick(t,e,i){t.preventDefault(),t.stopPropagation(),this.selected?(this.selected=null,this.itemSelected=null):(this.selected=e,this.itemSelected=this.items[e]),this.preventFocusEvent=!1,i.children||(this.selected=null,this.itemSelected=null,this._handleClick(t,e,i))}renderDropdown(t,e){return t.children?Y`
          <atmos-header-dropdown
            @click="${t=>t.stopPropagation()}"
            tabindex="${Number(e)+1}"
            aria-label="${t.label}"
            headline="${t.label}"
            @menu-click="${e=>{this._handleDropdownClick(e,t)}}"
            items="${JSON.stringify(t.children)}"
          />
        `:""}render(){return Y` <div class="submenu-wrapper">
      <div class="submenu">
        <ul class="first-level">
          ${this.items.map(((t,e)=>Y` <li
                class="${t.children&&this.selected===e?"selected":""} ${t.children?"has-children":""}"
              >
                <a
                  @focus="${()=>this._handleFocus(e)}"
                  @click="${i=>this._handleTopLevelClick(i,e,t)}"
                  @mousedown="${this._handlePreventFocus}"
                  href="${t.path}"
                  tabindex="${e+1}"
                >
                  ${t.label}
                </a>
              </li>`))}
        </ul>
      </div>
      ${this.itemSelected?Y`
            <div class="submenu-dropdowns">
              ${this.renderDropdown(this.itemSelected,this.selected)}
            </div>
          `:null}
    </div>`}};On.styles=[Vn],p([gt()],On.prototype,"selected",void 0),p([gt()],On.prototype,"itemSelected",void 0),p([gt()],On.prototype,"preventFocusEvent",void 0),p([ut({type:Array})],On.prototype,"items",void 0),On=p([ht("atmos-header-submenu")],On);var jn=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper {
  --tw-shadow: 2px 2px 8px rgba(0, 76, 142, 0.04), 4px 4px 22px rgba(0, 76, 142, 0.12);
  --tw-shadow-colored: 2px 2px 8px var(--tw-shadow-color), 4px 4px 22px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius:32px;
  display:flex;
  overflow:hidden;
}

.highlight {
  color: var(--neutral-white);
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-end;
  background:linear-gradient(28.01deg, #0053b7 16.5%, #0074ff 85.96%);
  box-sizing:border-box;
  flex-shrink:0;
  padding:20px 48px;
  width:254px;
}

.highlight h2 {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  margin-top:0;
  margin-bottom:23px;
}

.highlight .change {
  font-family: Futura Std Bold, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  margin-bottom:26px;
}

.highlight .date {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

.highlight .icon{
  border:solid 14px white;
  border-bottom-color:transparent;
  border-right-color:transparent;
  transform:rotate(225deg) translate(20px, 20px);
}

.highlight.up .icon{
  transform:rotate(45deg) translate(0px, 0px);
}

.highlight .icon-wrapper{
  margin-bottom:20px;
  transform:translate(0, 20px);
}

.highlight.up .icon-wrapper{
  transform:translate(0px, 10px);
}

.highlight .inner-icon{
  border:solid 9px red;
  position:absolute;
  top:-11px;
  left:-11px;
  border-bottom-color:transparent;
  border-right-color:transparent;
}

.highlight.up .inner-icon{
  border-top-color:#19ad45;
  border-left-color:#19ad45;
}

.chart-wrapper{
  flex-grow:1;
  background:linear-gradient(#f8f8f8 0 0) calc((1 * 100% / 6) - 11%),
    linear-gradient(#f8f8f8 0 0) calc((2 * 100% / 6) - 11%),
    linear-gradient(#f8f8f8 0 0) calc((3 * 100% / 6) - 11%),
    linear-gradient(#f8f8f8 0 0) calc((4 * 100% / 6) - 11%),
    linear-gradient(#f8f8f8 0 0) calc((5 * 100% / 6) - 11%),
    linear-gradient(#f8f8f8 0 0) calc((6 * 100% / 6) - 11%);
  background-size:8% 100%;
  background-repeat:no-repeat;
}

.chart-inner-wrapper{
  position:relative;
}

.demo{
  align-items:center;
  display:flex;
  height:100%;
  justify-content:center;
}

@media only screen and (max-width: 767px){
  .wrapper{
    border-radius:0;
    box-shadow:none;
    flex-direction:column-reverse;
  }
  .highlight{
    width:100%;
  }
}

@media only screen and (min-width: 1024px){
  .wrapper {
    --tw-shadow: 2px 2px 12px rgba(0, 76, 142, 0.06), 5px 5px 64px rgba(0, 76, 142, 0.16);
    --tw-shadow-colored: 2px 2px 12px var(--tw-shadow-color), 5px 5px 64px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
`;function Zn(t){if(null===t||!0===t||!1===t)return NaN;var e=Number(t);return isNaN(e)?e:e<0?Math.ceil(e):Math.floor(e)}function Rn(t,e){if(e.length<t)throw new TypeError(t+" argument"+(t>1?"s":"")+" required, but only "+e.length+" present")}function Tn(t){Rn(1,arguments);var e=Object.prototype.toString.call(t);return t instanceof Date||"object"==typeof t&&"[object Date]"===e?new Date(t.getTime()):"number"==typeof t||"[object Number]"===e?new Date(t):("string"!=typeof t&&"[object String]"!==e||"undefined"==typeof console||(console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"),console.warn((new Error).stack)),new Date(NaN))}function Nn(t,e){Rn(2,arguments);var i=Tn(t).getTime(),r=Zn(e);return new Date(i+r)}function Pn(t){var e=new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds()));return e.setUTCFullYear(t.getFullYear()),t.getTime()-e.getTime()}function Yn(t){return Rn(1,arguments),t instanceof Date||"object"==typeof t&&"[object Date]"===Object.prototype.toString.call(t)}function In(t){if(Rn(1,arguments),!Yn(t)&&"number"!=typeof t)return!1;var e=Tn(t);return!isNaN(Number(e))}var Un={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXWeeks:{one:"about 1 week",other:"about {{count}} weeks"},xWeeks:{one:"1 week",other:"{{count}} weeks"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}},Wn=function(t,e,i){var r,n=Un[t];return r="string"==typeof n?n:1===e?n.one:n.other.replace("{{count}}",e.toString()),null!=i&&i.addSuffix?i.comparison&&i.comparison>0?"in "+r:r+" ago":r};function qn(t){return function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},i=e.width?String(e.width):t.defaultWidth,r=t.formats[i]||t.formats[t.defaultWidth];return r}}var Gn={date:qn({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:qn({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:qn({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},Qn={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"};function Xn(t){return function(e,i){var r,n=i||{};if("formatting"===(n.context?String(n.context):"standalone")&&t.formattingValues){var o=t.defaultFormattingWidth||t.defaultWidth,a=n.width?String(n.width):o;r=t.formattingValues[a]||t.formattingValues[o]}else{var s=t.defaultWidth,l=n.width?String(n.width):t.defaultWidth;r=t.values[l]||t.values[s]}return r[t.argumentCallback?t.argumentCallback(e):e]}}function Kn(t){return function(e){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=i.width,n=r&&t.matchPatterns[r]||t.matchPatterns[t.defaultMatchWidth],o=e.match(n);if(!o)return null;var a,s=o[0],l=r&&t.parsePatterns[r]||t.parsePatterns[t.defaultParseWidth],d=Array.isArray(l)?to(l,(function(t){return t.test(s)})):Jn(l,(function(t){return t.test(s)}));a=t.valueCallback?t.valueCallback(d):d,a=i.valueCallback?i.valueCallback(a):a;var c=e.slice(s.length);return{value:a,rest:c}}}function Jn(t,e){for(var i in t)if(t.hasOwnProperty(i)&&e(t[i]))return i}function to(t,e){for(var i=0;i<t.length;i++)if(e(t[i]))return i}var eo,io={code:"en-US",formatDistance:Wn,formatLong:Gn,formatRelative:function(t,e,i,r){return Qn[t]},localize:{ordinalNumber:function(t,e){var i=Number(t),r=i%100;if(r>20||r<10)switch(r%10){case 1:return i+"st";case 2:return i+"nd";case 3:return i+"rd"}return i+"th"},era:Xn({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:Xn({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:function(t){return t-1}}),month:Xn({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:Xn({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:Xn({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaultFormattingWidth:"wide"})},match:{ordinalNumber:(eo={matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:function(t){return parseInt(t,10)}},function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=t.match(eo.matchPattern);if(!i)return null;var r=i[0],n=t.match(eo.parsePattern);if(!n)return null;var o=eo.valueCallback?eo.valueCallback(n[0]):n[0];o=e.valueCallback?e.valueCallback(o):o;var a=t.slice(r.length);return{value:o,rest:a}}),era:Kn({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:Kn({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:function(t){return t+1}}),month:Kn({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:Kn({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:Kn({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})},options:{weekStartsOn:0,firstWeekContainsDate:1}};function ro(t,e){Rn(2,arguments);var i=Zn(e);return Nn(t,-i)}function no(t){Rn(1,arguments);var e=1,i=Tn(t),r=i.getUTCDay(),n=(r<e?7:0)+r-e;return i.setUTCDate(i.getUTCDate()-n),i.setUTCHours(0,0,0,0),i}function oo(t){Rn(1,arguments);var e=Tn(t),i=e.getUTCFullYear(),r=new Date(0);r.setUTCFullYear(i+1,0,4),r.setUTCHours(0,0,0,0);var n=no(r),o=new Date(0);o.setUTCFullYear(i,0,4),o.setUTCHours(0,0,0,0);var a=no(o);return e.getTime()>=n.getTime()?i+1:e.getTime()>=a.getTime()?i:i-1}function ao(t){Rn(1,arguments);var e=oo(t),i=new Date(0);i.setUTCFullYear(e,0,4),i.setUTCHours(0,0,0,0);var r=no(i);return r}function so(t,e){Rn(1,arguments);var i=e||{},r=i.locale,n=r&&r.options&&r.options.weekStartsOn,o=null==n?0:Zn(n),a=null==i.weekStartsOn?o:Zn(i.weekStartsOn);if(!(a>=0&&a<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var s=Tn(t),l=s.getUTCDay(),d=(l<a?7:0)+l-a;return s.setUTCDate(s.getUTCDate()-d),s.setUTCHours(0,0,0,0),s}function lo(t,e){Rn(1,arguments);var i=Tn(t),r=i.getUTCFullYear(),n=e||{},o=n.locale,a=o&&o.options&&o.options.firstWeekContainsDate,s=null==a?1:Zn(a),l=null==n.firstWeekContainsDate?s:Zn(n.firstWeekContainsDate);if(!(l>=1&&l<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var d=new Date(0);d.setUTCFullYear(r+1,0,l),d.setUTCHours(0,0,0,0);var c=so(d,e),h=new Date(0);h.setUTCFullYear(r,0,l),h.setUTCHours(0,0,0,0);var p=so(h,e);return i.getTime()>=c.getTime()?r+1:i.getTime()>=p.getTime()?r:r-1}function co(t,e){Rn(1,arguments);var i=e||{},r=i.locale,n=r&&r.options&&r.options.firstWeekContainsDate,o=null==n?1:Zn(n),a=null==i.firstWeekContainsDate?o:Zn(i.firstWeekContainsDate),s=lo(t,e),l=new Date(0);l.setUTCFullYear(s,0,a),l.setUTCHours(0,0,0,0);var d=so(l,e);return d}function ho(t,e){for(var i=t<0?"-":"",r=Math.abs(t).toString();r.length<e;)r="0"+r;return i+r}var po={y:function(t,e){var i=t.getUTCFullYear(),r=i>0?i:1-i;return ho("yy"===e?r%100:r,e.length)},M:function(t,e){var i=t.getUTCMonth();return"M"===e?String(i+1):ho(i+1,2)},d:function(t,e){return ho(t.getUTCDate(),e.length)},a:function(t,e){var i=t.getUTCHours()/12>=1?"pm":"am";switch(e){case"a":case"aa":return i.toUpperCase();case"aaa":return i;case"aaaaa":return i[0];default:return"am"===i?"a.m.":"p.m."}},h:function(t,e){return ho(t.getUTCHours()%12||12,e.length)},H:function(t,e){return ho(t.getUTCHours(),e.length)},m:function(t,e){return ho(t.getUTCMinutes(),e.length)},s:function(t,e){return ho(t.getUTCSeconds(),e.length)},S:function(t,e){var i=e.length,r=t.getUTCMilliseconds();return ho(Math.floor(r*Math.pow(10,i-3)),e.length)}},uo="midnight",go="noon",fo="morning",mo="afternoon",bo="evening",vo="night",wo={G:function(t,e,i){var r=t.getUTCFullYear()>0?1:0;switch(e){case"G":case"GG":case"GGG":return i.era(r,{width:"abbreviated"});case"GGGGG":return i.era(r,{width:"narrow"});default:return i.era(r,{width:"wide"})}},y:function(t,e,i){if("yo"===e){var r=t.getUTCFullYear(),n=r>0?r:1-r;return i.ordinalNumber(n,{unit:"year"})}return po.y(t,e)},Y:function(t,e,i,r){var n=lo(t,r),o=n>0?n:1-n;return"YY"===e?ho(o%100,2):"Yo"===e?i.ordinalNumber(o,{unit:"year"}):ho(o,e.length)},R:function(t,e){return ho(oo(t),e.length)},u:function(t,e){return ho(t.getUTCFullYear(),e.length)},Q:function(t,e,i){var r=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"Q":return String(r);case"QQ":return ho(r,2);case"Qo":return i.ordinalNumber(r,{unit:"quarter"});case"QQQ":return i.quarter(r,{width:"abbreviated",context:"formatting"});case"QQQQQ":return i.quarter(r,{width:"narrow",context:"formatting"});default:return i.quarter(r,{width:"wide",context:"formatting"})}},q:function(t,e,i){var r=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"q":return String(r);case"qq":return ho(r,2);case"qo":return i.ordinalNumber(r,{unit:"quarter"});case"qqq":return i.quarter(r,{width:"abbreviated",context:"standalone"});case"qqqqq":return i.quarter(r,{width:"narrow",context:"standalone"});default:return i.quarter(r,{width:"wide",context:"standalone"})}},M:function(t,e,i){var r=t.getUTCMonth();switch(e){case"M":case"MM":return po.M(t,e);case"Mo":return i.ordinalNumber(r+1,{unit:"month"});case"MMM":return i.month(r,{width:"abbreviated",context:"formatting"});case"MMMMM":return i.month(r,{width:"narrow",context:"formatting"});default:return i.month(r,{width:"wide",context:"formatting"})}},L:function(t,e,i){var r=t.getUTCMonth();switch(e){case"L":return String(r+1);case"LL":return ho(r+1,2);case"Lo":return i.ordinalNumber(r+1,{unit:"month"});case"LLL":return i.month(r,{width:"abbreviated",context:"standalone"});case"LLLLL":return i.month(r,{width:"narrow",context:"standalone"});default:return i.month(r,{width:"wide",context:"standalone"})}},w:function(t,e,i,r){var n=function(t,e){Rn(1,arguments);var i=Tn(t),r=so(i,e).getTime()-co(i,e).getTime();return Math.round(r/6048e5)+1}(t,r);return"wo"===e?i.ordinalNumber(n,{unit:"week"}):ho(n,e.length)},I:function(t,e,i){var r=function(t){Rn(1,arguments);var e=Tn(t),i=no(e).getTime()-ao(e).getTime();return Math.round(i/6048e5)+1}(t);return"Io"===e?i.ordinalNumber(r,{unit:"week"}):ho(r,e.length)},d:function(t,e,i){return"do"===e?i.ordinalNumber(t.getUTCDate(),{unit:"date"}):po.d(t,e)},D:function(t,e,i){var r=function(t){Rn(1,arguments);var e=Tn(t),i=e.getTime();e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0);var r=e.getTime(),n=i-r;return Math.floor(n/864e5)+1}(t);return"Do"===e?i.ordinalNumber(r,{unit:"dayOfYear"}):ho(r,e.length)},E:function(t,e,i){var r=t.getUTCDay();switch(e){case"E":case"EE":case"EEE":return i.day(r,{width:"abbreviated",context:"formatting"});case"EEEEE":return i.day(r,{width:"narrow",context:"formatting"});case"EEEEEE":return i.day(r,{width:"short",context:"formatting"});default:return i.day(r,{width:"wide",context:"formatting"})}},e:function(t,e,i,r){var n=t.getUTCDay(),o=(n-r.weekStartsOn+8)%7||7;switch(e){case"e":return String(o);case"ee":return ho(o,2);case"eo":return i.ordinalNumber(o,{unit:"day"});case"eee":return i.day(n,{width:"abbreviated",context:"formatting"});case"eeeee":return i.day(n,{width:"narrow",context:"formatting"});case"eeeeee":return i.day(n,{width:"short",context:"formatting"});default:return i.day(n,{width:"wide",context:"formatting"})}},c:function(t,e,i,r){var n=t.getUTCDay(),o=(n-r.weekStartsOn+8)%7||7;switch(e){case"c":return String(o);case"cc":return ho(o,e.length);case"co":return i.ordinalNumber(o,{unit:"day"});case"ccc":return i.day(n,{width:"abbreviated",context:"standalone"});case"ccccc":return i.day(n,{width:"narrow",context:"standalone"});case"cccccc":return i.day(n,{width:"short",context:"standalone"});default:return i.day(n,{width:"wide",context:"standalone"})}},i:function(t,e,i){var r=t.getUTCDay(),n=0===r?7:r;switch(e){case"i":return String(n);case"ii":return ho(n,e.length);case"io":return i.ordinalNumber(n,{unit:"day"});case"iii":return i.day(r,{width:"abbreviated",context:"formatting"});case"iiiii":return i.day(r,{width:"narrow",context:"formatting"});case"iiiiii":return i.day(r,{width:"short",context:"formatting"});default:return i.day(r,{width:"wide",context:"formatting"})}},a:function(t,e,i){var r=t.getUTCHours()/12>=1?"pm":"am";switch(e){case"a":case"aa":return i.dayPeriod(r,{width:"abbreviated",context:"formatting"});case"aaa":return i.dayPeriod(r,{width:"abbreviated",context:"formatting"}).toLowerCase();case"aaaaa":return i.dayPeriod(r,{width:"narrow",context:"formatting"});default:return i.dayPeriod(r,{width:"wide",context:"formatting"})}},b:function(t,e,i){var r,n=t.getUTCHours();switch(r=12===n?go:0===n?uo:n/12>=1?"pm":"am",e){case"b":case"bb":return i.dayPeriod(r,{width:"abbreviated",context:"formatting"});case"bbb":return i.dayPeriod(r,{width:"abbreviated",context:"formatting"}).toLowerCase();case"bbbbb":return i.dayPeriod(r,{width:"narrow",context:"formatting"});default:return i.dayPeriod(r,{width:"wide",context:"formatting"})}},B:function(t,e,i){var r,n=t.getUTCHours();switch(r=n>=17?bo:n>=12?mo:n>=4?fo:vo,e){case"B":case"BB":case"BBB":return i.dayPeriod(r,{width:"abbreviated",context:"formatting"});case"BBBBB":return i.dayPeriod(r,{width:"narrow",context:"formatting"});default:return i.dayPeriod(r,{width:"wide",context:"formatting"})}},h:function(t,e,i){if("ho"===e){var r=t.getUTCHours()%12;return 0===r&&(r=12),i.ordinalNumber(r,{unit:"hour"})}return po.h(t,e)},H:function(t,e,i){return"Ho"===e?i.ordinalNumber(t.getUTCHours(),{unit:"hour"}):po.H(t,e)},K:function(t,e,i){var r=t.getUTCHours()%12;return"Ko"===e?i.ordinalNumber(r,{unit:"hour"}):ho(r,e.length)},k:function(t,e,i){var r=t.getUTCHours();return 0===r&&(r=24),"ko"===e?i.ordinalNumber(r,{unit:"hour"}):ho(r,e.length)},m:function(t,e,i){return"mo"===e?i.ordinalNumber(t.getUTCMinutes(),{unit:"minute"}):po.m(t,e)},s:function(t,e,i){return"so"===e?i.ordinalNumber(t.getUTCSeconds(),{unit:"second"}):po.s(t,e)},S:function(t,e){return po.S(t,e)},X:function(t,e,i,r){var n=(r._originalDate||t).getTimezoneOffset();if(0===n)return"Z";switch(e){case"X":return yo(n);case"XXXX":case"XX":return Co(n);default:return Co(n,":")}},x:function(t,e,i,r){var n=(r._originalDate||t).getTimezoneOffset();switch(e){case"x":return yo(n);case"xxxx":case"xx":return Co(n);default:return Co(n,":")}},O:function(t,e,i,r){var n=(r._originalDate||t).getTimezoneOffset();switch(e){case"O":case"OO":case"OOO":return"GMT"+xo(n,":");default:return"GMT"+Co(n,":")}},z:function(t,e,i,r){var n=(r._originalDate||t).getTimezoneOffset();switch(e){case"z":case"zz":case"zzz":return"GMT"+xo(n,":");default:return"GMT"+Co(n,":")}},t:function(t,e,i,r){var n=r._originalDate||t;return ho(Math.floor(n.getTime()/1e3),e.length)},T:function(t,e,i,r){return ho((r._originalDate||t).getTime(),e.length)}};function xo(t,e){var i=t>0?"-":"+",r=Math.abs(t),n=Math.floor(r/60),o=r%60;if(0===o)return i+String(n);var a=e||"";return i+String(n)+a+ho(o,2)}function yo(t,e){return t%60==0?(t>0?"-":"+")+ho(Math.abs(t)/60,2):Co(t,e)}function Co(t,e){var i=e||"",r=t>0?"-":"+",n=Math.abs(t);return r+ho(Math.floor(n/60),2)+i+ho(n%60,2)}var ko=wo;function Ao(t,e){switch(t){case"P":return e.date({width:"short"});case"PP":return e.date({width:"medium"});case"PPP":return e.date({width:"long"});default:return e.date({width:"full"})}}function zo(t,e){switch(t){case"p":return e.time({width:"short"});case"pp":return e.time({width:"medium"});case"ppp":return e.time({width:"long"});default:return e.time({width:"full"})}}var $o={p:zo,P:function(t,e){var i,r=t.match(/(P+)(p+)?/)||[],n=r[1],o=r[2];if(!o)return Ao(t,e);switch(n){case"P":i=e.dateTime({width:"short"});break;case"PP":i=e.dateTime({width:"medium"});break;case"PPP":i=e.dateTime({width:"long"});break;default:i=e.dateTime({width:"full"})}return i.replace("{{date}}",Ao(n,e)).replace("{{time}}",zo(o,e))}},Mo=$o,So=["D","DD"],Lo=["YY","YYYY"];function Ho(t){return-1!==So.indexOf(t)}function Bo(t){return-1!==Lo.indexOf(t)}function _o(t,e,i){if("YYYY"===t)throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e,"`) for formatting years to the input `").concat(i,"`; see: https://git.io/fxCyr"));if("YY"===t)throw new RangeError("Use `yy` instead of `YY` (in `".concat(e,"`) for formatting years to the input `").concat(i,"`; see: https://git.io/fxCyr"));if("D"===t)throw new RangeError("Use `d` instead of `D` (in `".concat(e,"`) for formatting days of the month to the input `").concat(i,"`; see: https://git.io/fxCyr"));if("DD"===t)throw new RangeError("Use `dd` instead of `DD` (in `".concat(e,"`) for formatting days of the month to the input `").concat(i,"`; see: https://git.io/fxCyr"))}var Fo=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,Do=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,Eo=/^'([^]*?)'?$/,Vo=/''/g,Oo=/[a-zA-Z]/;function jo(t){return t.match(Eo)[1].replace(Vo,"'")}
/*!
 * Chart.js v3.7.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */const Zo="undefined"==typeof window?function(t){return t()}:window.requestAnimationFrame;function Ro(t,e,i){const r=i||(t=>Array.prototype.slice.call(t));let n=!1,o=[];return function(...i){o=r(i),n||(n=!0,Zo.call(window,(()=>{n=!1,t.apply(e,o)})))}}const To=t=>"start"===t?"left":"end"===t?"right":"center",No=(t,e,i)=>"start"===t?e:"end"===t?i:(e+i)/2;function Po(){}const Yo=function(){let t=0;return function(){return t++}}();function Io(t){return null==t}function Uo(t){if(Array.isArray&&Array.isArray(t))return!0;const e=Object.prototype.toString.call(t);return"[object"===e.substr(0,7)&&"Array]"===e.substr(-6)}function Wo(t){return null!==t&&"[object Object]"===Object.prototype.toString.call(t)}const qo=t=>("number"==typeof t||t instanceof Number)&&isFinite(+t);function Go(t,e){return qo(t)?t:e}function Qo(t,e){return void 0===t?e:t}const Xo=(t,e)=>"string"==typeof t&&t.endsWith("%")?parseFloat(t)/100*e:+t;function Ko(t,e,i){if(t&&"function"==typeof t.call)return t.apply(i,e)}function Jo(t,e,i,r){let n,o,a;if(Uo(t))if(o=t.length,r)for(n=o-1;n>=0;n--)e.call(i,t[n],n);else for(n=0;n<o;n++)e.call(i,t[n],n);else if(Wo(t))for(a=Object.keys(t),o=a.length,n=0;n<o;n++)e.call(i,t[a[n]],a[n])}function ta(t,e){let i,r,n,o;if(!t||!e||t.length!==e.length)return!1;for(i=0,r=t.length;i<r;++i)if(n=t[i],o=e[i],n.datasetIndex!==o.datasetIndex||n.index!==o.index)return!1;return!0}function ea(t){if(Uo(t))return t.map(ea);if(Wo(t)){const e=Object.create(null),i=Object.keys(t),r=i.length;let n=0;for(;n<r;++n)e[i[n]]=ea(t[i[n]]);return e}return t}function ia(t){return-1===["__proto__","prototype","constructor"].indexOf(t)}function ra(t,e,i,r){if(!ia(t))return;const n=e[t],o=i[t];Wo(n)&&Wo(o)?na(n,o,r):e[t]=ea(o)}function na(t,e,i){const r=Uo(e)?e:[e],n=r.length;if(!Wo(t))return t;const o=(i=i||{}).merger||ra;for(let a=0;a<n;++a){if(e=r[a],!Wo(e))continue;const n=Object.keys(e);for(let r=0,a=n.length;r<a;++r)o(n[r],t,e,i)}return t}function oa(t,e){return na(t,e,{merger:aa})}function aa(t,e,i){if(!ia(t))return;const r=e[t],n=i[t];Wo(r)&&Wo(n)?oa(r,n):Object.prototype.hasOwnProperty.call(e,t)||(e[t]=ea(n))}function sa(t,e){const i=t.indexOf(".",e);return-1===i?t.length:i}function la(t,e){if(""===e)return t;let i=0,r=sa(e,i);for(;t&&r>i;)t=t[e.substr(i,r-i)],i=r+1,r=sa(e,i);return t}function da(t){return t.charAt(0).toUpperCase()+t.slice(1)}const ca=t=>void 0!==t,ha=t=>"function"==typeof t,pa=(t,e)=>{if(t.size!==e.size)return!1;for(const i of t)if(!e.has(i))return!1;return!0};const ua=Math.PI,ga=2*ua,fa=ga+ua,ma=Number.POSITIVE_INFINITY,ba=ua/180,va=ua/2,wa=ua/4,xa=2*ua/3,ya=Math.log10,Ca=Math.sign;function ka(t){const e=Math.round(t);t=za(t,e,t/1e3)?e:t;const i=Math.pow(10,Math.floor(ya(t))),r=t/i;return(r<=1?1:r<=2?2:r<=5?5:10)*i}function Aa(t){return!isNaN(parseFloat(t))&&isFinite(t)}function za(t,e,i){return Math.abs(t-e)<i}function $a(t,e,i){let r,n,o;for(r=0,n=t.length;r<n;r++)o=t[r][i],isNaN(o)||(e.min=Math.min(e.min,o),e.max=Math.max(e.max,o))}function Ma(t){return t*(ua/180)}function Sa(t){return t*(180/ua)}function La(t){if(!qo(t))return;let e=1,i=0;for(;Math.round(t*e)/e!==t;)e*=10,i++;return i}function Ha(t,e){const i=e.x-t.x,r=e.y-t.y,n=Math.sqrt(i*i+r*r);let o=Math.atan2(r,i);return o<-.5*ua&&(o+=ga),{angle:o,distance:n}}function Ba(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function _a(t,e){return(t-e+fa)%ga-ua}function Fa(t){return(t%ga+ga)%ga}function Da(t,e,i,r){const n=Fa(t),o=Fa(e),a=Fa(i),s=Fa(o-n),l=Fa(a-n),d=Fa(n-o),c=Fa(n-a);return n===o||n===a||r&&o===a||s>l&&d<c}function Ea(t,e,i){return Math.max(e,Math.min(i,t))}function Va(t,e,i,r=1e-6){return t>=Math.min(e,i)-r&&t<=Math.max(e,i)+r}const Oa=t=>0===t||1===t,ja=(t,e,i)=>-Math.pow(2,10*(t-=1))*Math.sin((t-e)*ga/i),Za=(t,e,i)=>Math.pow(2,-10*t)*Math.sin((t-e)*ga/i)+1,Ra={linear:t=>t,easeInQuad:t=>t*t,easeOutQuad:t=>-t*(t-2),easeInOutQuad:t=>(t/=.5)<1?.5*t*t:-.5*(--t*(t-2)-1),easeInCubic:t=>t*t*t,easeOutCubic:t=>(t-=1)*t*t+1,easeInOutCubic:t=>(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2),easeInQuart:t=>t*t*t*t,easeOutQuart:t=>-((t-=1)*t*t*t-1),easeInOutQuart:t=>(t/=.5)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2),easeInQuint:t=>t*t*t*t*t,easeOutQuint:t=>(t-=1)*t*t*t*t+1,easeInOutQuint:t=>(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2),easeInSine:t=>1-Math.cos(t*va),easeOutSine:t=>Math.sin(t*va),easeInOutSine:t=>-.5*(Math.cos(ua*t)-1),easeInExpo:t=>0===t?0:Math.pow(2,10*(t-1)),easeOutExpo:t=>1===t?1:1-Math.pow(2,-10*t),easeInOutExpo:t=>Oa(t)?t:t<.5?.5*Math.pow(2,10*(2*t-1)):.5*(2-Math.pow(2,-10*(2*t-1))),easeInCirc:t=>t>=1?t:-(Math.sqrt(1-t*t)-1),easeOutCirc:t=>Math.sqrt(1-(t-=1)*t),easeInOutCirc:t=>(t/=.5)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1),easeInElastic:t=>Oa(t)?t:ja(t,.075,.3),easeOutElastic:t=>Oa(t)?t:Za(t,.075,.3),easeInOutElastic(t){const e=.1125;return Oa(t)?t:t<.5?.5*ja(2*t,e,.45):.5+.5*Za(2*t-1,e,.45)},easeInBack(t){const e=1.70158;return t*t*((e+1)*t-e)},easeOutBack(t){const e=1.70158;return(t-=1)*t*((e+1)*t+e)+1},easeInOutBack(t){let e=1.70158;return(t/=.5)<1?t*t*((1+(e*=1.525))*t-e)*.5:.5*((t-=2)*t*((1+(e*=1.525))*t+e)+2)},easeInBounce:t=>1-Ra.easeOutBounce(1-t),easeOutBounce(t){const e=7.5625,i=2.75;return t<1/i?e*t*t:t<2/i?e*(t-=1.5/i)*t+.75:t<2.5/i?e*(t-=2.25/i)*t+.9375:e*(t-=2.625/i)*t+.984375},easeInOutBounce:t=>t<.5?.5*Ra.easeInBounce(2*t):.5*Ra.easeOutBounce(2*t-1)+.5},Ta={0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:10,B:11,C:12,D:13,E:14,F:15,a:10,b:11,c:12,d:13,e:14,f:15},Na="0123456789ABCDEF",Pa=t=>Na[15&t],Ya=t=>Na[(240&t)>>4]+Na[15&t],Ia=t=>(240&t)>>4==(15&t);function Ua(t){var e=function(t){return Ia(t.r)&&Ia(t.g)&&Ia(t.b)&&Ia(t.a)}(t)?Pa:Ya;return t?"#"+e(t.r)+e(t.g)+e(t.b)+(t.a<255?e(t.a):""):t}function Wa(t){return t+.5|0}const qa=(t,e,i)=>Math.max(Math.min(t,i),e);function Ga(t){return qa(Wa(2.55*t),0,255)}function Qa(t){return qa(Wa(255*t),0,255)}function Xa(t){return qa(Wa(t/2.55)/100,0,1)}function Ka(t){return qa(Wa(100*t),0,100)}const Ja=/^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;const ts=/^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;function es(t,e,i){const r=e*Math.min(i,1-i),n=(e,n=(e+t/30)%12)=>i-r*Math.max(Math.min(n-3,9-n,1),-1);return[n(0),n(8),n(4)]}function is(t,e,i){const r=(r,n=(r+t/60)%6)=>i-i*e*Math.max(Math.min(n,4-n,1),0);return[r(5),r(3),r(1)]}function rs(t,e,i){const r=es(t,1,.5);let n;for(e+i>1&&(n=1/(e+i),e*=n,i*=n),n=0;n<3;n++)r[n]*=1-e-i,r[n]+=e;return r}function ns(t){const e=t.r/255,i=t.g/255,r=t.b/255,n=Math.max(e,i,r),o=Math.min(e,i,r),a=(n+o)/2;let s,l,d;return n!==o&&(d=n-o,l=a>.5?d/(2-n-o):d/(n+o),s=n===e?(i-r)/d+(i<r?6:0):n===i?(r-e)/d+2:(e-i)/d+4,s=60*s+.5),[0|s,l||0,a]}function os(t,e,i,r){return(Array.isArray(e)?t(e[0],e[1],e[2]):t(e,i,r)).map(Qa)}function as(t,e,i){return os(es,t,e,i)}function ss(t){return(t%360+360)%360}function ls(t){const e=ts.exec(t);let i,r=255;if(!e)return;e[5]!==i&&(r=e[6]?Ga(+e[5]):Qa(+e[5]));const n=ss(+e[2]),o=+e[3]/100,a=+e[4]/100;return i="hwb"===e[1]?function(t,e,i){return os(rs,t,e,i)}(n,o,a):"hsv"===e[1]?function(t,e,i){return os(is,t,e,i)}(n,o,a):as(n,o,a),{r:i[0],g:i[1],b:i[2],a:r}}const ds={x:"dark",Z:"light",Y:"re",X:"blu",W:"gr",V:"medium",U:"slate",A:"ee",T:"ol",S:"or",B:"ra",C:"lateg",D:"ights",R:"in",Q:"turquois",E:"hi",P:"ro",O:"al",N:"le",M:"de",L:"yello",F:"en",K:"ch",G:"arks",H:"ea",I:"ightg",J:"wh"},cs={OiceXe:"f0f8ff",antiquewEte:"faebd7",aqua:"ffff",aquamarRe:"7fffd4",azuY:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"0",blanKedOmond:"ffebcd",Xe:"ff",XeviTet:"8a2be2",bPwn:"a52a2a",burlywood:"deb887",caMtXe:"5f9ea0",KartYuse:"7fff00",KocTate:"d2691e",cSO:"ff7f50",cSnflowerXe:"6495ed",cSnsilk:"fff8dc",crimson:"dc143c",cyan:"ffff",xXe:"8b",xcyan:"8b8b",xgTMnPd:"b8860b",xWay:"a9a9a9",xgYF:"6400",xgYy:"a9a9a9",xkhaki:"bdb76b",xmagFta:"8b008b",xTivegYF:"556b2f",xSange:"ff8c00",xScEd:"9932cc",xYd:"8b0000",xsOmon:"e9967a",xsHgYF:"8fbc8f",xUXe:"483d8b",xUWay:"2f4f4f",xUgYy:"2f4f4f",xQe:"ced1",xviTet:"9400d3",dAppRk:"ff1493",dApskyXe:"bfff",dimWay:"696969",dimgYy:"696969",dodgerXe:"1e90ff",fiYbrick:"b22222",flSOwEte:"fffaf0",foYstWAn:"228b22",fuKsia:"ff00ff",gaRsbSo:"dcdcdc",ghostwEte:"f8f8ff",gTd:"ffd700",gTMnPd:"daa520",Way:"808080",gYF:"8000",gYFLw:"adff2f",gYy:"808080",honeyMw:"f0fff0",hotpRk:"ff69b4",RdianYd:"cd5c5c",Rdigo:"4b0082",ivSy:"fffff0",khaki:"f0e68c",lavFMr:"e6e6fa",lavFMrXsh:"fff0f5",lawngYF:"7cfc00",NmoncEffon:"fffacd",ZXe:"add8e6",ZcSO:"f08080",Zcyan:"e0ffff",ZgTMnPdLw:"fafad2",ZWay:"d3d3d3",ZgYF:"90ee90",ZgYy:"d3d3d3",ZpRk:"ffb6c1",ZsOmon:"ffa07a",ZsHgYF:"20b2aa",ZskyXe:"87cefa",ZUWay:"778899",ZUgYy:"778899",ZstAlXe:"b0c4de",ZLw:"ffffe0",lime:"ff00",limegYF:"32cd32",lRF:"faf0e6",magFta:"ff00ff",maPon:"800000",VaquamarRe:"66cdaa",VXe:"cd",VScEd:"ba55d3",VpurpN:"9370db",VsHgYF:"3cb371",VUXe:"7b68ee",VsprRggYF:"fa9a",VQe:"48d1cc",VviTetYd:"c71585",midnightXe:"191970",mRtcYam:"f5fffa",mistyPse:"ffe4e1",moccasR:"ffe4b5",navajowEte:"ffdead",navy:"80",Tdlace:"fdf5e6",Tive:"808000",TivedBb:"6b8e23",Sange:"ffa500",SangeYd:"ff4500",ScEd:"da70d6",pOegTMnPd:"eee8aa",pOegYF:"98fb98",pOeQe:"afeeee",pOeviTetYd:"db7093",papayawEp:"ffefd5",pHKpuff:"ffdab9",peru:"cd853f",pRk:"ffc0cb",plum:"dda0dd",powMrXe:"b0e0e6",purpN:"800080",YbeccapurpN:"663399",Yd:"ff0000",Psybrown:"bc8f8f",PyOXe:"4169e1",saddNbPwn:"8b4513",sOmon:"fa8072",sandybPwn:"f4a460",sHgYF:"2e8b57",sHshell:"fff5ee",siFna:"a0522d",silver:"c0c0c0",skyXe:"87ceeb",UXe:"6a5acd",UWay:"708090",UgYy:"708090",snow:"fffafa",sprRggYF:"ff7f",stAlXe:"4682b4",tan:"d2b48c",teO:"8080",tEstN:"d8bfd8",tomato:"ff6347",Qe:"40e0d0",viTet:"ee82ee",JHt:"f5deb3",wEte:"ffffff",wEtesmoke:"f5f5f5",Lw:"ffff00",LwgYF:"9acd32"};let hs;function ps(t){hs||(hs=function(){const t={},e=Object.keys(cs),i=Object.keys(ds);let r,n,o,a,s;for(r=0;r<e.length;r++){for(a=s=e[r],n=0;n<i.length;n++)o=i[n],s=s.replace(o,ds[o]);o=parseInt(cs[a],16),t[s]=[o>>16&255,o>>8&255,255&o]}return t}(),hs.transparent=[0,0,0,0]);const e=hs[t.toLowerCase()];return e&&{r:e[0],g:e[1],b:e[2],a:4===e.length?e[3]:255}}function us(t,e,i){if(t){let r=ns(t);r[e]=Math.max(0,Math.min(r[e]+r[e]*i,0===e?360:1)),r=as(r),t.r=r[0],t.g=r[1],t.b=r[2]}}function gs(t,e){return t?Object.assign(e||{},t):t}function fs(t){var e={r:0,g:0,b:0,a:255};return Array.isArray(t)?t.length>=3&&(e={r:t[0],g:t[1],b:t[2],a:255},t.length>3&&(e.a=Qa(t[3]))):(e=gs(t,{r:0,g:0,b:0,a:1})).a=Qa(e.a),e}function ms(t){return"r"===t.charAt(0)?function(t){const e=Ja.exec(t);let i,r,n,o=255;if(e){if(e[7]!==i){const t=+e[7];o=255&(e[8]?Ga(t):255*t)}return i=+e[1],r=+e[3],n=+e[5],i=255&(e[2]?Ga(i):i),r=255&(e[4]?Ga(r):r),n=255&(e[6]?Ga(n):n),{r:i,g:r,b:n,a:o}}}(t):ls(t)}class bs{constructor(t){if(t instanceof bs)return t;const e=typeof t;let i;var r,n,o;"object"===e?i=fs(t):"string"===e&&(o=(r=t).length,"#"===r[0]&&(4===o||5===o?n={r:255&17*Ta[r[1]],g:255&17*Ta[r[2]],b:255&17*Ta[r[3]],a:5===o?17*Ta[r[4]]:255}:7!==o&&9!==o||(n={r:Ta[r[1]]<<4|Ta[r[2]],g:Ta[r[3]]<<4|Ta[r[4]],b:Ta[r[5]]<<4|Ta[r[6]],a:9===o?Ta[r[7]]<<4|Ta[r[8]]:255})),i=n||ps(t)||ms(t)),this._rgb=i,this._valid=!!i}get valid(){return this._valid}get rgb(){var t=gs(this._rgb);return t&&(t.a=Xa(t.a)),t}set rgb(t){this._rgb=fs(t)}rgbString(){return this._valid?function(t){return t&&(t.a<255?`rgba(${t.r}, ${t.g}, ${t.b}, ${Xa(t.a)})`:`rgb(${t.r}, ${t.g}, ${t.b})`)}(this._rgb):this._rgb}hexString(){return this._valid?Ua(this._rgb):this._rgb}hslString(){return this._valid?function(t){if(!t)return;const e=ns(t),i=e[0],r=Ka(e[1]),n=Ka(e[2]);return t.a<255?`hsla(${i}, ${r}%, ${n}%, ${Xa(t.a)})`:`hsl(${i}, ${r}%, ${n}%)`}(this._rgb):this._rgb}mix(t,e){const i=this;if(t){const r=i.rgb,n=t.rgb;let o;const a=e===o?.5:e,s=2*a-1,l=r.a-n.a,d=((s*l==-1?s:(s+l)/(1+s*l))+1)/2;o=1-d,r.r=255&d*r.r+o*n.r+.5,r.g=255&d*r.g+o*n.g+.5,r.b=255&d*r.b+o*n.b+.5,r.a=a*r.a+(1-a)*n.a,i.rgb=r}return i}clone(){return new bs(this.rgb)}alpha(t){return this._rgb.a=Qa(t),this}clearer(t){return this._rgb.a*=1-t,this}greyscale(){const t=this._rgb,e=Wa(.3*t.r+.59*t.g+.11*t.b);return t.r=t.g=t.b=e,this}opaquer(t){return this._rgb.a*=1+t,this}negate(){const t=this._rgb;return t.r=255-t.r,t.g=255-t.g,t.b=255-t.b,this}lighten(t){return us(this._rgb,2,t),this}darken(t){return us(this._rgb,2,-t),this}saturate(t){return us(this._rgb,1,t),this}desaturate(t){return us(this._rgb,1,-t),this}rotate(t){return function(t,e){var i=ns(t);i[0]=ss(i[0]+e),i=as(i),t.r=i[0],t.g=i[1],t.b=i[2]}(this._rgb,t),this}}function vs(t){return new bs(t)}const ws=t=>t instanceof CanvasGradient||t instanceof CanvasPattern;function xs(t){return ws(t)?t:vs(t)}function ys(t){return ws(t)?t:vs(t).saturate(.5).darken(.1).hexString()}const Cs=Object.create(null),ks=Object.create(null);function As(t,e){if(!e)return t;const i=e.split(".");for(let e=0,r=i.length;e<r;++e){const r=i[e];t=t[r]||(t[r]=Object.create(null))}return t}function zs(t,e,i){return"string"==typeof e?na(As(t,e),i):na(As(t,""),e)}var $s=new class{constructor(t){this.animation=void 0,this.backgroundColor="rgba(0,0,0,0.1)",this.borderColor="rgba(0,0,0,0.1)",this.color="#666",this.datasets={},this.devicePixelRatio=t=>t.chart.platform.getDevicePixelRatio(),this.elements={},this.events=["mousemove","mouseout","click","touchstart","touchmove"],this.font={family:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",size:12,style:"normal",lineHeight:1.2,weight:null},this.hover={},this.hoverBackgroundColor=(t,e)=>ys(e.backgroundColor),this.hoverBorderColor=(t,e)=>ys(e.borderColor),this.hoverColor=(t,e)=>ys(e.color),this.indexAxis="x",this.interaction={mode:"nearest",intersect:!0},this.maintainAspectRatio=!0,this.onHover=null,this.onClick=null,this.parsing=!0,this.plugins={},this.responsive=!0,this.scale=void 0,this.scales={},this.showLine=!0,this.drawActiveElementsOnTop=!0,this.describe(t)}set(t,e){return zs(this,t,e)}get(t){return As(this,t)}describe(t,e){return zs(ks,t,e)}override(t,e){return zs(Cs,t,e)}route(t,e,i,r){const n=As(this,t),o=As(this,i),a="_"+e;Object.defineProperties(n,{[a]:{value:n[e],writable:!0},[e]:{enumerable:!0,get(){const t=this[a],e=o[r];return Wo(t)?Object.assign({},e,t):Qo(t,e)},set(t){this[a]=t}}})}}({_scriptable:t=>!t.startsWith("on"),_indexable:t=>"events"!==t,hover:{_fallback:"interaction"},interaction:{_scriptable:!1,_indexable:!1}});function Ms(t,e,i,r,n){let o=e[n];return o||(o=e[n]=t.measureText(n).width,i.push(n)),o>r&&(r=o),r}function Ss(t,e,i,r){let n=(r=r||{}).data=r.data||{},o=r.garbageCollect=r.garbageCollect||[];r.font!==e&&(n=r.data={},o=r.garbageCollect=[],r.font=e),t.save(),t.font=e;let a=0;const s=i.length;let l,d,c,h,p;for(l=0;l<s;l++)if(h=i[l],null!=h&&!0!==Uo(h))a=Ms(t,n,o,a,h);else if(Uo(h))for(d=0,c=h.length;d<c;d++)p=h[d],null==p||Uo(p)||(a=Ms(t,n,o,a,p));t.restore();const u=o.length/2;if(u>i.length){for(l=0;l<u;l++)delete n[o[l]];o.splice(0,u)}return a}function Ls(t,e,i){const r=t.currentDevicePixelRatio,n=0!==i?Math.max(i/2,.5):0;return Math.round((e-n)*r)/r+n}function Hs(t,e){(e=e||t.getContext("2d")).save(),e.resetTransform(),e.clearRect(0,0,t.width,t.height),e.restore()}function Bs(t,e,i,r){let n,o,a,s,l;const d=e.pointStyle,c=e.rotation,h=e.radius;let p=(c||0)*ba;if(d&&"object"==typeof d&&(n=d.toString(),"[object HTMLImageElement]"===n||"[object HTMLCanvasElement]"===n))return t.save(),t.translate(i,r),t.rotate(p),t.drawImage(d,-d.width/2,-d.height/2,d.width,d.height),void t.restore();if(!(isNaN(h)||h<=0)){switch(t.beginPath(),d){default:t.arc(i,r,h,0,ga),t.closePath();break;case"triangle":t.moveTo(i+Math.sin(p)*h,r-Math.cos(p)*h),p+=xa,t.lineTo(i+Math.sin(p)*h,r-Math.cos(p)*h),p+=xa,t.lineTo(i+Math.sin(p)*h,r-Math.cos(p)*h),t.closePath();break;case"rectRounded":l=.516*h,s=h-l,o=Math.cos(p+wa)*s,a=Math.sin(p+wa)*s,t.arc(i-o,r-a,l,p-ua,p-va),t.arc(i+a,r-o,l,p-va,p),t.arc(i+o,r+a,l,p,p+va),t.arc(i-a,r+o,l,p+va,p+ua),t.closePath();break;case"rect":if(!c){s=Math.SQRT1_2*h,t.rect(i-s,r-s,2*s,2*s);break}p+=wa;case"rectRot":o=Math.cos(p)*h,a=Math.sin(p)*h,t.moveTo(i-o,r-a),t.lineTo(i+a,r-o),t.lineTo(i+o,r+a),t.lineTo(i-a,r+o),t.closePath();break;case"crossRot":p+=wa;case"cross":o=Math.cos(p)*h,a=Math.sin(p)*h,t.moveTo(i-o,r-a),t.lineTo(i+o,r+a),t.moveTo(i+a,r-o),t.lineTo(i-a,r+o);break;case"star":o=Math.cos(p)*h,a=Math.sin(p)*h,t.moveTo(i-o,r-a),t.lineTo(i+o,r+a),t.moveTo(i+a,r-o),t.lineTo(i-a,r+o),p+=wa,o=Math.cos(p)*h,a=Math.sin(p)*h,t.moveTo(i-o,r-a),t.lineTo(i+o,r+a),t.moveTo(i+a,r-o),t.lineTo(i-a,r+o);break;case"line":o=Math.cos(p)*h,a=Math.sin(p)*h,t.moveTo(i-o,r-a),t.lineTo(i+o,r+a);break;case"dash":t.moveTo(i,r),t.lineTo(i+Math.cos(p)*h,r+Math.sin(p)*h)}t.fill(),e.borderWidth>0&&t.stroke()}}function _s(t,e,i){return i=i||.5,!e||t&&t.x>e.left-i&&t.x<e.right+i&&t.y>e.top-i&&t.y<e.bottom+i}function Fs(t,e){t.save(),t.beginPath(),t.rect(e.left,e.top,e.right-e.left,e.bottom-e.top),t.clip()}function Ds(t){t.restore()}function Es(t,e,i,r,n){if(!e)return t.lineTo(i.x,i.y);if("middle"===n){const r=(e.x+i.x)/2;t.lineTo(r,e.y),t.lineTo(r,i.y)}else"after"===n!=!!r?t.lineTo(e.x,i.y):t.lineTo(i.x,e.y);t.lineTo(i.x,i.y)}function Vs(t,e,i,r){if(!e)return t.lineTo(i.x,i.y);t.bezierCurveTo(r?e.cp1x:e.cp2x,r?e.cp1y:e.cp2y,r?i.cp2x:i.cp1x,r?i.cp2y:i.cp1y,i.x,i.y)}function Os(t,e,i,r,n,o={}){const a=Uo(e)?e:[e],s=o.strokeWidth>0&&""!==o.strokeColor;let l,d;for(t.save(),t.font=n.string,function(t,e){e.translation&&t.translate(e.translation[0],e.translation[1]);Io(e.rotation)||t.rotate(e.rotation);e.color&&(t.fillStyle=e.color);e.textAlign&&(t.textAlign=e.textAlign);e.textBaseline&&(t.textBaseline=e.textBaseline)}(t,o),l=0;l<a.length;++l)d=a[l],s&&(o.strokeColor&&(t.strokeStyle=o.strokeColor),Io(o.strokeWidth)||(t.lineWidth=o.strokeWidth),t.strokeText(d,i,r,o.maxWidth)),t.fillText(d,i,r,o.maxWidth),js(t,i,r,d,o),r+=n.lineHeight;t.restore()}function js(t,e,i,r,n){if(n.strikethrough||n.underline){const o=t.measureText(r),a=e-o.actualBoundingBoxLeft,s=e+o.actualBoundingBoxRight,l=i-o.actualBoundingBoxAscent,d=i+o.actualBoundingBoxDescent,c=n.strikethrough?(l+d)/2:d;t.strokeStyle=t.fillStyle,t.beginPath(),t.lineWidth=n.decorationWidth||2,t.moveTo(a,c),t.lineTo(s,c),t.stroke()}}function Zs(t,e){const{x:i,y:r,w:n,h:o,radius:a}=e;t.arc(i+a.topLeft,r+a.topLeft,a.topLeft,-va,ua,!0),t.lineTo(i,r+o-a.bottomLeft),t.arc(i+a.bottomLeft,r+o-a.bottomLeft,a.bottomLeft,ua,va,!0),t.lineTo(i+n-a.bottomRight,r+o),t.arc(i+n-a.bottomRight,r+o-a.bottomRight,a.bottomRight,va,0,!0),t.lineTo(i+n,r+a.topRight),t.arc(i+n-a.topRight,r+a.topRight,a.topRight,0,-va,!0),t.lineTo(i+a.topLeft,r)}const Rs=new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/),Ts=new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);function Ns(t,e){const i=(""+t).match(Rs);if(!i||"normal"===i[1])return 1.2*e;switch(t=+i[2],i[3]){case"px":return t;case"%":t/=100}return e*t}const Ps=t=>+t||0;function Ys(t,e){const i={},r=Wo(e),n=r?Object.keys(e):e,o=Wo(t)?r?i=>Qo(t[i],t[e[i]]):e=>t[e]:()=>t;for(const t of n)i[t]=Ps(o(t));return i}function Is(t){return Ys(t,{top:"y",right:"x",bottom:"y",left:"x"})}function Us(t){return Ys(t,["topLeft","topRight","bottomLeft","bottomRight"])}function Ws(t){const e=Is(t);return e.width=e.left+e.right,e.height=e.top+e.bottom,e}function qs(t,e){t=t||{},e=e||$s.font;let i=Qo(t.size,e.size);"string"==typeof i&&(i=parseInt(i,10));let r=Qo(t.style,e.style);r&&!(""+r).match(Ts)&&(console.warn('Invalid font style specified: "'+r+'"'),r="");const n={family:Qo(t.family,e.family),lineHeight:Ns(Qo(t.lineHeight,e.lineHeight),i),size:i,style:r,weight:Qo(t.weight,e.weight),string:""};return n.string=function(t){return!t||Io(t.size)||Io(t.family)?null:(t.style?t.style+" ":"")+(t.weight?t.weight+" ":"")+t.size+"px "+t.family}(n),n}function Gs(t,e,i,r){let n,o,a,s=!0;for(n=0,o=t.length;n<o;++n)if(a=t[n],void 0!==a&&(void 0!==e&&"function"==typeof a&&(a=a(e),s=!1),void 0!==i&&Uo(a)&&(a=a[i%a.length],s=!1),void 0!==a))return r&&!s&&(r.cacheable=!1),a}function Qs(t,e){return Object.assign(Object.create(t),e)}function Xs(t,e,i){i=i||(i=>t[i]<e);let r,n=t.length-1,o=0;for(;n-o>1;)r=o+n>>1,i(r)?o=r:n=r;return{lo:o,hi:n}}const Ks=(t,e,i)=>Xs(t,i,(r=>t[r][e]<i)),Js=(t,e,i)=>Xs(t,i,(r=>t[r][e]>=i));const tl=["push","pop","shift","splice","unshift"];function el(t,e){const i=t._chartjs;if(!i)return;const r=i.listeners,n=r.indexOf(e);-1!==n&&r.splice(n,1),r.length>0||(tl.forEach((e=>{delete t[e]})),delete t._chartjs)}function il(t){const e=new Set;let i,r;for(i=0,r=t.length;i<r;++i)e.add(t[i]);return e.size===r?t:Array.from(e)}function rl(t,e=[""],i=t,r,n=(()=>t[0])){ca(r)||(r=gl("_fallback",t));const o={[Symbol.toStringTag]:"Object",_cacheable:!0,_scopes:t,_rootScopes:i,_fallback:r,_getTarget:n,override:n=>rl([n,...t],e,i,r)};return new Proxy(o,{deleteProperty:(e,i)=>(delete e[i],delete e._keys,delete t[0][i],!0),get:(i,r)=>ll(i,r,(()=>function(t,e,i,r){let n;for(const o of e)if(n=gl(al(o,t),i),ca(n))return sl(t,n)?pl(i,r,t,n):n}(r,e,t,i))),getOwnPropertyDescriptor:(t,e)=>Reflect.getOwnPropertyDescriptor(t._scopes[0],e),getPrototypeOf:()=>Reflect.getPrototypeOf(t[0]),has:(t,e)=>fl(t).includes(e),ownKeys:t=>fl(t),set(t,e,i){const r=t._storage||(t._storage=n());return t[e]=r[e]=i,delete t._keys,!0}})}function nl(t,e,i,r){const n={_cacheable:!1,_proxy:t,_context:e,_subProxy:i,_stack:new Set,_descriptors:ol(t,r),setContext:e=>nl(t,e,i,r),override:n=>nl(t.override(n),e,i,r)};return new Proxy(n,{deleteProperty:(e,i)=>(delete e[i],delete t[i],!0),get:(t,e,i)=>ll(t,e,(()=>function(t,e,i){const{_proxy:r,_context:n,_subProxy:o,_descriptors:a}=t;let s=r[e];ha(s)&&a.isScriptable(e)&&(s=function(t,e,i,r){const{_proxy:n,_context:o,_subProxy:a,_stack:s}=i;if(s.has(t))throw new Error("Recursion detected: "+Array.from(s).join("->")+"->"+t);s.add(t),e=e(o,a||r),s.delete(t),sl(t,e)&&(e=pl(n._scopes,n,t,e));return e}(e,s,t,i));Uo(s)&&s.length&&(s=function(t,e,i,r){const{_proxy:n,_context:o,_subProxy:a,_descriptors:s}=i;if(ca(o.index)&&r(t))e=e[o.index%e.length];else if(Wo(e[0])){const i=e,r=n._scopes.filter((t=>t!==i));e=[];for(const l of i){const i=pl(r,n,t,l);e.push(nl(i,o,a&&a[t],s))}}return e}(e,s,t,a.isIndexable));sl(e,s)&&(s=nl(s,n,o&&o[e],a));return s}(t,e,i))),getOwnPropertyDescriptor:(e,i)=>e._descriptors.allKeys?Reflect.has(t,i)?{enumerable:!0,configurable:!0}:void 0:Reflect.getOwnPropertyDescriptor(t,i),getPrototypeOf:()=>Reflect.getPrototypeOf(t),has:(e,i)=>Reflect.has(t,i),ownKeys:()=>Reflect.ownKeys(t),set:(e,i,r)=>(t[i]=r,delete e[i],!0)})}function ol(t,e={scriptable:!0,indexable:!0}){const{_scriptable:i=e.scriptable,_indexable:r=e.indexable,_allKeys:n=e.allKeys}=t;return{allKeys:n,scriptable:i,indexable:r,isScriptable:ha(i)?i:()=>i,isIndexable:ha(r)?r:()=>r}}const al=(t,e)=>t?t+da(e):e,sl=(t,e)=>Wo(e)&&"adapters"!==t&&(null===Object.getPrototypeOf(e)||e.constructor===Object);function ll(t,e,i){if(Object.prototype.hasOwnProperty.call(t,e))return t[e];const r=i();return t[e]=r,r}function dl(t,e,i){return ha(t)?t(e,i):t}const cl=(t,e)=>!0===t?e:"string"==typeof t?la(e,t):void 0;function hl(t,e,i,r,n){for(const o of e){const e=cl(i,o);if(e){t.add(e);const o=dl(e._fallback,i,n);if(ca(o)&&o!==i&&o!==r)return o}else if(!1===e&&ca(r)&&i!==r)return null}return!1}function pl(t,e,i,r){const n=e._rootScopes,o=dl(e._fallback,i,r),a=[...t,...n],s=new Set;s.add(r);let l=ul(s,a,i,o||i,r);return null!==l&&((!ca(o)||o===i||(l=ul(s,a,o,l,r),null!==l))&&rl(Array.from(s),[""],n,o,(()=>function(t,e,i){const r=t._getTarget();e in r||(r[e]={});const n=r[e];if(Uo(n)&&Wo(i))return i;return n}(e,i,r))))}function ul(t,e,i,r,n){for(;i;)i=hl(t,e,i,r,n);return i}function gl(t,e){for(const i of e){if(!i)continue;const e=i[t];if(ca(e))return e}}function fl(t){let e=t._keys;return e||(e=t._keys=function(t){const e=new Set;for(const i of t)for(const t of Object.keys(i).filter((t=>!t.startsWith("_"))))e.add(t);return Array.from(e)}(t._scopes)),e}const ml=Number.EPSILON||1e-14,bl=(t,e)=>e<t.length&&!t[e].skip&&t[e],vl=t=>"x"===t?"y":"x";function wl(t,e,i,r){const n=t.skip?e:t,o=e,a=i.skip?e:i,s=Ba(o,n),l=Ba(a,o);let d=s/(s+l),c=l/(s+l);d=isNaN(d)?0:d,c=isNaN(c)?0:c;const h=r*d,p=r*c;return{previous:{x:o.x-h*(a.x-n.x),y:o.y-h*(a.y-n.y)},next:{x:o.x+p*(a.x-n.x),y:o.y+p*(a.y-n.y)}}}function xl(t,e="x"){const i=vl(e),r=t.length,n=Array(r).fill(0),o=Array(r);let a,s,l,d=bl(t,0);for(a=0;a<r;++a)if(s=l,l=d,d=bl(t,a+1),l){if(d){const t=d[e]-l[e];n[a]=0!==t?(d[i]-l[i])/t:0}o[a]=s?d?Ca(n[a-1])!==Ca(n[a])?0:(n[a-1]+n[a])/2:n[a-1]:n[a]}!function(t,e,i){const r=t.length;let n,o,a,s,l,d=bl(t,0);for(let c=0;c<r-1;++c)l=d,d=bl(t,c+1),l&&d&&(za(e[c],0,ml)?i[c]=i[c+1]=0:(n=i[c]/e[c],o=i[c+1]/e[c],s=Math.pow(n,2)+Math.pow(o,2),s<=9||(a=3/Math.sqrt(s),i[c]=n*a*e[c],i[c+1]=o*a*e[c])))}(t,n,o),function(t,e,i="x"){const r=vl(i),n=t.length;let o,a,s,l=bl(t,0);for(let d=0;d<n;++d){if(a=s,s=l,l=bl(t,d+1),!s)continue;const n=s[i],c=s[r];a&&(o=(n-a[i])/3,s[`cp1${i}`]=n-o,s[`cp1${r}`]=c-o*e[d]),l&&(o=(l[i]-n)/3,s[`cp2${i}`]=n+o,s[`cp2${r}`]=c+o*e[d])}}(t,o,e)}function yl(t,e,i){return Math.max(Math.min(t,i),e)}function Cl(t,e,i,r,n){let o,a,s,l;if(e.spanGaps&&(t=t.filter((t=>!t.skip))),"monotone"===e.cubicInterpolationMode)xl(t,n);else{let i=r?t[t.length-1]:t[0];for(o=0,a=t.length;o<a;++o)s=t[o],l=wl(i,s,t[Math.min(o+1,a-(r?0:1))%a],e.tension),s.cp1x=l.previous.x,s.cp1y=l.previous.y,s.cp2x=l.next.x,s.cp2y=l.next.y,i=s}e.capBezierPoints&&function(t,e){let i,r,n,o,a,s=_s(t[0],e);for(i=0,r=t.length;i<r;++i)a=o,o=s,s=i<r-1&&_s(t[i+1],e),o&&(n=t[i],a&&(n.cp1x=yl(n.cp1x,e.left,e.right),n.cp1y=yl(n.cp1y,e.top,e.bottom)),s&&(n.cp2x=yl(n.cp2x,e.left,e.right),n.cp2y=yl(n.cp2y,e.top,e.bottom)))}(t,i)}function kl(){return"undefined"!=typeof window&&"undefined"!=typeof document}function Al(t){let e=t.parentNode;return e&&"[object ShadowRoot]"===e.toString()&&(e=e.host),e}function zl(t,e,i){let r;return"string"==typeof t?(r=parseInt(t,10),-1!==t.indexOf("%")&&(r=r/100*e.parentNode[i])):r=t,r}const $l=t=>window.getComputedStyle(t,null);const Ml=["top","right","bottom","left"];function Sl(t,e,i){const r={};i=i?"-"+i:"";for(let n=0;n<4;n++){const o=Ml[n];r[o]=parseFloat(t[e+"-"+o+i])||0}return r.width=r.left+r.right,r.height=r.top+r.bottom,r}function Ll(t,e){const{canvas:i,currentDevicePixelRatio:r}=e,n=$l(i),o="border-box"===n.boxSizing,a=Sl(n,"padding"),s=Sl(n,"border","width"),{x:l,y:d,box:c}=function(t,e){const i=t.native||t,r=i.touches,n=r&&r.length?r[0]:i,{offsetX:o,offsetY:a}=n;let s,l,d=!1;if(((t,e,i)=>(t>0||e>0)&&(!i||!i.shadowRoot))(o,a,i.target))s=o,l=a;else{const t=e.getBoundingClientRect();s=n.clientX-t.left,l=n.clientY-t.top,d=!0}return{x:s,y:l,box:d}}(t,i),h=a.left+(c&&s.left),p=a.top+(c&&s.top);let{width:u,height:g}=e;return o&&(u-=a.width+s.width,g-=a.height+s.height),{x:Math.round((l-h)/u*i.width/r),y:Math.round((d-p)/g*i.height/r)}}const Hl=t=>Math.round(10*t)/10;function Bl(t,e,i,r){const n=$l(t),o=Sl(n,"margin"),a=zl(n.maxWidth,t,"clientWidth")||ma,s=zl(n.maxHeight,t,"clientHeight")||ma,l=function(t,e,i){let r,n;if(void 0===e||void 0===i){const o=Al(t);if(o){const t=o.getBoundingClientRect(),a=$l(o),s=Sl(a,"border","width"),l=Sl(a,"padding");e=t.width-l.width-s.width,i=t.height-l.height-s.height,r=zl(a.maxWidth,o,"clientWidth"),n=zl(a.maxHeight,o,"clientHeight")}else e=t.clientWidth,i=t.clientHeight}return{width:e,height:i,maxWidth:r||ma,maxHeight:n||ma}}(t,e,i);let{width:d,height:c}=l;if("content-box"===n.boxSizing){const t=Sl(n,"border","width"),e=Sl(n,"padding");d-=e.width+t.width,c-=e.height+t.height}return d=Math.max(0,d-o.width),c=Math.max(0,r?Math.floor(d/r):c-o.height),d=Hl(Math.min(d,a,l.maxWidth)),c=Hl(Math.min(c,s,l.maxHeight)),d&&!c&&(c=Hl(d/2)),{width:d,height:c}}function _l(t,e,i){const r=e||1,n=Math.floor(t.height*r),o=Math.floor(t.width*r);t.height=n/r,t.width=o/r;const a=t.canvas;return a.style&&(i||!a.style.height&&!a.style.width)&&(a.style.height=`${t.height}px`,a.style.width=`${t.width}px`),(t.currentDevicePixelRatio!==r||a.height!==n||a.width!==o)&&(t.currentDevicePixelRatio=r,a.height=n,a.width=o,t.ctx.setTransform(r,0,0,r,0,0),!0)}const Fl=function(){let t=!1;try{const e={get passive(){return t=!0,!1}};window.addEventListener("test",null,e),window.removeEventListener("test",null,e)}catch(t){}return t}();function Dl(t,e){const i=function(t,e){return $l(t).getPropertyValue(e)}(t,e),r=i&&i.match(/^(\d+)(\.\d+)?px$/);return r?+r[1]:void 0}function El(t,e,i,r){return{x:t.x+i*(e.x-t.x),y:t.y+i*(e.y-t.y)}}function Vl(t,e,i,r){return{x:t.x+i*(e.x-t.x),y:"middle"===r?i<.5?t.y:e.y:"after"===r?i<1?t.y:e.y:i>0?e.y:t.y}}function Ol(t,e,i,r){const n={x:t.cp2x,y:t.cp2y},o={x:e.cp1x,y:e.cp1y},a=El(t,n,i),s=El(n,o,i),l=El(o,e,i),d=El(a,s,i),c=El(s,l,i);return El(d,c,i)}const jl=new Map;function Zl(t,e,i){return function(t,e){e=e||{};const i=t+JSON.stringify(e);let r=jl.get(i);return r||(r=new Intl.NumberFormat(t,e),jl.set(i,r)),r}(e,i).format(t)}function Rl(t,e,i){return t?function(t,e){return{x:i=>t+t+e-i,setWidth(t){e=t},textAlign:t=>"center"===t?t:"right"===t?"left":"right",xPlus:(t,e)=>t-e,leftForLtr:(t,e)=>t-e}}(e,i):{x:t=>t,setWidth(t){},textAlign:t=>t,xPlus:(t,e)=>t+e,leftForLtr:(t,e)=>t}}function Tl(t,e){let i,r;"ltr"!==e&&"rtl"!==e||(i=t.canvas.style,r=[i.getPropertyValue("direction"),i.getPropertyPriority("direction")],i.setProperty("direction",e,"important"),t.prevTextDirection=r)}function Nl(t,e){void 0!==e&&(delete t.prevTextDirection,t.canvas.style.setProperty("direction",e[0],e[1]))}function Pl(t){return"angle"===t?{between:Da,compare:_a,normalize:Fa}:{between:Va,compare:(t,e)=>t-e,normalize:t=>t}}function Yl({start:t,end:e,count:i,loop:r,style:n}){return{start:t%i,end:e%i,loop:r&&(e-t+1)%i==0,style:n}}function Il(t,e,i){if(!i)return[t];const{property:r,start:n,end:o}=i,a=e.length,{compare:s,between:l,normalize:d}=Pl(r),{start:c,end:h,loop:p,style:u}=function(t,e,i){const{property:r,start:n,end:o}=i,{between:a,normalize:s}=Pl(r),l=e.length;let d,c,{start:h,end:p,loop:u}=t;if(u){for(h+=l,p+=l,d=0,c=l;d<c&&a(s(e[h%l][r]),n,o);++d)h--,p--;h%=l,p%=l}return p<h&&(p+=l),{start:h,end:p,loop:u,style:t.style}}(t,e,i),g=[];let f,m,b,v=!1,w=null;const x=()=>v||l(n,b,f)&&0!==s(n,b),y=()=>!v||0===s(o,f)||l(o,b,f);for(let t=c,i=c;t<=h;++t)m=e[t%a],m.skip||(f=d(m[r]),f!==b&&(v=l(f,n,o),null===w&&x()&&(w=0===s(f,n)?t:i),null!==w&&y()&&(g.push(Yl({start:w,end:t,loop:p,count:a,style:u})),w=null),i=t,b=f));return null!==w&&g.push(Yl({start:w,end:h,loop:p,count:a,style:u})),g}function Ul(t,e){const i=[],r=t.segments;for(let n=0;n<r.length;n++){const o=Il(r[n],t.points,e);o.length&&i.push(...o)}return i}function Wl(t,e,i,r){return r&&r.setContext&&i?function(t,e,i,r){const n=t._chart.getContext(),o=ql(t.options),{_datasetIndex:a,options:{spanGaps:s}}=t,l=i.length,d=[];let c=o,h=e[0].start,p=h;function u(t,e,r,n){const o=s?-1:1;if(t!==e){for(t+=l;i[t%l].skip;)t-=o;for(;i[e%l].skip;)e+=o;t%l!=e%l&&(d.push({start:t%l,end:e%l,loop:r,style:n}),c=n,h=e%l)}}for(const t of e){h=s?h:t.start;let e,o=i[h%l];for(p=h+1;p<=t.end;p++){const s=i[p%l];e=ql(r.setContext(Qs(n,{type:"segment",p0:o,p1:s,p0DataIndex:(p-1)%l,p1DataIndex:p%l,datasetIndex:a}))),Gl(e,c)&&u(h,p-1,t.loop,c),o=s,c=e}h<p-1&&u(h,p-1,t.loop,c)}return d}(t,e,i,r):e}function ql(t){return{backgroundColor:t.backgroundColor,borderCapStyle:t.borderCapStyle,borderDash:t.borderDash,borderDashOffset:t.borderDashOffset,borderJoinStyle:t.borderJoinStyle,borderWidth:t.borderWidth,borderColor:t.borderColor}}function Gl(t,e){return e&&JSON.stringify(t)!==JSON.stringify(e)}
/*!
 * Chart.js v3.7.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */var Ql=new class{constructor(){this._request=null,this._charts=new Map,this._running=!1,this._lastDate=void 0}_notify(t,e,i,r){const n=e.listeners[r],o=e.duration;n.forEach((r=>r({chart:t,initial:e.initial,numSteps:o,currentStep:Math.min(i-e.start,o)})))}_refresh(){this._request||(this._running=!0,this._request=Zo.call(window,(()=>{this._update(),this._request=null,this._running&&this._refresh()})))}_update(t=Date.now()){let e=0;this._charts.forEach(((i,r)=>{if(!i.running||!i.items.length)return;const n=i.items;let o,a=n.length-1,s=!1;for(;a>=0;--a)o=n[a],o._active?(o._total>i.duration&&(i.duration=o._total),o.tick(t),s=!0):(n[a]=n[n.length-1],n.pop());s&&(r.draw(),this._notify(r,i,t,"progress")),n.length||(i.running=!1,this._notify(r,i,t,"complete"),i.initial=!1),e+=n.length})),this._lastDate=t,0===e&&(this._running=!1)}_getAnims(t){const e=this._charts;let i=e.get(t);return i||(i={running:!1,initial:!0,items:[],listeners:{complete:[],progress:[]}},e.set(t,i)),i}listen(t,e,i){this._getAnims(t).listeners[e].push(i)}add(t,e){e&&e.length&&this._getAnims(t).items.push(...e)}has(t){return this._getAnims(t).items.length>0}start(t){const e=this._charts.get(t);e&&(e.running=!0,e.start=Date.now(),e.duration=e.items.reduce(((t,e)=>Math.max(t,e._duration)),0),this._refresh())}running(t){if(!this._running)return!1;const e=this._charts.get(t);return!!(e&&e.running&&e.items.length)}stop(t){const e=this._charts.get(t);if(!e||!e.items.length)return;const i=e.items;let r=i.length-1;for(;r>=0;--r)i[r].cancel();e.items=[],this._notify(t,e,Date.now(),"complete")}remove(t){return this._charts.delete(t)}};const Xl={boolean:(t,e,i)=>i>.5?e:t,color(t,e,i){const r=xs(t||"transparent"),n=r.valid&&xs(e||"transparent");return n&&n.valid?n.mix(r,i).hexString():e},number:(t,e,i)=>t+(e-t)*i};class Kl{constructor(t,e,i,r){const n=e[i];r=Gs([t.to,r,n,t.from]);const o=Gs([t.from,n,r]);this._active=!0,this._fn=t.fn||Xl[t.type||typeof o],this._easing=Ra[t.easing]||Ra.linear,this._start=Math.floor(Date.now()+(t.delay||0)),this._duration=this._total=Math.floor(t.duration),this._loop=!!t.loop,this._target=e,this._prop=i,this._from=o,this._to=r,this._promises=void 0}active(){return this._active}update(t,e,i){if(this._active){this._notify(!1);const r=this._target[this._prop],n=i-this._start,o=this._duration-n;this._start=i,this._duration=Math.floor(Math.max(o,t.duration)),this._total+=n,this._loop=!!t.loop,this._to=Gs([t.to,e,r,t.from]),this._from=Gs([t.from,r,e])}}cancel(){this._active&&(this.tick(Date.now()),this._active=!1,this._notify(!1))}tick(t){const e=t-this._start,i=this._duration,r=this._prop,n=this._from,o=this._loop,a=this._to;let s;if(this._active=n!==a&&(o||e<i),!this._active)return this._target[r]=a,void this._notify(!0);e<0?this._target[r]=n:(s=e/i%2,s=o&&s>1?2-s:s,s=this._easing(Math.min(1,Math.max(0,s))),this._target[r]=this._fn(n,a,s))}wait(){const t=this._promises||(this._promises=[]);return new Promise(((e,i)=>{t.push({res:e,rej:i})}))}_notify(t){const e=t?"res":"rej",i=this._promises||[];for(let t=0;t<i.length;t++)i[t][e]()}}$s.set("animation",{delay:void 0,duration:1e3,easing:"easeOutQuart",fn:void 0,from:void 0,loop:void 0,to:void 0,type:void 0});const Jl=Object.keys($s.animation);$s.describe("animation",{_fallback:!1,_indexable:!1,_scriptable:t=>"onProgress"!==t&&"onComplete"!==t&&"fn"!==t}),$s.set("animations",{colors:{type:"color",properties:["color","borderColor","backgroundColor"]},numbers:{type:"number",properties:["x","y","borderWidth","radius","tension"]}}),$s.describe("animations",{_fallback:"animation"}),$s.set("transitions",{active:{animation:{duration:400}},resize:{animation:{duration:0}},show:{animations:{colors:{from:"transparent"},visible:{type:"boolean",duration:0}}},hide:{animations:{colors:{to:"transparent"},visible:{type:"boolean",easing:"linear",fn:t=>0|t}}}});class td{constructor(t,e){this._chart=t,this._properties=new Map,this.configure(e)}configure(t){if(!Wo(t))return;const e=this._properties;Object.getOwnPropertyNames(t).forEach((i=>{const r=t[i];if(!Wo(r))return;const n={};for(const t of Jl)n[t]=r[t];(Uo(r.properties)&&r.properties||[i]).forEach((t=>{t!==i&&e.has(t)||e.set(t,n)}))}))}_animateOptions(t,e){const i=e.options,r=function(t,e){if(!e)return;let i=t.options;if(!i)return void(t.options=e);i.$shared&&(t.options=i=Object.assign({},i,{$shared:!1,$animations:{}}));return i}(t,i);if(!r)return[];const n=this._createAnimations(r,i);return i.$shared&&function(t,e){const i=[],r=Object.keys(e);for(let e=0;e<r.length;e++){const n=t[r[e]];n&&n.active()&&i.push(n.wait())}return Promise.all(i)}(t.options.$animations,i).then((()=>{t.options=i}),(()=>{})),n}_createAnimations(t,e){const i=this._properties,r=[],n=t.$animations||(t.$animations={}),o=Object.keys(e),a=Date.now();let s;for(s=o.length-1;s>=0;--s){const l=o[s];if("$"===l.charAt(0))continue;if("options"===l){r.push(...this._animateOptions(t,e));continue}const d=e[l];let c=n[l];const h=i.get(l);if(c){if(h&&c.active()){c.update(h,d,a);continue}c.cancel()}h&&h.duration?(n[l]=c=new Kl(h,t,l,d),r.push(c)):t[l]=d}return r}update(t,e){if(0===this._properties.size)return void Object.assign(t,e);const i=this._createAnimations(t,e);return i.length?(Ql.add(this._chart,i),!0):void 0}}function ed(t,e){const i=t&&t.options||{},r=i.reverse,n=void 0===i.min?e:0,o=void 0===i.max?e:0;return{start:r?o:n,end:r?n:o}}function id(t,e){const i=[],r=t._getSortedDatasetMetas(e);let n,o;for(n=0,o=r.length;n<o;++n)i.push(r[n].index);return i}function rd(t,e,i,r={}){const n=t.keys,o="single"===r.mode;let a,s,l,d;if(null!==e){for(a=0,s=n.length;a<s;++a){if(l=+n[a],l===i){if(r.all)continue;break}d=t.values[l],qo(d)&&(o||0===e||Ca(e)===Ca(d))&&(e+=d)}return e}}function nd(t,e){const i=t&&t.options.stacked;return i||void 0===i&&void 0!==e.stack}function od(t,e,i){const r=t[e]||(t[e]={});return r[i]||(r[i]={})}function ad(t,e,i,r){for(const n of e.getMatchingVisibleMetas(r).reverse()){const e=t[n.index];if(i&&e>0||!i&&e<0)return n.index}return null}function sd(t,e){const{chart:i,_cachedMeta:r}=t,n=i._stacks||(i._stacks={}),{iScale:o,vScale:a,index:s}=r,l=o.axis,d=a.axis,c=function(t,e,i){return`${t.id}.${e.id}.${i.stack||i.type}`}(o,a,r),h=e.length;let p;for(let t=0;t<h;++t){const i=e[t],{[l]:o,[d]:h}=i;p=(i._stacks||(i._stacks={}))[d]=od(n,c,o),p[s]=h,p._top=ad(p,a,!0,r.type),p._bottom=ad(p,a,!1,r.type)}}function ld(t,e){const i=t.scales;return Object.keys(i).filter((t=>i[t].axis===e)).shift()}function dd(t,e){const i=t.controller.index,r=t.vScale&&t.vScale.axis;if(r){e=e||t._parsed;for(const t of e){const e=t._stacks;if(!e||void 0===e[r]||void 0===e[r][i])return;delete e[r][i]}}}const cd=t=>"reset"===t||"none"===t,hd=(t,e)=>e?t:Object.assign({},t);class pd{constructor(t,e){this.chart=t,this._ctx=t.ctx,this.index=e,this._cachedDataOpts={},this._cachedMeta=this.getMeta(),this._type=this._cachedMeta.type,this.options=void 0,this._parsing=!1,this._data=void 0,this._objectData=void 0,this._sharedOptions=void 0,this._drawStart=void 0,this._drawCount=void 0,this.enableOptionSharing=!1,this.$context=void 0,this._syncList=[],this.initialize()}initialize(){const t=this._cachedMeta;this.configure(),this.linkScales(),t._stacked=nd(t.vScale,t),this.addElements()}updateIndex(t){this.index!==t&&dd(this._cachedMeta),this.index=t}linkScales(){const t=this.chart,e=this._cachedMeta,i=this.getDataset(),r=(t,e,i,r)=>"x"===t?e:"r"===t?r:i,n=e.xAxisID=Qo(i.xAxisID,ld(t,"x")),o=e.yAxisID=Qo(i.yAxisID,ld(t,"y")),a=e.rAxisID=Qo(i.rAxisID,ld(t,"r")),s=e.indexAxis,l=e.iAxisID=r(s,n,o,a),d=e.vAxisID=r(s,o,n,a);e.xScale=this.getScaleForId(n),e.yScale=this.getScaleForId(o),e.rScale=this.getScaleForId(a),e.iScale=this.getScaleForId(l),e.vScale=this.getScaleForId(d)}getDataset(){return this.chart.data.datasets[this.index]}getMeta(){return this.chart.getDatasetMeta(this.index)}getScaleForId(t){return this.chart.scales[t]}_getOtherScale(t){const e=this._cachedMeta;return t===e.iScale?e.vScale:e.iScale}reset(){this._update("reset")}_destroy(){const t=this._cachedMeta;this._data&&el(this._data,this),t._stacked&&dd(t)}_dataCheck(){const t=this.getDataset(),e=t.data||(t.data=[]),i=this._data;if(Wo(e))this._data=function(t){const e=Object.keys(t),i=new Array(e.length);let r,n,o;for(r=0,n=e.length;r<n;++r)o=e[r],i[r]={x:o,y:t[o]};return i}(e);else if(i!==e){if(i){el(i,this);const t=this._cachedMeta;dd(t),t._parsed=[]}e&&Object.isExtensible(e)&&(n=this,(r=e)._chartjs?r._chartjs.listeners.push(n):(Object.defineProperty(r,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[n]}}),tl.forEach((t=>{const e="_onData"+da(t),i=r[t];Object.defineProperty(r,t,{configurable:!0,enumerable:!1,value(...t){const n=i.apply(this,t);return r._chartjs.listeners.forEach((i=>{"function"==typeof i[e]&&i[e](...t)})),n}})})))),this._syncList=[],this._data=e}var r,n}addElements(){const t=this._cachedMeta;this._dataCheck(),this.datasetElementType&&(t.dataset=new this.datasetElementType)}buildOrUpdateElements(t){const e=this._cachedMeta,i=this.getDataset();let r=!1;this._dataCheck();const n=e._stacked;e._stacked=nd(e.vScale,e),e.stack!==i.stack&&(r=!0,dd(e),e.stack=i.stack),this._resyncElements(t),(r||n!==e._stacked)&&sd(this,e._parsed)}configure(){const t=this.chart.config,e=t.datasetScopeKeys(this._type),i=t.getOptionScopes(this.getDataset(),e,!0);this.options=t.createResolver(i,this.getContext()),this._parsing=this.options.parsing,this._cachedDataOpts={}}parse(t,e){const{_cachedMeta:i,_data:r}=this,{iScale:n,_stacked:o}=i,a=n.axis;let s,l,d,c=0===t&&e===r.length||i._sorted,h=t>0&&i._parsed[t-1];if(!1===this._parsing)i._parsed=r,i._sorted=!0,d=r;else{d=Uo(r[t])?this.parseArrayData(i,r,t,e):Wo(r[t])?this.parseObjectData(i,r,t,e):this.parsePrimitiveData(i,r,t,e);const n=()=>null===l[a]||h&&l[a]<h[a];for(s=0;s<e;++s)i._parsed[s+t]=l=d[s],c&&(n()&&(c=!1),h=l);i._sorted=c}o&&sd(this,d)}parsePrimitiveData(t,e,i,r){const{iScale:n,vScale:o}=t,a=n.axis,s=o.axis,l=n.getLabels(),d=n===o,c=new Array(r);let h,p,u;for(h=0,p=r;h<p;++h)u=h+i,c[h]={[a]:d||n.parse(l[u],u),[s]:o.parse(e[u],u)};return c}parseArrayData(t,e,i,r){const{xScale:n,yScale:o}=t,a=new Array(r);let s,l,d,c;for(s=0,l=r;s<l;++s)d=s+i,c=e[d],a[s]={x:n.parse(c[0],d),y:o.parse(c[1],d)};return a}parseObjectData(t,e,i,r){const{xScale:n,yScale:o}=t,{xAxisKey:a="x",yAxisKey:s="y"}=this._parsing,l=new Array(r);let d,c,h,p;for(d=0,c=r;d<c;++d)h=d+i,p=e[h],l[d]={x:n.parse(la(p,a),h),y:o.parse(la(p,s),h)};return l}getParsed(t){return this._cachedMeta._parsed[t]}getDataElement(t){return this._cachedMeta.data[t]}applyStack(t,e,i){const r=this.chart,n=this._cachedMeta,o=e[t.axis];return rd({keys:id(r,!0),values:e._stacks[t.axis]},o,n.index,{mode:i})}updateRangeFromParsed(t,e,i,r){const n=i[e.axis];let o=null===n?NaN:n;const a=r&&i._stacks[e.axis];r&&a&&(r.values=a,o=rd(r,n,this._cachedMeta.index)),t.min=Math.min(t.min,o),t.max=Math.max(t.max,o)}getMinMax(t,e){const i=this._cachedMeta,r=i._parsed,n=i._sorted&&t===i.iScale,o=r.length,a=this._getOtherScale(t),s=((t,e,i)=>t&&!e.hidden&&e._stacked&&{keys:id(i,!0),values:null})(e,i,this.chart),l={min:Number.POSITIVE_INFINITY,max:Number.NEGATIVE_INFINITY},{min:d,max:c}=function(t){const{min:e,max:i,minDefined:r,maxDefined:n}=t.getUserBounds();return{min:r?e:Number.NEGATIVE_INFINITY,max:n?i:Number.POSITIVE_INFINITY}}(a);let h,p;function u(){p=r[h];const e=p[a.axis];return!qo(p[t.axis])||d>e||c<e}for(h=0;h<o&&(u()||(this.updateRangeFromParsed(l,t,p,s),!n));++h);if(n)for(h=o-1;h>=0;--h)if(!u()){this.updateRangeFromParsed(l,t,p,s);break}return l}getAllParsedValues(t){const e=this._cachedMeta._parsed,i=[];let r,n,o;for(r=0,n=e.length;r<n;++r)o=e[r][t.axis],qo(o)&&i.push(o);return i}getMaxOverflow(){return!1}getLabelAndValue(t){const e=this._cachedMeta,i=e.iScale,r=e.vScale,n=this.getParsed(t);return{label:i?""+i.getLabelForValue(n[i.axis]):"",value:r?""+r.getLabelForValue(n[r.axis]):""}}_update(t){const e=this._cachedMeta;this.update(t||"default"),e._clip=function(t){let e,i,r,n;return Wo(t)?(e=t.top,i=t.right,r=t.bottom,n=t.left):e=i=r=n=t,{top:e,right:i,bottom:r,left:n,disabled:!1===t}}(Qo(this.options.clip,function(t,e,i){if(!1===i)return!1;const r=ed(t,i),n=ed(e,i);return{top:n.end,right:r.end,bottom:n.start,left:r.start}}(e.xScale,e.yScale,this.getMaxOverflow())))}update(t){}draw(){const t=this._ctx,e=this.chart,i=this._cachedMeta,r=i.data||[],n=e.chartArea,o=[],a=this._drawStart||0,s=this._drawCount||r.length-a,l=this.options.drawActiveElementsOnTop;let d;for(i.dataset&&i.dataset.draw(t,n,a,s),d=a;d<a+s;++d){const e=r[d];e.hidden||(e.active&&l?o.push(e):e.draw(t,n))}for(d=0;d<o.length;++d)o[d].draw(t,n)}getStyle(t,e){const i=e?"active":"default";return void 0===t&&this._cachedMeta.dataset?this.resolveDatasetElementOptions(i):this.resolveDataElementOptions(t||0,i)}getContext(t,e,i){const r=this.getDataset();let n;if(t>=0&&t<this._cachedMeta.data.length){const e=this._cachedMeta.data[t];n=e.$context||(e.$context=function(t,e,i){return Qs(t,{active:!1,dataIndex:e,parsed:void 0,raw:void 0,element:i,index:e,mode:"default",type:"data"})}(this.getContext(),t,e)),n.parsed=this.getParsed(t),n.raw=r.data[t],n.index=n.dataIndex=t}else n=this.$context||(this.$context=function(t,e){return Qs(t,{active:!1,dataset:void 0,datasetIndex:e,index:e,mode:"default",type:"dataset"})}(this.chart.getContext(),this.index)),n.dataset=r,n.index=n.datasetIndex=this.index;return n.active=!!e,n.mode=i,n}resolveDatasetElementOptions(t){return this._resolveElementOptions(this.datasetElementType.id,t)}resolveDataElementOptions(t,e){return this._resolveElementOptions(this.dataElementType.id,e,t)}_resolveElementOptions(t,e="default",i){const r="active"===e,n=this._cachedDataOpts,o=t+"-"+e,a=n[o],s=this.enableOptionSharing&&ca(i);if(a)return hd(a,s);const l=this.chart.config,d=l.datasetElementScopeKeys(this._type,t),c=r?[`${t}Hover`,"hover",t,""]:[t,""],h=l.getOptionScopes(this.getDataset(),d),p=Object.keys($s.elements[t]),u=l.resolveNamedOptions(h,p,(()=>this.getContext(i,r)),c);return u.$shared&&(u.$shared=s,n[o]=Object.freeze(hd(u,s))),u}_resolveAnimations(t,e,i){const r=this.chart,n=this._cachedDataOpts,o=`animation-${e}`,a=n[o];if(a)return a;let s;if(!1!==r.options.animation){const r=this.chart.config,n=r.datasetAnimationScopeKeys(this._type,e),o=r.getOptionScopes(this.getDataset(),n);s=r.createResolver(o,this.getContext(t,i,e))}const l=new td(r,s&&s.animations);return s&&s._cacheable&&(n[o]=Object.freeze(l)),l}getSharedOptions(t){if(t.$shared)return this._sharedOptions||(this._sharedOptions=Object.assign({},t))}includeOptions(t,e){return!e||cd(t)||this.chart._animationsDisabled}updateElement(t,e,i,r){cd(r)?Object.assign(t,i):this._resolveAnimations(e,r).update(t,i)}updateSharedOptions(t,e,i){t&&!cd(e)&&this._resolveAnimations(void 0,e).update(t,i)}_setStyle(t,e,i,r){t.active=r;const n=this.getStyle(e,r);this._resolveAnimations(e,i,r).update(t,{options:!r&&this.getSharedOptions(n)||n})}removeHoverStyle(t,e,i){this._setStyle(t,i,"active",!1)}setHoverStyle(t,e,i){this._setStyle(t,i,"active",!0)}_removeDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!1)}_setDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!0)}_resyncElements(t){const e=this._data,i=this._cachedMeta.data;for(const[t,e,i]of this._syncList)this[t](e,i);this._syncList=[];const r=i.length,n=e.length,o=Math.min(n,r);o&&this.parse(0,o),n>r?this._insertElements(r,n-r,t):n<r&&this._removeElements(n,r-n)}_insertElements(t,e,i=!0){const r=this._cachedMeta,n=r.data,o=t+e;let a;const s=t=>{for(t.length+=e,a=t.length-1;a>=o;a--)t[a]=t[a-e]};for(s(n),a=t;a<o;++a)n[a]=new this.dataElementType;this._parsing&&s(r._parsed),this.parse(t,e),i&&this.updateElements(n,t,e,"reset")}updateElements(t,e,i,r){}_removeElements(t,e){const i=this._cachedMeta;if(this._parsing){const r=i._parsed.splice(t,e);i._stacked&&dd(i,r)}i.data.splice(t,e)}_sync(t){if(this._parsing)this._syncList.push(t);else{const[e,i,r]=t;this[e](i,r)}this.chart._dataChanges.push([this.index,...t])}_onDataPush(){const t=arguments.length;this._sync(["_insertElements",this.getDataset().data.length-t,t])}_onDataPop(){this._sync(["_removeElements",this._cachedMeta.data.length-1,1])}_onDataShift(){this._sync(["_removeElements",0,1])}_onDataSplice(t,e){e&&this._sync(["_removeElements",t,e]);const i=arguments.length-2;i&&this._sync(["_insertElements",t,i])}_onDataUnshift(){this._sync(["_insertElements",0,arguments.length])}}function ud(t){const e=t.iScale,i=function(t,e){if(!t._cache.$bar){const i=t.getMatchingVisibleMetas(e);let r=[];for(let e=0,n=i.length;e<n;e++)r=r.concat(i[e].controller.getAllParsedValues(t));t._cache.$bar=il(r.sort(((t,e)=>t-e)))}return t._cache.$bar}(e,t.type);let r,n,o,a,s=e._length;const l=()=>{32767!==o&&-32768!==o&&(ca(a)&&(s=Math.min(s,Math.abs(o-a)||s)),a=o)};for(r=0,n=i.length;r<n;++r)o=e.getPixelForValue(i[r]),l();for(a=void 0,r=0,n=e.ticks.length;r<n;++r)o=e.getPixelForTick(r),l();return s}function gd(t,e,i,r){return Uo(t)?function(t,e,i,r){const n=i.parse(t[0],r),o=i.parse(t[1],r),a=Math.min(n,o),s=Math.max(n,o);let l=a,d=s;Math.abs(a)>Math.abs(s)&&(l=s,d=a),e[i.axis]=d,e._custom={barStart:l,barEnd:d,start:n,end:o,min:a,max:s}}(t,e,i,r):e[i.axis]=i.parse(t,r),e}function fd(t,e,i,r){const n=t.iScale,o=t.vScale,a=n.getLabels(),s=n===o,l=[];let d,c,h,p;for(d=i,c=i+r;d<c;++d)p=e[d],h={},h[n.axis]=s||n.parse(a[d],d),l.push(gd(p,h,o,d));return l}function md(t){return t&&void 0!==t.barStart&&void 0!==t.barEnd}function bd(t,e,i,r){let n=e.borderSkipped;const o={};if(!n)return void(t.borderSkipped=o);const{start:a,end:s,reverse:l,top:d,bottom:c}=function(t){let e,i,r,n,o;return t.horizontal?(e=t.base>t.x,i="left",r="right"):(e=t.base<t.y,i="bottom",r="top"),e?(n="end",o="start"):(n="start",o="end"),{start:i,end:r,reverse:e,top:n,bottom:o}}(t);"middle"===n&&i&&(t.enableBorderRadius=!0,(i._top||0)===r?n=d:(i._bottom||0)===r?n=c:(o[vd(c,a,s,l)]=!0,n=d)),o[vd(n,a,s,l)]=!0,t.borderSkipped=o}function vd(t,e,i,r){var n,o,a;return r?(a=i,t=wd(t=(n=t)===(o=e)?a:n===a?o:n,i,e)):t=wd(t,e,i),t}function wd(t,e,i){return"start"===t?e:"end"===t?i:t}function xd(t,{inflateAmount:e},i){t.inflateAmount="auto"===e?1===i?.33:0:e}pd.defaults={},pd.prototype.datasetElementType=null,pd.prototype.dataElementType=null;class yd extends pd{parsePrimitiveData(t,e,i,r){return fd(t,e,i,r)}parseArrayData(t,e,i,r){return fd(t,e,i,r)}parseObjectData(t,e,i,r){const{iScale:n,vScale:o}=t,{xAxisKey:a="x",yAxisKey:s="y"}=this._parsing,l="x"===n.axis?a:s,d="x"===o.axis?a:s,c=[];let h,p,u,g;for(h=i,p=i+r;h<p;++h)g=e[h],u={},u[n.axis]=n.parse(la(g,l),h),c.push(gd(la(g,d),u,o,h));return c}updateRangeFromParsed(t,e,i,r){super.updateRangeFromParsed(t,e,i,r);const n=i._custom;n&&e===this._cachedMeta.vScale&&(t.min=Math.min(t.min,n.min),t.max=Math.max(t.max,n.max))}getMaxOverflow(){return 0}getLabelAndValue(t){const e=this._cachedMeta,{iScale:i,vScale:r}=e,n=this.getParsed(t),o=n._custom,a=md(o)?"["+o.start+", "+o.end+"]":""+r.getLabelForValue(n[r.axis]);return{label:""+i.getLabelForValue(n[i.axis]),value:a}}initialize(){this.enableOptionSharing=!0,super.initialize();this._cachedMeta.stack=this.getDataset().stack}update(t){const e=this._cachedMeta;this.updateElements(e.data,0,e.data.length,t)}updateElements(t,e,i,r){const n="reset"===r,{index:o,_cachedMeta:{vScale:a}}=this,s=a.getBasePixel(),l=a.isHorizontal(),d=this._getRuler(),c=this.resolveDataElementOptions(e,r),h=this.getSharedOptions(c),p=this.includeOptions(r,h);this.updateSharedOptions(h,r,c);for(let c=e;c<e+i;c++){const e=this.getParsed(c),i=n||Io(e[a.axis])?{base:s,head:s}:this._calculateBarValuePixels(c),u=this._calculateBarIndexPixels(c,d),g=(e._stacks||{})[a.axis],f={horizontal:l,base:i.base,enableBorderRadius:!g||md(e._custom)||o===g._top||o===g._bottom,x:l?i.head:u.center,y:l?u.center:i.head,height:l?u.size:Math.abs(i.size),width:l?Math.abs(i.size):u.size};p&&(f.options=h||this.resolveDataElementOptions(c,t[c].active?"active":r));const m=f.options||t[c].options;bd(f,m,g,o),xd(f,m,d.ratio),this.updateElement(t[c],c,f,r)}}_getStacks(t,e){const i=this._cachedMeta.iScale,r=i.getMatchingVisibleMetas(this._type),n=i.options.stacked,o=r.length,a=[];let s,l;for(s=0;s<o;++s)if(l=r[s],l.controller.options.grouped){if(void 0!==e){const t=l.controller.getParsed(e)[l.controller._cachedMeta.vScale.axis];if(Io(t)||isNaN(t))continue}if((!1===n||-1===a.indexOf(l.stack)||void 0===n&&void 0===l.stack)&&a.push(l.stack),l.index===t)break}return a.length||a.push(void 0),a}_getStackCount(t){return this._getStacks(void 0,t).length}_getStackIndex(t,e,i){const r=this._getStacks(t,i),n=void 0!==e?r.indexOf(e):-1;return-1===n?r.length-1:n}_getRuler(){const t=this.options,e=this._cachedMeta,i=e.iScale,r=[];let n,o;for(n=0,o=e.data.length;n<o;++n)r.push(i.getPixelForValue(this.getParsed(n)[i.axis],n));const a=t.barThickness;return{min:a||ud(e),pixels:r,start:i._startPixel,end:i._endPixel,stackCount:this._getStackCount(),scale:i,grouped:t.grouped,ratio:a?1:t.categoryPercentage*t.barPercentage}}_calculateBarValuePixels(t){const{_cachedMeta:{vScale:e,_stacked:i},options:{base:r,minBarLength:n}}=this,o=r||0,a=this.getParsed(t),s=a._custom,l=md(s);let d,c,h=a[e.axis],p=0,u=i?this.applyStack(e,a,i):h;u!==h&&(p=u-h,u=h),l&&(h=s.barStart,u=s.barEnd-s.barStart,0!==h&&Ca(h)!==Ca(s.barEnd)&&(p=0),p+=h);const g=Io(r)||l?p:r;let f=e.getPixelForValue(g);if(d=this.chart.getDataVisibility(t)?e.getPixelForValue(p+u):f,c=d-f,Math.abs(c)<n&&(c=function(t,e,i){return 0!==t?Ca(t):(e.isHorizontal()?1:-1)*(e.min>=i?1:-1)}(c,e,o)*n,h===o&&(f-=c/2),d=f+c),f===e.getPixelForValue(o)){const t=Ca(c)*e.getLineWidthForValue(o)/2;f+=t,c-=t}return{size:c,base:f,head:d,center:d+c/2}}_calculateBarIndexPixels(t,e){const i=e.scale,r=this.options,n=r.skipNull,o=Qo(r.maxBarThickness,1/0);let a,s;if(e.grouped){const i=n?this._getStackCount(t):e.stackCount,l="flex"===r.barThickness?function(t,e,i,r){const n=e.pixels,o=n[t];let a=t>0?n[t-1]:null,s=t<n.length-1?n[t+1]:null;const l=i.categoryPercentage;null===a&&(a=o-(null===s?e.end-e.start:s-o)),null===s&&(s=o+o-a);const d=o-(o-Math.min(a,s))/2*l;return{chunk:Math.abs(s-a)/2*l/r,ratio:i.barPercentage,start:d}}(t,e,r,i):function(t,e,i,r){const n=i.barThickness;let o,a;return Io(n)?(o=e.min*i.categoryPercentage,a=i.barPercentage):(o=n*r,a=1),{chunk:o/r,ratio:a,start:e.pixels[t]-o/2}}(t,e,r,i),d=this._getStackIndex(this.index,this._cachedMeta.stack,n?t:void 0);a=l.start+l.chunk*d+l.chunk/2,s=Math.min(o,l.chunk*l.ratio)}else a=i.getPixelForValue(this.getParsed(t)[i.axis],t),s=Math.min(o,e.min*e.ratio);return{base:a-s/2,head:a+s/2,center:a,size:s}}draw(){const t=this._cachedMeta,e=t.vScale,i=t.data,r=i.length;let n=0;for(;n<r;++n)null!==this.getParsed(n)[e.axis]&&i[n].draw(this._ctx)}}yd.id="bar",yd.defaults={datasetElementType:!1,dataElementType:"bar",categoryPercentage:.8,barPercentage:.9,grouped:!0,animations:{numbers:{type:"number",properties:["x","y","base","width","height"]}}},yd.overrides={scales:{_index_:{type:"category",offset:!0,grid:{offset:!0}},_value_:{type:"linear",beginAtZero:!0}}};class Cd extends pd{initialize(){this.enableOptionSharing=!0,super.initialize()}parsePrimitiveData(t,e,i,r){const n=super.parsePrimitiveData(t,e,i,r);for(let t=0;t<n.length;t++)n[t]._custom=this.resolveDataElementOptions(t+i).radius;return n}parseArrayData(t,e,i,r){const n=super.parseArrayData(t,e,i,r);for(let t=0;t<n.length;t++){const r=e[i+t];n[t]._custom=Qo(r[2],this.resolveDataElementOptions(t+i).radius)}return n}parseObjectData(t,e,i,r){const n=super.parseObjectData(t,e,i,r);for(let t=0;t<n.length;t++){const r=e[i+t];n[t]._custom=Qo(r&&r.r&&+r.r,this.resolveDataElementOptions(t+i).radius)}return n}getMaxOverflow(){const t=this._cachedMeta.data;let e=0;for(let i=t.length-1;i>=0;--i)e=Math.max(e,t[i].size(this.resolveDataElementOptions(i))/2);return e>0&&e}getLabelAndValue(t){const e=this._cachedMeta,{xScale:i,yScale:r}=e,n=this.getParsed(t),o=i.getLabelForValue(n.x),a=r.getLabelForValue(n.y),s=n._custom;return{label:e.label,value:"("+o+", "+a+(s?", "+s:"")+")"}}update(t){const e=this._cachedMeta.data;this.updateElements(e,0,e.length,t)}updateElements(t,e,i,r){const n="reset"===r,{iScale:o,vScale:a}=this._cachedMeta,s=this.resolveDataElementOptions(e,r),l=this.getSharedOptions(s),d=this.includeOptions(r,l),c=o.axis,h=a.axis;for(let s=e;s<e+i;s++){const e=t[s],i=!n&&this.getParsed(s),l={},p=l[c]=n?o.getPixelForDecimal(.5):o.getPixelForValue(i[c]),u=l[h]=n?a.getBasePixel():a.getPixelForValue(i[h]);l.skip=isNaN(p)||isNaN(u),d&&(l.options=this.resolveDataElementOptions(s,e.active?"active":r),n&&(l.options.radius=0)),this.updateElement(e,s,l,r)}this.updateSharedOptions(l,r,s)}resolveDataElementOptions(t,e){const i=this.getParsed(t);let r=super.resolveDataElementOptions(t,e);r.$shared&&(r=Object.assign({},r,{$shared:!1}));const n=r.radius;return"active"!==e&&(r.radius=0),r.radius+=Qo(i&&i._custom,n),r}}Cd.id="bubble",Cd.defaults={datasetElementType:!1,dataElementType:"point",animations:{numbers:{type:"number",properties:["x","y","borderWidth","radius"]}}},Cd.overrides={scales:{x:{type:"linear"},y:{type:"linear"}},plugins:{tooltip:{callbacks:{title:()=>""}}}};class kd extends pd{constructor(t,e){super(t,e),this.enableOptionSharing=!0,this.innerRadius=void 0,this.outerRadius=void 0,this.offsetX=void 0,this.offsetY=void 0}linkScales(){}parse(t,e){const i=this.getDataset().data,r=this._cachedMeta;if(!1===this._parsing)r._parsed=i;else{let n,o,a=t=>+i[t];if(Wo(i[t])){const{key:t="value"}=this._parsing;a=e=>+la(i[e],t)}for(n=t,o=t+e;n<o;++n)r._parsed[n]=a(n)}}_getRotation(){return Ma(this.options.rotation-90)}_getCircumference(){return Ma(this.options.circumference)}_getRotationExtents(){let t=ga,e=-ga;for(let i=0;i<this.chart.data.datasets.length;++i)if(this.chart.isDatasetVisible(i)){const r=this.chart.getDatasetMeta(i).controller,n=r._getRotation(),o=r._getCircumference();t=Math.min(t,n),e=Math.max(e,n+o)}return{rotation:t,circumference:e-t}}update(t){const e=this.chart,{chartArea:i}=e,r=this._cachedMeta,n=r.data,o=this.getMaxBorderWidth()+this.getMaxOffset(n)+this.options.spacing,a=Math.max((Math.min(i.width,i.height)-o)/2,0),s=Math.min((l=this.options.cutout,d=a,"string"==typeof l&&l.endsWith("%")?parseFloat(l)/100:l/d),1);var l,d;const c=this._getRingWeight(this.index),{circumference:h,rotation:p}=this._getRotationExtents(),{ratioX:u,ratioY:g,offsetX:f,offsetY:m}=function(t,e,i){let r=1,n=1,o=0,a=0;if(e<ga){const s=t,l=s+e,d=Math.cos(s),c=Math.sin(s),h=Math.cos(l),p=Math.sin(l),u=(t,e,r)=>Da(t,s,l,!0)?1:Math.max(e,e*i,r,r*i),g=(t,e,r)=>Da(t,s,l,!0)?-1:Math.min(e,e*i,r,r*i),f=u(0,d,h),m=u(va,c,p),b=g(ua,d,h),v=g(ua+va,c,p);r=(f-b)/2,n=(m-v)/2,o=-(f+b)/2,a=-(m+v)/2}return{ratioX:r,ratioY:n,offsetX:o,offsetY:a}}(p,h,s),b=(i.width-o)/u,v=(i.height-o)/g,w=Math.max(Math.min(b,v)/2,0),x=Xo(this.options.radius,w),y=(x-Math.max(x*s,0))/this._getVisibleDatasetWeightTotal();this.offsetX=f*x,this.offsetY=m*x,r.total=this.calculateTotal(),this.outerRadius=x-y*this._getRingWeightOffset(this.index),this.innerRadius=Math.max(this.outerRadius-y*c,0),this.updateElements(n,0,n.length,t)}_circumference(t,e){const i=this.options,r=this._cachedMeta,n=this._getCircumference();return e&&i.animation.animateRotate||!this.chart.getDataVisibility(t)||null===r._parsed[t]||r.data[t].hidden?0:this.calculateCircumference(r._parsed[t]*n/ga)}updateElements(t,e,i,r){const n="reset"===r,o=this.chart,a=o.chartArea,s=o.options.animation,l=(a.left+a.right)/2,d=(a.top+a.bottom)/2,c=n&&s.animateScale,h=c?0:this.innerRadius,p=c?0:this.outerRadius,u=this.resolveDataElementOptions(e,r),g=this.getSharedOptions(u),f=this.includeOptions(r,g);let m,b=this._getRotation();for(m=0;m<e;++m)b+=this._circumference(m,n);for(m=e;m<e+i;++m){const e=this._circumference(m,n),i=t[m],o={x:l+this.offsetX,y:d+this.offsetY,startAngle:b,endAngle:b+e,circumference:e,outerRadius:p,innerRadius:h};f&&(o.options=g||this.resolveDataElementOptions(m,i.active?"active":r)),b+=e,this.updateElement(i,m,o,r)}this.updateSharedOptions(g,r,u)}calculateTotal(){const t=this._cachedMeta,e=t.data;let i,r=0;for(i=0;i<e.length;i++){const n=t._parsed[i];null===n||isNaN(n)||!this.chart.getDataVisibility(i)||e[i].hidden||(r+=Math.abs(n))}return r}calculateCircumference(t){const e=this._cachedMeta.total;return e>0&&!isNaN(t)?ga*(Math.abs(t)/e):0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,r=i.data.labels||[],n=Zl(e._parsed[t],i.options.locale);return{label:r[t]||"",value:n}}getMaxBorderWidth(t){let e=0;const i=this.chart;let r,n,o,a,s;if(!t)for(r=0,n=i.data.datasets.length;r<n;++r)if(i.isDatasetVisible(r)){o=i.getDatasetMeta(r),t=o.data,a=o.controller;break}if(!t)return 0;for(r=0,n=t.length;r<n;++r)s=a.resolveDataElementOptions(r),"inner"!==s.borderAlign&&(e=Math.max(e,s.borderWidth||0,s.hoverBorderWidth||0));return e}getMaxOffset(t){let e=0;for(let i=0,r=t.length;i<r;++i){const t=this.resolveDataElementOptions(i);e=Math.max(e,t.offset||0,t.hoverOffset||0)}return e}_getRingWeightOffset(t){let e=0;for(let i=0;i<t;++i)this.chart.isDatasetVisible(i)&&(e+=this._getRingWeight(i));return e}_getRingWeight(t){return Math.max(Qo(this.chart.data.datasets[t].weight,1),0)}_getVisibleDatasetWeightTotal(){return this._getRingWeightOffset(this.chart.data.datasets.length)||1}}kd.id="doughnut",kd.defaults={datasetElementType:!1,dataElementType:"arc",animation:{animateRotate:!0,animateScale:!1},animations:{numbers:{type:"number",properties:["circumference","endAngle","innerRadius","outerRadius","startAngle","x","y","offset","borderWidth","spacing"]}},cutout:"50%",rotation:0,circumference:360,radius:"100%",spacing:0,indexAxis:"r"},kd.descriptors={_scriptable:t=>"spacing"!==t,_indexable:t=>"spacing"!==t},kd.overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data;if(e.labels.length&&e.datasets.length){const{labels:{pointStyle:i}}=t.legend.options;return e.labels.map(((e,r)=>{const n=t.getDatasetMeta(0).controller.getStyle(r);return{text:e,fillStyle:n.backgroundColor,strokeStyle:n.borderColor,lineWidth:n.borderWidth,pointStyle:i,hidden:!t.getDataVisibility(r),index:r}}))}return[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}},tooltip:{callbacks:{title:()=>"",label(t){let e=t.label;const i=": "+t.formattedValue;return Uo(e)?(e=e.slice(),e[0]+=i):e+=i,e}}}}};class Ad extends pd{initialize(){this.enableOptionSharing=!0,super.initialize()}update(t){const e=this._cachedMeta,{dataset:i,data:r=[],_dataset:n}=e,o=this.chart._animationsDisabled;let{start:a,count:s}=function(t,e,i){const r=e.length;let n=0,o=r;if(t._sorted){const{iScale:a,_parsed:s}=t,l=a.axis,{min:d,max:c,minDefined:h,maxDefined:p}=a.getUserBounds();h&&(n=Ea(Math.min(Ks(s,a.axis,d).lo,i?r:Ks(e,l,a.getPixelForValue(d)).lo),0,r-1)),o=p?Ea(Math.max(Ks(s,a.axis,c).hi+1,i?0:Ks(e,l,a.getPixelForValue(c)).hi+1),n,r)-n:r-n}return{start:n,count:o}}(e,r,o);this._drawStart=a,this._drawCount=s,function(t){const{xScale:e,yScale:i,_scaleRanges:r}=t,n={xmin:e.min,xmax:e.max,ymin:i.min,ymax:i.max};if(!r)return t._scaleRanges=n,!0;const o=r.xmin!==e.min||r.xmax!==e.max||r.ymin!==i.min||r.ymax!==i.max;return Object.assign(r,n),o}(e)&&(a=0,s=r.length),i._chart=this.chart,i._datasetIndex=this.index,i._decimated=!!n._decimated,i.points=r;const l=this.resolveDatasetElementOptions(t);this.options.showLine||(l.borderWidth=0),l.segment=this.options.segment,this.updateElement(i,void 0,{animated:!o,options:l},t),this.updateElements(r,a,s,t)}updateElements(t,e,i,r){const n="reset"===r,{iScale:o,vScale:a,_stacked:s,_dataset:l}=this._cachedMeta,d=this.resolveDataElementOptions(e,r),c=this.getSharedOptions(d),h=this.includeOptions(r,c),p=o.axis,u=a.axis,{spanGaps:g,segment:f}=this.options,m=Aa(g)?g:Number.POSITIVE_INFINITY,b=this.chart._animationsDisabled||n||"none"===r;let v=e>0&&this.getParsed(e-1);for(let d=e;d<e+i;++d){const e=t[d],i=this.getParsed(d),g=b?e:{},w=Io(i[u]),x=g[p]=o.getPixelForValue(i[p],d),y=g[u]=n||w?a.getBasePixel():a.getPixelForValue(s?this.applyStack(a,i,s):i[u],d);g.skip=isNaN(x)||isNaN(y)||w,g.stop=d>0&&i[p]-v[p]>m,f&&(g.parsed=i,g.raw=l.data[d]),h&&(g.options=c||this.resolveDataElementOptions(d,e.active?"active":r)),b||this.updateElement(e,d,g,r),v=i}this.updateSharedOptions(c,r,d)}getMaxOverflow(){const t=this._cachedMeta,e=t.dataset,i=e.options&&e.options.borderWidth||0,r=t.data||[];if(!r.length)return i;const n=r[0].size(this.resolveDataElementOptions(0)),o=r[r.length-1].size(this.resolveDataElementOptions(r.length-1));return Math.max(i,n,o)/2}draw(){const t=this._cachedMeta;t.dataset.updateControlPoints(this.chart.chartArea,t.iScale.axis),super.draw()}}Ad.id="line",Ad.defaults={datasetElementType:"line",dataElementType:"point",showLine:!0,spanGaps:!1},Ad.overrides={scales:{_index_:{type:"category"},_value_:{type:"linear"}}};class zd extends pd{constructor(t,e){super(t,e),this.innerRadius=void 0,this.outerRadius=void 0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,r=i.data.labels||[],n=Zl(e._parsed[t].r,i.options.locale);return{label:r[t]||"",value:n}}update(t){const e=this._cachedMeta.data;this._updateRadius(),this.updateElements(e,0,e.length,t)}_updateRadius(){const t=this.chart,e=t.chartArea,i=t.options,r=Math.min(e.right-e.left,e.bottom-e.top),n=Math.max(r/2,0),o=(n-Math.max(i.cutoutPercentage?n/100*i.cutoutPercentage:1,0))/t.getVisibleDatasetCount();this.outerRadius=n-o*this.index,this.innerRadius=this.outerRadius-o}updateElements(t,e,i,r){const n="reset"===r,o=this.chart,a=this.getDataset(),s=o.options.animation,l=this._cachedMeta.rScale,d=l.xCenter,c=l.yCenter,h=l.getIndexAngle(0)-.5*ua;let p,u=h;const g=360/this.countVisibleElements();for(p=0;p<e;++p)u+=this._computeAngle(p,r,g);for(p=e;p<e+i;p++){const e=t[p];let i=u,f=u+this._computeAngle(p,r,g),m=o.getDataVisibility(p)?l.getDistanceFromCenterForValue(a.data[p]):0;u=f,n&&(s.animateScale&&(m=0),s.animateRotate&&(i=f=h));const b={x:d,y:c,innerRadius:0,outerRadius:m,startAngle:i,endAngle:f,options:this.resolveDataElementOptions(p,e.active?"active":r)};this.updateElement(e,p,b,r)}}countVisibleElements(){const t=this.getDataset(),e=this._cachedMeta;let i=0;return e.data.forEach(((e,r)=>{!isNaN(t.data[r])&&this.chart.getDataVisibility(r)&&i++})),i}_computeAngle(t,e,i){return this.chart.getDataVisibility(t)?Ma(this.resolveDataElementOptions(t,e).angle||i):0}}zd.id="polarArea",zd.defaults={dataElementType:"arc",animation:{animateRotate:!0,animateScale:!0},animations:{numbers:{type:"number",properties:["x","y","startAngle","endAngle","innerRadius","outerRadius"]}},indexAxis:"r",startAngle:0},zd.overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data;if(e.labels.length&&e.datasets.length){const{labels:{pointStyle:i}}=t.legend.options;return e.labels.map(((e,r)=>{const n=t.getDatasetMeta(0).controller.getStyle(r);return{text:e,fillStyle:n.backgroundColor,strokeStyle:n.borderColor,lineWidth:n.borderWidth,pointStyle:i,hidden:!t.getDataVisibility(r),index:r}}))}return[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}},tooltip:{callbacks:{title:()=>"",label:t=>t.chart.data.labels[t.dataIndex]+": "+t.formattedValue}}},scales:{r:{type:"radialLinear",angleLines:{display:!1},beginAtZero:!0,grid:{circular:!0},pointLabels:{display:!1},startAngle:0}}};class $d extends kd{}$d.id="pie",$d.defaults={cutout:0,rotation:0,circumference:360,radius:"100%"};class Md extends pd{getLabelAndValue(t){const e=this._cachedMeta.vScale,i=this.getParsed(t);return{label:e.getLabels()[t],value:""+e.getLabelForValue(i[e.axis])}}update(t){const e=this._cachedMeta,i=e.dataset,r=e.data||[],n=e.iScale.getLabels();if(i.points=r,"resize"!==t){const e=this.resolveDatasetElementOptions(t);this.options.showLine||(e.borderWidth=0);const o={_loop:!0,_fullLoop:n.length===r.length,options:e};this.updateElement(i,void 0,o,t)}this.updateElements(r,0,r.length,t)}updateElements(t,e,i,r){const n=this.getDataset(),o=this._cachedMeta.rScale,a="reset"===r;for(let s=e;s<e+i;s++){const e=t[s],i=this.resolveDataElementOptions(s,e.active?"active":r),l=o.getPointPositionForValue(s,n.data[s]),d=a?o.xCenter:l.x,c=a?o.yCenter:l.y,h={x:d,y:c,angle:l.angle,skip:isNaN(d)||isNaN(c),options:i};this.updateElement(e,s,h,r)}}}Md.id="radar",Md.defaults={datasetElementType:"line",dataElementType:"point",indexAxis:"r",showLine:!0,elements:{line:{fill:"start"}}},Md.overrides={aspectRatio:1,scales:{r:{type:"radialLinear"}}};class Sd extends Ad{}Sd.id="scatter",Sd.defaults={showLine:!1,fill:!1},Sd.overrides={interaction:{mode:"point"},plugins:{tooltip:{callbacks:{title:()=>"",label:t=>"("+t.label+", "+t.formattedValue+")"}}},scales:{x:{type:"linear"},y:{type:"linear"}}};var Ld=Object.freeze({__proto__:null,BarController:yd,BubbleController:Cd,DoughnutController:kd,LineController:Ad,PolarAreaController:zd,PieController:$d,RadarController:Md,ScatterController:Sd});function Hd(){throw new Error("This method is not implemented: Check that a complete date adapter is provided.")}class Bd{constructor(t){this.options=t||{}}formats(){return Hd()}parse(t,e){return Hd()}format(t,e){return Hd()}add(t,e,i){return Hd()}diff(t,e,i){return Hd()}startOf(t,e,i){return Hd()}endOf(t,e){return Hd()}}Bd.override=function(t){Object.assign(Bd.prototype,t)};var _d={_date:Bd};function Fd(t,e){return"native"in t?{x:t.x,y:t.y}:Ll(t,e)}function Dd(t,e,i,r){const{controller:n,data:o,_sorted:a}=t,s=n._cachedMeta.iScale;if(s&&e===s.axis&&"r"!==e&&a&&o.length){const t=s._reversePixels?Js:Ks;if(!r)return t(o,e,i);if(n._sharedOptions){const r=o[0],n="function"==typeof r.getRange&&r.getRange(e);if(n){const r=t(o,e,i-n),a=t(o,e,i+n);return{lo:r.lo,hi:a.hi}}}}return{lo:0,hi:o.length-1}}function Ed(t,e,i,r,n){const o=t.getSortedVisibleDatasetMetas(),a=i[e];for(let t=0,i=o.length;t<i;++t){const{index:i,data:s}=o[t],{lo:l,hi:d}=Dd(o[t],e,a,n);for(let t=l;t<=d;++t){const e=s[t];e.skip||r(e,i,t)}}}function Vd(t,e,i,r){const n=[];if(!_s(e,t.chartArea,t._minPadding))return n;return Ed(t,i,e,(function(t,i,o){t.inRange(e.x,e.y,r)&&n.push({element:t,datasetIndex:i,index:o})}),!0),n}function Od(t,e,i,r,n){let o=[];const a=function(t){const e=-1!==t.indexOf("x"),i=-1!==t.indexOf("y");return function(t,r){const n=e?Math.abs(t.x-r.x):0,o=i?Math.abs(t.y-r.y):0;return Math.sqrt(Math.pow(n,2)+Math.pow(o,2))}}(i);let s=Number.POSITIVE_INFINITY;return Ed(t,i,e,(function(i,l,d){const c=i.inRange(e.x,e.y,n);if(r&&!c)return;const h=i.getCenterPoint(n);if(!_s(h,t.chartArea,t._minPadding)&&!c)return;const p=a(e,h);p<s?(o=[{element:i,datasetIndex:l,index:d}],s=p):p===s&&o.push({element:i,datasetIndex:l,index:d})})),o}function jd(t,e,i,r,n){return _s(e,t.chartArea,t._minPadding)?"r"!==i||r?Od(t,e,i,r,n):function(t,e,i,r){let n=[];return Ed(t,i,e,(function(t,i,o){const{startAngle:a,endAngle:s}=t.getProps(["startAngle","endAngle"],r),{angle:l}=Ha(t,{x:e.x,y:e.y});Da(l,a,s)&&n.push({element:t,datasetIndex:i,index:o})})),n}(t,e,i,n):[]}function Zd(t,e,i,r){const n=Fd(e,t),o=[],a=i.axis,s="x"===a?"inXRange":"inYRange";let l=!1;return function(t,e){const i=t.getSortedVisibleDatasetMetas();let r,n,o;for(let t=0,a=i.length;t<a;++t){({index:r,data:n}=i[t]);for(let t=0,i=n.length;t<i;++t)o=n[t],o.skip||e(o,r,t)}}(t,((t,e,i)=>{t[s](n[a],r)&&o.push({element:t,datasetIndex:e,index:i}),t.inRange(n.x,n.y,r)&&(l=!0)})),i.intersect&&!l?[]:o}var Rd={modes:{index(t,e,i,r){const n=Fd(e,t),o=i.axis||"x",a=i.intersect?Vd(t,n,o,r):jd(t,n,o,!1,r),s=[];return a.length?(t.getSortedVisibleDatasetMetas().forEach((t=>{const e=a[0].index,i=t.data[e];i&&!i.skip&&s.push({element:i,datasetIndex:t.index,index:e})})),s):[]},dataset(t,e,i,r){const n=Fd(e,t),o=i.axis||"xy";let a=i.intersect?Vd(t,n,o,r):jd(t,n,o,!1,r);if(a.length>0){const e=a[0].datasetIndex,i=t.getDatasetMeta(e).data;a=[];for(let t=0;t<i.length;++t)a.push({element:i[t],datasetIndex:e,index:t})}return a},point:(t,e,i,r)=>Vd(t,Fd(e,t),i.axis||"xy",r),nearest:(t,e,i,r)=>jd(t,Fd(e,t),i.axis||"xy",i.intersect,r),x:(t,e,i,r)=>Zd(t,e,{axis:"x",intersect:i.intersect},r),y:(t,e,i,r)=>Zd(t,e,{axis:"y",intersect:i.intersect},r)}};const Td=["left","top","right","bottom"];function Nd(t,e){return t.filter((t=>t.pos===e))}function Pd(t,e){return t.filter((t=>-1===Td.indexOf(t.pos)&&t.box.axis===e))}function Yd(t,e){return t.sort(((t,i)=>{const r=e?i:t,n=e?t:i;return r.weight===n.weight?r.index-n.index:r.weight-n.weight}))}function Id(t,e){const i=function(t){const e={};for(const i of t){const{stack:t,pos:r,stackWeight:n}=i;if(!t||!Td.includes(r))continue;const o=e[t]||(e[t]={count:0,placed:0,weight:0,size:0});o.count++,o.weight+=n}return e}(t),{vBoxMaxWidth:r,hBoxMaxHeight:n}=e;let o,a,s;for(o=0,a=t.length;o<a;++o){s=t[o];const{fullSize:a}=s.box,l=i[s.stack],d=l&&s.stackWeight/l.weight;s.horizontal?(s.width=d?d*r:a&&e.availableWidth,s.height=n):(s.width=r,s.height=d?d*n:a&&e.availableHeight)}return i}function Ud(t,e,i,r){return Math.max(t[i],e[i])+Math.max(t[r],e[r])}function Wd(t,e){t.top=Math.max(t.top,e.top),t.left=Math.max(t.left,e.left),t.bottom=Math.max(t.bottom,e.bottom),t.right=Math.max(t.right,e.right)}function qd(t,e,i,r){const{pos:n,box:o}=i,a=t.maxPadding;if(!Wo(n)){i.size&&(t[n]-=i.size);const e=r[i.stack]||{size:0,count:1};e.size=Math.max(e.size,i.horizontal?o.height:o.width),i.size=e.size/e.count,t[n]+=i.size}o.getPadding&&Wd(a,o.getPadding());const s=Math.max(0,e.outerWidth-Ud(a,t,"left","right")),l=Math.max(0,e.outerHeight-Ud(a,t,"top","bottom")),d=s!==t.w,c=l!==t.h;return t.w=s,t.h=l,i.horizontal?{same:d,other:c}:{same:c,other:d}}function Gd(t,e){const i=e.maxPadding;function r(t){const r={left:0,top:0,right:0,bottom:0};return t.forEach((t=>{r[t]=Math.max(e[t],i[t])})),r}return r(t?["left","right"]:["top","bottom"])}function Qd(t,e,i,r){const n=[];let o,a,s,l,d,c;for(o=0,a=t.length,d=0;o<a;++o){s=t[o],l=s.box,l.update(s.width||e.w,s.height||e.h,Gd(s.horizontal,e));const{same:a,other:h}=qd(e,i,s,r);d|=a&&n.length,c=c||h,l.fullSize||n.push(s)}return d&&Qd(n,e,i,r)||c}function Xd(t,e,i,r,n){t.top=i,t.left=e,t.right=e+r,t.bottom=i+n,t.width=r,t.height=n}function Kd(t,e,i,r){const n=i.padding;let{x:o,y:a}=e;for(const s of t){const t=s.box,l=r[s.stack]||{count:1,placed:0,weight:1},d=s.stackWeight/l.weight||1;if(s.horizontal){const r=e.w*d,o=l.size||t.height;ca(l.start)&&(a=l.start),t.fullSize?Xd(t,n.left,a,i.outerWidth-n.right-n.left,o):Xd(t,e.left+l.placed,a,r,o),l.start=a,l.placed+=r,a=t.bottom}else{const r=e.h*d,a=l.size||t.width;ca(l.start)&&(o=l.start),t.fullSize?Xd(t,o,n.top,a,i.outerHeight-n.bottom-n.top):Xd(t,o,e.top+l.placed,a,r),l.start=o,l.placed+=r,o=t.right}}e.x=o,e.y=a}$s.set("layout",{autoPadding:!0,padding:{top:0,right:0,bottom:0,left:0}});var Jd={addBox(t,e){t.boxes||(t.boxes=[]),e.fullSize=e.fullSize||!1,e.position=e.position||"top",e.weight=e.weight||0,e._layers=e._layers||function(){return[{z:0,draw(t){e.draw(t)}}]},t.boxes.push(e)},removeBox(t,e){const i=t.boxes?t.boxes.indexOf(e):-1;-1!==i&&t.boxes.splice(i,1)},configure(t,e,i){e.fullSize=i.fullSize,e.position=i.position,e.weight=i.weight},update(t,e,i,r){if(!t)return;const n=Ws(t.options.layout.padding),o=Math.max(e-n.width,0),a=Math.max(i-n.height,0),s=function(t){const e=function(t){const e=[];let i,r,n,o,a,s;for(i=0,r=(t||[]).length;i<r;++i)n=t[i],({position:o,options:{stack:a,stackWeight:s=1}}=n),e.push({index:i,box:n,pos:o,horizontal:n.isHorizontal(),weight:n.weight,stack:a&&o+a,stackWeight:s});return e}(t),i=Yd(e.filter((t=>t.box.fullSize)),!0),r=Yd(Nd(e,"left"),!0),n=Yd(Nd(e,"right")),o=Yd(Nd(e,"top"),!0),a=Yd(Nd(e,"bottom")),s=Pd(e,"x"),l=Pd(e,"y");return{fullSize:i,leftAndTop:r.concat(o),rightAndBottom:n.concat(l).concat(a).concat(s),chartArea:Nd(e,"chartArea"),vertical:r.concat(n).concat(l),horizontal:o.concat(a).concat(s)}}(t.boxes),l=s.vertical,d=s.horizontal;Jo(t.boxes,(t=>{"function"==typeof t.beforeLayout&&t.beforeLayout()}));const c=l.reduce(((t,e)=>e.box.options&&!1===e.box.options.display?t:t+1),0)||1,h=Object.freeze({outerWidth:e,outerHeight:i,padding:n,availableWidth:o,availableHeight:a,vBoxMaxWidth:o/2/c,hBoxMaxHeight:a/2}),p=Object.assign({},n);Wd(p,Ws(r));const u=Object.assign({maxPadding:p,w:o,h:a,x:n.left,y:n.top},n),g=Id(l.concat(d),h);Qd(s.fullSize,u,h,g),Qd(l,u,h,g),Qd(d,u,h,g)&&Qd(l,u,h,g),function(t){const e=t.maxPadding;function i(i){const r=Math.max(e[i]-t[i],0);return t[i]+=r,r}t.y+=i("top"),t.x+=i("left"),i("right"),i("bottom")}(u),Kd(s.leftAndTop,u,h,g),u.x+=u.w,u.y+=u.h,Kd(s.rightAndBottom,u,h,g),t.chartArea={left:u.left,top:u.top,right:u.left+u.w,bottom:u.top+u.h,height:u.h,width:u.w},Jo(s.chartArea,(e=>{const i=e.box;Object.assign(i,t.chartArea),i.update(u.w,u.h,{left:0,top:0,right:0,bottom:0})}))}};class tc{acquireContext(t,e){}releaseContext(t){return!1}addEventListener(t,e,i){}removeEventListener(t,e,i){}getDevicePixelRatio(){return 1}getMaximumSize(t,e,i,r){return e=Math.max(0,e||t.width),i=i||t.height,{width:e,height:Math.max(0,r?Math.floor(e/r):i)}}isAttached(t){return!0}updateConfig(t){}}class ec extends tc{acquireContext(t){return t&&t.getContext&&t.getContext("2d")||null}updateConfig(t){t.options.animation=!1}}const ic={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"},rc=t=>null===t||""===t;const nc=!!Fl&&{passive:!0};function oc(t,e,i){t.canvas.removeEventListener(e,i,nc)}function ac(t,e){for(const i of t)if(i===e||i.contains(e))return!0}function sc(t,e,i){const r=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||ac(i.addedNodes,r),e=e&&!ac(i.removedNodes,r);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}function lc(t,e,i){const r=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||ac(i.removedNodes,r),e=e&&!ac(i.addedNodes,r);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}const dc=new Map;let cc=0;function hc(){const t=window.devicePixelRatio;t!==cc&&(cc=t,dc.forEach(((e,i)=>{i.currentDevicePixelRatio!==t&&e()})))}function pc(t,e,i){const r=t.canvas,n=r&&Al(r);if(!n)return;const o=Ro(((t,e)=>{const r=n.clientWidth;i(t,e),r<n.clientWidth&&i()}),window),a=new ResizeObserver((t=>{const e=t[0],i=e.contentRect.width,r=e.contentRect.height;0===i&&0===r||o(i,r)}));return a.observe(n),function(t,e){dc.size||window.addEventListener("resize",hc),dc.set(t,e)}(t,o),a}function uc(t,e,i){i&&i.disconnect(),"resize"===e&&function(t){dc.delete(t),dc.size||window.removeEventListener("resize",hc)}(t)}function gc(t,e,i){const r=t.canvas,n=Ro((e=>{null!==t.ctx&&i(function(t,e){const i=ic[t.type]||t.type,{x:r,y:n}=Ll(t,e);return{type:i,chart:e,native:t,x:void 0!==r?r:null,y:void 0!==n?n:null}}(e,t))}),t,(t=>{const e=t[0];return[e,e.offsetX,e.offsetY]}));return function(t,e,i){t.addEventListener(e,i,nc)}(r,e,n),n}class fc extends tc{acquireContext(t,e){const i=t&&t.getContext&&t.getContext("2d");return i&&i.canvas===t?(function(t,e){const i=t.style,r=t.getAttribute("height"),n=t.getAttribute("width");if(t.$chartjs={initial:{height:r,width:n,style:{display:i.display,height:i.height,width:i.width}}},i.display=i.display||"block",i.boxSizing=i.boxSizing||"border-box",rc(n)){const e=Dl(t,"width");void 0!==e&&(t.width=e)}if(rc(r))if(""===t.style.height)t.height=t.width/(e||2);else{const e=Dl(t,"height");void 0!==e&&(t.height=e)}}(t,e),i):null}releaseContext(t){const e=t.canvas;if(!e.$chartjs)return!1;const i=e.$chartjs.initial;["height","width"].forEach((t=>{const r=i[t];Io(r)?e.removeAttribute(t):e.setAttribute(t,r)}));const r=i.style||{};return Object.keys(r).forEach((t=>{e.style[t]=r[t]})),e.width=e.width,delete e.$chartjs,!0}addEventListener(t,e,i){this.removeEventListener(t,e);const r=t.$proxies||(t.$proxies={}),n={attach:sc,detach:lc,resize:pc}[e]||gc;r[e]=n(t,e,i)}removeEventListener(t,e){const i=t.$proxies||(t.$proxies={}),r=i[e];if(!r)return;({attach:uc,detach:uc,resize:uc}[e]||oc)(t,e,r),i[e]=void 0}getDevicePixelRatio(){return window.devicePixelRatio}getMaximumSize(t,e,i,r){return Bl(t,e,i,r)}isAttached(t){const e=Al(t);return!(!e||!e.isConnected)}}class mc{constructor(){this.x=void 0,this.y=void 0,this.active=!1,this.options=void 0,this.$animations=void 0}tooltipPosition(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}hasValue(){return Aa(this.x)&&Aa(this.y)}getProps(t,e){const i=this.$animations;if(!e||!i)return this;const r={};return t.forEach((t=>{r[t]=i[t]&&i[t].active()?i[t]._to:this[t]})),r}}mc.defaults={},mc.defaultRoutes=void 0;const bc={values:t=>Uo(t)?t:""+t,numeric(t,e,i){if(0===t)return"0";const r=this.chart.options.locale;let n,o=t;if(i.length>1){const e=Math.max(Math.abs(i[0].value),Math.abs(i[i.length-1].value));(e<1e-4||e>1e15)&&(n="scientific"),o=function(t,e){let i=e.length>3?e[2].value-e[1].value:e[1].value-e[0].value;Math.abs(i)>=1&&t!==Math.floor(t)&&(i=t-Math.floor(t));return i}(t,i)}const a=ya(Math.abs(o)),s=Math.max(Math.min(-1*Math.floor(a),20),0),l={notation:n,minimumFractionDigits:s,maximumFractionDigits:s};return Object.assign(l,this.options.ticks.format),Zl(t,r,l)},logarithmic(t,e,i){if(0===t)return"0";const r=t/Math.pow(10,Math.floor(ya(t)));return 1===r||2===r||5===r?bc.numeric.call(this,t,e,i):""}};var vc={formatters:bc};function wc(t,e){const i=t.options.ticks,r=i.maxTicksLimit||function(t){const e=t.options.offset,i=t._tickSize(),r=t._length/i+(e?0:1),n=t._maxLength/i;return Math.floor(Math.min(r,n))}(t),n=i.major.enabled?function(t){const e=[];let i,r;for(i=0,r=t.length;i<r;i++)t[i].major&&e.push(i);return e}(e):[],o=n.length,a=n[0],s=n[o-1],l=[];if(o>r)return function(t,e,i,r){let n,o=0,a=i[0];for(r=Math.ceil(r),n=0;n<t.length;n++)n===a&&(e.push(t[n]),o++,a=i[o*r])}(e,l,n,o/r),l;const d=function(t,e,i){const r=function(t){const e=t.length;let i,r;if(e<2)return!1;for(r=t[0],i=1;i<e;++i)if(t[i]-t[i-1]!==r)return!1;return r}(t),n=e.length/i;if(!r)return Math.max(n,1);const o=function(t){const e=[],i=Math.sqrt(t);let r;for(r=1;r<i;r++)t%r==0&&(e.push(r),e.push(t/r));return i===(0|i)&&e.push(i),e.sort(((t,e)=>t-e)).pop(),e}(r);for(let t=0,e=o.length-1;t<e;t++){const e=o[t];if(e>n)return e}return Math.max(n,1)}(n,e,r);if(o>0){let t,i;const r=o>1?Math.round((s-a)/(o-1)):null;for(xc(e,l,d,Io(r)?0:a-r,a),t=0,i=o-1;t<i;t++)xc(e,l,d,n[t],n[t+1]);return xc(e,l,d,s,Io(r)?e.length:s+r),l}return xc(e,l,d),l}function xc(t,e,i,r,n){const o=Qo(r,0),a=Math.min(Qo(n,t.length),t.length);let s,l,d,c=0;for(i=Math.ceil(i),n&&(s=n-r,i=s/Math.floor(s/i)),d=o;d<0;)c++,d=Math.round(o+c*i);for(l=Math.max(o,0);l<a;l++)l===d&&(e.push(t[l]),c++,d=Math.round(o+c*i))}$s.set("scale",{display:!0,offset:!1,reverse:!1,beginAtZero:!1,bounds:"ticks",grace:0,grid:{display:!0,lineWidth:1,drawBorder:!0,drawOnChartArea:!0,drawTicks:!0,tickLength:8,tickWidth:(t,e)=>e.lineWidth,tickColor:(t,e)=>e.color,offset:!1,borderDash:[],borderDashOffset:0,borderWidth:1},title:{display:!1,text:"",padding:{top:4,bottom:4}},ticks:{minRotation:0,maxRotation:50,mirror:!1,textStrokeWidth:0,textStrokeColor:"",padding:3,display:!0,autoSkip:!0,autoSkipPadding:3,labelOffset:0,callback:vc.formatters.values,minor:{},major:{},align:"center",crossAlign:"near",showLabelBackdrop:!1,backdropColor:"rgba(255, 255, 255, 0.75)",backdropPadding:2}}),$s.route("scale.ticks","color","","color"),$s.route("scale.grid","color","","borderColor"),$s.route("scale.grid","borderColor","","borderColor"),$s.route("scale.title","color","","color"),$s.describe("scale",{_fallback:!1,_scriptable:t=>!t.startsWith("before")&&!t.startsWith("after")&&"callback"!==t&&"parser"!==t,_indexable:t=>"borderDash"!==t&&"tickBorderDash"!==t}),$s.describe("scales",{_fallback:"scale"}),$s.describe("scale.ticks",{_scriptable:t=>"backdropPadding"!==t&&"callback"!==t,_indexable:t=>"backdropPadding"!==t});const yc=(t,e,i)=>"top"===e||"left"===e?t[e]+i:t[e]-i;function Cc(t,e){const i=[],r=t.length/e,n=t.length;let o=0;for(;o<n;o+=r)i.push(t[Math.floor(o)]);return i}function kc(t,e,i){const r=t.ticks.length,n=Math.min(e,r-1),o=t._startPixel,a=t._endPixel,s=1e-6;let l,d=t.getPixelForTick(n);if(!(i&&(l=1===r?Math.max(d-o,a-d):0===e?(t.getPixelForTick(1)-d)/2:(d-t.getPixelForTick(n-1))/2,d+=n<e?l:-l,d<o-s||d>a+s)))return d}function Ac(t){return t.drawTicks?t.tickLength:0}function zc(t,e){if(!t.display)return 0;const i=qs(t.font,e),r=Ws(t.padding);return(Uo(t.text)?t.text.length:1)*i.lineHeight+r.height}function $c(t,e,i){let r=To(t);return(i&&"right"!==e||!i&&"right"===e)&&(r=(t=>"left"===t?"right":"right"===t?"left":t)(r)),r}class Mc extends mc{constructor(t){super(),this.id=t.id,this.type=t.type,this.options=void 0,this.ctx=t.ctx,this.chart=t.chart,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this._margins={left:0,right:0,top:0,bottom:0},this.maxWidth=void 0,this.maxHeight=void 0,this.paddingTop=void 0,this.paddingBottom=void 0,this.paddingLeft=void 0,this.paddingRight=void 0,this.axis=void 0,this.labelRotation=void 0,this.min=void 0,this.max=void 0,this._range=void 0,this.ticks=[],this._gridLineItems=null,this._labelItems=null,this._labelSizes=null,this._length=0,this._maxLength=0,this._longestTextCache={},this._startPixel=void 0,this._endPixel=void 0,this._reversePixels=!1,this._userMax=void 0,this._userMin=void 0,this._suggestedMax=void 0,this._suggestedMin=void 0,this._ticksLength=0,this._borderValue=0,this._cache={},this._dataLimitsCached=!1,this.$context=void 0}init(t){this.options=t.setContext(this.getContext()),this.axis=t.axis,this._userMin=this.parse(t.min),this._userMax=this.parse(t.max),this._suggestedMin=this.parse(t.suggestedMin),this._suggestedMax=this.parse(t.suggestedMax)}parse(t,e){return t}getUserBounds(){let{_userMin:t,_userMax:e,_suggestedMin:i,_suggestedMax:r}=this;return t=Go(t,Number.POSITIVE_INFINITY),e=Go(e,Number.NEGATIVE_INFINITY),i=Go(i,Number.POSITIVE_INFINITY),r=Go(r,Number.NEGATIVE_INFINITY),{min:Go(t,i),max:Go(e,r),minDefined:qo(t),maxDefined:qo(e)}}getMinMax(t){let e,{min:i,max:r,minDefined:n,maxDefined:o}=this.getUserBounds();if(n&&o)return{min:i,max:r};const a=this.getMatchingVisibleMetas();for(let s=0,l=a.length;s<l;++s)e=a[s].controller.getMinMax(this,t),n||(i=Math.min(i,e.min)),o||(r=Math.max(r,e.max));return i=o&&i>r?r:i,r=n&&i>r?i:r,{min:Go(i,Go(r,i)),max:Go(r,Go(i,r))}}getPadding(){return{left:this.paddingLeft||0,top:this.paddingTop||0,right:this.paddingRight||0,bottom:this.paddingBottom||0}}getTicks(){return this.ticks}getLabels(){const t=this.chart.data;return this.options.labels||(this.isHorizontal()?t.xLabels:t.yLabels)||t.labels||[]}beforeLayout(){this._cache={},this._dataLimitsCached=!1}beforeUpdate(){Ko(this.options.beforeUpdate,[this])}update(t,e,i){const{beginAtZero:r,grace:n,ticks:o}=this.options,a=o.sampleSize;this.beforeUpdate(),this.maxWidth=t,this.maxHeight=e,this._margins=i=Object.assign({left:0,right:0,top:0,bottom:0},i),this.ticks=null,this._labelSizes=null,this._gridLineItems=null,this._labelItems=null,this.beforeSetDimensions(),this.setDimensions(),this.afterSetDimensions(),this._maxLength=this.isHorizontal()?this.width+i.left+i.right:this.height+i.top+i.bottom,this._dataLimitsCached||(this.beforeDataLimits(),this.determineDataLimits(),this.afterDataLimits(),this._range=function(t,e,i){const{min:r,max:n}=t,o=Xo(e,(n-r)/2),a=(t,e)=>i&&0===t?0:t+e;return{min:a(r,-Math.abs(o)),max:a(n,o)}}(this,n,r),this._dataLimitsCached=!0),this.beforeBuildTicks(),this.ticks=this.buildTicks()||[],this.afterBuildTicks();const s=a<this.ticks.length;this._convertTicksToLabels(s?Cc(this.ticks,a):this.ticks),this.configure(),this.beforeCalculateLabelRotation(),this.calculateLabelRotation(),this.afterCalculateLabelRotation(),o.display&&(o.autoSkip||"auto"===o.source)&&(this.ticks=wc(this,this.ticks),this._labelSizes=null),s&&this._convertTicksToLabels(this.ticks),this.beforeFit(),this.fit(),this.afterFit(),this.afterUpdate()}configure(){let t,e,i=this.options.reverse;this.isHorizontal()?(t=this.left,e=this.right):(t=this.top,e=this.bottom,i=!i),this._startPixel=t,this._endPixel=e,this._reversePixels=i,this._length=e-t,this._alignToPixels=this.options.alignToPixels}afterUpdate(){Ko(this.options.afterUpdate,[this])}beforeSetDimensions(){Ko(this.options.beforeSetDimensions,[this])}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=0,this.right=this.width):(this.height=this.maxHeight,this.top=0,this.bottom=this.height),this.paddingLeft=0,this.paddingTop=0,this.paddingRight=0,this.paddingBottom=0}afterSetDimensions(){Ko(this.options.afterSetDimensions,[this])}_callHooks(t){this.chart.notifyPlugins(t,this.getContext()),Ko(this.options[t],[this])}beforeDataLimits(){this._callHooks("beforeDataLimits")}determineDataLimits(){}afterDataLimits(){this._callHooks("afterDataLimits")}beforeBuildTicks(){this._callHooks("beforeBuildTicks")}buildTicks(){return[]}afterBuildTicks(){this._callHooks("afterBuildTicks")}beforeTickToLabelConversion(){Ko(this.options.beforeTickToLabelConversion,[this])}generateTickLabels(t){const e=this.options.ticks;let i,r,n;for(i=0,r=t.length;i<r;i++)n=t[i],n.label=Ko(e.callback,[n.value,i,t],this)}afterTickToLabelConversion(){Ko(this.options.afterTickToLabelConversion,[this])}beforeCalculateLabelRotation(){Ko(this.options.beforeCalculateLabelRotation,[this])}calculateLabelRotation(){const t=this.options,e=t.ticks,i=this.ticks.length,r=e.minRotation||0,n=e.maxRotation;let o,a,s,l=r;if(!this._isVisible()||!e.display||r>=n||i<=1||!this.isHorizontal())return void(this.labelRotation=r);const d=this._getLabelSizes(),c=d.widest.width,h=d.highest.height,p=Ea(this.chart.width-c,0,this.maxWidth);o=t.offset?this.maxWidth/i:p/(i-1),c+6>o&&(o=p/(i-(t.offset?.5:1)),a=this.maxHeight-Ac(t.grid)-e.padding-zc(t.title,this.chart.options.font),s=Math.sqrt(c*c+h*h),l=Sa(Math.min(Math.asin(Ea((d.highest.height+6)/o,-1,1)),Math.asin(Ea(a/s,-1,1))-Math.asin(Ea(h/s,-1,1)))),l=Math.max(r,Math.min(n,l))),this.labelRotation=l}afterCalculateLabelRotation(){Ko(this.options.afterCalculateLabelRotation,[this])}beforeFit(){Ko(this.options.beforeFit,[this])}fit(){const t={width:0,height:0},{chart:e,options:{ticks:i,title:r,grid:n}}=this,o=this._isVisible(),a=this.isHorizontal();if(o){const o=zc(r,e.options.font);if(a?(t.width=this.maxWidth,t.height=Ac(n)+o):(t.height=this.maxHeight,t.width=Ac(n)+o),i.display&&this.ticks.length){const{first:e,last:r,widest:n,highest:o}=this._getLabelSizes(),s=2*i.padding,l=Ma(this.labelRotation),d=Math.cos(l),c=Math.sin(l);if(a){const e=i.mirror?0:c*n.width+d*o.height;t.height=Math.min(this.maxHeight,t.height+e+s)}else{const e=i.mirror?0:d*n.width+c*o.height;t.width=Math.min(this.maxWidth,t.width+e+s)}this._calculatePadding(e,r,c,d)}}this._handleMargins(),a?(this.width=this._length=e.width-this._margins.left-this._margins.right,this.height=t.height):(this.width=t.width,this.height=this._length=e.height-this._margins.top-this._margins.bottom)}_calculatePadding(t,e,i,r){const{ticks:{align:n,padding:o},position:a}=this.options,s=0!==this.labelRotation,l="top"!==a&&"x"===this.axis;if(this.isHorizontal()){const a=this.getPixelForTick(0)-this.left,d=this.right-this.getPixelForTick(this.ticks.length-1);let c=0,h=0;s?l?(c=r*t.width,h=i*e.height):(c=i*t.height,h=r*e.width):"start"===n?h=e.width:"end"===n?c=t.width:(c=t.width/2,h=e.width/2),this.paddingLeft=Math.max((c-a+o)*this.width/(this.width-a),0),this.paddingRight=Math.max((h-d+o)*this.width/(this.width-d),0)}else{let i=e.height/2,r=t.height/2;"start"===n?(i=0,r=t.height):"end"===n&&(i=e.height,r=0),this.paddingTop=i+o,this.paddingBottom=r+o}}_handleMargins(){this._margins&&(this._margins.left=Math.max(this.paddingLeft,this._margins.left),this._margins.top=Math.max(this.paddingTop,this._margins.top),this._margins.right=Math.max(this.paddingRight,this._margins.right),this._margins.bottom=Math.max(this.paddingBottom,this._margins.bottom))}afterFit(){Ko(this.options.afterFit,[this])}isHorizontal(){const{axis:t,position:e}=this.options;return"top"===e||"bottom"===e||"x"===t}isFullSize(){return this.options.fullSize}_convertTicksToLabels(t){let e,i;for(this.beforeTickToLabelConversion(),this.generateTickLabels(t),e=0,i=t.length;e<i;e++)Io(t[e].label)&&(t.splice(e,1),i--,e--);this.afterTickToLabelConversion()}_getLabelSizes(){let t=this._labelSizes;if(!t){const e=this.options.ticks.sampleSize;let i=this.ticks;e<i.length&&(i=Cc(i,e)),this._labelSizes=t=this._computeLabelSizes(i,i.length)}return t}_computeLabelSizes(t,e){const{ctx:i,_longestTextCache:r}=this,n=[],o=[];let a,s,l,d,c,h,p,u,g,f,m,b=0,v=0;for(a=0;a<e;++a){if(d=t[a].label,c=this._resolveTickFontOptions(a),i.font=h=c.string,p=r[h]=r[h]||{data:{},gc:[]},u=c.lineHeight,g=f=0,Io(d)||Uo(d)){if(Uo(d))for(s=0,l=d.length;s<l;++s)m=d[s],Io(m)||Uo(m)||(g=Ms(i,p.data,p.gc,g,m),f+=u)}else g=Ms(i,p.data,p.gc,g,d),f=u;n.push(g),o.push(f),b=Math.max(g,b),v=Math.max(f,v)}!function(t,e){Jo(t,(t=>{const i=t.gc,r=i.length/2;let n;if(r>e){for(n=0;n<r;++n)delete t.data[i[n]];i.splice(0,r)}}))}(r,e);const w=n.indexOf(b),x=o.indexOf(v),y=t=>({width:n[t]||0,height:o[t]||0});return{first:y(0),last:y(e-1),widest:y(w),highest:y(x),widths:n,heights:o}}getLabelForValue(t){return t}getPixelForValue(t,e){return NaN}getValueForPixel(t){}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getPixelForDecimal(t){this._reversePixels&&(t=1-t);const e=this._startPixel+t*this._length;return Ea(this._alignToPixels?Ls(this.chart,e,0):e,-32768,32767)}getDecimalForPixel(t){const e=(t-this._startPixel)/this._length;return this._reversePixels?1-e:e}getBasePixel(){return this.getPixelForValue(this.getBaseValue())}getBaseValue(){const{min:t,max:e}=this;return t<0&&e<0?e:t>0&&e>0?t:0}getContext(t){const e=this.ticks||[];if(t>=0&&t<e.length){const i=e[t];return i.$context||(i.$context=function(t,e,i){return Qs(t,{tick:i,index:e,type:"tick"})}(this.getContext(),t,i))}return this.$context||(this.$context=Qs(this.chart.getContext(),{scale:this,type:"scale"}))}_tickSize(){const t=this.options.ticks,e=Ma(this.labelRotation),i=Math.abs(Math.cos(e)),r=Math.abs(Math.sin(e)),n=this._getLabelSizes(),o=t.autoSkipPadding||0,a=n?n.widest.width+o:0,s=n?n.highest.height+o:0;return this.isHorizontal()?s*i>a*r?a/i:s/r:s*r<a*i?s/i:a/r}_isVisible(){const t=this.options.display;return"auto"!==t?!!t:this.getMatchingVisibleMetas().length>0}_computeGridLineItems(t){const e=this.axis,i=this.chart,r=this.options,{grid:n,position:o}=r,a=n.offset,s=this.isHorizontal(),l=this.ticks.length+(a?1:0),d=Ac(n),c=[],h=n.setContext(this.getContext()),p=h.drawBorder?h.borderWidth:0,u=p/2,g=function(t){return Ls(i,t,p)};let f,m,b,v,w,x,y,C,k,A,z,$;if("top"===o)f=g(this.bottom),x=this.bottom-d,C=f-u,A=g(t.top)+u,$=t.bottom;else if("bottom"===o)f=g(this.top),A=t.top,$=g(t.bottom)-u,x=f+u,C=this.top+d;else if("left"===o)f=g(this.right),w=this.right-d,y=f-u,k=g(t.left)+u,z=t.right;else if("right"===o)f=g(this.left),k=t.left,z=g(t.right)-u,w=f+u,y=this.left+d;else if("x"===e){if("center"===o)f=g((t.top+t.bottom)/2+.5);else if(Wo(o)){const t=Object.keys(o)[0],e=o[t];f=g(this.chart.scales[t].getPixelForValue(e))}A=t.top,$=t.bottom,x=f+u,C=x+d}else if("y"===e){if("center"===o)f=g((t.left+t.right)/2);else if(Wo(o)){const t=Object.keys(o)[0],e=o[t];f=g(this.chart.scales[t].getPixelForValue(e))}w=f-u,y=w-d,k=t.left,z=t.right}const M=Qo(r.ticks.maxTicksLimit,l),S=Math.max(1,Math.ceil(l/M));for(m=0;m<l;m+=S){const t=n.setContext(this.getContext(m)),e=t.lineWidth,r=t.color,o=n.borderDash||[],l=t.borderDashOffset,d=t.tickWidth,h=t.tickColor,p=t.tickBorderDash||[],u=t.tickBorderDashOffset;b=kc(this,m,a),void 0!==b&&(v=Ls(i,b,e),s?w=y=k=z=v:x=C=A=$=v,c.push({tx1:w,ty1:x,tx2:y,ty2:C,x1:k,y1:A,x2:z,y2:$,width:e,color:r,borderDash:o,borderDashOffset:l,tickWidth:d,tickColor:h,tickBorderDash:p,tickBorderDashOffset:u}))}return this._ticksLength=l,this._borderValue=f,c}_computeLabelItems(t){const e=this.axis,i=this.options,{position:r,ticks:n}=i,o=this.isHorizontal(),a=this.ticks,{align:s,crossAlign:l,padding:d,mirror:c}=n,h=Ac(i.grid),p=h+d,u=c?-d:p,g=-Ma(this.labelRotation),f=[];let m,b,v,w,x,y,C,k,A,z,$,M,S="middle";if("top"===r)y=this.bottom-u,C=this._getXAxisLabelAlignment();else if("bottom"===r)y=this.top+u,C=this._getXAxisLabelAlignment();else if("left"===r){const t=this._getYAxisLabelAlignment(h);C=t.textAlign,x=t.x}else if("right"===r){const t=this._getYAxisLabelAlignment(h);C=t.textAlign,x=t.x}else if("x"===e){if("center"===r)y=(t.top+t.bottom)/2+p;else if(Wo(r)){const t=Object.keys(r)[0],e=r[t];y=this.chart.scales[t].getPixelForValue(e)+p}C=this._getXAxisLabelAlignment()}else if("y"===e){if("center"===r)x=(t.left+t.right)/2-p;else if(Wo(r)){const t=Object.keys(r)[0],e=r[t];x=this.chart.scales[t].getPixelForValue(e)}C=this._getYAxisLabelAlignment(h).textAlign}"y"===e&&("start"===s?S="top":"end"===s&&(S="bottom"));const L=this._getLabelSizes();for(m=0,b=a.length;m<b;++m){v=a[m],w=v.label;const t=n.setContext(this.getContext(m));k=this.getPixelForTick(m)+n.labelOffset,A=this._resolveTickFontOptions(m),z=A.lineHeight,$=Uo(w)?w.length:1;const e=$/2,i=t.color,s=t.textStrokeColor,d=t.textStrokeWidth;let h;if(o?(x=k,M="top"===r?"near"===l||0!==g?-$*z+z/2:"center"===l?-L.highest.height/2-e*z+z:-L.highest.height+z/2:"near"===l||0!==g?z/2:"center"===l?L.highest.height/2-e*z:L.highest.height-$*z,c&&(M*=-1)):(y=k,M=(1-$)*z/2),t.showLabelBackdrop){const e=Ws(t.backdropPadding),i=L.heights[m],r=L.widths[m];let n=y+M-e.top,o=x-e.left;switch(S){case"middle":n-=i/2;break;case"bottom":n-=i}switch(C){case"center":o-=r/2;break;case"right":o-=r}h={left:o,top:n,width:r+e.width,height:i+e.height,color:t.backdropColor}}f.push({rotation:g,label:w,font:A,color:i,strokeColor:s,strokeWidth:d,textOffset:M,textAlign:C,textBaseline:S,translation:[x,y],backdrop:h})}return f}_getXAxisLabelAlignment(){const{position:t,ticks:e}=this.options;if(-Ma(this.labelRotation))return"top"===t?"left":"right";let i="center";return"start"===e.align?i="left":"end"===e.align&&(i="right"),i}_getYAxisLabelAlignment(t){const{position:e,ticks:{crossAlign:i,mirror:r,padding:n}}=this.options,o=t+n,a=this._getLabelSizes().widest.width;let s,l;return"left"===e?r?(l=this.right+n,"near"===i?s="left":"center"===i?(s="center",l+=a/2):(s="right",l+=a)):(l=this.right-o,"near"===i?s="right":"center"===i?(s="center",l-=a/2):(s="left",l=this.left)):"right"===e?r?(l=this.left+n,"near"===i?s="right":"center"===i?(s="center",l-=a/2):(s="left",l-=a)):(l=this.left+o,"near"===i?s="left":"center"===i?(s="center",l+=a/2):(s="right",l=this.right)):s="right",{textAlign:s,x:l}}_computeLabelArea(){if(this.options.ticks.mirror)return;const t=this.chart,e=this.options.position;return"left"===e||"right"===e?{top:0,left:this.left,bottom:t.height,right:this.right}:"top"===e||"bottom"===e?{top:this.top,left:0,bottom:this.bottom,right:t.width}:void 0}drawBackground(){const{ctx:t,options:{backgroundColor:e},left:i,top:r,width:n,height:o}=this;e&&(t.save(),t.fillStyle=e,t.fillRect(i,r,n,o),t.restore())}getLineWidthForValue(t){const e=this.options.grid;if(!this._isVisible()||!e.display)return 0;const i=this.ticks.findIndex((e=>e.value===t));if(i>=0){return e.setContext(this.getContext(i)).lineWidth}return 0}drawGrid(t){const e=this.options.grid,i=this.ctx,r=this._gridLineItems||(this._gridLineItems=this._computeGridLineItems(t));let n,o;const a=(t,e,r)=>{r.width&&r.color&&(i.save(),i.lineWidth=r.width,i.strokeStyle=r.color,i.setLineDash(r.borderDash||[]),i.lineDashOffset=r.borderDashOffset,i.beginPath(),i.moveTo(t.x,t.y),i.lineTo(e.x,e.y),i.stroke(),i.restore())};if(e.display)for(n=0,o=r.length;n<o;++n){const t=r[n];e.drawOnChartArea&&a({x:t.x1,y:t.y1},{x:t.x2,y:t.y2},t),e.drawTicks&&a({x:t.tx1,y:t.ty1},{x:t.tx2,y:t.ty2},{color:t.tickColor,width:t.tickWidth,borderDash:t.tickBorderDash,borderDashOffset:t.tickBorderDashOffset})}}drawBorder(){const{chart:t,ctx:e,options:{grid:i}}=this,r=i.setContext(this.getContext()),n=i.drawBorder?r.borderWidth:0;if(!n)return;const o=i.setContext(this.getContext(0)).lineWidth,a=this._borderValue;let s,l,d,c;this.isHorizontal()?(s=Ls(t,this.left,n)-n/2,l=Ls(t,this.right,o)+o/2,d=c=a):(d=Ls(t,this.top,n)-n/2,c=Ls(t,this.bottom,o)+o/2,s=l=a),e.save(),e.lineWidth=r.borderWidth,e.strokeStyle=r.borderColor,e.beginPath(),e.moveTo(s,d),e.lineTo(l,c),e.stroke(),e.restore()}drawLabels(t){if(!this.options.ticks.display)return;const e=this.ctx,i=this._computeLabelArea();i&&Fs(e,i);const r=this._labelItems||(this._labelItems=this._computeLabelItems(t));let n,o;for(n=0,o=r.length;n<o;++n){const t=r[n],i=t.font,o=t.label;t.backdrop&&(e.fillStyle=t.backdrop.color,e.fillRect(t.backdrop.left,t.backdrop.top,t.backdrop.width,t.backdrop.height)),Os(e,o,0,t.textOffset,i,t)}i&&Ds(e)}drawTitle(){const{ctx:t,options:{position:e,title:i,reverse:r}}=this;if(!i.display)return;const n=qs(i.font),o=Ws(i.padding),a=i.align;let s=n.lineHeight/2;"bottom"===e||"center"===e||Wo(e)?(s+=o.bottom,Uo(i.text)&&(s+=n.lineHeight*(i.text.length-1))):s+=o.top;const{titleX:l,titleY:d,maxWidth:c,rotation:h}=function(t,e,i,r){const{top:n,left:o,bottom:a,right:s,chart:l}=t,{chartArea:d,scales:c}=l;let h,p,u,g=0;const f=a-n,m=s-o;if(t.isHorizontal()){if(p=No(r,o,s),Wo(i)){const t=Object.keys(i)[0],r=i[t];u=c[t].getPixelForValue(r)+f-e}else u="center"===i?(d.bottom+d.top)/2+f-e:yc(t,i,e);h=s-o}else{if(Wo(i)){const t=Object.keys(i)[0],r=i[t];p=c[t].getPixelForValue(r)-m+e}else p="center"===i?(d.left+d.right)/2-m+e:yc(t,i,e);u=No(r,a,n),g="left"===i?-va:va}return{titleX:p,titleY:u,maxWidth:h,rotation:g}}(this,s,e,a);Os(t,i.text,0,0,n,{color:i.color,maxWidth:c,rotation:h,textAlign:$c(a,e,r),textBaseline:"middle",translation:[l,d]})}draw(t){this._isVisible()&&(this.drawBackground(),this.drawGrid(t),this.drawBorder(),this.drawTitle(),this.drawLabels(t))}_layers(){const t=this.options,e=t.ticks&&t.ticks.z||0,i=Qo(t.grid&&t.grid.z,-1);return this._isVisible()&&this.draw===Mc.prototype.draw?[{z:i,draw:t=>{this.drawBackground(),this.drawGrid(t),this.drawTitle()}},{z:i+1,draw:()=>{this.drawBorder()}},{z:e,draw:t=>{this.drawLabels(t)}}]:[{z:e,draw:t=>{this.draw(t)}}]}getMatchingVisibleMetas(t){const e=this.chart.getSortedVisibleDatasetMetas(),i=this.axis+"AxisID",r=[];let n,o;for(n=0,o=e.length;n<o;++n){const o=e[n];o[i]!==this.id||t&&o.type!==t||r.push(o)}return r}_resolveTickFontOptions(t){return qs(this.options.ticks.setContext(this.getContext(t)).font)}_maxDigits(){const t=this._resolveTickFontOptions(0).lineHeight;return(this.isHorizontal()?this.width:this.height)/t}}class Sc{constructor(t,e,i){this.type=t,this.scope=e,this.override=i,this.items=Object.create(null)}isForType(t){return Object.prototype.isPrototypeOf.call(this.type.prototype,t.prototype)}register(t){const e=Object.getPrototypeOf(t);let i;(function(t){return"id"in t&&"defaults"in t})(e)&&(i=this.register(e));const r=this.items,n=t.id,o=this.scope+"."+n;if(!n)throw new Error("class does not have id: "+t);return n in r||(r[n]=t,function(t,e,i){const r=na(Object.create(null),[i?$s.get(i):{},$s.get(e),t.defaults]);$s.set(e,r),t.defaultRoutes&&function(t,e){Object.keys(e).forEach((i=>{const r=i.split("."),n=r.pop(),o=[t].concat(r).join("."),a=e[i].split("."),s=a.pop(),l=a.join(".");$s.route(o,n,l,s)}))}(e,t.defaultRoutes);t.descriptors&&$s.describe(e,t.descriptors)}(t,o,i),this.override&&$s.override(t.id,t.overrides)),o}get(t){return this.items[t]}unregister(t){const e=this.items,i=t.id,r=this.scope;i in e&&delete e[i],r&&i in $s[r]&&(delete $s[r][i],this.override&&delete Cs[i])}}var Lc=new class{constructor(){this.controllers=new Sc(pd,"datasets",!0),this.elements=new Sc(mc,"elements"),this.plugins=new Sc(Object,"plugins"),this.scales=new Sc(Mc,"scales"),this._typedRegistries=[this.controllers,this.scales,this.elements]}add(...t){this._each("register",t)}remove(...t){this._each("unregister",t)}addControllers(...t){this._each("register",t,this.controllers)}addElements(...t){this._each("register",t,this.elements)}addPlugins(...t){this._each("register",t,this.plugins)}addScales(...t){this._each("register",t,this.scales)}getController(t){return this._get(t,this.controllers,"controller")}getElement(t){return this._get(t,this.elements,"element")}getPlugin(t){return this._get(t,this.plugins,"plugin")}getScale(t){return this._get(t,this.scales,"scale")}removeControllers(...t){this._each("unregister",t,this.controllers)}removeElements(...t){this._each("unregister",t,this.elements)}removePlugins(...t){this._each("unregister",t,this.plugins)}removeScales(...t){this._each("unregister",t,this.scales)}_each(t,e,i){[...e].forEach((e=>{const r=i||this._getRegistryForType(e);i||r.isForType(e)||r===this.plugins&&e.id?this._exec(t,r,e):Jo(e,(e=>{const r=i||this._getRegistryForType(e);this._exec(t,r,e)}))}))}_exec(t,e,i){const r=da(t);Ko(i["before"+r],[],i),e[t](i),Ko(i["after"+r],[],i)}_getRegistryForType(t){for(let e=0;e<this._typedRegistries.length;e++){const i=this._typedRegistries[e];if(i.isForType(t))return i}return this.plugins}_get(t,e,i){const r=e.get(t);if(void 0===r)throw new Error('"'+t+'" is not a registered '+i+".");return r}};class Hc{constructor(){this._init=[]}notify(t,e,i,r){"beforeInit"===e&&(this._init=this._createDescriptors(t,!0),this._notify(this._init,t,"install"));const n=r?this._descriptors(t).filter(r):this._descriptors(t),o=this._notify(n,t,e,i);return"afterDestroy"===e&&(this._notify(n,t,"stop"),this._notify(this._init,t,"uninstall")),o}_notify(t,e,i,r){r=r||{};for(const n of t){const t=n.plugin;if(!1===Ko(t[i],[e,r,n.options],t)&&r.cancelable)return!1}return!0}invalidate(){Io(this._cache)||(this._oldCache=this._cache,this._cache=void 0)}_descriptors(t){if(this._cache)return this._cache;const e=this._cache=this._createDescriptors(t);return this._notifyStateChanges(t),e}_createDescriptors(t,e){const i=t&&t.config,r=Qo(i.options&&i.options.plugins,{}),n=function(t){const e=[],i=Object.keys(Lc.plugins.items);for(let t=0;t<i.length;t++)e.push(Lc.getPlugin(i[t]));const r=t.plugins||[];for(let t=0;t<r.length;t++){const i=r[t];-1===e.indexOf(i)&&e.push(i)}return e}(i);return!1!==r||e?function(t,e,i,r){const n=[],o=t.getContext();for(let a=0;a<e.length;a++){const s=e[a],l=Bc(i[s.id],r);null!==l&&n.push({plugin:s,options:_c(t.config,s,l,o)})}return n}(t,n,r,e):[]}_notifyStateChanges(t){const e=this._oldCache||[],i=this._cache,r=(t,e)=>t.filter((t=>!e.some((e=>t.plugin.id===e.plugin.id))));this._notify(r(e,i),t,"stop"),this._notify(r(i,e),t,"start")}}function Bc(t,e){return e||!1!==t?!0===t?{}:t:null}function _c(t,e,i,r){const n=t.pluginScopeKeys(e),o=t.getOptionScopes(i,n);return t.createResolver(o,r,[""],{scriptable:!1,indexable:!1,allKeys:!0})}function Fc(t,e){const i=$s.datasets[t]||{};return((e.datasets||{})[t]||{}).indexAxis||e.indexAxis||i.indexAxis||"x"}function Dc(t,e){return"x"===t||"y"===t?t:e.axis||("top"===(i=e.position)||"bottom"===i?"x":"left"===i||"right"===i?"y":void 0)||t.charAt(0).toLowerCase();var i}function Ec(t){const e=t.options||(t.options={});e.plugins=Qo(e.plugins,{}),e.scales=function(t,e){const i=Cs[t.type]||{scales:{}},r=e.scales||{},n=Fc(t.type,e),o=Object.create(null),a=Object.create(null);return Object.keys(r).forEach((t=>{const e=r[t];if(!Wo(e))return console.error(`Invalid scale configuration for scale: ${t}`);if(e._proxy)return console.warn(`Ignoring resolver passed as options for scale: ${t}`);const s=Dc(t,e),l=function(t,e){return t===e?"_index_":"_value_"}(s,n),d=i.scales||{};o[s]=o[s]||t,a[t]=oa(Object.create(null),[{axis:s},e,d[s],d[l]])})),t.data.datasets.forEach((i=>{const n=i.type||t.type,s=i.indexAxis||Fc(n,e),l=(Cs[n]||{}).scales||{};Object.keys(l).forEach((t=>{const e=function(t,e){let i=t;return"_index_"===t?i=e:"_value_"===t&&(i="x"===e?"y":"x"),i}(t,s),n=i[e+"AxisID"]||o[e]||e;a[n]=a[n]||Object.create(null),oa(a[n],[{axis:e},r[n],l[t]])}))})),Object.keys(a).forEach((t=>{const e=a[t];oa(e,[$s.scales[e.type],$s.scale])})),a}(t,e)}function Vc(t){return(t=t||{}).datasets=t.datasets||[],t.labels=t.labels||[],t}const Oc=new Map,jc=new Set;function Zc(t,e){let i=Oc.get(t);return i||(i=e(),Oc.set(t,i),jc.add(i)),i}const Rc=(t,e,i)=>{const r=la(e,i);void 0!==r&&t.add(r)};class Tc{constructor(t){this._config=function(t){return(t=t||{}).data=Vc(t.data),Ec(t),t}(t),this._scopeCache=new Map,this._resolverCache=new Map}get platform(){return this._config.platform}get type(){return this._config.type}set type(t){this._config.type=t}get data(){return this._config.data}set data(t){this._config.data=Vc(t)}get options(){return this._config.options}set options(t){this._config.options=t}get plugins(){return this._config.plugins}update(){const t=this._config;this.clearCache(),Ec(t)}clearCache(){this._scopeCache.clear(),this._resolverCache.clear()}datasetScopeKeys(t){return Zc(t,(()=>[[`datasets.${t}`,""]]))}datasetAnimationScopeKeys(t,e){return Zc(`${t}.transition.${e}`,(()=>[[`datasets.${t}.transitions.${e}`,`transitions.${e}`],[`datasets.${t}`,""]]))}datasetElementScopeKeys(t,e){return Zc(`${t}-${e}`,(()=>[[`datasets.${t}.elements.${e}`,`datasets.${t}`,`elements.${e}`,""]]))}pluginScopeKeys(t){const e=t.id;return Zc(`${this.type}-plugin-${e}`,(()=>[[`plugins.${e}`,...t.additionalOptionScopes||[]]]))}_cachedScopes(t,e){const i=this._scopeCache;let r=i.get(t);return r&&!e||(r=new Map,i.set(t,r)),r}getOptionScopes(t,e,i){const{options:r,type:n}=this,o=this._cachedScopes(t,i),a=o.get(e);if(a)return a;const s=new Set;e.forEach((e=>{t&&(s.add(t),e.forEach((e=>Rc(s,t,e)))),e.forEach((t=>Rc(s,r,t))),e.forEach((t=>Rc(s,Cs[n]||{},t))),e.forEach((t=>Rc(s,$s,t))),e.forEach((t=>Rc(s,ks,t)))}));const l=Array.from(s);return 0===l.length&&l.push(Object.create(null)),jc.has(e)&&o.set(e,l),l}chartOptionScopes(){const{options:t,type:e}=this;return[t,Cs[e]||{},$s.datasets[e]||{},{type:e},$s,ks]}resolveNamedOptions(t,e,i,r=[""]){const n={$shared:!0},{resolver:o,subPrefixes:a}=Nc(this._resolverCache,t,r);let s=o;if(function(t,e){const{isScriptable:i,isIndexable:r}=ol(t);for(const n of e){const e=i(n),o=r(n),a=(o||e)&&t[n];if(e&&(ha(a)||Pc(a))||o&&Uo(a))return!0}return!1}(o,e)){n.$shared=!1;s=nl(o,i=ha(i)?i():i,this.createResolver(t,i,a))}for(const t of e)n[t]=s[t];return n}createResolver(t,e,i=[""],r){const{resolver:n}=Nc(this._resolverCache,t,i);return Wo(e)?nl(n,e,void 0,r):n}}function Nc(t,e,i){let r=t.get(e);r||(r=new Map,t.set(e,r));const n=i.join();let o=r.get(n);if(!o){o={resolver:rl(e,i),subPrefixes:i.filter((t=>!t.toLowerCase().includes("hover")))},r.set(n,o)}return o}const Pc=t=>Wo(t)&&Object.getOwnPropertyNames(t).reduce(((e,i)=>e||ha(t[i])),!1);const Yc=["top","bottom","left","right","chartArea"];function Ic(t,e){return"top"===t||"bottom"===t||-1===Yc.indexOf(t)&&"x"===e}function Uc(t,e){return function(i,r){return i[t]===r[t]?i[e]-r[e]:i[t]-r[t]}}function Wc(t){const e=t.chart,i=e.options.animation;e.notifyPlugins("afterRender"),Ko(i&&i.onComplete,[t],e)}function qc(t){const e=t.chart,i=e.options.animation;Ko(i&&i.onProgress,[t],e)}function Gc(t){return kl()&&"string"==typeof t?t=document.getElementById(t):t&&t.length&&(t=t[0]),t&&t.canvas&&(t=t.canvas),t}const Qc={},Xc=t=>{const e=Gc(t);return Object.values(Qc).filter((t=>t.canvas===e)).pop()};function Kc(t,e,i){const r=Object.keys(t);for(const n of r){const r=+n;if(r>=e){const o=t[n];delete t[n],(i>0||r>e)&&(t[r+i]=o)}}}class Jc{constructor(t,e){const i=this.config=new Tc(e),r=Gc(t),n=Xc(r);if(n)throw new Error("Canvas is already in use. Chart with ID '"+n.id+"' must be destroyed before the canvas can be reused.");const o=i.createResolver(i.chartOptionScopes(),this.getContext());this.platform=new(i.platform||function(t){return!kl()||"undefined"!=typeof OffscreenCanvas&&t instanceof OffscreenCanvas?ec:fc}(r)),this.platform.updateConfig(i);const a=this.platform.acquireContext(r,o.aspectRatio),s=a&&a.canvas,l=s&&s.height,d=s&&s.width;this.id=Yo(),this.ctx=a,this.canvas=s,this.width=d,this.height=l,this._options=o,this._aspectRatio=this.aspectRatio,this._layers=[],this._metasets=[],this._stacks=void 0,this.boxes=[],this.currentDevicePixelRatio=void 0,this.chartArea=void 0,this._active=[],this._lastEvent=void 0,this._listeners={},this._responsiveListeners=void 0,this._sortedMetasets=[],this.scales={},this._plugins=new Hc,this.$proxies={},this._hiddenIndices={},this.attached=!1,this._animationsDisabled=void 0,this.$context=void 0,this._doResize=function(t,e){let i;return function(...r){return e?(clearTimeout(i),i=setTimeout(t,e,r)):t.apply(this,r),e}}((t=>this.update(t)),o.resizeDelay||0),this._dataChanges=[],Qc[this.id]=this,a&&s?(Ql.listen(this,"complete",Wc),Ql.listen(this,"progress",qc),this._initialize(),this.attached&&this.update()):console.error("Failed to create chart: can't acquire context from the given item")}get aspectRatio(){const{options:{aspectRatio:t,maintainAspectRatio:e},width:i,height:r,_aspectRatio:n}=this;return Io(t)?e&&n?n:r?i/r:null:t}get data(){return this.config.data}set data(t){this.config.data=t}get options(){return this._options}set options(t){this.config.options=t}_initialize(){return this.notifyPlugins("beforeInit"),this.options.responsive?this.resize():_l(this,this.options.devicePixelRatio),this.bindEvents(),this.notifyPlugins("afterInit"),this}clear(){return Hs(this.canvas,this.ctx),this}stop(){return Ql.stop(this),this}resize(t,e){Ql.running(this)?this._resizeBeforeDraw={width:t,height:e}:this._resize(t,e)}_resize(t,e){const i=this.options,r=this.canvas,n=i.maintainAspectRatio&&this.aspectRatio,o=this.platform.getMaximumSize(r,t,e,n),a=i.devicePixelRatio||this.platform.getDevicePixelRatio(),s=this.width?"resize":"attach";this.width=o.width,this.height=o.height,this._aspectRatio=this.aspectRatio,_l(this,a,!0)&&(this.notifyPlugins("resize",{size:o}),Ko(i.onResize,[this,o],this),this.attached&&this._doResize(s)&&this.render())}ensureScalesHaveIDs(){Jo(this.options.scales||{},((t,e)=>{t.id=e}))}buildOrUpdateScales(){const t=this.options,e=t.scales,i=this.scales,r=Object.keys(i).reduce(((t,e)=>(t[e]=!1,t)),{});let n=[];e&&(n=n.concat(Object.keys(e).map((t=>{const i=e[t],r=Dc(t,i),n="r"===r,o="x"===r;return{options:i,dposition:n?"chartArea":o?"bottom":"left",dtype:n?"radialLinear":o?"category":"linear"}})))),Jo(n,(e=>{const n=e.options,o=n.id,a=Dc(o,n),s=Qo(n.type,e.dtype);void 0!==n.position&&Ic(n.position,a)===Ic(e.dposition)||(n.position=e.dposition),r[o]=!0;let l=null;if(o in i&&i[o].type===s)l=i[o];else{l=new(Lc.getScale(s))({id:o,type:s,ctx:this.ctx,chart:this}),i[l.id]=l}l.init(n,t)})),Jo(r,((t,e)=>{t||delete i[e]})),Jo(i,(t=>{Jd.configure(this,t,t.options),Jd.addBox(this,t)}))}_updateMetasets(){const t=this._metasets,e=this.data.datasets.length,i=t.length;if(t.sort(((t,e)=>t.index-e.index)),i>e){for(let t=e;t<i;++t)this._destroyDatasetMeta(t);t.splice(e,i-e)}this._sortedMetasets=t.slice(0).sort(Uc("order","index"))}_removeUnreferencedMetasets(){const{_metasets:t,data:{datasets:e}}=this;t.length>e.length&&delete this._stacks,t.forEach(((t,i)=>{0===e.filter((e=>e===t._dataset)).length&&this._destroyDatasetMeta(i)}))}buildOrUpdateControllers(){const t=[],e=this.data.datasets;let i,r;for(this._removeUnreferencedMetasets(),i=0,r=e.length;i<r;i++){const r=e[i];let n=this.getDatasetMeta(i);const o=r.type||this.config.type;if(n.type&&n.type!==o&&(this._destroyDatasetMeta(i),n=this.getDatasetMeta(i)),n.type=o,n.indexAxis=r.indexAxis||Fc(o,this.options),n.order=r.order||0,n.index=i,n.label=""+r.label,n.visible=this.isDatasetVisible(i),n.controller)n.controller.updateIndex(i),n.controller.linkScales();else{const e=Lc.getController(o),{datasetElementType:r,dataElementType:a}=$s.datasets[o];Object.assign(e.prototype,{dataElementType:Lc.getElement(a),datasetElementType:r&&Lc.getElement(r)}),n.controller=new e(this,i),t.push(n.controller)}}return this._updateMetasets(),t}_resetElements(){Jo(this.data.datasets,((t,e)=>{this.getDatasetMeta(e).controller.reset()}),this)}reset(){this._resetElements(),this.notifyPlugins("reset")}update(t){const e=this.config;e.update();const i=this._options=e.createResolver(e.chartOptionScopes(),this.getContext()),r=this._animationsDisabled=!i.animation;if(this._updateScales(),this._checkEventBindings(),this._updateHiddenIndices(),this._plugins.invalidate(),!1===this.notifyPlugins("beforeUpdate",{mode:t,cancelable:!0}))return;const n=this.buildOrUpdateControllers();this.notifyPlugins("beforeElementsUpdate");let o=0;for(let t=0,e=this.data.datasets.length;t<e;t++){const{controller:e}=this.getDatasetMeta(t),i=!r&&-1===n.indexOf(e);e.buildOrUpdateElements(i),o=Math.max(+e.getMaxOverflow(),o)}o=this._minPadding=i.layout.autoPadding?o:0,this._updateLayout(o),r||Jo(n,(t=>{t.reset()})),this._updateDatasets(t),this.notifyPlugins("afterUpdate",{mode:t}),this._layers.sort(Uc("z","_idx"));const{_active:a,_lastEvent:s}=this;s?this._eventHandler(s,!0):a.length&&this._updateHoverStyles(a,a,!0),this.render()}_updateScales(){Jo(this.scales,(t=>{Jd.removeBox(this,t)})),this.ensureScalesHaveIDs(),this.buildOrUpdateScales()}_checkEventBindings(){const t=this.options,e=new Set(Object.keys(this._listeners)),i=new Set(t.events);pa(e,i)&&!!this._responsiveListeners===t.responsive||(this.unbindEvents(),this.bindEvents())}_updateHiddenIndices(){const{_hiddenIndices:t}=this,e=this._getUniformDataChanges()||[];for(const{method:i,start:r,count:n}of e){Kc(t,r,"_removeElements"===i?-n:n)}}_getUniformDataChanges(){const t=this._dataChanges;if(!t||!t.length)return;this._dataChanges=[];const e=this.data.datasets.length,i=e=>new Set(t.filter((t=>t[0]===e)).map(((t,e)=>e+","+t.splice(1).join(",")))),r=i(0);for(let t=1;t<e;t++)if(!pa(r,i(t)))return;return Array.from(r).map((t=>t.split(","))).map((t=>({method:t[1],start:+t[2],count:+t[3]})))}_updateLayout(t){if(!1===this.notifyPlugins("beforeLayout",{cancelable:!0}))return;Jd.update(this,this.width,this.height,t);const e=this.chartArea,i=e.width<=0||e.height<=0;this._layers=[],Jo(this.boxes,(t=>{i&&"chartArea"===t.position||(t.configure&&t.configure(),this._layers.push(...t._layers()))}),this),this._layers.forEach(((t,e)=>{t._idx=e})),this.notifyPlugins("afterLayout")}_updateDatasets(t){if(!1!==this.notifyPlugins("beforeDatasetsUpdate",{mode:t,cancelable:!0})){for(let t=0,e=this.data.datasets.length;t<e;++t)this.getDatasetMeta(t).controller.configure();for(let e=0,i=this.data.datasets.length;e<i;++e)this._updateDataset(e,ha(t)?t({datasetIndex:e}):t);this.notifyPlugins("afterDatasetsUpdate",{mode:t})}}_updateDataset(t,e){const i=this.getDatasetMeta(t),r={meta:i,index:t,mode:e,cancelable:!0};!1!==this.notifyPlugins("beforeDatasetUpdate",r)&&(i.controller._update(e),r.cancelable=!1,this.notifyPlugins("afterDatasetUpdate",r))}render(){!1!==this.notifyPlugins("beforeRender",{cancelable:!0})&&(Ql.has(this)?this.attached&&!Ql.running(this)&&Ql.start(this):(this.draw(),Wc({chart:this})))}draw(){let t;if(this._resizeBeforeDraw){const{width:t,height:e}=this._resizeBeforeDraw;this._resize(t,e),this._resizeBeforeDraw=null}if(this.clear(),this.width<=0||this.height<=0)return;if(!1===this.notifyPlugins("beforeDraw",{cancelable:!0}))return;const e=this._layers;for(t=0;t<e.length&&e[t].z<=0;++t)e[t].draw(this.chartArea);for(this._drawDatasets();t<e.length;++t)e[t].draw(this.chartArea);this.notifyPlugins("afterDraw")}_getSortedDatasetMetas(t){const e=this._sortedMetasets,i=[];let r,n;for(r=0,n=e.length;r<n;++r){const n=e[r];t&&!n.visible||i.push(n)}return i}getSortedVisibleDatasetMetas(){return this._getSortedDatasetMetas(!0)}_drawDatasets(){if(!1===this.notifyPlugins("beforeDatasetsDraw",{cancelable:!0}))return;const t=this.getSortedVisibleDatasetMetas();for(let e=t.length-1;e>=0;--e)this._drawDataset(t[e]);this.notifyPlugins("afterDatasetsDraw")}_drawDataset(t){const e=this.ctx,i=t._clip,r=!i.disabled,n=this.chartArea,o={meta:t,index:t.index,cancelable:!0};!1!==this.notifyPlugins("beforeDatasetDraw",o)&&(r&&Fs(e,{left:!1===i.left?0:n.left-i.left,right:!1===i.right?this.width:n.right+i.right,top:!1===i.top?0:n.top-i.top,bottom:!1===i.bottom?this.height:n.bottom+i.bottom}),t.controller.draw(),r&&Ds(e),o.cancelable=!1,this.notifyPlugins("afterDatasetDraw",o))}getElementsAtEventForMode(t,e,i,r){const n=Rd.modes[e];return"function"==typeof n?n(this,t,i,r):[]}getDatasetMeta(t){const e=this.data.datasets[t],i=this._metasets;let r=i.filter((t=>t&&t._dataset===e)).pop();return r||(r={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null,order:e&&e.order||0,index:t,_dataset:e,_parsed:[],_sorted:!1},i.push(r)),r}getContext(){return this.$context||(this.$context=Qs(null,{chart:this,type:"chart"}))}getVisibleDatasetCount(){return this.getSortedVisibleDatasetMetas().length}isDatasetVisible(t){const e=this.data.datasets[t];if(!e)return!1;const i=this.getDatasetMeta(t);return"boolean"==typeof i.hidden?!i.hidden:!e.hidden}setDatasetVisibility(t,e){this.getDatasetMeta(t).hidden=!e}toggleDataVisibility(t){this._hiddenIndices[t]=!this._hiddenIndices[t]}getDataVisibility(t){return!this._hiddenIndices[t]}_updateVisibility(t,e,i){const r=i?"show":"hide",n=this.getDatasetMeta(t),o=n.controller._resolveAnimations(void 0,r);ca(e)?(n.data[e].hidden=!i,this.update()):(this.setDatasetVisibility(t,i),o.update(n,{visible:i}),this.update((e=>e.datasetIndex===t?r:void 0)))}hide(t,e){this._updateVisibility(t,e,!1)}show(t,e){this._updateVisibility(t,e,!0)}_destroyDatasetMeta(t){const e=this._metasets[t];e&&e.controller&&e.controller._destroy(),delete this._metasets[t]}_stop(){let t,e;for(this.stop(),Ql.remove(this),t=0,e=this.data.datasets.length;t<e;++t)this._destroyDatasetMeta(t)}destroy(){this.notifyPlugins("beforeDestroy");const{canvas:t,ctx:e}=this;this._stop(),this.config.clearCache(),t&&(this.unbindEvents(),Hs(t,e),this.platform.releaseContext(e),this.canvas=null,this.ctx=null),this.notifyPlugins("destroy"),delete Qc[this.id],this.notifyPlugins("afterDestroy")}toBase64Image(...t){return this.canvas.toDataURL(...t)}bindEvents(){this.bindUserEvents(),this.options.responsive?this.bindResponsiveEvents():this.attached=!0}bindUserEvents(){const t=this._listeners,e=this.platform,i=(i,r)=>{e.addEventListener(this,i,r),t[i]=r},r=(t,e,i)=>{t.offsetX=e,t.offsetY=i,this._eventHandler(t)};Jo(this.options.events,(t=>i(t,r)))}bindResponsiveEvents(){this._responsiveListeners||(this._responsiveListeners={});const t=this._responsiveListeners,e=this.platform,i=(i,r)=>{e.addEventListener(this,i,r),t[i]=r},r=(i,r)=>{t[i]&&(e.removeEventListener(this,i,r),delete t[i])},n=(t,e)=>{this.canvas&&this.resize(t,e)};let o;const a=()=>{r("attach",a),this.attached=!0,this.resize(),i("resize",n),i("detach",o)};o=()=>{this.attached=!1,r("resize",n),this._stop(),this._resize(0,0),i("attach",a)},e.isAttached(this.canvas)?a():o()}unbindEvents(){Jo(this._listeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._listeners={},Jo(this._responsiveListeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._responsiveListeners=void 0}updateHoverStyle(t,e,i){const r=i?"set":"remove";let n,o,a,s;for("dataset"===e&&(n=this.getDatasetMeta(t[0].datasetIndex),n.controller["_"+r+"DatasetHoverStyle"]()),a=0,s=t.length;a<s;++a){o=t[a];const e=o&&this.getDatasetMeta(o.datasetIndex).controller;e&&e[r+"HoverStyle"](o.element,o.datasetIndex,o.index)}}getActiveElements(){return this._active||[]}setActiveElements(t){const e=this._active||[],i=t.map((({datasetIndex:t,index:e})=>{const i=this.getDatasetMeta(t);if(!i)throw new Error("No dataset found at index "+t);return{datasetIndex:t,element:i.data[e],index:e}}));!ta(i,e)&&(this._active=i,this._lastEvent=null,this._updateHoverStyles(i,e))}notifyPlugins(t,e,i){return this._plugins.notify(this,t,e,i)}_updateHoverStyles(t,e,i){const r=this.options.hover,n=(t,e)=>t.filter((t=>!e.some((e=>t.datasetIndex===e.datasetIndex&&t.index===e.index)))),o=n(e,t),a=i?t:n(t,e);o.length&&this.updateHoverStyle(o,r.mode,!1),a.length&&r.mode&&this.updateHoverStyle(a,r.mode,!0)}_eventHandler(t,e){const i={event:t,replay:e,cancelable:!0,inChartArea:_s(t,this.chartArea,this._minPadding)},r=e=>(e.options.events||this.options.events).includes(t.native.type);if(!1===this.notifyPlugins("beforeEvent",i,r))return;const n=this._handleEvent(t,e,i.inChartArea);return i.cancelable=!1,this.notifyPlugins("afterEvent",i,r),(n||i.changed)&&this.render(),this}_handleEvent(t,e,i){const{_active:r=[],options:n}=this,o=e,a=this._getActiveElements(t,r,i,o),s=function(t){return"mouseup"===t.type||"click"===t.type||"contextmenu"===t.type}(t),l=function(t,e,i,r){return i&&"mouseout"!==t.type?r?e:t:null}(t,this._lastEvent,i,s);i&&(this._lastEvent=null,Ko(n.onHover,[t,a,this],this),s&&Ko(n.onClick,[t,a,this],this));const d=!ta(a,r);return(d||e)&&(this._active=a,this._updateHoverStyles(a,r,e)),this._lastEvent=l,d}_getActiveElements(t,e,i,r){if("mouseout"===t.type)return[];if(!i)return e;const n=this.options.hover;return this.getElementsAtEventForMode(t,n.mode,n,r)}}const th=()=>Jo(Jc.instances,(t=>t._plugins.invalidate()));function eh(t,e,i){const{startAngle:r,pixelMargin:n,x:o,y:a,outerRadius:s,innerRadius:l}=e;let d=n/s;t.beginPath(),t.arc(o,a,s,r-d,i+d),l>n?(d=n/l,t.arc(o,a,l,i+d,r-d,!0)):t.arc(o,a,n,i+va,r-va),t.closePath(),t.clip()}function ih(t,e,i,r){const n=Ys(t.options.borderRadius,["outerStart","outerEnd","innerStart","innerEnd"]);const o=(i-e)/2,a=Math.min(o,r*e/2),s=t=>{const e=(i-Math.min(o,t))*r/2;return Ea(t,0,Math.min(o,e))};return{outerStart:s(n.outerStart),outerEnd:s(n.outerEnd),innerStart:Ea(n.innerStart,0,a),innerEnd:Ea(n.innerEnd,0,a)}}function rh(t,e,i,r){return{x:i+t*Math.cos(e),y:r+t*Math.sin(e)}}function nh(t,e,i,r,n){const{x:o,y:a,startAngle:s,pixelMargin:l,innerRadius:d}=e,c=Math.max(e.outerRadius+r+i-l,0),h=d>0?d+r+i+l:0;let p=0;const u=n-s;if(r){const t=((d>0?d-r:0)+(c>0?c-r:0))/2;p=(u-(0!==t?u*t/(t+r):u))/2}const g=(u-Math.max(.001,u*c-i/ua)/c)/2,f=s+g+p,m=n-g-p,{outerStart:b,outerEnd:v,innerStart:w,innerEnd:x}=ih(e,h,c,m-f),y=c-b,C=c-v,k=f+b/y,A=m-v/C,z=h+w,$=h+x,M=f+w/z,S=m-x/$;if(t.beginPath(),t.arc(o,a,c,k,A),v>0){const e=rh(C,A,o,a);t.arc(e.x,e.y,v,A,m+va)}const L=rh($,m,o,a);if(t.lineTo(L.x,L.y),x>0){const e=rh($,S,o,a);t.arc(e.x,e.y,x,m+va,S+Math.PI)}if(t.arc(o,a,h,m-x/h,f+w/h,!0),w>0){const e=rh(z,M,o,a);t.arc(e.x,e.y,w,M+Math.PI,f-va)}const H=rh(y,f,o,a);if(t.lineTo(H.x,H.y),b>0){const e=rh(y,k,o,a);t.arc(e.x,e.y,b,f-va,k)}t.closePath()}function oh(t,e,i,r,n){const{options:o}=e,{borderWidth:a,borderJoinStyle:s}=o,l="inner"===o.borderAlign;a&&(l?(t.lineWidth=2*a,t.lineJoin=s||"round"):(t.lineWidth=a,t.lineJoin=s||"bevel"),e.fullCircles&&function(t,e,i){const{x:r,y:n,startAngle:o,pixelMargin:a,fullCircles:s}=e,l=Math.max(e.outerRadius-a,0),d=e.innerRadius+a;let c;for(i&&eh(t,e,o+ga),t.beginPath(),t.arc(r,n,d,o+ga,o,!0),c=0;c<s;++c)t.stroke();for(t.beginPath(),t.arc(r,n,l,o,o+ga),c=0;c<s;++c)t.stroke()}(t,e,l),l&&eh(t,e,n),nh(t,e,i,r,n),t.stroke())}Object.defineProperties(Jc,{defaults:{enumerable:true,value:$s},instances:{enumerable:true,value:Qc},overrides:{enumerable:true,value:Cs},registry:{enumerable:true,value:Lc},version:{enumerable:true,value:"3.7.1"},getChart:{enumerable:true,value:Xc},register:{enumerable:true,value:(...t)=>{Lc.add(...t),th()}},unregister:{enumerable:true,value:(...t)=>{Lc.remove(...t),th()}}});class ah extends mc{constructor(t){super(),this.options=void 0,this.circumference=void 0,this.startAngle=void 0,this.endAngle=void 0,this.innerRadius=void 0,this.outerRadius=void 0,this.pixelMargin=0,this.fullCircles=0,t&&Object.assign(this,t)}inRange(t,e,i){const r=this.getProps(["x","y"],i),{angle:n,distance:o}=Ha(r,{x:t,y:e}),{startAngle:a,endAngle:s,innerRadius:l,outerRadius:d,circumference:c}=this.getProps(["startAngle","endAngle","innerRadius","outerRadius","circumference"],i),h=this.options.spacing/2,p=Qo(c,s-a)>=ga||Da(n,a,s),u=Va(o,l+h,d+h);return p&&u}getCenterPoint(t){const{x:e,y:i,startAngle:r,endAngle:n,innerRadius:o,outerRadius:a}=this.getProps(["x","y","startAngle","endAngle","innerRadius","outerRadius","circumference"],t),{offset:s,spacing:l}=this.options,d=(r+n)/2,c=(o+a+l+s)/2;return{x:e+Math.cos(d)*c,y:i+Math.sin(d)*c}}tooltipPosition(t){return this.getCenterPoint(t)}draw(t){const{options:e,circumference:i}=this,r=(e.offset||0)/2,n=(e.spacing||0)/2;if(this.pixelMargin="inner"===e.borderAlign?.33:0,this.fullCircles=i>ga?Math.floor(i/ga):0,0===i||this.innerRadius<0||this.outerRadius<0)return;t.save();let o=0;if(r){o=r/2;const e=(this.startAngle+this.endAngle)/2;t.translate(Math.cos(e)*o,Math.sin(e)*o),this.circumference>=ua&&(o=r)}t.fillStyle=e.backgroundColor,t.strokeStyle=e.borderColor;const a=function(t,e,i,r){const{fullCircles:n,startAngle:o,circumference:a}=e;let s=e.endAngle;if(n){nh(t,e,i,r,o+ga);for(let e=0;e<n;++e)t.fill();isNaN(a)||(s=o+a%ga,a%ga==0&&(s+=ga))}return nh(t,e,i,r,s),t.fill(),s}(t,this,o,n);oh(t,this,o,n,a),t.restore()}}function sh(t,e,i=e){t.lineCap=Qo(i.borderCapStyle,e.borderCapStyle),t.setLineDash(Qo(i.borderDash,e.borderDash)),t.lineDashOffset=Qo(i.borderDashOffset,e.borderDashOffset),t.lineJoin=Qo(i.borderJoinStyle,e.borderJoinStyle),t.lineWidth=Qo(i.borderWidth,e.borderWidth),t.strokeStyle=Qo(i.borderColor,e.borderColor)}function lh(t,e,i){t.lineTo(i.x,i.y)}function dh(t,e,i={}){const r=t.length,{start:n=0,end:o=r-1}=i,{start:a,end:s}=e,l=Math.max(n,a),d=Math.min(o,s),c=n<a&&o<a||n>s&&o>s;return{count:r,start:l,loop:e.loop,ilen:d<l&&!c?r+d-l:d-l}}function ch(t,e,i,r){const{points:n,options:o}=e,{count:a,start:s,loop:l,ilen:d}=dh(n,i,r),c=function(t){return t.stepped?Es:t.tension||"monotone"===t.cubicInterpolationMode?Vs:lh}(o);let h,p,u,{move:g=!0,reverse:f}=r||{};for(h=0;h<=d;++h)p=n[(s+(f?d-h:h))%a],p.skip||(g?(t.moveTo(p.x,p.y),g=!1):c(t,u,p,f,o.stepped),u=p);return l&&(p=n[(s+(f?d:0))%a],c(t,u,p,f,o.stepped)),!!l}function hh(t,e,i,r){const n=e.points,{count:o,start:a,ilen:s}=dh(n,i,r),{move:l=!0,reverse:d}=r||{};let c,h,p,u,g,f,m=0,b=0;const v=t=>(a+(d?s-t:t))%o,w=()=>{u!==g&&(t.lineTo(m,g),t.lineTo(m,u),t.lineTo(m,f))};for(l&&(h=n[v(0)],t.moveTo(h.x,h.y)),c=0;c<=s;++c){if(h=n[v(c)],h.skip)continue;const e=h.x,i=h.y,r=0|e;r===p?(i<u?u=i:i>g&&(g=i),m=(b*m+e)/++b):(w(),t.lineTo(e,i),p=r,b=0,u=g=i),f=i}w()}function ph(t){const e=t.options,i=e.borderDash&&e.borderDash.length;return!(t._decimated||t._loop||e.tension||"monotone"===e.cubicInterpolationMode||e.stepped||i)?hh:ch}ah.id="arc",ah.defaults={borderAlign:"center",borderColor:"#fff",borderJoinStyle:void 0,borderRadius:0,borderWidth:2,offset:0,spacing:0,angle:void 0},ah.defaultRoutes={backgroundColor:"backgroundColor"};const uh="function"==typeof Path2D;function gh(t,e,i,r){uh&&!e.options.segment?function(t,e,i,r){let n=e._path;n||(n=e._path=new Path2D,e.path(n,i,r)&&n.closePath()),sh(t,e.options),t.stroke(n)}(t,e,i,r):function(t,e,i,r){const{segments:n,options:o}=e,a=ph(e);for(const s of n)sh(t,o,s.style),t.beginPath(),a(t,e,s,{start:i,end:i+r-1})&&t.closePath(),t.stroke()}(t,e,i,r)}class fh extends mc{constructor(t){super(),this.animated=!0,this.options=void 0,this._chart=void 0,this._loop=void 0,this._fullLoop=void 0,this._path=void 0,this._points=void 0,this._segments=void 0,this._decimated=!1,this._pointsUpdated=!1,this._datasetIndex=void 0,t&&Object.assign(this,t)}updateControlPoints(t,e){const i=this.options;if((i.tension||"monotone"===i.cubicInterpolationMode)&&!i.stepped&&!this._pointsUpdated){const r=i.spanGaps?this._loop:this._fullLoop;Cl(this._points,i,t,r,e),this._pointsUpdated=!0}}set points(t){this._points=t,delete this._segments,delete this._path,this._pointsUpdated=!1}get points(){return this._points}get segments(){return this._segments||(this._segments=function(t,e){const i=t.points,r=t.options.spanGaps,n=i.length;if(!n)return[];const o=!!t._loop,{start:a,end:s}=function(t,e,i,r){let n=0,o=e-1;if(i&&!r)for(;n<e&&!t[n].skip;)n++;for(;n<e&&t[n].skip;)n++;for(n%=e,i&&(o+=n);o>n&&t[o%e].skip;)o--;return o%=e,{start:n,end:o}}(i,n,o,r);return Wl(t,!0===r?[{start:a,end:s,loop:o}]:function(t,e,i,r){const n=t.length,o=[];let a,s=e,l=t[e];for(a=e+1;a<=i;++a){const i=t[a%n];i.skip||i.stop?l.skip||(r=!1,o.push({start:e%n,end:(a-1)%n,loop:r}),e=s=i.stop?a:null):(s=a,l.skip&&(e=a)),l=i}return null!==s&&o.push({start:e%n,end:s%n,loop:r}),o}(i,a,s<a?s+n:s,!!t._fullLoop&&0===a&&s===n-1),i,e)}(this,this.options.segment))}first(){const t=this.segments,e=this.points;return t.length&&e[t[0].start]}last(){const t=this.segments,e=this.points,i=t.length;return i&&e[t[i-1].end]}interpolate(t,e){const i=this.options,r=t[e],n=this.points,o=Ul(this,{property:e,start:r,end:r});if(!o.length)return;const a=[],s=function(t){return t.stepped?Vl:t.tension||"monotone"===t.cubicInterpolationMode?Ol:El}(i);let l,d;for(l=0,d=o.length;l<d;++l){const{start:d,end:c}=o[l],h=n[d],p=n[c];if(h===p){a.push(h);continue}const u=s(h,p,Math.abs((r-h[e])/(p[e]-h[e])),i.stepped);u[e]=t[e],a.push(u)}return 1===a.length?a[0]:a}pathSegment(t,e,i){return ph(this)(t,this,e,i)}path(t,e,i){const r=this.segments,n=ph(this);let o=this._loop;e=e||0,i=i||this.points.length-e;for(const a of r)o&=n(t,this,a,{start:e,end:e+i-1});return!!o}draw(t,e,i,r){const n=this.options||{};(this.points||[]).length&&n.borderWidth&&(t.save(),gh(t,this,i,r),t.restore()),this.animated&&(this._pointsUpdated=!1,this._path=void 0)}}function mh(t,e,i,r){const n=t.options,{[i]:o}=t.getProps([i],r);return Math.abs(e-o)<n.radius+n.hitRadius}fh.id="line",fh.defaults={borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",borderWidth:3,capBezierPoints:!0,cubicInterpolationMode:"default",fill:!1,spanGaps:!1,stepped:!1,tension:0},fh.defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"},fh.descriptors={_scriptable:!0,_indexable:t=>"borderDash"!==t&&"fill"!==t};class bh extends mc{constructor(t){super(),this.options=void 0,this.parsed=void 0,this.skip=void 0,this.stop=void 0,t&&Object.assign(this,t)}inRange(t,e,i){const r=this.options,{x:n,y:o}=this.getProps(["x","y"],i);return Math.pow(t-n,2)+Math.pow(e-o,2)<Math.pow(r.hitRadius+r.radius,2)}inXRange(t,e){return mh(this,t,"x",e)}inYRange(t,e){return mh(this,t,"y",e)}getCenterPoint(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}size(t){let e=(t=t||this.options||{}).radius||0;e=Math.max(e,e&&t.hoverRadius||0);return 2*(e+(e&&t.borderWidth||0))}draw(t,e){const i=this.options;this.skip||i.radius<.1||!_s(this,e,this.size(i)/2)||(t.strokeStyle=i.borderColor,t.lineWidth=i.borderWidth,t.fillStyle=i.backgroundColor,Bs(t,i,this.x,this.y))}getRange(){const t=this.options||{};return t.radius+t.hitRadius}}function vh(t,e){const{x:i,y:r,base:n,width:o,height:a}=t.getProps(["x","y","base","width","height"],e);let s,l,d,c,h;return t.horizontal?(h=a/2,s=Math.min(i,n),l=Math.max(i,n),d=r-h,c=r+h):(h=o/2,s=i-h,l=i+h,d=Math.min(r,n),c=Math.max(r,n)),{left:s,top:d,right:l,bottom:c}}function wh(t,e,i,r){return t?0:Ea(e,i,r)}function xh(t){const e=vh(t),i=e.right-e.left,r=e.bottom-e.top,n=function(t,e,i){const r=t.options.borderWidth,n=t.borderSkipped,o=Is(r);return{t:wh(n.top,o.top,0,i),r:wh(n.right,o.right,0,e),b:wh(n.bottom,o.bottom,0,i),l:wh(n.left,o.left,0,e)}}(t,i/2,r/2),o=function(t,e,i){const{enableBorderRadius:r}=t.getProps(["enableBorderRadius"]),n=t.options.borderRadius,o=Us(n),a=Math.min(e,i),s=t.borderSkipped,l=r||Wo(n);return{topLeft:wh(!l||s.top||s.left,o.topLeft,0,a),topRight:wh(!l||s.top||s.right,o.topRight,0,a),bottomLeft:wh(!l||s.bottom||s.left,o.bottomLeft,0,a),bottomRight:wh(!l||s.bottom||s.right,o.bottomRight,0,a)}}(t,i/2,r/2);return{outer:{x:e.left,y:e.top,w:i,h:r,radius:o},inner:{x:e.left+n.l,y:e.top+n.t,w:i-n.l-n.r,h:r-n.t-n.b,radius:{topLeft:Math.max(0,o.topLeft-Math.max(n.t,n.l)),topRight:Math.max(0,o.topRight-Math.max(n.t,n.r)),bottomLeft:Math.max(0,o.bottomLeft-Math.max(n.b,n.l)),bottomRight:Math.max(0,o.bottomRight-Math.max(n.b,n.r))}}}}function yh(t,e,i,r){const n=null===e,o=null===i,a=t&&!(n&&o)&&vh(t,r);return a&&(n||Va(e,a.left,a.right))&&(o||Va(i,a.top,a.bottom))}function Ch(t,e){t.rect(e.x,e.y,e.w,e.h)}function kh(t,e,i={}){const r=t.x!==i.x?-e:0,n=t.y!==i.y?-e:0,o=(t.x+t.w!==i.x+i.w?e:0)-r,a=(t.y+t.h!==i.y+i.h?e:0)-n;return{x:t.x+r,y:t.y+n,w:t.w+o,h:t.h+a,radius:t.radius}}bh.id="point",bh.defaults={borderWidth:1,hitRadius:1,hoverBorderWidth:1,hoverRadius:4,pointStyle:"circle",radius:3,rotation:0},bh.defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};class Ah extends mc{constructor(t){super(),this.options=void 0,this.horizontal=void 0,this.base=void 0,this.width=void 0,this.height=void 0,this.inflateAmount=void 0,t&&Object.assign(this,t)}draw(t){const{inflateAmount:e,options:{borderColor:i,backgroundColor:r}}=this,{inner:n,outer:o}=xh(this),a=(s=o.radius).topLeft||s.topRight||s.bottomLeft||s.bottomRight?Zs:Ch;var s;t.save(),o.w===n.w&&o.h===n.h||(t.beginPath(),a(t,kh(o,e,n)),t.clip(),a(t,kh(n,-e,o)),t.fillStyle=i,t.fill("evenodd")),t.beginPath(),a(t,kh(n,e)),t.fillStyle=r,t.fill(),t.restore()}inRange(t,e,i){return yh(this,t,e,i)}inXRange(t,e){return yh(this,t,null,e)}inYRange(t,e){return yh(this,null,t,e)}getCenterPoint(t){const{x:e,y:i,base:r,horizontal:n}=this.getProps(["x","y","base","horizontal"],t);return{x:n?(e+r)/2:e,y:n?i:(i+r)/2}}getRange(t){return"x"===t?this.width/2:this.height/2}}Ah.id="bar",Ah.defaults={borderSkipped:"start",borderWidth:0,borderRadius:0,inflateAmount:"auto",pointStyle:void 0},Ah.defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};var zh=Object.freeze({__proto__:null,ArcElement:ah,LineElement:fh,PointElement:bh,BarElement:Ah});function $h(t){if(t._decimated){const e=t._data;delete t._decimated,delete t._data,Object.defineProperty(t,"data",{value:e})}}function Mh(t){t.data.datasets.forEach((t=>{$h(t)}))}var Sh={id:"decimation",defaults:{algorithm:"min-max",enabled:!1},beforeElementsUpdate:(t,e,i)=>{if(!i.enabled)return void Mh(t);const r=t.width;t.data.datasets.forEach(((e,n)=>{const{_data:o,indexAxis:a}=e,s=t.getDatasetMeta(n),l=o||e.data;if("y"===Gs([a,t.options.indexAxis]))return;if("line"!==s.type)return;const d=t.scales[s.xAxisID];if("linear"!==d.type&&"time"!==d.type)return;if(t.options.parsing)return;let{start:c,count:h}=function(t,e){const i=e.length;let r,n=0;const{iScale:o}=t,{min:a,max:s,minDefined:l,maxDefined:d}=o.getUserBounds();return l&&(n=Ea(Ks(e,o.axis,a).lo,0,i-1)),r=d?Ea(Ks(e,o.axis,s).hi+1,n,i)-n:i-n,{start:n,count:r}}(s,l);if(h<=(i.threshold||4*r))return void $h(e);let p;switch(Io(o)&&(e._data=l,delete e.data,Object.defineProperty(e,"data",{configurable:!0,enumerable:!0,get:function(){return this._decimated},set:function(t){this._data=t}})),i.algorithm){case"lttb":p=function(t,e,i,r,n){const o=n.samples||r;if(o>=i)return t.slice(e,e+i);const a=[],s=(i-2)/(o-2);let l=0;const d=e+i-1;let c,h,p,u,g,f=e;for(a[l++]=t[f],c=0;c<o-2;c++){let r,n=0,o=0;const d=Math.floor((c+1)*s)+1+e,m=Math.min(Math.floor((c+2)*s)+1,i)+e,b=m-d;for(r=d;r<m;r++)n+=t[r].x,o+=t[r].y;n/=b,o/=b;const v=Math.floor(c*s)+1+e,w=Math.min(Math.floor((c+1)*s)+1,i)+e,{x,y}=t[f];for(p=u=-1,r=v;r<w;r++)u=.5*Math.abs((x-n)*(t[r].y-y)-(x-t[r].x)*(o-y)),u>p&&(p=u,h=t[r],g=r);a[l++]=h,f=g}return a[l++]=t[d],a}(l,c,h,r,i);break;case"min-max":p=function(t,e,i,r){let n,o,a,s,l,d,c,h,p,u,g=0,f=0;const m=[],b=e+i-1,v=t[e].x,w=t[b].x-v;for(n=e;n<e+i;++n){o=t[n],a=(o.x-v)/w*r,s=o.y;const e=0|a;if(e===l)s<p?(p=s,d=n):s>u&&(u=s,c=n),g=(f*g+o.x)/++f;else{const i=n-1;if(!Io(d)&&!Io(c)){const e=Math.min(d,c),r=Math.max(d,c);e!==h&&e!==i&&m.push({...t[e],x:g}),r!==h&&r!==i&&m.push({...t[r],x:g})}n>0&&i!==h&&m.push(t[i]),m.push(o),l=e,f=0,p=u=s,d=c=h=n}}return m}(l,c,h,r);break;default:throw new Error(`Unsupported decimation algorithm '${i.algorithm}'`)}e._decimated=p}))},destroy(t){Mh(t)}};function Lh(t,e,i){const r=function(t){const e=t.options,i=e.fill;let r=Qo(i&&i.target,i);return void 0===r&&(r=!!e.backgroundColor),!1!==r&&null!==r&&(!0===r?"origin":r)}(t);if(Wo(r))return!isNaN(r.value)&&r;let n=parseFloat(r);return qo(n)&&Math.floor(n)===n?("-"!==r[0]&&"+"!==r[0]||(n=e+n),!(n===e||n<0||n>=i)&&n):["origin","start","end","stack","shape"].indexOf(r)>=0&&r}class Hh{constructor(t){this.x=t.x,this.y=t.y,this.radius=t.radius}pathSegment(t,e,i){const{x:r,y:n,radius:o}=this;return e=e||{start:0,end:ga},t.arc(r,n,o,e.end,e.start,!0),!i.bounds}interpolate(t){const{x:e,y:i,radius:r}=this,n=t.angle;return{x:e+Math.cos(n)*r,y:i+Math.sin(n)*r,angle:n}}}function Bh(t){return(t.scale||{}).getPointPositionForValue?function(t){const{scale:e,fill:i}=t,r=e.options,n=e.getLabels().length,o=[],a=r.reverse?e.max:e.min,s=r.reverse?e.min:e.max;let l,d,c;if(c="start"===i?a:"end"===i?s:Wo(i)?i.value:e.getBaseValue(),r.grid.circular)return d=e.getPointPositionForValue(0,a),new Hh({x:d.x,y:d.y,radius:e.getDistanceFromCenterForValue(c)});for(l=0;l<n;++l)o.push(e.getPointPositionForValue(l,c));return o}(t):function(t){const{scale:e={},fill:i}=t;let r,n=null;return"start"===i?n=e.bottom:"end"===i?n=e.top:Wo(i)?n=e.getPixelForValue(i.value):e.getBasePixel&&(n=e.getBasePixel()),qo(n)?(r=e.isHorizontal(),{x:r?n:null,y:r?null:n}):null}(t)}function _h(t,e,i){for(;e>t;e--){const t=i[e];if(!isNaN(t.x)&&!isNaN(t.y))break}return e}function Fh(t,e,i){const r=[];for(let n=0;n<i.length;n++){const o=i[n],{first:a,last:s,point:l}=Dh(o,e,"x");if(!(!l||a&&s))if(a)r.unshift(l);else if(t.push(l),!s)break}t.push(...r)}function Dh(t,e,i){const r=t.interpolate(e,i);if(!r)return{};const n=r[i],o=t.segments,a=t.points;let s=!1,l=!1;for(let t=0;t<o.length;t++){const e=o[t],r=a[e.start][i],d=a[e.end][i];if(Va(n,r,d)){s=n===r,l=n===d;break}}return{first:s,last:l,point:r}}function Eh(t){const{chart:e,fill:i,line:r}=t;if(qo(i))return function(t,e){const i=t.getDatasetMeta(e);return i&&t.isDatasetVisible(e)?i.dataset:null}(e,i);if("stack"===i)return function(t){const{scale:e,index:i,line:r}=t,n=[],o=r.segments,a=r.points,s=function(t,e){const i=[],r=t.getMatchingVisibleMetas("line");for(let t=0;t<r.length;t++){const n=r[t];if(n.index===e)break;n.hidden||i.unshift(n.dataset)}return i}(e,i);s.push(Vh({x:null,y:e.bottom},r));for(let t=0;t<o.length;t++){const e=o[t];for(let t=e.start;t<=e.end;t++)Fh(n,a[t],s)}return new fh({points:n,options:{}})}(t);if("shape"===i)return!0;const n=Bh(t);return n instanceof Hh?n:Vh(n,r)}function Vh(t,e){let i=[],r=!1;return Uo(t)?(r=!0,i=t):i=function(t,e){const{x:i=null,y:r=null}=t||{},n=e.points,o=[];return e.segments.forEach((({start:t,end:e})=>{e=_h(t,e,n);const a=n[t],s=n[e];null!==r?(o.push({x:a.x,y:r}),o.push({x:s.x,y:r})):null!==i&&(o.push({x:i,y:a.y}),o.push({x:i,y:s.y}))})),o}(t,e),i.length?new fh({points:i,options:{tension:0},_loop:r,_fullLoop:r}):null}function Oh(t,e,i){let r=t[e].fill;const n=[e];let o;if(!i)return r;for(;!1!==r&&-1===n.indexOf(r);){if(!qo(r))return r;if(o=t[r],!o)return!1;if(o.visible)return r;n.push(r),r=o.fill}return!1}function jh(t,e,i){const{segments:r,points:n}=e;let o=!0,a=!1;t.beginPath();for(const s of r){const{start:r,end:l}=s,d=n[r],c=n[_h(r,l,n)];o?(t.moveTo(d.x,d.y),o=!1):(t.lineTo(d.x,i),t.lineTo(d.x,d.y)),a=!!e.pathSegment(t,s,{move:a}),a?t.closePath():t.lineTo(c.x,i)}t.lineTo(e.first().x,i),t.closePath(),t.clip()}function Zh(t,e,i,r){if(r)return;let n=e[t],o=i[t];return"angle"===t&&(n=Fa(n),o=Fa(o)),{property:t,start:n,end:o}}function Rh(t,e,i,r){return t&&e?r(t[i],e[i]):t?t[i]:e?e[i]:0}function Th(t,e,i){const{top:r,bottom:n}=e.chart.chartArea,{property:o,start:a,end:s}=i||{};"x"===o&&(t.beginPath(),t.rect(a,r,s-a,n-r),t.clip())}function Nh(t,e,i,r){const n=e.interpolate(i,r);n&&t.lineTo(n.x,n.y)}function Ph(t,e){const{line:i,target:r,property:n,color:o,scale:a}=e,s=function(t,e,i){const r=t.segments,n=t.points,o=e.points,a=[];for(const t of r){let{start:r,end:s}=t;s=_h(r,s,n);const l=Zh(i,n[r],n[s],t.loop);if(!e.segments){a.push({source:t,target:l,start:n[r],end:n[s]});continue}const d=Ul(e,l);for(const e of d){const r=Zh(i,o[e.start],o[e.end],e.loop),s=Il(t,n,r);for(const t of s)a.push({source:t,target:e,start:{[i]:Rh(l,r,"start",Math.max)},end:{[i]:Rh(l,r,"end",Math.min)}})}}return a}(i,r,n);for(const{source:e,target:l,start:d,end:c}of s){const{style:{backgroundColor:s=o}={}}=e,h=!0!==r;t.save(),t.fillStyle=s,Th(t,a,h&&Zh(n,d,c)),t.beginPath();const p=!!i.pathSegment(t,e);let u;if(h){p?t.closePath():Nh(t,r,c,n);const e=!!r.pathSegment(t,l,{move:p,reverse:!0});u=p&&e,u||Nh(t,r,d,n)}t.closePath(),t.fill(u?"evenodd":"nonzero"),t.restore()}}function Yh(t,e,i){const r=Eh(e),{line:n,scale:o,axis:a}=e,s=n.options,l=s.fill,d=s.backgroundColor,{above:c=d,below:h=d}=l||{};r&&n.points.length&&(Fs(t,i),function(t,e){const{line:i,target:r,above:n,below:o,area:a,scale:s}=e,l=i._loop?"angle":e.axis;t.save(),"x"===l&&o!==n&&(jh(t,r,a.top),Ph(t,{line:i,target:r,color:n,scale:s,property:l}),t.restore(),t.save(),jh(t,r,a.bottom)),Ph(t,{line:i,target:r,color:o,scale:s,property:l}),t.restore()}(t,{line:n,target:r,above:c,below:h,area:i,scale:o,axis:a}),Ds(t))}var Ih={id:"filler",afterDatasetsUpdate(t,e,i){const r=(t.data.datasets||[]).length,n=[];let o,a,s,l;for(a=0;a<r;++a)o=t.getDatasetMeta(a),s=o.dataset,l=null,s&&s.options&&s instanceof fh&&(l={visible:t.isDatasetVisible(a),index:a,fill:Lh(s,a,r),chart:t,axis:o.controller.options.indexAxis,scale:o.vScale,line:s}),o.$filler=l,n.push(l);for(a=0;a<r;++a)l=n[a],l&&!1!==l.fill&&(l.fill=Oh(n,a,i.propagate))},beforeDraw(t,e,i){const r="beforeDraw"===i.drawTime,n=t.getSortedVisibleDatasetMetas(),o=t.chartArea;for(let e=n.length-1;e>=0;--e){const i=n[e].$filler;i&&(i.line.updateControlPoints(o,i.axis),r&&Yh(t.ctx,i,o))}},beforeDatasetsDraw(t,e,i){if("beforeDatasetsDraw"!==i.drawTime)return;const r=t.getSortedVisibleDatasetMetas();for(let e=r.length-1;e>=0;--e){const i=r[e].$filler;i&&Yh(t.ctx,i,t.chartArea)}},beforeDatasetDraw(t,e,i){const r=e.meta.$filler;r&&!1!==r.fill&&"beforeDatasetDraw"===i.drawTime&&Yh(t.ctx,r,t.chartArea)},defaults:{propagate:!0,drawTime:"beforeDatasetDraw"}};const Uh=(t,e)=>{let{boxHeight:i=e,boxWidth:r=e}=t;return t.usePointStyle&&(i=Math.min(i,e),r=Math.min(r,e)),{boxWidth:r,boxHeight:i,itemHeight:Math.max(e,i)}};class Wh extends mc{constructor(t){super(),this._added=!1,this.legendHitBoxes=[],this._hoveredItem=null,this.doughnutMode=!1,this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this.legendItems=void 0,this.columnSizes=void 0,this.lineWidths=void 0,this.maxHeight=void 0,this.maxWidth=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.height=void 0,this.width=void 0,this._margins=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e,i){this.maxWidth=t,this.maxHeight=e,this._margins=i,this.setDimensions(),this.buildLabels(),this.fit()}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=this._margins.left,this.right=this.width):(this.height=this.maxHeight,this.top=this._margins.top,this.bottom=this.height)}buildLabels(){const t=this.options.labels||{};let e=Ko(t.generateLabels,[this.chart],this)||[];t.filter&&(e=e.filter((e=>t.filter(e,this.chart.data)))),t.sort&&(e=e.sort(((e,i)=>t.sort(e,i,this.chart.data)))),this.options.reverse&&e.reverse(),this.legendItems=e}fit(){const{options:t,ctx:e}=this;if(!t.display)return void(this.width=this.height=0);const i=t.labels,r=qs(i.font),n=r.size,o=this._computeTitleHeight(),{boxWidth:a,itemHeight:s}=Uh(i,n);let l,d;e.font=r.string,this.isHorizontal()?(l=this.maxWidth,d=this._fitRows(o,n,a,s)+10):(d=this.maxHeight,l=this._fitCols(o,n,a,s)+10),this.width=Math.min(l,t.maxWidth||this.maxWidth),this.height=Math.min(d,t.maxHeight||this.maxHeight)}_fitRows(t,e,i,r){const{ctx:n,maxWidth:o,options:{labels:{padding:a}}}=this,s=this.legendHitBoxes=[],l=this.lineWidths=[0],d=r+a;let c=t;n.textAlign="left",n.textBaseline="middle";let h=-1,p=-d;return this.legendItems.forEach(((t,u)=>{const g=i+e/2+n.measureText(t.text).width;(0===u||l[l.length-1]+g+2*a>o)&&(c+=d,l[l.length-(u>0?0:1)]=0,p+=d,h++),s[u]={left:0,top:p,row:h,width:g,height:r},l[l.length-1]+=g+a})),c}_fitCols(t,e,i,r){const{ctx:n,maxHeight:o,options:{labels:{padding:a}}}=this,s=this.legendHitBoxes=[],l=this.columnSizes=[],d=o-t;let c=a,h=0,p=0,u=0,g=0;return this.legendItems.forEach(((t,o)=>{const f=i+e/2+n.measureText(t.text).width;o>0&&p+r+2*a>d&&(c+=h+a,l.push({width:h,height:p}),u+=h+a,g++,h=p=0),s[o]={left:u,top:p,col:g,width:f,height:r},h=Math.max(h,f),p+=r+a})),c+=h,l.push({width:h,height:p}),c}adjustHitBoxes(){if(!this.options.display)return;const t=this._computeTitleHeight(),{legendHitBoxes:e,options:{align:i,labels:{padding:r},rtl:n}}=this,o=Rl(n,this.left,this.width);if(this.isHorizontal()){let n=0,a=No(i,this.left+r,this.right-this.lineWidths[n]);for(const s of e)n!==s.row&&(n=s.row,a=No(i,this.left+r,this.right-this.lineWidths[n])),s.top+=this.top+t+r,s.left=o.leftForLtr(o.x(a),s.width),a+=s.width+r}else{let n=0,a=No(i,this.top+t+r,this.bottom-this.columnSizes[n].height);for(const s of e)s.col!==n&&(n=s.col,a=No(i,this.top+t+r,this.bottom-this.columnSizes[n].height)),s.top=a,s.left+=this.left+r,s.left=o.leftForLtr(o.x(s.left),s.width),a+=s.height+r}}isHorizontal(){return"top"===this.options.position||"bottom"===this.options.position}draw(){if(this.options.display){const t=this.ctx;Fs(t,this),this._draw(),Ds(t)}}_draw(){const{options:t,columnSizes:e,lineWidths:i,ctx:r}=this,{align:n,labels:o}=t,a=$s.color,s=Rl(t.rtl,this.left,this.width),l=qs(o.font),{color:d,padding:c}=o,h=l.size,p=h/2;let u;this.drawTitle(),r.textAlign=s.textAlign("left"),r.textBaseline="middle",r.lineWidth=.5,r.font=l.string;const{boxWidth:g,boxHeight:f,itemHeight:m}=Uh(o,h),b=this.isHorizontal(),v=this._computeTitleHeight();u=b?{x:No(n,this.left+c,this.right-i[0]),y:this.top+c+v,line:0}:{x:this.left+c,y:No(n,this.top+v+c,this.bottom-e[0].height),line:0},Tl(this.ctx,t.textDirection);const w=m+c;this.legendItems.forEach(((x,y)=>{r.strokeStyle=x.fontColor||d,r.fillStyle=x.fontColor||d;const C=r.measureText(x.text).width,k=s.textAlign(x.textAlign||(x.textAlign=o.textAlign)),A=g+p+C;let z=u.x,$=u.y;s.setWidth(this.width),b?y>0&&z+A+c>this.right&&($=u.y+=w,u.line++,z=u.x=No(n,this.left+c,this.right-i[u.line])):y>0&&$+w>this.bottom&&(z=u.x=z+e[u.line].width+c,u.line++,$=u.y=No(n,this.top+v+c,this.bottom-e[u.line].height));!function(t,e,i){if(isNaN(g)||g<=0||isNaN(f)||f<0)return;r.save();const n=Qo(i.lineWidth,1);if(r.fillStyle=Qo(i.fillStyle,a),r.lineCap=Qo(i.lineCap,"butt"),r.lineDashOffset=Qo(i.lineDashOffset,0),r.lineJoin=Qo(i.lineJoin,"miter"),r.lineWidth=n,r.strokeStyle=Qo(i.strokeStyle,a),r.setLineDash(Qo(i.lineDash,[])),o.usePointStyle){const o={radius:g*Math.SQRT2/2,pointStyle:i.pointStyle,rotation:i.rotation,borderWidth:n},a=s.xPlus(t,g/2);Bs(r,o,a,e+p)}else{const o=e+Math.max((h-f)/2,0),a=s.leftForLtr(t,g),l=Us(i.borderRadius);r.beginPath(),Object.values(l).some((t=>0!==t))?Zs(r,{x:a,y:o,w:g,h:f,radius:l}):r.rect(a,o,g,f),r.fill(),0!==n&&r.stroke()}r.restore()}(s.x(z),$,x),z=((t,e,i,r)=>t===(r?"left":"right")?i:"center"===t?(e+i)/2:e)(k,z+g+p,b?z+A:this.right,t.rtl),function(t,e,i){Os(r,i.text,t,e+m/2,l,{strikethrough:i.hidden,textAlign:s.textAlign(i.textAlign)})}(s.x(z),$,x),b?u.x+=A+c:u.y+=w})),Nl(this.ctx,t.textDirection)}drawTitle(){const t=this.options,e=t.title,i=qs(e.font),r=Ws(e.padding);if(!e.display)return;const n=Rl(t.rtl,this.left,this.width),o=this.ctx,a=e.position,s=i.size/2,l=r.top+s;let d,c=this.left,h=this.width;if(this.isHorizontal())h=Math.max(...this.lineWidths),d=this.top+l,c=No(t.align,c,this.right-h);else{const e=this.columnSizes.reduce(((t,e)=>Math.max(t,e.height)),0);d=l+No(t.align,this.top,this.bottom-e-t.labels.padding-this._computeTitleHeight())}const p=No(a,c,c+h);o.textAlign=n.textAlign(To(a)),o.textBaseline="middle",o.strokeStyle=e.color,o.fillStyle=e.color,o.font=i.string,Os(o,e.text,p,d,i)}_computeTitleHeight(){const t=this.options.title,e=qs(t.font),i=Ws(t.padding);return t.display?e.lineHeight+i.height:0}_getLegendItemAt(t,e){let i,r,n;if(Va(t,this.left,this.right)&&Va(e,this.top,this.bottom))for(n=this.legendHitBoxes,i=0;i<n.length;++i)if(r=n[i],Va(t,r.left,r.left+r.width)&&Va(e,r.top,r.top+r.height))return this.legendItems[i];return null}handleEvent(t){const e=this.options;if(!function(t,e){if("mousemove"===t&&(e.onHover||e.onLeave))return!0;if(e.onClick&&("click"===t||"mouseup"===t))return!0;return!1}(t.type,e))return;const i=this._getLegendItemAt(t.x,t.y);if("mousemove"===t.type){const r=this._hoveredItem,n=((t,e)=>null!==t&&null!==e&&t.datasetIndex===e.datasetIndex&&t.index===e.index)(r,i);r&&!n&&Ko(e.onLeave,[t,r,this],this),this._hoveredItem=i,i&&!n&&Ko(e.onHover,[t,i,this],this)}else i&&Ko(e.onClick,[t,i,this],this)}}var qh={id:"legend",_element:Wh,start(t,e,i){const r=t.legend=new Wh({ctx:t.ctx,options:i,chart:t});Jd.configure(t,r,i),Jd.addBox(t,r)},stop(t){Jd.removeBox(t,t.legend),delete t.legend},beforeUpdate(t,e,i){const r=t.legend;Jd.configure(t,r,i),r.options=i},afterUpdate(t){const e=t.legend;e.buildLabels(),e.adjustHitBoxes()},afterEvent(t,e){e.replay||t.legend.handleEvent(e.event)},defaults:{display:!0,position:"top",align:"center",fullSize:!0,reverse:!1,weight:1e3,onClick(t,e,i){const r=e.datasetIndex,n=i.chart;n.isDatasetVisible(r)?(n.hide(r),e.hidden=!0):(n.show(r),e.hidden=!1)},onHover:null,onLeave:null,labels:{color:t=>t.chart.options.color,boxWidth:40,padding:10,generateLabels(t){const e=t.data.datasets,{labels:{usePointStyle:i,pointStyle:r,textAlign:n,color:o}}=t.legend.options;return t._getSortedDatasetMetas().map((t=>{const a=t.controller.getStyle(i?0:void 0),s=Ws(a.borderWidth);return{text:e[t.index].label,fillStyle:a.backgroundColor,fontColor:o,hidden:!t.visible,lineCap:a.borderCapStyle,lineDash:a.borderDash,lineDashOffset:a.borderDashOffset,lineJoin:a.borderJoinStyle,lineWidth:(s.width+s.height)/4,strokeStyle:a.borderColor,pointStyle:r||a.pointStyle,rotation:a.rotation,textAlign:n||a.textAlign,borderRadius:0,datasetIndex:t.index}}),this)}},title:{color:t=>t.chart.options.color,display:!1,position:"center",text:""}},descriptors:{_scriptable:t=>!t.startsWith("on"),labels:{_scriptable:t=>!["generateLabels","filter","sort"].includes(t)}}};class Gh extends mc{constructor(t){super(),this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this._padding=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e){const i=this.options;if(this.left=0,this.top=0,!i.display)return void(this.width=this.height=this.right=this.bottom=0);this.width=this.right=t,this.height=this.bottom=e;const r=Uo(i.text)?i.text.length:1;this._padding=Ws(i.padding);const n=r*qs(i.font).lineHeight+this._padding.height;this.isHorizontal()?this.height=n:this.width=n}isHorizontal(){const t=this.options.position;return"top"===t||"bottom"===t}_drawArgs(t){const{top:e,left:i,bottom:r,right:n,options:o}=this,a=o.align;let s,l,d,c=0;return this.isHorizontal()?(l=No(a,i,n),d=e+t,s=n-i):("left"===o.position?(l=i+t,d=No(a,r,e),c=-.5*ua):(l=n-t,d=No(a,e,r),c=.5*ua),s=r-e),{titleX:l,titleY:d,maxWidth:s,rotation:c}}draw(){const t=this.ctx,e=this.options;if(!e.display)return;const i=qs(e.font),r=i.lineHeight/2+this._padding.top,{titleX:n,titleY:o,maxWidth:a,rotation:s}=this._drawArgs(r);Os(t,e.text,0,0,i,{color:e.color,maxWidth:a,rotation:s,textAlign:To(e.align),textBaseline:"middle",translation:[n,o]})}}var Qh={id:"title",_element:Gh,start(t,e,i){!function(t,e){const i=new Gh({ctx:t.ctx,options:e,chart:t});Jd.configure(t,i,e),Jd.addBox(t,i),t.titleBlock=i}(t,i)},stop(t){const e=t.titleBlock;Jd.removeBox(t,e),delete t.titleBlock},beforeUpdate(t,e,i){const r=t.titleBlock;Jd.configure(t,r,i),r.options=i},defaults:{align:"center",display:!1,font:{weight:"bold"},fullSize:!0,padding:10,position:"top",text:"",weight:2e3},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const Xh=new WeakMap;var Kh={id:"subtitle",start(t,e,i){const r=new Gh({ctx:t.ctx,options:i,chart:t});Jd.configure(t,r,i),Jd.addBox(t,r),Xh.set(t,r)},stop(t){Jd.removeBox(t,Xh.get(t)),Xh.delete(t)},beforeUpdate(t,e,i){const r=Xh.get(t);Jd.configure(t,r,i),r.options=i},defaults:{align:"center",display:!1,font:{weight:"normal"},fullSize:!0,padding:0,position:"top",text:"",weight:1500},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const Jh={average(t){if(!t.length)return!1;let e,i,r=0,n=0,o=0;for(e=0,i=t.length;e<i;++e){const i=t[e].element;if(i&&i.hasValue()){const t=i.tooltipPosition();r+=t.x,n+=t.y,++o}}return{x:r/o,y:n/o}},nearest(t,e){if(!t.length)return!1;let i,r,n,o=e.x,a=e.y,s=Number.POSITIVE_INFINITY;for(i=0,r=t.length;i<r;++i){const r=t[i].element;if(r&&r.hasValue()){const t=Ba(e,r.getCenterPoint());t<s&&(s=t,n=r)}}if(n){const t=n.tooltipPosition();o=t.x,a=t.y}return{x:o,y:a}}};function tp(t,e){return e&&(Uo(e)?Array.prototype.push.apply(t,e):t.push(e)),t}function ep(t){return("string"==typeof t||t instanceof String)&&t.indexOf("\n")>-1?t.split("\n"):t}function ip(t,e){const{element:i,datasetIndex:r,index:n}=e,o=t.getDatasetMeta(r).controller,{label:a,value:s}=o.getLabelAndValue(n);return{chart:t,label:a,parsed:o.getParsed(n),raw:t.data.datasets[r].data[n],formattedValue:s,dataset:o.getDataset(),dataIndex:n,datasetIndex:r,element:i}}function rp(t,e){const i=t.chart.ctx,{body:r,footer:n,title:o}=t,{boxWidth:a,boxHeight:s}=e,l=qs(e.bodyFont),d=qs(e.titleFont),c=qs(e.footerFont),h=o.length,p=n.length,u=r.length,g=Ws(e.padding);let f=g.height,m=0,b=r.reduce(((t,e)=>t+e.before.length+e.lines.length+e.after.length),0);if(b+=t.beforeBody.length+t.afterBody.length,h&&(f+=h*d.lineHeight+(h-1)*e.titleSpacing+e.titleMarginBottom),b){f+=u*(e.displayColors?Math.max(s,l.lineHeight):l.lineHeight)+(b-u)*l.lineHeight+(b-1)*e.bodySpacing}p&&(f+=e.footerMarginTop+p*c.lineHeight+(p-1)*e.footerSpacing);let v=0;const w=function(t){m=Math.max(m,i.measureText(t).width+v)};return i.save(),i.font=d.string,Jo(t.title,w),i.font=l.string,Jo(t.beforeBody.concat(t.afterBody),w),v=e.displayColors?a+2+e.boxPadding:0,Jo(r,(t=>{Jo(t.before,w),Jo(t.lines,w),Jo(t.after,w)})),v=0,i.font=c.string,Jo(t.footer,w),i.restore(),m+=g.width,{width:m,height:f}}function np(t,e,i,r){const{x:n,width:o}=i,{width:a,chartArea:{left:s,right:l}}=t;let d="center";return"center"===r?d=n<=(s+l)/2?"left":"right":n<=o/2?d="left":n>=a-o/2&&(d="right"),function(t,e,i,r){const{x:n,width:o}=r,a=i.caretSize+i.caretPadding;return"left"===t&&n+o+a>e.width||"right"===t&&n-o-a<0||void 0}(d,t,e,i)&&(d="center"),d}function op(t,e,i){const r=i.yAlign||e.yAlign||function(t,e){const{y:i,height:r}=e;return i<r/2?"top":i>t.height-r/2?"bottom":"center"}(t,i);return{xAlign:i.xAlign||e.xAlign||np(t,e,i,r),yAlign:r}}function ap(t,e,i,r){const{caretSize:n,caretPadding:o,cornerRadius:a}=t,{xAlign:s,yAlign:l}=i,d=n+o,{topLeft:c,topRight:h,bottomLeft:p,bottomRight:u}=Us(a);let g=function(t,e){let{x:i,width:r}=t;return"right"===e?i-=r:"center"===e&&(i-=r/2),i}(e,s);const f=function(t,e,i){let{y:r,height:n}=t;return"top"===e?r+=i:r-="bottom"===e?n+i:n/2,r}(e,l,d);return"center"===l?"left"===s?g+=d:"right"===s&&(g-=d):"left"===s?g-=Math.max(c,p)+n:"right"===s&&(g+=Math.max(h,u)+n),{x:Ea(g,0,r.width-e.width),y:Ea(f,0,r.height-e.height)}}function sp(t,e,i){const r=Ws(i.padding);return"center"===e?t.x+t.width/2:"right"===e?t.x+t.width-r.right:t.x+r.left}function lp(t){return tp([],ep(t))}function dp(t,e){const i=e&&e.dataset&&e.dataset.tooltip&&e.dataset.tooltip.callbacks;return i?t.override(i):t}class cp extends mc{constructor(t){super(),this.opacity=0,this._active=[],this._eventPosition=void 0,this._size=void 0,this._cachedAnimations=void 0,this._tooltipItems=[],this.$animations=void 0,this.$context=void 0,this.chart=t.chart||t._chart,this._chart=this.chart,this.options=t.options,this.dataPoints=void 0,this.title=void 0,this.beforeBody=void 0,this.body=void 0,this.afterBody=void 0,this.footer=void 0,this.xAlign=void 0,this.yAlign=void 0,this.x=void 0,this.y=void 0,this.height=void 0,this.width=void 0,this.caretX=void 0,this.caretY=void 0,this.labelColors=void 0,this.labelPointStyles=void 0,this.labelTextColors=void 0}initialize(t){this.options=t,this._cachedAnimations=void 0,this.$context=void 0}_resolveAnimations(){const t=this._cachedAnimations;if(t)return t;const e=this.chart,i=this.options.setContext(this.getContext()),r=i.enabled&&e.options.animation&&i.animations,n=new td(this.chart,r);return r._cacheable&&(this._cachedAnimations=Object.freeze(n)),n}getContext(){return this.$context||(this.$context=(t=this.chart.getContext(),e=this,i=this._tooltipItems,Qs(t,{tooltip:e,tooltipItems:i,type:"tooltip"})));var t,e,i}getTitle(t,e){const{callbacks:i}=e,r=i.beforeTitle.apply(this,[t]),n=i.title.apply(this,[t]),o=i.afterTitle.apply(this,[t]);let a=[];return a=tp(a,ep(r)),a=tp(a,ep(n)),a=tp(a,ep(o)),a}getBeforeBody(t,e){return lp(e.callbacks.beforeBody.apply(this,[t]))}getBody(t,e){const{callbacks:i}=e,r=[];return Jo(t,(t=>{const e={before:[],lines:[],after:[]},n=dp(i,t);tp(e.before,ep(n.beforeLabel.call(this,t))),tp(e.lines,n.label.call(this,t)),tp(e.after,ep(n.afterLabel.call(this,t))),r.push(e)})),r}getAfterBody(t,e){return lp(e.callbacks.afterBody.apply(this,[t]))}getFooter(t,e){const{callbacks:i}=e,r=i.beforeFooter.apply(this,[t]),n=i.footer.apply(this,[t]),o=i.afterFooter.apply(this,[t]);let a=[];return a=tp(a,ep(r)),a=tp(a,ep(n)),a=tp(a,ep(o)),a}_createItems(t){const e=this._active,i=this.chart.data,r=[],n=[],o=[];let a,s,l=[];for(a=0,s=e.length;a<s;++a)l.push(ip(this.chart,e[a]));return t.filter&&(l=l.filter(((e,r,n)=>t.filter(e,r,n,i)))),t.itemSort&&(l=l.sort(((e,r)=>t.itemSort(e,r,i)))),Jo(l,(e=>{const i=dp(t.callbacks,e);r.push(i.labelColor.call(this,e)),n.push(i.labelPointStyle.call(this,e)),o.push(i.labelTextColor.call(this,e))})),this.labelColors=r,this.labelPointStyles=n,this.labelTextColors=o,this.dataPoints=l,l}update(t,e){const i=this.options.setContext(this.getContext()),r=this._active;let n,o=[];if(r.length){const t=Jh[i.position].call(this,r,this._eventPosition);o=this._createItems(i),this.title=this.getTitle(o,i),this.beforeBody=this.getBeforeBody(o,i),this.body=this.getBody(o,i),this.afterBody=this.getAfterBody(o,i),this.footer=this.getFooter(o,i);const e=this._size=rp(this,i),a=Object.assign({},t,e),s=op(this.chart,i,a),l=ap(i,a,s,this.chart);this.xAlign=s.xAlign,this.yAlign=s.yAlign,n={opacity:1,x:l.x,y:l.y,width:e.width,height:e.height,caretX:t.x,caretY:t.y}}else 0!==this.opacity&&(n={opacity:0});this._tooltipItems=o,this.$context=void 0,n&&this._resolveAnimations().update(this,n),t&&i.external&&i.external.call(this,{chart:this.chart,tooltip:this,replay:e})}drawCaret(t,e,i,r){const n=this.getCaretPosition(t,i,r);e.lineTo(n.x1,n.y1),e.lineTo(n.x2,n.y2),e.lineTo(n.x3,n.y3)}getCaretPosition(t,e,i){const{xAlign:r,yAlign:n}=this,{caretSize:o,cornerRadius:a}=i,{topLeft:s,topRight:l,bottomLeft:d,bottomRight:c}=Us(a),{x:h,y:p}=t,{width:u,height:g}=e;let f,m,b,v,w,x;return"center"===n?(w=p+g/2,"left"===r?(f=h,m=f-o,v=w+o,x=w-o):(f=h+u,m=f+o,v=w-o,x=w+o),b=f):(m="left"===r?h+Math.max(s,d)+o:"right"===r?h+u-Math.max(l,c)-o:this.caretX,"top"===n?(v=p,w=v-o,f=m-o,b=m+o):(v=p+g,w=v+o,f=m+o,b=m-o),x=v),{x1:f,x2:m,x3:b,y1:v,y2:w,y3:x}}drawTitle(t,e,i){const r=this.title,n=r.length;let o,a,s;if(n){const l=Rl(i.rtl,this.x,this.width);for(t.x=sp(this,i.titleAlign,i),e.textAlign=l.textAlign(i.titleAlign),e.textBaseline="middle",o=qs(i.titleFont),a=i.titleSpacing,e.fillStyle=i.titleColor,e.font=o.string,s=0;s<n;++s)e.fillText(r[s],l.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+a,s+1===n&&(t.y+=i.titleMarginBottom-a)}}_drawColorBox(t,e,i,r,n){const o=this.labelColors[i],a=this.labelPointStyles[i],{boxHeight:s,boxWidth:l,boxPadding:d}=n,c=qs(n.bodyFont),h=sp(this,"left",n),p=r.x(h),u=s<c.lineHeight?(c.lineHeight-s)/2:0,g=e.y+u;if(n.usePointStyle){const e={radius:Math.min(l,s)/2,pointStyle:a.pointStyle,rotation:a.rotation,borderWidth:1},i=r.leftForLtr(p,l)+l/2,d=g+s/2;t.strokeStyle=n.multiKeyBackground,t.fillStyle=n.multiKeyBackground,Bs(t,e,i,d),t.strokeStyle=o.borderColor,t.fillStyle=o.backgroundColor,Bs(t,e,i,d)}else{t.lineWidth=o.borderWidth||1,t.strokeStyle=o.borderColor,t.setLineDash(o.borderDash||[]),t.lineDashOffset=o.borderDashOffset||0;const e=r.leftForLtr(p,l-d),i=r.leftForLtr(r.xPlus(p,1),l-d-2),a=Us(o.borderRadius);Object.values(a).some((t=>0!==t))?(t.beginPath(),t.fillStyle=n.multiKeyBackground,Zs(t,{x:e,y:g,w:l,h:s,radius:a}),t.fill(),t.stroke(),t.fillStyle=o.backgroundColor,t.beginPath(),Zs(t,{x:i,y:g+1,w:l-2,h:s-2,radius:a}),t.fill()):(t.fillStyle=n.multiKeyBackground,t.fillRect(e,g,l,s),t.strokeRect(e,g,l,s),t.fillStyle=o.backgroundColor,t.fillRect(i,g+1,l-2,s-2))}t.fillStyle=this.labelTextColors[i]}drawBody(t,e,i){const{body:r}=this,{bodySpacing:n,bodyAlign:o,displayColors:a,boxHeight:s,boxWidth:l,boxPadding:d}=i,c=qs(i.bodyFont);let h=c.lineHeight,p=0;const u=Rl(i.rtl,this.x,this.width),g=function(i){e.fillText(i,u.x(t.x+p),t.y+h/2),t.y+=h+n},f=u.textAlign(o);let m,b,v,w,x,y,C;for(e.textAlign=o,e.textBaseline="middle",e.font=c.string,t.x=sp(this,f,i),e.fillStyle=i.bodyColor,Jo(this.beforeBody,g),p=a&&"right"!==f?"center"===o?l/2+d:l+2+d:0,w=0,y=r.length;w<y;++w){for(m=r[w],b=this.labelTextColors[w],e.fillStyle=b,Jo(m.before,g),v=m.lines,a&&v.length&&(this._drawColorBox(e,t,w,u,i),h=Math.max(c.lineHeight,s)),x=0,C=v.length;x<C;++x)g(v[x]),h=c.lineHeight;Jo(m.after,g)}p=0,h=c.lineHeight,Jo(this.afterBody,g),t.y-=n}drawFooter(t,e,i){const r=this.footer,n=r.length;let o,a;if(n){const s=Rl(i.rtl,this.x,this.width);for(t.x=sp(this,i.footerAlign,i),t.y+=i.footerMarginTop,e.textAlign=s.textAlign(i.footerAlign),e.textBaseline="middle",o=qs(i.footerFont),e.fillStyle=i.footerColor,e.font=o.string,a=0;a<n;++a)e.fillText(r[a],s.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+i.footerSpacing}}drawBackground(t,e,i,r){const{xAlign:n,yAlign:o}=this,{x:a,y:s}=t,{width:l,height:d}=i,{topLeft:c,topRight:h,bottomLeft:p,bottomRight:u}=Us(r.cornerRadius);e.fillStyle=r.backgroundColor,e.strokeStyle=r.borderColor,e.lineWidth=r.borderWidth,e.beginPath(),e.moveTo(a+c,s),"top"===o&&this.drawCaret(t,e,i,r),e.lineTo(a+l-h,s),e.quadraticCurveTo(a+l,s,a+l,s+h),"center"===o&&"right"===n&&this.drawCaret(t,e,i,r),e.lineTo(a+l,s+d-u),e.quadraticCurveTo(a+l,s+d,a+l-u,s+d),"bottom"===o&&this.drawCaret(t,e,i,r),e.lineTo(a+p,s+d),e.quadraticCurveTo(a,s+d,a,s+d-p),"center"===o&&"left"===n&&this.drawCaret(t,e,i,r),e.lineTo(a,s+c),e.quadraticCurveTo(a,s,a+c,s),e.closePath(),e.fill(),r.borderWidth>0&&e.stroke()}_updateAnimationTarget(t){const e=this.chart,i=this.$animations,r=i&&i.x,n=i&&i.y;if(r||n){const i=Jh[t.position].call(this,this._active,this._eventPosition);if(!i)return;const o=this._size=rp(this,t),a=Object.assign({},i,this._size),s=op(e,t,a),l=ap(t,a,s,e);r._to===l.x&&n._to===l.y||(this.xAlign=s.xAlign,this.yAlign=s.yAlign,this.width=o.width,this.height=o.height,this.caretX=i.x,this.caretY=i.y,this._resolveAnimations().update(this,l))}}draw(t){const e=this.options.setContext(this.getContext());let i=this.opacity;if(!i)return;this._updateAnimationTarget(e);const r={width:this.width,height:this.height},n={x:this.x,y:this.y};i=Math.abs(i)<.001?0:i;const o=Ws(e.padding),a=this.title.length||this.beforeBody.length||this.body.length||this.afterBody.length||this.footer.length;e.enabled&&a&&(t.save(),t.globalAlpha=i,this.drawBackground(n,t,r,e),Tl(t,e.textDirection),n.y+=o.top,this.drawTitle(n,t,e),this.drawBody(n,t,e),this.drawFooter(n,t,e),Nl(t,e.textDirection),t.restore())}getActiveElements(){return this._active||[]}setActiveElements(t,e){const i=this._active,r=t.map((({datasetIndex:t,index:e})=>{const i=this.chart.getDatasetMeta(t);if(!i)throw new Error("Cannot find a dataset at index "+t);return{datasetIndex:t,element:i.data[e],index:e}})),n=!ta(i,r),o=this._positionChanged(r,e);(n||o)&&(this._active=r,this._eventPosition=e,this._ignoreReplayEvents=!0,this.update(!0))}handleEvent(t,e,i=!0){if(e&&this._ignoreReplayEvents)return!1;this._ignoreReplayEvents=!1;const r=this.options,n=this._active||[],o=this._getActiveElements(t,n,e,i),a=this._positionChanged(o,t),s=e||!ta(o,n)||a;return s&&(this._active=o,(r.enabled||r.external)&&(this._eventPosition={x:t.x,y:t.y},this.update(!0,e))),s}_getActiveElements(t,e,i,r){const n=this.options;if("mouseout"===t.type)return[];if(!r)return e;const o=this.chart.getElementsAtEventForMode(t,n.mode,n,i);return n.reverse&&o.reverse(),o}_positionChanged(t,e){const{caretX:i,caretY:r,options:n}=this,o=Jh[n.position].call(this,t,e);return!1!==o&&(i!==o.x||r!==o.y)}}cp.positioners=Jh;var hp={id:"tooltip",_element:cp,positioners:Jh,afterInit(t,e,i){i&&(t.tooltip=new cp({chart:t,options:i}))},beforeUpdate(t,e,i){t.tooltip&&t.tooltip.initialize(i)},reset(t,e,i){t.tooltip&&t.tooltip.initialize(i)},afterDraw(t){const e=t.tooltip,i={tooltip:e};!1!==t.notifyPlugins("beforeTooltipDraw",i)&&(e&&e.draw(t.ctx),t.notifyPlugins("afterTooltipDraw",i))},afterEvent(t,e){if(t.tooltip){const i=e.replay;t.tooltip.handleEvent(e.event,i,e.inChartArea)&&(e.changed=!0)}},defaults:{enabled:!0,external:null,position:"average",backgroundColor:"rgba(0,0,0,0.8)",titleColor:"#fff",titleFont:{weight:"bold"},titleSpacing:2,titleMarginBottom:6,titleAlign:"left",bodyColor:"#fff",bodySpacing:2,bodyFont:{},bodyAlign:"left",footerColor:"#fff",footerSpacing:2,footerMarginTop:6,footerFont:{weight:"bold"},footerAlign:"left",padding:6,caretPadding:2,caretSize:5,cornerRadius:6,boxHeight:(t,e)=>e.bodyFont.size,boxWidth:(t,e)=>e.bodyFont.size,multiKeyBackground:"#fff",displayColors:!0,boxPadding:0,borderColor:"rgba(0,0,0,0)",borderWidth:0,animation:{duration:400,easing:"easeOutQuart"},animations:{numbers:{type:"number",properties:["x","y","width","height","caretX","caretY"]},opacity:{easing:"linear",duration:200}},callbacks:{beforeTitle:Po,title(t){if(t.length>0){const e=t[0],i=e.chart.data.labels,r=i?i.length:0;if(this&&this.options&&"dataset"===this.options.mode)return e.dataset.label||"";if(e.label)return e.label;if(r>0&&e.dataIndex<r)return i[e.dataIndex]}return""},afterTitle:Po,beforeBody:Po,beforeLabel:Po,label(t){if(this&&this.options&&"dataset"===this.options.mode)return t.label+": "+t.formattedValue||t.formattedValue;let e=t.dataset.label||"";e&&(e+=": ");const i=t.formattedValue;return Io(i)||(e+=i),e},labelColor(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{borderColor:e.borderColor,backgroundColor:e.backgroundColor,borderWidth:e.borderWidth,borderDash:e.borderDash,borderDashOffset:e.borderDashOffset,borderRadius:0}},labelTextColor(){return this.options.bodyColor},labelPointStyle(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{pointStyle:e.pointStyle,rotation:e.rotation}},afterLabel:Po,afterBody:Po,beforeFooter:Po,footer:Po,afterFooter:Po}},defaultRoutes:{bodyFont:"font",footerFont:"font",titleFont:"font"},descriptors:{_scriptable:t=>"filter"!==t&&"itemSort"!==t&&"external"!==t,_indexable:!1,callbacks:{_scriptable:!1,_indexable:!1},animation:{_fallback:!1},animations:{_fallback:"animation"}},additionalOptionScopes:["interaction"]},pp=Object.freeze({__proto__:null,Decimation:Sh,Filler:Ih,Legend:qh,SubTitle:Kh,Title:Qh,Tooltip:hp});function up(t,e,i,r){const n=t.indexOf(e);if(-1===n)return((t,e,i,r)=>("string"==typeof e?(i=t.push(e)-1,r.unshift({index:i,label:e})):isNaN(e)&&(i=null),i))(t,e,i,r);return n!==t.lastIndexOf(e)?i:n}class gp extends Mc{constructor(t){super(t),this._startValue=void 0,this._valueRange=0,this._addedLabels=[]}init(t){const e=this._addedLabels;if(e.length){const t=this.getLabels();for(const{index:i,label:r}of e)t[i]===r&&t.splice(i,1);this._addedLabels=[]}super.init(t)}parse(t,e){if(Io(t))return null;const i=this.getLabels();return((t,e)=>null===t?null:Ea(Math.round(t),0,e))(e=isFinite(e)&&i[e]===t?e:up(i,t,Qo(e,t),this._addedLabels),i.length-1)}determineDataLimits(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let{min:i,max:r}=this.getMinMax(!0);"ticks"===this.options.bounds&&(t||(i=0),e||(r=this.getLabels().length-1)),this.min=i,this.max=r}buildTicks(){const t=this.min,e=this.max,i=this.options.offset,r=[];let n=this.getLabels();n=0===t&&e===n.length-1?n:n.slice(t,e+1),this._valueRange=Math.max(n.length-(i?0:1),1),this._startValue=this.min-(i?.5:0);for(let i=t;i<=e;i++)r.push({value:i});return r}getLabelForValue(t){const e=this.getLabels();return t>=0&&t<e.length?e[t]:t}configure(){super.configure(),this.isHorizontal()||(this._reversePixels=!this._reversePixels)}getPixelForValue(t){return"number"!=typeof t&&(t=this.parse(t)),null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getValueForPixel(t){return Math.round(this._startValue+this.getDecimalForPixel(t)*this._valueRange)}getBasePixel(){return this.bottom}}function fp(t,e){const i=[],{bounds:r,step:n,min:o,max:a,precision:s,count:l,maxTicks:d,maxDigits:c,includeBounds:h}=t,p=n||1,u=d-1,{min:g,max:f}=e,m=!Io(o),b=!Io(a),v=!Io(l),w=(f-g)/(c+1);let x,y,C,k,A=ka((f-g)/u/p)*p;if(A<1e-14&&!m&&!b)return[{value:g},{value:f}];k=Math.ceil(f/A)-Math.floor(g/A),k>u&&(A=ka(k*A/u/p)*p),Io(s)||(x=Math.pow(10,s),A=Math.ceil(A*x)/x),"ticks"===r?(y=Math.floor(g/A)*A,C=Math.ceil(f/A)*A):(y=g,C=f),m&&b&&n&&function(t,e){const i=Math.round(t);return i-e<=t&&i+e>=t}((a-o)/n,A/1e3)?(k=Math.round(Math.min((a-o)/A,d)),A=(a-o)/k,y=o,C=a):v?(y=m?o:y,C=b?a:C,k=l-1,A=(C-y)/k):(k=(C-y)/A,k=za(k,Math.round(k),A/1e3)?Math.round(k):Math.ceil(k));const z=Math.max(La(A),La(y));x=Math.pow(10,Io(s)?z:s),y=Math.round(y*x)/x,C=Math.round(C*x)/x;let $=0;for(m&&(h&&y!==o?(i.push({value:o}),y<o&&$++,za(Math.round((y+$*A)*x)/x,o,mp(o,w,t))&&$++):y<o&&$++);$<k;++$)i.push({value:Math.round((y+$*A)*x)/x});return b&&h&&C!==a?i.length&&za(i[i.length-1].value,a,mp(a,w,t))?i[i.length-1].value=a:i.push({value:a}):b&&C!==a||i.push({value:C}),i}function mp(t,e,{horizontal:i,minRotation:r}){const n=Ma(r),o=(i?Math.sin(n):Math.cos(n))||.001,a=.75*e*(""+t).length;return Math.min(e/o,a)}gp.id="category",gp.defaults={ticks:{callback:gp.prototype.getLabelForValue}};class bp extends Mc{constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._endValue=void 0,this._valueRange=0}parse(t,e){return Io(t)||("number"==typeof t||t instanceof Number)&&!isFinite(+t)?null:+t}handleTickRangeOptions(){const{beginAtZero:t}=this.options,{minDefined:e,maxDefined:i}=this.getUserBounds();let{min:r,max:n}=this;const o=t=>r=e?r:t,a=t=>n=i?n:t;if(t){const t=Ca(r),e=Ca(n);t<0&&e<0?a(0):t>0&&e>0&&o(0)}if(r===n){let e=1;(n>=Number.MAX_SAFE_INTEGER||r<=Number.MIN_SAFE_INTEGER)&&(e=Math.abs(.05*n)),a(n+e),t||o(r-e)}this.min=r,this.max=n}getTickLimit(){const t=this.options.ticks;let e,{maxTicksLimit:i,stepSize:r}=t;return r?(e=Math.ceil(this.max/r)-Math.floor(this.min/r)+1,e>1e3&&(console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${e} ticks. Limiting to 1000.`),e=1e3)):(e=this.computeTickLimit(),i=i||11),i&&(e=Math.min(i,e)),e}computeTickLimit(){return Number.POSITIVE_INFINITY}buildTicks(){const t=this.options,e=t.ticks;let i=this.getTickLimit();i=Math.max(2,i);const r=fp({maxTicks:i,bounds:t.bounds,min:t.min,max:t.max,precision:e.precision,step:e.stepSize,count:e.count,maxDigits:this._maxDigits(),horizontal:this.isHorizontal(),minRotation:e.minRotation||0,includeBounds:!1!==e.includeBounds},this._range||this);return"ticks"===t.bounds&&$a(r,this,"value"),t.reverse?(r.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),r}configure(){const t=this.ticks;let e=this.min,i=this.max;if(super.configure(),this.options.offset&&t.length){const r=(i-e)/Math.max(t.length-1,1)/2;e-=r,i+=r}this._startValue=e,this._endValue=i,this._valueRange=i-e}getLabelForValue(t){return Zl(t,this.chart.options.locale,this.options.ticks.format)}}class vp extends bp{determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=qo(t)?t:0,this.max=qo(e)?e:1,this.handleTickRangeOptions()}computeTickLimit(){const t=this.isHorizontal(),e=t?this.width:this.height,i=Ma(this.options.ticks.minRotation),r=(t?Math.sin(i):Math.cos(i))||.001,n=this._resolveTickFontOptions(0);return Math.ceil(e/Math.min(40,n.lineHeight/r))}getPixelForValue(t){return null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getValueForPixel(t){return this._startValue+this.getDecimalForPixel(t)*this._valueRange}}function wp(t){return 1===t/Math.pow(10,Math.floor(ya(t)))}vp.id="linear",vp.defaults={ticks:{callback:vc.formatters.numeric}};class xp extends Mc{constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._valueRange=0}parse(t,e){const i=bp.prototype.parse.apply(this,[t,e]);if(0!==i)return qo(i)&&i>0?i:null;this._zero=!0}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=qo(t)?Math.max(0,t):null,this.max=qo(e)?Math.max(0,e):null,this.options.beginAtZero&&(this._zero=!0),this.handleTickRangeOptions()}handleTickRangeOptions(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let i=this.min,r=this.max;const n=e=>i=t?i:e,o=t=>r=e?r:t,a=(t,e)=>Math.pow(10,Math.floor(ya(t))+e);i===r&&(i<=0?(n(1),o(10)):(n(a(i,-1)),o(a(r,1)))),i<=0&&n(a(r,-1)),r<=0&&o(a(i,1)),this._zero&&this.min!==this._suggestedMin&&i===a(this.min,0)&&n(a(i,-1)),this.min=i,this.max=r}buildTicks(){const t=this.options,e=function(t,e){const i=Math.floor(ya(e.max)),r=Math.ceil(e.max/Math.pow(10,i)),n=[];let o=Go(t.min,Math.pow(10,Math.floor(ya(e.min)))),a=Math.floor(ya(o)),s=Math.floor(o/Math.pow(10,a)),l=a<0?Math.pow(10,Math.abs(a)):1;do{n.push({value:o,major:wp(o)}),++s,10===s&&(s=1,++a,l=a>=0?1:l),o=Math.round(s*Math.pow(10,a)*l)/l}while(a<i||a===i&&s<r);const d=Go(t.max,o);return n.push({value:d,major:wp(o)}),n}({min:this._userMin,max:this._userMax},this);return"ticks"===t.bounds&&$a(e,this,"value"),t.reverse?(e.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),e}getLabelForValue(t){return void 0===t?"0":Zl(t,this.chart.options.locale,this.options.ticks.format)}configure(){const t=this.min;super.configure(),this._startValue=ya(t),this._valueRange=ya(this.max)-ya(t)}getPixelForValue(t){return void 0!==t&&0!==t||(t=this.min),null===t||isNaN(t)?NaN:this.getPixelForDecimal(t===this.min?0:(ya(t)-this._startValue)/this._valueRange)}getValueForPixel(t){const e=this.getDecimalForPixel(t);return Math.pow(10,this._startValue+e*this._valueRange)}}function yp(t){const e=t.ticks;if(e.display&&t.display){const t=Ws(e.backdropPadding);return Qo(e.font&&e.font.size,$s.font.size)+t.height}return 0}function Cp(t,e,i,r,n){return t===r||t===n?{start:e-i/2,end:e+i/2}:t<r||t>n?{start:e-i,end:e}:{start:e,end:e+i}}function kp(t){const e={l:t.left+t._padding.left,r:t.right-t._padding.right,t:t.top+t._padding.top,b:t.bottom-t._padding.bottom},i=Object.assign({},e),r=[],n=[],o=t._pointLabels.length,a=t.options.pointLabels,s=a.centerPointLabels?ua/o:0;for(let h=0;h<o;h++){const o=a.setContext(t.getPointLabelContext(h));n[h]=o.padding;const p=t.getPointPosition(h,t.drawingArea+n[h],s),u=qs(o.font),g=(l=t.ctx,d=u,c=Uo(c=t._pointLabels[h])?c:[c],{w:Ss(l,d.string,c),h:c.length*d.lineHeight});r[h]=g;const f=Fa(t.getIndexAngle(h)+s),m=Math.round(Sa(f));Ap(i,e,f,Cp(m,p.x,g.w,0,180),Cp(m,p.y,g.h,90,270))}var l,d,c;t.setCenterPoint(e.l-i.l,i.r-e.r,e.t-i.t,i.b-e.b),t._pointLabelItems=function(t,e,i){const r=[],n=t._pointLabels.length,o=t.options,a=yp(o)/2,s=t.drawingArea,l=o.pointLabels.centerPointLabels?ua/n:0;for(let o=0;o<n;o++){const n=t.getPointPosition(o,s+a+i[o],l),d=Math.round(Sa(Fa(n.angle+va))),c=e[o],h=Mp(n.y,c.h,d),p=zp(d),u=$p(n.x,c.w,p);r.push({x:n.x,y:h,textAlign:p,left:u,top:h,right:u+c.w,bottom:h+c.h})}return r}(t,r,n)}function Ap(t,e,i,r,n){const o=Math.abs(Math.sin(i)),a=Math.abs(Math.cos(i));let s=0,l=0;r.start<e.l?(s=(e.l-r.start)/o,t.l=Math.min(t.l,e.l-s)):r.end>e.r&&(s=(r.end-e.r)/o,t.r=Math.max(t.r,e.r+s)),n.start<e.t?(l=(e.t-n.start)/a,t.t=Math.min(t.t,e.t-l)):n.end>e.b&&(l=(n.end-e.b)/a,t.b=Math.max(t.b,e.b+l))}function zp(t){return 0===t||180===t?"center":t<180?"left":"right"}function $p(t,e,i){return"right"===i?t-=e:"center"===i&&(t-=e/2),t}function Mp(t,e,i){return 90===i||270===i?t-=e/2:(i>270||i<90)&&(t-=e),t}function Sp(t,e,i,r){const{ctx:n}=t;if(i)n.arc(t.xCenter,t.yCenter,e,0,ga);else{let i=t.getPointPosition(0,e);n.moveTo(i.x,i.y);for(let o=1;o<r;o++)i=t.getPointPosition(o,e),n.lineTo(i.x,i.y)}}xp.id="logarithmic",xp.defaults={ticks:{callback:vc.formatters.logarithmic,major:{enabled:!0}}};class Lp extends bp{constructor(t){super(t),this.xCenter=void 0,this.yCenter=void 0,this.drawingArea=void 0,this._pointLabels=[],this._pointLabelItems=[]}setDimensions(){const t=this._padding=Ws(yp(this.options)/2),e=this.width=this.maxWidth-t.width,i=this.height=this.maxHeight-t.height;this.xCenter=Math.floor(this.left+e/2+t.left),this.yCenter=Math.floor(this.top+i/2+t.top),this.drawingArea=Math.floor(Math.min(e,i)/2)}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!1);this.min=qo(t)&&!isNaN(t)?t:0,this.max=qo(e)&&!isNaN(e)?e:0,this.handleTickRangeOptions()}computeTickLimit(){return Math.ceil(this.drawingArea/yp(this.options))}generateTickLabels(t){bp.prototype.generateTickLabels.call(this,t),this._pointLabels=this.getLabels().map(((t,e)=>{const i=Ko(this.options.pointLabels.callback,[t,e],this);return i||0===i?i:""})).filter(((t,e)=>this.chart.getDataVisibility(e)))}fit(){const t=this.options;t.display&&t.pointLabels.display?kp(this):this.setCenterPoint(0,0,0,0)}setCenterPoint(t,e,i,r){this.xCenter+=Math.floor((t-e)/2),this.yCenter+=Math.floor((i-r)/2),this.drawingArea-=Math.min(this.drawingArea/2,Math.max(t,e,i,r))}getIndexAngle(t){return Fa(t*(ga/(this._pointLabels.length||1))+Ma(this.options.startAngle||0))}getDistanceFromCenterForValue(t){if(Io(t))return NaN;const e=this.drawingArea/(this.max-this.min);return this.options.reverse?(this.max-t)*e:(t-this.min)*e}getValueForDistanceFromCenter(t){if(Io(t))return NaN;const e=t/(this.drawingArea/(this.max-this.min));return this.options.reverse?this.max-e:this.min+e}getPointLabelContext(t){const e=this._pointLabels||[];if(t>=0&&t<e.length){const i=e[t];return function(t,e,i){return Qs(t,{label:i,index:e,type:"pointLabel"})}(this.getContext(),t,i)}}getPointPosition(t,e,i=0){const r=this.getIndexAngle(t)-va+i;return{x:Math.cos(r)*e+this.xCenter,y:Math.sin(r)*e+this.yCenter,angle:r}}getPointPositionForValue(t,e){return this.getPointPosition(t,this.getDistanceFromCenterForValue(e))}getBasePosition(t){return this.getPointPositionForValue(t||0,this.getBaseValue())}getPointLabelPosition(t){const{left:e,top:i,right:r,bottom:n}=this._pointLabelItems[t];return{left:e,top:i,right:r,bottom:n}}drawBackground(){const{backgroundColor:t,grid:{circular:e}}=this.options;if(t){const i=this.ctx;i.save(),i.beginPath(),Sp(this,this.getDistanceFromCenterForValue(this._endValue),e,this._pointLabels.length),i.closePath(),i.fillStyle=t,i.fill(),i.restore()}}drawGrid(){const t=this.ctx,e=this.options,{angleLines:i,grid:r}=e,n=this._pointLabels.length;let o,a,s;if(e.pointLabels.display&&function(t,e){const{ctx:i,options:{pointLabels:r}}=t;for(let n=e-1;n>=0;n--){const e=r.setContext(t.getPointLabelContext(n)),o=qs(e.font),{x:a,y:s,textAlign:l,left:d,top:c,right:h,bottom:p}=t._pointLabelItems[n],{backdropColor:u}=e;if(!Io(u)){const t=Ws(e.backdropPadding);i.fillStyle=u,i.fillRect(d-t.left,c-t.top,h-d+t.width,p-c+t.height)}Os(i,t._pointLabels[n],a,s+o.lineHeight/2,o,{color:e.color,textAlign:l,textBaseline:"middle"})}}(this,n),r.display&&this.ticks.forEach(((t,e)=>{if(0!==e){a=this.getDistanceFromCenterForValue(t.value);!function(t,e,i,r){const n=t.ctx,o=e.circular,{color:a,lineWidth:s}=e;!o&&!r||!a||!s||i<0||(n.save(),n.strokeStyle=a,n.lineWidth=s,n.setLineDash(e.borderDash),n.lineDashOffset=e.borderDashOffset,n.beginPath(),Sp(t,i,o,r),n.closePath(),n.stroke(),n.restore())}(this,r.setContext(this.getContext(e-1)),a,n)}})),i.display){for(t.save(),o=n-1;o>=0;o--){const r=i.setContext(this.getPointLabelContext(o)),{color:n,lineWidth:l}=r;l&&n&&(t.lineWidth=l,t.strokeStyle=n,t.setLineDash(r.borderDash),t.lineDashOffset=r.borderDashOffset,a=this.getDistanceFromCenterForValue(e.ticks.reverse?this.min:this.max),s=this.getPointPosition(o,a),t.beginPath(),t.moveTo(this.xCenter,this.yCenter),t.lineTo(s.x,s.y),t.stroke())}t.restore()}}drawBorder(){}drawLabels(){const t=this.ctx,e=this.options,i=e.ticks;if(!i.display)return;const r=this.getIndexAngle(0);let n,o;t.save(),t.translate(this.xCenter,this.yCenter),t.rotate(r),t.textAlign="center",t.textBaseline="middle",this.ticks.forEach(((r,a)=>{if(0===a&&!e.reverse)return;const s=i.setContext(this.getContext(a)),l=qs(s.font);if(n=this.getDistanceFromCenterForValue(this.ticks[a].value),s.showLabelBackdrop){t.font=l.string,o=t.measureText(r.label).width,t.fillStyle=s.backdropColor;const e=Ws(s.backdropPadding);t.fillRect(-o/2-e.left,-n-l.size/2-e.top,o+e.width,l.size+e.height)}Os(t,r.label,0,-n,l,{color:s.color})})),t.restore()}drawTitle(){}}Lp.id="radialLinear",Lp.defaults={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,lineWidth:1,borderDash:[],borderDashOffset:0},grid:{circular:!1},startAngle:0,ticks:{showLabelBackdrop:!0,callback:vc.formatters.numeric},pointLabels:{backdropColor:void 0,backdropPadding:2,display:!0,font:{size:10},callback:t=>t,padding:5,centerPointLabels:!1}},Lp.defaultRoutes={"angleLines.color":"borderColor","pointLabels.color":"color","ticks.color":"color"},Lp.descriptors={angleLines:{_fallback:"grid"}};const Hp={millisecond:{common:!0,size:1,steps:1e3},second:{common:!0,size:1e3,steps:60},minute:{common:!0,size:6e4,steps:60},hour:{common:!0,size:36e5,steps:24},day:{common:!0,size:864e5,steps:30},week:{common:!1,size:6048e5,steps:4},month:{common:!0,size:2628e6,steps:12},quarter:{common:!1,size:7884e6,steps:4},year:{common:!0,size:3154e7}},Bp=Object.keys(Hp);function _p(t,e){return t-e}function Fp(t,e){if(Io(e))return null;const i=t._adapter,{parser:r,round:n,isoWeekday:o}=t._parseOpts;let a=e;return"function"==typeof r&&(a=r(a)),qo(a)||(a="string"==typeof r?i.parse(a,r):i.parse(a)),null===a?null:(n&&(a="week"!==n||!Aa(o)&&!0!==o?i.startOf(a,n):i.startOf(a,"isoWeek",o)),+a)}function Dp(t,e,i,r){const n=Bp.length;for(let o=Bp.indexOf(t);o<n-1;++o){const t=Hp[Bp[o]],n=t.steps?t.steps:Number.MAX_SAFE_INTEGER;if(t.common&&Math.ceil((i-e)/(n*t.size))<=r)return Bp[o]}return Bp[n-1]}function Ep(t,e,i){if(i){if(i.length){const{lo:r,hi:n}=Xs(i,e);t[i[r]>=e?i[r]:i[n]]=!0}}else t[e]=!0}function Vp(t,e,i){const r=[],n={},o=e.length;let a,s;for(a=0;a<o;++a)s=e[a],n[s]=a,r.push({value:s,major:!1});return 0!==o&&i?function(t,e,i,r){const n=t._adapter,o=+n.startOf(e[0].value,r),a=e[e.length-1].value;let s,l;for(s=o;s<=a;s=+n.add(s,1,r))l=i[s],l>=0&&(e[l].major=!0);return e}(t,r,n,i):r}class Op extends Mc{constructor(t){super(t),this._cache={data:[],labels:[],all:[]},this._unit="day",this._majorUnit=void 0,this._offsets={},this._normalized=!1,this._parseOpts=void 0}init(t,e){const i=t.time||(t.time={}),r=this._adapter=new _d._date(t.adapters.date);oa(i.displayFormats,r.formats()),this._parseOpts={parser:i.parser,round:i.round,isoWeekday:i.isoWeekday},super.init(t),this._normalized=e.normalized}parse(t,e){return void 0===t?null:Fp(this,t)}beforeLayout(){super.beforeLayout(),this._cache={data:[],labels:[],all:[]}}determineDataLimits(){const t=this.options,e=this._adapter,i=t.time.unit||"day";let{min:r,max:n,minDefined:o,maxDefined:a}=this.getUserBounds();function s(t){o||isNaN(t.min)||(r=Math.min(r,t.min)),a||isNaN(t.max)||(n=Math.max(n,t.max))}o&&a||(s(this._getLabelBounds()),"ticks"===t.bounds&&"labels"===t.ticks.source||s(this.getMinMax(!1))),r=qo(r)&&!isNaN(r)?r:+e.startOf(Date.now(),i),n=qo(n)&&!isNaN(n)?n:+e.endOf(Date.now(),i)+1,this.min=Math.min(r,n-1),this.max=Math.max(r+1,n)}_getLabelBounds(){const t=this.getLabelTimestamps();let e=Number.POSITIVE_INFINITY,i=Number.NEGATIVE_INFINITY;return t.length&&(e=t[0],i=t[t.length-1]),{min:e,max:i}}buildTicks(){const t=this.options,e=t.time,i=t.ticks,r="labels"===i.source?this.getLabelTimestamps():this._generate();"ticks"===t.bounds&&r.length&&(this.min=this._userMin||r[0],this.max=this._userMax||r[r.length-1]);const n=this.min,o=function(t,e,i){let r=0,n=t.length;for(;r<n&&t[r]<e;)r++;for(;n>r&&t[n-1]>i;)n--;return r>0||n<t.length?t.slice(r,n):t}(r,n,this.max);return this._unit=e.unit||(i.autoSkip?Dp(e.minUnit,this.min,this.max,this._getLabelCapacity(n)):function(t,e,i,r,n){for(let o=Bp.length-1;o>=Bp.indexOf(i);o--){const i=Bp[o];if(Hp[i].common&&t._adapter.diff(n,r,i)>=e-1)return i}return Bp[i?Bp.indexOf(i):0]}(this,o.length,e.minUnit,this.min,this.max)),this._majorUnit=i.major.enabled&&"year"!==this._unit?function(t){for(let e=Bp.indexOf(t)+1,i=Bp.length;e<i;++e)if(Hp[Bp[e]].common)return Bp[e]}(this._unit):void 0,this.initOffsets(r),t.reverse&&o.reverse(),Vp(this,o,this._majorUnit)}initOffsets(t){let e,i,r=0,n=0;this.options.offset&&t.length&&(e=this.getDecimalForValue(t[0]),r=1===t.length?1-e:(this.getDecimalForValue(t[1])-e)/2,i=this.getDecimalForValue(t[t.length-1]),n=1===t.length?i:(i-this.getDecimalForValue(t[t.length-2]))/2);const o=t.length<3?.5:.25;r=Ea(r,0,o),n=Ea(n,0,o),this._offsets={start:r,end:n,factor:1/(r+1+n)}}_generate(){const t=this._adapter,e=this.min,i=this.max,r=this.options,n=r.time,o=n.unit||Dp(n.minUnit,e,i,this._getLabelCapacity(e)),a=Qo(n.stepSize,1),s="week"===o&&n.isoWeekday,l=Aa(s)||!0===s,d={};let c,h,p=e;if(l&&(p=+t.startOf(p,"isoWeek",s)),p=+t.startOf(p,l?"day":o),t.diff(i,e,o)>1e5*a)throw new Error(e+" and "+i+" are too far apart with stepSize of "+a+" "+o);const u="data"===r.ticks.source&&this.getDataTimestamps();for(c=p,h=0;c<i;c=+t.add(c,a,o),h++)Ep(d,c,u);return c!==i&&"ticks"!==r.bounds&&1!==h||Ep(d,c,u),Object.keys(d).sort(((t,e)=>t-e)).map((t=>+t))}getLabelForValue(t){const e=this._adapter,i=this.options.time;return i.tooltipFormat?e.format(t,i.tooltipFormat):e.format(t,i.displayFormats.datetime)}_tickFormatFunction(t,e,i,r){const n=this.options,o=n.time.displayFormats,a=this._unit,s=this._majorUnit,l=a&&o[a],d=s&&o[s],c=i[e],h=s&&d&&c&&c.major,p=this._adapter.format(t,r||(h?d:l)),u=n.ticks.callback;return u?Ko(u,[p,e,i],this):p}generateTickLabels(t){let e,i,r;for(e=0,i=t.length;e<i;++e)r=t[e],r.label=this._tickFormatFunction(r.value,e,t)}getDecimalForValue(t){return null===t?NaN:(t-this.min)/(this.max-this.min)}getPixelForValue(t){const e=this._offsets,i=this.getDecimalForValue(t);return this.getPixelForDecimal((e.start+i)*e.factor)}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return this.min+i*(this.max-this.min)}_getLabelSize(t){const e=this.options.ticks,i=this.ctx.measureText(t).width,r=Ma(this.isHorizontal()?e.maxRotation:e.minRotation),n=Math.cos(r),o=Math.sin(r),a=this._resolveTickFontOptions(0).size;return{w:i*n+a*o,h:i*o+a*n}}_getLabelCapacity(t){const e=this.options.time,i=e.displayFormats,r=i[e.unit]||i.millisecond,n=this._tickFormatFunction(t,0,Vp(this,[t],this._majorUnit),r),o=this._getLabelSize(n),a=Math.floor(this.isHorizontal()?this.width/o.w:this.height/o.h)-1;return a>0?a:1}getDataTimestamps(){let t,e,i=this._cache.data||[];if(i.length)return i;const r=this.getMatchingVisibleMetas();if(this._normalized&&r.length)return this._cache.data=r[0].controller.getAllParsedValues(this);for(t=0,e=r.length;t<e;++t)i=i.concat(r[t].controller.getAllParsedValues(this));return this._cache.data=this.normalize(i)}getLabelTimestamps(){const t=this._cache.labels||[];let e,i;if(t.length)return t;const r=this.getLabels();for(e=0,i=r.length;e<i;++e)t.push(Fp(this,r[e]));return this._cache.labels=this._normalized?t:this.normalize(t)}normalize(t){return il(t.sort(_p))}}function jp(t,e,i){let r,n,o,a,s=0,l=t.length-1;i?(e>=t[s].pos&&e<=t[l].pos&&({lo:s,hi:l}=Ks(t,"pos",e)),({pos:r,time:o}=t[s]),({pos:n,time:a}=t[l])):(e>=t[s].time&&e<=t[l].time&&({lo:s,hi:l}=Ks(t,"time",e)),({time:r,pos:o}=t[s]),({time:n,pos:a}=t[l]));const d=n-r;return d?o+(a-o)*(e-r)/d:o}Op.id="time",Op.defaults={bounds:"data",adapters:{},time:{parser:!1,unit:!1,round:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{}},ticks:{source:"auto",major:{enabled:!1}}};class Zp extends Op{constructor(t){super(t),this._table=[],this._minPos=void 0,this._tableRange=void 0}initOffsets(){const t=this._getTimestampsForTable(),e=this._table=this.buildLookupTable(t);this._minPos=jp(e,this.min),this._tableRange=jp(e,this.max)-this._minPos,super.initOffsets(t)}buildLookupTable(t){const{min:e,max:i}=this,r=[],n=[];let o,a,s,l,d;for(o=0,a=t.length;o<a;++o)l=t[o],l>=e&&l<=i&&r.push(l);if(r.length<2)return[{time:e,pos:0},{time:i,pos:1}];for(o=0,a=r.length;o<a;++o)d=r[o+1],s=r[o-1],l=r[o],Math.round((d+s)/2)!==l&&n.push({time:l,pos:o/(a-1)});return n}_getTimestampsForTable(){let t=this._cache.all||[];if(t.length)return t;const e=this.getDataTimestamps(),i=this.getLabelTimestamps();return t=e.length&&i.length?this.normalize(e.concat(i)):e.length?e:i,t=this._cache.all=t,t}getDecimalForValue(t){return(jp(this._table,t)-this._minPos)/this._tableRange}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return jp(this._table,i*this._tableRange+this._minPos,!0)}}Zp.id="timeseries",Zp.defaults=Op.defaults;const Rp=[Ld,zh,pp,Object.freeze({__proto__:null,CategoryScale:gp,LinearScale:vp,LogarithmicScale:xp,RadialLinearScale:Lp,TimeScale:Op,TimeSeriesScale:Zp})];Jc.register(...Rp);let Tp=class extends $t{constructor(){super(...arguments),this.data=[]}firstUpdated(){let t=[""],e=[0];if(this.data.length>0){t=this.data.map((t=>t.label)),e=this.data.map((t=>t.close));const i={type:"line",data:{labels:t,datasets:[{backgroundColor:"rgb(33, 117, 217)",borderColor:"rgb(33, 117, 217)",data:e}]},options:{responsive:!0,aspectRatio:3,layout:{padding:0},scales:{y:{display:!1},x:{display:!1}},elements:{point:{radius:1},line:{tension:.3,borderJoinStyle:"round"}},plugins:{legend:{display:!1}}}};return new Jc(this._graph,i)}return""}render(){if(!this.data.length)return Y``;const t=new Date;let e=0,i=1,r=100,n=new Date;this.quoteData&&({latestPrice:e=0,change:i=0,changePercent:r=0,latestUpdate:n=new Date}=this.quoteData);const o=function(t,e,i){Rn(2,arguments);var r=String(e),n=i||{},o=n.locale||io,a=o.options&&o.options.firstWeekContainsDate,s=null==a?1:Zn(a),l=null==n.firstWeekContainsDate?s:Zn(n.firstWeekContainsDate);if(!(l>=1&&l<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var d=o.options&&o.options.weekStartsOn,c=null==d?0:Zn(d),h=null==n.weekStartsOn?c:Zn(n.weekStartsOn);if(!(h>=0&&h<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(!o.localize)throw new RangeError("locale must contain localize property");if(!o.formatLong)throw new RangeError("locale must contain formatLong property");var p=Tn(t);if(!In(p))throw new RangeError("Invalid time value");var u=Pn(p),g=ro(p,u),f={firstWeekContainsDate:l,weekStartsOn:h,locale:o,_originalDate:p};return r.match(Do).map((function(t){var e=t[0];return"p"===e||"P"===e?(0,Mo[e])(t,o.formatLong,f):t})).join("").match(Fo).map((function(i){if("''"===i)return"'";var r=i[0];if("'"===r)return jo(i);var a=ko[r];if(a)return!n.useAdditionalWeekYearTokens&&Bo(i)&&_o(i,e,t),!n.useAdditionalDayOfYearTokens&&Ho(i)&&_o(i,e,t),a(g,i,o.localize,f);if(r.match(Oo))throw new RangeError("Format string contains an unescaped latin alphabet character `"+r+"`");return i})).join("")}(n||t.getTime(),"MMMM do, yyyy h:mma");return Y`
      <div class="wrapper">
        <div class="highlight ${i<0?"down":"up"}">
          <h2>${e}</h2>
          <div class="icon-wrapper">
            <div class="icon">
              <span class="inner-icon"></span>
            </div>
          </div>
          <div class="change">
            <span
              >${i.toFixed(2)}(${(100*r).toFixed(2)}%)</span
            >
          </div>
          <span class="date">Updated ${o}</span>
        </div>
        <div class="chart-wrapper">
          ${this.data.length<=1?Y`<div class="demo">
                <div class="stock-widget-exception">
                  <h3>Sorry for the inconvenience:</h3>
                  <p>
                    We seem to be experiencing issues with our stock quote at
                    this time. Please check back later.
                  </p>
                </div>
              </div>`:Y`<div class="chart-inner-wrapper">
                <canvas class="graph"></canvas>
                <div></div>
              </div>`}
        </div>
      </div>
    `}};Tp.styles=[jn],p([mt(".graph")],Tp.prototype,"_graph",void 0),p([ut({attribute:"data",type:Array})],Tp.prototype,"data",void 0),p([ut({attribute:"quote-data",type:Array})],Tp.prototype,"quoteData",void 0),Tp=p([ht("atmos-stock-chart")],Tp);var Np=b`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  background:linear-gradient(355.13deg, #2e2e2e 5.24%, #3b4551 90.93%);
  border-radius:32px;
  box-sizing:border-box;
  min-height:443px;
  padding:32px 32px 100px 32px;
}

h3 {
  color: var(--neutral-white);
  font-size:26px;
  margin-bottom:45px;
  margin-top:0;
}

dl{
  display:grid;
  margin:0;
  grid-template-columns:2fr 1fr;
  row-gap:25px;
}

dt, dd {
  color: var(--neutral-white);
  font-family: Futura Std, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  margin:0;
}

dd {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  font-weight:bold;
  text-align:right;
}
`;let Pp=class extends $t{constructor(){super(...arguments),this.previousClose=0,this.week52Low=0,this.week52High=0,this.marketCap=0,this.volume=0}render(){return Y`
      <div class="wrapper">
        <h3>Overview</h3>
        <dl>
          <dt>Previous Close:</dt>
          <dd>$${this.previousClose}</dd>
          <dt>52 Week Low:</dt>
          <dd>$${this.week52Low}</dd>
          <dt>52 Week High:</dt>
          <dd>$${this.week52High}</dd>
          <dt>Market Cap:</dt>
          <dd>$${(this.marketCap/1e9).toFixed(2)}b</dd>
          <dt>Volume:</dt>
          <dd>${`${(this.volume/1e3).toFixed(2)}k`}</dd>
        </dl>
        ${0===this.previousClose?Y`
              <div style="color: #FFF;" class="stock-widget-exception">
                <h5>Sorry for the inconvenience:</h5>
                <div>
                  We seem to be experiencing issues with our stock quote at this
                  time. Please check back later.
                </div>
              </div>
            `:""}
      </div>
    `}};Pp.styles=[Np],p([ut({attribute:"previous-close",type:Number})],Pp.prototype,"previousClose",void 0),p([ut({attribute:"week52-low",type:Number})],Pp.prototype,"week52Low",void 0),p([ut({attribute:"week52-high",type:Number})],Pp.prototype,"week52High",void 0),p([ut({attribute:"market-cap",type:Number})],Pp.prototype,"marketCap",void 0),p([ut({attribute:"volume",type:Number})],Pp.prototype,"volume",void 0),Pp=p([ht("atmos-stock-overview")],Pp);export{t as ALL_COLORS,Jr as ALL_ORIENTATION,Xr as ALL_SIZES,Qr as ALL_SPACING_TOKENS,tn as ALL_TEXT_INPUTS,Kr as ALL_VERTICAL_ALIGNMENT,_e as AlertWeights,Fe as AllIcons,oi as AtmosAccordion,di as AtmosButton,pi as AtmosCirclePromo,mi as AtmosContentSwitcher,vi as AtmosDocuments,xi as AtmosDropdown,Ci as AtmosEmployeeSpotlight,fi as AtmosFeatureContent,Ai as AtmosFeedback,$i as AtmosFooter,Li as AtmosFootprint,Bi as AtmosFormInput,Ln as AtmosHeader,Bn as AtmosHeaderDropdown,Fn as AtmosHeaderMenuButton,En as AtmosHeaderMobileSubmenu,On as AtmosHeaderSubmenu,Vi as AtmosHero,Ti as AtmosIcon,Pi as AtmosIconCard,Ui as AtmosIconLink,qi as AtmosIconPromo,Qi as AtmosImageCard,Ki as AtmosInfoCard,tr as AtmosInfoCardCarousel,ir as AtmosInfoCardStacked,nr as AtmosJumboFeature,ar as AtmosModalDialog,lr as AtmosMultiColumn,cr as AtmosPageContentSwitcher,pr as AtmosPerson,gr as AtmosPlayButton,hi as AtmosPromoBase,mr as AtmosPullQuote,vr as AtmosQuickLinks,Cr as AtmosRelatedCards,Ar as AtmosResearchCoverage,Mr as AtmosSearch,Sr as AtmosSearchDesktop,Hr as AtmosSearchField,_r as AtmosSearchResult,Dr as AtmosSeasonSwitcher,Vr as AtmosSocialCarousel,Zr as AtmosSystemMessage,Tr as AtmosTextarea,Pr as AtmosVideo,Ir as AtmosVideoCard,Wr as AtmosWysiwyg,Gr as AtmosZipCodeCollection,o as ContainerSizeController,ke as HeadingSizes,Ae as HeadingStyles,Me as IconList,Oi as IconType,Se as IconTypeCustom,Le as IconTypeOutline,He as IconTypeSolid,Be as IconVariant,a as IsHoverableDeviceController,s as LinkedBlockController,l as MobileController,St as OutlineAccordion,oe as OutlineAdminLinks,de as OutlineAlert,ue as OutlineBreadcrumbs,fe as OutlineButton,be as OutlineCard,xe as OutlineCodeBlock,bn as OutlineColumn,pe as OutlineContainer,$t as OutlineElement,Ce as OutlineGrid,$e as OutlineHeading,Ee as OutlineImage,Te as OutlineLink,We as OutlineList,Xe as OutlineModal,Je as OutlineStyledText,ei as OutlineVideoVimeo,ri as OutlineVideoYoutube,xr as RecognizingLeak,c as ScreenSizeController,h as SlotController,se as alertSizes,le as alertStatusTypes,on as argTypeColSpan,hn as argTypeColor,sn as argTypeGapSize,gn as argTypeHidden,dn as argTypeHorizontalAlign,je as argTypeHref,un as argTypeImageUrl,nn as argTypeOrientation,Ze as argTypeRel,an as argTypeRowSpan,cn as argTypeSize,rn as argTypeSlotContent,pn as argTypeSpacing,ln as argTypeVerticalAlign,Ue as columnsCount,n as containerSizeMap,Ie as dividerColors,fn as extractPx,en as format,qt as getIconLibrary,Ri as icons,Ye as listOrientations,Pe as listTypes,Ge as modalSizes,Fi as primaryLink,Gt as registerIconLibrary,Jt as requestIcon,Xt as requestInclude,d as screenSizeMap,Di as searchData,_i as subMenu,Zi as svgs,It as unregisterIconLibrary,Wt as unwatchIcon,Ut as watchIcon};
//# sourceMappingURL=outline.js.map
